(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.it.dW === region.jk.dW)
	{
		return 'on line ' + region.it.dW;
	}
	return 'on lines ' + region.it.dW + ' through ' + region.jk.dW;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.x,
		impl._,
		impl.nN,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		mJ: func(record.mJ),
		nJ: record.nJ,
		ni: record.ni
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.mJ;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.nJ;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.ni) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.x,
		impl._,
		impl.nN,
		function(sendToApp, initialModel) {
			var view = impl.n3;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.x,
		impl._,
		impl.nN,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ip && impl.ip(sendToApp)
			var view = impl.n3;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dp);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.iB) && (_VirtualDom_doc.title = title = doc.iB);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.m8;
	var onUrlRequest = impl.m9;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ip: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.ko === next.ko
							&& curr.jy === next.jy
							&& curr.kb.a === next.kb.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		x: function(flags)
		{
			return A3(impl.x, flags, _Browser_getUrl(), key);
		},
		n3: impl.n3,
		_: impl._,
		nN: impl.nN
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { mi: 'hidden', lz: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { mi: 'mozHidden', lz: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { mi: 'msHidden', lz: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { mi: 'webkitHidden', lz: 'webkitvisibilitychange' }
		: { mi: 'hidden', lz: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		kA: _Browser_getScene(),
		la: {
			n8: _Browser_window.pageXOffset,
			n9: _Browser_window.pageYOffset,
			lg: _Browser_doc.documentElement.clientWidth,
			jw: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		lg: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		jw: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			kA: {
				lg: node.scrollWidth,
				jw: node.scrollHeight
			},
			la: {
				n8: node.scrollLeft,
				n9: node.scrollTop,
				lg: node.clientWidth,
				jw: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			kA: _Browser_getScene(),
			la: {
				n8: x,
				n9: y,
				lg: _Browser_doc.documentElement.clientWidth,
				jw: _Browser_doc.documentElement.clientHeight
			},
			l$: {
				n8: x + rect.left,
				n9: y + rect.top,
				lg: rect.width,
				jw: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.dC.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.dC.b, xhr)); });
		$elm$core$Maybe$isJust(request.ez) && _Http_track(router, xhr, request.ez.a);

		try {
			xhr.open(request.d0, request.eD, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.eD));
		}

		_Http_configureRequest(xhr, request);

		request.dp.a && xhr.setRequestHeader('Content-Type', request.dp.a);
		xhr.send(request.dp.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.dE; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.ew.a || 0;
	xhr.responseType = request.dC.d;
	xhr.withCredentials = request.lm;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		eD: xhr.responseURL,
		nH: xhr.status,
		nI: xhr.statusText,
		dE: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			nB: event.loaded,
			kK: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			nn: event.loaded,
			kK: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}



// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.mT) { flags += 'm'; }
	if (options.ly) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$LinkClicked = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Main$OnNavigation = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.r) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.v),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.v);
		} else {
			var treeLen = builder.r * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.z) : builder.z;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.r);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.v) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.v);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{z: nodeList, r: (len / $elm$core$Array$branchFactor) | 0, v: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {jp: fragment, jy: host, nc: path, kb: port_, ko: protocol, bN: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $author$project$Main$Redirect = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Cms = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$GotCmsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$GotLoginMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$GotUserMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$Login = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$User = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Pages$Cms$AddProductConfigModel = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Cms$ChangeDisplayIntervalModel = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Cms$ChangeDisplayOrderModel = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Cms$ChangeUserProductModel = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Cms$EditMailAddress = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$EditPermalinkGroups = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$EditProducts = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Cms$EditProductsPermalinks = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Cms$EditSoldoutProducts = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Cms$EditStoreGroups = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Cms$EditStoreProperties = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$EditStores = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Cms$EditUsersStores = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$GetAccessCount = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$GotAddProductConfigMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Cms$GotChangeDisplayIntervalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Cms$GotChangeDisplayOrderMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Cms$GotChangeUserProductMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Cms$GotEditMailAddressMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Cms$GotEditPermalinkGroupsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$GotEditProducts = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Cms$GotEditProductsPermalinks = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Cms$GotEditSoldoutProductsMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Cms$GotEditStoreGroupsMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$GotEditStorePropertiesMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$GotEditStoresMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Cms$GotEditUsersStoresMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$GotGetAccessCountMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Cms$GotRakutenExcludedItems = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$GotUpdateFujiWeeklyProductsByCsv = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Cms$GotUpdateHIitachiProductsOrderByCsv = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$GotUpdateHitachiWeeklyProductsByCsv = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$GotUpdateSharpProductsByCsv = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Cms$GotUpdateTescomProductsByCsv = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Cms$GotUpdateTletProductsByCsv = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Cms$GotUpdateWeek30ByCsv = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$GotUserSpecificRoutingMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Cms$GotYahooMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Cms$RakutenExcludedItems = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Cms$UpdateFujiWeeklyProductsByCsv = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Cms$UpdateHitachiProductsOrderByCsv = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$UpdateHitachiWeeklyProductsByCsv = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Cms$UpdateSharpProductsByCsv = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Cms$UpdateTescomProductsByCsv = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$UpdateTletProductsByCsv = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Cms$UpdateWeek30ByCsv = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Cms$UserSpecificRoutingModel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Cms$Yahoo = function (a) {
	return {$: 22, a: a};
};
var $author$project$Routers$CmsRouter$NotFound = 0;
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {by: frag, bK: params, bl: unvisited, m: value, b0: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.bl;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.m);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.m);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.nc),
					$elm$url$Url$Parser$prepareQuery(url.bN),
					url.jp,
					$elm$core$Basics$identity)));
	});
var $author$project$Routers$CmsRouter$AddProductConfig = 17;
var $author$project$Routers$CmsRouter$ChangeDisplayInterval = 14;
var $author$project$Routers$CmsRouter$ChangeDisplayOrder = 16;
var $author$project$Routers$CmsRouter$ChangeUserProduct = 15;
var $author$project$Routers$CmsRouter$EditMailAddress = 20;
var $author$project$Routers$CmsRouter$EditPermalinkGroups = 3;
var $author$project$Routers$CmsRouter$EditProducts = 19;
var $author$project$Routers$CmsRouter$EditProductsPermalinks = 18;
var $author$project$Routers$CmsRouter$EditSoldoutProducts = 24;
var $author$project$Routers$CmsRouter$EditStoreGroups = 4;
var $author$project$Routers$CmsRouter$EditStoreProperties = 2;
var $author$project$Routers$CmsRouter$EditStores = 22;
var $author$project$Routers$CmsRouter$EditUsersStores = 5;
var $author$project$Routers$CmsRouter$GetAccessCount = 21;
var $author$project$Routers$CmsRouter$RakutenExcludedItems = 13;
var $author$project$Routers$CmsRouter$Top = 1;
var $author$project$Routers$CmsRouter$UpdateFujiWeeklyProductsByCsv = 25;
var $author$project$Routers$CmsRouter$UpdateHitachiProductsOrderByCsv = 11;
var $author$project$Routers$CmsRouter$UpdateHitachiWeeklyProductsByCsv = 10;
var $author$project$Routers$CmsRouter$UpdateSharpProductsByCsv = 9;
var $author$project$Routers$CmsRouter$UpdateTescomProductsByCsv = 8;
var $author$project$Routers$CmsRouter$UpdateTletProductsByCsv = 7;
var $author$project$Routers$CmsRouter$UpdateWeek30ByCsv = 6;
var $author$project$Routers$CmsRouter$UserSpecificRouting = 12;
var $author$project$Routers$CmsRouter$Yahoo = 23;
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.b0;
		var unvisited = _v0.bl;
		var params = _v0.bK;
		var frag = _v0.by;
		var value = _v0.m;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.b0;
			var unvisited = _v1.bl;
			var params = _v1.bK;
			var frag = _v1.by;
			var value = _v1.m;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.b0;
		var unvisited = _v0.bl;
		var params = _v0.bK;
		var frag = _v0.by;
		var value = _v0.m;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Routers$CmsRouter$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, 1, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			2,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('stores'),
					$elm$url$Url$Parser$s('edit-store-properties')))),
			A2(
			$elm$url$Url$Parser$map,
			3,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('stores'),
					$elm$url$Url$Parser$s('edit-permalink-groups')))),
			A2(
			$elm$url$Url$Parser$map,
			4,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('stores'),
					$elm$url$Url$Parser$s('edit-store-groups')))),
			A2(
			$elm$url$Url$Parser$map,
			20,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('others'),
					$elm$url$Url$Parser$s('edit-mailaddress')))),
			A2(
			$elm$url$Url$Parser$map,
			22,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('stores'),
					$elm$url$Url$Parser$s('edit-stores')))),
			A2(
			$elm$url$Url$Parser$map,
			5,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('stores'),
					$elm$url$Url$Parser$s('edit-users-stores')))),
			A2(
			$elm$url$Url$Parser$map,
			6,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('update-week30-by-csv')))),
			A2(
			$elm$url$Url$Parser$map,
			7,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('update-tlet-products')))),
			A2(
			$elm$url$Url$Parser$map,
			8,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('update-tescom-products')))),
			A2(
			$elm$url$Url$Parser$map,
			9,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('update-sharp-products')))),
			A2(
			$elm$url$Url$Parser$map,
			10,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('update-hitachi-weekly-products')))),
			A2(
			$elm$url$Url$Parser$map,
			11,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('update-hitachi-products-order')))),
			A2(
			$elm$url$Url$Parser$map,
			12,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('user-specific-routing')))),
			A2(
			$elm$url$Url$Parser$map,
			13,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('rakuten-excluded-items')))),
			A2(
			$elm$url$Url$Parser$map,
			14,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('change-display-interval')))),
			A2(
			$elm$url$Url$Parser$map,
			15,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('change-user-product')))),
			A2(
			$elm$url$Url$Parser$map,
			16,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('change-display-order')))),
			A2(
			$elm$url$Url$Parser$map,
			17,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('add-product-config')))),
			A2(
			$elm$url$Url$Parser$map,
			18,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('edit-products-permalinks')))),
			A2(
			$elm$url$Url$Parser$map,
			19,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('edit-products')))),
			A2(
			$elm$url$Url$Parser$map,
			23,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('stores'),
					$elm$url$Url$Parser$s('yahoo')))),
			A2(
			$elm$url$Url$Parser$map,
			21,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('others'),
					$elm$url$Url$Parser$s('get-access-count')))),
			A2(
			$elm$url$Url$Parser$map,
			24,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('edit-soldout-products')))),
			A2(
			$elm$url$Url$Parser$map,
			25,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('cms'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('update-fuji-weekly-products'))))
		]));
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Routers$CmsRouter$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$url$Url$Parser$parse, $author$project$Routers$CmsRouter$parser, url));
};
var $author$project$Pages$Cms$Others$EditMailAddress$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Endpoints$Cms$cms = 'cms';
var $author$project$Endpoints$Cms$editMailAddress = 'edit-mailaddress';
var $author$project$Endpoints$Cms$others = 'others';
var $author$project$Endpoints$Cms$editMailAddressEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'add']),
		_List_Nil),
	li: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'add-target']),
		_List_Nil),
	lw: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'bulk-update']),
		_List_Nil),
	ci: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'delete']),
		_List_Nil),
	lS: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'delete-target']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'init']),
		_List_Nil),
	mC: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'list-stores']),
		_List_Nil),
	mD: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'list-targets']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$editMailAddress, 'update']),
		_List_Nil)
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Api$GET = 0;
var $author$project$Api$decodeHTTPMethod = function (method) {
	switch (method) {
		case 0:
			return 'GET';
		case 1:
			return 'POST';
		case 2:
			return 'PUT';
		default:
			return 'DELETE';
	}
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Api$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$elm$http$Http$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($elm$http$Http$Timeout);
					case 2:
						return $elm$core$Result$Err($elm$http$Http$NetworkError);
					case 3:
						var body = response.b;
						return $elm$core$Result$Err(
							$elm$http$Http$BadBody(body));
					default:
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v1.$) {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(err)));
						}
				}
			});
	});
var $author$project$Session$getConfig = function (session) {
	switch (session.$) {
		case 0:
			var config = session.e;
			return config;
		case 1:
			var config = session.c;
			return config;
		default:
			var config = session.b;
			return config;
	}
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Session$token = function (session) {
	switch (session.$) {
		case 0:
			var t = session.b;
			return $elm$core$Maybe$Just(t);
		case 1:
			var t = session.b;
			return $elm$core$Maybe$Just(t);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$makeAuthHeader = function (session) {
	var _v0 = $author$project$Session$token(session);
	if (!_v0.$) {
		var t = _v0.a;
		return _List_fromArray(
			[
				A2($elm$http$Http$header, 'authorization', 'Bearer ' + t),
				A2($elm$http$Http$header, 'Accept', 'application/json')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$makeUrl = F2(
	function (ip, port_) {
		return ip + (':' + $elm$core$String$fromInt(port_));
	});
var $author$project$Utils$Constants$version = 'v1';
var $author$project$Api$makeEndpoint = F3(
	function (config, paths, queryParam) {
		var url = A2($author$project$Api$makeUrl, config.iS, config.iT);
		return _Utils_ap(
			url,
			A2(
				$elm$url$Url$Builder$absolute,
				A2(
					$elm$core$List$cons,
					'api',
					A2($elm$core$List$cons, $author$project$Utils$Constants$version, paths)),
				queryParam));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {ks: reqs, kW: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.ez;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.ks));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.kW)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					lm: r.lm,
					dp: r.dp,
					dC: A2(_Http_mapExpect, func, r.dC),
					dE: r.dE,
					d0: r.d0,
					ew: r.ew,
					ez: r.ez,
					eD: r.eD
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{lm: false, dp: r.dp, dC: r.dC, dE: r.dE, d0: r.d0, ew: r.ew, ez: r.ez, eD: r.eD}));
};
var $author$project$Api$get = F4(
	function (path, session, decoder, msg) {
		var apiConf = $author$project$Session$getConfig(session);
		var config = {
			dp: $elm$http$Http$emptyBody,
			dC: A2($author$project$Api$expectJson, msg, decoder),
			dE: $author$project$Api$makeAuthHeader(session),
			d0: $author$project$Api$decodeHTTPMethod(0),
			ew: $elm$core$Maybe$Nothing,
			ez: $elm$core$Maybe$Nothing,
			eD: A3(
				$author$project$Api$makeEndpoint,
				apiConf,
				_List_fromArray(
					[path]),
				_List_Nil)
		};
		return $elm$http$Http$request(config);
	});
var $author$project$Pages$Cms$Others$EditMailAddress$initNewPermalinkGroup = {R: false, T: 0, as: '', aE: '', aP: true};
var $author$project$Pages$Cms$Others$EditMailAddress$InitResponse = F3(
	function (users, permalinkGroups, stores) {
		return {i: permalinkGroups, aN: stores, k8: users};
	});
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Pages$Cms$Others$EditMailAddress$PermalinkGroup = F5(
	function (permalinkGroupId, permalinkGroupName, supervisor, valid, isUpdated) {
		return {R: isUpdated, T: permalinkGroupId, as: permalinkGroupName, aE: supervisor, aP: valid};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Pages$Cms$Others$EditMailAddress$permalinkGroupsDecoder = $elm$json$Json$Decode$list(
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Pages$Cms$Others$EditMailAddress$PermalinkGroup,
		A2($elm$json$Json$Decode$field, 'mail_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'supervisor',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(''),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$field,
			'valid',
			A2(
				$elm$json$Json$Decode$map,
				function (v) {
					return v === 1;
				},
				$elm$json$Json$Decode$int)),
		$elm$json$Json$Decode$succeed(false)));
var $author$project$Pages$Cms$Others$EditMailAddress$Store = F2(
	function (storeId, storeName) {
		return {iw: storeId, kS: storeName};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$storeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Others$EditMailAddress$Store,
	A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string));
var $author$project$Utils$Types$User = F2(
	function (userId, userName) {
		return {k7: userId, n2: userName};
	});
var $author$project$Utils$Decoders$usersDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Utils$Types$User,
		A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'user_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Others$EditMailAddress$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Cms$Others$EditMailAddress$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder),
	A2($elm$json$Json$Decode$field, 'mail_address', $author$project$Pages$Cms$Others$EditMailAddress$permalinkGroupsDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'stores',
		$elm$json$Json$Decode$list($author$project$Pages$Cms$Others$EditMailAddress$storeDecoder)));
var $author$project$Pages$Cms$Others$EditMailAddress$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{H: $elm$core$Maybe$Nothing, a0: $elm$core$Set$empty, cv: true, k: false, ae: $elm$core$Dict$empty, ba: $author$project$Pages$Cms$Others$EditMailAddress$initNewPermalinkGroup, cJ: $elm$core$Dict$empty, i: _List_Nil, $9: $elm$core$Maybe$Nothing, C: session, ej: false, aN: _List_Nil, k8: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editMailAddressEndpoints.x, session, $author$project$Pages$Cms$Others$EditMailAddress$initResponseDecoder, $author$project$Pages$Cms$Others$EditMailAddress$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Others$GetAccessCount$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$Others$GetAccessCount$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Endpoints$Cms$getAccessCount = 'get-access-count';
var $author$project$Endpoints$Cms$getAccessCountEndpoints = {
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$getAccessCount, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$getAccessCount]),
		_List_Nil),
	gH: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$others, $author$project$Endpoints$Cms$getAccessCount, 'send']),
		_List_Nil)
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Pages$Cms$Others$GetAccessCount$InitResponse = function (users) {
	return {k8: users};
};
var $author$project$Pages$Cms$Others$GetAccessCount$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Others$GetAccessCount$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Pages$Cms$Others$GetAccessCount$init = function (session) {
	var getTime = A3($elm$core$Task$map2, $elm$core$Tuple$pair, $elm$time$Time$here, $elm$time$Time$now);
	return _Utils_Tuple2(
		{
			b3: {
				hb: {dl: $elm$core$Maybe$Nothing},
				hc: _List_Nil,
				iF: $elm$core$Maybe$Nothing
			},
			H: $elm$core$Maybe$Nothing,
			cv: true,
			cY: '',
			cZ: '',
			$9: $elm$core$Maybe$Nothing,
			C: session,
			k8: _List_Nil
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Pages$Cms$Others$GetAccessCount$GotDate, getTime),
					A4($author$project$Api$get, $author$project$Endpoints$Cms$getAccessCountEndpoints.x, session, $author$project$Pages$Cms$Others$GetAccessCount$initResponseDecoder, $author$project$Pages$Cms$Others$GetAccessCount$InitRequestSent)
				])));
};
var $author$project$Pages$Cms$Products$AddProductConfig$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$addProductConfig = 'add-product-config';
var $author$project$Endpoints$Cms$products = 'products';
var $author$project$Endpoints$Cms$addProductConfigEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$addProductConfig, 'add']),
		_List_Nil),
	hk: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$addProductConfig, 'categories']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$addProductConfig, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$addProductConfig]),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$AddProductConfig$InitResponse = F2(
	function (users, makers) {
		return {cE: makers, k8: users};
	});
var $author$project$Utils$Types$Maker = F2(
	function (makerId, makerName) {
		return {jW: makerId, mH: makerName};
	});
var $author$project$Utils$Decoders$makersDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Utils$Types$Maker,
		A2($elm$json$Json$Decode$field, 'maker_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'maker_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$AddProductConfig$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Products$AddProductConfig$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Cms$Products$AddProductConfig$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{b4: '', b5: '', iR: $elm$core$Maybe$Nothing, iW: _List_Nil, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, hA: false, cv: true, dP: false, k: false, cE: _List_Nil, kn: _List_Nil, ig: $elm$core$Maybe$Nothing, eh: $elm$core$Maybe$Nothing, gD: $elm$core$Maybe$Nothing, gF: $elm$core$Maybe$Nothing, C: session, kL: _List_Nil, k8: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$addProductConfigEndpoints.x, session, $author$project$Pages$Cms$Products$AddProductConfig$initResponseDecoder, $author$project$Pages$Cms$Products$AddProductConfig$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$changeDisplayInterval = 'change-display-interval';
var $author$project$Endpoints$Cms$changeDisplayIntervalEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval, 'add']),
		_List_Nil),
	hk: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval, 'categories']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval, 'init']),
		_List_Nil),
	kn: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval, 'products']),
		_List_Nil),
	ie: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval, 'remove']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval, 'update']),
		_List_Nil),
	iE: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayInterval, 'update-all']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$InitResponse = function (users) {
	return {k8: users};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$ChangeDisplayInterval$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder));
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, iW: _List_Nil, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, hA: false, cv: true, dP: false, k: false, cE: _List_Nil, kn: _List_Nil, ig: $elm$core$Maybe$Nothing, eh: $elm$core$Maybe$Nothing, gD: $elm$core$Maybe$Nothing, gF: $elm$core$Maybe$Nothing, C: session, kL: _List_Nil, k8: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$changeDisplayIntervalEndpoints.x, session, $author$project$Pages$Cms$Products$ChangeDisplayInterval$initResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayInterval$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$changeDisplayOrder = 'change-display-order';
var $author$project$Endpoints$Cms$changeDisplayOrderEndpoints = {
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayOrder, 'init']),
		_List_Nil),
	kn: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayOrder, 'products']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayOrder]),
		_List_Nil),
	iE: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeDisplayOrder, 'update-all']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$InitResponse = function (users) {
	return {k8: users};
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$ChangeDisplayOrder$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder));
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, iW: _List_Nil, H: $elm$core$Maybe$Nothing, hA: false, cv: true, dP: false, k: false, cE: _List_Nil, kn: _List_Nil, ig: $elm$core$Maybe$Nothing, eh: $elm$core$Maybe$Nothing, gD: $elm$core$Maybe$Nothing, gF: $elm$core$Maybe$Nothing, C: session, kL: _List_Nil, k8: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$changeDisplayOrderEndpoints.x, session, $author$project$Pages$Cms$Products$ChangeDisplayOrder$initResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayOrder$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$changeUserProduct = 'change-user-product';
var $author$project$Endpoints$Cms$changeUserProductEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct, 'add']),
		_List_Nil),
	hk: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct, 'categories']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct, 'init']),
		_List_Nil),
	kn: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct, 'products']),
		_List_Nil),
	ie: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct, 'remove']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct, 'update']),
		_List_Nil),
	iE: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$changeUserProduct, 'update-all']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$initAddProduct = {
	ls: 0,
	lt: 0,
	a_: true,
	lW: _List_fromArray(
		[15]),
	lY: 0,
	a6: true,
	ju: 0,
	kl: '',
	nk: '',
	nl: 0,
	dk: false,
	oc: false
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$InitResponse = function (users) {
	return {k8: users};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$ChangeUserProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder));
var $author$project$Pages$Cms$Products$ChangeUserProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{ab: $author$project$Pages$Cms$Products$ChangeUserProduct$initAddProduct, iR: $elm$core$Maybe$Nothing, iW: _List_Nil, dx: 0, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, hA: false, cv: true, dP: false, k: false, cE: _List_Nil, kn: _List_Nil, ig: $elm$core$Maybe$Nothing, eh: $elm$core$Maybe$Nothing, gD: $elm$core$Maybe$Nothing, gF: $elm$core$Maybe$Nothing, C: session, kL: _List_Nil, k8: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$changeUserProductEndpoints.x, session, $author$project$Pages$Cms$Products$ChangeUserProduct$initResponseDecoder, $author$project$Pages$Cms$Products$ChangeUserProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Products$EditProducts$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$editProducts = 'edit-products';
var $author$project$Endpoints$Cms$editProductsEndpoints = {
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProducts, 'init']),
		_List_Nil),
	hS: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProducts, 'list-stores']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProducts]),
		_List_Nil),
	gH: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProducts, 'send']),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProducts, 'update']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$EditProducts$InitResponse = F2(
	function (makers, small_categories) {
		return {cE: makers, kM: small_categories};
	});
var $author$project$Pages$Cms$Products$EditProducts$Maker = F2(
	function (maker_id, maker_name) {
		return {ap: maker_id, jX: maker_name};
	});
var $author$project$Pages$Cms$Products$EditProducts$makersDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Pages$Cms$Products$EditProducts$Maker,
		A2($elm$json$Json$Decode$field, 'maker_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'maker_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$EditProducts$SmallCategory = F4(
	function (small_category_id, small_category_name, big_category_name, category_name) {
		return {iX: big_category_name, e4: category_name, c6: small_category_id, kN: small_category_name};
	});
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Pages$Cms$Products$EditProducts$smallCategoriesDecoder = $elm$json$Json$Decode$list(
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Pages$Cms$Products$EditProducts$SmallCategory,
		A2($elm$json$Json$Decode$field, 'small_category_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'small_category_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'big_category_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'category_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$EditProducts$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Products$EditProducts$InitResponse,
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Pages$Cms$Products$EditProducts$makersDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Pages$Cms$Products$EditProducts$smallCategoriesDecoder));
var $author$project$Pages$Cms$Products$EditProducts$init = function (session) {
	return _Utils_Tuple2(
		{fB: true, dK: '', dL: '', fE: false, fI: false, cE: _List_Nil, kl: '', nk: '', bg: _List_Nil, gz: $elm$core$Dict$empty, kE: _List_Nil, C: session, kL: _List_Nil, g_: false},
		A4($author$project$Api$get, $author$project$Endpoints$Cms$editProductsEndpoints.x, session, $author$project$Pages$Cms$Products$EditProducts$initResponseDecoder, $author$project$Pages$Cms$Products$EditProducts$InitRequestSent));
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$JanOrKataban = 0;
var $inkuzmin$elm_multiselect$Multiselect$Show = 0;
var $author$project$Endpoints$Cms$editProductsPermalinks = 'edit-products-permalinks';
var $author$project$Endpoints$Cms$editProductsPermalinksEndpoints = {
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProductsPermalinks, 'init']),
		_List_Nil),
	hS: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProductsPermalinks, 'list-stores']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProductsPermalinks]),
		_List_Nil),
	gH: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProductsPermalinks, 'send']),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editProductsPermalinks, 'update']),
		_List_Nil)
};
var $inkuzmin$elm_multiselect$Multiselect$Closed = 0;
var $inkuzmin$elm_multiselect$Multiselect$Model = $elm$core$Basics$identity;
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $inkuzmin$elm_multiselect$Multiselect$initModel = F3(
	function (values, tag1, inputInMenu) {
		return {
			bv: $elm$core$Maybe$Nothing,
			n: values,
			o: $elm$core$List$head(values),
			jH: $elm$core$Maybe$Just(''),
			hI: inputInMenu,
			hJ: 23.0,
			aL: false,
			kC: _List_Nil,
			al: 0,
			A: tag1,
			w: values
		};
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$InitResponse = F2(
	function (users, stores) {
		return {aN: stores, k8: users};
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$Store = F9(
	function (store_id, store_name, store_group_id, url, exhibition_name, property_id, permalink_group_id, display_name, isUpdated) {
		return {jd: display_name, l3: exhibition_name, R: isUpdated, U: permalink_group_id, nm: property_id, nL: store_group_id, gM: store_id, el: store_name, eD: url};
	});
var $elm_community$json_extra$Json$Decode$Extra$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$storeDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	$elm$json$Json$Decode$succeed(false),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'display_name',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'permalink_group_id',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'property_id',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'exhibition_name',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'url',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'store_group_id',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$field,
									'store_name',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Products$EditProductsPermalinks$Store))))))))));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$storesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int)),
		$elm$json$Json$Decode$list($author$project$Pages$Cms$Products$EditProductsPermalinks$storeDecoder)));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$usersDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Utils$Types$User,
		A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'user_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Products$EditProductsPermalinks$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Pages$Cms$Products$EditProductsPermalinks$usersDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Pages$Cms$Products$EditProductsPermalinks$storesDecoder));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$init = function (session) {
	return _Utils_Tuple2(
		{
			fB: true,
			fI: false,
			ad: false,
			p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
			s: _List_Nil,
			bh: 0,
			cW: $elm$core$Maybe$Nothing,
			c$: '',
			c0: '',
			ik: $elm$core$Maybe$Nothing,
			gF: $elm$core$Maybe$Nothing,
			aj: _List_Nil,
			C: session,
			aN: $elm$core$Dict$empty,
			b$: _List_Nil,
			k8: _List_Nil,
			ha: false
		},
		A4($author$project$Api$get, $author$project$Endpoints$Cms$editProductsPermalinksEndpoints.x, session, $author$project$Pages$Cms$Products$EditProductsPermalinks$initResponseDecoder, $author$project$Pages$Cms$Products$EditProductsPermalinks$InitRequestSent));
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$editSoldoutProducts = 'edit-soldout-products';
var $author$project$Endpoints$Cms$editSoldoutProductsEndpoints = {
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editSoldoutProducts, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editSoldoutProducts]),
		_List_Nil),
	gH: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editSoldoutProducts, 'send']),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$editSoldoutProducts, 'update']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$InitResponse = F2(
	function (makers, small_categories) {
		return {cE: makers, kM: small_categories};
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$Maker = F2(
	function (maker_id, maker_name) {
		return {ap: maker_id, jX: maker_name};
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$makersDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Pages$Cms$Products$EditSoldoutProducts$Maker,
		A2($elm$json$Json$Decode$field, 'maker_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'maker_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$EditSoldoutProducts$SmallCategory = F4(
	function (small_category_id, small_category_name, big_category_name, category_name) {
		return {iX: big_category_name, e4: category_name, c6: small_category_id, kN: small_category_name};
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$smallCategoriesDecoder = $elm$json$Json$Decode$list(
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Pages$Cms$Products$EditSoldoutProducts$SmallCategory,
		A2($elm$json$Json$Decode$field, 'small_category_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'small_category_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'big_category_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'category_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$EditSoldoutProducts$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Products$EditSoldoutProducts$InitResponse,
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Pages$Cms$Products$EditSoldoutProducts$makersDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Pages$Cms$Products$EditSoldoutProducts$smallCategoriesDecoder));
var $author$project$Pages$Cms$Products$EditSoldoutProducts$init = function (session) {
	return _Utils_Tuple2(
		{fB: true, dK: '', dL: '', fE: false, fI: false, cE: _List_Nil, kl: '', nk: '', bg: _List_Nil, kE: _List_Nil, C: session, kL: _List_Nil, aD: _List_Nil, g_: false},
		A4($author$project$Api$get, $author$project$Endpoints$Cms$editSoldoutProductsEndpoints.x, session, $author$project$Pages$Cms$Products$EditSoldoutProducts$initResponseDecoder, $author$project$Pages$Cms$Products$EditSoldoutProducts$InitRequestSent));
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$Product = F2(
	function (productId, productName) {
		return {kl: productId, nk: productName};
	});
var $author$project$Pages$Cms$Products$RakutenExcludedItems$productsDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Pages$Cms$Products$RakutenExcludedItems$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$RakutenExcludedItems$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$RakutenExcludedItems$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Cms$Products$RakutenExcludedItems$productsDecoder));
var $author$project$Endpoints$Cms$rakutenExcludedItems = 'rakuten-excluded-items';
var $author$project$Endpoints$Cms$rakutenExcludedItemsEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$rakutenExcludedItems, 'add']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$rakutenExcludedItems, 'init']),
		_List_Nil),
	ie: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$rakutenExcludedItems, 'remove']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$rakutenExcludedItems]),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$init = function (session) {
	return _Utils_Tuple2(
		{b4: '', fB: true, kn: _List_Nil, cV: '', C: session},
		A4($author$project$Api$get, $author$project$Endpoints$Cms$rakutenExcludedItemsEndpoints.x, session, $author$project$Pages$Cms$Products$RakutenExcludedItems$initResponseDecoder, $author$project$Pages$Cms$Products$RakutenExcludedItems$InitRequestSent));
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, cD: false, C: session, nO: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$init = function (session) {
	return _Utils_Tuple2(
		{
			iW: _List_fromArray(
				[
					{e_: 1, lu: '冷蔵庫'},
					{e_: 2, lu: '洗濯機'},
					{e_: 3, lu: 'クリーナー・空清'},
					{e_: 4, lu: 'レンジ・炊飯器'},
					{e_: 5, lu: '小家電'},
					{e_: 6, lu: 'ビルトインIH'}
				]),
			H: $elm$core$Maybe$Nothing,
			cD: false,
			ig: $elm$core$Maybe$Nothing,
			C: session,
			nO: false
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, cD: false, C: session, nO: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, cD: false, C: session, nO: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, cD: false, C: session, nO: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, cD: false, C: session, nO: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, cD: false, C: session, nO: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$InitResponse = function (users) {
	return {k8: users};
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$UserSpecificRouting$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder));
var $author$project$Endpoints$Cms$userSpecificRouting = 'user-specific-routing';
var $author$project$Endpoints$Cms$userSpecificRoutingEndpoints = {
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$userSpecificRouting, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$userSpecificRouting]),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{H: $elm$core$Maybe$Nothing, cv: true, gF: $elm$core$Maybe$Nothing, C: session, k8: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$userSpecificRoutingEndpoints.x, session, $author$project$Pages$Cms$Products$UserSpecificRouting$initResponseDecoder, $author$project$Pages$Cms$Products$UserSpecificRouting$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$editPermalinkGroup = 'edit-permalink-groups';
var $author$project$Endpoints$Cms$stores = 'stores';
var $author$project$Endpoints$Cms$editPermalinkGroupsEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editPermalinkGroup, 'add']),
		_List_Nil),
	ci: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editPermalinkGroup, 'delete']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editPermalinkGroup, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editPermalinkGroup]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editPermalinkGroup, 'update']),
		_List_Nil)
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$initNewPermalinkGroup = {R: false, T: 0, as: ''};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$InitResponse = function (permalinkGroups) {
	return {i: permalinkGroups};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$PermalinkGroup = F3(
	function (permalinkGroupId, permalinkGroupName, isUpdated) {
		return {R: isUpdated, T: permalinkGroupId, as: permalinkGroupName};
	});
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$permalinkGroupsDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Pages$Cms$Stores$EditPermalinkGroups$PermalinkGroup,
		A2($elm$json$Json$Decode$field, 'permalink_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'permalink_group_name', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed(false)));
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditPermalinkGroups$InitResponse,
	A2($elm$json$Json$Decode$field, 'permalink_groups', $author$project$Pages$Cms$Stores$EditPermalinkGroups$permalinkGroupsDecoder));
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{H: $elm$core$Maybe$Nothing, cv: true, k: false, ba: $author$project$Pages$Cms$Stores$EditPermalinkGroups$initNewPermalinkGroup, i: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editPermalinkGroupsEndpoints.x, session, $author$project$Pages$Cms$Stores$EditPermalinkGroups$initResponseDecoder, $author$project$Pages$Cms$Stores$EditPermalinkGroups$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Stores$EditStoreGroups$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$editStoreGroup = 'edit-store-groups';
var $author$project$Endpoints$Cms$editStoreGroupsEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreGroup, 'add']),
		_List_Nil),
	ci: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreGroup, 'delete']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreGroup, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreGroup]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreGroup, 'update']),
		_List_Nil)
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$initNewStoreGroup = {R: false, iv: 0, kR: ''};
var $author$project$Pages$Cms$Stores$EditStoreGroups$InitResponse = function (storeGroups) {
	return {X: storeGroups};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$StoreGroup = F3(
	function (storeGroupId, storeGroupName, isUpdated) {
		return {R: isUpdated, iv: storeGroupId, kR: storeGroupName};
	});
var $author$project$Pages$Cms$Stores$EditStoreGroups$storeGroupsDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Pages$Cms$Stores$EditStoreGroups$StoreGroup,
		A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed(false)));
var $author$project$Pages$Cms$Stores$EditStoreGroups$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditStoreGroups$InitResponse,
	A2($elm$json$Json$Decode$field, 'store_groups', $author$project$Pages$Cms$Stores$EditStoreGroups$storeGroupsDecoder));
var $author$project$Pages$Cms$Stores$EditStoreGroups$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{H: $elm$core$Maybe$Nothing, cv: true, k: false, cI: $author$project$Pages$Cms$Stores$EditStoreGroups$initNewStoreGroup, C: session, X: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editStoreGroupsEndpoints.x, session, $author$project$Pages$Cms$Stores$EditStoreGroups$initResponseDecoder, $author$project$Pages$Cms$Stores$EditStoreGroups$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$None = 0;
var $author$project$Endpoints$Cms$editStoreProperty = 'edit-store-properties';
var $author$project$Endpoints$Cms$editStorePropertiesEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreProperty, 'add']),
		_List_Nil),
	ci: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreProperty, 'delete']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreProperty, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreProperty]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStoreProperty, 'update']),
		_List_Nil)
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$InitResponse = F3(
	function (storeProperties, convertTypes, drivers) {
		return {bp: convertTypes, bt: drivers, Y: storeProperties};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$ConvertType = F2(
	function (convertType, description) {
		return {e9: convertType, lV: description};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$KeyLabel = F2(
	function (key, label) {
		return {dR: key, jP: label};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$convertTypesDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Pages$Cms$Stores$EditStoreProperties$ConvertType,
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Pages$Cms$Stores$EditStoreProperties$KeyLabel,
			A2($elm$json$Json$Decode$field, 'convert_type_id', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'convert_type_name', $elm$json$Json$Decode$string)),
		A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Stores$EditStoreProperties$driversDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Pages$Cms$Stores$EditStoreProperties$KeyLabel,
		A2($elm$json$Json$Decode$field, 'driver_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'driver_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Stores$EditStoreProperties$StoreProperty = function (property_id) {
	return function (property_name) {
		return function (price_selector) {
			return function (price_regex) {
				return function (point_selector) {
					return function (point_regex) {
						return function (constant_point) {
							return function (soldout_selector) {
								return function (soldout_regex) {
									return function (convert_type_id) {
										return function (sleep_time) {
											return function (driver_id) {
												return function (isUpdated) {
													return {cf: constant_point, cg: convert_type_id, cm: driver_id, R: isUpdated, cL: point_regex, cM: point_selector, cO: price_regex, cP: price_selector, nm: property_id, cT: property_name, c5: sleep_time, c8: soldout_regex, c9: soldout_selector};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$storePropertyDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	$elm$json$Json$Decode$succeed(false),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'driver_id', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'sleep_time', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'convert_type_id', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'soldout_regex',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'soldout_selector',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'constant_point', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$field,
									'point_regex',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2(
										$elm$json$Json$Decode$field,
										'point_selector',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'price_regex', $elm$json$Json$Decode$string),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'price_selector', $elm$json$Json$Decode$string),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'property_name', $elm$json$Json$Decode$string),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'property_id', $elm$json$Json$Decode$int),
													$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Stores$EditStoreProperties$StoreProperty))))))))))))));
var $author$project$Pages$Cms$Stores$EditStoreProperties$storePropertiesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'property_id', $elm$json$Json$Decode$int)),
		$elm$json$Json$Decode$list($author$project$Pages$Cms$Stores$EditStoreProperties$storePropertyDecoder)));
var $author$project$Pages$Cms$Stores$EditStoreProperties$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Cms$Stores$EditStoreProperties$InitResponse,
	A2($elm$json$Json$Decode$field, 'store_properties', $author$project$Pages$Cms$Stores$EditStoreProperties$storePropertiesDecoder),
	A2($elm$json$Json$Decode$field, 'convert_types', $author$project$Pages$Cms$Stores$EditStoreProperties$convertTypesDecoder),
	A2($elm$json$Json$Decode$field, 'webdrivers', $author$project$Pages$Cms$Stores$EditStoreProperties$driversDecoder));
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$newStoreProperty = {
	cf: 0,
	cg: 1,
	cm: 1,
	R: false,
	cL: $elm$core$Maybe$Just('.*?(\\d{1,3}(,\\d{3})*).*?'),
	cM: $elm$core$Maybe$Nothing,
	cO: '.*?(\\d{1,3}(,\\d{3})*).*?',
	cP: '',
	nm: -1,
	cT: '',
	c5: 5,
	c8: $elm$core$Maybe$Nothing,
	c9: $elm$core$Maybe$Nothing
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$init = function (session) {
	return _Utils_Tuple2(
		{bp: _List_Nil, bt: _List_Nil, H: $elm$core$Maybe$Nothing, fB: true, bb: $author$project$Pages$Cms$Stores$EditStoreProperties$newStoreProperty, f7: $elm$core$Dict$empty, C: session, Y: $elm$core$Dict$empty, F: 0, bm: $elm$core$Maybe$Nothing},
		A4($author$project$Api$get, $author$project$Endpoints$Cms$editStorePropertiesEndpoints.x, session, $author$project$Pages$Cms$Stores$EditStoreProperties$initResponseDecoder, $author$project$Pages$Cms$Stores$EditStoreProperties$InitRequestSent));
};
var $author$project$Pages$Cms$Stores$EditStores$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$Stores$EditStores$None = 0;
var $author$project$Endpoints$Cms$editStores = 'edit-stores';
var $author$project$Endpoints$Cms$editStoresEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStores, 'add']),
		_List_Nil),
	ci: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStores, 'delete']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStores, 'init']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStores]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editStores, 'update']),
		_List_Nil)
};
var $author$project$Pages$Cms$Stores$EditStores$InitResponse = F4(
	function (storeProperties, storeGroups, permalinkGroups, stores) {
		return {i: permalinkGroups, X: storeGroups, Y: storeProperties, aN: stores};
	});
var $author$project$Utils$Types$PermalinkGroup = F2(
	function (permalink_group_id, permalink_group_name) {
		return {U: permalink_group_id, j8: permalink_group_name};
	});
var $author$project$Pages$Cms$Stores$EditStores$permalinkGroupsDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Utils$Types$PermalinkGroup,
		A2($elm$json$Json$Decode$field, 'permalink_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'permalink_group_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Stores$EditStores$StoreGroup = F2(
	function (store_group_id, store_group_name) {
		return {nL: store_group_id, kU: store_group_name};
	});
var $author$project$Pages$Cms$Stores$EditStores$storeGroupsDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Pages$Cms$Stores$EditStores$StoreGroup,
		A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Stores$EditStores$StoreProperty = function (property_id) {
	return function (property_name) {
		return function (price_selector) {
			return function (price_regex) {
				return function (point_selector) {
					return function (point_regex) {
						return function (constant_point) {
							return function (soldout_selector) {
								return function (soldout_regex) {
									return function (convert_type_id) {
										return function (sleep_time) {
											return function (driver_id) {
												return {cf: constant_point, cg: convert_type_id, cm: driver_id, cL: point_regex, cM: point_selector, cO: price_regex, cP: price_selector, nm: property_id, cT: property_name, c5: sleep_time, c8: soldout_regex, c9: soldout_selector};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Cms$Stores$EditStores$storePropertyDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'driver_id', $elm$json$Json$Decode$int),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'sleep_time', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'convert_type_id', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'soldout_regex',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'soldout_selector',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'constant_point', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'point_regex',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$field,
									'point_selector',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'price_regex', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'price_selector', $elm$json$Json$Decode$string),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'property_name', $elm$json$Json$Decode$string),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'property_id', $elm$json$Json$Decode$int),
												$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Stores$EditStores$StoreProperty)))))))))))));
var $author$project$Pages$Cms$Stores$EditStores$storePropertiesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'property_id', $elm$json$Json$Decode$int)),
		$elm$json$Json$Decode$list($author$project$Pages$Cms$Stores$EditStores$storePropertyDecoder)));
var $author$project$Pages$Cms$Stores$EditStores$Store = F9(
	function (store_id, store_name, store_group_id, url, exhibition_name, property_id, permalink_group_id, display_name, isUpdated) {
		return {jd: display_name, l3: exhibition_name, R: isUpdated, U: permalink_group_id, nm: property_id, nL: store_group_id, gM: store_id, el: store_name, eD: url};
	});
var $author$project$Pages$Cms$Stores$EditStores$storeDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	$elm$json$Json$Decode$succeed(false),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'display_name',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'permalink_group_id',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'property_id',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'exhibition_name',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'url',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'store_group_id',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$field,
									'store_name',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Stores$EditStores$Store))))))))));
var $author$project$Pages$Cms$Stores$EditStores$storesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int)),
		$elm$json$Json$Decode$list($author$project$Pages$Cms$Stores$EditStores$storeDecoder)));
var $author$project$Pages$Cms$Stores$EditStores$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Cms$Stores$EditStores$InitResponse,
	A2($elm$json$Json$Decode$field, 'store_properties', $author$project$Pages$Cms$Stores$EditStores$storePropertiesDecoder),
	A2($elm$json$Json$Decode$field, 'store_groups', $author$project$Pages$Cms$Stores$EditStores$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'permalink_groups', $author$project$Pages$Cms$Stores$EditStores$permalinkGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Pages$Cms$Stores$EditStores$storesDecoder));
var $author$project$Pages$Cms$Stores$EditStores$newStore = {jd: $elm$core$Maybe$Nothing, l3: $elm$core$Maybe$Nothing, R: false, U: $elm$core$Maybe$Nothing, nm: $elm$core$Maybe$Nothing, nL: $elm$core$Maybe$Nothing, gM: -1, el: $elm$core$Maybe$Nothing, eD: $elm$core$Maybe$Nothing};
var $author$project$Pages$Cms$Stores$EditStores$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, fB: true, fI: false, bJ: $author$project$Pages$Cms$Stores$EditStores$newStore, i: _List_Nil, kD: $elm$core$Maybe$Nothing, kF: $elm$core$Maybe$Nothing, kH: $elm$core$Maybe$Nothing, C: session, X: _List_Nil, Y: $elm$core$Dict$empty, aN: $elm$core$Dict$empty, F: 0, g$: $elm$core$Maybe$Nothing},
		A4($author$project$Api$get, $author$project$Endpoints$Cms$editStoresEndpoints.x, session, $author$project$Pages$Cms$Stores$EditStores$initResponseDecoder, $author$project$Pages$Cms$Stores$EditStores$InitRequestSent));
};
var $author$project$Pages$Cms$Stores$EditUsersStores$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$Cms$editUsersStores = 'edit-users-stores';
var $author$project$Endpoints$Cms$editUsersStoresEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editUsersStores, 'add']),
		_List_Nil),
	ci: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editUsersStores, 'delete']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editUsersStores, 'init']),
		_List_Nil),
	hS: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editUsersStores, 'list-stores']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editUsersStores]),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$editUsersStores, 'update']),
		_List_Nil)
};
var $author$project$Pages$Cms$Stores$EditUsersStores$initNewUserStore = {fh: $elm$core$Maybe$Nothing, jr: false, js: $elm$core$Maybe$Nothing, R: false, iv: 0, kR: '', iw: -1, kS: '', kT: 0};
var $author$project$Pages$Cms$Stores$EditUsersStores$InitResponse = F3(
	function (users, storeGroups, stores) {
		return {X: storeGroups, aN: stores, k8: users};
	});
var $author$project$Utils$Types$Store = F4(
	function (storeId, storeName, storeGroupId, displayName) {
		return {fh: displayName, iv: storeGroupId, iw: storeId, kS: storeName};
	});
var $author$project$Utils$Decoders$storesDecoder = $elm$json$Json$Decode$list(
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Utils$Types$Store,
		A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'display_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Stores$EditUsersStores$TStoreGroup = F2(
	function (storeGroupId, storeGroupName) {
		return {iv: storeGroupId, kR: storeGroupName};
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$tStoreGroupsDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Pages$Cms$Stores$EditUsersStores$TStoreGroup,
		A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Stores$EditUsersStores$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Cms$Stores$EditUsersStores$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder),
	A2($elm$json$Json$Decode$field, 'store_groups', $author$project$Pages$Cms$Stores$EditUsersStores$tStoreGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder));
var $author$project$Pages$Cms$Stores$EditUsersStores$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{H: $elm$core$Maybe$Nothing, cv: true, k: false, y: $author$project$Pages$Cms$Stores$EditUsersStores$initNewUserStore, gC: $elm$core$Maybe$Nothing, $9: $elm$core$Maybe$Nothing, C: session, X: _List_Nil, aN: _List_Nil, b$: _List_Nil, k8: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editUsersStoresEndpoints.x, session, $author$project$Pages$Cms$Stores$EditUsersStores$initResponseDecoder, $author$project$Pages$Cms$Stores$EditUsersStores$InitRequestSent)
					])));
	});
var $author$project$Pages$Cms$Stores$Yahoo$GotInitResponse = function (a) {
	return {$: 0, a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Pages$Cms$Stores$Yahoo$InitResponse = function (users) {
	return {k8: users};
};
var $author$project$Pages$Cms$Stores$Yahoo$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$Yahoo$InitResponse,
	A2($elm$json$Json$Decode$field, 'users', $author$project$Utils$Decoders$usersDecoder));
var $author$project$Endpoints$Cms$yahoo = 'yahoo';
var $author$project$Endpoints$Cms$yahooEndpoints = {
	mc: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$yahoo, 'direct-urls'])),
	me: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$yahoo, 'get-products'])),
	x: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$yahoo, 'init'])),
	l: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$yahoo])),
	_: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$stores, $author$project$Endpoints$Cms$yahoo, 'update']))
};
var $author$project$Pages$Cms$Stores$Yahoo$init = function (session) {
	return _Utils_Tuple2(
		{aY: $krisajenkins$remotedata$RemoteData$Loading, fC: $krisajenkins$remotedata$RemoteData$Loading, cx: false, fJ: false, kn: $krisajenkins$remotedata$RemoteData$NotAsked, ii: '', bU: '', C: session},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Api$get,
					$author$project$Endpoints$Cms$yahooEndpoints.x(_List_Nil),
					session,
					$author$project$Pages$Cms$Stores$Yahoo$initResponseDecoder,
					$author$project$Pages$Cms$Stores$Yahoo$GotInitResponse)
				])));
};
var $author$project$Pages$Cms$Others$EditMailAddress$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Others$GetAccessCount$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$AddProductConfig$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$EditProducts$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Stores$EditStores$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Stores$EditUsersStores$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$Stores$Yahoo$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Cms$toSession = function (_v0) {
	var cmsModel = _v0.a;
	switch (cmsModel.$) {
		case 0:
			var session = cmsModel.a;
			return session;
		case 1:
			var espModel = cmsModel.a;
			return $author$project$Pages$Cms$Stores$EditStoreProperties$toSession(espModel);
		case 2:
			var espModel = cmsModel.a;
			return $author$project$Pages$Cms$Stores$EditPermalinkGroups$toSession(espModel);
		case 3:
			var espModel = cmsModel.a;
			return $author$project$Pages$Cms$Stores$EditStoreGroups$toSession(espModel);
		case 4:
			var espModel = cmsModel.a;
			return $author$project$Pages$Cms$Others$EditMailAddress$toSession(espModel);
		case 5:
			var espModel = cmsModel.a;
			return $author$project$Pages$Cms$Others$GetAccessCount$toSession(espModel);
		case 6:
			var espModel = cmsModel.a;
			return $author$project$Pages$Cms$Stores$EditUsersStores$toSession(espModel);
		case 21:
			var espModel = cmsModel.a;
			return $author$project$Pages$Cms$Stores$EditStores$toSession(espModel);
		case 10:
			var uwModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$toSession(uwModel);
		case 11:
			var model = cmsModel.a;
			return $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$toSession(model);
		case 12:
			var model = cmsModel.a;
			return $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$toSession(model);
		case 9:
			var model = cmsModel.a;
			return $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$toSession(model);
		case 7:
			var model = cmsModel.a;
			return $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$toSession(model);
		case 8:
			var model = cmsModel.a;
			return $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$toSession(model);
		case 14:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$RakutenExcludedItems$toSession(reiModel);
		case 15:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$ChangeDisplayInterval$toSession(reiModel);
		case 13:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$UserSpecificRouting$toSession(reiModel);
		case 16:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$ChangeUserProduct$toSession(reiModel);
		case 17:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$AddProductConfig$toSession(reiModel);
		case 18:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$ChangeDisplayOrder$toSession(reiModel);
		case 19:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$EditProductsPermalinks$toSession(reiModel);
		case 20:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$EditProducts$toSession(reiModel);
		case 22:
			var yModel = cmsModel.a;
			return $author$project$Pages$Cms$Stores$Yahoo$toSession(yModel);
		case 23:
			var reiModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$EditSoldoutProducts$toSession(reiModel);
		default:
			var uwModel = cmsModel.a;
			return $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$toSession(uwModel);
	}
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Pages$Cms$updateWithNavModel = F4(
	function (toModel, toMsg, navModel, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_Tuple2(
				toModel(subModel),
				navModel),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Pages$Cms$changeRouteTo = F2(
	function (url, model) {
		var router = $author$project$Routers$CmsRouter$fromUrl(url);
		var _v0 = model;
		var cmsModel = _v0.a;
		var navModel = _v0.b;
		switch (router) {
			case 1:
				return _Utils_Tuple2(
					_Utils_Tuple2(cmsModel, navModel),
					$elm$core$Platform$Cmd$none);
			case 2:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditStoreProperties,
					$author$project$Pages$Cms$GotEditStorePropertiesMsg,
					navModel,
					$author$project$Pages$Cms$Stores$EditStoreProperties$init(
						$author$project$Pages$Cms$toSession(model)));
			case 3:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditPermalinkGroups,
					$author$project$Pages$Cms$GotEditPermalinkGroupsMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Stores$EditPermalinkGroups$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 4:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditStoreGroups,
					$author$project$Pages$Cms$GotEditStoreGroupsMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Stores$EditStoreGroups$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 20:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditMailAddress,
					$author$project$Pages$Cms$GotEditMailAddressMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Others$EditMailAddress$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 21:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$GetAccessCount,
					$author$project$Pages$Cms$GotGetAccessCountMsg,
					navModel,
					$author$project$Pages$Cms$Others$GetAccessCount$init(
						$author$project$Pages$Cms$toSession(model)));
			case 5:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditUsersStores,
					$author$project$Pages$Cms$GotEditUsersStoresMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Stores$EditUsersStores$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 6:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UpdateWeek30ByCsv,
					$author$project$Pages$Cms$GotUpdateWeek30ByCsv,
					navModel,
					$author$project$Pages$Cms$Products$UpdateWeek30ByCsv$init(
						$author$project$Pages$Cms$toSession(model)));
			case 7:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UpdateTletProductsByCsv,
					$author$project$Pages$Cms$GotUpdateTletProductsByCsv,
					navModel,
					$author$project$Pages$Cms$Products$UpdateTletProductsByCsv$init(
						$author$project$Pages$Cms$toSession(model)));
			case 8:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UpdateTescomProductsByCsv,
					$author$project$Pages$Cms$GotUpdateTescomProductsByCsv,
					navModel,
					$author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$init(
						$author$project$Pages$Cms$toSession(model)));
			case 10:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UpdateHitachiWeeklyProductsByCsv,
					$author$project$Pages$Cms$GotUpdateHitachiWeeklyProductsByCsv,
					navModel,
					$author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$init(
						$author$project$Pages$Cms$toSession(model)));
			case 11:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UpdateHitachiProductsOrderByCsv,
					$author$project$Pages$Cms$GotUpdateHIitachiProductsOrderByCsv,
					navModel,
					$author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$init(
						$author$project$Pages$Cms$toSession(model)));
			case 9:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UpdateSharpProductsByCsv,
					$author$project$Pages$Cms$GotUpdateSharpProductsByCsv,
					navModel,
					$author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$init(
						$author$project$Pages$Cms$toSession(model)));
			case 12:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UserSpecificRoutingModel,
					$author$project$Pages$Cms$GotUserSpecificRoutingMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Products$UserSpecificRouting$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 13:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$RakutenExcludedItems,
					$author$project$Pages$Cms$GotRakutenExcludedItems,
					navModel,
					$author$project$Pages$Cms$Products$RakutenExcludedItems$init(
						$author$project$Pages$Cms$toSession(model)));
			case 14:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$ChangeDisplayIntervalModel,
					$author$project$Pages$Cms$GotChangeDisplayIntervalMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Products$ChangeDisplayInterval$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 15:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$ChangeUserProductModel,
					$author$project$Pages$Cms$GotChangeUserProductMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Products$ChangeUserProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 17:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$AddProductConfigModel,
					$author$project$Pages$Cms$GotAddProductConfigMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Products$AddProductConfig$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 16:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$ChangeDisplayOrderModel,
					$author$project$Pages$Cms$GotChangeDisplayOrderMsg,
					navModel,
					A3(
						$author$project$Pages$Cms$Products$ChangeDisplayOrder$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Cms$toSession(model)));
			case 18:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditProductsPermalinks,
					$author$project$Pages$Cms$GotEditProductsPermalinks,
					navModel,
					$author$project$Pages$Cms$Products$EditProductsPermalinks$init(
						$author$project$Pages$Cms$toSession(model)));
			case 19:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditProducts,
					$author$project$Pages$Cms$GotEditProducts,
					navModel,
					$author$project$Pages$Cms$Products$EditProducts$init(
						$author$project$Pages$Cms$toSession(model)));
			case 22:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditStores,
					$author$project$Pages$Cms$GotEditStoresMsg,
					navModel,
					$author$project$Pages$Cms$Stores$EditStores$init(
						$author$project$Pages$Cms$toSession(model)));
			case 23:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$Yahoo,
					$author$project$Pages$Cms$GotYahooMsg,
					navModel,
					$author$project$Pages$Cms$Stores$Yahoo$init(
						$author$project$Pages$Cms$toSession(model)));
			case 24:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$EditSoldoutProducts,
					$author$project$Pages$Cms$GotEditSoldoutProductsMsg,
					navModel,
					$author$project$Pages$Cms$Products$EditSoldoutProducts$init(
						$author$project$Pages$Cms$toSession(model)));
			case 25:
				return A4(
					$author$project$Pages$Cms$updateWithNavModel,
					$author$project$Pages$Cms$UpdateFujiWeeklyProductsByCsv,
					$author$project$Pages$Cms$GotUpdateFujiWeeklyProductsByCsv,
					navModel,
					$author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$init(
						$author$project$Pages$Cms$toSession(model)));
			default:
				return _Utils_Tuple2(
					_Utils_Tuple2(cmsModel, navModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$User$AddProductConfigModel = function (a) {
	return {$: 83, a: a};
};
var $author$project$Pages$User$BraunComnetHourModel = function (a) {
	return {$: 87, a: a};
};
var $author$project$Pages$User$BraunComnetWideModel = function (a) {
	return {$: 88, a: a};
};
var $author$project$Pages$User$Ca6ComnetCsvModel = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$User$Ca6ComnetHour2Model = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$User$Ca6ComnetHourModel = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$User$Ca6ComnetItemsModel = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$User$Ca6ComnetLowModel = function (a) {
	return {$: 41, a: a};
};
var $author$project$Pages$User$Ca6ComnetWeeklyProduct2Model = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$User$Ca6ComnetWeeklyProductModel = function (a) {
	return {$: 38, a: a};
};
var $author$project$Pages$User$ChangeProductModel = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$User$ChangeUserProductModel = function (a) {
	return {$: 82, a: a};
};
var $author$project$Pages$User$CommonWeeklyProductModel = function (a) {
	return {$: 96, a: a};
};
var $author$project$Pages$User$Dbi6ComnetHourModel = function (a) {
	return {$: 77, a: a};
};
var $author$project$Pages$User$Dbi6ComnetTimeSeqModel = function (a) {
	return {$: 78, a: a};
};
var $author$project$Pages$User$DefaultModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$DelonghiChangeProductModel = function (a) {
	return {$: 61, a: a};
};
var $author$project$Pages$User$DelonghiHourModel = function (a) {
	return {$: 60, a: a};
};
var $author$project$Pages$User$DelonghiNineAMModel = function (a) {
	return {$: 64, a: a};
};
var $author$project$Pages$User$DelonghiTimeSeq2Model = function (a) {
	return {$: 63, a: a};
};
var $author$project$Pages$User$DelonghiTimeSeqModel = function (a) {
	return {$: 62, a: a};
};
var $author$project$Pages$User$DelonghiWeeklyModel = function (a) {
	return {$: 65, a: a};
};
var $author$project$Pages$User$Denon6ComnetTimeSeqModel = function (a) {
	return {$: 79, a: a};
};
var $author$project$Pages$User$Denon6ComnetWideModel = function (a) {
	return {$: 80, a: a};
};
var $author$project$Pages$User$EditProductsModel = function (a) {
	return {$: 84, a: a};
};
var $author$project$Pages$User$EditProductsPermalinks = function (a) {
	return {$: 81, a: a};
};
var $author$project$Pages$User$EditSoldoutProductsModel = function (a) {
	return {$: 86, a: a};
};
var $author$project$Pages$User$ElecComnetChangeProductModel = function (a) {
	return {$: 56, a: a};
};
var $author$project$Pages$User$ElecComnetExcelModel = function (a) {
	return {$: 55, a: a};
};
var $author$project$Pages$User$ElecComnetHourModel = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$User$ElecComnetTimeSeqModel = function (a) {
	return {$: 57, a: a};
};
var $author$project$Pages$User$FujiComnetChangeProductModel = function (a) {
	return {$: 93, a: a};
};
var $author$project$Pages$User$FujiComnetFifteenModel = function (a) {
	return {$: 91, a: a};
};
var $author$project$Pages$User$FujiComnetLatestStoreModel = function (a) {
	return {$: 94, a: a};
};
var $author$project$Pages$User$FujiComnetMailAddressModel = function (a) {
	return {$: 95, a: a};
};
var $author$project$Pages$User$FujiComnetWeek30Model = function (a) {
	return {$: 92, a: a};
};
var $author$project$Pages$User$FujiinstaxComnetLatestStoreModel = function (a) {
	return {$: 99, a: a};
};
var $author$project$Pages$User$FujiinstaxComnetThirtyModel = function (a) {
	return {$: 97, a: a};
};
var $author$project$Pages$User$FujiinstaxComnetWeek30Model = function (a) {
	return {$: 98, a: a};
};
var $author$project$Pages$User$GotAddProductConfigMsg = function (a) {
	return {$: 84, a: a};
};
var $author$project$Pages$User$GotBraunComnetHourMsg = function (a) {
	return {$: 88, a: a};
};
var $author$project$Pages$User$GotBraunComnetWideMsg = function (a) {
	return {$: 89, a: a};
};
var $author$project$Pages$User$GotCa6ComnetCsvMsg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Pages$User$GotCa6ComnetHour2Msg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$User$GotCa6ComnetHourMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$User$GotCa6ComnetItemsMsg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Pages$User$GotCa6ComnetLowMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$User$GotCa6ComnetWeeklyProduct2Msg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$User$GotCa6ComnetWeeklyProductMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$User$GotChangeProductMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$User$GotChangeUserProductMsg = function (a) {
	return {$: 83, a: a};
};
var $author$project$Pages$User$GotCommonWeeklyProductMsg = function (a) {
	return {$: 97, a: a};
};
var $author$project$Pages$User$GotDbi6ComnetHourMsg = function (a) {
	return {$: 78, a: a};
};
var $author$project$Pages$User$GotDbi6ComnetTimeSeqMsg = function (a) {
	return {$: 79, a: a};
};
var $author$project$Pages$User$GotDefaultMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$GotDelonghiChangeProductMsg = function (a) {
	return {$: 62, a: a};
};
var $author$project$Pages$User$GotDelonghiHourMsg = function (a) {
	return {$: 61, a: a};
};
var $author$project$Pages$User$GotDelonghiNineAMMsg = function (a) {
	return {$: 65, a: a};
};
var $author$project$Pages$User$GotDelonghiTimeSeq2Msg = function (a) {
	return {$: 64, a: a};
};
var $author$project$Pages$User$GotDelonghiTimeSeqMsg = function (a) {
	return {$: 63, a: a};
};
var $author$project$Pages$User$GotDelonghiWeeklyMsg = function (a) {
	return {$: 66, a: a};
};
var $author$project$Pages$User$GotDenon6ComnetTimeSeqMsg = function (a) {
	return {$: 81, a: a};
};
var $author$project$Pages$User$GotDenon6ComnetWideMsg = function (a) {
	return {$: 80, a: a};
};
var $author$project$Pages$User$GotEditProductsMsg = function (a) {
	return {$: 85, a: a};
};
var $author$project$Pages$User$GotEditProductsPermalinks = function (a) {
	return {$: 82, a: a};
};
var $author$project$Pages$User$GotEditSoldoutProductsMsg = function (a) {
	return {$: 87, a: a};
};
var $author$project$Pages$User$GotElecComnetChangeProductMsg = function (a) {
	return {$: 57, a: a};
};
var $author$project$Pages$User$GotElecComnetExcelMsg = function (a) {
	return {$: 56, a: a};
};
var $author$project$Pages$User$GotElecComnetHourMsg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Pages$User$GotElecComnetTimeSeqMsg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Pages$User$GotFujiComnetChangeProductMsg = function (a) {
	return {$: 94, a: a};
};
var $author$project$Pages$User$GotFujiComnetFifteenMsg = function (a) {
	return {$: 92, a: a};
};
var $author$project$Pages$User$GotFujiComnetLatestStoreMsg = function (a) {
	return {$: 95, a: a};
};
var $author$project$Pages$User$GotFujiComnetMailAddressMsg = function (a) {
	return {$: 96, a: a};
};
var $author$project$Pages$User$GotFujiComnetWeek30Msg = function (a) {
	return {$: 93, a: a};
};
var $author$project$Pages$User$GotFujiinstaxComnetLatestStoreMsg = function (a) {
	return {$: 100, a: a};
};
var $author$project$Pages$User$GotFujiinstaxComnetThirtyMsg = function (a) {
	return {$: 98, a: a};
};
var $author$project$Pages$User$GotFujiinstaxComnetWeek30Msg = function (a) {
	return {$: 99, a: a};
};
var $author$project$Pages$User$GotHi24ComnetDayMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$User$GotHi24ComnetHourMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$GotHi24ComnetHourSeqMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$User$GotHi24ComnetSixHourMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$User$GotHi24ComnetTenAMMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$User$GotHi24ComnetTimeSeqMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$GotHi24ComnetWeeklyProductFifteenMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$User$GotHi3ComnetHourMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$User$GotHi3ComnetTimeSeqMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$User$GotHisenseAmazonMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$User$GotHisenseChangeProductMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$User$GotHisenseDayMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$User$GotHisenseExcelMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$User$GotHisenseReviewMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$User$GotHisenseTimeSeqMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$User$GotHisenseTvHourMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$User$GotJvcComnetAmazonMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$User$GotJvcComnetDefaultMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$User$GotJvcComnetPriceDropMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$User$GotJvcComnetTimeSeqMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$User$GotKinujoComnetChangeProductMsg = function (a) {
	return {$: 68, a: a};
};
var $author$project$Pages$User$GotKinujoComnetExcelMsg = function (a) {
	return {$: 67, a: a};
};
var $author$project$Pages$User$GotKinujoComnetFifteeenMsg = function (a) {
	return {$: 69, a: a};
};
var $author$project$Pages$User$GotMlnComnetAutoReloadMsg = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$User$GotMlnComnetChangeMailMsg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$User$GotMlnComnetChangeMailTestMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$User$GotMlnComnetChangePasswordMsg = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$User$GotMlnComnetChangeProductMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Pages$User$GotMlnComnetChronologicalMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$User$GotMlnComnetHourMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$User$GotMlnComnetHourYamadaMsg = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$User$GotMlnComnetMailSettingMsg = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$User$GotMlnComnetYahooMsg = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$User$GotShaComnetChangeProductMsg = function (a) {
	return {$: 75, a: a};
};
var $author$project$Pages$User$GotShaComnetDayMsg = function (a) {
	return {$: 74, a: a};
};
var $author$project$Pages$User$GotShaComnetHourMsg = function (a) {
	return {$: 71, a: a};
};
var $author$project$Pages$User$GotShaComnetTimeSeqMsg = function (a) {
	return {$: 72, a: a};
};
var $author$project$Pages$User$GotShaComnetWeeklyProductMsg = function (a) {
	return {$: 73, a: a};
};
var $author$project$Pages$User$GotShaComnetWideMsg = function (a) {
	return {$: 70, a: a};
};
var $author$project$Pages$User$GotTescomComnetChangeProductMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$User$GotTescomComnetExcelMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$User$GotTescomComnetHourMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$User$GotTestFifteeenMsg = function (a) {
	return {$: 101, a: a};
};
var $author$project$Pages$User$GotTimeSeqMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$GotTo24tclComnetChangeProductMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$User$GotTo24tclComnetDayMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$User$GotTo24tclComnetTimeSeqMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$User$GotTo24tcmComnetChangeProductMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$User$GotTo24tcmComnetCsvMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$User$GotTo24tcmComnetDayMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$User$GotTo24tcmComnetProductMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$User$GotTo24tcmFridgeHourMixMsg = function (a) {
	return {$: 60, a: a};
};
var $author$project$Pages$User$GotTo24tcmKitchenDayMsg = function (a) {
	return {$: 59, a: a};
};
var $author$project$Pages$User$GotTsBatTimeSeqMsg = function (a) {
	return {$: 91, a: a};
};
var $author$project$Pages$User$GotTsBatWideMsg = function (a) {
	return {$: 90, a: a};
};
var $author$project$Pages$User$GotTstComnetTimeSeqMsg = function (a) {
	return {$: 76, a: a};
};
var $author$project$Pages$User$GotTstComnetWideMsg = function (a) {
	return {$: 77, a: a};
};
var $author$project$Pages$User$GotTv24ComnetChangeProductMsg = function (a) {
	return {$: 53, a: a};
};
var $author$project$Pages$User$GotTv24ComnetThirtyMsg = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$User$GotYahooMsg = function (a) {
	return {$: 86, a: a};
};
var $author$project$Pages$User$Hi24ComnetDayModel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$User$Hi24ComnetHourModel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Hi24ComnetHourSeqModel = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$User$Hi24ComnetSixHourModel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$User$Hi24ComnetTenAMModel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$User$Hi24ComnetTimeSeqModel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$User$Hi24ComnetWeeklyProductFifteenModel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$User$Hi3ComnetHourModel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$User$Hi3ComnetTimeSeqModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$User$HisenseAmazonModel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$User$HisenseChangeProductModel = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$User$HisenseDayModel = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$User$HisenseExcelModel = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$User$HisenseReviewModel = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$User$HisenseTimeSeqModel = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$User$HisenseTvHourModel = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$User$JvcComnetAmazonModel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$User$JvcComnetDefaultModel = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$User$JvcComnetPriceDropModel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$User$JvcComnetTimeSeqModel = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$User$KinujoComnetChangeProductModel = function (a) {
	return {$: 67, a: a};
};
var $author$project$Pages$User$KinujoComnetExcelModel = function (a) {
	return {$: 66, a: a};
};
var $author$project$Pages$User$KinujoComnetFifteenModel = function (a) {
	return {$: 68, a: a};
};
var $author$project$Pages$User$MlnComnetAutoReloadModel = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$User$MlnComnetChangeMailModel = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$User$MlnComnetChangeMailTestModel = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$User$MlnComnetChangePasswordModel = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$User$MlnComnetChangeProductModel = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$User$MlnComnetChronologicalModel = function (a) {
	return {$: 43, a: a};
};
var $author$project$Pages$User$MlnComnetHourModel = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$User$MlnComnetHourYamadaModel = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$User$MlnComnetMailSettingModel = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$User$MlnComnetYahooModel = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$User$ShaComnetChangeProductModel = function (a) {
	return {$: 74, a: a};
};
var $author$project$Pages$User$ShaComnetDayModel = function (a) {
	return {$: 73, a: a};
};
var $author$project$Pages$User$ShaComnetHourModel = function (a) {
	return {$: 70, a: a};
};
var $author$project$Pages$User$ShaComnetTimeSeqModel = function (a) {
	return {$: 71, a: a};
};
var $author$project$Pages$User$ShaComnetWeeklyProductModel = function (a) {
	return {$: 72, a: a};
};
var $author$project$Pages$User$ShaComnetWideModel = function (a) {
	return {$: 69, a: a};
};
var $author$project$Pages$User$TescomComnetChangeProductModel = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$User$TescomComnetExcelModel = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$User$TescomComnetHourModel = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$User$TestFifteenModel = function (a) {
	return {$: 100, a: a};
};
var $author$project$Pages$User$TimeSeqModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$To24tclComnetChangeProductModel = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$User$To24tclComnetDayModel = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$User$To24tclComnetTimeSeqModel = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$User$To24tcmComnetChangeProductModel = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$User$To24tcmComnetCsvModel = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$User$To24tcmComnetDayModel = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$User$To24tcmComnetProductModel = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$User$To24tcmComnetTimeSeqModel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$User$To24tcmFridgeHourMixModel = function (a) {
	return {$: 59, a: a};
};
var $author$project$Pages$User$To24tcmKitchenDayModel = function (a) {
	return {$: 58, a: a};
};
var $author$project$Pages$User$TsBatTimeSeqModel = function (a) {
	return {$: 89, a: a};
};
var $author$project$Pages$User$TsBatWideModel = function (a) {
	return {$: 90, a: a};
};
var $author$project$Pages$User$TstComnetTimeSeqModel = function (a) {
	return {$: 75, a: a};
};
var $author$project$Pages$User$TstComnetWideModel = function (a) {
	return {$: 76, a: a};
};
var $author$project$Pages$User$Tv24ComnetChangeProductModel = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$User$Tv24ComnetThirtyModel = function (a) {
	return {$: 53, a: a};
};
var $author$project$Pages$User$Yahoo = function (a) {
	return {$: 85, a: a};
};
var $author$project$Routers$UserRouter$NotFound = 0;
var $author$project$Routers$UserRouter$AddProductConfig = 113;
var $author$project$Routers$UserRouter$BraunComnetHour = 109;
var $author$project$Routers$UserRouter$BraunComnetWide = 110;
var $author$project$Routers$UserRouter$Ca6ComnetCsv = 49;
var $author$project$Routers$UserRouter$Ca6ComnetHour = 47;
var $author$project$Routers$UserRouter$Ca6ComnetHour2 = 48;
var $author$project$Routers$UserRouter$Ca6ComnetItems = 52;
var $author$project$Routers$UserRouter$Ca6ComnetLow = 53;
var $author$project$Routers$UserRouter$Ca6ComnetWeeklyProduct = 50;
var $author$project$Routers$UserRouter$Ca6ComnetWeeklyProduct2 = 51;
var $author$project$Routers$UserRouter$ChangeUserProduct = 112;
var $author$project$Routers$UserRouter$Dbi6ComnetHour = 105;
var $author$project$Routers$UserRouter$Dbi6ComnetTimeSeq = 106;
var $author$project$Routers$UserRouter$DelonghiChangeProduct = 82;
var $author$project$Routers$UserRouter$DelonghiHour = 81;
var $author$project$Routers$UserRouter$DelonghiNineAM = 85;
var $author$project$Routers$UserRouter$DelonghiTimeSeq2Hour = 84;
var $author$project$Routers$UserRouter$DelonghiTimeSeqHour = 83;
var $author$project$Routers$UserRouter$DelonghiWeekly = 86;
var $author$project$Routers$UserRouter$Denon6ComnetTimeSeq = 108;
var $author$project$Routers$UserRouter$Denon6ComnetWide = 107;
var $author$project$Routers$UserRouter$EditProducts = 114;
var $author$project$Routers$UserRouter$EditProductsPermalinks = 111;
var $author$project$Routers$UserRouter$EditSoldoutProducts = 116;
var $author$project$Routers$UserRouter$ElecComnet15Min = 67;
var $author$project$Routers$UserRouter$ElecComnetChangeProduct = 70;
var $author$project$Routers$UserRouter$ElecComnetExcel = 69;
var $author$project$Routers$UserRouter$ElecComnetHour = 68;
var $author$project$Routers$UserRouter$ElecComnetTimeSeqFifteen = 71;
var $author$project$Routers$UserRouter$ElecComnetTimeSeqHour = 72;
var $author$project$Routers$UserRouter$FujiComnetChangeProduct = 122;
var $author$project$Routers$UserRouter$FujiComnetFifteen = 119;
var $author$project$Routers$UserRouter$FujiComnetLatestStore = 123;
var $author$project$Routers$UserRouter$FujiComnetMailAddress = 124;
var $author$project$Routers$UserRouter$FujiComnetTimeSeqFifteen = 120;
var $author$project$Routers$UserRouter$FujiComnetWeek30 = 121;
var $author$project$Routers$UserRouter$FujiComnetWeeklyProductFifteen = 125;
var $author$project$Routers$UserRouter$FujiinstaxComnetLatestStore = 129;
var $author$project$Routers$UserRouter$FujiinstaxComnetThirty = 126;
var $author$project$Routers$UserRouter$FujiinstaxComnetTimeSeqThirty = 127;
var $author$project$Routers$UserRouter$FujiinstaxComnetWeek30 = 128;
var $author$project$Routers$UserRouter$Hi24ComnetDay = 90;
var $author$project$Routers$UserRouter$Hi24ComnetHour = 91;
var $author$project$Routers$UserRouter$Hi24ComnetHourSeq = 94;
var $author$project$Routers$UserRouter$Hi24ComnetSixHour = 92;
var $author$project$Routers$UserRouter$Hi24ComnetTenAM = 96;
var $author$project$Routers$UserRouter$Hi24ComnetTimeSeq = 93;
var $author$project$Routers$UserRouter$Hi24ComnetWeeklyProductFifteen = 95;
var $author$project$Routers$UserRouter$Hi3ComnetChangeProduct = 80;
var $author$project$Routers$UserRouter$Hi3ComnetHour = 78;
var $author$project$Routers$UserRouter$Hi3ComnetHourSeq = 79;
var $author$project$Routers$UserRouter$HisenseAmazon = 39;
var $author$project$Routers$UserRouter$HisenseChangeProduct = 40;
var $author$project$Routers$UserRouter$HisenseDay = 36;
var $author$project$Routers$UserRouter$HisenseExcel = 42;
var $author$project$Routers$UserRouter$HisenseReview = 41;
var $author$project$Routers$UserRouter$HisenseTimeSeq = 37;
var $author$project$Routers$UserRouter$HisenseTvHour = 38;
var $author$project$Routers$UserRouter$JvcComnetAmazon = 33;
var $author$project$Routers$UserRouter$JvcComnetAmazonFifteen = 34;
var $author$project$Routers$UserRouter$JvcComnetFifteen = 29;
var $author$project$Routers$UserRouter$JvcComnetHour = 30;
var $author$project$Routers$UserRouter$JvcComnetPriceDrop = 35;
var $author$project$Routers$UserRouter$JvcComnetTimeSeqFifteen = 31;
var $author$project$Routers$UserRouter$JvcComnetTimeSeqHour = 32;
var $author$project$Routers$UserRouter$KinujoComnetChangeProduct = 89;
var $author$project$Routers$UserRouter$KinujoComnetExcel = 88;
var $author$project$Routers$UserRouter$KinujoComnetFifteen = 87;
var $author$project$Routers$UserRouter$MlnComnetAutoReload = 61;
var $author$project$Routers$UserRouter$MlnComnetChangeMail = 55;
var $author$project$Routers$UserRouter$MlnComnetChangeMailTest = 56;
var $author$project$Routers$UserRouter$MlnComnetChangePassword = 57;
var $author$project$Routers$UserRouter$MlnComnetChangeProduct = 54;
var $author$project$Routers$UserRouter$MlnComnetChronological30min = 58;
var $author$project$Routers$UserRouter$MlnComnetHour = 59;
var $author$project$Routers$UserRouter$MlnComnetHourYamada = 60;
var $author$project$Routers$UserRouter$MlnComnetMailSetting = 62;
var $author$project$Routers$UserRouter$MlnComnetYahoo = 63;
var $author$project$Routers$UserRouter$ShaComnetChangeProduct = 102;
var $author$project$Routers$UserRouter$ShaComnetDay = 101;
var $author$project$Routers$UserRouter$ShaComnetHour = 98;
var $author$project$Routers$UserRouter$ShaComnetHourSeq = 99;
var $author$project$Routers$UserRouter$ShaComnetWeeklyProduct = 100;
var $author$project$Routers$UserRouter$ShaComnetWide = 97;
var $author$project$Routers$UserRouter$TescomComnet15Min = 43;
var $author$project$Routers$UserRouter$TescomComnetChangeProduct = 46;
var $author$project$Routers$UserRouter$TescomComnetExcel = 45;
var $author$project$Routers$UserRouter$TescomComnetHour = 44;
var $author$project$Routers$UserRouter$TestFifteen = 130;
var $author$project$Routers$UserRouter$To24tclComnetChangeProduct = 13;
var $author$project$Routers$UserRouter$To24tclComnetCsv = 12;
var $author$project$Routers$UserRouter$To24tclComnetDay = 11;
var $author$project$Routers$UserRouter$To24tclComnetFifteen = 9;
var $author$project$Routers$UserRouter$To24tclComnetFifteenSeq = 10;
var $author$project$Routers$UserRouter$To24tcmAirChangeProduct = 77;
var $author$project$Routers$UserRouter$To24tcmAirCsv = 76;
var $author$project$Routers$UserRouter$To24tcmAirFifteen = 73;
var $author$project$Routers$UserRouter$To24tcmAirHour = 74;
var $author$project$Routers$UserRouter$To24tcmAirHourSeq = 75;
var $author$project$Routers$UserRouter$To24tcmComnetChangeProduct = 8;
var $author$project$Routers$UserRouter$To24tcmComnetCsv = 7;
var $author$project$Routers$UserRouter$To24tcmComnetDay = 4;
var $author$project$Routers$UserRouter$To24tcmComnetFifteen = 2;
var $author$project$Routers$UserRouter$To24tcmComnetFifteenSeq = 5;
var $author$project$Routers$UserRouter$To24tcmComnetHour = 3;
var $author$project$Routers$UserRouter$To24tcmComnetHourSeq = 6;
var $author$project$Routers$UserRouter$To24tcmFridgeChangeProduct = 21;
var $author$project$Routers$UserRouter$To24tcmFridgeCsv = 19;
var $author$project$Routers$UserRouter$To24tcmFridgeDay = 20;
var $author$project$Routers$UserRouter$To24tcmFridgeFifteen = 14;
var $author$project$Routers$UserRouter$To24tcmFridgeFifteenSeq = 17;
var $author$project$Routers$UserRouter$To24tcmFridgeHour = 15;
var $author$project$Routers$UserRouter$To24tcmFridgeHourMix = 16;
var $author$project$Routers$UserRouter$To24tcmFridgeHourSeq = 18;
var $author$project$Routers$UserRouter$To24tcmKitchenChangeProduct = 28;
var $author$project$Routers$UserRouter$To24tcmKitchenCsv = 27;
var $author$project$Routers$UserRouter$To24tcmKitchenDay = 24;
var $author$project$Routers$UserRouter$To24tcmKitchenFifteen = 22;
var $author$project$Routers$UserRouter$To24tcmKitchenFifteenSeq = 25;
var $author$project$Routers$UserRouter$To24tcmKitchenHour = 23;
var $author$project$Routers$UserRouter$To24tcmKitchenHourSeq = 26;
var $author$project$Routers$UserRouter$Top = 1;
var $author$project$Routers$UserRouter$TsBatTimeSeq = 118;
var $author$project$Routers$UserRouter$TsBatWide = 117;
var $author$project$Routers$UserRouter$TstComnetTimeSeq = 103;
var $author$project$Routers$UserRouter$TstComnetWide = 104;
var $author$project$Routers$UserRouter$Tv24ComnetChangeProduct = 66;
var $author$project$Routers$UserRouter$Tv24ComnetCsv = 65;
var $author$project$Routers$UserRouter$Tv24ComnetThirty = 64;
var $author$project$Routers$UserRouter$Yahoo = 115;
var $author$project$Routers$UserRouter$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, 1, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			2,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-comnet'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			3,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			4,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-comnet'),
					$elm$url$Url$Parser$s('day')))),
			A2(
			$elm$url$Url$Parser$map,
			5,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-comnet'),
					$elm$url$Url$Parser$s('fifteen-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			6,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-comnet'),
					$elm$url$Url$Parser$s('hour-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			7,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-comnet'),
					$elm$url$Url$Parser$s('csv')))),
			A2(
			$elm$url$Url$Parser$map,
			8,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			9,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcl-comnet'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			10,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcl-comnet'),
					$elm$url$Url$Parser$s('fifteen-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			11,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcl-comnet'),
					$elm$url$Url$Parser$s('day')))),
			A2(
			$elm$url$Url$Parser$map,
			12,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcl-comnet'),
					$elm$url$Url$Parser$s('csv')))),
			A2(
			$elm$url$Url$Parser$map,
			13,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcl-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			14,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			15,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			16,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('hour-mix')))),
			A2(
			$elm$url$Url$Parser$map,
			17,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('fifteen-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			18,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('hour-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			19,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('csv')))),
			A2(
			$elm$url$Url$Parser$map,
			20,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('day')))),
			A2(
			$elm$url$Url$Parser$map,
			21,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-fridge'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			22,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-kitchen'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			25,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-kitchen'),
					$elm$url$Url$Parser$s('fifteen-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			26,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-kitchen'),
					$elm$url$Url$Parser$s('hour-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			23,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-kitchen'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			24,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-kitchen'),
					$elm$url$Url$Parser$s('day')))),
			A2(
			$elm$url$Url$Parser$map,
			27,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-kitchen'),
					$elm$url$Url$Parser$s('csv')))),
			A2(
			$elm$url$Url$Parser$map,
			28,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-kitchen'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			29,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('jvc-comnet'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			30,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('jvc-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			31,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('jvc-comnet'),
					$elm$url$Url$Parser$s('time-seq-fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			32,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('jvc-comnet'),
					$elm$url$Url$Parser$s('time-seq-hour')))),
			A2(
			$elm$url$Url$Parser$map,
			33,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('jvc-comnet'),
					$elm$url$Url$Parser$s('amazon')))),
			A2(
			$elm$url$Url$Parser$map,
			34,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('jvc-comnet'),
					$elm$url$Url$Parser$s('amazon-fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			35,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('jvc-comnet'),
					$elm$url$Url$Parser$s('price-drop')))),
			A2(
			$elm$url$Url$Parser$map,
			36,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hisense'),
					$elm$url$Url$Parser$s('day')))),
			A2(
			$elm$url$Url$Parser$map,
			37,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hisense'),
					$elm$url$Url$Parser$s('time-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			38,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hisense'),
					$elm$url$Url$Parser$s('tv-hour')))),
			A2(
			$elm$url$Url$Parser$map,
			39,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hisense'),
					$elm$url$Url$Parser$s('amazon-ranking')))),
			A2(
			$elm$url$Url$Parser$map,
			40,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hisense'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			41,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hisense'),
					$elm$url$Url$Parser$s('review')))),
			A2(
			$elm$url$Url$Parser$map,
			42,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hisense'),
					$elm$url$Url$Parser$s('excel')))),
			A2(
			$elm$url$Url$Parser$map,
			43,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tescom-comnet'),
					$elm$url$Url$Parser$s('15min')))),
			A2(
			$elm$url$Url$Parser$map,
			44,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tescom-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			45,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tescom-comnet'),
					$elm$url$Url$Parser$s('excel')))),
			A2(
			$elm$url$Url$Parser$map,
			46,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tescom-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			59,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			60,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('hour-yamada')))),
			A2(
			$elm$url$Url$Parser$map,
			47,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ca6-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			48,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ca6-comnet'),
					$elm$url$Url$Parser$s('hour2')))),
			A2(
			$elm$url$Url$Parser$map,
			49,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ca6-comnet'),
					$elm$url$Url$Parser$s('csv')))),
			A2(
			$elm$url$Url$Parser$map,
			50,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ca6-comnet'),
					$elm$url$Url$Parser$s('weekly-product')))),
			A2(
			$elm$url$Url$Parser$map,
			51,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ca6-comnet'),
					$elm$url$Url$Parser$s('weekly-product2')))),
			A2(
			$elm$url$Url$Parser$map,
			52,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ca6-comnet'),
					$elm$url$Url$Parser$s('items')))),
			A2(
			$elm$url$Url$Parser$map,
			53,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ca6-comnet'),
					$elm$url$Url$Parser$s('low')))),
			A2(
			$elm$url$Url$Parser$map,
			54,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			55,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('change-mail')))),
			A2(
			$elm$url$Url$Parser$map,
			56,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('change-mail-test')))),
			A2(
			$elm$url$Url$Parser$map,
			57,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('change-password')))),
			A2(
			$elm$url$Url$Parser$map,
			61,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('auto-reload')))),
			A2(
			$elm$url$Url$Parser$map,
			62,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('mail-setting')))),
			A2(
			$elm$url$Url$Parser$map,
			58,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('chronological-30min')))),
			A2(
			$elm$url$Url$Parser$map,
			63,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('mln-comnet'),
					$elm$url$Url$Parser$s('yahoo')))),
			A2(
			$elm$url$Url$Parser$map,
			64,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tv24-comnet'),
					$elm$url$Url$Parser$s('thirty')))),
			A2(
			$elm$url$Url$Parser$map,
			65,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tv24-comnet'),
					$elm$url$Url$Parser$s('csv')))),
			A2(
			$elm$url$Url$Parser$map,
			66,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tv24-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			67,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elec-comnet'),
					$elm$url$Url$Parser$s('15min')))),
			A2(
			$elm$url$Url$Parser$map,
			68,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elec-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			69,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elec-comnet'),
					$elm$url$Url$Parser$s('excel')))),
			A2(
			$elm$url$Url$Parser$map,
			70,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elec-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			71,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elec-comnet'),
					$elm$url$Url$Parser$s('time-seq-fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			72,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elec-comnet'),
					$elm$url$Url$Parser$s('time-seq-hour')))),
			A2(
			$elm$url$Url$Parser$map,
			73,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-air'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			74,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-air'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			75,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-air'),
					$elm$url$Url$Parser$s('hour-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			76,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-air'),
					$elm$url$Url$Parser$s('csv')))),
			A2(
			$elm$url$Url$Parser$map,
			77,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('to24tcm-air'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			78,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi3-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			79,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi3-comnet'),
					$elm$url$Url$Parser$s('hour-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			80,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi3-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			81,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('delonghi'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			82,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('delonghi'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			83,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('delonghi'),
					$elm$url$Url$Parser$s('time-seq-hour')))),
			A2(
			$elm$url$Url$Parser$map,
			84,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('delonghi'),
					$elm$url$Url$Parser$s('time-seq-2-hour')))),
			A2(
			$elm$url$Url$Parser$map,
			85,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('delonghi'),
					$elm$url$Url$Parser$s('nine-am')))),
			A2(
			$elm$url$Url$Parser$map,
			86,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('delonghi'),
					$elm$url$Url$Parser$s('weekly')))),
			A2(
			$elm$url$Url$Parser$map,
			87,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('kinujo-comnet'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			88,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('kinujo-comnet'),
					$elm$url$Url$Parser$s('excel')))),
			A2(
			$elm$url$Url$Parser$map,
			89,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('kinujo-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			90,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi24-comnet'),
					$elm$url$Url$Parser$s('day')))),
			A2(
			$elm$url$Url$Parser$map,
			91,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi24-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			92,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi24-comnet'),
					$elm$url$Url$Parser$s('six-hour')))),
			A2(
			$elm$url$Url$Parser$map,
			93,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi24-comnet'),
					$elm$url$Url$Parser$s('time-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			94,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi24-comnet'),
					$elm$url$Url$Parser$s('hour-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			95,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi24-comnet'),
					$elm$url$Url$Parser$s('weekly-product-15min')))),
			A2(
			$elm$url$Url$Parser$map,
			96,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hi24-comnet'),
					$elm$url$Url$Parser$s('ten-am')))),
			A2(
			$elm$url$Url$Parser$map,
			97,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sha-comnet'),
					$elm$url$Url$Parser$s('wide')))),
			A2(
			$elm$url$Url$Parser$map,
			98,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sha-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			99,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sha-comnet'),
					$elm$url$Url$Parser$s('hour-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			102,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sha-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			101,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sha-comnet'),
					$elm$url$Url$Parser$s('day')))),
			A2(
			$elm$url$Url$Parser$map,
			100,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sha-comnet'),
					$elm$url$Url$Parser$s('weekly-product')))),
			A2(
			$elm$url$Url$Parser$map,
			104,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tst-comnet'),
					$elm$url$Url$Parser$s('wide')))),
			A2(
			$elm$url$Url$Parser$map,
			103,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tst-comnet'),
					$elm$url$Url$Parser$s('time-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			105,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('dbi6-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			106,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('dbi6-comnet'),
					$elm$url$Url$Parser$s('time-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			107,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('denon6-comnet'),
					$elm$url$Url$Parser$s('wide')))),
			A2(
			$elm$url$Url$Parser$map,
			108,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('denon6-comnet'),
					$elm$url$Url$Parser$s('time-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			109,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('braun-comnet'),
					$elm$url$Url$Parser$s('hour')))),
			A2(
			$elm$url$Url$Parser$map,
			110,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('braun-comnet'),
					$elm$url$Url$Parser$s('wide')))),
			A2(
			$elm$url$Url$Parser$map,
			111,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('edit-products-permalinks')))),
			A2(
			$elm$url$Url$Parser$map,
			112,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('change-user-product')))),
			A2(
			$elm$url$Url$Parser$map,
			113,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('add-product-config')))),
			A2(
			$elm$url$Url$Parser$map,
			114,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('edit-products')))),
			A2(
			$elm$url$Url$Parser$map,
			115,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('yahoo')))),
			A2(
			$elm$url$Url$Parser$map,
			116,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('products'),
					$elm$url$Url$Parser$s('edit-soldout-products')))),
			A2(
			$elm$url$Url$Parser$map,
			117,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ts-bat'),
					$elm$url$Url$Parser$s('wide')))),
			A2(
			$elm$url$Url$Parser$map,
			118,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ts-bat'),
					$elm$url$Url$Parser$s('time-seq')))),
			A2(
			$elm$url$Url$Parser$map,
			119,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fuji-comnet'),
					$elm$url$Url$Parser$s('fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			120,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fuji-comnet'),
					$elm$url$Url$Parser$s('time-seq-fifteen')))),
			A2(
			$elm$url$Url$Parser$map,
			121,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fuji-comnet'),
					$elm$url$Url$Parser$s('week30')))),
			A2(
			$elm$url$Url$Parser$map,
			122,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fuji-comnet'),
					$elm$url$Url$Parser$s('change-product')))),
			A2(
			$elm$url$Url$Parser$map,
			123,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fuji-comnet'),
					$elm$url$Url$Parser$s('latest-store')))),
			A2(
			$elm$url$Url$Parser$map,
			124,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fuji-comnet'),
					$elm$url$Url$Parser$s('mail-address')))),
			A2(
			$elm$url$Url$Parser$map,
			125,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fuji-comnet'),
					$elm$url$Url$Parser$s('weekly-product-15min')))),
			A2(
			$elm$url$Url$Parser$map,
			126,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fujiinstax-comnet'),
					$elm$url$Url$Parser$s('thirty')))),
			A2(
			$elm$url$Url$Parser$map,
			127,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fujiinstax-comnet'),
					$elm$url$Url$Parser$s('time-seq-thirty')))),
			A2(
			$elm$url$Url$Parser$map,
			128,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fujiinstax-comnet'),
					$elm$url$Url$Parser$s('week30')))),
			A2(
			$elm$url$Url$Parser$map,
			129,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('fujiinstax-comnet'),
					$elm$url$Url$Parser$s('latest-store')))),
			A2(
			$elm$url$Url$Parser$map,
			130,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('test'),
					$elm$url$Url$Parser$s('fifteen'))))
		]));
var $author$project$Routers$UserRouter$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2($elm$url$Url$Parser$parse, $author$project$Routers$UserRouter$parser, url));
};
var $author$project$Pages$Users$BraunComnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$BraunComnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $Herteby$url_builder_plus$UrlBuilderPlus$None = {$: 1};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $Herteby$url_builder_plus$UrlBuilderPlus$toQueryPair = function (param) {
	if (!param.$) {
		var key = param.a;
		var value = param.b;
		return key + ('=' + value);
	} else {
		return '';
	}
};
var $Herteby$url_builder_plus$UrlBuilderPlus$toQuery = function (parameters) {
	var _v0 = A2(
		$elm$core$List$filter,
		function (p) {
			return !_Utils_eq(p, $Herteby$url_builder_plus$UrlBuilderPlus$None);
		},
		parameters);
	if (!_v0.b) {
		return '';
	} else {
		var params = _v0;
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $Herteby$url_builder_plus$UrlBuilderPlus$toQueryPair, params));
	}
};
var $Herteby$url_builder_plus$UrlBuilderPlus$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $Herteby$url_builder_plus$UrlBuilderPlus$toQuery(parameters));
	});
var $author$project$Endpoints$User$common = 'common';
var $author$project$Endpoints$User$default = 'default';
var $author$project$Endpoints$User$user = 'user';
var $author$project$Endpoints$User$defaultEndpoints = {
	aV: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'change-product', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'change-product', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'change-product', 'update-all']),
			_List_Nil)
	},
	bA: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$default, 'csv'])),
	fp: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'news'])),
	g: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$default, 'prices'])),
	x: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$default, 'init']))
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.it, posixMinutes) < 0) {
					return posixMinutes + era.b;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		fd: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		mQ: month,
		ob: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fd;
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).mQ;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ob;
	});
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			fd: A2($elm$time$Time$toDay, zone, posix),
			mj: A2($elm$time$Time$toHour, zone, posix),
			mM: A2($elm$time$Time$toMillis, zone, posix),
			mO: A2($elm$time$Time$toMinute, zone, posix),
			mQ: A2($elm$time$Time$toMonth, zone, posix),
			ny: A2($elm$time$Time$toSecond, zone, posix),
			ob: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $author$project$Utils$Helpers$getDate = A3($elm$core$Task$map2, $justinmimbs$time_extra$Time$Extra$posixToParts, $elm$time$Time$here, $elm$time$Time$now);
var $author$project$Pages$Users$BraunComnet$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Utils$Types$BigCategory = F2(
	function (bigCategoryId, bigCategoryName) {
		return {e_: bigCategoryId, lu: bigCategoryName};
	});
var $author$project$Utils$Decoders$bigCategoriesDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Utils$Types$BigCategory,
		A2($elm$json$Json$Decode$field, 'big_category_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'big_category_name', $elm$json$Json$Decode$string)));
var $author$project$Utils$Types$SmallCategory = F3(
	function (smallCategoryId, smallCategoryName, bigCategoryId) {
		return {e_: bigCategoryId, ir: smallCategoryId, nF: smallCategoryName};
	});
var $author$project$Utils$Decoders$smallCategoriesDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Utils$Types$SmallCategory,
		A2($elm$json$Json$Decode$field, 'small_category_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'small_category_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'big_category_id', $elm$json$Json$Decode$int)));
var $author$project$Pages$Users$BraunComnet$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$BraunComnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Pages$Users$BraunComnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$BraunComnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$BraunComnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$BraunComnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$BraunComnet$Wide$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Utils$Types$UsersProduct = function (productId) {
	return function (productName) {
		return function (basePrice) {
			return function (basePriceIncludeTax) {
				return function (basePoint) {
					return function (basePriceWithoutPoint) {
						return function (makerId) {
							return function (smallCategoryId) {
								return function (bigCategoryId) {
									return function (yodobashiFlag) {
										return function (triggerFlag) {
											return function (releaseDate) {
												return function (mailEnabled) {
													return function (productOrder) {
														return function (getInterval) {
															return {ls: basePoint, lt: basePrice, eY: basePriceIncludeTax, cb: basePriceWithoutPoint, e_: bigCategoryId, js: getInterval, bE: mailEnabled, jW: makerId, kl: productId, nk: productName, nl: productOrder, ee: releaseDate, ir: smallCategoryId, n$: triggerFlag, oc: yodobashiFlag};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {i7: col, lJ: contextStack, ki: problem, kw: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.kw, s.i7, x, s.f));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.a),
			s.b) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{i7: col, f: s0.f, h: s0.h, b: offset, kw: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.kw, s.i7, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{i7: 1, f: s.f, h: s.h, b: s.b + 1, kw: s.kw + 1, a: s.a}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{i7: s.i7 + 1, f: s.f, h: s.h, b: newOffset, kw: s.kw, a: s.a}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.b, s.kw, s.i7, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{i7: newCol, f: s.f, h: s.h, b: newOffset, kw: newRow, a: s.a});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {i7: col, ki: problem, kw: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.kw, p.i7, p.ki);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{i7: 1, f: _List_Nil, h: 1, b: 0, kw: 1, a: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$Decoders$productDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		$elm_community$maybe_extra$Maybe$Extra$join,
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'get_interval',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$map,
			$elm_community$maybe_extra$Maybe$Extra$join,
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'product_order',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)))),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(false),
				$elm$json$Json$Decode$maybe(
					A2($elm$json$Json$Decode$field, 'mail_enabled', $elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$map,
					$elm_community$maybe_extra$Maybe$Extra$join,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$field,
							'release_date',
							$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'trigger_flag', $elm$json$Json$Decode$bool),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'big_category_id', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'small_category_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'maker_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'base_price_without_point', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'base_price', $elm$json$Json$Decode$int),
													A2(
														$elm_community$json_extra$Json$Decode$Extra$andMap,
														A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
														A2(
															$elm_community$json_extra$Json$Decode$Extra$andMap,
															A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
															$elm$json$Json$Decode$succeed($author$project$Utils$Types$UsersProduct))))))))))))))));
var $author$project$Utils$Decoders$productsDecoder = $elm$json$Json$Decode$list($author$project$Utils$Decoders$productDecoder);
var $author$project$Pages$Users$BraunComnet$Wide$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$BraunComnet$Wide$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Endpoints$User$timeSeq = 'time-seq';
var $author$project$Endpoints$User$timeSeqEndpoints = {
	bA: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$timeSeq, 'csv'])),
	g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$timeSeq, 'prices'])),
	x: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$timeSeq, 'init']))
};
var $author$project$Pages$Users$BraunComnet$Wide$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$BraunComnet$Wide$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$BraunComnet$Wide$initResponseDecoder,
						$author$project$Pages$Users$BraunComnet$Wide$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$All = 0;
var $author$project$Pages$Users$Ca6Comnet$Csv$AllStoreGroups = 0;
var $author$project$Pages$Users$Ca6Comnet$Csv$GotDate = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$User$ca6Comnet = 'ca6-comnet';
var $author$project$Endpoints$User$ca6ComnetEndpoints = {
	ja: {
		lX: function (path) {
			return $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
				_List_fromArray(
					[$author$project$Endpoints$User$ca6Comnet, path]));
		},
		l9: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'csv', 'gen-csv-all-stores'])),
		ma: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'csv', 'gen-csv-canon'])),
		mb: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'csv', 'gen-csv-store-groups'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'csv', 'init']))
	},
	mj: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'hour', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'hour', 'init']))
	},
	mk: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'hour2', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'hour2', 'init']))
	},
	mx: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'items', 'init']))
	},
	mE: {
		mB: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'low', 'list']))
	},
	iH: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'weekly-product', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'weekly-product', 'init']))
	},
	n6: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'weekly-product2', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$ca6Comnet, 'weekly-product2', 'init']))
	}
};
var $author$project$Pages$Users$Ca6Comnet$Csv$InitResponse = F6(
	function (bigCategories, smallCategories, makers, products, productsWeek30, canonGroupStores) {
		return {iW: bigCategories, i2: canonGroupStores, cE: makers, kn: products, cS: productsWeek30, kL: smallCategories};
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$RawCanonGroupStore = F5(
	function (canonGroupId, canonGroupName, storeId, storeName, storeDisplayName) {
		return {hj: canonGroupId, i1: canonGroupName, kQ: storeDisplayName, iw: storeId, kS: storeName};
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$canonGroupStoresDecoder = $elm$json$Json$Decode$list(
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Pages$Users$Ca6Comnet$Csv$RawCanonGroupStore,
		A2($elm$json$Json$Decode$field, 'canon_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'canon_group_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'display_name', $elm$json$Json$Decode$string)));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Pages$Users$Ca6Comnet$Csv$initResponseDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Pages$Users$Ca6Comnet$Csv$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'productsWeek30', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'canon_group_stores', $author$project$Pages$Users$Ca6Comnet$Csv$canonGroupStoresDecoder));
var $author$project$Pages$Users$Ca6Comnet$Csv$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				dr: {e2: $elm$core$Dict$empty, cc: $elm$core$Dict$empty, gL: $elm$core$Dict$empty},
				ch: {co: _List_Nil, h0: 0},
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				ac: interval,
				cv: false,
				dP: false,
				cE: _List_Nil,
				d_: '',
				d1: '',
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				kn: _List_Nil,
				cS: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				eh: $elm$core$Maybe$Just(-1),
				bT: 0,
				ei: 0,
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				C: session,
				kL: _List_Nil,
				iB: maybeTitle,
				aF: {aU: $elm$core$Set$empty, aN: $elm$core$Set$empty}
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Ca6Comnet$Csv$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$ca6ComnetEndpoints.ja.x(_List_Nil),
						session,
						$author$project$Pages$Users$Ca6Comnet$Csv$initResponseDecoder,
						$author$project$Pages$Users$Ca6Comnet$Csv$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, canonGroupStores) {
		return {iW: bigCategories, i2: canonGroupStores, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$RawCanonGroupStore = F5(
	function (canonGroupId, canonGroupName, storeId, storeName, storeDisplayName) {
		return {hj: canonGroupId, i1: canonGroupName, kQ: storeDisplayName, iw: storeId, kS: storeName};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$canonGroupStoresDecoder = $elm$json$Json$Decode$list(
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Pages$Users$Ca6Comnet$Hour$RawCanonGroupStore,
		A2($elm$json$Json$Decode$field, 'canon_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'canon_group_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'display_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Users$Ca6Comnet$Hour$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Ca6Comnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'canon_group_stores', $author$project$Pages$Users$Ca6Comnet$Hour$canonGroupStoresDecoder));
var $Herteby$url_builder_plus$UrlBuilderPlus$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Herteby$url_builder_plus$UrlBuilderPlus$string = F2(
	function (key, value) {
		return A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				dr: {e2: $elm$core$Dict$empty, cc: $elm$core$Dict$empty, gL: $elm$core$Dict$empty},
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				jx: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayPrice',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				aF: {aU: $elm$core$Set$empty, aN: $elm$core$Set$empty}
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Ca6Comnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$ca6ComnetEndpoints.mj.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Ca6Comnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$Ca6Comnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Ca6Comnet$Hour2$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Ca6Comnet$Hour2$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayPrice',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Ca6Comnet$Hour2$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$ca6ComnetEndpoints.mk.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Ca6Comnet$Hour2$initResponseDecoder,
						$author$project$Pages$Users$Ca6Comnet$Hour2$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Ca6Comnet$Items$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Items$InitResponse = function (items) {
	return {mx: items};
};
var $author$project$Pages$Users$Ca6Comnet$Items$Item = F5(
	function (productName, productId, bigCategory, smallCategory, price) {
		return {hf: bigCategory, kg: price, kl: productId, nk: productName, iq: smallCategory};
	});
var $author$project$Pages$Users$Ca6Comnet$Items$itemDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Ca6Comnet$Items$Item,
	A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'big_category_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'small_category_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'tax_excluded_price', $elm$json$Json$Decode$int));
var $author$project$Pages$Users$Ca6Comnet$Items$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Ca6Comnet$Items$InitResponse,
	A2(
		$elm$json$Json$Decode$field,
		'items',
		$elm$json$Json$Decode$list($author$project$Pages$Users$Ca6Comnet$Items$itemDecoder)));
var $author$project$Pages$Users$Ca6Comnet$Items$init = F2(
	function (maybeTitle, session) {
		return _Utils_Tuple2(
			{H: $elm$core$Maybe$Nothing, cv: true, mx: _List_Nil, C: session, iB: maybeTitle},
			A4(
				$author$project$Api$get,
				$author$project$Endpoints$User$ca6ComnetEndpoints.mx.x(_List_Nil),
				session,
				$author$project$Pages$Users$Ca6Comnet$Items$initResponseDecoder,
				$author$project$Pages$Users$Ca6Comnet$Items$InitRequestSent));
	});
var $author$project$Pages$Users$Ca6Comnet$Low$GotDate = function (a) {
	return {$: 1, a: a};
};
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Pages$Users$Ca6Comnet$Low$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{
				H: $elm$core$Maybe$Nothing,
				dA: true,
				dB: true,
				fx: false,
				ac: interval,
				cv: true,
				dP: false,
				ed: $elm$core$String$fromFloat(2 / 3),
				gv: _List_Nil,
				bS: '',
				bi: '',
				C: session,
				ek: false,
				iB: maybeTitle
			},
			A2($elm$core$Task$perform, $author$project$Pages$Users$Ca6Comnet$Low$GotDate, $author$project$Utils$Helpers$getDate));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$InitResponse = F4(
	function (bigCategories, smallCategories, makers, canonGroupStores) {
		return {iW: bigCategories, i2: canonGroupStores, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$RawCanonGroupStore = F5(
	function (canonGroupId, canonGroupName, storeId, storeName, storeDisplayName) {
		return {hj: canonGroupId, i1: canonGroupName, kQ: storeDisplayName, iw: storeId, kS: storeName};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$canonGroupStoresDecoder = $elm$json$Json$Decode$list(
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$RawCanonGroupStore,
		A2($elm$json$Json$Decode$field, 'canon_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'canon_group_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'display_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'canon_group_stores', $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$canonGroupStoresDecoder));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				dr: {e2: $elm$core$Dict$empty, cc: $elm$core$Dict$empty, gL: $elm$core$Dict$empty},
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayPrice',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				aF: {aU: $elm$core$Set$empty, aN: $elm$core$Set$empty}
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$ca6ComnetEndpoints.iH.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$initResponseDecoder,
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayPrice',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$ca6ComnetEndpoints.n6.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$initResponseDecoder,
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Common$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$Common$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $elm$json$Json$Decode$map8 = _Json_map8;
var $author$project$Pages$Users$Common$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$Common$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(0)));
var $author$project$Pages$Users$Common$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Common$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$Common$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$Common$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$Common$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$Common$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Common$Default$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$Default$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Common$Default$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Common$Default$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Common$Default$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Common$Default$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Common$Default$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Common$Default$initResponseDecoder,
						$author$project$Pages$Users$Common$Default$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Common$MailAddress$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$initNewPermalinkGroup = {R: false, T: 0, as: '', aE: '', aP: true};
var $author$project$Pages$Users$Common$MailAddress$InitResponse = F2(
	function (permalinkGroups, stores) {
		return {i: permalinkGroups, aN: stores};
	});
var $author$project$Pages$Users$Common$MailAddress$PermalinkGroup = F5(
	function (permalinkGroupId, permalinkGroupName, supervisor, valid, isUpdated) {
		return {R: isUpdated, T: permalinkGroupId, as: permalinkGroupName, aE: supervisor, aP: valid};
	});
var $author$project$Pages$Users$Common$MailAddress$permalinkGroupsDecoder = $elm$json$Json$Decode$list(
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Pages$Users$Common$MailAddress$PermalinkGroup,
		A2($elm$json$Json$Decode$field, 'mail_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'supervisor',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(''),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$field,
			'valid',
			A2(
				$elm$json$Json$Decode$map,
				function (v) {
					return v === 1;
				},
				$elm$json$Json$Decode$int)),
		$elm$json$Json$Decode$succeed(false)));
var $author$project$Pages$Users$Common$MailAddress$Store = F2(
	function (storeId, storeName) {
		return {iw: storeId, kS: storeName};
	});
var $author$project$Pages$Users$Common$MailAddress$storeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$Common$MailAddress$Store,
	A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$Common$MailAddress$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$Common$MailAddress$InitResponse,
	A2($elm$json$Json$Decode$field, 'mail_address', $author$project$Pages$Users$Common$MailAddress$permalinkGroupsDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'stores',
		$elm$json$Json$Decode$list($author$project$Pages$Users$Common$MailAddress$storeDecoder)));
var $author$project$Endpoints$User$mailAddress = 'mail-address';
var $author$project$Endpoints$User$mailAddressEndpoints = {
	am: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'add']),
		_List_Nil),
	li: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'add-target']),
		_List_Nil),
	lw: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'bulk-update']),
		_List_Nil),
	ci: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'delete']),
		_List_Nil),
	lS: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'delete-target']),
		_List_Nil),
	x: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'init']),
		_List_Nil),
	mD: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'list-targets']),
		_List_Nil),
	_: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$mailAddress, 'update']),
		_List_Nil)
};
var $author$project$Pages$Users$Common$MailAddress$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, a0: $elm$core$Set$empty, dO: true, k: false, ae: $elm$core$Dict$empty, ba: $author$project$Pages$Users$Common$MailAddress$initNewPermalinkGroup, cJ: $elm$core$Dict$empty, i: _List_Nil, C: session, ej: false, aN: _List_Nil},
		A4($author$project$Api$get, $author$project$Endpoints$User$mailAddressEndpoints.x, session, $author$project$Pages$Users$Common$MailAddress$initResponseDecoder, $author$project$Pages$Users$Common$MailAddress$InitRequestSent));
};
var $author$project$Pages$Users$Common$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Common$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Common$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Common$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				dI: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Common$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Common$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$Common$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Common$WeeklyProduct$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Common$WeeklyProduct$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Common$WeeklyProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Common$WeeklyProduct$init = F6(
	function (initEndpoint, pricesEndpoint, interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				dn: false,
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				fk: true,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				jE: initEndpoint,
				ac: interval,
				cv: true,
				dP: false,
				dV: $elm$core$Maybe$Nothing,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				gf: pricesEndpoint,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Common$WeeklyProduct$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						initEndpoint(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Common$WeeklyProduct$initResponseDecoder,
						$author$project$Pages$Users$Common$WeeklyProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Dbi6Comnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Dbi6Comnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Dbi6Comnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Dbi6Comnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$Dbi6Comnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Dbi6Comnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Dbi6Comnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$Dbi6Comnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$Dbi6Comnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$User$delonghi = 'Delonghi';
var $author$project$Endpoints$User$delonghiEndpoints = {
	aV: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'change-product', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'change-product', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'change-product', 'update-all']),
			_List_Nil)
	},
	mU: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'nineAM', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'nineAM', 'init']))
	},
	iA: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'time-seq', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'time-seq', 'init']))
	},
	nX: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'time-seq2', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'time-seq2', 'init']))
	},
	lf: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'weekly-product-fifteen', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$delonghi, 'weekly-product-fifteen', 'init']))
	}
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$InitResponse = F2(
	function (products, weeklyProducts) {
		return {kn: products, aQ: weeklyProducts};
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$Delonghi$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(0)));
var $author$project$Pages$Users$Delonghi$ChangeProduct$weeklyProductsDecoder = $elm$json$Json$Decode$list($elm$json$Json$Decode$string);
var $author$project$Pages$Users$Delonghi$ChangeProduct$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$Delonghi$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$Delonghi$ChangeProduct$productsDecoder),
	A2($elm$json$Json$Decode$field, 'weeklyProducts', $author$project$Pages$Users$Delonghi$ChangeProduct$weeklyProductsDecoder));
var $author$project$Pages$Users$Delonghi$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, cy: _List_Nil, kn: _List_Nil, C: session, aQ: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$delonghiEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$Delonghi$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$Delonghi$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Delonghi$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Delonghi$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Delonghi$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Delonghi$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty,
				aa: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Delonghi$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Delonghi$Hour$initResponseDecoder,
						$author$project$Pages$Users$Delonghi$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Delonghi$NineAM$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, userStores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, b$: userStores};
	});
var $author$project$Utils$Types$UserStore = F9(
	function (storeId, storeName, storeGroupId, displayName, storeOrder, storeGroupName, getInterval, getEnabled, isUpdated) {
		return {fh: displayName, jr: getEnabled, js: getInterval, R: isUpdated, iv: storeGroupId, kR: storeGroupName, iw: storeId, kS: storeName, kT: storeOrder};
	});
var $author$project$Pages$Users$Delonghi$NineAM$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Utils$Types$UserStore)))))))))));
var $author$project$Pages$Users$Delonghi$NineAM$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Delonghi$NineAM$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'users_stores', $author$project$Pages$Users$Delonghi$NineAM$userStoresDecoder));
var $author$project$Pages$Users$Delonghi$NineAM$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '09:00:00',
				im: '14:00:00',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Delonghi$NineAM$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$delonghiEndpoints.mU.x(_List_Nil),
						session,
						$author$project$Pages$Users$Delonghi$NineAM$initResponseDecoder,
						$author$project$Pages$Users$Delonghi$NineAM$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$InitResponse = F3(
	function (bigCategories, smallCategories, products) {
		return {iW: bigCategories, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Delonghi$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Delonghi$TimeSeq$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				dQ: false,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				ih: $elm$core$Maybe$Nothing,
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				en: '',
				eo: '',
				ep: $elm$core$Maybe$Nothing,
				eq: '',
				er: '',
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Delonghi$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$delonghiEndpoints.iA.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Delonghi$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$Delonghi$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, userStores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, b$: userStores};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Utils$Types$UserStore)))))))))));
var $author$project$Pages$Users$Delonghi$TimeSeq2$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Delonghi$TimeSeq2$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'users_stores', $author$project$Pages$Users$Delonghi$TimeSeq2$userStoresDecoder));
var $author$project$Pages$Users$Delonghi$TimeSeq2$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				io: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Delonghi$TimeSeq2$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$delonghiEndpoints.nX.x(_List_Nil),
						session,
						$author$project$Pages$Users$Delonghi$TimeSeq2$initResponseDecoder,
						$author$project$Pages$Users$Delonghi$TimeSeq2$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Delonghi$Weekly$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, userStores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, b$: userStores};
	});
var $author$project$Pages$Users$Delonghi$Weekly$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Utils$Types$UserStore)))))))))));
var $author$project$Pages$Users$Delonghi$Weekly$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Delonghi$Weekly$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'users_stores', $author$project$Pages$Users$Delonghi$Weekly$userStoresDecoder));
var $author$project$Pages$Users$Delonghi$Weekly$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				ck: '',
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				io: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Delonghi$Weekly$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$delonghiEndpoints.lf.x(_List_Nil),
						session,
						$author$project$Pages$Users$Delonghi$Weekly$initResponseDecoder,
						$author$project$Pages$Users$Delonghi$Weekly$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Denon6Comnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Denon6Comnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Denon6Comnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$Denon6Comnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Denon6Comnet$Wide$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Denon6Comnet$Wide$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Denon6Comnet$Wide$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$Denon6Comnet$Wide$initResponseDecoder,
						$author$project$Pages$Users$Denon6Comnet$Wide$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$ElecComnet$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(0)));
var $author$project$Pages$Users$ElecComnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$ElecComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$ElecComnet$ChangeProduct$productsDecoder));
var $author$project$Endpoints$User$tv24Comnet = 'to24tcm-comnet';
var $author$project$Endpoints$User$tv24ComnetEndpoints = {
	aV: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$tv24Comnet, 'change-product', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$tv24Comnet, 'change-product', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$tv24Comnet, 'change-product', 'update-all']),
			_List_Nil)
	}
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$tv24ComnetEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$ElecComnet$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$ElecComnet$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ElecComnet$Excel$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Endpoints$User$elecComnet = 'elec-comnet';
var $author$project$Endpoints$User$elecComnetEndpoints = {
	fn: {
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'time-seq', 'init'])),
		em: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$elecComnet, 'excel', 'submit']))
	},
	iA: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$elecComnet, 'time-seq', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$elecComnet, 'time-seq', 'init']))
	}
};
var $author$project$Pages$Users$ElecComnet$Excel$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$ElecComnet$Excel$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$ElecComnet$Excel$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ElecComnet$Excel$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$ElecComnet$Excel$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$elecComnetEndpoints.fn.x(_List_Nil),
						session,
						$author$project$Pages$Users$ElecComnet$Excel$initResponseDecoder,
						$author$project$Pages$Users$ElecComnet$Excel$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ElecComnet$Hour$init = $author$project$Pages$Users$Common$Default$init;
var $author$project$Pages$Users$ElecComnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$InitResponse = F3(
	function (bigCategories, smallCategories, products) {
		return {iW: bigCategories, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$ElecComnet$TimeSeq$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ElecComnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ElecComnet$TimeSeq$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				dQ: false,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				ih: $elm$core$Maybe$Nothing,
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				en: '',
				eo: '',
				ep: $elm$core$Maybe$Nothing,
				eq: '',
				er: '',
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$ElecComnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$elecComnetEndpoints.iA.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$ElecComnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$ElecComnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$FujiComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$User$fujiComnet = 'fuji-comnet';
var $author$project$Endpoints$User$fujiComnetEndpoints = {
	aV: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'change-product', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'change-product', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'change-product', 'update-all']),
			_List_Nil)
	},
	l7: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'fifteen', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'fifteen', 'init']))
	},
	jR: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'latest-store', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'latest-store', 'init']))
	},
	lb: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'week30', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiComnet, 'week30', 'update']),
			_List_Nil)
	}
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, week30ProductOrder, yodobashiFlag, getInterval) {
		return {ls: basePoint, lt: basePrice, js: getInterval, kl: productId, nk: productName, nl: productOrder, bn: week30ProductOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$FujiComnet$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$FujiComnet$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2(
			$elm$json$Json$Decode$field,
			'week30_product_order',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)))));
var $author$project$Pages$Users$FujiComnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$FujiComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$FujiComnet$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$FujiComnet$ChangeProduct$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
		A4(
			$author$project$Api$get,
			$author$project$Endpoints$User$fujiComnetEndpoints.aV.x(_List_Nil),
			session,
			$author$project$Pages$Users$FujiComnet$ChangeProduct$initResponseDecoder,
			$author$project$Pages$Users$FujiComnet$ChangeProduct$InitRequestSent));
};
var $author$project$Pages$Users$FujiComnet$Fifteen$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$FujiComnet$Fifteen$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$FujiComnet$Fifteen$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$FujiComnet$Fifteen$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$fujiComnetEndpoints.l7.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$FujiComnet$Fifteen$initResponseDecoder,
						$author$project$Pages$Users$FujiComnet$Fifteen$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$FujiComnet$LatestStore$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$InitResponse = F2(
	function (stores, smallCategories) {
		return {kL: smallCategories, aN: stores};
	});
var $author$project$Pages$Users$FujiComnet$LatestStore$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$FujiComnet$LatestStore$InitResponse,
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder));
var $author$project$Pages$Users$FujiComnet$LatestStore$init = F2(
	function (maybeTitle, session) {
		return _Utils_Tuple2(
			{
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				cv: true,
				dP: false,
				cQ: _List_Nil,
				bS: '',
				gD: $elm$core$Maybe$Just(-1),
				aB: $elm$core$Maybe$Nothing,
				bi: '',
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$FujiComnet$LatestStore$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$fujiComnetEndpoints.jR.x(_List_Nil),
						session,
						$author$project$Pages$Users$FujiComnet$LatestStore$initResponseDecoder,
						$author$project$Pages$Users$FujiComnet$LatestStore$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$FujiComnet$Week30$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiComnet$Week30$InitResponse = F2(
	function (products, week30Products) {
		return {kn: products, lc: week30Products};
	});
var $author$project$Pages$Users$FujiComnet$Week30$Product = F2(
	function (productId, productName) {
		return {kl: productId, nk: productName};
	});
var $author$project$Pages$Users$FujiComnet$Week30$productDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$FujiComnet$Week30$Product,
	A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$FujiComnet$Week30$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$FujiComnet$Week30$InitResponse,
	A2(
		$elm$json$Json$Decode$field,
		'products',
		$elm$json$Json$Decode$list($author$project$Pages$Users$FujiComnet$Week30$productDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'week30Products',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Pages$Users$FujiComnet$Week30$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, dO: true, a7: false, kn: _List_Nil, ij: $elm$core$Set$empty, C: session, dc: $elm$core$Maybe$Nothing},
		A4(
			$author$project$Api$get,
			$author$project$Endpoints$User$fujiComnetEndpoints.lb.x(_List_Nil),
			session,
			$author$project$Pages$Users$FujiComnet$Week30$initResponseDecoder,
			$author$project$Pages$Users$FujiComnet$Week30$InitRequestSent));
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Endpoints$User$fujiinstaxComnet = 'fujiinstax-comnet';
var $author$project$Endpoints$User$fujiinstaxComnetEndpoints = {
	jR: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiinstaxComnet, 'latest-store', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiinstaxComnet, 'latest-store', 'init']))
	},
	nU: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiinstaxComnet, 'thirty', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiinstaxComnet, 'thirty', 'init']))
	},
	lb: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiinstaxComnet, 'week30', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$fujiinstaxComnet, 'week30', 'update']),
			_List_Nil)
	}
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$InitResponse = F2(
	function (stores, smallCategories) {
		return {kL: smallCategories, aN: stores};
	});
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$FujiinstaxComnet$LatestStore$InitResponse,
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder));
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$init = F2(
	function (maybeTitle, session) {
		return _Utils_Tuple2(
			{
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				cv: true,
				dP: false,
				cQ: _List_Nil,
				bS: '',
				gD: $elm$core$Maybe$Just(-1),
				aB: $elm$core$Maybe$Nothing,
				bi: '',
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$FujiinstaxComnet$LatestStore$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$fujiinstaxComnetEndpoints.jR.x(_List_Nil),
						session,
						$author$project$Pages$Users$FujiinstaxComnet$LatestStore$initResponseDecoder,
						$author$project$Pages$Users$FujiinstaxComnet$LatestStore$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$FujiinstaxComnet$Thirty$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$FujiinstaxComnet$Thirty$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$fujiinstaxComnetEndpoints.nU.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$FujiinstaxComnet$Thirty$initResponseDecoder,
						$author$project$Pages$Users$FujiinstaxComnet$Thirty$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$FujiinstaxComnet$Week30$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$InitResponse = F2(
	function (products, week30Products) {
		return {kn: products, lc: week30Products};
	});
var $author$project$Pages$Users$FujiinstaxComnet$Week30$Product = F2(
	function (productId, productName) {
		return {kl: productId, nk: productName};
	});
var $author$project$Pages$Users$FujiinstaxComnet$Week30$productDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$FujiinstaxComnet$Week30$Product,
	A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$FujiinstaxComnet$Week30$initResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$FujiinstaxComnet$Week30$InitResponse,
	A2(
		$elm$json$Json$Decode$field,
		'products',
		$elm$json$Json$Decode$list($author$project$Pages$Users$FujiinstaxComnet$Week30$productDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'week30Products',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Pages$Users$FujiinstaxComnet$Week30$init = function (session) {
	return _Utils_Tuple2(
		{H: $elm$core$Maybe$Nothing, dO: true, a7: false, kn: _List_Nil, ij: $elm$core$Set$empty, C: session, dc: $elm$core$Maybe$Nothing},
		A4(
			$author$project$Api$get,
			$author$project$Endpoints$User$fujiinstaxComnetEndpoints.lb.x(_List_Nil),
			session,
			$author$project$Pages$Users$FujiinstaxComnet$Week30$initResponseDecoder,
			$author$project$Pages$Users$FujiinstaxComnet$Week30$InitRequestSent));
};
var $author$project$Pages$Users$Hi24Comnet$Day$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Endpoints$User$hi24Comnet = 'hi24-comnet';
var $author$project$Endpoints$User$hi24ComnetEndpoints = {
	fd: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'day', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'day', 'init']))
	},
	mm: {
		bA: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'hour-seq', 'csv'])),
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'hour-seq', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'hour-seq', 'init']))
	},
	nE: {
		bA: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'six-hour', 'csv'])),
		fp: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'six-hour'])),
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'six-hour', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'six-hour', 'init']))
	},
	nS: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'tenAM', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'tenAM', 'init']))
	},
	lf: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'weekly-product-fifteen', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hi24Comnet, 'weekly-product-fifteen', 'init']))
	}
};
var $author$project$Pages$Users$Hi24Comnet$Day$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, userStores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, b$: userStores};
	});
var $author$project$Pages$Users$Hi24Comnet$Day$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Utils$Types$UserStore)))))))))));
var $author$project$Pages$Users$Hi24Comnet$Day$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Hi24Comnet$Day$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'users_stores', $author$project$Pages$Users$Hi24Comnet$Day$userStoresDecoder));
var $author$project$Pages$Users$Hi24Comnet$Day$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				S: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'makers-selector', 0),
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				io: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				b$: _List_Nil,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi24Comnet$Day$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$hi24ComnetEndpoints.fd.x(_List_Nil),
						session,
						$author$project$Pages$Users$Hi24Comnet$Day$initResponseDecoder,
						$author$project$Pages$Users$Hi24Comnet$Day$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Hi24Comnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				jx: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi24Comnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Hi24Comnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$Hi24Comnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Hi24Comnet$HourSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$HourSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				jx: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				S: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'makers-selector', 0),
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi24Comnet$HourSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$hi24ComnetEndpoints.mm.x(_List_Nil),
						session,
						$author$project$Pages$Users$Hi24Comnet$HourSeq$initResponseDecoder,
						$author$project$Pages$Users$Hi24Comnet$HourSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$SixHour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Hi24Comnet$SixHour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				S: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'makers-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi24Comnet$SixHour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$hi24ComnetEndpoints.nE.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Hi24Comnet$SixHour$initResponseDecoder,
						$author$project$Pages$Users$Hi24Comnet$SixHour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, userStores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, b$: userStores};
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Utils$Types$UserStore)))))))))));
var $author$project$Pages$Users$Hi24Comnet$TenAM$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Hi24Comnet$TenAM$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'users_stores', $author$project$Pages$Users$Hi24Comnet$TenAM$userStoresDecoder));
var $author$project$Pages$Users$Hi24Comnet$TenAM$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				jx: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				S: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'makers-selector', 0),
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '10:00:00',
				im: '23:59:59',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi24Comnet$TenAM$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$hi24ComnetEndpoints.nS.x(_List_Nil),
						session,
						$author$project$Pages$Users$Hi24Comnet$TenAM$initResponseDecoder,
						$author$project$Pages$Users$Hi24Comnet$TenAM$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Hi24Comnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				jx: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi24Comnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$Hi24Comnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$Hi24Comnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				jx: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$hi24ComnetEndpoints.lf.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$initResponseDecoder,
						$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi3Comnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Hi3Comnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi3Comnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Hi3Comnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$Hi3Comnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Hi3Comnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hi3Comnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$Hi3Comnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$Hi3Comnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hisense$Amazon$GotDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hisense$Amazon$init = function (session) {
	return _Utils_Tuple2(
		{fa: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, dO: false, cX: -1, bS: '', bi: '', C: session, eu: $elm$core$Maybe$Nothing},
		A2($elm$core$Task$perform, $author$project$Pages$Users$Hisense$Amazon$GotDate, $author$project$Utils$Helpers$getDate));
};
var $author$project$Pages$Users$Hisense$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Endpoints$User$hisense = 'hisense';
var $author$project$Endpoints$User$hisenseEndpoints = {
	aV: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hisense, 'change-product', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hisense, 'change-product', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hisense, 'change-product', 'update-all']),
			_List_Nil)
	},
	fn: {
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'time-seq', 'init'])),
		em: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hisense, 'excel', 'submit']))
	},
	hy: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hisense, 'amazon-ranking'])),
	ns: {
		mf: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$hisense, 'review', 'get-review-excel']))
	}
};
var $author$project$Pages$Users$Hisense$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$Hisense$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$Hisense$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(0)));
var $author$project$Pages$Users$Hisense$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Hisense$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$Hisense$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$Hisense$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$hisenseEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$Hisense$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$Hisense$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hisense$Day$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Common$Default$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$Common$Default$initResponseDecoder,
						$author$project$Pages$Users$Common$Default$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hisense$Excel$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Hisense$Excel$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Hisense$Excel$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hisense$Excel$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hisense$Excel$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$hisenseEndpoints.fn.x(_List_Nil),
						session,
						$author$project$Pages$Users$Hisense$Excel$initResponseDecoder,
						$author$project$Pages$Users$Hisense$Excel$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hisense$Review$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hisense$Review$init = function (session) {
	return _Utils_Tuple2(
		{bz: '', C: session, bY: ''},
		A2($elm$core$Task$perform, $author$project$Pages$Users$Hisense$Review$GotDate, $elm$time$Time$now));
};
var $author$project$Pages$Users$Hisense$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$InitResponse = F3(
	function (bigCategories, smallCategories, products) {
		return {iW: bigCategories, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$Hisense$TimeSeq$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hisense$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Endpoints$User$jvcComnet = 'jvc-comnet';
var $author$project$Endpoints$User$jvcComnetEndpoints = {
	lp: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$jvcComnet, 'amazon', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$jvcComnet, 'amazon', 'init']))
	},
	iA: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$jvcComnet, 'time-seq', 'prices'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$jvcComnet, 'time-seq', 'init']))
	}
};
var $author$project$Pages$Users$Hisense$TimeSeq$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				dQ: false,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				ih: $elm$core$Maybe$Nothing,
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				en: '',
				eo: '',
				ep: $elm$core$Maybe$Nothing,
				eq: '',
				er: '',
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Hisense$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$jvcComnetEndpoints.iA.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Hisense$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$Hisense$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Hisense$TvHour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Common$Default$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$Common$Default$initResponseDecoder,
						$author$project$Pages$Users$Common$Default$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$JvcComnet$Amazon$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$InitResponse = F3(
	function (bigCategories, smallCategories, products) {
		return {iW: bigCategories, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$JvcComnet$Amazon$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$JvcComnet$Amazon$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$JvcComnet$Amazon$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				ih: $elm$core$Maybe$Nothing,
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				ak: false,
				kL: _List_Nil,
				aN: _List_Nil,
				en: '',
				eo: '',
				ep: $elm$core$Maybe$Nothing,
				eq: '',
				er: '',
				iB: maybeTitle,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$JvcComnet$Amazon$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$jvcComnetEndpoints.lp.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$JvcComnet$Amazon$initResponseDecoder,
						$author$project$Pages$Users$JvcComnet$Amazon$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$JvcComnet$Default$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$JvcComnet$Default$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$JvcComnet$Default$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$JvcComnet$Default$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				eE: false,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$JvcComnet$Default$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$JvcComnet$Default$initResponseDecoder,
						$author$project$Pages$Users$JvcComnet$Default$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$InitResponse = function (success) {
	return {nP: success};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$JvcComnet$PriceDrop$InitResponse,
	A2($elm$json$Json$Decode$field, 'success', $elm$json$Json$Decode$bool));
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Endpoints$User$priceDrop = 'price-drop';
var $author$project$Endpoints$User$priceDropEndpoint = {
	hy: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$priceDrop, 'get'])),
	x: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$priceDrop, 'init']))
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{fa: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, hA: false, ac: interval, cv: true, dP: false, ea: _List_Nil, ay: '', az: '', ah: '', ai: '', C: session, aN: _List_Nil, iB: maybeTitle, dg: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$JvcComnet$PriceDrop$GotDate, $elm$time$Time$now),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$priceDropEndpoint.x(
							_List_fromArray(
								[
									A2($elm$url$Url$Builder$int, 'user_id', 15)
								])),
						session,
						$author$project$Pages$Users$JvcComnet$PriceDrop$initResponseDecoder,
						$author$project$Pages$Users$JvcComnet$PriceDrop$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$InitResponse = F3(
	function (bigCategories, smallCategories, products) {
		return {iW: bigCategories, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$JvcComnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$JvcComnet$TimeSeq$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				dQ: false,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				ih: $elm$core$Maybe$Nothing,
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				C: session,
				kL: _List_Nil,
				aN: _List_Nil,
				en: '',
				eo: '',
				ep: $elm$core$Maybe$Nothing,
				eq: '',
				er: '',
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$JvcComnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$jvcComnetEndpoints.iA.x(
							_List_fromArray(
								[
									A2(
									$Herteby$url_builder_plus$UrlBuilderPlus$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$JvcComnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$JvcComnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$Product = F9(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, triggerPointFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, bZ: triggerPointFlag, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(0),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_interval',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(0),
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'trigger_flag', $elm$json$Json$Decode$bool),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$KinujoComnet$ChangeProduct$Product)))))))))));
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$KinujoComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$KinujoComnet$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$tv24ComnetEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$KinujoComnet$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$KinujoComnet$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$KinujoComnet$Excel$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$KinujoComnet$Excel$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$KinujoComnet$Excel$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Endpoints$User$kinujoComnet = 'kinujo-comnet';
var $author$project$Endpoints$User$kinujoComnetEndpoints = {
	fn: {
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'time-seq', 'init'])),
		em: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$kinujoComnet, 'excel', 'submit']))
	}
};
var $author$project$Pages$Users$KinujoComnet$Excel$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$KinujoComnet$Excel$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$kinujoComnetEndpoints.fn.x(_List_Nil),
						session,
						$author$project$Pages$Users$KinujoComnet$Excel$initResponseDecoder,
						$author$project$Pages$Users$KinujoComnet$Excel$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$KinujoComnet$Fifteen$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$KinujoComnet$Fifteen$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$KinujoComnet$Fifteen$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$KinujoComnet$Fifteen$initResponseDecoder,
						$author$project$Pages$Users$KinujoComnet$Fifteen$InitRequestSent)
					])));
	});
var $author$project$Utils$Types$ReleaseDateDesc = 0;
var $author$project$Pages$Users$MlnComnet$AutoReload$Tick = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$MlnComnet$AutoReload$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{fN: $elm$core$Maybe$Nothing, bR: $krisajenkins$remotedata$RemoteData$NotAsked, c_: 'DisplayAll', kG: 0, C: session, L: $elm$core$Set$empty},
			A2($elm$core$Task$perform, $author$project$Pages$Users$MlnComnet$AutoReload$Tick, $elm$time$Time$now));
	});
var $author$project$Pages$Users$MlnComnet$ChangeMail$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$InitResponse = function (productsMails) {
	return {gg: productsMails};
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$ProductMail = F3(
	function (product, mails, mailsPerHour) {
		return {bF: mails, bG: mailsPerHour, bL: product};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMail$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$MlnComnet$ChangeMail$InitResponse,
	A2(
		$elm$json$Json$Decode$field,
		'products_mails',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Pages$Users$MlnComnet$ChangeMail$ProductMail,
				A2($elm$json$Json$Decode$field, 'userProduct', $author$project$Utils$Decoders$productDecoder),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$String$join(','),
					A2(
						$elm$json$Json$Decode$field,
						'mails',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$String$join(','),
					A2(
						$elm$json$Json$Decode$field,
						'mailsPerHour',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))))));
var $author$project$Endpoints$User$mlnComnet = 'mln-comnet';
var $author$project$Endpoints$User$mlnComnetEndpoints = {
	lj: {
		iM: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting', 'add-mails-products'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting', 'init'])),
		kq: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting', 'remove-mails-products'])),
		k6: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting', 'update-mails-products']))
	},
	lk: {
		iM: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting-test', 'add-mails-products']),
			_List_Nil),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting-test', 'init'])),
		kq: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting', 'remove-mails-products'])),
		nz: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting-test', 'select-user']),
			_List_Nil),
		k6: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'alert-setting', 'update-mails-products']))
	},
	lA: {
		ci: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-mail', 'delete']),
			_List_Nil),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-mail', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-mail', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-mail', 'update-all']),
			_List_Nil)
	},
	aV: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-product', 'init'])),
		nu: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-product', 'save-form-snapshot']),
			_List_Nil),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-product', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-product', 'update-all']),
			_List_Nil)
	},
	lC: {
		l0: function (filename) {
			return $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
				_List_fromArray(
					[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'chronological', 'export-excel', filename]));
		},
		l1: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'chronological', 'export-excel'])),
		l2: function (filename) {
			return $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
				_List_fromArray(
					[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'chronological', 'export-excel', filename, 'status']));
		},
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'chronological', 'init'])),
		em: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'chronological', 'submit']))
	},
	mG: {
		am: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'mail-setting', 'add']),
			_List_Nil),
		ci: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'mail-setting', 'delete']),
			_List_Nil),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'mail-setting', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'mail-setting', 'update']),
			_List_Nil)
	},
	nA: {
		lL: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'selector-snapshot', 'create'])),
		hy: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'selector-snapshot', 'get'])),
		ie: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'selector-snapshot', 'remove'])),
		nt: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'selector-snapshot', 'save']))
	},
	n1: {
		_: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'change-password']))
	},
	oa: {
		mc: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'yahoo', 'direct-urls'])),
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'yahoo', 'init'])),
		_: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$mlnComnet, 'yahoo', 'update']))
	}
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$init = function (session) {
	return _Utils_Tuple2(
		{fC: $krisajenkins$remotedata$RemoteData$NotAsked, bN: '', kG: 0, C: session},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Api$get,
					$author$project$Endpoints$User$mlnComnetEndpoints.lj.x(_List_Nil),
					session,
					$author$project$Pages$Users$MlnComnet$ChangeMail$initResponseDecoder,
					$author$project$Pages$Users$MlnComnet$ChangeMail$InitRequestSent)
				])));
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Types$ProductNameAsc = 1;
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$InitResponse = F3(
	function (products, productsMails, formSnapshot) {
		return {hx: formSnapshot, kn: products, gg: productsMails};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$Form = F4(
	function (bigCategoryId, smallCategoryId, showOnlyBasePriceEnabled, showOnlyMailEnabled) {
		return {e_: bigCategoryId, kJ: showOnlyBasePriceEnabled, aC: showOnlyMailEnabled, ir: smallCategoryId};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$formSnapshotDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$MlnComnet$ChangeMailTest$Form,
	$elm$json$Json$Decode$succeed(
		$elm$core$Maybe$Just(-1)),
	$elm$json$Json$Decode$succeed(
		$elm$core$Maybe$Just(-1)),
	A2($elm$json$Json$Decode$field, 'display_only_base_price_enabled', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'display_only_mail_enabled', $elm$json$Json$Decode$bool));
var $author$project$Utils$Types$UsersMailProduct = F6(
	function (productId, productName, releaseDate, mail_enabled_once, mail_enabled_four, productOrder) {
		return {dZ: mail_enabled_four, jV: mail_enabled_once, kl: productId, nk: productName, nl: productOrder, ee: releaseDate};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$productDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		$elm_community$maybe_extra$Maybe$Extra$join,
		$elm$json$Json$Decode$maybe(
			A2(
				$elm$json$Json$Decode$field,
				'product_order',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(false),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'mail_enabled_four',
					A2(
						$elm$json$Json$Decode$map,
						function (n) {
							return n === 1;
						},
						$elm$json$Json$Decode$int)))),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(false),
				$elm$json$Json$Decode$maybe(
					A2(
						$elm$json$Json$Decode$field,
						'mail_enabled_once',
						A2(
							$elm$json$Json$Decode$map,
							function (n) {
								return n === 1;
							},
							$elm$json$Json$Decode$int)))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$map,
					$elm_community$maybe_extra$Maybe$Extra$join,
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$field,
							'release_date',
							$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Utils$Types$UsersMailProduct)))))));
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$productsDecoder = $elm$json$Json$Decode$list($author$project$Pages$Users$MlnComnet$ChangeMailTest$productDecoder);
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$TUserMailAddresses = F2(
	function (mailId, mailAddress) {
		return {jU: mailAddress, mF: mailId};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$tUserMailAddressesDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$MlnComnet$ChangeMailTest$TUserMailAddresses,
	A2($elm$json$Json$Decode$field, 'mail_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'mail_address', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$MlnComnet$ChangeMailTest$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$MlnComnet$ChangeMailTest$productsDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'products_mails',
		$elm$json$Json$Decode$list($author$project$Pages$Users$MlnComnet$ChangeMailTest$tUserMailAddressesDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'change_product_form_snapshot',
		$elm$json$Json$Decode$nullable($author$project$Pages$Users$MlnComnet$ChangeMailTest$formSnapshotDecoder)));
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$init = function (session) {
	return _Utils_Tuple2(
		{iR: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, gg: _List_Nil, bN: '', aA: $elm$core$Maybe$Nothing, kG: 1, C: session, c4: false, aC: false},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Api$get,
					$author$project$Endpoints$User$mlnComnetEndpoints.lk.x(_List_Nil),
					session,
					$author$project$Pages$Users$MlnComnet$ChangeMailTest$initResponseDecoder,
					$author$project$Pages$Users$MlnComnet$ChangeMailTest$InitRequestSent)
				])));
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$init = function (session) {
	return _Utils_Tuple2(
		{dv: '', a9: '', ef: '', C: session, aO: $krisajenkins$remotedata$RemoteData$NotAsked},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$InitResponse = F4(
	function (products, bigCategories, smallCategories, formSnapshot) {
		return {iW: bigCategories, hx: formSnapshot, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$Form = F4(
	function (bigCategoryId, smallCategoryId, showOnlyBasePriceEnabled, showOnlyMailEnabled) {
		return {e_: bigCategoryId, kJ: showOnlyBasePriceEnabled, aC: showOnlyMailEnabled, ir: smallCategoryId};
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$formSnapshotDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$MlnComnet$ChangeProduct$Form,
	A2(
		$elm$json$Json$Decode$field,
		'big_category_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'small_category_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
	A2($elm$json$Json$Decode$field, 'display_only_base_price_enabled', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'display_only_mail_enabled', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$MlnComnet$ChangeProduct$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$MlnComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'change_product_form_snapshot',
		$elm$json$Json$Decode$nullable($author$project$Pages$Users$MlnComnet$ChangeProduct$formSnapshotDecoder)));
var $author$project$Pages$Users$MlnComnet$ChangeProduct$init = function (session) {
	return _Utils_Tuple2(
		{iR: $elm$core$Maybe$Nothing, iW: _List_Nil, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, bN: '', ig: $elm$core$Maybe$Nothing, gD: $elm$core$Maybe$Nothing, kG: 0, C: session, c4: false, aC: false, kL: _List_Nil},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Api$get,
					$author$project$Endpoints$User$mlnComnetEndpoints.aV.x(_List_Nil),
					session,
					$author$project$Pages$Users$MlnComnet$ChangeProduct$initResponseDecoder,
					$author$project$Pages$Users$MlnComnet$ChangeProduct$InitRequestSent)
				])));
};
var $author$project$Pages$Users$MlnComnet$Chronological$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$GotGetSelectorSnapshot = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$NotAsked = {$: 0};
var $frandibar$elm_bootstrap$Bootstrap$Modal$Hide = 3;
var $frandibar$elm_bootstrap$Bootstrap$Modal$hidden = 3;
var $author$project$Pages$Users$MlnComnet$Chronological$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, stores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, aN: stores};
	});
var $author$project$Pages$Users$MlnComnet$Chronological$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$MlnComnet$Chronological$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder));
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$Area = F4(
	function (top, left, width, height) {
		return {jw: height, jS: left, k1: top, lg: width};
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$Closed = 2;
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$State = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$initialState = {
	d$: A4($frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$Area, 0, 0, 0, 0),
	al: 2,
	gX: A4($frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$Area, 0, 0, 0, 0)
};
var $author$project$Pages$Users$MlnComnet$Chronological$pageName = 'MLN_COMNET_CHRONOLOGICAL';
var $author$project$Utils$Types$SelectorSnapshot = F6(
	function (selectorSnapshotId, name, bigCategoryId, smallCategoryId, productIds, storeIds) {
		return {e_: bigCategoryId, jZ: name, nj: productIds, gG: selectorSnapshotId, ir: smallCategoryId, nK: storeIds};
	});
var $author$project$Utils$Decoders$selectorSnapshotDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Utils$Types$SelectorSnapshot,
	A2($elm$json$Json$Decode$field, 'selector_snapshot_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'big_category_id',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'small_category_id',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'product_ids',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'store_ids',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Utils$Decoders$selectorSnapshotsDecoder = $elm$json$Json$Decode$list($author$project$Utils$Decoders$selectorSnapshotDecoder);
var $author$project$Pages$Users$MlnComnet$Chronological$init = F2(
	function (session, interval) {
		return _Utils_Tuple2(
			{
				O: $elm$core$Set$empty,
				bq: $frandibar$elm_bootstrap$Bootstrap$Modal$hidden,
				fa: $elm$core$Maybe$Nothing,
				bw: $author$project$Pages$Users$MlnComnet$Chronological$NotAsked,
				a$: $frandibar$elm_bootstrap$Bootstrap$Modal$hidden,
				a1: true,
				aH: $krisajenkins$remotedata$RemoteData$NotAsked,
				ac: interval,
				ao: false,
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores', 0),
				au: false,
				aw: false,
				ax: true,
				eb: $frandibar$elm_bootstrap$Bootstrap$Modal$hidden,
				h7: '',
				bO: false,
				bP: false,
				bQ: false,
				eg: $frandibar$elm_bootstrap$Bootstrap$Dropdown$initialState,
				ig: -1,
				cY: '',
				cZ: '',
				eh: $elm$core$Maybe$Nothing,
				ij: _List_Nil,
				gD: -1,
				ag: $elm$core$Maybe$Nothing,
				gE: '',
				il: '',
				im: '',
				bV: $krisajenkins$remotedata$RemoteData$NotAsked,
				c3: false,
				C: session,
				aM: '',
				db: $krisajenkins$remotedata$RemoteData$NotAsked,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				gW: $elm$core$Maybe$Nothing,
				b_: $frandibar$elm_bootstrap$Bootstrap$Modal$hidden
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$MlnComnet$Chronological$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$mlnComnetEndpoints.lC.x(_List_Nil),
						session,
						$author$project$Pages$Users$MlnComnet$Chronological$initResponseDecoder,
						$author$project$Pages$Users$MlnComnet$Chronological$InitRequestSent),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$mlnComnetEndpoints.nA.hy(
							_List_fromArray(
								[
									A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'pageName', $author$project$Pages$Users$MlnComnet$Chronological$pageName)
								])),
						session,
						A2($elm$json$Json$Decode$field, 'selectorSnapshots', $author$project$Utils$Decoders$selectorSnapshotsDecoder),
						$author$project$Pages$Users$MlnComnet$Chronological$GotGetSelectorSnapshot)
					])));
	});
var $author$project$Pages$Users$MlnComnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$MlnComnet$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$MlnComnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$MlnComnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				kG: 0,
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$MlnComnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$MlnComnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$MlnComnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$MlnComnet$HourYamada$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$MlnComnet$HourYamada$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$MlnComnet$HourYamada$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$MlnComnet$HourYamada$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				kG: 0,
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$MlnComnet$HourYamada$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$MlnComnet$HourYamada$initResponseDecoder,
						$author$project$Pages$Users$MlnComnet$HourYamada$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$MailSetting$InitResponse = function (mails) {
	return {bF: mails};
};
var $author$project$Pages$Users$MlnComnet$MailSetting$Mail = F5(
	function (mailId, mailAddress, enabled, startTime, endTime) {
		return {fl: enabled, fm: endTime, jU: mailAddress, mF: mailId, gK: startTime};
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$MlnComnet$MailSetting$InitResponse,
	A2(
		$elm$json$Json$Decode$field,
		'mails',
		$elm$json$Json$Decode$list(
			A6(
				$elm$json$Json$Decode$map5,
				$author$project$Pages$Users$MlnComnet$MailSetting$Mail,
				A2($elm$json$Json$Decode$field, 'mail_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'mail_address', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'enabled', $elm$json$Json$Decode$bool),
				A2(
					$elm$json$Json$Decode$field,
					'start_time',
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$andThen,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$split(':'),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$take(2),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$join(':'),
										$elm$json$Json$Decode$succeed))),
							$elm$json$Json$Decode$string))),
				A2(
					$elm$json$Json$Decode$field,
					'end_time',
					$elm$json$Json$Decode$maybe(
						A2(
							$elm$json$Json$Decode$andThen,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$split(':'),
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$take(2),
									A2(
										$elm$core$Basics$composeR,
										$elm$core$String$join(':'),
										$elm$json$Json$Decode$succeed))),
							$elm$json$Json$Decode$string)))))));
var $author$project$Pages$Users$MlnComnet$MailSetting$init = function (session) {
	return _Utils_Tuple2(
		{fC: $krisajenkins$remotedata$RemoteData$NotAsked, cG: '00:00', bI: '', cH: '00:00', bN: '', C: session},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Api$get,
					$author$project$Endpoints$User$mlnComnetEndpoints.mG.x(_List_Nil),
					session,
					$author$project$Pages$Users$MlnComnet$MailSetting$initResponseDecoder,
					$author$project$Pages$Users$MlnComnet$MailSetting$InitRequestSent)
				])));
};
var $author$project$Pages$Users$MlnComnet$Yahoo$GotInitResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$Yahoo$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$MlnComnet$Yahoo$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$MlnComnet$Yahoo$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$MlnComnet$Yahoo$init = function (session) {
	return _Utils_Tuple2(
		{aY: $krisajenkins$remotedata$RemoteData$Loading, fC: $krisajenkins$remotedata$RemoteData$Loading, ii: '', C: session},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A4(
					$author$project$Api$get,
					$author$project$Endpoints$User$mlnComnetEndpoints.oa.x(_List_Nil),
					session,
					$author$project$Pages$Users$MlnComnet$Yahoo$initResponseDecoder,
					$author$project$Pages$Users$MlnComnet$Yahoo$GotInitResponse)
				])));
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$ShaComnet$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(0)));
var $author$project$Pages$Users$ShaComnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$ShaComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$ShaComnet$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$ShaComnet$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$ShaComnet$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$ShaComnet$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ShaComnet$Day$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, userStores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, b$: userStores};
	});
var $author$project$Pages$Users$ShaComnet$Day$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Utils$Types$UserStore)))))))))));
var $author$project$Pages$Users$ShaComnet$Day$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$ShaComnet$Day$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'users_stores', $author$project$Pages$Users$ShaComnet$Day$userStoresDecoder));
var $author$project$Endpoints$User$shaComnet = 'sha-comnet';
var $author$project$Endpoints$User$shaComnetEndpoints = {
	fd: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$shaComnet, 'day', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$shaComnet, 'day', 'init']))
	},
	iH: {
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$shaComnet, 'weekly-product', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$shaComnet, 'weekly-product', 'init']))
	}
};
var $author$project$Pages$Users$ShaComnet$Day$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				io: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				b$: _List_Nil,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$ShaComnet$Day$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$shaComnetEndpoints.fd.x(_List_Nil),
						session,
						$author$project$Pages$Users$ShaComnet$Day$initResponseDecoder,
						$author$project$Pages$Users$ShaComnet$Day$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ShaComnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$ShaComnet$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ShaComnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$ShaComnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$ShaComnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$ShaComnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$ShaComnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$ShaComnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ShaComnet$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$ShaComnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$ShaComnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$ShaComnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ShaComnet$WeeklyProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$ShaComnet$WeeklyProduct$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$shaComnetEndpoints.iH.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$ShaComnet$WeeklyProduct$initResponseDecoder,
						$author$project$Pages$Users$ShaComnet$WeeklyProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$ShaComnet$Wide$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$ShaComnet$Wide$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$ShaComnet$Wide$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ShaComnet$Wide$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				c2: false,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$ShaComnet$Wide$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$ShaComnet$Wide$initResponseDecoder,
						$author$project$Pages$Users$ShaComnet$Wide$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$Product = F9(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, triggerFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, n$: triggerFlag, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(0),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_interval',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(0),
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'trigger_flag', $elm$json$Json$Decode$bool),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$TescomComnet$ChangeProduct$Product)))))))))));
var $author$project$Pages$Users$TescomComnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$TescomComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$TescomComnet$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$TescomComnet$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$tv24ComnetEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$TescomComnet$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$TescomComnet$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$TescomComnet$Excel$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$TescomComnet$Excel$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$TescomComnet$Excel$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Endpoints$User$tescomComnet = 'tescom-comnet';
var $author$project$Endpoints$User$tescomComnetEndpoints = {
	fn: {
		x: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'time-seq', 'init'])),
		em: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$tescomComnet, 'excel', 'submit']))
	}
};
var $author$project$Pages$Users$TescomComnet$Excel$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				iB: maybeTitle
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$TescomComnet$Excel$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$tescomComnetEndpoints.fn.x(_List_Nil),
						session,
						$author$project$Pages$Users$TescomComnet$Excel$initResponseDecoder,
						$author$project$Pages$Users$TescomComnet$Excel$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$TescomComnet$Hour$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$TescomComnet$Hour$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$TescomComnet$Hour$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$TescomComnet$Hour$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$TescomComnet$Hour$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$TescomComnet$Hour$initResponseDecoder,
						$author$project$Pages$Users$TescomComnet$Hour$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Test$Fifteen$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Test$Fifteen$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Test$Fifteen$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Test$Fifteen$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Test$Fifteen$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Test$Fifteen$initResponseDecoder,
						$author$project$Pages$Users$Test$Fifteen$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, isDraggingOver) {
		return {ls: basePoint, lt: basePrice, ju: get_interval, dM: isDraggingOver, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$To24tclComnet$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(false)));
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$To24tclComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$To24tclComnet$ChangeProduct$productsDecoder));
var $author$project$Endpoints$User$to24tcmComnet = 'to24tcm-comnet';
var $author$project$Endpoints$User$to24tcmComnetEndpoints = {
	aV: {
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$to24tcmComnet, 'change-product', 'init'])),
		_: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$to24tcmComnet, 'change-product', 'update']),
			_List_Nil),
		iE: A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$absolute,
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$to24tcmComnet, 'change-product', 'update-all']),
			_List_Nil)
	},
	ja: {
		bA: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$tv24Comnet, 'csv', 'get-csv'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$tv24Comnet, 'csv', 'init']))
	},
	fd: {
		bA: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$default, 'csv'])),
		fp: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'news'])),
		g: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$default, 'prices'])),
		jt: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$to24tcmComnet, 'day', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, $author$project$Endpoints$User$default, 'init']))
	}
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, cl: $elm$core$Maybe$Nothing, dy: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$to24tcmComnetEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$To24tclComnet$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$To24tclComnet$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tclComnet$Day$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$To24tclComnet$Day$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tclComnet$Day$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$To24tclComnet$Day$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$To24tclComnet$Day$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$To24tclComnet$Day$initResponseDecoder,
						$author$project$Pages$Users$To24tclComnet$Day$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tclComnet$TimeSeq$init = $author$project$Pages$Users$Common$TimeSeq$init;
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$Product = F8(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$productsDecoder = $elm$json$Json$Decode$list(
	A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$To24tcmComnet$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(0)));
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$To24tcmComnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$To24tcmComnet$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$to24tcmComnetEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tcmComnet$Csv$GotDate = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$productsDecoder = $elm$json$Json$Decode$list(
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string)));
var $author$project$Pages$Users$To24tcmComnet$Csv$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$To24tcmComnet$Csv$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$To24tcmComnet$Csv$productsDecoder));
var $author$project$Pages$Users$To24tcmComnet$Csv$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{ds: $elm$core$Set$empty, fa: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, ac: interval, cv: false, dP: false, d_: '', d1: '', kn: _List_Nil, cY: '', cZ: '', ij: _List_Nil, il: '', im: '', C: session, iB: maybeTitle},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$To24tcmComnet$Csv$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$to24tcmComnetEndpoints.ja.x(_List_Nil),
						session,
						$author$project$Pages$Users$To24tcmComnet$Csv$initResponseDecoder,
						$author$project$Pages$Users$To24tcmComnet$Csv$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tcmComnet$Day$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$To24tcmComnet$Day$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tcmComnet$Day$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$To24tcmComnet$Day$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$To24tcmComnet$Day$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$To24tcmComnet$Day$initResponseDecoder,
						$author$project$Pages$Users$To24tcmComnet$Day$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tcmComnet$Product$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$To24tcmComnet$Product$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tcmComnet$Product$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$To24tcmComnet$Product$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				dI: true,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$To24tcmComnet$Product$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$To24tcmComnet$Product$initResponseDecoder,
						$author$project$Pages$Users$To24tcmComnet$Product$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$init = $author$project$Pages$Users$Common$TimeSeq$init;
var $author$project$Pages$Users$To24tcmFridge$HourMix$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$InitResponse = F5(
	function (bigCategories, smallCategories, makers, products, userStores) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories, b$: userStores};
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Utils$Types$UserStore)))))))))));
var $author$project$Pages$Users$To24tcmFridge$HourMix$initResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$To24tcmFridge$HourMix$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'users_stores', $author$project$Pages$Users$To24tcmFridge$HourMix$userStoresDecoder));
var $author$project$Endpoints$User$to24tcmFridge = 'to24tcm-fridge';
var $author$project$Endpoints$User$to24tcmFridgeEndpoints = {
	ml: {
		g: $Herteby$url_builder_plus$UrlBuilderPlus$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$to24tcmFridge, 'hour-mix', 'prices'])),
		x: $elm$url$Url$Builder$absolute(
			_List_fromArray(
				[$author$project$Endpoints$User$user, $author$project$Endpoints$User$to24tcmFridge, 'hour-mix', 'init']))
	}
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				S: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'makers-selector', 0),
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				p: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'stores-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				io: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				b$: _List_Nil,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$To24tcmFridge$HourMix$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$to24tcmFridgeEndpoints.ml.x(_List_Nil),
						session,
						$author$project$Pages$Users$To24tcmFridge$HourMix$initResponseDecoder,
						$author$project$Pages$Users$To24tcmFridge$HourMix$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tcmKitchen$Day$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$To24tcmKitchen$Day$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$To24tcmKitchen$Day$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$To24tcmKitchen$Day$initResponseDecoder,
						$author$project$Pages$Users$To24tcmKitchen$Day$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$TsBat$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$TsBat$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$TsBat$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TsBat$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$TsBat$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$TsBat$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$TsBat$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$TsBat$Wide$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$TsBat$Wide$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$TsBat$Wide$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TsBat$Wide$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$TsBat$Wide$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$TsBat$Wide$initResponseDecoder,
						$author$project$Pages$Users$TsBat$Wide$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$TstComnet$TimeSeq$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TstComnet$TimeSeq$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$TstComnet$TimeSeq$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$TstComnet$TimeSeq$initResponseDecoder,
						$author$project$Pages$Users$TstComnet$TimeSeq$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$TstComnet$Wide$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$InitResponse = F4(
	function (bigCategories, smallCategories, makers, products) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Users$TstComnet$Wide$initResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$TstComnet$Wide$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TstComnet$Wide$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				E: A3($inkuzmin$elm_multiselect$Multiselect$initModel, _List_Nil, 'products-selector', 0),
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				cY: '',
				cZ: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				il: '',
				im: '',
				c1: _List_Nil,
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				es: '',
				gP: '',
				et: '',
				gQ: '',
				iB: maybeTitle,
				L: $elm$core$Set$empty,
				ha: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$TstComnet$Wide$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$timeSeqEndpoints.x(_List_Nil),
						session,
						$author$project$Pages$Users$TstComnet$Wide$initResponseDecoder,
						$author$project$Pages$Users$TstComnet$Wide$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$InitRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$InitResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$Product = F9(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus, rTyousei) {
		return {ls: basePoint, lt: basePrice, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, ec: rTyousei, oc: yodobashiFlag};
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$productsDecoder = function () {
	var mainFields = A9(
		$elm$json$Json$Decode$map8,
		$author$project$Pages$Users$Tv24Comnet$ChangeProduct$Product,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'base_price', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'get_interval',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(0),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$succeed(0));
	return $elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Basics$apL,
			mainFields,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'r_tyousei', $elm$json$Json$Decode$int))));
}();
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$initResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Tv24Comnet$ChangeProduct$InitResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$Tv24Comnet$ChangeProduct$productsDecoder));
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$init = F3(
	function (interval, maybeTitle, session) {
		return _Utils_Tuple2(
			{iR: $elm$core$Maybe$Nothing, jg: $elm$core$Maybe$Nothing, H: $elm$core$Maybe$Nothing, cv: true, k: false, kn: _List_Nil, C: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$tv24ComnetEndpoints.aV.x(_List_Nil),
						session,
						$author$project$Pages$Users$Tv24Comnet$ChangeProduct$initResponseDecoder,
						$author$project$Pages$Users$Tv24Comnet$ChangeProduct$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$GotDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$InitRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$InitResponse = F3(
	function (bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kL: smallCategories};
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$initResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Tv24Comnet$Thirty$InitResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Users$Tv24Comnet$Thirty$init = F4(
	function (interval, maybeTitle, usePast, session) {
		return _Utils_Tuple2(
			{
				iW: _List_Nil,
				fa: $elm$core$Maybe$Nothing,
				H: $elm$core$Maybe$Nothing,
				hA: false,
				ac: interval,
				cv: true,
				dP: false,
				cE: _List_Nil,
				cQ: $elm$core$Dict$empty,
				kn: _List_Nil,
				ig: $elm$core$Maybe$Just(-1),
				bS: '',
				c_: 'DisplayAll',
				eh: $elm$core$Maybe$Just(-1),
				gD: $elm$core$Maybe$Just(-1),
				bi: '',
				C: session,
				kL: _List_Nil,
				X: _List_Nil,
				aN: _List_Nil,
				gN: '',
				gO: '',
				iB: maybeTitle,
				g2: usePast,
				L: $elm$core$Set$empty
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Task$perform, $author$project$Pages$Users$Tv24Comnet$Thirty$GotDate, $author$project$Utils$Helpers$getDate),
						A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$defaultEndpoints.x(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'interval',
									$elm$core$String$fromInt(interval))
								])),
						session,
						$author$project$Pages$Users$Tv24Comnet$Thirty$initResponseDecoder,
						$author$project$Pages$Users$Tv24Comnet$Thirty$InitRequestSent)
					])));
	});
var $author$project$Pages$Users$BraunComnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$BraunComnet$Wide$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Ca6Comnet$Csv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Ca6Comnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Ca6Comnet$Items$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Ca6Comnet$Low$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Common$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Common$Default$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Common$MailAddress$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Common$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Common$WeeklyProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Delonghi$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Delonghi$NineAM$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Delonghi$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Delonghi$Weekly$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Denon6Comnet$Wide$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ElecComnet$Excel$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ElecComnet$Hour$toSession = $author$project$Pages$Users$Common$Default$toSession;
var $author$project$Pages$Users$ElecComnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$FujiComnet$Fifteen$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$FujiComnet$LatestStore$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$FujiComnet$Week30$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi24Comnet$Day$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi24Comnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi3Comnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hisense$Amazon$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hisense$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hisense$Day$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hisense$Excel$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hisense$Review$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hisense$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Hisense$TvHour$toSession = $author$project$Pages$Users$Common$Default$toSession;
var $author$project$Pages$Users$JvcComnet$Amazon$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$JvcComnet$Default$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$KinujoComnet$Excel$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$AutoReload$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$Chronological$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$HourYamada$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$MailSetting$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$MlnComnet$Yahoo$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ShaComnet$Day$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ShaComnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$ShaComnet$Wide$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$TescomComnet$Excel$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$TescomComnet$Hour$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Test$Fifteen$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tclComnet$Day$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tclComnet$TimeSeq$toSession = $author$project$Pages$Users$Common$TimeSeq$toSession;
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tcmComnet$Csv$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tcmComnet$Day$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tcmComnet$Product$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$toSession = $author$project$Pages$Users$Common$TimeSeq$toSession;
var $author$project$Pages$Users$To24tcmFridge$HourMix$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$To24tcmKitchen$Day$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$TsBat$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$TsBat$Wide$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$TstComnet$TimeSeq$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$TstComnet$Wide$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$toSession = function (model) {
	return model.C;
};
var $author$project$Pages$User$toSession = function (_v0) {
	var userModel = _v0.a;
	switch (userModel.$) {
		case 0:
			var session = userModel.a;
			return session;
		case 1:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Common$Default$toSession(defaultModel);
		case 2:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Common$TimeSeq$toSession(defaultModel);
		case 12:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Common$ChangeProduct$toSession(defaultModel);
		case 13:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tcmComnet$TimeSeq$toSession(defaultModel);
		case 14:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tcmComnet$Csv$toSession(defaultModel);
		case 15:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tcmComnet$Day$toSession(defaultModel);
		case 16:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tcmComnet$ChangeProduct$toSession(defaultModel);
		case 17:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tcmComnet$Product$toSession(defaultModel);
		case 58:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tcmKitchen$Day$toSession(defaultModel);
		case 59:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tcmFridge$HourMix$toSession(defaultModel);
		case 18:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tclComnet$ChangeProduct$toSession(defaultModel);
		case 19:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tclComnet$Day$toSession(defaultModel);
		case 20:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$To24tclComnet$TimeSeq$toSession(defaultModel);
		case 21:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$JvcComnet$TimeSeq$toSession(defaultModel);
		case 22:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$JvcComnet$Default$toSession(defaultModel);
		case 23:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$JvcComnet$Amazon$toSession(defaultModel);
		case 24:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$JvcComnet$PriceDrop$toSession(defaultModel);
		case 3:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi24Comnet$Hour$toSession(defaultModel);
		case 4:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi24Comnet$TimeSeq$toSession(defaultModel);
		case 5:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi24Comnet$HourSeq$toSession(defaultModel);
		case 6:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$toSession(defaultModel);
		case 7:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi24Comnet$TenAM$toSession(defaultModel);
		case 8:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi24Comnet$Day$toSession(defaultModel);
		case 9:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi24Comnet$SixHour$toSession(defaultModel);
		case 10:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi3Comnet$Hour$toSession(defaultModel);
		case 11:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hi3Comnet$TimeSeq$toSession(defaultModel);
		case 25:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hisense$Day$toSession(defaultModel);
		case 26:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hisense$TvHour$toSession(defaultModel);
		case 28:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hisense$Amazon$toSession(defaultModel);
		case 30:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hisense$ChangeProduct$toSession(defaultModel);
		case 27:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hisense$Review$toSession(defaultModel);
		case 29:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hisense$TimeSeq$toSession(defaultModel);
		case 31:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Hisense$Excel$toSession(defaultModel);
		case 32:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$TescomComnet$Hour$toSession(defaultModel);
		case 33:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$TescomComnet$Excel$toSession(defaultModel);
		case 34:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$TescomComnet$ChangeProduct$toSession(defaultModel);
		case 35:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Ca6Comnet$Hour$toSession(defaultModel);
		case 36:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Ca6Comnet$Hour2$toSession(defaultModel);
		case 37:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Ca6Comnet$Csv$toSession(defaultModel);
		case 38:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$toSession(defaultModel);
		case 39:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$toSession(defaultModel);
		case 40:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Ca6Comnet$Items$toSession(defaultModel);
		case 41:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Ca6Comnet$Low$toSession(defaultModel);
		case 42:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$ChangeProduct$toSession(defaultModel);
		case 46:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$ChangeMail$toSession(defaultModel);
		case 47:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$ChangeMailTest$toSession(defaultModel);
		case 50:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$ChangePassword$toSession(defaultModel);
		case 43:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$Chronological$toSession(defaultModel);
		case 44:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$Hour$toSession(defaultModel);
		case 45:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$HourYamada$toSession(defaultModel);
		case 48:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$AutoReload$toSession(defaultModel);
		case 49:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$MailSetting$toSession(defaultModel);
		case 51:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$MlnComnet$Yahoo$toSession(defaultModel);
		case 52:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Tv24Comnet$ChangeProduct$toSession(defaultModel);
		case 53:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Tv24Comnet$Thirty$toSession(defaultModel);
		case 54:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ElecComnet$Hour$toSession(defaultModel);
		case 55:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ElecComnet$Excel$toSession(defaultModel);
		case 56:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ElecComnet$ChangeProduct$toSession(defaultModel);
		case 57:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ElecComnet$TimeSeq$toSession(defaultModel);
		case 60:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Delonghi$Hour$toSession(defaultModel);
		case 61:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Delonghi$ChangeProduct$toSession(defaultModel);
		case 62:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Delonghi$TimeSeq$toSession(defaultModel);
		case 63:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Delonghi$TimeSeq2$toSession(defaultModel);
		case 64:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Delonghi$NineAM$toSession(defaultModel);
		case 65:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Delonghi$Weekly$toSession(defaultModel);
		case 66:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$KinujoComnet$Excel$toSession(defaultModel);
		case 67:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$KinujoComnet$ChangeProduct$toSession(defaultModel);
		case 68:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$KinujoComnet$Fifteen$toSession(defaultModel);
		case 69:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ShaComnet$Wide$toSession(defaultModel);
		case 70:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ShaComnet$Hour$toSession(defaultModel);
		case 71:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ShaComnet$TimeSeq$toSession(defaultModel);
		case 72:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ShaComnet$WeeklyProduct$toSession(defaultModel);
		case 73:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ShaComnet$Day$toSession(defaultModel);
		case 74:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$ShaComnet$ChangeProduct$toSession(defaultModel);
		case 75:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$TstComnet$TimeSeq$toSession(defaultModel);
		case 76:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$TstComnet$Wide$toSession(defaultModel);
		case 77:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Dbi6Comnet$Hour$toSession(defaultModel);
		case 78:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Dbi6Comnet$TimeSeq$toSession(defaultModel);
		case 80:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Denon6Comnet$Wide$toSession(defaultModel);
		case 79:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Denon6Comnet$TimeSeq$toSession(defaultModel);
		case 87:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$BraunComnet$Hour$toSession(defaultModel);
		case 88:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$BraunComnet$Wide$toSession(defaultModel);
		case 81:
			var reiModel = userModel.a;
			return $author$project$Pages$Cms$Products$EditProductsPermalinks$toSession(reiModel);
		case 82:
			var reiModel = userModel.a;
			return $author$project$Pages$Cms$Products$ChangeUserProduct$toSession(reiModel);
		case 83:
			var reiModel = userModel.a;
			return $author$project$Pages$Cms$Products$AddProductConfig$toSession(reiModel);
		case 84:
			var reiModel = userModel.a;
			return $author$project$Pages$Cms$Products$EditProducts$toSession(reiModel);
		case 85:
			var yModel = userModel.a;
			return $author$project$Pages$Cms$Stores$Yahoo$toSession(yModel);
		case 86:
			var reiModel = userModel.a;
			return $author$project$Pages$Cms$Products$EditSoldoutProducts$toSession(reiModel);
		case 90:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$TsBat$Wide$toSession(defaultModel);
		case 89:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$TsBat$TimeSeq$toSession(defaultModel);
		case 100:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Test$Fifteen$toSession(defaultModel);
		case 91:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$FujiComnet$Fifteen$toSession(defaultModel);
		case 92:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$FujiComnet$Week30$toSession(defaultModel);
		case 93:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$FujiComnet$ChangeProduct$toSession(defaultModel);
		case 94:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$FujiComnet$LatestStore$toSession(defaultModel);
		case 95:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Common$MailAddress$toSession(defaultModel);
		case 96:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$Common$WeeklyProduct$toSession(defaultModel);
		case 97:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$FujiinstaxComnet$Thirty$toSession(defaultModel);
		case 98:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$FujiinstaxComnet$Week30$toSession(defaultModel);
		default:
			var defaultModel = userModel.a;
			return $author$project$Pages$Users$FujiinstaxComnet$LatestStore$toSession(defaultModel);
	}
};
var $author$project$Pages$User$updateWithNavModel = F5(
	function (toModel, toMsg, navModel, news, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_Tuple3(
				toModel(subModel),
				navModel,
				news),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Endpoints$User$weeklyProductEndpoints = {
	g: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'weekly-product', 'prices'])),
	x: $elm$url$Url$Builder$absolute(
		_List_fromArray(
			[$author$project$Endpoints$User$user, $author$project$Endpoints$User$common, 'weekly-product', 'init']))
};
var $author$project$Pages$User$changeRouteTo = F2(
	function (url, model) {
		var router = $author$project$Routers$UserRouter$fromUrl(url);
		var _v0 = model;
		var userModel = _v0.a;
		var navModel = _v0.b;
		var news = _v0.c;
		switch (router) {
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetProductModel,
					$author$project$Pages$User$GotTo24tcmComnetProductMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$Product$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 3:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetProductModel,
					$author$project$Pages$User$GotTo24tcmComnetProductMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$Product$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 4:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetDayModel,
					$author$project$Pages$User$GotTo24tcmComnetDayMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$Day$init,
						1440,
						$elm$core$Maybe$Just('一日取得'),
						false,
						$author$project$Pages$User$toSession(model)));
			case 5:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 6:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 7:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetCsvModel,
					$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$Csv$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 8:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetChangeProductModel,
					$author$project$Pages$User$GotTo24tcmComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 9:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DefaultModel,
					$author$project$Pages$User$GotDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$Default$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 10:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tclComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tclComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tclComnet$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 11:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tclComnetDayModel,
					$author$project$Pages$User$GotTo24tclComnetDayMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tclComnet$Day$init,
						1440,
						$elm$core$Maybe$Just('一日取得'),
						false,
						$author$project$Pages$User$toSession(model)));
			case 12:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetCsvModel,
					$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$Csv$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 13:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tclComnetChangeProductModel,
					$author$project$Pages$User$GotTo24tclComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tclComnet$ChangeProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 14:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DefaultModel,
					$author$project$Pages$User$GotDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$Default$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 15:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DefaultModel,
					$author$project$Pages$User$GotDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$Default$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 16:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmFridgeHourMixModel,
					$author$project$Pages$User$GotTo24tcmFridgeHourMixMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmFridge$HourMix$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 17:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 18:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 19:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetCsvModel,
					$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$Csv$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 20:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetDayModel,
					$author$project$Pages$User$GotTo24tcmComnetDayMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$Day$init,
						1440,
						$elm$core$Maybe$Just('一日取得'),
						false,
						$author$project$Pages$User$toSession(model)));
			case 21:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetChangeProductModel,
					$author$project$Pages$User$GotTo24tcmComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 22:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DefaultModel,
					$author$project$Pages$User$GotDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$Default$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 23:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DefaultModel,
					$author$project$Pages$User$GotDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$Default$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 25:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 26:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 24:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmKitchenDayModel,
					$author$project$Pages$User$GotTo24tcmKitchenDayMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmKitchen$Day$init,
						1440,
						$elm$core$Maybe$Just('一日取得'),
						false,
						$author$project$Pages$User$toSession(model)));
			case 27:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetCsvModel,
					$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$Csv$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 28:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetChangeProductModel,
					$author$project$Pages$User$GotTo24tcmComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 29:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$JvcComnetDefaultModel,
					$author$project$Pages$User$GotJvcComnetDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$JvcComnet$Default$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 30:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$JvcComnetDefaultModel,
					$author$project$Pages$User$GotJvcComnetDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$JvcComnet$Default$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 31:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$JvcComnetTimeSeqModel,
					$author$project$Pages$User$GotJvcComnetTimeSeqMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$JvcComnet$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 32:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$JvcComnetTimeSeqModel,
					$author$project$Pages$User$GotJvcComnetTimeSeqMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$JvcComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 33:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$JvcComnetAmazonModel,
					$author$project$Pages$User$GotJvcComnetAmazonMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$JvcComnet$Amazon$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 34:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$JvcComnetAmazonModel,
					$author$project$Pages$User$GotJvcComnetAmazonMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$JvcComnet$Amazon$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 35:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$JvcComnetPriceDropModel,
					$author$project$Pages$User$GotJvcComnetPriceDropMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$JvcComnet$PriceDrop$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 36:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$HisenseDayModel,
					$author$project$Pages$User$GotHisenseDayMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hisense$Day$init,
						1440,
						$elm$core$Maybe$Just('一日取得'),
						false,
						$author$project$Pages$User$toSession(model)));
			case 38:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$HisenseTvHourModel,
					$author$project$Pages$User$GotHisenseTvHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hisense$TvHour$init,
						60,
						$elm$core$Maybe$Just('60分取得/ハイセンス4商品'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 39:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$HisenseAmazonModel,
					$author$project$Pages$User$GotHisenseAmazonMsg,
					navModel,
					news,
					$author$project$Pages$Users$Hisense$Amazon$init(
						$author$project$Pages$User$toSession(model)));
			case 40:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$HisenseChangeProductModel,
					$author$project$Pages$User$GotHisenseChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Hisense$ChangeProduct$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 41:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$HisenseReviewModel,
					$author$project$Pages$User$GotHisenseReviewMsg,
					navModel,
					news,
					$author$project$Pages$Users$Hisense$Review$init(
						$author$project$Pages$User$toSession(model)));
			case 37:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$HisenseTimeSeqModel,
					$author$project$Pages$User$GotHisenseTimeSeqMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Hisense$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 42:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$HisenseExcelModel,
					$author$project$Pages$User$GotHisenseExcelMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hisense$Excel$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 47:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Ca6ComnetHourModel,
					$author$project$Pages$User$GotCa6ComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Ca6Comnet$Hour$init,
						60,
						$elm$core$Maybe$Just('1時間取得'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 48:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Ca6ComnetHour2Model,
					$author$project$Pages$User$GotCa6ComnetHour2Msg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Ca6Comnet$Hour2$init,
						60,
						$elm$core$Maybe$Just('1時間取得(本サイト/モール順)'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 49:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Ca6ComnetCsvModel,
					$author$project$Pages$User$GotCa6ComnetCsvMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Ca6Comnet$Csv$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 50:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Ca6ComnetWeeklyProductModel,
					$author$project$Pages$User$GotCa6ComnetWeeklyProductMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$init,
						60,
						$elm$core$Maybe$Just('今週の品目(1時間)'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 51:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Ca6ComnetWeeklyProduct2Model,
					$author$project$Pages$User$GotCa6ComnetWeeklyProduct2Msg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$init,
						60,
						$elm$core$Maybe$Just('今週の品目(1時間, 本サイト/モール順)'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 52:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Ca6ComnetItemsModel,
					$author$project$Pages$User$GotCa6ComnetItemsMsg,
					navModel,
					news,
					A2(
						$author$project$Pages$Users$Ca6Comnet$Items$init,
						$elm$core$Maybe$Just('取得一覧'),
						$author$project$Pages$User$toSession(model)));
			case 53:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Ca6ComnetLowModel,
					$author$project$Pages$User$GotCa6ComnetLowMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Ca6Comnet$Low$init,
						60,
						$elm$core$Maybe$Just('低価格抽出'),
						$author$project$Pages$User$toSession(model)));
			case 54:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetChangeProductModel,
					$author$project$Pages$User$GotMlnComnetChangeProductMsg,
					navModel,
					news,
					$author$project$Pages$Users$MlnComnet$ChangeProduct$init(
						$author$project$Pages$User$toSession(model)));
			case 55:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetChangeMailModel,
					$author$project$Pages$User$GotMlnComnetChangeMailMsg,
					navModel,
					news,
					$author$project$Pages$Users$MlnComnet$ChangeMail$init(
						$author$project$Pages$User$toSession(model)));
			case 56:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetChangeMailTestModel,
					$author$project$Pages$User$GotMlnComnetChangeMailTestMsg,
					navModel,
					news,
					$author$project$Pages$Users$MlnComnet$ChangeMailTest$init(
						$author$project$Pages$User$toSession(model)));
			case 57:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetChangePasswordModel,
					$author$project$Pages$User$GotMlnComnetChangePasswordMsg,
					navModel,
					news,
					$author$project$Pages$Users$MlnComnet$ChangePassword$init(
						$author$project$Pages$User$toSession(model)));
			case 58:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetChronologicalModel,
					$author$project$Pages$User$GotMlnComnetChronologicalMsg,
					navModel,
					news,
					A2(
						$author$project$Pages$Users$MlnComnet$Chronological$init,
						$author$project$Pages$User$toSession(model),
						30));
			case 59:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetHourModel,
					$author$project$Pages$User$GotMlnComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$MlnComnet$Hour$init,
						30,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 60:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetHourYamadaModel,
					$author$project$Pages$User$GotMlnComnetHourYamadaMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$MlnComnet$HourYamada$init,
						30,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 61:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetAutoReloadModel,
					$author$project$Pages$User$GotMlnComnetAutoReloadMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$MlnComnet$AutoReload$init,
						30,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 62:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetMailSettingModel,
					$author$project$Pages$User$GotMlnComnetMailSettingMsg,
					navModel,
					news,
					$author$project$Pages$Users$MlnComnet$MailSetting$init(
						$author$project$Pages$User$toSession(model)));
			case 63:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$MlnComnetYahooModel,
					$author$project$Pages$User$GotMlnComnetYahooMsg,
					navModel,
					news,
					$author$project$Pages$Users$MlnComnet$Yahoo$init(
						$author$project$Pages$User$toSession(model)));
			case 43:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TescomComnetHourModel,
					$author$project$Pages$User$GotTescomComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$TescomComnet$Hour$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 44:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TescomComnetHourModel,
					$author$project$Pages$User$GotTescomComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$TescomComnet$Hour$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 45:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TescomComnetExcelModel,
					$author$project$Pages$User$GotTescomComnetExcelMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$TescomComnet$Excel$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 46:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TescomComnetChangeProductModel,
					$author$project$Pages$User$GotTescomComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$TescomComnet$ChangeProduct$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 64:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Tv24ComnetThirtyModel,
					$author$project$Pages$User$GotTv24ComnetThirtyMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Tv24Comnet$Thirty$init,
						30,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 65:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetCsvModel,
					$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$Csv$init,
						30,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 66:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Tv24ComnetChangeProductModel,
					$author$project$Pages$User$GotTv24ComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Tv24Comnet$ChangeProduct$init,
						30,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 67:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ElecComnetHourModel,
					$author$project$Pages$User$GotElecComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ElecComnet$Hour$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 68:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ElecComnetHourModel,
					$author$project$Pages$User$GotElecComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ElecComnet$Hour$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 69:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ElecComnetExcelModel,
					$author$project$Pages$User$GotElecComnetExcelMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ElecComnet$Excel$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 70:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ElecComnetChangeProductModel,
					$author$project$Pages$User$GotElecComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$ElecComnet$ChangeProduct$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 71:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ElecComnetTimeSeqModel,
					$author$project$Pages$User$GotElecComnetTimeSeqMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$ElecComnet$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 72:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ElecComnetTimeSeqModel,
					$author$project$Pages$User$GotElecComnetTimeSeqMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$ElecComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 73:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DefaultModel,
					$author$project$Pages$User$GotDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$Default$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 74:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DefaultModel,
					$author$project$Pages$User$GotDefaultMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$Default$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 75:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetTimeSeqModel,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 76:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetCsvModel,
					$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$Csv$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 77:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$To24tcmComnetChangeProductModel,
					$author$project$Pages$User$GotTo24tcmComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 78:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi3ComnetHourModel,
					$author$project$Pages$User$GotHi3ComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi3Comnet$Hour$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 79:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi3ComnetTimeSeqModel,
					$author$project$Pages$User$GotHi3ComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi3Comnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 80:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ChangeProductModel,
					$author$project$Pages$User$GotChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Common$ChangeProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 81:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DelonghiHourModel,
					$author$project$Pages$User$GotDelonghiHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Delonghi$Hour$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 82:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DelonghiChangeProductModel,
					$author$project$Pages$User$GotDelonghiChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Delonghi$ChangeProduct$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 83:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DelonghiTimeSeqModel,
					$author$project$Pages$User$GotDelonghiTimeSeqMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$Delonghi$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 84:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DelonghiTimeSeq2Model,
					$author$project$Pages$User$GotDelonghiTimeSeq2Msg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Delonghi$TimeSeq2$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 85:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DelonghiNineAMModel,
					$author$project$Pages$User$GotDelonghiNineAMMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Delonghi$NineAM$init,
						60,
						$elm$core$Maybe$Just('9時の状況'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 86:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$DelonghiWeeklyModel,
					$author$project$Pages$User$GotDelonghiWeeklyMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Delonghi$Weekly$init,
						60,
						$elm$core$Maybe$Just('トラッキング(試験運用)'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 87:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$KinujoComnetFifteenModel,
					$author$project$Pages$User$GotKinujoComnetFifteeenMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$KinujoComnet$Fifteen$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 88:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$KinujoComnetExcelModel,
					$author$project$Pages$User$GotKinujoComnetExcelMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$KinujoComnet$Excel$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 89:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$KinujoComnetChangeProductModel,
					$author$project$Pages$User$GotKinujoComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$KinujoComnet$ChangeProduct$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 91:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi24ComnetHourModel,
					$author$project$Pages$User$GotHi24ComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi24Comnet$Hour$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 92:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi24ComnetSixHourModel,
					$author$project$Pages$User$GotHi24ComnetSixHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi24Comnet$SixHour$init,
						360,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 93:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi24ComnetTimeSeqModel,
					$author$project$Pages$User$GotHi24ComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi24Comnet$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 94:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi24ComnetHourSeqModel,
					$author$project$Pages$User$GotHi24ComnetHourSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi24Comnet$HourSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 95:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi24ComnetWeeklyProductFifteenModel,
					$author$project$Pages$User$GotHi24ComnetWeeklyProductFifteenMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$init,
						15,
						$elm$core$Maybe$Just('今週の品目15分'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 96:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi24ComnetTenAMModel,
					$author$project$Pages$User$GotHi24ComnetTenAMMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi24Comnet$TenAM$init,
						15,
						$elm$core$Maybe$Just('10時の状況'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 90:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Hi24ComnetDayModel,
					$author$project$Pages$User$GotHi24ComnetDayMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Hi24Comnet$Day$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 97:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ShaComnetWideModel,
					$author$project$Pages$User$GotShaComnetWideMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ShaComnet$Wide$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 98:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ShaComnetHourModel,
					$author$project$Pages$User$GotShaComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ShaComnet$Hour$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 99:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ShaComnetTimeSeqModel,
					$author$project$Pages$User$GotShaComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ShaComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 101:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ShaComnetDayModel,
					$author$project$Pages$User$GotShaComnetDayMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ShaComnet$Day$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 102:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ShaComnetChangeProductModel,
					$author$project$Pages$User$GotShaComnetChangeProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Users$ShaComnet$ChangeProduct$init,
						60,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 100:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ShaComnetWeeklyProductModel,
					$author$project$Pages$User$GotShaComnetWeeklyProductMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$ShaComnet$WeeklyProduct$init,
						60,
						$elm$core$Maybe$Just('週次(1時間毎に頁更新)'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 103:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TstComnetTimeSeqModel,
					$author$project$Pages$User$GotTstComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$TstComnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 104:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TstComnetWideModel,
					$author$project$Pages$User$GotTstComnetWideMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$TstComnet$Wide$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 105:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Dbi6ComnetHourModel,
					$author$project$Pages$User$GotDbi6ComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Dbi6Comnet$Hour$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 106:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Dbi6ComnetTimeSeqModel,
					$author$project$Pages$User$GotDbi6ComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Dbi6Comnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 107:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Denon6ComnetWideModel,
					$author$project$Pages$User$GotDenon6ComnetWideMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Denon6Comnet$Wide$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 108:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Denon6ComnetTimeSeqModel,
					$author$project$Pages$User$GotDenon6ComnetTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Denon6Comnet$TimeSeq$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 109:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$BraunComnetHourModel,
					$author$project$Pages$User$GotBraunComnetHourMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$BraunComnet$Hour$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 110:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$BraunComnetWideModel,
					$author$project$Pages$User$GotBraunComnetWideMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$BraunComnet$Wide$init,
						60,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 111:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$EditProductsPermalinks,
					$author$project$Pages$User$GotEditProductsPermalinks,
					navModel,
					news,
					$author$project$Pages$Cms$Products$EditProductsPermalinks$init(
						$author$project$Pages$User$toSession(model)));
			case 112:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$ChangeUserProductModel,
					$author$project$Pages$User$GotChangeUserProductMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Cms$Products$ChangeUserProduct$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 113:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$AddProductConfigModel,
					$author$project$Pages$User$GotAddProductConfigMsg,
					navModel,
					news,
					A3(
						$author$project$Pages$Cms$Products$AddProductConfig$init,
						15,
						$elm$core$Maybe$Nothing,
						$author$project$Pages$User$toSession(model)));
			case 114:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$EditProductsModel,
					$author$project$Pages$User$GotEditProductsMsg,
					navModel,
					news,
					$author$project$Pages$Cms$Products$EditProducts$init(
						$author$project$Pages$User$toSession(model)));
			case 115:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$Yahoo,
					$author$project$Pages$User$GotYahooMsg,
					navModel,
					news,
					$author$project$Pages$Cms$Stores$Yahoo$init(
						$author$project$Pages$User$toSession(model)));
			case 116:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$EditSoldoutProductsModel,
					$author$project$Pages$User$GotEditSoldoutProductsMsg,
					navModel,
					news,
					$author$project$Pages$Cms$Products$EditSoldoutProducts$init(
						$author$project$Pages$User$toSession(model)));
			case 117:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TsBatWideModel,
					$author$project$Pages$User$GotTsBatWideMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$TsBat$Wide$init,
						360,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 118:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TsBatTimeSeqModel,
					$author$project$Pages$User$GotTsBatTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$TsBat$TimeSeq$init,
						360,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 119:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiComnetFifteenModel,
					$author$project$Pages$User$GotFujiComnetFifteenMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$FujiComnet$Fifteen$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 120:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TimeSeqModel,
					$author$project$Pages$User$GotTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$TimeSeq$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 121:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiComnetWeek30Model,
					$author$project$Pages$User$GotFujiComnetWeek30Msg,
					navModel,
					news,
					$author$project$Pages$Users$FujiComnet$Week30$init(
						$author$project$Pages$User$toSession(model)));
			case 122:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiComnetChangeProductModel,
					$author$project$Pages$User$GotFujiComnetChangeProductMsg,
					navModel,
					news,
					$author$project$Pages$Users$FujiComnet$ChangeProduct$init(
						$author$project$Pages$User$toSession(model)));
			case 123:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiComnetLatestStoreModel,
					$author$project$Pages$User$GotFujiComnetLatestStoreMsg,
					navModel,
					news,
					A2(
						$author$project$Pages$Users$FujiComnet$LatestStore$init,
						$elm$core$Maybe$Just('販売店別'),
						$author$project$Pages$User$toSession(model)));
			case 124:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiComnetMailAddressModel,
					$author$project$Pages$User$GotFujiComnetMailAddressMsg,
					navModel,
					news,
					$author$project$Pages$Users$Common$MailAddress$init(
						$author$project$Pages$User$toSession(model)));
			case 125:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$CommonWeeklyProductModel,
					$author$project$Pages$User$GotCommonWeeklyProductMsg,
					navModel,
					news,
					A6(
						$author$project$Pages$Users$Common$WeeklyProduct$init,
						$author$project$Endpoints$User$weeklyProductEndpoints.x,
						$author$project$Endpoints$User$weeklyProductEndpoints.g,
						15,
						$elm$core$Maybe$Just('今週の品目15分'),
						true,
						$author$project$Pages$User$toSession(model)));
			case 126:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiinstaxComnetThirtyModel,
					$author$project$Pages$User$GotFujiinstaxComnetThirtyMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$FujiinstaxComnet$Thirty$init,
						30,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 127:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TimeSeqModel,
					$author$project$Pages$User$GotTimeSeqMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Common$TimeSeq$init,
						30,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
			case 128:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiinstaxComnetWeek30Model,
					$author$project$Pages$User$GotFujiinstaxComnetWeek30Msg,
					navModel,
					news,
					$author$project$Pages$Users$FujiinstaxComnet$Week30$init(
						$author$project$Pages$User$toSession(model)));
			case 129:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$FujiinstaxComnetLatestStoreModel,
					$author$project$Pages$User$GotFujiinstaxComnetLatestStoreMsg,
					navModel,
					news,
					A2(
						$author$project$Pages$Users$FujiinstaxComnet$LatestStore$init,
						$elm$core$Maybe$Just('販売店別'),
						$author$project$Pages$User$toSession(model)));
			default:
				return A5(
					$author$project$Pages$User$updateWithNavModel,
					$author$project$Pages$User$TestFifteenModel,
					$author$project$Pages$User$GotTestFifteeenMsg,
					navModel,
					news,
					A4(
						$author$project$Pages$Users$Test$Fifteen$init,
						15,
						$elm$core$Maybe$Nothing,
						true,
						$author$project$Pages$User$toSession(model)));
		}
	});
var $author$project$Routers$TopRouter$Cms = {$: 4};
var $author$project$Routers$TopRouter$Login = {$: 2};
var $author$project$Routers$TopRouter$NotFound = {$: 0};
var $author$project$Routers$TopRouter$Redirect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Routers$TopRouter$User = {$: 5};
var $author$project$Session$isAdmin = function (session) {
	if (session.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Session$isUser = function (session) {
	if (!session.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Routers$TopRouter$Root = {$: 1};
var $author$project$Routers$TopRouter$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Routers$TopRouter$Root, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routers$TopRouter$Login,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routers$TopRouter$Cms,
			$elm$url$Url$Parser$s('cms')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routers$TopRouter$User,
			$elm$url$Url$Parser$s('user'))
		]));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Routers$TopRouter$fromUrl = F2(
	function (url, session) {
		var firstPathUrl = function (path) {
			return _Utils_update(
				url,
				{nc: '/' + path});
		}(
			A2(
				$elm$core$Maybe$withDefault,
				'/',
				$elm$core$List$head(
					A2(
						$elm$core$Maybe$withDefault,
						_List_fromArray(
							['/']),
						$elm$core$List$tail(
							A2($elm$core$String$split, '/', url.nc))))));
		var parsedUrl = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Routers$TopRouter$NotFound,
			A2($elm$url$Url$Parser$parse, $author$project$Routers$TopRouter$parser, firstPathUrl));
		switch (parsedUrl.$) {
			case 1:
				return $author$project$Session$isAdmin(session) ? $author$project$Routers$TopRouter$Redirect('cms') : ($author$project$Session$isUser(session) ? $author$project$Routers$TopRouter$Redirect('user') : $author$project$Routers$TopRouter$Redirect('login'));
			case 2:
				return $author$project$Session$isAdmin(session) ? $author$project$Routers$TopRouter$Redirect('cms') : ($author$project$Session$isUser(session) ? $author$project$Routers$TopRouter$Redirect('user') : $author$project$Routers$TopRouter$Login);
			case 4:
				return $author$project$Session$isAdmin(session) ? $author$project$Routers$TopRouter$Cms : $author$project$Routers$TopRouter$NotFound;
			case 5:
				return $author$project$Session$isUser(session) ? $author$project$Routers$TopRouter$User : $author$project$Routers$TopRouter$NotFound;
			default:
				return $author$project$Routers$TopRouter$NotFound;
		}
	});
var $author$project$Pages$Cms$GotNavBarMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Cms$Top = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$NavBar$NavbarMsg = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Hidden = 0;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$State = $elm$core$Basics$identity;
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $frandibar$elm_bootstrap$Bootstrap$Navbar$mapState = F2(
	function (mapper, _v0) {
		var state = _v0;
		return mapper(state);
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$initWindowSize = F2(
	function (toMsg, state) {
		return A2(
			$elm$core$Task$perform,
			function (vp) {
				return toMsg(
					A2(
						$frandibar$elm_bootstrap$Bootstrap$Navbar$mapState,
						function (s) {
							return _Utils_update(
								s,
								{
									eK: $elm$core$Maybe$Just(vp.la.lg)
								});
						},
						state));
			},
			$elm$browser$Browser$Dom$getViewport);
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$initialState = function (toMsg) {
	var state = {bu: $elm$core$Dict$empty, jw: $elm$core$Maybe$Nothing, aF: 0, eK: $elm$core$Maybe$Nothing};
	return _Utils_Tuple2(
		state,
		A2($frandibar$elm_bootstrap$Bootstrap$Navbar$initWindowSize, toMsg, state));
};
var $author$project$Components$NavBar$init = function () {
	var _v0 = $frandibar$elm_bootstrap$Bootstrap$Navbar$initialState($author$project$Components$NavBar$NavbarMsg);
	var navbarState = _v0.a;
	var navbarCmd = _v0.b;
	return _Utils_Tuple2(
		{d3: navbarState},
		navbarCmd);
}();
var $author$project$Pages$Cms$init = function (session) {
	var _v0 = $author$project$Components$NavBar$init;
	var navbarState = _v0.a;
	var navbarCmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_Tuple2(
			$author$project$Pages$Cms$Top(session),
			navbarState),
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$Cms$GotNavBarMsg, navbarCmd));
};
var $author$project$Pages$Login$Valid = {$: 0};
var $author$project$Pages$Login$init = function (session) {
	return _Utils_Tuple2(
		{
			H: $elm$core$Maybe$Nothing,
			a5: {d7: '', n2: ''},
			C: session,
			k9: $author$project$Pages$Login$Valid
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$User$GotNavBarMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$User$GotNewsMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$User$Top = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$NewsResponse = function (news) {
	return {j$: news};
};
var $author$project$Pages$User$newsResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$User$NewsResponse,
	A2($elm$json$Json$Decode$field, 'news', $elm$json$Json$Decode$string));
var $author$project$Pages$User$init = function (session) {
	var _v0 = $author$project$Components$NavBar$init;
	var navbarState = _v0.a;
	var navbarCmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_Tuple3(
			$author$project$Pages$User$Top(session),
			navbarState,
			''),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$GotNavBarMsg, navbarCmd),
					A4(
					$author$project$Api$get,
					$author$project$Endpoints$User$defaultEndpoints.fp(_List_Nil),
					session,
					$author$project$Pages$User$newsResponseDecoder,
					$author$project$Pages$User$GotNewsMsg)
				])));
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Pages$Login$toSession = function (model) {
	return model.C;
};
var $author$project$Main$toSession = function (model) {
	switch (model.$) {
		case 0:
			var session = model.a;
			return session;
		case 1:
			var loginModel = model.a;
			return $author$project$Pages$Login$toSession(loginModel);
		case 2:
			var cmsModel = model.a;
			return $author$project$Pages$Cms$toSession(cmsModel);
		default:
			var userModel = model.a;
			return $author$project$Pages$User$toSession(userModel);
	}
};
var $author$project$Main$updateWith = F3(
	function (toModel, toMsg, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			toModel(subModel),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Main$changeRouteTo = F2(
	function (url, model) {
		var router = A2(
			$author$project$Routers$TopRouter$fromUrl,
			url,
			$author$project$Main$toSession(model));
		switch (router.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var segment = router.a;
				return _Utils_Tuple2(
					model,
					$elm$browser$Browser$Navigation$load(segment));
			case 1:
				return A3(
					$author$project$Main$updateWith,
					$author$project$Main$Login,
					$author$project$Main$GotLoginMsg,
					$author$project$Pages$Login$init(
						$author$project$Main$toSession(model)));
			case 2:
				return A3(
					$author$project$Main$updateWith,
					$author$project$Main$Login,
					$author$project$Main$GotLoginMsg,
					$author$project$Pages$Login$init(
						$author$project$Main$toSession(model)));
			case 4:
				var _v1 = $author$project$Pages$Cms$init(
					$author$project$Main$toSession(model));
				var cmsModel = _v1.a;
				var cmsCmd = _v1.b;
				return function (_v2) {
					var model_ = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple2(
						model_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Main$GotCmsMsg, cmsCmd),
									cmd
								])));
				}(
					A3(
						$author$project$Main$updateWith,
						$author$project$Main$Cms,
						$author$project$Main$GotCmsMsg,
						A2($author$project$Pages$Cms$changeRouteTo, url, cmsModel)));
			default:
				var _v3 = $author$project$Pages$User$init(
					$author$project$Main$toSession(model));
				var userModel = _v3.a;
				var userCmd = _v3.b;
				return function (_v4) {
					var model_ = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple2(
						model_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Main$GotUserMsg, userCmd),
									cmd
								])));
				}(
					A3(
						$author$project$Main$updateWith,
						$author$project$Main$User,
						$author$project$Main$GotUserMsg,
						A2($author$project$Pages$User$changeRouteTo, url, userModel)));
		}
	});
var $author$project$Session$Config = F3(
	function (bindAddress, apiDestIp, apiDestPort) {
		return {iS: apiDestIp, iT: apiDestPort, lv: bindAddress};
	});
var $author$project$Main$configDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Session$Config,
	A2($elm$json$Json$Decode$field, 'bindAddress', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'apiDestIp', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'apiDestPort', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Session$NotLoggedIn = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Session$initSession = F2(
	function (key, config) {
		return A2($author$project$Session$NotLoggedIn, key, config);
	});
var $author$project$Session$LoggedIn = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Session$LoggedInAsAdmin = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Session$login = F5(
	function (session, t, isAdmin_, name, role) {
		switch (session.$) {
			case 0:
				return session;
			case 1:
				return session;
			default:
				var key = session.a;
				var config = session.b;
				return isAdmin_ ? A3($author$project$Session$LoggedInAsAdmin, key, t, config) : A5($author$project$Session$LoggedIn, key, t, name, role, config);
		}
	});
var $author$project$Main$UserInfo = F4(
	function (token, isAdmin, userName, role) {
		return {hK: isAdmin, $8: role, iC: token, n2: userName};
	});
var $author$project$Main$userInfoDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Main$UserInfo,
	A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'isAdmin', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'userName', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'role', $elm$json$Json$Decode$string)));
var $author$project$Main$init = F3(
	function (maybeEncodedFlags, url, key) {
		var defaultConfig = {iS: 'http://localhost', iT: 5001, lv: 'http://0.0.0.0'};
		var config = function () {
			if (!maybeEncodedFlags.$) {
				var encodedFlags = maybeEncodedFlags.a;
				var decodedConfig = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$configDecoder, encodedFlags);
				if (!decodedConfig.$) {
					var conf = decodedConfig.a;
					return conf;
				} else {
					var err = decodedConfig.a;
					return defaultConfig;
				}
			} else {
				return defaultConfig;
			}
		}();
		var initialSession = function () {
			if (!maybeEncodedFlags.$) {
				var encodedFlags = maybeEncodedFlags.a;
				var maybeUserInfo = A2($elm$json$Json$Decode$decodeValue, $author$project$Main$userInfoDecoder, encodedFlags);
				if (!maybeUserInfo.$) {
					var userInfo = maybeUserInfo.a;
					return A5(
						$author$project$Session$login,
						A2($author$project$Session$initSession, key, config),
						userInfo.iC,
						userInfo.hK,
						userInfo.n2,
						userInfo.$8);
				} else {
					var err = maybeUserInfo.a;
					return A2($author$project$Session$initSession, key, config);
				}
			} else {
				return A2($author$project$Session$initSession, key, config);
			}
		}();
		return A2(
			$author$project$Main$changeRouteTo,
			url,
			$author$project$Main$Redirect(initialSession));
	});
var $author$project$Main$OnLogout = {$: 6};
var $author$project$Main$OnUserInfoChanged = function (a) {
	return {$: 5, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Api$login = _Platform_incomingPort('login', $elm$json$Json$Decode$value);
var $author$project$Api$logout = _Platform_incomingPort(
	'logout',
	$elm$json$Json$Decode$null(0));
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $frandibar$elm_bootstrap$Bootstrap$Navbar$AnimatingDown = 2;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$AnimatingUp = 4;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Closed = 2;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$ListenClicks = 1;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Open = 0;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {hZ: oldTime, kt: request, kW: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.kt;
		var oldTime = _v0.hZ;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.kW;
		var oldTime = _v0.hZ;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {j9: pids, kW: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {jl: event, dR: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.j9,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.dR;
		var event = _v0.jl;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.kW);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $frandibar$elm_bootstrap$Bootstrap$Navbar$dropdownSubscriptions = F2(
	function (state, toMsg) {
		var dropdowns = state.bu;
		var updDropdowns = A2(
			$elm$core$Dict$map,
			F2(
				function (_v2, status) {
					switch (status) {
						case 0:
							return 1;
						case 1:
							return 2;
						default:
							return 2;
					}
				}),
			dropdowns);
		var updState = A2(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$mapState,
			function (s) {
				return _Utils_update(
					s,
					{bu: updDropdowns});
			},
			state);
		var needsSub = function (s) {
			return A2(
				$elm$core$List$any,
				function (_v1) {
					var status = _v1.b;
					return _Utils_eq(status, s);
				},
				$elm$core$Dict$toList(dropdowns));
		};
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					needsSub(0) ? $elm$browser$Browser$Events$onAnimationFrame(
					function (_v0) {
						return toMsg(updState);
					}) : $elm$core$Platform$Sub$none,
					needsSub(1) ? $elm$browser$Browser$Events$onClick(
					$elm$json$Json$Decode$succeed(
						toMsg(updState))) : $elm$core$Platform$Sub$none
				]));
	});
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$subscriptions = F2(
	function (state, toMsg) {
		var visibility = state.aF;
		var updState = function (v) {
			return A2(
				$frandibar$elm_bootstrap$Bootstrap$Navbar$mapState,
				function (s) {
					return _Utils_update(
						s,
						{aF: v});
				},
				state);
		};
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					function () {
					switch (visibility) {
						case 1:
							return $elm$browser$Browser$Events$onAnimationFrame(
								function (_v1) {
									return toMsg(
										updState(2));
								});
						case 3:
							return $elm$browser$Browser$Events$onAnimationFrame(
								function (_v2) {
									return toMsg(
										updState(4));
								});
						default:
							return $elm$core$Platform$Sub$none;
					}
				}(),
					$elm$browser$Browser$Events$onResize(
					F2(
						function (x, _v3) {
							return toMsg(
								A2(
									$frandibar$elm_bootstrap$Bootstrap$Navbar$mapState,
									function (s) {
										return _Utils_update(
											s,
											{
												eK: $elm$core$Maybe$Just(x)
											});
									},
									state));
						})),
					A2($frandibar$elm_bootstrap$Bootstrap$Navbar$dropdownSubscriptions, state, toMsg)
				]));
	});
var $author$project$Components$NavBar$subscriptions = function (model) {
	return A2($frandibar$elm_bootstrap$Bootstrap$Navbar$subscriptions, model.d3, $author$project$Components$NavBar$NavbarMsg);
};
var $author$project$Pages$Users$BraunComnet$Hour$Tick = function (a) {
	return {$: 14, a: a};
};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {kk: processes, kX: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.kk;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.kX);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Pages$Users$BraunComnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$BraunComnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Csv$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Ca6Comnet$Csv$Tick)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Ca6Comnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$Tick = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Ca6Comnet$Hour2$Tick)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Items$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Ca6Comnet$Low$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$Tick = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$Tick)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$Tick)
			]));
};
var $author$project$Pages$Users$Common$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Common$Default$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Common$Default$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Common$Default$Tick)
			]));
};
var $author$project$Pages$Users$Common$MailAddress$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Common$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$Tick = function (a) {
	return {$: 17, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Click = {$: 1};
var $inkuzmin$elm_multiselect$Multiselect$Opened = 2;
var $inkuzmin$elm_multiselect$Multiselect$subscriptions = function (_v0) {
	var model = _v0;
	return (model.al === 2) ? $elm$browser$Browser$Events$onClick(
		$elm$json$Json$Decode$succeed($inkuzmin$elm_multiselect$Multiselect$Click)) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Users$Common$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Common$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Common$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Common$WeeklyProduct$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Common$WeeklyProduct$Tick)
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Dbi6Comnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Delonghi$Hour$Tick = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Delonghi$Hour$Tick)
			]));
};
var $author$project$Pages$Users$Delonghi$NineAM$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$OnChangeStore = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Delonghi$NineAM$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Delonghi$NineAM$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Delonghi$NineAM$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Delonghi$TimeSeq$Tick)
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeStore = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Delonghi$TimeSeq2$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p))
			]));
};
var $author$project$Pages$Users$Delonghi$Weekly$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$OnChangeStore = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Delonghi$Weekly$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Delonghi$Weekly$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Delonghi$Weekly$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Denon6Comnet$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$Tick = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Denon6Comnet$Wide$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Denon6Comnet$Wide$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$ElecComnet$Excel$OnChangeProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$Tick = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$ElecComnet$Excel$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$ElecComnet$Excel$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$ElecComnet$Hour$subscriptions = $author$project$Pages$Users$Common$Default$subscriptions;
var $author$project$Pages$Users$ElecComnet$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$ElecComnet$TimeSeq$Tick)
			]));
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$FujiComnet$Fifteen$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$FujiComnet$Fifteen$Tick)
			]));
};
var $author$project$Pages$Users$FujiComnet$LatestStore$Tick = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$FujiComnet$LatestStore$Tick)
			]));
};
var $author$project$Pages$Users$FujiComnet$Week30$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$Tick = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$FujiinstaxComnet$LatestStore$Tick)
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$FujiinstaxComnet$Thirty$Tick)
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Hi24Comnet$Day$OnChangeMaker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$OnChangeStore = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi24Comnet$Day$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi24Comnet$Day$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi24Comnet$Day$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi24Comnet$Day$OnChangeMaker,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.S))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Hour$Tick = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi24Comnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeProduct = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi24Comnet$HourSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi24Comnet$SixHour$Tick)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeProduct = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeStore = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$Tick = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi24Comnet$TenAM$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi24Comnet$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$Tick = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$Tick)
			]));
};
var $author$project$Pages$Users$Hi3Comnet$Hour$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi3Comnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hi3Comnet$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Hisense$Amazon$Tick = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Hisense$Amazon$subscriptions = function (_v0) {
	return A2($elm$time$Time$every, 60 * 1000, $author$project$Pages$Users$Hisense$Amazon$Tick);
};
var $author$project$Pages$Users$Hisense$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Hisense$Day$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Common$Default$Tick)
			]));
};
var $author$project$Pages$Users$Hisense$Excel$OnChangeProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$Tick = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hisense$Excel$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$Hisense$Excel$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Hisense$Review$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Users$Hisense$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Hisense$TimeSeq$Tick)
			]));
};
var $author$project$Pages$Users$Hisense$TvHour$subscriptions = $author$project$Pages$Users$Common$Default$subscriptions;
var $author$project$Pages$Users$JvcComnet$Amazon$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$JvcComnet$Amazon$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$JvcComnet$Amazon$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$JvcComnet$Default$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$JvcComnet$Default$Tick)
			]));
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$JvcComnet$TimeSeq$Tick)
			]));
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$KinujoComnet$Excel$OnChangeProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$Tick = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$KinujoComnet$Excel$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$KinujoComnet$Excel$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$KinujoComnet$Fifteen$Tick)
			]));
};
var $author$project$Pages$Users$MlnComnet$AutoReload$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 30000, $author$project$Pages$Users$MlnComnet$AutoReload$Tick)
			]));
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$MlnComnet$Chronological$GotDropdownMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnChangeStore = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$Tick = function (a) {
	return {$: 22, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$ListenClicks = 1;
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$updateStatus = F2(
	function (status, _v0) {
		var stateRec = _v0;
		return _Utils_update(
			stateRec,
			{al: status});
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$subscriptions = F2(
	function (state, toMsg) {
		var status = state.al;
		switch (status) {
			case 0:
				return $elm$browser$Browser$Events$onAnimationFrame(
					function (_v1) {
						return toMsg(
							A2($frandibar$elm_bootstrap$Bootstrap$Dropdown$updateStatus, 1, state));
					});
			case 1:
				return $elm$browser$Browser$Events$onClick(
					$elm$json$Json$Decode$succeed(
						toMsg(
							A2($frandibar$elm_bootstrap$Bootstrap$Dropdown$updateStatus, 2, state))));
			default:
				return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Pages$Users$MlnComnet$Chronological$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$MlnComnet$Chronological$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$MlnComnet$Chronological$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p)),
				A2($frandibar$elm_bootstrap$Bootstrap$Dropdown$subscriptions, model.eg, $author$project$Pages$Users$MlnComnet$Chronological$GotDropdownMsg)
			]));
};
var $author$project$Pages$Users$MlnComnet$Hour$Tick = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$MlnComnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$MlnComnet$HourYamada$Tick)
			]));
};
var $author$project$Pages$Users$MlnComnet$MailSetting$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$MlnComnet$Yahoo$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$ShaComnet$Day$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$OnChangeStore = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$ShaComnet$Day$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$ShaComnet$Day$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$ShaComnet$Day$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p))
			]));
};
var $author$project$Pages$Users$ShaComnet$Hour$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$ShaComnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$ShaComnet$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$Tick = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$ShaComnet$WeeklyProduct$Tick)
			]));
};
var $author$project$Pages$Users$ShaComnet$Wide$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$Tick = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$ShaComnet$Wide$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$ShaComnet$Wide$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$TescomComnet$Excel$OnChangeProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$Tick = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$TescomComnet$Excel$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$TescomComnet$Excel$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$TescomComnet$Hour$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$TescomComnet$Hour$Tick)
			]));
};
var $author$project$Pages$Users$Test$Fifteen$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Test$Fifteen$Tick)
			]));
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$To24tclComnet$Day$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$To24tclComnet$Day$Tick)
			]));
};
var $author$project$Pages$Users$To24tclComnet$TimeSeq$subscriptions = $author$project$Pages$Users$Common$TimeSeq$subscriptions;
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$To24tcmComnet$Csv$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Users$To24tcmComnet$Day$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$To24tcmComnet$Day$Tick)
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Product$Tick = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$To24tcmComnet$Product$Tick)
			]));
};
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$subscriptions = $author$project$Pages$Users$Common$TimeSeq$subscriptions;
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeMaker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeStore = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$Tick = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$To24tcmFridge$HourMix$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeStore,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.p)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeMaker,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.S))
			]));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$To24tcmKitchen$Day$Tick)
			]));
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$TsBat$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$TsBat$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$TsBat$Wide$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$Tick = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$TsBat$Wide$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$TsBat$Wide$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$Tick = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$TstComnet$TimeSeq$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$TstComnet$TimeSeq$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$TstComnet$Wide$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$Tick = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$TstComnet$Wide$Tick),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Users$TstComnet$Wide$OnChangeProduct,
				$inkuzmin$elm_multiselect$Multiselect$subscriptions(model.E))
			]));
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(_List_Nil);
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$Tick = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Pages$Users$Tv24Comnet$Thirty$Tick)
			]));
};
var $author$project$Pages$User$subscriptions = function (_v0) {
	var userModel = _v0.a;
	var navModel = _v0.b;
	var userSub = function () {
		switch (userModel.$) {
			case 0:
				return $elm$core$Platform$Sub$none;
			case 1:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDefaultMsg,
					$author$project$Pages$Users$Common$Default$subscriptions(defaultModel));
			case 2:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTimeSeqMsg,
					$author$project$Pages$Users$Common$TimeSeq$subscriptions(defaultModel));
			case 12:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotChangeProductMsg,
					$author$project$Pages$Users$Common$ChangeProduct$subscriptions(defaultModel));
			case 13:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
					$author$project$Pages$Users$To24tcmComnet$TimeSeq$subscriptions(defaultModel));
			case 14:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
					$author$project$Pages$Users$To24tcmComnet$Csv$subscriptions(defaultModel));
			case 15:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tcmComnetDayMsg,
					$author$project$Pages$Users$To24tcmComnet$Day$subscriptions(defaultModel));
			case 16:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tcmComnetChangeProductMsg,
					$author$project$Pages$Users$To24tcmComnet$ChangeProduct$subscriptions(defaultModel));
			case 17:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tcmComnetProductMsg,
					$author$project$Pages$Users$To24tcmComnet$Product$subscriptions(defaultModel));
			case 58:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tcmKitchenDayMsg,
					$author$project$Pages$Users$To24tcmKitchen$Day$subscriptions(defaultModel));
			case 59:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tcmFridgeHourMixMsg,
					$author$project$Pages$Users$To24tcmFridge$HourMix$subscriptions(defaultModel));
			case 18:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tclComnetChangeProductMsg,
					$author$project$Pages$Users$To24tclComnet$ChangeProduct$subscriptions(defaultModel));
			case 19:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tclComnetDayMsg,
					$author$project$Pages$Users$To24tclComnet$Day$subscriptions(defaultModel));
			case 20:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTo24tclComnetTimeSeqMsg,
					$author$project$Pages$Users$To24tclComnet$TimeSeq$subscriptions(defaultModel));
			case 21:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotJvcComnetTimeSeqMsg,
					$author$project$Pages$Users$JvcComnet$TimeSeq$subscriptions(defaultModel));
			case 22:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotJvcComnetDefaultMsg,
					$author$project$Pages$Users$JvcComnet$Default$subscriptions(defaultModel));
			case 23:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotJvcComnetAmazonMsg,
					$author$project$Pages$Users$JvcComnet$Amazon$subscriptions(defaultModel));
			case 3:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi24ComnetHourMsg,
					$author$project$Pages$Users$Hi24Comnet$Hour$subscriptions(defaultModel));
			case 24:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotJvcComnetPriceDropMsg,
					$author$project$Pages$Users$JvcComnet$PriceDrop$subscriptions(defaultModel));
			case 4:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi24ComnetTimeSeqMsg,
					$author$project$Pages$Users$Hi24Comnet$TimeSeq$subscriptions(defaultModel));
			case 5:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi24ComnetHourSeqMsg,
					$author$project$Pages$Users$Hi24Comnet$HourSeq$subscriptions(defaultModel));
			case 6:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi24ComnetWeeklyProductFifteenMsg,
					$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$subscriptions(defaultModel));
			case 7:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi24ComnetTenAMMsg,
					$author$project$Pages$Users$Hi24Comnet$TenAM$subscriptions(defaultModel));
			case 8:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi24ComnetDayMsg,
					$author$project$Pages$Users$Hi24Comnet$Day$subscriptions(defaultModel));
			case 9:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi24ComnetSixHourMsg,
					$author$project$Pages$Users$Hi24Comnet$SixHour$subscriptions(defaultModel));
			case 10:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi3ComnetHourMsg,
					$author$project$Pages$Users$Hi3Comnet$Hour$subscriptions(defaultModel));
			case 11:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHi3ComnetTimeSeqMsg,
					$author$project$Pages$Users$Hi3Comnet$TimeSeq$subscriptions(defaultModel));
			case 25:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHisenseDayMsg,
					$author$project$Pages$Users$Hisense$Day$subscriptions(defaultModel));
			case 26:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHisenseTvHourMsg,
					$author$project$Pages$Users$Hisense$TvHour$subscriptions(defaultModel));
			case 28:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHisenseAmazonMsg,
					$author$project$Pages$Users$Hisense$Amazon$subscriptions(defaultModel));
			case 30:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHisenseChangeProductMsg,
					$author$project$Pages$Users$Hisense$ChangeProduct$subscriptions(defaultModel));
			case 27:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHisenseReviewMsg,
					$author$project$Pages$Users$Hisense$Review$subscriptions(defaultModel));
			case 29:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHisenseTimeSeqMsg,
					$author$project$Pages$Users$Hisense$TimeSeq$subscriptions(defaultModel));
			case 31:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotHisenseExcelMsg,
					$author$project$Pages$Users$Hisense$Excel$subscriptions(defaultModel));
			case 32:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTescomComnetHourMsg,
					$author$project$Pages$Users$TescomComnet$Hour$subscriptions(defaultModel));
			case 33:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTescomComnetExcelMsg,
					$author$project$Pages$Users$TescomComnet$Excel$subscriptions(defaultModel));
			case 34:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTescomComnetChangeProductMsg,
					$author$project$Pages$Users$TescomComnet$ChangeProduct$subscriptions(defaultModel));
			case 35:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCa6ComnetHourMsg,
					$author$project$Pages$Users$Ca6Comnet$Hour$subscriptions(defaultModel));
			case 36:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCa6ComnetHour2Msg,
					$author$project$Pages$Users$Ca6Comnet$Hour2$subscriptions(defaultModel));
			case 37:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCa6ComnetCsvMsg,
					$author$project$Pages$Users$Ca6Comnet$Csv$subscriptions(defaultModel));
			case 38:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCa6ComnetWeeklyProductMsg,
					$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$subscriptions(defaultModel));
			case 39:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCa6ComnetWeeklyProduct2Msg,
					$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$subscriptions(defaultModel));
			case 40:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCa6ComnetItemsMsg,
					$author$project$Pages$Users$Ca6Comnet$Items$subscriptions(defaultModel));
			case 41:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCa6ComnetLowMsg,
					$author$project$Pages$Users$Ca6Comnet$Low$subscriptions(defaultModel));
			case 42:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetChangeProductMsg,
					$author$project$Pages$Users$MlnComnet$ChangeProduct$subscriptions(defaultModel));
			case 46:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetChangeMailMsg,
					$author$project$Pages$Users$MlnComnet$ChangeMail$subscriptions(defaultModel));
			case 47:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetChangeMailTestMsg,
					$author$project$Pages$Users$MlnComnet$ChangeMailTest$subscriptions(defaultModel));
			case 50:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetChangePasswordMsg,
					$author$project$Pages$Users$MlnComnet$ChangePassword$subscriptions(defaultModel));
			case 43:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetChronologicalMsg,
					$author$project$Pages$Users$MlnComnet$Chronological$subscriptions(defaultModel));
			case 44:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetHourMsg,
					$author$project$Pages$Users$MlnComnet$Hour$subscriptions(defaultModel));
			case 45:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetHourYamadaMsg,
					$author$project$Pages$Users$MlnComnet$HourYamada$subscriptions(defaultModel));
			case 48:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetAutoReloadMsg,
					$author$project$Pages$Users$MlnComnet$AutoReload$subscriptions(defaultModel));
			case 49:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetMailSettingMsg,
					$author$project$Pages$Users$MlnComnet$MailSetting$subscriptions(defaultModel));
			case 51:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotMlnComnetYahooMsg,
					$author$project$Pages$Users$MlnComnet$Yahoo$subscriptions(defaultModel));
			case 52:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTv24ComnetChangeProductMsg,
					$author$project$Pages$Users$Tv24Comnet$ChangeProduct$subscriptions(defaultModel));
			case 53:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTv24ComnetThirtyMsg,
					$author$project$Pages$Users$Tv24Comnet$Thirty$subscriptions(defaultModel));
			case 54:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotElecComnetHourMsg,
					$author$project$Pages$Users$ElecComnet$Hour$subscriptions(defaultModel));
			case 55:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotElecComnetExcelMsg,
					$author$project$Pages$Users$ElecComnet$Excel$subscriptions(defaultModel));
			case 56:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotElecComnetChangeProductMsg,
					$author$project$Pages$Users$ElecComnet$ChangeProduct$subscriptions(defaultModel));
			case 57:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotElecComnetTimeSeqMsg,
					$author$project$Pages$Users$ElecComnet$TimeSeq$subscriptions(defaultModel));
			case 60:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDelonghiHourMsg,
					$author$project$Pages$Users$Delonghi$Hour$subscriptions(defaultModel));
			case 61:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDelonghiChangeProductMsg,
					$author$project$Pages$Users$Delonghi$ChangeProduct$subscriptions(defaultModel));
			case 62:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDelonghiTimeSeqMsg,
					$author$project$Pages$Users$Delonghi$TimeSeq$subscriptions(defaultModel));
			case 63:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDelonghiTimeSeq2Msg,
					$author$project$Pages$Users$Delonghi$TimeSeq2$subscriptions(defaultModel));
			case 64:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDelonghiNineAMMsg,
					$author$project$Pages$Users$Delonghi$NineAM$subscriptions(defaultModel));
			case 65:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDelonghiWeeklyMsg,
					$author$project$Pages$Users$Delonghi$Weekly$subscriptions(defaultModel));
			case 66:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotKinujoComnetExcelMsg,
					$author$project$Pages$Users$KinujoComnet$Excel$subscriptions(defaultModel));
			case 67:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotKinujoComnetChangeProductMsg,
					$author$project$Pages$Users$KinujoComnet$ChangeProduct$subscriptions(defaultModel));
			case 68:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotKinujoComnetFifteeenMsg,
					$author$project$Pages$Users$KinujoComnet$Fifteen$subscriptions(defaultModel));
			case 69:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotShaComnetWideMsg,
					$author$project$Pages$Users$ShaComnet$Wide$subscriptions(defaultModel));
			case 70:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotShaComnetHourMsg,
					$author$project$Pages$Users$ShaComnet$Hour$subscriptions(defaultModel));
			case 71:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotShaComnetTimeSeqMsg,
					$author$project$Pages$Users$ShaComnet$TimeSeq$subscriptions(defaultModel));
			case 72:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotShaComnetWeeklyProductMsg,
					$author$project$Pages$Users$ShaComnet$WeeklyProduct$subscriptions(defaultModel));
			case 73:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotShaComnetDayMsg,
					$author$project$Pages$Users$ShaComnet$Day$subscriptions(defaultModel));
			case 74:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotShaComnetChangeProductMsg,
					$author$project$Pages$Users$ShaComnet$ChangeProduct$subscriptions(defaultModel));
			case 75:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTstComnetTimeSeqMsg,
					$author$project$Pages$Users$TstComnet$TimeSeq$subscriptions(defaultModel));
			case 76:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTstComnetWideMsg,
					$author$project$Pages$Users$TstComnet$Wide$subscriptions(defaultModel));
			case 77:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDbi6ComnetHourMsg,
					$author$project$Pages$Users$Dbi6Comnet$Hour$subscriptions(defaultModel));
			case 78:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDbi6ComnetTimeSeqMsg,
					$author$project$Pages$Users$Dbi6Comnet$TimeSeq$subscriptions(defaultModel));
			case 80:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDenon6ComnetWideMsg,
					$author$project$Pages$Users$Denon6Comnet$Wide$subscriptions(defaultModel));
			case 79:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotDenon6ComnetTimeSeqMsg,
					$author$project$Pages$Users$Denon6Comnet$TimeSeq$subscriptions(defaultModel));
			case 90:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTsBatWideMsg,
					$author$project$Pages$Users$TsBat$Wide$subscriptions(defaultModel));
			case 89:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTsBatTimeSeqMsg,
					$author$project$Pages$Users$TsBat$TimeSeq$subscriptions(defaultModel));
			case 100:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotTestFifteeenMsg,
					$author$project$Pages$Users$Test$Fifteen$subscriptions(defaultModel));
			case 91:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiComnetFifteenMsg,
					$author$project$Pages$Users$FujiComnet$Fifteen$subscriptions(defaultModel));
			case 92:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiComnetWeek30Msg,
					$author$project$Pages$Users$FujiComnet$Week30$subscriptions(defaultModel));
			case 93:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiComnetChangeProductMsg,
					$author$project$Pages$Users$FujiComnet$ChangeProduct$subscriptions(defaultModel));
			case 94:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiComnetLatestStoreMsg,
					$author$project$Pages$Users$FujiComnet$LatestStore$subscriptions(defaultModel));
			case 95:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiComnetMailAddressMsg,
					$author$project$Pages$Users$Common$MailAddress$subscriptions(defaultModel));
			case 96:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotCommonWeeklyProductMsg,
					$author$project$Pages$Users$Common$WeeklyProduct$subscriptions(defaultModel));
			case 97:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiinstaxComnetThirtyMsg,
					$author$project$Pages$Users$FujiinstaxComnet$Thirty$subscriptions(defaultModel));
			case 98:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiinstaxComnetWeek30Msg,
					$author$project$Pages$Users$FujiinstaxComnet$Week30$subscriptions(defaultModel));
			case 99:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotFujiinstaxComnetLatestStoreMsg,
					$author$project$Pages$Users$FujiinstaxComnet$LatestStore$subscriptions(defaultModel));
			case 87:
				var defaultModel = userModel.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$User$GotBraunComnetHourMsg,
					$author$project$Pages$Users$BraunComnet$Hour$subscriptions(defaultModel));
			default:
				return $elm$core$Platform$Sub$none;
		}
	}();
	var navSub = A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$User$GotNavBarMsg,
		$author$project$Components$NavBar$subscriptions(navModel));
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[userSub, navSub]));
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Api$login(
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Decode$decodeValue($author$project$Main$userInfoDecoder),
					$author$project$Main$OnUserInfoChanged)),
				$author$project$Api$logout(
				function (_v0) {
					return $author$project$Main$OnLogout;
				}),
				function () {
				if (model.$ === 3) {
					var userModel = model.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Main$GotUserMsg,
						$author$project$Pages$User$subscriptions(userModel));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Session$navKey = function (session) {
	switch (session.$) {
		case 0:
			var key = session.a;
			return key;
		case 1:
			var key = session.a;
			return key;
		default:
			var key = session.a;
			return key;
	}
};
var $author$project$Session$logout = function (session) {
	return A2(
		$author$project$Session$initSession,
		$author$project$Session$navKey(session),
		$author$project$Session$getConfig(session));
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Api$removeUserInfo = _Platform_outgoingPort(
	'removeUserInfo',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Components$NavBar$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var state = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{d3: state}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Api$removeUserInfo(0));
		}
	});
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedAddPermalinkGroup = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedAddTarget = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedBulkUpdatePermalinkGroups = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedDeletePermalinkGroup = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedDeleteTarget = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedListTargets = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedUpdatePermalinkGroup = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Utils$Helpers$errToStr = function (err) {
	switch (err.$) {
		case 1:
			return 'RequestTimeout';
		case 2:
			return 'Network is Unreachable';
		case 3:
			var code = err.a;
			return 'Error Status Code: ' + $elm$core$String$fromInt(code);
		case 4:
			var body = err.a;
			return 'Error: ' + body;
		default:
			var url = err.a;
			return 'Malformed url: ' + url;
	}
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Pages$Cms$Others$EditMailAddress$MailTarget = F5(
	function (mailTargetId, mailId, storeId, storeName, type_) {
		return {mF: mailId, hT: mailTargetId, iw: storeId, kS: storeName, gZ: type_};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$mailTargetDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Cms$Others$EditMailAddress$MailTarget,
	A2($elm$json$Json$Decode$field, 'mail_target_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'mail_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$int));
var $author$project$Pages$Cms$Others$EditMailAddress$mailTargetsDecoder = A2(
	$elm$json$Json$Decode$field,
	'targets',
	$elm$json$Json$Decode$list($author$project$Pages$Cms$Others$EditMailAddress$mailTargetDecoder));
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$POST = 1;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $author$project$Api$post = F5(
	function (path, session, body, decoder, msg) {
		var apiConf = $author$project$Session$getConfig(session);
		var config = {
			dp: $elm$http$Http$jsonBody(body),
			dC: A2($author$project$Api$expectJson, msg, decoder),
			dE: $author$project$Api$makeAuthHeader(session),
			d0: $author$project$Api$decodeHTTPMethod(1),
			ew: $elm$core$Maybe$Nothing,
			ez: $elm$core$Maybe$Nothing,
			eD: A3(
				$author$project$Api$makeEndpoint,
				apiConf,
				_List_fromArray(
					[path]),
				_List_Nil)
		};
		return $elm$http$Http$request(config);
	});
var $author$project$Pages$Cms$Others$EditMailAddress$CompletedListUserAddress = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$UserAddressResponse = F2(
	function (permalinkGroups, stores) {
		return {i: permalinkGroups, aN: stores};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$userAddressDecoder = $elm$json$Json$Decode$list(
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Pages$Cms$Others$EditMailAddress$PermalinkGroup,
		A2($elm$json$Json$Decode$field, 'mail_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'supervisor',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(''),
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))),
		A2(
			$elm$json$Json$Decode$field,
			'valid',
			A2(
				$elm$json$Json$Decode$map,
				function (v) {
					return v === 1;
				},
				$elm$json$Json$Decode$int)),
		$elm$json$Json$Decode$succeed(false)));
var $author$project$Pages$Cms$Others$EditMailAddress$listMailAddressResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Others$EditMailAddress$UserAddressResponse,
	A2($elm$json$Json$Decode$field, 'mail_address', $author$project$Pages$Cms$Others$EditMailAddress$userAddressDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'stores',
		$elm$json$Json$Decode$list($author$project$Pages$Cms$Others$EditMailAddress$storeDecoder)));
var $author$project$Pages$Cms$Others$EditMailAddress$postListAddress = F2(
	function (maybeUser, model) {
		if (maybeUser.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var userId = maybeUser.a;
			return A5(
				$author$project$Api$post,
				$author$project$Endpoints$Cms$editMailAddressEndpoints.mC,
				model.C,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'user_id',
							$elm$json$Json$Encode$int(userId))
						])),
				$author$project$Pages$Cms$Others$EditMailAddress$listMailAddressResponseDecoder,
				$author$project$Pages$Cms$Others$EditMailAddress$CompletedListUserAddress);
		}
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Pages$Cms$Others$EditMailAddress$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Others$EditMailAddress$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Others$EditMailAddress$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, i: initResponse.i, aN: initResponse.aN, k8: initResponse.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 9:
				if (!msg.a.$) {
					var userAddressResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, i: userAddressResponse.i, aN: userAddressResponse.aN}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 7:
				if (!msg.b.$) {
					var permalinkGroupId = msg.a;
					var updateResponse = msg.b.a;
					var permalinkGroups = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.T, permalinkGroupId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.i);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, i: permalinkGroups}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 10:
				if (!msg.a.$) {
					var updateResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, ba: $author$project$Pages$Cms$Others$EditMailAddress$initNewPermalinkGroup}),
						A2($author$project$Pages$Cms$Others$EditMailAddress$postListAddress, model.$9, model));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 8:
				if (!msg.b.$) {
					var permalinkGroupId = msg.a;
					var updateResponse = msg.b.a;
					var permalinkGroups = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.T, permalinkGroupId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.i);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, i: permalinkGroups}),
						A2($author$project$Pages$Cms$Others$EditMailAddress$postListAddress, model.$9, model));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								i: A2(
									$elm$core$List$map,
									function (pg) {
										return _Utils_update(
											pg,
											{R: false});
									},
									model.i)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 12:
				var permalinkGroup = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'permalink_group_id',
							$elm$json$Json$Encode$int(permalinkGroup.T)),
							_Utils_Tuple2(
							'permalink_group_name',
							$elm$json$Json$Encode$string(permalinkGroup.as)),
							_Utils_Tuple2(
							'supervisor',
							$elm$json$Json$Encode$string(permalinkGroup.aE)),
							_Utils_Tuple2(
							'valid',
							$elm$json$Json$Encode$bool(permalinkGroup.aP))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editMailAddressEndpoints._,
						model.C,
						body,
						$author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder,
						$author$project$Pages$Cms$Others$EditMailAddress$CompletedUpdatePermalinkGroup(permalinkGroup.T)));
			case 15:
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'addresses',
							A2(
								$elm$json$Json$Encode$list,
								function (pg) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'mail_id',
												$elm$json$Json$Encode$int(pg.T)),
												_Utils_Tuple2(
												'address',
												$elm$json$Json$Encode$string(pg.as)),
												_Utils_Tuple2(
												'supervisor',
												$elm$json$Json$Encode$string(pg.aE)),
												_Utils_Tuple2(
												'valid',
												$elm$json$Json$Encode$bool(pg.aP))
											]));
								},
								model.i))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$editMailAddressEndpoints.lw, model.C, body, $author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder, $author$project$Pages$Cms$Others$EditMailAddress$CompletedBulkUpdatePermalinkGroups));
			case 16:
				var valid = msg.a;
				var updatedGroups = A2(
					$elm$core$List$map,
					function (pg) {
						return _Utils_update(
							pg,
							{aP: valid});
					},
					model.i);
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'addresses',
							A2(
								$elm$json$Json$Encode$list,
								function (pg) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'mail_id',
												$elm$json$Json$Encode$int(pg.T)),
												_Utils_Tuple2(
												'address',
												$elm$json$Json$Encode$string(pg.as)),
												_Utils_Tuple2(
												'supervisor',
												$elm$json$Json$Encode$string(pg.aE)),
												_Utils_Tuple2(
												'valid',
												$elm$json$Json$Encode$bool(pg.aP))
											]));
								},
								updatedGroups))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true, i: updatedGroups}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$editMailAddressEndpoints.lw, model.C, body, $author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder, $author$project$Pages$Cms$Others$EditMailAddress$CompletedBulkUpdatePermalinkGroups));
			case 14:
				var newPermalinkGroup = msg.a;
				var _v1 = model.$9;
				if (_v1.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var selectedUser = _v1.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'address',
								$elm$json$Json$Encode$string(newPermalinkGroup.as)),
								_Utils_Tuple2(
								'supervisor',
								$elm$json$Json$Encode$string(newPermalinkGroup.aE)),
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(selectedUser))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$Cms$editMailAddressEndpoints.am, model.C, body, $author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder, $author$project$Pages$Cms$Others$EditMailAddress$CompletedAddPermalinkGroup));
				}
			case 13:
				var permalinkGroupId = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'permalink_group_id',
							$elm$json$Json$Encode$int(permalinkGroupId))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editMailAddressEndpoints.ci,
						model.C,
						body,
						$author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder,
						$author$project$Pages$Cms$Others$EditMailAddress$CompletedDeletePermalinkGroup(permalinkGroupId)));
			case 2:
				var permalinkGroupId = msg.a;
				var permalinkGroupName = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (pg) {
									return _Utils_eq(pg.T, permalinkGroupId);
								},
								function (pg) {
									return _Utils_update(
										pg,
										{R: true, as: permalinkGroupName});
								},
								model.i)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var permalinkGroupId = msg.a;
				var supervisor = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (pg) {
									return _Utils_eq(pg.T, permalinkGroupId);
								},
								function (pg) {
									return _Utils_update(
										pg,
										{R: true, aE: supervisor});
								},
								model.i)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var permalinkGroupId = msg.a;
				var valid = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (pg) {
									return _Utils_eq(pg.T, permalinkGroupId);
								},
								function (pg) {
									return _Utils_update(
										pg,
										{R: true, aP: valid});
								},
								model.i)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var selectedUserStr = msg.a;
				var maybeSelectedUser = $elm$core$String$toInt(selectedUserStr);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{$9: maybeSelectedUser}),
					A2($author$project$Pages$Cms$Others$EditMailAddress$postListAddress, maybeSelectedUser, model));
			case 5:
				var permalinkGroupName = msg.a;
				var newPermalinkGroup = model.ba;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ba: _Utils_update(
								newPermalinkGroup,
								{R: true, as: permalinkGroupName})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var supervisor = msg.a;
				var newPermalinkGroup = model.ba;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ba: _Utils_update(
								newPermalinkGroup,
								{R: true, aE: supervisor})
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var showValidOnly = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ej: showValidOnly}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var mailId = msg.a;
				var newExpandedMailIds = A2($elm$core$Set$member, mailId, model.a0) ? A2($elm$core$Set$remove, mailId, model.a0) : A2($elm$core$Set$insert, mailId, model.a0);
				var fetchCmd = function () {
					if (A2($elm$core$Set$member, mailId, model.a0)) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var _v2 = A2($elm$core$Dict$get, mailId, model.ae);
						if (!_v2.$) {
							return $elm$core$Platform$Cmd$none;
						} else {
							return A5(
								$author$project$Api$post,
								$author$project$Endpoints$Cms$editMailAddressEndpoints.mD,
								model.C,
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'mail_id',
											$elm$json$Json$Encode$int(mailId)),
											_Utils_Tuple2(
											'user_id',
											$elm$json$Json$Encode$int(
												A2($elm$core$Maybe$withDefault, -1, model.$9)))
										])),
								$author$project$Pages$Cms$Others$EditMailAddress$mailTargetsDecoder,
								$author$project$Pages$Cms$Others$EditMailAddress$CompletedListTargets(mailId));
						}
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a0: newExpandedMailIds}),
					fetchCmd);
			case 19:
				if (!msg.b.$) {
					var mailId = msg.a;
					var targets = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ae: A3($elm$core$Dict$insert, mailId, targets, model.ae)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 20:
				var mailId = msg.a;
				var storeIdStr = msg.b;
				var _v3 = $elm$core$String$toInt(storeIdStr);
				if (_v3.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var storeId = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cJ: A3($elm$core$Dict$insert, mailId, storeId, model.cJ)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 21:
				var mailId = msg.a;
				var _v4 = A2($elm$core$Dict$get, mailId, model.cJ);
				if (_v4.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var storeId = _v4.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editMailAddressEndpoints.li,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId)),
										_Utils_Tuple2(
										'store_id',
										$elm$json$Json$Encode$int(storeId)),
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$int(2)),
										_Utils_Tuple2(
										'user_id',
										$elm$json$Json$Encode$int(
											A2($elm$core$Maybe$withDefault, -1, model.$9)))
									])),
							$author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder,
							$author$project$Pages$Cms$Others$EditMailAddress$CompletedAddTarget(mailId)));
				}
			case 22:
				if (!msg.b.$) {
					var mailId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								ae: A2($elm$core$Dict$remove, mailId, model.ae)
							}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editMailAddressEndpoints.mD,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId)),
										_Utils_Tuple2(
										'user_id',
										$elm$json$Json$Encode$int(
											A2($elm$core$Maybe$withDefault, -1, model.$9)))
									])),
							$author$project$Pages$Cms$Others$EditMailAddress$mailTargetsDecoder,
							$author$project$Pages$Cms$Others$EditMailAddress$CompletedListTargets(mailId)));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 23:
				var mailId = msg.a;
				var mailTargetId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editMailAddressEndpoints.lS,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mail_target_id',
									$elm$json$Json$Encode$int(mailTargetId))
								])),
						$author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder,
						$author$project$Pages$Cms$Others$EditMailAddress$CompletedDeleteTarget(mailId)));
			case 24:
				if (!msg.b.$) {
					var mailId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								ae: A2($elm$core$Dict$remove, mailId, model.ae)
							}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editMailAddressEndpoints.mD,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId)),
										_Utils_Tuple2(
										'user_id',
										$elm$json$Json$Encode$int(
											A2($elm$core$Maybe$withDefault, -1, model.$9)))
									])),
							$author$project$Pages$Cms$Others$EditMailAddress$mailTargetsDecoder,
							$author$project$Pages$Cms$Others$EditMailAddress$CompletedListTargets(mailId)));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var mailId = msg.a;
				var allStoresTarget = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (t) {
							return t.gZ === 1;
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Dict$get, mailId, model.ae))));
				var cmd = function () {
					if (!allStoresTarget.$) {
						var target = allStoresTarget.a;
						return A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editMailAddressEndpoints.lS,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_target_id',
										$elm$json$Json$Encode$int(target.hT))
									])),
							$author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder,
							$author$project$Pages$Cms$Others$EditMailAddress$CompletedDeleteTarget(mailId));
					} else {
						return A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editMailAddressEndpoints.li,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId)),
										_Utils_Tuple2(
										'store_id',
										$elm$json$Json$Encode$int(0)),
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$int(1))
									])),
							$author$project$Pages$Cms$Others$EditMailAddress$updateResponseDecoder,
							$author$project$Pages$Cms$Others$EditMailAddress$CompletedAddTarget(mailId));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					cmd);
		}
	});
var $author$project$Pages$Cms$Others$GetAccessCount$SendRequestSent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Utils$Helpers$monthToInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$Utils$Helpers$formatDate = F3(
	function (year, month, day) {
		return $elm$core$String$fromInt(year) + ('-' + (A2(
			$elm$core$String$right,
			2,
			'0' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Utils$Helpers$monthToInt)(month)) + ('-' + A2(
			$elm$core$String$right,
			2,
			'0' + $elm$core$String$fromInt(day)))));
	});
var $author$project$Pages$Cms$Others$GetAccessCount$postListAddress = F2(
	function (maybeUser, model) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Cms$Others$GetAccessCount$SendResponse = F3(
	function (user_id, access_counts_each_day, access_count_total) {
		return {hb: access_count_total, hc: access_counts_each_day, iF: user_id};
	});
var $author$project$Pages$Cms$Others$GetAccessCount$AccessCountsEachDay = F2(
	function (access_count, access_date) {
		return {dl: access_count, iL: access_date};
	});
var $author$project$Pages$Cms$Others$GetAccessCount$accessCountsEachDayDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Others$GetAccessCount$AccessCountsEachDay,
	A2(
		$elm$json$Json$Decode$field,
		'access_count',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'access_date',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Others$GetAccessCount$AccessCountsTotal = function (access_count) {
	return {dl: access_count};
};
var $author$project$Pages$Cms$Others$GetAccessCount$accessCountsTotalDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Others$GetAccessCount$AccessCountsTotal,
	A2(
		$elm$json$Json$Decode$field,
		'access_count',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)));
var $author$project$Pages$Cms$Others$GetAccessCount$sendResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Cms$Others$GetAccessCount$SendResponse,
	A2(
		$elm$json$Json$Decode$field,
		'user_id',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm$json$Json$Decode$field,
		'access_counts_each_day',
		$elm$json$Json$Decode$list($author$project$Pages$Cms$Others$GetAccessCount$accessCountsEachDayDecoder)),
	A2($elm$json$Json$Decode$field, 'access_count_total', $author$project$Pages$Cms$Others$GetAccessCount$accessCountsTotalDecoder));
var $author$project$Pages$Cms$Others$GetAccessCount$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = msg.a;
				var here = _v1.a;
				var now = _v1.b;
				var year = A2($elm$time$Time$toYear, here, now);
				var oneWeekMs = (((7 * 24) * 60) * 60) * 1000;
				var month = A2($elm$time$Time$toMonth, here, now);
				var dayto = A2($elm$time$Time$toDay, here, now);
				var dayfrom = A2(
					$elm$time$Time$toDay,
					here,
					$elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(now) - oneWeekMs));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, year, month, dayfrom),
							cZ: A3($author$project$Utils$Helpers$formatDate, year, month, dayto)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cv: false, k8: initResponse.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var selectedUserStr = msg.a;
				var maybeSelectedUser = $elm$core$String$toInt(selectedUserStr);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{$9: maybeSelectedUser}),
					A2($author$project$Pages$Cms$Others$GetAccessCount$postListAddress, maybeSelectedUser, model));
			case 3:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var selectedDateTo = model.cZ;
				var selectedDateFrom = model.cY;
				var maybeSelectedUser = model.$9;
				if (!maybeSelectedUser.$) {
					var selectedUser = maybeSelectedUser.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5(
									$author$project$Api$post,
									$author$project$Endpoints$Cms$getAccessCountEndpoints.gH,
									model.C,
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'user_id',
												$elm$json$Json$Encode$int(selectedUser)),
												_Utils_Tuple2(
												'date_from',
												$elm$json$Json$Encode$string(selectedDateFrom)),
												_Utils_Tuple2(
												'date_to',
												$elm$json$Json$Encode$string(selectedDateTo))
											])),
									$author$project$Pages$Cms$Others$GetAccessCount$sendResponseDecoder,
									$author$project$Pages$Cms$Others$GetAccessCount$SendRequestSent)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just('ユーザー、日付を選択してください')
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				if (!msg.a.$) {
					var submitResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b3: submitResponse, H: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Cms$Products$AddProductConfig$CategoryRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$AddProductConfig$InsertionRequestSent = function (a) {
	return {$: 9, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$Cms$Products$AddProductConfig$CategoryResponse = F2(
	function (bigCategories, smallCategories) {
		return {iW: bigCategories, kL: smallCategories};
	});
var $author$project$Pages$Cms$Products$AddProductConfig$categoryResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Products$AddProductConfig$CategoryResponse,
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder));
var $author$project$Pages$Cms$Products$AddProductConfig$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, cE: initResponse.cE, k8: initResponse.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 6:
				var object = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'jan',
							$elm$json$Json$Encode$string(model.b4)),
							_Utils_Tuple2(
							'kataban',
							$elm$json$Json$Encode$string(model.b5)),
							_Utils_Tuple2(
							'maker',
							$elm$json$Json$Encode$int(
								A2($elm$core$Maybe$withDefault, -1, model.eh))),
							_Utils_Tuple2(
							'big_category',
							$elm$json$Json$Encode$int(
								A2($elm$core$Maybe$withDefault, -1, model.ig))),
							_Utils_Tuple2(
							'small_category',
							$elm$json$Json$Encode$int(
								A2($elm$core$Maybe$withDefault, -1, model.gD)))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b4: '', b5: ''}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$addProductConfigEndpoints.am, model.C, object, $author$project$Pages$Cms$Products$AddProductConfig$initResponseDecoder, $author$project$Pages$Cms$Products$AddProductConfig$InsertionRequestSent));
			case 9:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b4: input}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b5: input}),
					$elm$core$Platform$Cmd$none);
			case 1:
				if (!msg.a.$) {
					var categoryResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: categoryResponse.iW, hA: true, dP: false, kL: categoryResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var maybeUserId = msg.a;
				var newModel = _Utils_update(
					model,
					{gF: maybeUserId});
				if (maybeUserId.$ === 1) {
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var userId = maybeUserId.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(userId))
							]));
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$post, $author$project$Endpoints$Cms$addProductConfigEndpoints.hk, model.C, body, $author$project$Pages$Cms$Products$AddProductConfig$categoryResponseDecoder, $author$project$Pages$Cms$Products$AddProductConfig$CategoryRequestSent)
								])));
				}
		}
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$ProductsRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$UpdateProductRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$DragPorts$dragover = _Platform_outgoingPort(
	'dragover',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dropEffect',
					$elm$json$Json$Encode$string($.lZ)),
					_Utils_Tuple2(
					'event',
					$elm$core$Basics$identity($.jl))
				]));
	});
var $author$project$DragPorts$dragstart = _Platform_outgoingPort(
	'dragstart',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'effectAllowed',
					$elm$json$Json$Encode$string($.l_)),
					_Utils_Tuple2(
					'event',
					$elm$core$Basics$identity($.jl))
				]));
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$getIntervalSum = function (products) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (p) {
				return (60 / p.ju) | 0;
			},
			products));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$dropEffectToString = function (dropEffect) {
	switch (dropEffect) {
		case 0:
			return 'none';
		case 1:
			return 'move';
		case 2:
			return 'copy';
		default:
			return 'link';
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData = F2(
	function (dropEffect, value) {
		return {
			lZ: $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$dropEffectToString(dropEffect),
			jl: value
		};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$ProductsResponse = F4(
	function (products, bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$Product = F9(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus, display_intervals) {
		return {ls: basePoint, lt: basePrice, lW: display_intervals, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$productsDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'display_intervals',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$succeed(0),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(0),
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Products$ChangeDisplayInterval$Product)))))))))));
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$productsResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Cms$Products$ChangeDisplayInterval$ProductsResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Cms$Products$ChangeDisplayInterval$productsDecoder),
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$effectAllowedToString = function (eff) {
	var _v0 = _Utils_Tuple3(eff.mS, eff.lK, eff.mA);
	if (!_v0.a) {
		if (!_v0.b) {
			if (!_v0.c) {
				return 'none';
			} else {
				return 'link';
			}
		} else {
			if (!_v0.c) {
				return 'copy';
			} else {
				return 'copyLink';
			}
		}
	} else {
		if (!_v0.b) {
			if (!_v0.c) {
				return 'move';
			} else {
				return 'linkMove';
			}
		} else {
			if (!_v0.c) {
				return 'copyMove';
			} else {
				return 'all';
			}
		}
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData = F2(
	function (effectAllowed, value) {
		return {
			l_: $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$effectAllowedToString(effectAllowed),
			jl: value
		};
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $elm_community$list_extra$List$Extra$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $elm_community$list_extra$List$Extra$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_Utils_eq(index1, index2) || (index1 < 0)) {
				return l;
			} else {
				if (_Utils_cmp(index1, index2) > 0) {
					var $temp$index1 = index2,
						$temp$index2 = index1,
						$temp$l = l;
					index1 = $temp$index1;
					index2 = $temp$index2;
					l = $temp$l;
					continue swapAt;
				} else {
					var _v0 = A2($elm_community$list_extra$List$Extra$splitAt, index1, l);
					var part1 = _v0.a;
					var tail1 = _v0.b;
					var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, index2 - index1, tail1);
					var head2 = _v1.a;
					var tail2 = _v1.b;
					var _v2 = _Utils_Tuple2(
						$elm_community$list_extra$List$Extra$uncons(head2),
						$elm_community$list_extra$List$Extra$uncons(tail2));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var value1 = _v3.a;
						var part2 = _v3.b;
						var _v4 = _v2.b.a;
						var value2 = _v4.a;
						var part3 = _v4.b;
						return $elm$core$List$concat(
							_List_fromArray(
								[
									part1,
									A2($elm$core$List$cons, value2, part2),
									A2($elm$core$List$cons, value1, part3)
								]));
					} else {
						return l;
					}
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$ChangeDisplayInterval$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, k8: initResponse.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var productResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: productResponse.iW, hA: true, dP: false, cE: productResponse.cE, kn: productResponse.kn, kL: productResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ju: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 6:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Cms$Products$ChangeDisplayInterval$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 7:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 14:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var maybeUserId = msg.a;
				var newModel = _Utils_update(
					model,
					{gF: maybeUserId});
				if (maybeUserId.$ === 1) {
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var userId = maybeUserId.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(userId))
							]));
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$post, $author$project$Endpoints$Cms$changeDisplayIntervalEndpoints.kn, model.C, body, $author$project$Pages$Cms$Products$ChangeDisplayInterval$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayInterval$ProductsRequestSent)
								])));
				}
			case 8:
				var index = msg.a;
				if ($author$project$Pages$Cms$Products$ChangeDisplayInterval$getIntervalSum(model.kn) > 120) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
					if (!maybeProduct.$) {
						var product = maybeProduct.a;
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user_id',
									$elm$json$Json$Encode$int(
										A2($elm$core$Maybe$withDefault, -1, model.gF))),
									_Utils_Tuple2(
									'product',
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'product_id',
												$elm$json$Json$Encode$string(product.kl)),
												_Utils_Tuple2(
												'base_price',
												$elm$json$Json$Encode$int(product.lt)),
												_Utils_Tuple2(
												'base_point',
												$elm$json$Json$Encode$int(product.ls)),
												_Utils_Tuple2(
												'product_order',
												$elm$json$Json$Encode$int(index + 1)),
												_Utils_Tuple2(
												'yodobashi_base_price_flag',
												$elm$json$Json$Encode$bool(product.oc)),
												_Utils_Tuple2(
												'get_interval',
												$elm$json$Json$Encode$int(product.ju)),
												_Utils_Tuple2(
												'display_intervals',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, product.lW))
											])))
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{k: true}),
							A5($author$project$Api$post, $author$project$Endpoints$Cms$changeDisplayIntervalEndpoints._, model.C, body, $author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProductResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayInterval$UpdateProductRequestSent));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 9:
				if ($author$project$Pages$Cms$Products$ChangeDisplayInterval$getIntervalSum(model.kn) > 120) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(
									A2($elm$core$Maybe$withDefault, -1, model.gF))),
								_Utils_Tuple2(
								'products',
								A2(
									$elm$json$Json$Encode$list,
									function (product) {
										return $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'product_id',
													$elm$json$Json$Encode$string(product.kl)),
													_Utils_Tuple2(
													'base_price',
													$elm$json$Json$Encode$int(product.lt)),
													_Utils_Tuple2(
													'base_point',
													$elm$json$Json$Encode$int(product.ls)),
													_Utils_Tuple2(
													'product_order',
													$elm$json$Json$Encode$int(product.nl)),
													_Utils_Tuple2(
													'yodobashi_base_price_flag',
													$elm$json$Json$Encode$bool(product.oc)),
													_Utils_Tuple2(
													'get_interval',
													$elm$json$Json$Encode$int(product.ju)),
													_Utils_Tuple2(
													'display_intervals',
													A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, product.lW))
												]));
									},
									model.kn))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$Cms$changeDisplayIntervalEndpoints.iE, model.C, body, $author$project$Pages$Cms$Products$ChangeDisplayInterval$updateProductResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayInterval$UpdateProductRequestSent));
				}
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var index = msg.a;
				var display_interval = msg.b;
				var enableInterval = msg.c;
				var products = A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, product) {
							return _Utils_eq(i, index) ? (enableInterval ? _Utils_update(
								product,
								{
									lW: A2($elm$core$List$cons, display_interval, product.lW)
								}) : _Utils_update(
								product,
								{
									lW: A2(
										$elm$core$List$filter,
										function (di) {
											return !_Utils_eq(di, display_interval);
										},
										product.lW)
								})) : product;
						}),
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kn: products}),
					$elm$core$Platform$Cmd$none);
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$ProductsRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$UpdateProductRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$ProductsResponse = F4(
	function (products, bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$Product = F9(
	function (productId, productName, basePrice, basePoint, productOrder, yodobashiFlag, get_interval, dragStatus, display_intervals) {
		return {ls: basePoint, lt: basePrice, lW: display_intervals, lY: dragStatus, ju: get_interval, kl: productId, nk: productName, nl: productOrder, oc: yodobashiFlag};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$productsDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'display_intervals',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$succeed(0),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(0),
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Products$ChangeDisplayOrder$Product)))))))))));
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$productsResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Cms$Products$ChangeDisplayOrder$ProductsResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Cms$Products$ChangeDisplayOrder$productsDecoder),
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$ChangeDisplayOrder$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, k8: initResponse.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var productResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: productResponse.iW, hA: true, dP: false, cE: productResponse.cE, kn: productResponse.kn, kL: productResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Cms$Products$ChangeDisplayOrder$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 5:
				var maybeUserId = msg.a;
				var newModel = _Utils_update(
					model,
					{gF: maybeUserId});
				if (maybeUserId.$ === 1) {
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var userId = maybeUserId.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(userId)),
								_Utils_Tuple2(
								'big_category_id',
								$elm$json$Json$Encode$int(
									A2($elm$core$Maybe$withDefault, -1, model.ig)))
							]));
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$post, $author$project$Endpoints$Cms$changeDisplayOrderEndpoints.kn, model.C, body, $author$project$Pages$Cms$Products$ChangeDisplayOrder$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayOrder$ProductsRequestSent)
								])));
				}
			case 6:
				var maybeBigCategoryId = msg.a;
				var newModel = _Utils_update(
					model,
					{ig: maybeBigCategoryId});
				if (maybeBigCategoryId.$ === 1) {
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(
									A2($elm$core$Maybe$withDefault, -1, model.gF))),
								_Utils_Tuple2(
								'big_category_id',
								$elm$json$Json$Encode$int(-1))
							]));
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$post, $author$project$Endpoints$Cms$changeDisplayOrderEndpoints.kn, model.C, body, $author$project$Pages$Cms$Products$ChangeDisplayOrder$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayOrder$ProductsRequestSent)
								])));
				} else {
					var bigCategoryId = maybeBigCategoryId.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(
									A2($elm$core$Maybe$withDefault, -1, model.gF))),
								_Utils_Tuple2(
								'big_category_id',
								$elm$json$Json$Encode$int(bigCategoryId))
							]));
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$post, $author$project$Endpoints$Cms$changeDisplayOrderEndpoints.kn, model.C, body, $author$project$Pages$Cms$Products$ChangeDisplayOrder$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayOrder$ProductsRequestSent)
								])));
				}
			case 7:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'user_id',
							$elm$json$Json$Encode$int(
								A2($elm$core$Maybe$withDefault, -1, model.gF))),
							_Utils_Tuple2(
							'products',
							A2(
								$elm$json$Json$Encode$list,
								function (product) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'product_id',
												$elm$json$Json$Encode$string(product.kl)),
												_Utils_Tuple2(
												'base_price',
												$elm$json$Json$Encode$int(product.lt)),
												_Utils_Tuple2(
												'base_point',
												$elm$json$Json$Encode$int(product.ls)),
												_Utils_Tuple2(
												'product_order',
												$elm$json$Json$Encode$int(product.nl)),
												_Utils_Tuple2(
												'yodobashi_base_price_flag',
												$elm$json$Json$Encode$bool(product.oc)),
												_Utils_Tuple2(
												'get_interval',
												$elm$json$Json$Encode$int(product.ju)),
												_Utils_Tuple2(
												'display_intervals',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, product.lW))
											]));
								},
								model.kn))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$changeDisplayOrderEndpoints.iE, model.C, body, $author$project$Pages$Cms$Products$ChangeDisplayOrder$updateProductResponseDecoder, $author$project$Pages$Cms$Products$ChangeDisplayOrder$UpdateProductRequestSent));
		}
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateAllProducts = {$: 15};
var $author$project$Pages$Cms$Products$ChangeUserProduct$ProductsRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$encodeProduct = function (product) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'product_id',
				$elm$json$Json$Encode$string(product.kl)),
				_Utils_Tuple2(
				'base_price',
				$elm$json$Json$Encode$int(product.lt)),
				_Utils_Tuple2(
				'base_point',
				$elm$json$Json$Encode$int(product.ls)),
				_Utils_Tuple2(
				'product_order',
				$elm$json$Json$Encode$int(product.nl)),
				_Utils_Tuple2(
				'get_enabled',
				$elm$json$Json$Encode$bool(product.a6)),
				_Utils_Tuple2(
				'display_enabled',
				$elm$json$Json$Encode$bool(product.a_)),
				_Utils_Tuple2(
				'yodobashi_base_price_flag',
				$elm$json$Json$Encode$bool(product.oc)),
				_Utils_Tuple2(
				'week30_flag',
				$elm$json$Json$Encode$bool(product.dk)),
				_Utils_Tuple2(
				'get_interval',
				$elm$json$Json$Encode$int(product.ju)),
				_Utils_Tuple2(
				'display_intervals',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, product.lW))
			]));
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$ProductsResponse = F4(
	function (products, bigCategories, smallCategories, makers) {
		return {iW: bigCategories, cE: makers, kn: products, kL: smallCategories};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$Product = function (productId) {
	return function (productName) {
		return function (basePrice) {
			return function (basePoint) {
				return function (productOrder) {
					return function (getFlag) {
						return function (displayFlag) {
							return function (yodobashiFlag) {
								return function (week30Flag) {
									return function (get_interval) {
										return function (dragStatus) {
											return function (display_intervals) {
												return {ls: basePoint, lt: basePrice, a_: displayFlag, lW: display_intervals, lY: dragStatus, a6: getFlag, ju: get_interval, kl: productId, nk: productName, nl: productOrder, dk: week30Flag, oc: yodobashiFlag};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$productsDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'display_intervals',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$succeed(0),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(0),
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'week30_flag', $elm$json$Json$Decode$bool),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'display_enabled', $elm$json$Json$Decode$bool),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'get_enabled', $elm$json$Json$Decode$bool),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'product_order', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
													$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Products$ChangeUserProduct$Product))))))))))))));
var $author$project$Pages$Cms$Products$ChangeUserProduct$productsResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Cms$Products$ChangeUserProduct$ProductsResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Cms$Products$ChangeUserProduct$productsDecoder),
	A2($elm$json$Json$Decode$field, 'big_categories', $author$project$Utils$Decoders$bigCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'small_categories', $author$project$Utils$Decoders$smallCategoriesDecoder),
	A2($elm$json$Json$Decode$field, 'makers', $author$project$Utils$Decoders$makersDecoder));
var $author$project$Pages$Cms$Products$ChangeUserProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (_Utils_eq(ind, -1)) {
			var newProduct = f(model.ab);
			return _Utils_update(
				model,
				{ab: newProduct});
		} else {
			if (!maybeCorrespondingProduct.$) {
				var product = maybeCorrespondingProduct.a;
				var newProduct = f(product);
				var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				return _Utils_update(
					model,
					{kn: newProducts});
			} else {
				return model;
			}
		}
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					if (!msg.a.$) {
						var initResponse = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cv: false, k8: initResponse.k8}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										$author$project$Utils$Helpers$errToStr(err)),
									cv: false
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 1:
					if (!msg.a.$) {
						var productResponse = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ab: _Utils_update(
										$author$project$Pages$Cms$Products$ChangeUserProduct$initAddProduct,
										{ls: model.dx}),
									iW: productResponse.iW,
									hA: true,
									dP: false,
									cE: productResponse.cE,
									kn: productResponse.kn,
									kL: productResponse.kL
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										$author$project$Utils$Helpers$errToStr(err)),
									dP: false
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 2:
					if (!msg.a.$) {
						var updateProductResponse = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ab: _Utils_update(
										$author$project$Pages$Cms$Products$ChangeUserProduct$initAddProduct,
										{ls: model.dx}),
									k: false
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										$author$project$Utils$Helpers$errToStr(err)),
									k: false
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 4:
					var productId = msg.a;
					var addProduct = model.ab;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ab: _Utils_update(
									addProduct,
									{kl: productId})
							}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var ind = msg.a;
					var val = msg.b;
					var f = function (product) {
						return _Utils_update(
							product,
							{
								lt: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(val))
							});
					};
					return _Utils_Tuple2(
						A3($author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$none);
				case 6:
					var ind = msg.a;
					var val = msg.b;
					var f = function (product) {
						return _Utils_update(
							product,
							{
								nl: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(val))
							});
					};
					return _Utils_Tuple2(
						A3($author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$none);
				case 7:
					var ind = msg.a;
					var val = msg.b;
					var f = function (product) {
						return _Utils_update(
							product,
							{
								ju: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(val))
							});
					};
					return _Utils_Tuple2(
						A3($author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$none);
				case 8:
					var ind = msg.a;
					var newOrder = msg.b;
					return _Utils_Tuple2(
						A3(
							$author$project$Pages$Cms$Products$ChangeUserProduct$updateOrder,
							ind,
							model,
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(newOrder))),
						$elm$core$Platform$Cmd$none);
				case 5:
					var ind = msg.a;
					var val = msg.b;
					var f = function (product) {
						return _Utils_update(
							product,
							{
								ls: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(val))
							});
					};
					return _Utils_Tuple2(
						A3($author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$none);
				case 9:
					var ind = msg.a;
					var val = msg.b;
					var f = function (product) {
						return _Utils_update(
							product,
							{a6: val});
					};
					return _Utils_Tuple2(
						A3($author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$none);
				case 10:
					var ind = msg.a;
					var val = msg.b;
					var f = function (product) {
						return _Utils_update(
							product,
							{a_: val});
					};
					return _Utils_Tuple2(
						A3($author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$none);
				case 11:
					var ind = msg.a;
					var val = msg.b;
					var f = function (product) {
						return _Utils_update(
							product,
							{oc: val});
					};
					return _Utils_Tuple2(
						A3($author$project$Pages$Cms$Products$ChangeUserProduct$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$none);
				case 21:
					var ind = msg.a;
					var effectAllowed = msg.b;
					var value = msg.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(ind)
							}),
						$author$project$DragPorts$dragstart(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
				case 22:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Nothing,
								kn: A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_update(
											p,
											{lY: 0});
									},
									model.kn)
							}),
						$elm$core$Platform$Cmd$none);
				case 23:
					var destInd = msg.a;
					var dropEffect = msg.b;
					var value = msg.c;
					var _v1 = model.jg;
					if (!_v1.$) {
						var sourceInd = _v1.a;
						var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
						var products = A3(
							$elm_community$list_extra$List$Extra$swapAt,
							sourceInd,
							destInd,
							A3(
								$elm_community$list_extra$List$Extra$updateAt,
								destInd,
								function (product) {
									return _Utils_update(
										product,
										{lY: product.lY + dragStatusIncVal});
								},
								model.kn));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									jg: $elm$core$Maybe$Just(destInd),
									kn: products
								}),
							$author$project$DragPorts$dragover(
								A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
					} else {
						return _Utils_Tuple2(
							model,
							$author$project$DragPorts$dragover(
								A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
					}
				case 24:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Nothing,
								kn: A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_update(
											p,
											{lY: 0});
									},
									model.kn)
							}),
						$elm$core$Platform$Cmd$none);
				case 17:
					var maybeUserId = msg.a;
					var newDefaultPoint = _Utils_eq(
						maybeUserId,
						$elm$core$Maybe$Just(31)) ? 10 : 0;
					var newModel = _Utils_update(
						model,
						{
							ab: _Utils_update(
								$author$project$Pages$Cms$Products$ChangeUserProduct$initAddProduct,
								{ls: newDefaultPoint}),
							dx: newDefaultPoint,
							gF: maybeUserId
						});
					if (maybeUserId.$ === 1) {
						return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					} else {
						var userId = maybeUserId.a;
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user_id',
									$elm$json$Json$Encode$int(userId))
								]));
						return _Utils_Tuple2(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A5($author$project$Api$post, $author$project$Endpoints$Cms$changeUserProductEndpoints.kn, model.C, body, $author$project$Pages$Cms$Products$ChangeUserProduct$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeUserProduct$ProductsRequestSent)
									])));
					}
				case 13:
					var product = model.ab;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(
									A2($elm$core$Maybe$withDefault, -1, model.gF))),
								_Utils_Tuple2(
								'product',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'product_id',
											$elm$json$Json$Encode$string(product.kl)),
											_Utils_Tuple2(
											'base_price',
											$elm$json$Json$Encode$int(product.lt)),
											_Utils_Tuple2(
											'base_point',
											$elm$json$Json$Encode$int(product.ls)),
											_Utils_Tuple2(
											'product_order',
											$elm$json$Json$Encode$int(0)),
											_Utils_Tuple2(
											'get_enabled',
											$elm$json$Json$Encode$bool(product.a6)),
											_Utils_Tuple2(
											'display_enabled',
											$elm$json$Json$Encode$bool(product.a_)),
											_Utils_Tuple2(
											'yodobashi_base_price_flag',
											$elm$json$Json$Encode$bool(product.oc)),
											_Utils_Tuple2(
											'week30_flag',
											$elm$json$Json$Encode$bool(product.dk)),
											_Utils_Tuple2(
											'get_interval',
											$elm$json$Json$Encode$int(product.ju)),
											_Utils_Tuple2(
											'display_intervals',
											A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, product.lW))
										])))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						A5($author$project$Api$post, $author$project$Endpoints$Cms$changeUserProductEndpoints.am, model.C, body, $author$project$Pages$Cms$Products$ChangeUserProduct$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeUserProduct$ProductsRequestSent));
				case 12:
					var index = msg.a;
					var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
					if (!maybeProduct.$) {
						var product = maybeProduct.a;
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user_id',
									$elm$json$Json$Encode$int(
										A2($elm$core$Maybe$withDefault, -1, model.gF))),
									_Utils_Tuple2(
									'product',
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'product_id',
												$elm$json$Json$Encode$string(product.kl)),
												_Utils_Tuple2(
												'base_price',
												$elm$json$Json$Encode$int(product.lt)),
												_Utils_Tuple2(
												'base_point',
												$elm$json$Json$Encode$int(product.ls)),
												_Utils_Tuple2(
												'product_order',
												$elm$json$Json$Encode$int(product.nl)),
												_Utils_Tuple2(
												'get_enabled',
												$elm$json$Json$Encode$bool(product.a6)),
												_Utils_Tuple2(
												'display_enabled',
												$elm$json$Json$Encode$bool(product.a_)),
												_Utils_Tuple2(
												'yodobashi_base_price_flag',
												$elm$json$Json$Encode$bool(product.oc)),
												_Utils_Tuple2(
												'week30_flag',
												$elm$json$Json$Encode$bool(product.dk)),
												_Utils_Tuple2(
												'get_interval',
												$elm$json$Json$Encode$int(product.ju)),
												_Utils_Tuple2(
												'display_intervals',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, product.lW))
											])))
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{k: false}),
							A5($author$project$Api$post, $author$project$Endpoints$Cms$changeUserProductEndpoints._, model.C, body, $author$project$Pages$Cms$Products$ChangeUserProduct$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeUserProduct$ProductsRequestSent));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 15:
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(
									A2($elm$core$Maybe$withDefault, -1, model.gF))),
								_Utils_Tuple2(
								'products',
								A2($elm$json$Json$Encode$list, $author$project$Pages$Cms$Products$ChangeUserProduct$encodeProduct, model.kn))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						A5($author$project$Api$post, $author$project$Endpoints$Cms$changeUserProductEndpoints.iE, model.C, body, $author$project$Pages$Cms$Products$ChangeUserProduct$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeUserProduct$ProductsRequestSent));
				case 16:
					var $temp$msg = $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateAllProducts,
						$temp$model = _Utils_update(
						model,
						{
							kn: A2(
								$elm$core$List$map,
								function (product) {
									return _Utils_update(
										product,
										{ls: 0, lt: 0});
								},
								model.kn)
						});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 18:
					var bigCategoryId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ig: A2(
									$elm$core$Maybe$andThen,
									$elm$core$Maybe$Just,
									$elm$core$String$toInt(bigCategoryId))
							}),
						$elm$core$Platform$Cmd$none);
				case 19:
					var smallCategoryId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gD: A2(
									$elm$core$Maybe$andThen,
									$elm$core$Maybe$Just,
									$elm$core$String$toInt(smallCategoryId))
							}),
						$elm$core$Platform$Cmd$none);
				case 20:
					var makerId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eh: A2(
									$elm$core$Maybe$andThen,
									$elm$core$Maybe$Just,
									$elm$core$String$toInt(makerId))
							}),
						$elm$core$Platform$Cmd$none);
				case 26:
					var index = msg.a;
					var display_interval = msg.b;
					var enableInterval = msg.c;
					var products = A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, product) {
								return _Utils_eq(i, index) ? (enableInterval ? _Utils_update(
									product,
									{
										lW: A2($elm$core$List$cons, display_interval, product.lW)
									}) : _Utils_update(
									product,
									{
										lW: A2(
											$elm$core$List$filter,
											function (di) {
												return !_Utils_eq(di, display_interval);
											},
											product.lW)
									})) : product;
							}),
						model.kn);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kn: products}),
						$elm$core$Platform$Cmd$none);
				case 25:
					var point = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iR: $elm$core$String$toInt(point)
							}),
						$elm$core$Platform$Cmd$none);
				default:
					var index = msg.a;
					var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
					if (!maybeProduct.$) {
						var product = maybeProduct.a;
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user_id',
									$elm$json$Json$Encode$int(
										A2($elm$core$Maybe$withDefault, -1, model.gF))),
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl))
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{k: false}),
							A5($author$project$Api$post, $author$project$Endpoints$Cms$changeUserProductEndpoints.ie, model.C, body, $author$project$Pages$Cms$Products$ChangeUserProduct$productsResponseDecoder, $author$project$Pages$Cms$Products$ChangeUserProduct$ProductsRequestSent));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
			}
		}
	});
var $author$project$Pages$Cms$Products$EditProducts$QDelete = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$EditProducts$QInsert = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Cms$Products$EditProducts$QUpdate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$EditProducts$SendRequestSent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$Products$EditProducts$UpdateRequestSent = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$Cms$Products$EditProducts$SendResponse = function (rawProductsGeneralInformations) {
	return {kp: rawProductsGeneralInformations};
};
var $author$project$Pages$Cms$Products$EditProducts$RawProductsGeneralInformation = F5(
	function (product_id, product_name, release_date, maker_id, small_category_id) {
		return {ap: maker_id, bf: product_id, bM: product_name, gs: release_date, c6: small_category_id};
	});
var $author$project$Pages$Cms$Products$EditProducts$rawProductsGeneralInformationDecoder = $elm$json$Json$Decode$list(
	A6(
		$elm$json$Json$Decode$map5,
		$author$project$Pages$Cms$Products$EditProducts$RawProductsGeneralInformation,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'release_date',
			$elm$json$Json$Decode$maybe($rtfeldman$elm_iso8601_date_strings$Iso8601$decoder)),
		A2($elm$json$Json$Decode$field, 'maker_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'small_category_id', $elm$json$Json$Decode$int)));
var $author$project$Pages$Cms$Products$EditProducts$sendResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$EditProducts$SendResponse,
	A2($elm$json$Json$Decode$field, 'products_general_informations', $author$project$Pages$Cms$Products$EditProducts$rawProductsGeneralInformationDecoder));
var $elm_community$list_extra$List$Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $elm$core$String$trim = _String_trim;
var $author$project$Pages$Cms$Products$EditProducts$updateProductGeneralInformation = F4(
	function (index, model, f, setUpdated) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.bg);
		if (_Utils_eq(index, -1)) {
			return model;
		} else {
			if (!maybeCorrespondingProduct.$) {
				var product = maybeCorrespondingProduct.a;
				var newProduct = f(
					_Utils_update(
						product,
						{R: setUpdated}));
				var newProducts = A3($elm_community$list_extra$List$Extra$setAt, index, newProduct, model.bg);
				return _Utils_update(
					model,
					{bg: newProducts});
			} else {
				return model;
			}
		}
	});
var $author$project$Pages$Cms$Products$EditProducts$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Products$EditProducts$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$EditProducts$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Pages$Cms$Products$EditProducts$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					var small_categories = initResponse.kM;
					var scid2cname = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (sc) {
								return _Utils_Tuple2(sc.c6, sc.e4);
							},
							small_categories));
					var makers = initResponse.cE;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fB: false, cE: makers, gz: scid2cname, kL: small_categories}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dK: $elm$core$String$trim(input)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dL: $elm$core$String$trim(input)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var object = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'product_id',
							$elm$json$Json$Encode$string(model.dK)),
							_Utils_Tuple2(
							'product_name',
							$elm$json$Json$Encode$string(model.dL))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fI: true}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$editProductsEndpoints.gH, model.C, object, $author$project$Pages$Cms$Products$EditProducts$sendResponseDecoder, $author$project$Pages$Cms$Products$EditProducts$SendRequestSent));
			case 6:
				if (!msg.a.$) {
					var response = msg.a.a;
					var gather = F2(
						function (rpgis, processed) {
							gather:
							while (true) {
								if (!rpgis.b) {
									return processed;
								} else {
									var rpgi = rpgis.a;
									var rest = rpgis.b;
									var sameProduct = function (r) {
										return _Utils_eq(r.bf, rpgi.bf);
									};
									var pgi = {
										R: false,
										ap: rpgi.ap,
										bf: rpgi.bf,
										bM: rpgi.bM,
										gs: rpgi.gs,
										t: $elm$core$Dict$fromList(
											A2(
												$elm$core$List$map,
												function (r) {
													var scid = r.c6;
													var cname = A2(
														$elm$core$Maybe$withDefault,
														'',
														A2($elm$core$Dict$get, scid, model.gz));
													return _Utils_Tuple2(
														cname,
														A2($author$project$Pages$Cms$Products$EditProducts$QUpdate, scid, scid));
												},
												A2($elm_community$list_extra$List$Extra$takeWhile, sameProduct, rpgis)))
									};
									var $temp$rpgis = A2($elm_community$list_extra$List$Extra$dropWhile, sameProduct, rest),
										$temp$processed = A2($elm$core$List$cons, pgi, processed);
									rpgis = $temp$rpgis;
									processed = $temp$processed;
									continue gather;
								}
							}
						});
					var newModel = _Utils_update(
						model,
						{
							bg: A2(gather, response.kp, _List_Nil)
						});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var selected = msg.a;
				if (selected.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var id = selected.a;
					switch (id) {
						case 0:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{fE: false}),
								$elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{fE: true}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 9:
				var index = msg.a;
				var productName = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{bM: productName});
				};
				return _Utils_Tuple2(
					A4($author$project$Pages$Cms$Products$EditProducts$updateProductGeneralInformation, index, model, f, true),
					$elm$core$Platform$Cmd$none);
			case 10:
				var index = msg.a;
				var makerId = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{ap: makerId});
				};
				return _Utils_Tuple2(
					A4($author$project$Pages$Cms$Products$EditProducts$updateProductGeneralInformation, index, model, f, true),
					$elm$core$Platform$Cmd$none);
			case 11:
				var index = msg.a;
				var category_name = msg.b;
				var new_small_category_id = msg.c;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							t: function () {
								var _v4 = A2($elm$core$Dict$get, category_name, product.t);
								if (!_v4.$) {
									var old = _v4.a;
									if (!new_small_category_id.$) {
										var newId = new_small_category_id.a;
										switch (old.$) {
											case 0:
												return A3(
													$elm$core$Dict$insert,
													category_name,
													$author$project$Pages$Cms$Products$EditProducts$QInsert(newId),
													product.t);
											case 1:
												var oldId = old.a;
												return A3(
													$elm$core$Dict$insert,
													category_name,
													A2($author$project$Pages$Cms$Products$EditProducts$QUpdate, oldId, newId),
													product.t);
											default:
												var oldId = old.a;
												return A3(
													$elm$core$Dict$insert,
													category_name,
													A2($author$project$Pages$Cms$Products$EditProducts$QUpdate, oldId, newId),
													product.t);
										}
									} else {
										switch (old.$) {
											case 0:
												return A2($elm$core$Dict$remove, category_name, product.t);
											case 1:
												var oldId = old.a;
												return A3(
													$elm$core$Dict$insert,
													category_name,
													$author$project$Pages$Cms$Products$EditProducts$QDelete(oldId),
													product.t);
											default:
												return product.t;
										}
									}
								} else {
									if (!new_small_category_id.$) {
										var newId = new_small_category_id.a;
										return A3(
											$elm$core$Dict$insert,
											category_name,
											$author$project$Pages$Cms$Products$EditProducts$QInsert(newId),
											product.t);
									} else {
										return product.t;
									}
								}
							}()
						});
				};
				return _Utils_Tuple2(
					A4($author$project$Pages$Cms$Products$EditProducts$updateProductGeneralInformation, index, model, f, true),
					$elm$core$Platform$Cmd$none);
			case 12:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.bg);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var queries = $elm$core$Dict$values(product.t);
					var encodeQuery = function (query) {
						switch (query.$) {
							case 0:
								var newId = query.a;
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'tag',
											$elm$json$Json$Encode$string('Insert')),
											_Utils_Tuple2(
											'newId',
											$elm$json$Json$Encode$int(newId))
										]));
							case 1:
								var oldId = query.a;
								var newId = query.b;
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'tag',
											$elm$json$Json$Encode$string('Update')),
											_Utils_Tuple2(
											'oldId',
											$elm$json$Json$Encode$int(oldId)),
											_Utils_Tuple2(
											'newId',
											$elm$json$Json$Encode$int(newId))
										]));
							default:
								var oldId = query.a;
								return $elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'tag',
											$elm$json$Json$Encode$string('Delete')),
											_Utils_Tuple2(
											'oldId',
											$elm$json$Json$Encode$int(oldId))
										]));
						}
					};
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.bf)),
								_Utils_Tuple2(
								'product_name',
								$elm$json$Json$Encode$string(product.bM)),
								_Utils_Tuple2(
								'maker_id',
								$elm$json$Json$Encode$int(product.ap)),
								_Utils_Tuple2(
								'small_category_queries',
								A2($elm$json$Json$Encode$list, encodeQuery, queries))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g_: true}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editProductsEndpoints._,
							model.C,
							body,
							$author$project$Pages$Cms$Products$EditProducts$updateResponseDecoder,
							$author$project$Pages$Cms$Products$EditProducts$UpdateRequestSent(index)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (!msg.b.$) {
					var index = msg.a;
					var updateResponse = msg.b.a;
					var dictFilterMap = F2(
						function (f, dict) {
							return $elm$core$Dict$fromList(
								A2(
									$elm$core$List$filterMap,
									function (_v13) {
										var k = _v13.a;
										var v = _v13.b;
										return A2(
											$elm$core$Maybe$map,
											function (v2) {
												return _Utils_Tuple2(k, v2);
											},
											A2(f, k, v));
									},
									$elm$core$Dict$toList(dict)));
						});
					var newmodel = A4(
						$author$project$Pages$Cms$Products$EditProducts$updateProductGeneralInformation,
						index,
						model,
						function (pgi) {
							return _Utils_update(
								pgi,
								{
									t: A2(
										dictFilterMap,
										F2(
											function (_v11, query) {
												switch (query.$) {
													case 0:
														var newId = query.a;
														return $elm$core$Maybe$Just(
															A2($author$project$Pages$Cms$Products$EditProducts$QUpdate, newId, newId));
													case 1:
														var oldId = query.a;
														var newId = query.b;
														return $elm$core$Maybe$Just(
															A2($author$project$Pages$Cms$Products$EditProducts$QUpdate, newId, newId));
													default:
														return $elm$core$Maybe$Nothing;
												}
											}),
										pgi.t)
								});
						},
						false);
					return _Utils_Tuple2(
						_Utils_update(
							newmodel,
							{g_: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var index = msg.a;
					var e = msg.b.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$InvalidInput = 0;
var $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeStore = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeUserId = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$SendRequestSent = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode = F3(
	function (a, b, searchMode) {
		if (!searchMode) {
			return a;
		} else {
			return b;
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $inkuzmin$elm_multiselect$Multiselect$getSelectedValues = function (_v0) {
	var model = _v0;
	return model.kC;
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$getSelectedStoreIds = function (multiselectStores) {
	return A2(
		$elm$core$List$map,
		function (t) {
			return A2(
				$elm$core$Maybe$withDefault,
				-1,
				$elm$core$String$toInt(t.a));
		},
		$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(multiselectStores));
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$filterBySelectedStores = F3(
	function (permalinkInfos, stores, multiselectStores) {
		var selectedStoreIds = $author$project$Pages$Cms$Products$EditProductsPermalinks$getSelectedStoreIds(multiselectStores);
		var selectedStores = A2(
			$elm$core$Dict$filter,
			F2(
				function (_v0, item) {
					return A2($elm$core$List$member, item.gM, selectedStoreIds);
				}),
			stores);
		var selectedPermalinkGroupIds = A2(
			$elm$core$List$filterMap,
			function (store) {
				return store.U;
			},
			$elm$core$Dict$values(selectedStores));
		return A2(
			$elm$core$List$filter,
			function (permalinkInfo) {
				return A2($elm$core$List$member, permalinkInfo.at.U, selectedPermalinkGroupIds);
			},
			permalinkInfos);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$userStoresToPermalinkGroupIds = F2(
	function (userStores, stores) {
		var getPermalinkGroupId = function (userStore) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.U;
					},
					A2($elm$core$Dict$get, userStore.iw, stores)));
		};
		return $elm$core$Set$toList(
			$elm$core$Set$fromList(
				A2($elm$core$List$map, getPermalinkGroupId, userStores)));
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$filterBySelectedUserStores = F4(
	function (permalinkInfos, stores, userStores, hasQ10) {
		var selectedList = A2($author$project$Pages$Cms$Products$EditProductsPermalinks$userStoresToPermalinkGroupIds, userStores, stores);
		var selectedListWithRakutenAmazonQ10 = hasQ10 ? _Utils_ap(
			selectedList,
			_List_fromArray(
				[12, 2, 103])) : _Utils_ap(
			selectedList,
			_List_fromArray(
				[12, 2]));
		return A2(
			$elm$core$List$filter,
			function (permalinkInfo) {
				return A2($elm$core$List$member, permalinkInfo.at.U, selectedListWithRakutenAmazonQ10);
			},
			permalinkInfos);
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$filterMall = function (stores) {
	var malls = _List_fromArray(
		['Rakuten', 'Yahoo', 'Ymall', 'auPay', 'Q10', 'PayPay']);
	var isInSomeMall = F2(
		function (store, mallName) {
			var _v0 = store.jd;
			if (!_v0.$) {
				var storeName = _v0.a;
				return (!A2($elm$core$String$contains, 'リスト', storeName)) && A2($elm$core$String$contains, mallName, storeName);
			} else {
				return false;
			}
		});
	return A3(
		$elm$core$List$foldl,
		F2(
			function (mall, acc) {
				return A2(
					$elm$core$Dict$filter,
					F2(
						function (key, store) {
							return !A2(isInSomeMall, store, mall);
						}),
					acc);
			}),
		stores,
		malls);
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$filterMallU = F2(
	function (model, userStores) {
		var searchMode = model.bh;
		var rakuten = {
			fh: $elm$core$Maybe$Just('楽天リスト'),
			jr: false,
			js: $elm$core$Maybe$Nothing,
			R: false,
			iv: 3,
			kR: '楽天',
			iw: 99,
			kS: 'Rakuten (楽天リスト)',
			kT: -1
		};
		var malls = A3(
			$author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode,
			_List_fromArray(
				['Rakuten', 'Yahoo', 'Ymall', 'Amazon', 'auPay', 'Q10', 'PayPay']),
			_List_fromArray(
				['Yahoo', 'Ymall', 'Amazon', 'auPay', 'Q10', 'PayPay']),
			searchMode);
		var isInSomeMallU = F2(
			function (userStore, mallName) {
				var _v1 = userStore.fh;
				if (!_v1.$) {
					var storeName = _v1.a;
					return (!A2($elm$core$String$contains, 'リスト', storeName)) && A2($elm$core$String$contains, mallName, storeName);
				} else {
					return false;
				}
			});
		var hasRakutenMall = A2(
			$elm$core$List$any,
			function (us) {
				var _v0 = us.fh;
				if (!_v0.$) {
					var storeName = _v0.a;
					return A2($elm$core$String$contains, 'Rakuten', storeName);
				} else {
					return false;
				}
			},
			userStores);
		var filtered = A3(
			$elm$core$List$foldl,
			F2(
				function (mall, acc) {
					return A2(
						$elm$core$List$filter,
						function (store) {
							return (store.iw === 9) || (!A2(isInSomeMallU, store, mall));
						},
						acc);
				}),
			userStores,
			malls);
		return A3(
			$author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode,
			filtered,
			hasRakutenMall ? A2($elm$core$List$cons, rakuten, filtered) : filtered,
			searchMode);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected = function (_v0) {
	var selected = _v0.kC;
	var values = _v0.w;
	return A2(
		$elm$core$List$filter,
		function (value) {
			return !A2($elm$core$List$member, value, selected);
		},
		values);
};
var $inkuzmin$elm_multiselect$Multiselect$populateValues = F3(
	function (_v0, values, selected) {
		var model = _v0;
		var filtered = $elm$core$List$isEmpty(selected) ? values : $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected(
			{kC: selected, w: values});
		return _Utils_update(
			model,
			{n: filtered, kC: selected, w: values});
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$SendListUserStoresRequestSent = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$UserStoresResponse = function (userStores) {
	return {b$: userStores};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$UserStore = F9(
	function (storeId, storeName, storeGroupId, displayName, storeOrder, storeGroupName, getInterval, getEnabled, isUpdated) {
		return {fh: displayName, jr: getEnabled, js: getInterval, R: isUpdated, iv: storeGroupId, kR: storeGroupName, iw: storeId, kS: storeName, kT: storeOrder};
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Products$EditProductsPermalinks$UserStore)))))))))));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$listUserStoresResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$EditProductsPermalinks$UserStoresResponse,
	A2($elm$json$Json$Decode$field, 'userStores', $author$project$Pages$Cms$Products$EditProductsPermalinks$userStoresDecoder));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$postListStores = F2(
	function (userId, model) {
		return A5(
			$author$project$Api$post,
			$author$project$Endpoints$Cms$editProductsPermalinksEndpoints.hS,
			model.C,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'user_id',
						$elm$json$Json$Encode$int(userId))
					])),
			$author$project$Pages$Cms$Products$EditProductsPermalinks$listUserStoresResponseDecoder,
			$author$project$Pages$Cms$Products$EditProductsPermalinks$SendListUserStoresRequestSent);
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$SendResponse = function (permalinkInfos) {
	return {s: permalinkInfos};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$PermalinkInfo = F4(
	function (product, permalink_group, permalink, url) {
		return {ga: permalink, at: permalink_group, bL: product, eD: url};
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$PermalinkGroup = F2(
	function (permalink_group_id, permalink_group_name) {
		return {U: permalink_group_id, j8: permalink_group_name};
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$permalinkGroupDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Products$EditProductsPermalinks$PermalinkGroup,
	A2($elm$json$Json$Decode$field, 'permalink_group_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'permalink_group_name', $elm$json$Json$Decode$string));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$Product = F2(
	function (product_id, product_name) {
		return {bf: product_id, bM: product_name};
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$productDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Cms$Products$EditProductsPermalinks$Product,
	A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$permalinkInfoDecoder = $elm$json$Json$Decode$list(
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Pages$Cms$Products$EditProductsPermalinks$PermalinkInfo,
		A2($elm$json$Json$Decode$field, 'product', $author$project$Pages$Cms$Products$EditProductsPermalinks$productDecoder),
		A2($elm$json$Json$Decode$field, 'permalink_group', $author$project$Pages$Cms$Products$EditProductsPermalinks$permalinkGroupDecoder),
		A2($elm$json$Json$Decode$field, 'permalink', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string)));
var $author$project$Pages$Cms$Products$EditProductsPermalinks$sendResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$EditProductsPermalinks$SendResponse,
	A2($elm$json$Json$Decode$field, 'permalinkInfos', $author$project$Pages$Cms$Products$EditProductsPermalinks$permalinkInfoDecoder));
var $elm$core$List$sortBy = _List_sortBy;
var $inkuzmin$elm_multiselect$Multiselect$Cleared = {$: 2};
var $inkuzmin$elm_multiselect$Multiselect$DisableProtection = {$: 3};
var $inkuzmin$elm_multiselect$Multiselect$FocusResult = function (a) {
	return {$: 8, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Hide = 1;
var $inkuzmin$elm_multiselect$Multiselect$NotFound = function (a) {
	return {$: 3, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$ScrollResult = function (a) {
	return {$: 9, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$ScrollY = function (a) {
	return {$: 14, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Selected = function (a) {
	return {$: 0, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Unselected = function (a) {
	return {$: 1, a: a};
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace = 8;
var $elm$core$Process$sleep = _Process_sleep;
var $inkuzmin$elm_multiselect$Multiselect$delayInMs = F2(
	function (ms, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(ms));
	});
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $inkuzmin$elm_multiselect$Multiselect$domScrollToY = F2(
	function (id, y) {
		return A2(
			$elm$core$Task$andThen,
			function (vp) {
				return A3($elm$browser$Browser$Dom$setViewportOf, id, vp.la.n8, y);
			},
			$elm$browser$Browser$Dom$getViewportOf(id));
	});
var $inkuzmin$elm_multiselect$Multiselect$domScrollY = function (id) {
	return A2(
		$elm$core$Task$map,
		function (vp) {
			return vp.la.n9;
		},
		$elm$browser$Browser$Dom$getViewportOf(id));
};
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow = 40;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$end = 35;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$escape = 27;
var $inkuzmin$elm_multiselect$Multiselect$fitViewPort = F2(
	function (_v0, _v1) {
		var top = _v0.a;
		var bottom = _v0.b;
		var vpTop = _v1.a;
		var vpBottom = _v1.b;
		return (_Utils_cmp(top, vpTop) < 0) ? top : ((_Utils_cmp(bottom, vpBottom) > 0) ? (vpTop + (bottom - vpBottom)) : vpTop);
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight = 32;
var $inkuzmin$elm_multiselect$Multiselect$getBoundaries = function (i) {
	return _Utils_Tuple2(i * $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight, (i * $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight) + $inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight);
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight = 200;
var $inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries = function (i) {
	return _Utils_Tuple2(i, i + $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight);
};
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$home = 36;
var $inkuzmin$elm_multiselect$Multiselect$indexOf = F2(
	function (el, list) {
		var helper = F2(
			function (l, index) {
				helper:
				while (true) {
					if (!l.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var xs = l.b;
						if (_Utils_eq(x, el)) {
							return $elm$core$Maybe$Just(index);
						} else {
							var $temp$l = xs,
								$temp$index = index + 1;
							l = $temp$l;
							index = $temp$index;
							continue helper;
						}
					}
				}
			});
		return A2(helper, list, 0);
	});
var $inkuzmin$elm_multiselect$Multiselect$lastElem = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$always),
	$elm$core$Maybe$Nothing);
var $inkuzmin$elm_multiselect$Multiselect$nextItem = F2(
	function (list, item) {
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? $elm$core$List$head(list) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $inkuzmin$elm_multiselect$Multiselect$nextSelectedItem = F2(
	function (list, item) {
		var takeLast = function (l) {
			if (!l.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				if (!l.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v3 = l.b;
					var y = _v3.a;
					return $elm$core$Maybe$Just(y);
				}
			}
		};
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? takeLast(
							$elm$core$List$reverse(list)) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown = 34;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp = 33;
var $inkuzmin$elm_multiselect$Multiselect$prevItem = F2(
	function (list, item) {
		return A2(
			$inkuzmin$elm_multiselect$Multiselect$nextItem,
			$elm$core$List$reverse(list),
			item);
	});
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$return = 13;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$tab = 9;
var $elm$core$String$toLower = _String_toLower;
var $inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow = 38;
var $inkuzmin$elm_multiselect$Multiselect$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			case 4:
				return (model.al === 2) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{al: 0}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.A))
							])),
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{al: 2}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.A))
							])),
					$elm$core$Maybe$Nothing);
			case 1:
				return model.aL ? _Utils_Tuple3(
					_Utils_update(
						model,
						{aL: false}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{al: 0}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aL: false}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 2:
				return model.aL ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{aL: true, al: 2}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.A)),
								A2($inkuzmin$elm_multiselect$Multiselect$delayInMs, 100, $inkuzmin$elm_multiselect$Multiselect$DisableProtection)
							])),
					$elm$core$Maybe$Nothing);
			case 9:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bv: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					var _v3 = model.jH;
					if (_v3.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									jH: $elm$core$Maybe$Just('')
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bv: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					}
				}
			case 8:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bv: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					var _v5 = model.jH;
					if (_v5.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									jH: $elm$core$Maybe$Just('')
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bv: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					}
				}
			case 11:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hJ: value}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 10:
				var value = msg.a;
				if (model.aL) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aL: false}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					var lowerValue = $elm$core$String$toLower(value);
					var valuesMatchingSearch = A2(
						$elm$core$List$filter,
						function (_v8) {
							var val = _v8.b;
							return A2(
								$elm$core$String$contains,
								lowerValue,
								$elm$core$String$toLower(val));
						},
						model.w);
					var maybePrefixedWithValue = ((model.hI === 1) || ((value === '') || A2(
						$elm$core$List$any,
						function (_v7) {
							var val = _v7.b;
							return _Utils_eq(
								$elm$core$String$toLower(val),
								value);
						},
						valuesMatchingSearch))) ? valuesMatchingSearch : A2(
						$elm$core$List$cons,
						_Utils_Tuple2(value, value),
						valuesMatchingSearch);
					var filtered = $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected(
						{kC: model.kC, w: maybePrefixedWithValue});
					var _v6 = model.o;
					if (_v6.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									n: filtered,
									o: $elm$core$List$head(filtered),
									jH: $elm$core$Maybe$Just(value),
									al: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v6.a;
						return (!$elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (i) {
									return _Utils_eq(i, item);
								},
								filtered))) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									n: filtered,
									o: $elm$core$List$head(filtered),
									jH: $elm$core$Maybe$Just(value),
									al: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									n: filtered,
									jH: $elm$core$Maybe$Just(value),
									al: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					}
				}
			case 5:
				var item = msg.a;
				var selected = _Utils_ap(
					model.kC,
					_List_fromArray(
						[item]));
				var filtered = $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected(
					{kC: selected, w: model.w});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							n: filtered,
							o: A2($inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.n, item),
							jH: $elm$core$Maybe$Nothing,
							kC: selected,
							al: $elm$core$List$isEmpty(filtered) ? 0 : 2
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.A))
							])),
					$elm$core$Maybe$Just(
						$inkuzmin$elm_multiselect$Multiselect$Selected(item)));
			case 6:
				var item = msg.a;
				var selected = A2(
					$elm$core$List$filter,
					function (value) {
						return !_Utils_eq(value, item);
					},
					model.kC);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							n: $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected(
								{kC: selected, w: model.w}),
							o: $elm$core$Maybe$Just(item),
							kC: selected
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$ScrollY,
								$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.A))
							])),
					$elm$core$Maybe$Just(
						$inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
			case 7:
				var selected = _List_Nil;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							n: $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected(
								{kC: selected, w: model.w}),
							jH: $elm$core$Maybe$Nothing,
							kC: selected,
							al: 0
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$inkuzmin$elm_multiselect$Multiselect$FocusResult,
								$elm$browser$Browser$Dom$focus('multiselectInput' + model.A))
							])),
					$elm$core$Maybe$Just($inkuzmin$elm_multiselect$Multiselect$Cleared));
			case 12:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							o: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			case 14:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bv: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					var y = result.a;
					var _v10 = model.o;
					if (_v10.$ === 1) {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					} else {
						var item = _v10.a;
						var _v11 = A2($inkuzmin$elm_multiselect$Multiselect$indexOf, item, model.n);
						if (_v11.$ === 1) {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						} else {
							var idx = _v11.a;
							var vpBoundaries = $inkuzmin$elm_multiselect$Multiselect$getViewPortBoundaries(y);
							var boundaries = $inkuzmin$elm_multiselect$Multiselect$getBoundaries(idx);
							var scroll = A2($inkuzmin$elm_multiselect$Multiselect$fitViewPort, boundaries, vpBoundaries);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bv: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$inkuzmin$elm_multiselect$Multiselect$ScrollResult,
											A2($inkuzmin$elm_multiselect$Multiselect$domScrollToY, 'multiselectMenu' + model.A, scroll))
										])),
								$elm$core$Maybe$Nothing);
						}
					}
				}
			default:
				var key = msg.a;
				if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow)) {
					var _v12 = model.o;
					if (_v12.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									o: $elm$core$List$head(model.n)
								}),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v12.a;
						var prev = A2($inkuzmin$elm_multiselect$Multiselect$prevItem, model.n, item);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{o: prev}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$attempt,
										$inkuzmin$elm_multiselect$Multiselect$ScrollY,
										$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.A))
									])),
							$elm$core$Maybe$Nothing);
					}
				} else {
					if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) {
						var _v13 = model.o;
						if (_v13.$ === 1) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										o: $elm$core$List$head(model.n)
									}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Nothing);
						} else {
							var item = _v13.a;
							var next = A2($inkuzmin$elm_multiselect$Multiselect$nextItem, model.n, item);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{o: next}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$inkuzmin$elm_multiselect$Multiselect$ScrollY,
											$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.A))
										])),
								$elm$core$Maybe$Nothing);
						}
					} else {
						if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageUp) || _Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$home)) {
							var first = $elm$core$List$head(model.n);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{o: first}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Task$attempt,
											$inkuzmin$elm_multiselect$Multiselect$ScrollY,
											$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.A))
										])),
								$elm$core$Maybe$Nothing);
						} else {
							if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$pageDown) || _Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$end)) {
								var last = $inkuzmin$elm_multiselect$Multiselect$lastElem(model.n);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{o: last}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$core$Task$attempt,
												$inkuzmin$elm_multiselect$Multiselect$ScrollY,
												$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.A))
											])),
									$elm$core$Maybe$Nothing);
							} else {
								if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$return) && ((model.al === 2) || $elm$core$List$isEmpty(model.n))) {
									var _v14 = model.o;
									if (_v14.$ === 1) {
										var _v15 = model.jH;
										if (_v15.$ === 1) {
											return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
										} else {
											if (_v15.a === '') {
												return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
											} else {
												var input_ = _v15.a;
												return _Utils_Tuple3(
													model,
													$elm$core$Platform$Cmd$none,
													$elm$core$Maybe$Just(
														$inkuzmin$elm_multiselect$Multiselect$NotFound(input_)));
											}
										}
									} else {
										var _v16 = _v14.a;
										var id = _v16.a;
										var val = _v16.b;
										var lowerVal = $elm$core$String$toLower(val);
										if ((!model.hI) && (_Utils_eq(
											$elm$core$Maybe$Just(val),
											model.jH) && A2(
											$elm$core$List$all,
											function (_v17) {
												var value = _v17.b;
												return !_Utils_eq(
													$elm$core$String$toLower(value),
													lowerVal);
											},
											model.w))) {
											return _Utils_Tuple3(
												model,
												$elm$core$Platform$Cmd$none,
												$elm$core$Maybe$Just(
													$inkuzmin$elm_multiselect$Multiselect$NotFound(val)));
										} else {
											var item = _Utils_Tuple2(id, val);
											var selected = _Utils_ap(
												model.kC,
												_List_fromArray(
													[item]));
											var filtered = $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected(
												{kC: selected, w: model.w});
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{
														n: filtered,
														o: A2($inkuzmin$elm_multiselect$Multiselect$nextSelectedItem, model.n, item),
														jH: $elm$core$Maybe$Nothing,
														kC: selected,
														al: $elm$core$List$isEmpty(filtered) ? 0 : 2
													}),
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2(
															$elm$core$Task$attempt,
															$inkuzmin$elm_multiselect$Multiselect$FocusResult,
															$elm$browser$Browser$Dom$focus('multiselectInput' + model.A))
														])),
												$elm$core$Maybe$Just(
													$inkuzmin$elm_multiselect$Multiselect$Selected(item)));
										}
									}
								} else {
									if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$escape)) {
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{aL: true, al: 0}),
											$elm$core$Platform$Cmd$none,
											$elm$core$Maybe$Nothing);
									} else {
										if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$tab)) {
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{al: 0}),
												$elm$core$Platform$Cmd$none,
												$elm$core$Maybe$Nothing);
										} else {
											if (_Utils_eq(key, $inkuzmin$elm_multiselect$Multiselect$Keycodes$backspace)) {
												var _v18 = model.jH;
												if ((!_v18.$) && (_v18.a === '')) {
													var _v19 = $inkuzmin$elm_multiselect$Multiselect$lastElem(model.kC);
													if (_v19.$ === 1) {
														return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
													} else {
														var item = _v19.a;
														var selected = A2(
															$elm$core$List$filter,
															function (value) {
																return !_Utils_eq(value, item);
															},
															model.kC);
														return _Utils_Tuple3(
															_Utils_update(
																model,
																{
																	n: $inkuzmin$elm_multiselect$Multiselect$valuesWithoutSelected(
																		{kC: selected, w: model.w}),
																	o: $elm$core$Maybe$Just(item),
																	kC: selected
																}),
															$elm$core$Platform$Cmd$batch(
																_List_fromArray(
																	[
																		A2(
																		$elm$core$Task$attempt,
																		$inkuzmin$elm_multiselect$Multiselect$ScrollY,
																		$inkuzmin$elm_multiselect$Multiselect$domScrollY('multiselectMenu' + model.A))
																	])),
															$elm$core$Maybe$Just(
																$inkuzmin$elm_multiselect$Multiselect$Unselected(item)));
													}
												} else {
													return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
												}
											} else {
												return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
											}
										}
									}
								}
							}
						}
					}
				}
		}
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$updatePermalink = F3(
	function (index, model, f) {
		var targetPermalinkInfo = A2(
			$elm_community$list_extra$List$Extra$getAt,
			index,
			$elm$core$List$isEmpty(
				$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? (model.ad ? model.aj : model.s) : A3($author$project$Pages$Cms$Products$EditProductsPermalinks$filterBySelectedStores, model.s, model.aN, model.p));
		var sameProduct = F2(
			function (pi1, pi2) {
				return _Utils_eq(pi1.bL.bf, pi2.bL.bf);
			});
		var samePermalinkGroup = F2(
			function (pi1, pi2) {
				return _Utils_eq(pi1.at.U, pi2.at.U);
			});
		var maybeCorrespondingPermalinkInfo = A2(
			$elm$core$Maybe$andThen,
			function (target) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (pi) {
							return A2(samePermalinkGroup, pi, target) && A2(sameProduct, pi, target);
						},
						model.s));
			},
			targetPermalinkInfo);
		if (!maybeCorrespondingPermalinkInfo.$) {
			var permalinkInfo = maybeCorrespondingPermalinkInfo.a;
			var newPermaLinkInfo = f(permalinkInfo);
			var updatePermalinkInfos = function (permalinkInfos) {
				return A2(
					$elm$core$List$map,
					function (pi) {
						if (!targetPermalinkInfo.$) {
							var target = targetPermalinkInfo.a;
							return (A2(samePermalinkGroup, pi, target) && A2(sameProduct, pi, target)) ? newPermaLinkInfo : pi;
						} else {
							return pi;
						}
					},
					permalinkInfos);
			};
			var newPermaLinkInfos = updatePermalinkInfos(model.s);
			var newSelectedUserPermalinkInfos = updatePermalinkInfos(model.aj);
			return _Utils_update(
				model,
				{s: newPermaLinkInfos, aj: newSelectedUserPermalinkInfos});
		} else {
			return model;
		}
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					var filteredStores = $author$project$Pages$Cms$Products$EditProductsPermalinks$filterMall(initResponse.aN);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fB: false,
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.gM),
												A2($elm$core$Maybe$withDefault, '', s.el));
										},
										A2(
											$elm$core$List$sortBy,
											function (s) {
												return A2($elm$core$Maybe$withDefault, '', s.el);
											},
											$elm$core$Dict$values(filteredStores))),
									_List_Nil),
								aN: filteredStores,
								k8: initResponse.k8
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k8: response.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k8: response.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c$: $elm$core$String$trim(input)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c0: $elm$core$String$trim(input)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var maybeUserId = msg.a;
				var selectedUserPermalinkInfos = model.aj;
				var searchMode = model.bh;
				var permalinkInfos = model.s;
				var newModel = _Utils_update(
					model,
					{
						s: A3($author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode, permalinkInfos, _List_Nil, searchMode),
						gF: maybeUserId,
						aj: A3($author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode, selectedUserPermalinkInfos, _List_Nil, searchMode)
					});
				if (maybeUserId.$ === 1) {
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{ad: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var userId = maybeUserId.a;
					return _Utils_Tuple2(
						_Utils_update(
							newModel,
							{
								ad: !_Utils_eq(userId, -1)
							}),
						A2($author$project$Pages$Cms$Products$EditProductsPermalinks$postListStores, userId, newModel));
				}
			case 6:
				var userId = function () {
					var _v2 = model.gF;
					if (!_v2.$) {
						var x = _v2.a;
						return x;
					} else {
						return -1;
					}
				}();
				var storeIds = $author$project$Pages$Cms$Products$EditProductsPermalinks$getSelectedStoreIds(model.p);
				var searchMode = model.bh;
				var productName = model.c0;
				var productId = model.c$;
				var object = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'product_id',
							$elm$json$Json$Encode$string(productId)),
							_Utils_Tuple2(
							'product_name',
							$elm$json$Json$Encode$string(productName)),
							_Utils_Tuple2(
							'user_id',
							$elm$json$Json$Encode$int(userId)),
							_Utils_Tuple2(
							'selected_stores',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, storeIds)),
							_Utils_Tuple2(
							'search_mode',
							$elm$json$Json$Encode$int(
								A3($author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode, 0, 1, searchMode)))
						]));
				var guard = A3(
					$author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode,
					(productId === '%') && (productName === '%'),
					_Utils_eq(userId, -1) || $elm$core$List$isEmpty(storeIds),
					searchMode);
				return guard ? _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cW: $elm$core$Maybe$Just(0)
						}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{fI: true, cW: $elm$core$Maybe$Nothing}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$editProductsPermalinksEndpoints.gH, model.C, object, $author$project$Pages$Cms$Products$EditProductsPermalinks$sendResponseDecoder, $author$project$Pages$Cms$Products$EditProductsPermalinks$SendRequestSent));
			case 7:
				if (!msg.a.$) {
					var response = msg.a.a;
					var newModel = _Utils_update(
						model,
						{s: response.s});
					var _v3 = _Utils_Tuple2(model.bh, model.gF);
					if ((!_v3.a) && (!_v3.b.$)) {
						var _v4 = _v3.a;
						var userId = _v3.b.a;
						return _Utils_Tuple2(
							newModel,
							A2(
								$elm$core$Task$perform,
								function (_v5) {
									return $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeUserId(
										$elm$core$Maybe$Just(userId));
								},
								$elm$core$Task$succeed(0)));
					} else {
						return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
					}
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				if (!msg.a.$) {
					var response = msg.a.a;
					var newUserStores = A2($author$project$Pages$Cms$Products$EditProductsPermalinks$filterMallU, model, response.b$);
					var newHasQ10 = A2(
						$elm$core$List$any,
						function (us) {
							return us.iv === 17;
						},
						response.b$);
					var newSelectedUserPermalinkInfos = A4($author$project$Pages$Cms$Products$EditProductsPermalinks$filterBySelectedUserStores, model.s, model.aN, newUserStores, newHasQ10);
					var selectStores = $elm$core$List$isEmpty(newUserStores) ? A2(
						$elm$core$List$map,
						function (s) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(s.gM),
								A2($elm$core$Maybe$withDefault, '', s.el));
						},
						A2(
							$elm$core$List$sortBy,
							function (s) {
								return A2($elm$core$Maybe$withDefault, '', s.el);
							},
							$elm$core$Dict$values(model.aN))) : A2(
						$elm$core$List$map,
						function (s) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(s.iw),
								s.kS);
						},
						A2(
							$elm$core$List$sortBy,
							function (s) {
								return s.kS;
							},
							newUserStores));
					var newMultiselectStores = A3($inkuzmin$elm_multiselect$Multiselect$populateValues, model.p, selectStores, _List_Nil);
					var newModel = _Utils_update(
						model,
						{p: newMultiselectStores, aj: newSelectedUserPermalinkInfos, b$: newUserStores});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var id = msg.a;
				var input = msg.b;
				var f = function (permalinkInfos) {
					return _Utils_update(
						permalinkInfos,
						{ga: input});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Cms$Products$EditProductsPermalinks$updatePermalink, id, model, f),
					$elm$core$Platform$Cmd$none);
			case 10:
				var id = msg.a;
				var targetPermalinkInfo = $elm$core$List$isEmpty(
					$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? (model.ad ? A2($elm_community$list_extra$List$Extra$getAt, id, model.aj) : A2($elm_community$list_extra$List$Extra$getAt, id, model.s)) : A2(
					$elm_community$list_extra$List$Extra$getAt,
					id,
					A3($author$project$Pages$Cms$Products$EditProductsPermalinks$filterBySelectedStores, model.s, model.aN, model.p));
				var updatePermalinkInfo = A2(
					$elm$core$Maybe$andThen,
					function (target) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (permalinkInfo) {
									return _Utils_eq(permalinkInfo.at.U, target.at.U) && _Utils_eq(permalinkInfo.bL.bf, target.bL.bf);
								},
								model.s));
					},
					targetPermalinkInfo);
				if (!updatePermalinkInfo.$) {
					var permalinkInfo = updatePermalinkInfo.a;
					var object = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(permalinkInfo.bL.bf)),
								_Utils_Tuple2(
								'permalink_group_id',
								$elm$json$Json$Encode$int(permalinkInfo.at.U)),
								_Utils_Tuple2(
								'permalink',
								$elm$json$Json$Encode$string(permalinkInfo.ga))
							]));
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$post, $author$project$Endpoints$Cms$editProductsPermalinksEndpoints._, model.C, object, $author$project$Pages$Cms$Products$EditProductsPermalinks$sendResponseDecoder, $author$project$Pages$Cms$Products$EditProductsPermalinks$SendRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 11:
				var selected = msg.a;
				if (selected.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var id = selected.a;
					switch (id) {
						case 0:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ad: false}),
								$elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ad: true}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 12:
				var sub = msg.a;
				var _v9 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v9.a;
				var subCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeStore, subCmd));
			default:
				var selected = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fI: false,
							ad: false,
							p: A3($inkuzmin$elm_multiselect$Multiselect$populateValues, model.p, _List_Nil, _List_Nil),
							s: _List_Nil,
							bh: selected,
							cW: $elm$core$Maybe$Nothing,
							c$: '',
							c0: '',
							ik: $elm$core$Maybe$Nothing,
							gF: $elm$core$Maybe$Nothing,
							aj: _List_Nil,
							b$: _List_Nil
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$SendRequestSent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$UpdateRequestSent = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$SendResponse = function (soldoutInfos) {
	return {aD: soldoutInfos};
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$SoldoutInfo = F7(
	function (product_id, product_name, store_id, store_name, url, is_soldout, isUpdated) {
		return {R: isUpdated, fL: is_soldout, bf: product_id, bM: product_name, gM: store_id, el: store_name, eD: url};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Pages$Cms$Products$EditSoldoutProducts$soldoutInfoDecoder = $elm$json$Json$Decode$list(
	A8(
		$elm$json$Json$Decode$map7,
		$author$project$Pages$Cms$Products$EditSoldoutProducts$SoldoutInfo,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
		A2(
			$elm$json$Json$Decode$field,
			'store_name',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
		A2(
			$elm$json$Json$Decode$field,
			'url',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
		A2($elm$json$Json$Decode$field, 'is_soldout', $elm$json$Json$Decode$bool),
		$elm$json$Json$Decode$succeed(false)));
var $author$project$Pages$Cms$Products$EditSoldoutProducts$sendResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$EditSoldoutProducts$SendResponse,
	A2($elm$json$Json$Decode$field, 'soldoutInfos', $author$project$Pages$Cms$Products$EditSoldoutProducts$soldoutInfoDecoder));
var $author$project$Pages$Cms$Products$EditSoldoutProducts$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Products$EditSoldoutProducts$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Products$EditSoldoutProducts$updateSoldoutInfo = F3(
	function (index, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.aD);
		if (_Utils_eq(index, -1)) {
			return model;
		} else {
			if (!maybeCorrespondingProduct.$) {
				var soldoutInfo = maybeCorrespondingProduct.a;
				var newProduct = f(
					_Utils_update(
						soldoutInfo,
						{R: true}));
				var newProducts = A3($elm_community$list_extra$List$Extra$setAt, index, newProduct, model.aD);
				return _Utils_update(
					model,
					{aD: newProducts});
			} else {
				return model;
			}
		}
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fB: false, cE: initResponse.cE, kL: initResponse.kM}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 11:
				var ind = msg.a;
				var val = msg.b;
				var f = function (soldoutInfo) {
					return _Utils_update(
						soldoutInfo,
						{fL: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Cms$Products$EditSoldoutProducts$updateSoldoutInfo, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 1:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dK: $elm$core$String$trim(input)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dL: $elm$core$String$trim(input)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var object = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'product_id',
							$elm$json$Json$Encode$string(model.dK)),
							_Utils_Tuple2(
							'product_name',
							$elm$json$Json$Encode$string(model.dL))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fI: true}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$editSoldoutProductsEndpoints.gH, model.C, object, $author$project$Pages$Cms$Products$EditSoldoutProducts$sendResponseDecoder, $author$project$Pages$Cms$Products$EditSoldoutProducts$SendRequestSent));
			case 6:
				if (!msg.a.$) {
					var response = msg.a.a;
					var newModel = _Utils_update(
						model,
						{aD: response.aD});
					return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var selected = msg.a;
				if (selected.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var id = selected.a;
					switch (id) {
						case 0:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{fE: false}),
								$elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{fE: true}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 9:
				var index = msg.a;
				var maybepProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.aD);
				if (!maybepProduct.$) {
					var soldoutInfo = maybepProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(soldoutInfo.bf)),
								_Utils_Tuple2(
								'store_id',
								$elm$json$Json$Encode$int(soldoutInfo.gM)),
								_Utils_Tuple2(
								'is_soldout',
								$elm$json$Json$Encode$bool(soldoutInfo.fL))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g_: true}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editSoldoutProductsEndpoints._,
							model.C,
							body,
							$author$project$Pages$Cms$Products$EditSoldoutProducts$updateResponseDecoder,
							$author$project$Pages$Cms$Products$EditSoldoutProducts$UpdateRequestSent(index)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				if (!msg.b.$) {
					var index = msg.a;
					var updateResponse = msg.b.a;
					var newmodel = A3(
						$author$project$Pages$Cms$Products$EditSoldoutProducts$updateSoldoutInfo,
						index,
						model,
						function (p) {
							return _Utils_update(
								p,
								{R: false});
						});
					return _Utils_Tuple2(
						_Utils_update(
							newmodel,
							{g_: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var index = msg.a;
					var e = msg.b.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Cms$Products$RakutenExcludedItems$InsertionRequestSent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$RemoveRequestSent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fB: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var object = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'jan',
							$elm$json$Json$Encode$string(model.b4))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b4: ''}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$rakutenExcludedItemsEndpoints.am, model.C, object, $author$project$Pages$Cms$Products$RakutenExcludedItems$initResponseDecoder, $author$project$Pages$Cms$Products$RakutenExcludedItems$InsertionRequestSent));
			case 2:
				var object = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'jan',
							$elm$json$Json$Encode$string(model.cV))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cV: ''}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$rakutenExcludedItemsEndpoints.ie, model.C, object, $author$project$Pages$Cms$Products$RakutenExcludedItems$initResponseDecoder, $author$project$Pages$Cms$Products$RakutenExcludedItems$RemoveRequestSent));
			case 5:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kn: response.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kn: response.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b4: input}),
					$elm$core$Platform$Cmd$none);
			default:
				var input = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cV: input}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnCsvLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnSucceeded = {$: 3};
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnUpload = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$Received = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Helpers$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(time));
	});
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $elm$file$File$toString = _File_toString;
var $author$project$Endpoints$Cms$updateFujiWeeklyProducts = {
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-fuji-weekly-products']),
		_List_Nil),
	di: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-fuji-weekly-products', 'upload-csv']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['text/csv']),
						$author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnCsvLoaded));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnUpload,
						$elm$file$File$toString(file)));
			case 2:
				var csv = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'csv',
							$elm$json$Json$Encode$string(csv))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cD: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$updateFujiWeeklyProducts.di,
						model.C,
						body,
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
						$author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$Received));
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cD: false, nO: true}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnSucceeded));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e)),
								cD: false,
								nO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nO: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnCsvLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnSucceeded = {$: 3};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnUpload = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$Received = function (a) {
	return {$: 4, a: a};
};
var $author$project$Endpoints$Cms$updateHitachiProductsOrder = {
	lD: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-products-order', 'cleaner']),
		_List_Nil),
	mq: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-products-order', 'ih']),
		_List_Nil),
	mL: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-products-order', 'microwave']),
		_List_Nil),
	np: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-products-order', 'refrigerator']),
		_List_Nil),
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-products-order']),
		_List_Nil),
	nG: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-products-order', 'smalls']),
		_List_Nil),
	n4: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-products-order', 'washing-machine']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['text/csv']),
						$author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnCsvLoaded));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnUpload,
						$elm$file$File$toString(file)));
			case 2:
				var csv = msg.a;
				var maybeMaybeEndpoint = A2(
					$elm$core$Maybe$map,
					function (bigCategoryId) {
						switch (bigCategoryId) {
							case 1:
								return $elm$core$Maybe$Just($author$project$Endpoints$Cms$updateHitachiProductsOrder.np);
							case 2:
								return $elm$core$Maybe$Just($author$project$Endpoints$Cms$updateHitachiProductsOrder.n4);
							case 3:
								return $elm$core$Maybe$Just($author$project$Endpoints$Cms$updateHitachiProductsOrder.lD);
							case 4:
								return $elm$core$Maybe$Just($author$project$Endpoints$Cms$updateHitachiProductsOrder.mL);
							case 5:
								return $elm$core$Maybe$Just($author$project$Endpoints$Cms$updateHitachiProductsOrder.nG);
							case 6:
								return $elm$core$Maybe$Just($author$project$Endpoints$Cms$updateHitachiProductsOrder.mq);
							default:
								return $elm$core$Maybe$Nothing;
						}
					},
					model.ig);
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'csv',
							$elm$json$Json$Encode$string(csv))
						]));
				if (!maybeMaybeEndpoint.$) {
					var maybeEndpoint = maybeMaybeEndpoint.a;
					if (!maybeEndpoint.$) {
						var endpoint = maybeEndpoint.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cD: true}),
							A5(
								$author$project$Api$post,
								endpoint,
								model.C,
								body,
								$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
								$author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$Received));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just('正しい大分類を1つだけ選択してください')
								}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just('正しい大分類を1つだけ選択してください')
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cD: false, nO: true}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnSucceeded));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e)),
								cD: false,
								nO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nO: false}),
					$elm$core$Platform$Cmd$none);
			default:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnCsvLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnSucceeded = {$: 3};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnUpload = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$Received = function (a) {
	return {$: 4, a: a};
};
var $author$project$Endpoints$Cms$updateHitachiWeeklyProducts = {
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-weekly-products']),
		_List_Nil),
	di: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-hitachi-weekly-products', 'upload-csv']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['text/csv']),
						$author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnCsvLoaded));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnUpload,
						$elm$file$File$toString(file)));
			case 2:
				var csv = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'csv',
							$elm$json$Json$Encode$string(csv))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cD: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$updateHitachiWeeklyProducts.di,
						model.C,
						body,
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
						$author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$Received));
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cD: false, nO: true}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnSucceeded));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e)),
								cD: false,
								nO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nO: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnCsvLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnSucceeded = {$: 3};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnUpload = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$Received = function (a) {
	return {$: 4, a: a};
};
var $author$project$Endpoints$Cms$updateSharpProducts = {
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-sharp-products']),
		_List_Nil),
	di: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-sharp-products', 'upload-csv']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['text/csv']),
						$author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnCsvLoaded));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnUpload,
						$elm$file$File$toString(file)));
			case 2:
				var csv = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'csv',
							$elm$json$Json$Encode$string(csv))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cD: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$updateSharpProducts.di,
						model.C,
						body,
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
						$author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$Received));
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cD: false, nO: true}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnSucceeded));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e)),
								cD: false,
								nO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nO: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnCsvLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnSucceeded = {$: 3};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnUpload = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$Received = function (a) {
	return {$: 4, a: a};
};
var $author$project$Endpoints$Cms$updateTescomProducts = {
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-tescom-products']),
		_List_Nil),
	di: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-tescom-products', 'upload-csv']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['text/csv']),
						$author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnCsvLoaded));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnUpload,
						$elm$file$File$toString(file)));
			case 2:
				var csv = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'csv',
							$elm$json$Json$Encode$string(csv))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cD: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$updateTescomProducts.di,
						model.C,
						body,
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
						$author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$Received));
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cD: false, nO: true}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnSucceeded));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e)),
								cD: false,
								nO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nO: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnCsvLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnSucceeded = {$: 3};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnUpload = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$Received = function (a) {
	return {$: 4, a: a};
};
var $author$project$Endpoints$Cms$updateTletProducts = {
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-tlet-products']),
		_List_Nil),
	di: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, 'update-tlet-products', 'upload-csv']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['text/csv']),
						$author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnCsvLoaded));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnUpload,
						$elm$file$File$toString(file)));
			case 2:
				var csv = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'csv',
							$elm$json$Json$Encode$string(csv))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cD: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$updateTletProducts.di,
						model.C,
						body,
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
						$author$project$Pages$Cms$Products$UpdateTletProductsByCsv$Received));
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cD: false, nO: true}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnSucceeded));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e)),
								cD: false,
								nO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nO: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnCsvLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnSucceeded = {$: 3};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnUpload = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$Received = function (a) {
	return {$: 4, a: a};
};
var $author$project$Endpoints$Cms$updateWeek30ByCsv = 'update-week30-by-csv';
var $author$project$Endpoints$Cms$updateWeek30ByCsvEndpoints = {
	l: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$updateWeek30ByCsv]),
		_List_Nil),
	di: A2(
		$elm$url$Url$Builder$absolute,
		_List_fromArray(
			[$author$project$Endpoints$Cms$cms, $author$project$Endpoints$Cms$products, $author$project$Endpoints$Cms$updateWeek30ByCsv, 'upload-csv']),
		_List_Nil)
};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$file$File$Select$file,
						_List_fromArray(
							['text/csv']),
						$author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnCsvLoaded));
			case 1:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnUpload,
						$elm$file$File$toString(file)));
			case 2:
				var csv = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'csv',
							$elm$json$Json$Encode$string(csv))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cD: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$updateWeek30ByCsvEndpoints.di,
						model.C,
						body,
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
						$author$project$Pages$Cms$Products$UpdateWeek30ByCsv$Received));
			case 4:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cD: false, nO: true}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnSucceeded));
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e)),
								cD: false,
								nO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nO: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Products$UserSpecificRouting$filterUser = function (user) {
	return A2(
		$elm$core$List$member,
		user.k7,
		_List_fromArray(
			[1, 2, 6, 7, 16, 23, 31]));
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$update = F2(
	function (msg, model) {
		if (!msg.$) {
			if (!msg.a.$) {
				var initResponse = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cv: false,
							k8: A2($elm$core$List$filter, $author$project$Pages$Cms$Products$UserSpecificRouting$filterUser, initResponse.k8)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var err = msg.a.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							H: $elm$core$Maybe$Just(
								$author$project$Utils$Helpers$errToStr(err)),
							cv: false
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			var maybeUserId = msg.a;
			var newModel = _Utils_update(
				model,
				{gF: maybeUserId});
			if (maybeUserId.$ === 1) {
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			} else {
				var userId = maybeUserId.a;
				return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$CompletedAddPermalinkGroup = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$CompletedDeletePermalinkGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$CompletedUpdatePermalinkGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$setIf = F3(
	function (predicate, replacement, list) {
		return A3(
			$elm_community$list_extra$List$Extra$updateIf,
			predicate,
			$elm$core$Basics$always(replacement),
			list);
	});
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$updatePermalinkGroups = F2(
	function (permalinkGroup, permalinkGroups) {
		return A3(
			$elm_community$list_extra$List$Extra$setIf,
			function (pg) {
				return _Utils_eq(pg.T, permalinkGroup.T);
			},
			permalinkGroup,
			permalinkGroups);
	});
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditPermalinkGroups$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, i: initResponse.i}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				if (!msg.b.$) {
					var permalinkGroupId = msg.a;
					var updateResponse = msg.b.a;
					var permalinkGroups = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.T, permalinkGroupId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.i);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, i: permalinkGroups}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				if (!msg.a.$) {
					var updateResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, ba: $author$project$Pages$Cms$Stores$EditPermalinkGroups$initNewPermalinkGroup}),
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editPermalinkGroupsEndpoints.x, model.C, $author$project$Pages$Cms$Stores$EditPermalinkGroups$initResponseDecoder, $author$project$Pages$Cms$Stores$EditPermalinkGroups$InitRequestSent));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				if (!msg.b.$) {
					var permalinkGroupId = msg.a;
					var updateResponse = msg.b.a;
					var permalinkGroups = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.T, permalinkGroupId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.i);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, i: permalinkGroups}),
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editPermalinkGroupsEndpoints.x, model.C, $author$project$Pages$Cms$Stores$EditPermalinkGroups$initResponseDecoder, $author$project$Pages$Cms$Stores$EditPermalinkGroups$InitRequestSent));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 6:
				var permalinkGroup = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'permalink_group_id',
							$elm$json$Json$Encode$int(permalinkGroup.T)),
							_Utils_Tuple2(
							'permalink_group_name',
							$elm$json$Json$Encode$string(permalinkGroup.as))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editPermalinkGroupsEndpoints._,
						model.C,
						body,
						$author$project$Pages$Cms$Stores$EditPermalinkGroups$updateResponseDecoder,
						$author$project$Pages$Cms$Stores$EditPermalinkGroups$CompletedUpdatePermalinkGroup(permalinkGroup.T)));
			case 8:
				var newPermalinkGroup = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'permalink_group_name',
							$elm$json$Json$Encode$string(newPermalinkGroup.as))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$editPermalinkGroupsEndpoints.am, model.C, body, $author$project$Pages$Cms$Stores$EditPermalinkGroups$updateResponseDecoder, $author$project$Pages$Cms$Stores$EditPermalinkGroups$CompletedAddPermalinkGroup));
			case 7:
				var permalinkGroupId = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'permalink_group_id',
							$elm$json$Json$Encode$int(permalinkGroupId))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editPermalinkGroupsEndpoints.ci,
						model.C,
						body,
						$author$project$Pages$Cms$Stores$EditPermalinkGroups$updateResponseDecoder,
						$author$project$Pages$Cms$Stores$EditPermalinkGroups$CompletedDeletePermalinkGroup(permalinkGroupId)));
			case 1:
				var permalinkGroupId = msg.a;
				var permalinkGroupName = msg.b;
				var permalinkGroup = {R: true, T: permalinkGroupId, as: permalinkGroupName};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: A2($author$project$Pages$Cms$Stores$EditPermalinkGroups$updatePermalinkGroups, permalinkGroup, model.i)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var permalinkGroupName = msg.a;
				var newPermalinkGroup = model.ba;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ba: _Utils_update(
								newPermalinkGroup,
								{R: true, as: permalinkGroupName})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Stores$EditStoreGroups$CompletedAddStoreGroup = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$CompletedDeleteStoreGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreGroups$CompletedUpdateStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreGroups$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditStoreGroups$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Stores$EditStoreGroups$updateStoreGroups = F2(
	function (storeGroup, storeGroups) {
		return A3(
			$elm_community$list_extra$List$Extra$setIf,
			function (pg) {
				return _Utils_eq(pg.iv, storeGroup.iv);
			},
			storeGroup,
			storeGroups);
	});
var $author$project$Pages$Cms$Stores$EditStoreGroups$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, X: initResponse.X}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				if (!msg.b.$) {
					var storeGroupId = msg.a;
					var updateResponse = msg.b.a;
					var storeGroups = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.iv, storeGroupId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.X);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, X: storeGroups}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				if (!msg.a.$) {
					var updateResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, cI: $author$project$Pages$Cms$Stores$EditStoreGroups$initNewStoreGroup}),
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editStoreGroupsEndpoints.x, model.C, $author$project$Pages$Cms$Stores$EditStoreGroups$initResponseDecoder, $author$project$Pages$Cms$Stores$EditStoreGroups$InitRequestSent));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				if (!msg.b.$) {
					var storeGroupId = msg.a;
					var updateResponse = msg.b.a;
					var storeGroups = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.iv, storeGroupId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.X);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, X: storeGroups}),
						A4($author$project$Api$get, $author$project$Endpoints$Cms$editStoreGroupsEndpoints.x, model.C, $author$project$Pages$Cms$Stores$EditStoreGroups$initResponseDecoder, $author$project$Pages$Cms$Stores$EditStoreGroups$InitRequestSent));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 6:
				var storeGroup = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'store_group_id',
							$elm$json$Json$Encode$int(storeGroup.iv)),
							_Utils_Tuple2(
							'store_group_name',
							$elm$json$Json$Encode$string(storeGroup.kR))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editStoreGroupsEndpoints._,
						model.C,
						body,
						$author$project$Pages$Cms$Stores$EditStoreGroups$updateResponseDecoder,
						$author$project$Pages$Cms$Stores$EditStoreGroups$CompletedUpdateStoreGroup(storeGroup.iv)));
			case 8:
				var newStoreGroup = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'store_group_name',
							$elm$json$Json$Encode$string(newStoreGroup.kR))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$Cms$editStoreGroupsEndpoints.am, model.C, body, $author$project$Pages$Cms$Stores$EditStoreGroups$updateResponseDecoder, $author$project$Pages$Cms$Stores$EditStoreGroups$CompletedAddStoreGroup));
			case 7:
				var storeGroupId = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'store_group_id',
							$elm$json$Json$Encode$int(storeGroupId))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editStoreGroupsEndpoints.ci,
						model.C,
						body,
						$author$project$Pages$Cms$Stores$EditStoreGroups$updateResponseDecoder,
						$author$project$Pages$Cms$Stores$EditStoreGroups$CompletedDeleteStoreGroup(storeGroupId)));
			case 1:
				var storeGroupId = msg.a;
				var storeGroupName = msg.b;
				var storeGroup = {R: true, iv: storeGroupId, kR: storeGroupName};
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							X: A2($author$project$Pages$Cms$Stores$EditStoreGroups$updateStoreGroups, storeGroup, model.X)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var storeGroupName = msg.a;
				var newStoreGroup = model.cI;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cI: _Utils_update(
								newStoreGroup,
								{R: true, kR: storeGroupName})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$AddRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$DeleteRequestSent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$Failed = 3;
var $author$project$Pages$Cms$Stores$EditStoreProperties$Loading = 1;
var $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState = {$: 4};
var $author$project$Pages$Cms$Stores$EditStoreProperties$Succeeded = 2;
var $author$project$Pages$Cms$Stores$EditStoreProperties$UpdateRequestSent = function (a) {
	return {$: 1, a: a};
};
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$UpdateResponse = function (isSucceeded) {
	return {mw: isSucceeded};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditStoreProperties$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'isSucceeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties = F3(
	function (id, model, f) {
		var ff = function (storeProperty) {
			var sp = f(storeProperty);
			return _Utils_update(
				sp,
				{R: true});
		};
		if (_Utils_eq(id, -1)) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						bb: ff(model.bb)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var newStoreProperties = A3(
				$elm$core$Dict$update,
				id,
				$elm$core$Maybe$andThen(
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, ff)),
				model.Y);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{Y: newStoreProperties}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bp: initResponse.bp, bt: initResponse.bt, fB: false, f7: initResponse.Y, Y: initResponse.Y}),
						$elm$core$Platform$Cmd$none);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e))
							}),
						A2($author$project$Utils$Helpers$delay, 1000, $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState));
				}
			case 3:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 2}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState),
									A4(
									$author$project$Api$get,
									$author$project$Endpoints$Cms$editStorePropertiesEndpoints.x,
									$author$project$Pages$Cms$Stores$EditStoreProperties$toSession(model),
									$author$project$Pages$Cms$Stores$EditStoreProperties$initResponseDecoder,
									$author$project$Pages$Cms$Stores$EditStoreProperties$InitRequestSent)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 3}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState));
				}
			case 2:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bb: $author$project$Pages$Cms$Stores$EditStoreProperties$newStoreProperty, F: 2}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState),
									A4(
									$author$project$Api$get,
									$author$project$Endpoints$Cms$editStorePropertiesEndpoints.x,
									$author$project$Pages$Cms$Stores$EditStoreProperties$toSession(model),
									$author$project$Pages$Cms$Stores$EditStoreProperties$initResponseDecoder,
									$author$project$Pages$Cms$Stores$EditStoreProperties$InitRequestSent)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 3}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState));
				}
			case 1:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 2}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 3}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStoreProperties$ResetUpdateRequestState));
				}
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{F: 0, bm: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{cT: value});
					});
			case 6:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{cP: value});
					});
			case 7:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{cO: value});
					});
			case 8:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								cM: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 9:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								cL: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 11:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								c9: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 12:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								c8: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 10:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								cf: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							});
					});
			case 13:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								c5: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							});
					});
			case 14:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								cg: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							});
					});
			case 15:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStoreProperties$updateStoreProperties,
					id,
					model,
					function (storeProperty) {
						return _Utils_update(
							storeProperty,
							{
								cm: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							});
					});
			case 16:
				var id = msg.a;
				return _Utils_eq(id, -1) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{bb: $author$project$Pages$Cms$Stores$EditStoreProperties$newStoreProperty}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Y: A3(
								$elm$core$Dict$update,
								id,
								function (_v1) {
									return A2($elm$core$Dict$get, id, model.f7);
								},
								model.Y)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var id = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'property_id',
							$elm$json$Json$Encode$int(id))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: 1,
							bm: $elm$core$Maybe$Just(id)
						}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editStorePropertiesEndpoints.ci,
						$author$project$Pages$Cms$Stores$EditStoreProperties$toSession(model),
						body,
						$author$project$Pages$Cms$Stores$EditStoreProperties$updateResponseDecoder,
						$author$project$Pages$Cms$Stores$EditStoreProperties$DeleteRequestSent));
			default:
				var id = msg.a;
				var _v2 = A2($elm$core$Dict$get, id, model.Y);
				if (!_v2.$) {
					var storeProperty = _v2.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'property_id',
								$elm$json$Json$Encode$int(storeProperty.nm)),
								_Utils_Tuple2(
								'property_name',
								$elm$json$Json$Encode$string(storeProperty.cT)),
								_Utils_Tuple2(
								'price_selector',
								$elm$json$Json$Encode$string(storeProperty.cP)),
								_Utils_Tuple2(
								'price_regex',
								$elm$json$Json$Encode$string(storeProperty.cO)),
								_Utils_Tuple2(
								'point_selector',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.cM)),
								_Utils_Tuple2(
								'point_regex',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.cL)),
								_Utils_Tuple2(
								'constant_point',
								$elm$json$Json$Encode$int(storeProperty.cf)),
								_Utils_Tuple2(
								'soldout_selector',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.c9)),
								_Utils_Tuple2(
								'soldout_regex',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.c8)),
								_Utils_Tuple2(
								'convert_type_id',
								$elm$json$Json$Encode$int(storeProperty.cg)),
								_Utils_Tuple2(
								'sleep_time',
								$elm$json$Json$Encode$int(storeProperty.c5)),
								_Utils_Tuple2(
								'driver_id',
								$elm$json$Json$Encode$int(storeProperty.cm))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								F: 1,
								bm: $elm$core$Maybe$Just(id)
							}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editStorePropertiesEndpoints._,
							$author$project$Pages$Cms$Stores$EditStoreProperties$toSession(model),
							body,
							$author$project$Pages$Cms$Stores$EditStoreProperties$updateResponseDecoder,
							$author$project$Pages$Cms$Stores$EditStoreProperties$UpdateRequestSent));
				} else {
					if (_Utils_eq(id, -1)) {
						var storeProperty = model.bb;
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'property_id',
									$elm$json$Json$Encode$int(storeProperty.nm)),
									_Utils_Tuple2(
									'property_name',
									$elm$json$Json$Encode$string(storeProperty.cT)),
									_Utils_Tuple2(
									'price_selector',
									$elm$json$Json$Encode$string(storeProperty.cP)),
									_Utils_Tuple2(
									'price_regex',
									$elm$json$Json$Encode$string(storeProperty.cO)),
									_Utils_Tuple2(
									'point_selector',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.cM)),
									_Utils_Tuple2(
									'point_regex',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.cL)),
									_Utils_Tuple2(
									'constant_point',
									$elm$json$Json$Encode$int(storeProperty.cf)),
									_Utils_Tuple2(
									'soldout_selector',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.c9)),
									_Utils_Tuple2(
									'soldout_regex',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, storeProperty.c8)),
									_Utils_Tuple2(
									'convert_type_id',
									$elm$json$Json$Encode$int(storeProperty.cg)),
									_Utils_Tuple2(
									'sleep_time',
									$elm$json$Json$Encode$int(storeProperty.c5)),
									_Utils_Tuple2(
									'driver_id',
									$elm$json$Json$Encode$int(storeProperty.cm))
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									F: 1,
									bm: $elm$core$Maybe$Just(-1)
								}),
							A5(
								$author$project$Api$post,
								$author$project$Endpoints$Cms$editStorePropertiesEndpoints.am,
								$author$project$Pages$Cms$Stores$EditStoreProperties$toSession(model),
								body,
								$author$project$Pages$Cms$Stores$EditStoreProperties$updateResponseDecoder,
								$author$project$Pages$Cms$Stores$EditStoreProperties$AddRequestSent));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just('Error: Attempt to refer unknown property_id')
								}),
							$elm$core$Platform$Cmd$none);
					}
				}
		}
	});
var $author$project$Pages$Cms$Stores$EditStores$AddRequestSent = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Cms$Stores$EditStores$DeleteRequestSent = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Cms$Stores$EditStores$Failed = 3;
var $author$project$Pages$Cms$Stores$EditStores$Loading = 1;
var $author$project$Pages$Cms$Stores$EditStores$ResetUpdateRequestState = {$: 14};
var $author$project$Pages$Cms$Stores$EditStores$Succeeded = 2;
var $author$project$Pages$Cms$Stores$EditStores$UpdateRequestSent = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Cms$Stores$EditStores$SendResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Stores$EditStores$sendResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditStores$SendResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Stores$EditStores$updateStores = F3(
	function (id, model, f) {
		var ff = function (store) {
			var store_ = f(store);
			return _Utils_update(
				store_,
				{R: true});
		};
		if (_Utils_eq(id, -1)) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						bJ: ff(model.bJ)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			var newStores = A3(
				$elm$core$Dict$update,
				id,
				$elm$core$Maybe$andThen(
					A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, ff)),
				model.aN);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{aN: newStores}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Stores$EditStores$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fB: false, i: initResponse.i, X: initResponse.X, Y: initResponse.Y, aN: initResponse.aN}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								fB: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStores$updateStores,
					id,
					model,
					function (store) {
						return _Utils_update(
							store,
							{nm: value});
					});
			case 2:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStores$updateStores,
					id,
					model,
					function (store) {
						return _Utils_update(
							store,
							{U: value});
					});
			case 3:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStores$updateStores,
					id,
					model,
					function (store) {
						return _Utils_update(
							store,
							{nL: value});
					});
			case 4:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStores$updateStores,
					id,
					model,
					function (store) {
						return _Utils_update(
							store,
							{
								eD: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 6:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStores$updateStores,
					id,
					model,
					function (store) {
						return _Utils_update(
							store,
							{
								jd: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 7:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStores$updateStores,
					id,
					model,
					function (store) {
						return _Utils_update(
							store,
							{
								l3: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 5:
				var id = msg.a;
				var value = msg.b;
				return A3(
					$author$project$Pages$Cms$Stores$EditStores$updateStores,
					id,
					model,
					function (store) {
						return _Utils_update(
							store,
							{
								el: $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)
							});
					});
			case 8:
				var store = model.bJ;
				var _v1 = _Utils_Tuple3(store.nL, store.nm, store.U);
				if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
					var store_group_id = _v1.a.a;
					var property_id = _v1.b.a;
					var permalink_group_id = _v1.c.a;
					if (_Utils_eq(store_group_id, -1) || (_Utils_eq(property_id, -1) || _Utils_eq(permalink_group_id, -1))) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'store_group_id',
									$elm$json$Json$Encode$int(store_group_id)),
									_Utils_Tuple2(
									'property_id',
									$elm$json$Json$Encode$int(property_id)),
									_Utils_Tuple2(
									'permalink_group_id',
									$elm$json$Json$Encode$int(permalink_group_id)),
									_Utils_Tuple2(
									'url',
									$elm$json$Json$Encode$string(
										A2($elm$core$Maybe$withDefault, '', store.eD))),
									_Utils_Tuple2(
									'store_name',
									$elm$json$Json$Encode$string(
										A2($elm$core$Maybe$withDefault, '', store.el))),
									_Utils_Tuple2(
									'display_name',
									$elm$json$Json$Encode$string(
										A2($elm$core$Maybe$withDefault, '', store.jd))),
									_Utils_Tuple2(
									'exhibition_name',
									$elm$json$Json$Encode$string(
										A2($elm$core$Maybe$withDefault, '', store.l3)))
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fI: true}),
							A5($author$project$Api$post, $author$project$Endpoints$Cms$editStoresEndpoints.am, model.C, body, $author$project$Pages$Cms$Stores$EditStores$sendResponseDecoder, $author$project$Pages$Cms$Stores$EditStores$AddRequestSent));
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bJ: $author$project$Pages$Cms$Stores$EditStores$newStore, F: 2}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStores$ResetUpdateRequestState),
									A4($author$project$Api$get, $author$project$Endpoints$Cms$editStoresEndpoints.x, model.C, $author$project$Pages$Cms$Stores$EditStores$initResponseDecoder, $author$project$Pages$Cms$Stores$EditStores$InitRequestSent)
								])));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 3}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStores$ResetUpdateRequestState));
				}
			case 10:
				var id = msg.a;
				var _v2 = A2($elm$core$Dict$get, id, model.aN);
				if (!_v2.$) {
					var store = _v2.a;
					var _v3 = _Utils_Tuple3(store.nL, store.nm, store.U);
					if (((!_v3.a.$) && (!_v3.b.$)) && (!_v3.c.$)) {
						var store_group_id = _v3.a.a;
						var property_id = _v3.b.a;
						var permalink_group_id = _v3.c.a;
						if (_Utils_eq(store_group_id, -1) || (_Utils_eq(property_id, -1) || _Utils_eq(permalink_group_id, -1))) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							var body = $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'store_id',
										$elm$json$Json$Encode$int(store.gM)),
										_Utils_Tuple2(
										'store_group_id',
										$elm$json$Json$Encode$int(store_group_id)),
										_Utils_Tuple2(
										'property_id',
										$elm$json$Json$Encode$int(property_id)),
										_Utils_Tuple2(
										'permalink_group_id',
										$elm$json$Json$Encode$int(permalink_group_id)),
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string(
											A2($elm$core$Maybe$withDefault, '', store.eD))),
										_Utils_Tuple2(
										'store_name',
										$elm$json$Json$Encode$string(
											A2($elm$core$Maybe$withDefault, '', store.el))),
										_Utils_Tuple2(
										'display_name',
										$elm$json$Json$Encode$string(
											A2($elm$core$Maybe$withDefault, '', store.jd))),
										_Utils_Tuple2(
										'exhibition_name',
										$elm$json$Json$Encode$string(
											A2($elm$core$Maybe$withDefault, '', store.l3)))
									]));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{fI: true, F: 1}),
								A5($author$project$Api$post, $author$project$Endpoints$Cms$editStoresEndpoints._, model.C, body, $author$project$Pages$Cms$Stores$EditStores$sendResponseDecoder, $author$project$Pages$Cms$Stores$EditStores$UpdateRequestSent));
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 11:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 2}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStores$ResetUpdateRequestState));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 3}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStores$ResetUpdateRequestState));
				}
			case 12:
				var id = msg.a;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'store_id',
							$elm$json$Json$Encode$int(id))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							F: 1,
							g$: $elm$core$Maybe$Just(id)
						}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$Cms$editStoresEndpoints.ci,
						$author$project$Pages$Cms$Stores$EditStores$toSession(model),
						body,
						$author$project$Pages$Cms$Stores$EditStores$sendResponseDecoder,
						$author$project$Pages$Cms$Stores$EditStores$DeleteRequestSent));
			case 13:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 2}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStores$ResetUpdateRequestState),
									A4(
									$author$project$Api$get,
									$author$project$Endpoints$Cms$editStoresEndpoints.x,
									$author$project$Pages$Cms$Stores$EditStores$toSession(model),
									$author$project$Pages$Cms$Stores$EditStores$initResponseDecoder,
									$author$project$Pages$Cms$Stores$EditStores$InitRequestSent)
								])));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{F: 3}),
						A2($author$project$Utils$Helpers$delay, 500, $author$project$Pages$Cms$Stores$EditStores$ResetUpdateRequestState));
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{F: 0, g$: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$CompletedAddUserStore = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$CompletedDeleteUserStore = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$CompletedUpdateUserStore = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Cms$Stores$EditUsersStores$CompletedListUserStores = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$UserStoresResponse = function (userStores) {
	return {b$: userStores};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$UserStore = F9(
	function (storeId, storeName, storeGroupId, displayName, storeOrder, storeGroupName, getInterval, getEnabled, isUpdated) {
		return {fh: displayName, jr: getEnabled, js: getInterval, R: isUpdated, iv: storeGroupId, kR: storeGroupName, iw: storeId, kS: storeName, kT: storeOrder};
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$userStoresDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(false),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'get_enabled',
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(true),
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'get_interval',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'store_order', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'display_name',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Pages$Cms$Stores$EditUsersStores$UserStore)))))))))));
var $author$project$Pages$Cms$Stores$EditUsersStores$listUserStoresResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditUsersStores$UserStoresResponse,
	A2($elm$json$Json$Decode$field, 'userStores', $author$project$Pages$Cms$Stores$EditUsersStores$userStoresDecoder));
var $author$project$Pages$Cms$Stores$EditUsersStores$postListStores = F2(
	function (maybeUser, model) {
		if (maybeUser.$ === 1) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var userId = maybeUser.a;
			return A5(
				$author$project$Api$post,
				$author$project$Endpoints$Cms$editUsersStoresEndpoints.hS,
				model.C,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'user_id',
							$elm$json$Json$Encode$int(userId))
						])),
				$author$project$Pages$Cms$Stores$EditUsersStores$listUserStoresResponseDecoder,
				$author$project$Pages$Cms$Stores$EditUsersStores$CompletedListUserStores);
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Cms$Stores$EditUsersStores$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Cms$Stores$EditUsersStores$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, X: initResponse.X, aN: initResponse.aN, k8: initResponse.k8}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 10:
				if (!msg.a.$) {
					var userStoresResponse = msg.a.a;
					var order = A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$List$maximum(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.kT;
								},
								userStoresResponse.b$))) + 1;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								y: _Utils_update(
									$author$project$Pages$Cms$Stores$EditUsersStores$initNewUserStore,
									{kT: order}),
								b$: userStoresResponse.b$
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 7:
				if (!msg.b.$) {
					var userStoreId = msg.a;
					var updateResponse = msg.b.a;
					var userStores = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.iw, userStoreId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.b$);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, b$: userStores}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 9:
				if (!msg.a.$) {
					var updateResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, y: $author$project$Pages$Cms$Stores$EditUsersStores$initNewUserStore, gC: $elm$core$Maybe$Nothing}),
						A2($author$project$Pages$Cms$Stores$EditUsersStores$postListStores, model.$9, model));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 8:
				if (!msg.b.$) {
					var userStoreId = msg.a;
					var updateResponse = msg.b.a;
					var userStores = A3(
						$elm_community$list_extra$List$Extra$updateIf,
						function (pg) {
							return _Utils_eq(pg.iw, userStoreId);
						},
						function (pg) {
							return _Utils_update(
								pg,
								{R: false});
						},
						model.b$);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, b$: userStores}),
						A2($author$project$Pages$Cms$Stores$EditUsersStores$postListStores, model.$9, model));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				var userStore = msg.a;
				var _v1 = model.$9;
				if (_v1.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var selectedUser = _v1.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(selectedUser)),
								_Utils_Tuple2(
								'store_id',
								$elm$json$Json$Encode$int(userStore.iw)),
								_Utils_Tuple2(
								'ord',
								$elm$json$Json$Encode$int(userStore.kT)),
								_Utils_Tuple2(
								'get_interval',
								A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, userStore.js)),
								_Utils_Tuple2(
								'get_enabled',
								$elm$json$Json$Encode$bool(userStore.jr)),
								_Utils_Tuple2(
								'user_store_group_id',
								$elm$json$Json$Encode$int(userStore.iv))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editUsersStoresEndpoints._,
							model.C,
							body,
							$author$project$Pages$Cms$Stores$EditUsersStores$updateResponseDecoder,
							$author$project$Pages$Cms$Stores$EditUsersStores$CompletedUpdateUserStore(userStore.iw)));
				}
			case 13:
				var userStore = msg.a;
				var _v2 = model.$9;
				if (_v2.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var selectedUser = _v2.a;
					if (userStore.iw < 0) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user_id',
									$elm$json$Json$Encode$int(selectedUser)),
									_Utils_Tuple2(
									'store_id',
									$elm$json$Json$Encode$int(userStore.iw)),
									_Utils_Tuple2(
									'ord',
									$elm$json$Json$Encode$int(userStore.kT)),
									_Utils_Tuple2(
									'get_interval',
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, userStore.js)),
									_Utils_Tuple2(
									'get_enabled',
									$elm$json$Json$Encode$bool(userStore.jr)),
									_Utils_Tuple2(
									'user_store_group_id',
									$elm$json$Json$Encode$int(userStore.iv))
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{k: true}),
							A5($author$project$Api$post, $author$project$Endpoints$Cms$editUsersStoresEndpoints.am, model.C, body, $author$project$Pages$Cms$Stores$EditUsersStores$updateResponseDecoder, $author$project$Pages$Cms$Stores$EditUsersStores$CompletedAddUserStore));
					}
				}
			case 12:
				var userStoreId = msg.a;
				var _v3 = model.$9;
				if (_v3.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var selectedUser = _v3.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'user_id',
								$elm$json$Json$Encode$int(selectedUser)),
								_Utils_Tuple2(
								'store_id',
								$elm$json$Json$Encode$int(userStoreId))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$Cms$editUsersStoresEndpoints.ci,
							model.C,
							body,
							$author$project$Pages$Cms$Stores$EditUsersStores$updateResponseDecoder,
							$author$project$Pages$Cms$Stores$EditUsersStores$CompletedDeleteUserStore(userStoreId)));
				}
			case 1:
				var selectedUserStr = msg.a;
				var maybeSelectedUser = $elm$core$String$toInt(selectedUserStr);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{$9: maybeSelectedUser}),
					A2($author$project$Pages$Cms$Stores$EditUsersStores$postListStores, maybeSelectedUser, model));
			case 2:
				var userStoreId = msg.a;
				var storeOrder = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b$: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (us) {
									return _Utils_eq(us.iw, userStoreId);
								},
								function (us) {
									return _Utils_update(
										us,
										{
											R: true,
											kT: A2(
												$elm$core$Maybe$withDefault,
												0,
												$elm$core$String$toInt(storeOrder))
										});
								},
								model.b$)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var storeOrder = msg.a;
				var newUserStore = model.y;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							y: _Utils_update(
								newUserStore,
								{
									R: true,
									kT: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(storeOrder))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var userStoreId = msg.a;
				var getIntervalStr = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b$: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (us) {
									return _Utils_eq(us.iw, userStoreId);
								},
								function (us) {
									return _Utils_update(
										us,
										{
											js: $elm$core$String$toInt(getIntervalStr),
											R: true
										});
								},
								model.b$)
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var getIntervalStr = msg.a;
				var newUserStore = model.y;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							y: _Utils_update(
								newUserStore,
								{
									js: $elm$core$String$toInt(getIntervalStr),
									R: true
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var userStoreId = msg.a;
				var isGetEnabled = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b$: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (us) {
									return _Utils_eq(us.iw, userStoreId);
								},
								function (us) {
									return _Utils_update(
										us,
										{jr: isGetEnabled, R: true});
								},
								model.b$)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var isGetEnabled = msg.a;
				var newUserStore = model.y;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							y: _Utils_update(
								newUserStore,
								{jr: isGetEnabled, R: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var userStoreId = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var storeGroupName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function ($) {
						return $.kR;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (sg) {
							return _Utils_eq(sg.iv, storeGroupId);
						},
						model.X));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b$: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (us) {
									return _Utils_eq(us.iw, userStoreId);
								},
								function (us) {
									return _Utils_update(
										us,
										{R: true, iv: storeGroupId, kR: storeGroupName});
								},
								model.b$)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var userStoreName = msg.a;
				var newUserStore = model.y;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							y: _Utils_update(
								newUserStore,
								{R: true, kS: userStoreName})
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var selectedStoreIdStr = msg.a;
				var selectedStoreId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(selectedStoreIdStr));
				var newUserStoreName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function ($) {
						return $.kS;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (s) {
							return _Utils_eq(s.iw, selectedStoreId);
						},
						model.aN));
				var newUserStore = model.y;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							y: _Utils_update(
								newUserStore,
								{R: true, iw: selectedStoreId, kS: newUserStoreName})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var selectedStoreGroupIdStr = msg.a;
				var selectedStoreGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(selectedStoreGroupIdStr));
				var newUserStore = model.y;
				var newStoreGroupName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'',
					function ($) {
						return $.kR;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (s) {
							return _Utils_eq(s.iv, selectedStoreGroupId);
						},
						model.X));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							y: _Utils_update(
								newUserStore,
								{R: true, iv: selectedStoreGroupId, kR: newStoreGroupName})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$Stores$Yahoo$GotDirectURLs = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Stores$Yahoo$GotProducts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Stores$Yahoo$GotSubmitResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$Stores$Yahoo$DirectURL = F6(
	function (productID, storeID, productName, storeName, url, enabled) {
		return {fl: enabled, cR: productID, nk: productName, da: storeID, kS: storeName, eD: url};
	});
var $author$project$Pages$Cms$Stores$Yahoo$directURLsDecoder = $elm$json$Json$Decode$list(
	A7(
		$elm$json$Json$Decode$map6,
		$author$project$Pages$Cms$Stores$Yahoo$DirectURL,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'direct_url',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(''),
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))),
		A2($elm$json$Json$Decode$field, 'enabled', $elm$json$Json$Decode$bool)));
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.nH));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Api$postWhatever = F4(
	function (path, session, body, msg) {
		var apiConf = $author$project$Session$getConfig(session);
		var config = {
			dp: $elm$http$Http$jsonBody(body),
			dC: $elm$http$Http$expectWhatever(msg),
			dE: $author$project$Api$makeAuthHeader(session),
			d0: $author$project$Api$decodeHTTPMethod(1),
			ew: $elm$core$Maybe$Nothing,
			ez: $elm$core$Maybe$Nothing,
			eD: A3(
				$author$project$Api$makeEndpoint,
				apiConf,
				_List_fromArray(
					[path]),
				_List_Nil)
		};
		return $elm$http$Http$request(config);
	});
var $author$project$Pages$Cms$Stores$Yahoo$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fC: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kn: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var userID = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cx: false, fJ: true, bU: userID}),
					A4(
						$author$project$Api$get,
						$author$project$Endpoints$Cms$yahooEndpoints.me(
							_List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'user_id', userID)
								])),
						model.C,
						$author$project$Utils$Decoders$productsDecoder,
						$author$project$Pages$Cms$Stores$Yahoo$GotProducts));
			case 4:
				var productID = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cx: true, ii: productID}),
					A4(
						$author$project$Api$get,
						$author$project$Endpoints$Cms$yahooEndpoints.mc(
							_List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'product_id', productID),
									A2($elm$url$Url$Builder$string, 'user_id', model.bU)
								])),
						model.C,
						$author$project$Pages$Cms$Stores$Yahoo$directURLsDecoder,
						$author$project$Pages$Cms$Stores$Yahoo$GotDirectURLs));
			case 5:
				var productID = msg.a;
				var storeID = msg.b;
				var url = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2(
									$elm_community$list_extra$List$Extra$updateIf,
									function (data) {
										return _Utils_eq(data.cR, productID) && _Utils_eq(data.da, storeID);
									},
									function (data) {
										return _Utils_update(
											data,
											{eD: url});
									}),
								model.aY)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var productID = msg.a;
				var storeID = msg.b;
				var enabled = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2(
									$elm_community$list_extra$List$Extra$updateIf,
									function (data) {
										return _Utils_eq(data.cR, productID) && _Utils_eq(data.da, storeID);
									},
									function (data) {
										return _Utils_update(
											data,
											{fl: enabled});
									}),
								model.aY)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var directURL = msg.a;
				return _Utils_Tuple2(
					model,
					A4(
						$author$project$Api$postWhatever,
						$author$project$Endpoints$Cms$yahooEndpoints._(_List_Nil),
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'user_id',
									$elm$json$Json$Encode$string(model.bU)),
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(directURL.cR)),
									_Utils_Tuple2(
									'store_id',
									$elm$json$Json$Encode$int(directURL.da)),
									_Utils_Tuple2(
									'direct_url',
									$elm$json$Json$Encode$string(directURL.eD)),
									_Utils_Tuple2(
									'enabled',
									$elm$json$Json$Encode$bool(directURL.fl))
								])),
						$author$project$Pages$Cms$Stores$Yahoo$GotSubmitResponse));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Cms$updateWithCmsModel = F3(
	function (toMsg, cmsModel, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_Tuple2(cmsModel, subModel),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Pages$Cms$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model);
		_v0$25:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (_v0.b.a.$ === 1) {
						var espMsg = _v0.a.a;
						var _v1 = _v0.b;
						var espModel = _v1.a.a;
						var navModel = _v1.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditStoreProperties,
							$author$project$Pages$Cms$GotEditStorePropertiesMsg,
							navModel,
							A2($author$project$Pages$Cms$Stores$EditStoreProperties$update, espMsg, espModel));
					} else {
						break _v0$25;
					}
				case 1:
					if (_v0.b.a.$ === 2) {
						var espMsg = _v0.a.a;
						var _v2 = _v0.b;
						var espModel = _v2.a.a;
						var navModel = _v2.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditPermalinkGroups,
							$author$project$Pages$Cms$GotEditPermalinkGroupsMsg,
							navModel,
							A2($author$project$Pages$Cms$Stores$EditPermalinkGroups$update, espMsg, espModel));
					} else {
						break _v0$25;
					}
				case 2:
					if (_v0.b.a.$ === 3) {
						var espMsg = _v0.a.a;
						var _v3 = _v0.b;
						var espModel = _v3.a.a;
						var navModel = _v3.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditStoreGroups,
							$author$project$Pages$Cms$GotEditStoreGroupsMsg,
							navModel,
							A2($author$project$Pages$Cms$Stores$EditStoreGroups$update, espMsg, espModel));
					} else {
						break _v0$25;
					}
				case 3:
					if (_v0.b.a.$ === 4) {
						var espMsg = _v0.a.a;
						var _v4 = _v0.b;
						var espModel = _v4.a.a;
						var navModel = _v4.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditMailAddress,
							$author$project$Pages$Cms$GotEditMailAddressMsg,
							navModel,
							A2($author$project$Pages$Cms$Others$EditMailAddress$update, espMsg, espModel));
					} else {
						break _v0$25;
					}
				case 21:
					if (_v0.b.a.$ === 5) {
						var espMsg = _v0.a.a;
						var _v5 = _v0.b;
						var espModel = _v5.a.a;
						var navModel = _v5.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$GetAccessCount,
							$author$project$Pages$Cms$GotGetAccessCountMsg,
							navModel,
							A2($author$project$Pages$Cms$Others$GetAccessCount$update, espMsg, espModel));
					} else {
						break _v0$25;
					}
				case 4:
					if (_v0.b.a.$ === 6) {
						var espMsg = _v0.a.a;
						var _v6 = _v0.b;
						var espModel = _v6.a.a;
						var navModel = _v6.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditUsersStores,
							$author$project$Pages$Cms$GotEditUsersStoresMsg,
							navModel,
							A2($author$project$Pages$Cms$Stores$EditUsersStores$update, espMsg, espModel));
					} else {
						break _v0$25;
					}
				case 8:
					if (_v0.b.a.$ === 10) {
						var uwMsg = _v0.a.a;
						var _v7 = _v0.b;
						var uwModel = _v7.a.a;
						var navModel = _v7.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UpdateWeek30ByCsv,
							$author$project$Pages$Cms$GotUpdateWeek30ByCsv,
							navModel,
							A2($author$project$Pages$Cms$Products$UpdateWeek30ByCsv$update, uwMsg, uwModel));
					} else {
						break _v0$25;
					}
				case 9:
					if (_v0.b.a.$ === 11) {
						var uwMsg = _v0.a.a;
						var _v8 = _v0.b;
						var uwModel = _v8.a.a;
						var navModel = _v8.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UpdateTletProductsByCsv,
							$author$project$Pages$Cms$GotUpdateTletProductsByCsv,
							navModel,
							A2($author$project$Pages$Cms$Products$UpdateTletProductsByCsv$update, uwMsg, uwModel));
					} else {
						break _v0$25;
					}
				case 10:
					if (_v0.b.a.$ === 12) {
						var uwMsg = _v0.a.a;
						var _v9 = _v0.b;
						var uwModel = _v9.a.a;
						var navModel = _v9.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UpdateTescomProductsByCsv,
							$author$project$Pages$Cms$GotUpdateTescomProductsByCsv,
							navModel,
							A2($author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$update, uwMsg, uwModel));
					} else {
						break _v0$25;
					}
				case 5:
					if (_v0.b.a.$ === 7) {
						var uwMsg = _v0.a.a;
						var _v10 = _v0.b;
						var uwModel = _v10.a.a;
						var navModel = _v10.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UpdateHitachiWeeklyProductsByCsv,
							$author$project$Pages$Cms$GotUpdateHitachiWeeklyProductsByCsv,
							navModel,
							A2($author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$update, uwMsg, uwModel));
					} else {
						break _v0$25;
					}
				case 6:
					if (_v0.b.a.$ === 8) {
						var uwMsg = _v0.a.a;
						var _v11 = _v0.b;
						var uwModel = _v11.a.a;
						var navModel = _v11.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UpdateHitachiProductsOrderByCsv,
							$author$project$Pages$Cms$GotUpdateHIitachiProductsOrderByCsv,
							navModel,
							A2($author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$update, uwMsg, uwModel));
					} else {
						break _v0$25;
					}
				case 7:
					if (_v0.b.a.$ === 9) {
						var uwMsg = _v0.a.a;
						var _v12 = _v0.b;
						var uwModel = _v12.a.a;
						var navModel = _v12.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UpdateSharpProductsByCsv,
							$author$project$Pages$Cms$GotUpdateSharpProductsByCsv,
							navModel,
							A2($author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$update, uwMsg, uwModel));
					} else {
						break _v0$25;
					}
				case 12:
					if (_v0.b.a.$ === 14) {
						var reiMsg = _v0.a.a;
						var _v13 = _v0.b;
						var reiModel = _v13.a.a;
						var navModel = _v13.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$RakutenExcludedItems,
							$author$project$Pages$Cms$GotRakutenExcludedItems,
							navModel,
							A2($author$project$Pages$Cms$Products$RakutenExcludedItems$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 11:
					if (_v0.b.a.$ === 13) {
						var reiMsg = _v0.a.a;
						var _v14 = _v0.b;
						var reiModel = _v14.a.a;
						var navModel = _v14.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UserSpecificRoutingModel,
							$author$project$Pages$Cms$GotUserSpecificRoutingMsg,
							navModel,
							A2($author$project$Pages$Cms$Products$UserSpecificRouting$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 13:
					if (_v0.b.a.$ === 15) {
						var reiMsg = _v0.a.a;
						var _v15 = _v0.b;
						var reiModel = _v15.a.a;
						var navModel = _v15.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$ChangeDisplayIntervalModel,
							$author$project$Pages$Cms$GotChangeDisplayIntervalMsg,
							navModel,
							A2($author$project$Pages$Cms$Products$ChangeDisplayInterval$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 14:
					if (_v0.b.a.$ === 16) {
						var reiMsg = _v0.a.a;
						var _v16 = _v0.b;
						var reiModel = _v16.a.a;
						var navModel = _v16.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$ChangeUserProductModel,
							$author$project$Pages$Cms$GotChangeUserProductMsg,
							navModel,
							A2($author$project$Pages$Cms$Products$ChangeUserProduct$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 15:
					if (_v0.b.a.$ === 17) {
						var reiMsg = _v0.a.a;
						var _v17 = _v0.b;
						var reiModel = _v17.a.a;
						var navModel = _v17.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$AddProductConfigModel,
							$author$project$Pages$Cms$GotAddProductConfigMsg,
							navModel,
							A2($author$project$Pages$Cms$Products$AddProductConfig$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 16:
					if (_v0.b.a.$ === 18) {
						var reiMsg = _v0.a.a;
						var _v18 = _v0.b;
						var reiModel = _v18.a.a;
						var navModel = _v18.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$ChangeDisplayOrderModel,
							$author$project$Pages$Cms$GotChangeDisplayOrderMsg,
							navModel,
							A2($author$project$Pages$Cms$Products$ChangeDisplayOrder$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 17:
					if (_v0.b.a.$ === 19) {
						var reiMsg = _v0.a.a;
						var _v19 = _v0.b;
						var reiModel = _v19.a.a;
						var navModel = _v19.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditProductsPermalinks,
							$author$project$Pages$Cms$GotEditProductsPermalinks,
							navModel,
							A2($author$project$Pages$Cms$Products$EditProductsPermalinks$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 18:
					if (_v0.b.a.$ === 20) {
						var reiMsg = _v0.a.a;
						var _v20 = _v0.b;
						var reiModel = _v20.a.a;
						var navModel = _v20.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditProducts,
							$author$project$Pages$Cms$GotEditProducts,
							navModel,
							A2($author$project$Pages$Cms$Products$EditProducts$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				case 19:
					var navMsg = _v0.a.a;
					var _v21 = _v0.b;
					var cmsModel = _v21.a;
					var navModel = _v21.b;
					return A3(
						$author$project$Pages$Cms$updateWithCmsModel,
						$author$project$Pages$Cms$GotNavBarMsg,
						cmsModel,
						A2($author$project$Components$NavBar$update, navMsg, navModel));
				case 20:
					if (_v0.b.a.$ === 21) {
						var espMsg = _v0.a.a;
						var _v22 = _v0.b;
						var espModel = _v22.a.a;
						var navModel = _v22.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditStores,
							$author$project$Pages$Cms$GotEditStoresMsg,
							navModel,
							A2($author$project$Pages$Cms$Stores$EditStores$update, espMsg, espModel));
					} else {
						break _v0$25;
					}
				case 22:
					if (_v0.b.a.$ === 22) {
						var yMsg = _v0.a.a;
						var _v23 = _v0.b;
						var yModel = _v23.a.a;
						var navModel = _v23.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$Yahoo,
							$author$project$Pages$Cms$GotYahooMsg,
							navModel,
							A2($author$project$Pages$Cms$Stores$Yahoo$update, yMsg, yModel));
					} else {
						break _v0$25;
					}
				case 23:
					if (_v0.b.a.$ === 23) {
						var reiMsg = _v0.a.a;
						var _v24 = _v0.b;
						var reiModel = _v24.a.a;
						var navModel = _v24.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$EditSoldoutProducts,
							$author$project$Pages$Cms$GotEditSoldoutProductsMsg,
							navModel,
							A2($author$project$Pages$Cms$Products$EditSoldoutProducts$update, reiMsg, reiModel));
					} else {
						break _v0$25;
					}
				default:
					if (_v0.b.a.$ === 24) {
						var uwMsg = _v0.a.a;
						var _v25 = _v0.b;
						var uwModel = _v25.a.a;
						var navModel = _v25.b;
						return A4(
							$author$project$Pages$Cms$updateWithNavModel,
							$author$project$Pages$Cms$UpdateFujiWeeklyProductsByCsv,
							$author$project$Pages$Cms$GotUpdateFujiWeeklyProductsByCsv,
							navModel,
							A2($author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$update, uwMsg, uwModel));
					} else {
						break _v0$25;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Login$FormSent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Login$LoginPayload = F3(
	function (token, isAdmin, userName) {
		return {hK: isAdmin, iC: token, n2: userName};
	});
var $author$project$Endpoints$Login$login = A2(
	$elm$url$Url$Builder$absolute,
	_List_fromArray(
		['login']),
	_List_Nil);
var $author$project$Api$storeUserInfo = _Platform_outgoingPort('storeUserInfo', $elm$core$Basics$identity);
var $author$project$Pages$Login$updateForm = F2(
	function (model, f) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					a5: f(model.a5)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Login$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var input = msg.a;
				return A2(
					$author$project$Pages$Login$updateForm,
					model,
					function (form) {
						return _Utils_update(
							form,
							{n2: input});
					});
			case 2:
				var input = msg.a;
				return A2(
					$author$project$Pages$Login$updateForm,
					model,
					function (form) {
						return _Utils_update(
							form,
							{d7: input});
					});
			case 0:
				var decoder = A4(
					$elm$json$Json$Decode$map3,
					$author$project$Pages$Login$LoginPayload,
					A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'isAdmin', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'userName', $elm$json$Json$Decode$string));
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'username',
							$elm$json$Json$Encode$string(model.a5.n2)),
							_Utils_Tuple2(
							'password',
							$elm$json$Json$Encode$string(model.a5.d7))
						]));
				return _Utils_Tuple2(
					model,
					A5($author$project$Api$post, $author$project$Endpoints$Login$login, model.C, body, decoder, $author$project$Pages$Login$FormSent));
			default:
				if (!msg.a.$) {
					var loginPayload = msg.a.a;
					var msg_ = $author$project$Api$storeUserInfo(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'token',
									$elm$json$Json$Encode$string(loginPayload.iC)),
									_Utils_Tuple2(
									'isAdmin',
									$elm$json$Json$Encode$bool(loginPayload.hK)),
									_Utils_Tuple2(
									'userName',
									$elm$json$Json$Encode$string(loginPayload.n2))
								])));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing}),
						msg_);
				} else {
					var e = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(e))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$BraunComnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {fd: d, mQ: m, ob: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		h$: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		ob: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.ob, 0, date.h$);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.ob - 1)) + ($justinmimbs$date$Date$monthToNumber(date.mQ) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.fd,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {ho: current, J: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {is: standardOffset, iJ: zoneRules};
	});
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {aW: clock, fd: day, mQ: month, gT: time, ob: year};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.it <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.b, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var standard = _v0.bj;
		var save = _v0.nt;
		switch (clock) {
			case 0:
				return 0;
			case 1:
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var year = _v0.ob;
	var month = _v0.mQ;
	var day = _v0.fd;
	var time = _v0.gT;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.aW, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.it;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								aW: rule.aW,
								nt: rule.nt,
								it: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.fd;
										switch (_v2.$) {
											case 0:
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.mQ, day);
											case 1:
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.mQ, after));
											case 2:
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.mQ, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.mQ));
										}
									}()) + rule.gT
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.jq, year) < 1) && (_Utils_cmp(year, rule.k_) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.ob - 1, until.ob));
		var initialOffset = {nt: 0, bj: standardOffset};
		var initialChange = {
			b: standardOffset,
			it: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {nt: transition.nt, bj: standardOffset};
					if (_Utils_cmp(
						transition.it + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aW, previousOffset),
						initialChange.it) < 1) {
						var updatedInitialChange = {b: standardOffset + transition.nt, it: initialChange.it};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.it + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aW, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								b: standardOffset + transition.nt,
								it: transition.it + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.aW, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var standardOffset = _v0.is;
		var zoneRules = _v0.iJ;
		if (!zoneRules.$) {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						b: standardOffset + save,
						it: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{nt: save, bj: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.J);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.ho, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.J;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.ho;
			}
		}();
		var initialOffset = {
			nt: function () {
				var _v4 = initialState.iJ;
				if (!_v4.$) {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			bj: initialState.is
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.b;
			},
			initialOffset.bj + initialOffset.nt,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, 0, 1, 0, 0),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, 0, 1, 0, 0),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.bj + initialOffset.nt, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Api$createFixedMidashi = _Platform_outgoingPort(
	'createFixedMidashi',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $justinmimbs$time_extra$Time$Extra$Parts = F7(
	function (year, month, day, hour, minute, second, millisecond) {
		return {fd: day, mj: hour, mM: millisecond, mO: minute, mQ: month, ny: second, ob: year};
	});
var $author$project$Utils$Helpers$intToMonth = function (num) {
	switch (num) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		case 12:
			return 11;
		default:
			return 0;
	}
};
var $author$project$Utils$Helpers$dateTimeToParts = F2(
	function (date, time) {
		var timeList = A2(
			$elm$core$List$take,
			2,
			A2($elm$core$String$split, ':', time));
		var dateList = A2(
			$elm$core$List$take,
			3,
			A2($elm$core$String$split, '-', date));
		var _v0 = _Utils_Tuple2(dateList, timeList);
		if ((((((_v0.a.b && _v0.a.b.b) && _v0.a.b.b.b) && (!_v0.a.b.b.b.b)) && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var _v1 = _v0.a;
			var year = _v1.a;
			var _v2 = _v1.b;
			var month = _v2.a;
			var _v3 = _v2.b;
			var day = _v3.a;
			var _v4 = _v0.b;
			var hour = _v4.a;
			var _v5 = _v4.b;
			var minute = _v5.a;
			var _v6 = _List_fromArray(
				[
					$elm$core$String$toInt(year),
					$elm$core$String$toInt(month),
					$elm$core$String$toInt(day),
					$elm$core$String$toInt(hour),
					$elm$core$String$toInt(minute)
				]);
			if ((((((((((_v6.b && (!_v6.a.$)) && _v6.b.b) && (!_v6.b.a.$)) && _v6.b.b.b) && (!_v6.b.b.a.$)) && _v6.b.b.b.b) && (!_v6.b.b.b.a.$)) && _v6.b.b.b.b.b) && (!_v6.b.b.b.b.a.$)) && (!_v6.b.b.b.b.b.b)) {
				var iyear = _v6.a.a;
				var _v7 = _v6.b;
				var imonth = _v7.a.a;
				var _v8 = _v7.b;
				var iday = _v8.a.a;
				var _v9 = _v8.b;
				var ihour = _v9.a.a;
				var _v10 = _v9.b;
				var iminute = _v10.a.a;
				return $elm$core$Maybe$Just(
					A7(
						$justinmimbs$time_extra$Time$Extra$Parts,
						iyear,
						$author$project$Utils$Helpers$intToMonth(imonth),
						iday,
						ihour,
						iminute,
						0,
						0));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $author$project$Utils$Helpers$flip = function (f) {
	return F2(
		function (a, b) {
			return A2(f, b, a);
		});
};
var $author$project$Utils$Helpers$floorTimeByInterval = F2(
	function (parts, interval) {
		return function (minute) {
			return _Utils_update(
				parts,
				{mO: minute});
		}(interval * ((parts.mO / interval) | 0));
	});
var $author$project$Utils$Helpers$formatTime = F2(
	function (hour, minute) {
		return A2(
			$elm$core$String$right,
			2,
			'0' + $elm$core$String$fromInt(hour)) + (':' + A2(
			$elm$core$String$right,
			2,
			'0' + $elm$core$String$fromInt(minute)));
	});
var $author$project$Utils$Helpers$formatDateTime = function (parts) {
	return A3($author$project$Utils$Helpers$formatDate, parts.ob, parts.mQ, parts.fd) + (' ' + A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO));
};
var $author$project$Pages$Users$BraunComnet$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Utils$Types$Price = function (productId) {
	return function (storeId) {
		return function (dateTime) {
			return function (price) {
				return function (priceIncludeTax) {
					return function (point) {
						return function (priceWithoutPoint) {
							return function (coupon) {
								return function (isLatest) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, fH: isLatest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Utils$Decoders$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'is_latest', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Utils$Types$Price))))))))))));
var $author$project$Utils$Decoders$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Utils$Decoders$priceDecoder)));
var $author$project$Utils$Types$StoreGroup = F3(
	function (storeGroupId, storeGroupName, stores) {
		return {iv: storeGroupId, kR: storeGroupName, aN: stores};
	});
var $author$project$Utils$Decoders$storeGroupsDecoder = $elm$json$Json$Decode$list(
	A4(
		$elm$json$Json$Decode$map3,
		$author$project$Utils$Types$StoreGroup,
		A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder)));
var $author$project$Pages$Users$BraunComnet$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$BraunComnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Pages$Users$BraunComnet$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$BraunComnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$BraunComnet$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$BraunComnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $elm$core$Basics$pow = _Basics_pow;
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $author$project$Utils$Helpers$splitRight3 = F2(
	function (str, lst) {
		splitRight3:
		while (true) {
			if (str === '') {
				return lst;
			} else {
				var right = A2($elm$core$String$right, 3, str);
				var rest = A2($elm$core$String$dropRight, 3, str);
				var $temp$str = rest,
					$temp$lst = A2($elm$core$List$cons, right, lst);
				str = $temp$str;
				lst = $temp$lst;
				continue splitRight3;
			}
		}
	});
var $author$project$Utils$Helpers$toCommmaSplited = function (src) {
	return A2(
		$elm$core$String$join,
		',',
		A2($author$project$Utils$Helpers$splitRight3, src, _List_Nil));
};
var $author$project$Pages$Users$BraunComnet$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				if (product.nk === 'blank') {
					return _List_Nil;
				} else {
					var maybeYodobashiPrice = A2(
						$elm$core$Dict$get,
						_Utils_Tuple2(product.kl, 7),
						model.cQ);
					var lowestPrice = A3(
						$elm$core$List$foldl,
						function (price) {
							return function (m) {
								return A2($elm$core$Basics$min, m, price);
							};
						},
						A2($elm$core$Basics$pow, 2, 30),
						A2(
							$elm$core$List$map,
							function (maybePrice) {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
								} else {
									return A2($elm$core$Basics$pow, 2, 30);
								}
							},
							A2(
								$elm$core$List$map,
								function (store) {
									return A2(
										$elm$core$Dict$get,
										_Utils_Tuple2(product.kl, store.iw),
										model.cQ);
								},
								stores)));
					var itemList = _List_fromArray(
						[
							{jP: '税抜き', m: 0},
							{jP: '税込み', m: 1},
							{jP: 'P/クーポン', m: 2},
							{jP: 'P後', m: 3},
							{jP: '取得時刻', m: 4},
							{jP: '工事費', m: 5}
						]);
					var filterItemList = function (list) {
						return A2(
							$elm$core$List$map,
							function (i) {
								return A2(
									$elm$core$Maybe$withDefault,
									{jP: '', m: -1},
									A2($elm_community$list_extra$List$Extra$getAt, i, list));
							},
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(
									'DisplayAll',
									_List_fromArray(
										[0, 1, 2, 3, 4, 5])),
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (dispToValue) {
										return _Utils_eq(dispToValue.a, model.c_);
									},
									$author$project$Pages$Users$BraunComnet$Hour$displayStyleToValues)).b);
					};
					var filteredItemList = filterItemList(itemList);
					var _v0 = function () {
						var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
						if (_v1.a && (!_v1.b.$)) {
							var yodobashiPrice = _v1.b.a;
							return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
						} else {
							return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
						}
					}();
					var basePrice = _v0.lt;
					var basePriceIncludeTax = _v0.eY;
					var basePoint = _v0.ls;
					var basePriceWithoutPoint = _v0.cb;
					var basePriceList = _List_fromArray(
						[
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePrice)),
							m: 0
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePriceIncludeTax)),
							m: 1
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePoint)),
							m: 2
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePriceWithoutPoint)),
							m: 3
						},
							{jP: '-', m: 4},
							{jP: '-', m: 5}
						]);
					var filteredBasePriceList = filterItemList(basePriceList);
					return _Utils_ap(
						_List_fromArray(
							[
								$author$project$Pages$Users$BraunComnet$Hour$ProductPriceHeader(
								_List_fromArray(
									[
										{
										jP: $elm$core$String$fromInt(ind + 1),
										m: 0
									}
									])),
								$author$project$Pages$Users$BraunComnet$Hour$ProductPriceHeader(
								_List_fromArray(
									[
										{jP: product.nk, m: 0}
									])),
								$author$project$Pages$Users$BraunComnet$Hour$ProductPriceHeader(filteredItemList),
								$author$project$Pages$Users$BraunComnet$Hour$ProductPriceHeader(filteredBasePriceList)
							]),
						A2(
							$elm$core$List$map,
							function (store) {
								var maybePrice = A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
								var isLowest = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return _Utils_eq(price.be, lowestPrice);
									} else {
										return false;
									}
								}();
								var isLowestButHigherThanBase = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
										if (_v7.a && (!_v7.b.$)) {
											var yodobashiPrice = _v7.b.a;
											return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
										} else {
											return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										}
									} else {
										return false;
									}
								}();
								var isLower = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										var _v5 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
										if (_v5.a && (!_v5.b.$)) {
											var yodobashiPrice = _v5.b.a;
											return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
										} else {
											return _Utils_cmp(price.be, product.cb) < 0;
										}
									} else {
										return false;
									}
								}();
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var priceList = _List_fromArray(
										[
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.kg)),
											m: 0
										},
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.kh)),
											m: 1
										},
											{
											jP: function (point) {
												return _Utils_ap(
													point,
													(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
											}(
												$elm$core$String$fromInt(price.ka)),
											m: 2
										},
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.be)),
											m: 3
										},
											{
											jP: A2(
												$elm$core$Maybe$withDefault,
												'',
												$elm$core$List$head(
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														$elm$core$List$tail(
															A2($elm$core$String$split, ' ', price.lP))))),
											m: 4
										},
											{
											jP: function () {
												var _v3 = price.lG;
												if (_v3.$ === 1) {
													return '0';
												} else {
													var constructionCost = _v3.a;
													return $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(constructionCost));
												}
											}(),
											m: 5
										}
										]);
									var filteredPriceList = filterItemList(priceList);
									return $author$project$Pages$Users$BraunComnet$Hour$ProductPriceData(
										{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
								} else {
									return $author$project$Pages$Users$BraunComnet$Hour$ProductPriceNoData;
								}
							},
							stores));
				}
			};
		},
		products);
};
var $author$project$Pages$Users$BraunComnet$Hour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.ob;
		var month = _v0.mQ;
		var day = _v0.fd;
		var hour = _v0.mj;
		var minute = _v0.mO;
		var second = _v0.ny;
		var millisecond = _v0.mM;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $author$project$Utils$Helpers$roundByInterval = F2(
	function (interval, posix) {
		var minute = posix.mO;
		var mod = A2($elm$core$Basics$modBy, interval, minute);
		return _Utils_update(
			posix,
			{mO: minute - mod});
	});
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $commonmind$elm_csv_encode$Csv$Encode$crlf = $elm$bytes$Bytes$Encode$string('\u000D\n');
var $commonmind$elm_csv_encode$Csv$Encode$escapeString = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split('\"'),
	$elm$core$String$join('\"\"'));
var $commonmind$elm_csv_encode$Csv$Encode$formatField = function (s) {
	return '\"' + ($commonmind$elm_csv_encode$Csv$Encode$escapeString(s) + '\"');
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $commonmind$elm_csv_encode$Csv$Encode$formatRow = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($commonmind$elm_csv_encode$Csv$Encode$formatField),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$intersperse(','),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($elm$bytes$Bytes$Encode$string),
			$elm$bytes$Bytes$Encode$sequence)));
var $commonmind$elm_csv_encode$Csv$Encode$formatLines = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map($commonmind$elm_csv_encode$Csv$Encode$formatRow),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$intersperse($commonmind$elm_csv_encode$Csv$Encode$crlf),
		$elm$bytes$Bytes$Encode$sequence));
var $commonmind$elm_csv_encode$Csv$Encode$toEncoder = function (_v0) {
	var headers = _v0.dE;
	var records = _v0.no;
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				$commonmind$elm_csv_encode$Csv$Encode$formatLines(
				A2($elm$core$List$cons, headers, records)),
				$commonmind$elm_csv_encode$Csv$Encode$crlf
			]));
};
var $commonmind$elm_csv_encode$Csv$Encode$toBytes = A2($elm$core$Basics$composeR, $commonmind$elm_csv_encode$Csv$Encode$toEncoder, $elm$bytes$Bytes$Encode$encode);
var $author$project$Pages$Users$BraunComnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$BraunComnet$Hour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $author$project$Pages$Users$BraunComnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$BraunComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$BraunComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$BraunComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$BraunComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$BraunComnet$Hour$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$BraunComnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$BraunComnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$BraunComnet$Wide$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Utils$Helpers$filterBySelector = F4(
	function (selectedMakerId, selectedBigCategoryId, selectedSmallCategoryId, products) {
		return A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(
					selectedSmallCategoryId,
					$elm$core$Maybe$Just(-1)) || _Utils_eq(
					$elm$core$Maybe$Just(p.ir),
					selectedSmallCategoryId);
			},
			A2(
				$elm$core$List$filter,
				function (p) {
					return _Utils_eq(
						selectedBigCategoryId,
						$elm$core$Maybe$Just(-1)) || _Utils_eq(
						$elm$core$Maybe$Just(p.e_),
						selectedBigCategoryId);
				},
				A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							selectedMakerId,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.jW),
							selectedMakerId);
					},
					products)));
	});
var $author$project$Pages$Users$BraunComnet$Wide$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$BraunComnet$Wide$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$BraunComnet$Wide$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$BraunComnet$Wide$Price))))))))))));
var $author$project$Pages$Users$BraunComnet$Wide$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$BraunComnet$Wide$priceDecoder)));
var $author$project$Pages$Users$BraunComnet$Wide$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$BraunComnet$Wide$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$BraunComnet$Wide$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $Herteby$url_builder_plus$UrlBuilderPlus$list = F3(
	function (encoder, key, values) {
		return _Utils_eq(values, _List_Nil) ? $Herteby$url_builder_plus$UrlBuilderPlus$None : A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$string,
			key,
			A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$filterMap,
					function (p) {
						if (!p.$) {
							var str = p.b;
							return $elm$core$Maybe$Just(str);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					A2(
						$elm$core$List$map,
						encoder(''),
						values))));
	});
var $author$project$Pages$Users$BraunComnet$Wide$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$Lower = 1;
var $author$project$Pages$Users$BraunComnet$Wide$Lowest = 0;
var $author$project$Pages$Users$BraunComnet$Wide$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$BraunComnet$Wide$Normal = 3;
var $author$project$Pages$Users$BraunComnet$Wide$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$BraunComnet$Wide$Unchanged = {$: 2};
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.mQ;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$toFractionalDay = F2(
	function (zone, posix) {
		return A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix) / 86400000;
	});
var $justinmimbs$time_extra$Time$Extra$toMonths = F2(
	function (zone, posix) {
		var wholeMonths = (12 * (A2($elm$time$Time$toYear, zone, posix) - 1)) + ($justinmimbs$date$Date$monthToNumber(
			A2($elm$time$Time$toMonth, zone, posix)) - 1);
		var fractionalMonth = (A2($elm$time$Time$toDay, zone, posix) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix)) / 100;
		return wholeMonths + fractionalMonth;
	});
var $justinmimbs$time_extra$Time$Extra$toRataDieMoment = F2(
	function (zone, posix) {
		return $justinmimbs$date$Date$toRataDie(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$toFractionalDay, zone, posix);
	});
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$time_extra$Time$Extra$diff = F4(
	function (interval, zone, posix1, posix2) {
		diff:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$posixToMillis(posix2) - $elm$time$Time$posixToMillis(posix1);
				case 14:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 1000) | 0;
				case 13:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 60000) | 0;
				case 12:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 15, zone, posix1, posix2) / 3600000) | 0;
				case 11:
					return (A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toRataDieMoment, zone, posix1)) | 0;
				case 2:
					return (A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix2) - A2($justinmimbs$time_extra$Time$Extra$toMonths, zone, posix1)) | 0;
				case 0:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 12) | 0;
				case 1:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 2, zone, posix1, posix2) / 3) | 0;
				case 3:
					return (A4($justinmimbs$time_extra$Time$Extra$diff, 11, zone, posix1, posix2) / 7) | 0;
				default:
					var weekday = interval;
					var $temp$interval = 3,
						$temp$zone = zone,
						$temp$posix1 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix1),
						$temp$posix2 = A3($justinmimbs$time_extra$Time$Extra$floor, weekday, zone, posix2);
					interval = $temp$interval;
					zone = $temp$zone;
					posix1 = $temp$posix1;
					posix2 = $temp$posix2;
					continue diff;
			}
		}
	});
var $author$project$Pages$Users$BraunComnet$Wide$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Utils$Helpers$formatDateWithoutYear = F2(
	function (month, day) {
		return A2(
			$elm$core$String$right,
			2,
			'0' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Utils$Helpers$monthToInt)(month)) + ('-' + A2(
			$elm$core$String$right,
			2,
			'0' + $elm$core$String$fromInt(day)));
	});
var $author$project$Utils$Helpers$formatDateTimeWithoutYear = function (parts) {
	return A2($author$project$Utils$Helpers$formatDateWithoutYear, parts.mQ, parts.fd) + (' ' + A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO));
};
var $author$project$Pages$Users$BraunComnet$Wide$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$BraunComnet$Wide$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$BraunComnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$BraunComnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$BraunComnet$Wide$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$BraunComnet$Wide$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$BraunComnet$Wide$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$BraunComnet$Wide$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$BraunComnet$Wide$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$BraunComnet$Wide$Unchanged);
											} else {
												return $author$project$Pages$Users$BraunComnet$Wide$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$BraunComnet$Wide$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$BraunComnet$Wide$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$BraunComnet$Wide$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.ki;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($justinmimbs$date$Date$deadEndToString),
			$elm$core$String$join('; '))));
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.fd;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.h$;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		ld: 1 + (((rd - week1Day1) / 7) | 0),
		le: wy,
		n5: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ld;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.le;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.fT(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.hW(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.fT(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.hq(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.b1(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.b1(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.b1(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.iG(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.b1(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.b1(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.b, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	hq: $justinmimbs$date$Date$withOrdinalSuffix,
	hW: $justinmimbs$date$Date$monthToName,
	fT: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	iG: $justinmimbs$date$Date$weekdayToName,
	b1: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Pages$Users$BraunComnet$Wide$succDate = function (dateString) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(dateString);
	if (!_v0.$) {
		var date = _v0.a;
		return $justinmimbs$date$Date$toIsoString(
			A3($justinmimbs$date$Date$add, 3, 1, date));
	} else {
		return dateString;
	}
};
var $author$project$Utils$Helpers$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$BraunComnet$Wide$insertHendouAfterStoreName = F2(
	function (acc, list) {
		insertHendouAfterStoreName:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var x = list.a;
				var xs = list.b;
				if ($elm$core$List$length(acc) >= 6) {
					var $temp$acc = A2(
						$elm$core$List$cons,
						x,
						A2(
							$elm$core$List$cons,
							{iv: -2, kS: '価格変動'},
							acc)),
						$temp$list = xs;
					acc = $temp$acc;
					list = $temp$list;
					continue insertHendouAfterStoreName;
				} else {
					var $temp$acc = A2($elm$core$List$cons, x, acc),
						$temp$list = xs;
					acc = $temp$acc;
					list = $temp$list;
					continue insertHendouAfterStoreName;
				}
			}
		}
	});
var $author$project$Pages$Users$BraunComnet$Wide$PProductLowerMark = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$PProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$PProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$PProductPriceNoData = {$: 1};
var $author$project$Pages$Users$BraunComnet$Wide$convertBodyToProcBody = function (bodyProductPrice) {
	switch (bodyProductPrice.$) {
		case 0:
			var _v1 = bodyProductPrice.a;
			var rowspan = _v1.a;
			var list = _v1.b;
			return $author$project$Pages$Users$BraunComnet$Wide$PProductPriceHeader(
				_Utils_Tuple2(rowspan, list));
		case 1:
			return $author$project$Pages$Users$BraunComnet$Wide$PProductPriceNoData;
		default:
			var data = bodyProductPrice.a;
			return $author$project$Pages$Users$BraunComnet$Wide$PProductPriceData(
				{du: data.du, ge: data.ge, h6: data.h6, eD: data.eD});
	}
};
var $author$project$Pages$Users$BraunComnet$Wide$insertLowerMark = function (bodyProductPrices) {
	var insertLowerMarkSub = function (bodyProductPrice) {
		if (!bodyProductPrice.b) {
			return _List_Nil;
		} else {
			var x = bodyProductPrice.a;
			var xs = bodyProductPrice.b;
			switch (x.$) {
				case 2:
					var data = x.a;
					var lowerMark = function () {
						var _v2 = data.du;
						switch (_v2) {
							case 0:
								return $author$project$Pages$Users$BraunComnet$Wide$PProductLowerMark(
									{
										dY: _List_fromArray(
											[
												{jP: '●', m: -1}
											])
									});
							case 1:
								return $author$project$Pages$Users$BraunComnet$Wide$PProductLowerMark(
									{
										dY: _List_fromArray(
											[
												{jP: '※', m: -1}
											])
									});
							default:
								return $author$project$Pages$Users$BraunComnet$Wide$PProductLowerMark(
									{
										dY: _List_fromArray(
											[
												{jP: '', m: -1}
											])
									});
						}
					}();
					return A2(
						$elm$core$List$cons,
						$author$project$Pages$Users$BraunComnet$Wide$convertBodyToProcBody(x),
						A2(
							$elm$core$List$cons,
							lowerMark,
							insertLowerMarkSub(xs)));
				case 1:
					var lowerMark = $author$project$Pages$Users$BraunComnet$Wide$PProductLowerMark(
						{
							dY: _List_fromArray(
								[
									{jP: '', m: -1}
								])
						});
					return A2(
						$elm$core$List$cons,
						$author$project$Pages$Users$BraunComnet$Wide$convertBodyToProcBody(x),
						A2(
							$elm$core$List$cons,
							lowerMark,
							insertLowerMarkSub(xs)));
				default:
					return A2(
						$elm$core$List$cons,
						$author$project$Pages$Users$BraunComnet$Wide$convertBodyToProcBody(x),
						insertLowerMarkSub(xs));
			}
		}
	};
	return A2(
		$elm$core$List$map,
		function (productRow) {
			return A2($elm$core$List$map, insertLowerMarkSub, productRow);
		},
		bodyProductPrices);
};
var $author$project$Pages$Users$BraunComnet$Wide$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		var procStoreHeader = A2($author$project$Pages$Users$BraunComnet$Wide$insertHendouAfterStoreName, _List_Nil, storeHeader);
		var procPriceRows = $author$project$Pages$Users$BraunComnet$Wide$insertLowerMark(priceRows);
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					procStoreHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										var top_ind = function () {
											var _v5 = A2($elm_community$list_extra$List$Extra$getAt, 0, indices);
											if (!_v5.$) {
												var x = _v5.a;
												return x;
											} else {
												return 0;
											}
										}();
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											A2(
												$elm$core$List$map,
												function (ind) {
													return A2(
														$elm$core$List$map,
														function (cell) {
															switch (cell.$) {
																case 0:
																	var _v1 = cell.a;
																	var data = _v1.b;
																	var res = function () {
																		var _v2 = A2(
																			$elm$core$List$filter,
																			function (item) {
																				return (_Utils_eq(ind, top_ind) && _Utils_eq(item.m, -1)) || _Utils_eq(item.m, ind);
																			},
																			data);
																		if (!_v2.b) {
																			return $elm$core$Maybe$Nothing;
																		} else {
																			var x = _v2.a;
																			return $elm$core$Maybe$Just(x.jP);
																		}
																	}();
																	return A2($elm$core$Maybe$withDefault, '', res);
																case 1:
																	return '';
																case 2:
																	var data = cell.a;
																	var res = function () {
																		var _v3 = A2(
																			$elm$core$List$filter,
																			function (item) {
																				return _Utils_eq(item.m, ind);
																			},
																			data.h6);
																		if (!_v3.b) {
																			return $elm$core$Maybe$Nothing;
																		} else {
																			var x = _v3.a;
																			return $elm$core$Maybe$Just(x.jP);
																		}
																	}();
																	return A2($elm$core$Maybe$withDefault, '', res);
																default:
																	var data = cell.a;
																	var res = function () {
																		var _v4 = A2(
																			$elm$core$List$filter,
																			function (item) {
																				return (_Utils_eq(ind, top_ind) && _Utils_eq(item.m, -1)) || _Utils_eq(item.m, ind);
																			},
																			data.dY);
																		if (!_v4.b) {
																			return $elm$core$Maybe$Nothing;
																		} else {
																			var x = _v4.a;
																			return $elm$core$Maybe$Just(x.jP);
																		}
																	}();
																	return A2($elm$core$Maybe$withDefault, '', res);
															}
														},
														row);
												},
												indices));
									};
								},
								priceRow));
					},
					procPriceRows))
		};
	});
var $author$project$Pages$Users$BraunComnet$Wide$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date, cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:00'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$BraunComnet$Wide$getPriceResponseDecoder,
								$author$project$Pages$Users$BraunComnet$Wide$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				var bigCategoryId = msg.a;
				var selectedBigCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategoryId);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var makerId = msg.a;
				var selectedMakerId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A4($author$project$Utils$Helpers$filterBySelector, selectedMakerId, model.ig, model.gD, model.c1)),
								_List_Nil),
							eh: selectedMakerId
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$BraunComnet$Wide$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: $author$project$Pages$Users$BraunComnet$Wide$succDate(model.cY),
								et: '00:00',
								gQ: '00:00',
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 9:
				var storeHeader = A2($author$project$Pages$Users$BraunComnet$Wide$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$BraunComnet$Wide$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$BraunComnet$Wide$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$AllStores = 2;
var $author$project$Pages$Users$Ca6Comnet$Csv$CsvRequestSent = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$SelectedStores = 1;
var $author$project$Pages$Users$Ca6Comnet$Csv$CsvResponse = function (filenames) {
	return {co: filenames};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$csvResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Ca6Comnet$Csv$CsvResponse,
	A2(
		$elm$json$Json$Decode$field,
		'filenames',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
var $author$project$Pages$Users$Ca6Comnet$Csv$filterProducts = function (model) {
	return A4(
		$author$project$Utils$Helpers$filterBySelector,
		model.eh,
		model.ig,
		model.gD,
		function () {
			var _v0 = model.ei;
			if (!_v0) {
				return model.kn;
			} else {
				return model.cS;
			}
		}());
};
var $Herteby$url_builder_plus$UrlBuilderPlus$int = F2(
	function (key, value) {
		return A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Api$makeCsvEndpoint = F3(
	function (config, paths, queryParam) {
		var url = A2($author$project$Api$makeUrl, config.iS, config.iT);
		return _Utils_ap(
			url,
			A2(
				$elm$url$Url$Builder$absolute,
				A2($elm$core$List$cons, 'csv', paths),
				queryParam));
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$updateMultiselect = function (model) {
	return _Utils_update(
		model,
		{
			E: A3(
				$inkuzmin$elm_multiselect$Multiselect$populateValues,
				model.E,
				A2(
					$elm$core$List$map,
					function (p) {
						return _Utils_Tuple2(p.kl, p.nk);
					},
					$author$project$Pages$Users$Ca6Comnet$Csv$filterProducts(model)),
				_List_Nil)
		});
};
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Pages$Users$Ca6Comnet$Csv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 16:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d_: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							d1: function (parts) {
								return A3($author$project$Utils$Helpers$formatDate, parts.ob, parts.mQ, parts.fd);
							}(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										11,
										-2,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											date)))),
							cY: function (parts) {
								return A3($author$project$Utils$Helpers$formatDate, parts.ob, parts.mQ, parts.fd);
							}(
								function (parts) {
									return _Utils_update(
										parts,
										{mj: 0, mM: 0, mO: 0, ny: 0});
								}(date)),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: '00:00',
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var bigCategoryId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ig: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(bigCategoryId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Csv$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 4:
				var smallCategoryId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						gD: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(smallCategoryId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Csv$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 5:
				var makerId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						eh: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(makerId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Csv$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 2:
				var sub = msg.a;
				var _v1 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v1.a;
				var subCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeProduct, subCmd));
			case 6:
				var mode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bT: mode}),
					$author$project$Api$createFixedMidashi(0));
			case 7:
				var mode = msg.a;
				var newModel = _Utils_update(
					model,
					{ei: mode});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Csv$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 8:
				var canonGroup = msg.a;
				var toggle = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: function () {
								var visibility = model.aF;
								var toggleKey = F2(
									function (key, set) {
										return toggle ? A2($elm$core$Set$insert, key, set) : A2($elm$core$Set$remove, key, set);
									});
								var toggleKeys = F2(
									function (keys, set) {
										return A3($elm$core$List$foldl, toggleKey, set, keys);
									});
								var canonGroupToStores = model.dr.cc;
								return {
									aU: A2(toggleKey, canonGroup, visibility.aU),
									aN: A2(
										toggleKeys,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2($elm$core$Dict$get, canonGroup, canonGroupToStores)),
										visibility.aN)
								};
							}()
						}),
					$author$project$Api$createFixedMidashi(0));
			case 9:
				var store = msg.a;
				var toggle = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: function () {
								var visibility = model.aF;
								var toggleKey = F2(
									function (key, set) {
										return toggle ? A2($elm$core$Set$insert, key, set) : A2($elm$core$Set$remove, key, set);
									});
								return {
									aU: visibility.aU,
									aN: A2(toggleKey, store, visibility.aN)
								};
							}()
						}),
					$author$project$Api$createFixedMidashi(0));
			case 14:
				var mode = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var maybeTo = function () {
							if (!mode) {
								return A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im);
							} else {
								return A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										$justinmimbs$time_extra$Time$Extra$posixToParts(
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0)),
										$author$project$Utils$Helpers$roundByInterval(model.ac)),
									model.fa);
							}
						}();
						var maybeFrom = function () {
							if (!mode) {
								return A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il);
							} else {
								return A2(
									$elm$core$Maybe$map,
									A2(
										$elm$core$Basics$composeR,
										A3(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0)),
										A2(
											$elm$core$Basics$composeR,
											$justinmimbs$time_extra$Time$Extra$posixToParts(
												$justinmimbs$timezone_data$TimeZone$asia__tokyo(0)),
											$author$project$Utils$Helpers$roundByInterval(model.ac))),
									model.fa);
							}
						}();
						var _v2 = _Utils_Tuple2(maybeFrom, maybeTo);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var fromDateTime = _v2.a.a;
							var toDateTime = _v2.b.a;
							var to = A2(
								$Herteby$url_builder_plus$UrlBuilderPlus$string,
								'to',
								$author$project$Utils$Helpers$formatDateTime(toDateTime));
							var productIds = A3(
								$Herteby$url_builder_plus$UrlBuilderPlus$list,
								$Herteby$url_builder_plus$UrlBuilderPlus$string,
								'rawSelectedProducts',
								$elm$core$List$isEmpty(
									$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
									$elm$core$List$map,
									function ($) {
										return $.kl;
									},
									$author$project$Pages$Users$Ca6Comnet$Csv$filterProducts(model)) : A2(
									$elm$core$List$map,
									$elm$core$Tuple$first,
									$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)));
							var interval = A2($Herteby$url_builder_plus$UrlBuilderPlus$int, 'interval', model.ac);
							var from = A2(
								$Herteby$url_builder_plus$UrlBuilderPlus$string,
								'from',
								$author$project$Utils$Helpers$formatDateTime(fromDateTime));
							var _v3 = model.bT;
							switch (_v3) {
								case 0:
									return A4(
										$author$project$Api$get,
										$author$project$Endpoints$User$ca6ComnetEndpoints.ja.mb(
											_List_fromArray(
												[from, to, interval, productIds])),
										$author$project$Pages$Users$Ca6Comnet$Csv$toSession(model),
										$author$project$Pages$Users$Ca6Comnet$Csv$csvResponseDecoder,
										$author$project$Pages$Users$Ca6Comnet$Csv$CsvRequestSent(0));
								case 1:
									return A4(
										$author$project$Api$get,
										$author$project$Endpoints$User$ca6ComnetEndpoints.ja.ma(
											_List_fromArray(
												[
													from,
													to,
													interval,
													productIds,
													A3(
													$Herteby$url_builder_plus$UrlBuilderPlus$list,
													$Herteby$url_builder_plus$UrlBuilderPlus$int,
													'rawSelectedCanonGroups',
													$elm$core$Set$toList(model.aF.aU)),
													A3(
													$Herteby$url_builder_plus$UrlBuilderPlus$list,
													$Herteby$url_builder_plus$UrlBuilderPlus$int,
													'rawSelectedStores',
													$elm$core$Set$toList(model.aF.aN))
												])),
										$author$project$Pages$Users$Ca6Comnet$Csv$toSession(model),
										$author$project$Pages$Users$Ca6Comnet$Csv$csvResponseDecoder,
										$author$project$Pages$Users$Ca6Comnet$Csv$CsvRequestSent(1));
								default:
									return A4(
										$author$project$Api$get,
										$author$project$Endpoints$User$ca6ComnetEndpoints.ja.l9(
											_List_fromArray(
												[from, to, interval, productIds])),
										$author$project$Pages$Users$Ca6Comnet$Csv$toSession(model),
										$author$project$Pages$Users$Ca6Comnet$Csv$csvResponseDecoder,
										$author$project$Pages$Users$Ca6Comnet$Csv$CsvRequestSent(2));
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 0:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					var rawCanonGroupStores = initResponse.i2;
					var canonGroupStoresTables = function () {
						var group = function (xs) {
							return A3(
								$elm$core$List$foldr,
								F2(
									function (_v7, dict) {
										var k = _v7.a;
										var v = _v7.b;
										return A3(
											$elm$core$Dict$update,
											k,
											function (maybeList) {
												if (!maybeList.$) {
													var vs = maybeList.a;
													return $elm$core$Maybe$Just(
														A2($elm$core$List$cons, v, vs));
												} else {
													return $elm$core$Maybe$Just(
														_List_fromArray(
															[v]));
												}
											},
											dict);
									}),
								$elm$core$Dict$empty,
								xs);
						};
						return {
							e2: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(rawcgs.hj, rawcgs.i1);
									},
									rawCanonGroupStores)),
							cc: group(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(rawcgs.hj, rawcgs.iw);
									},
									rawCanonGroupStores)),
							gL: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(
											rawcgs.iw,
											{fh: rawcgs.kQ, kS: rawcgs.kS});
									},
									rawCanonGroupStores))
						};
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								dr: canonGroupStoresTables,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								kn: initResponse.kn,
								cS: initResponse.cS,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.b.$) {
					var outputMode = msg.a;
					var csvResponse = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ch: {co: csvResponse.co, h0: outputMode},
								H: $elm$core$Maybe$Nothing,
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just('エラーが発生しました'),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var filename = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$file$File$Download$url(
						A3(
							$author$project$Api$makeCsvEndpoint,
							$author$project$Session$getConfig(model.C),
							_List_fromArray(
								[
									A2($author$project$Endpoints$User$ca6ComnetEndpoints.ja.lX, filename, _List_Nil)
								]),
							_List_Nil)));
			default:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnChangeMultiselectProducts = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$GetPriceResponse = F2(
	function (dictPrice, products) {
		return {jb: dictPrice, kn: products};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$getPriceResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$Ca6Comnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Ca6Comnet$Hour$ProductKatabanHeader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$Ca6Comnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Ca6Comnet$Hour$pProductPriceRows = function (model) {
	var visibility = model.aF;
	var products = model.kn;
	var canonGroupStoresTables = model.dr;
	var canonGroupToStores = function (canonGroup) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
	};
	var hasVisibleStore = function (canonGroup) {
		return A2(
			$elm$core$List$any,
			function (store) {
				return A2($elm$core$Set$member, store, visibility.aN);
			},
			canonGroupToStores(canonGroup));
	};
	var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.e2);
	var stores = A2(
		$elm$core$List$concatMap,
		function (canonGroup) {
			return A2(
				$elm$core$List$filter,
				function (store) {
					return A2($elm$core$Set$member, store, visibility.aN);
				},
				canonGroupToStores(canonGroup));
		},
		A2(
			$elm$core$List$filter,
			function (canonGroup) {
				return hasVisibleStore(canonGroup);
			},
			canonGroups));
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜', m: 0},
						{jP: '税込', m: 1},
						{jP: 'ポイント(/ク)', m: 2},
						{jP: 'P適用後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Ca6Comnet$Hour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var hyoujiKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(basePriceIncludeTax));
				var sankouKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(
						$elm$core$Basics$round((basePriceIncludeTax * 9) / 10)));
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Ca6Comnet$Hour$ProductKatabanHeader(
							{jB: hyoujiKakaku, hQ: product.nk, ky: sankouKakaku}),
							$author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Ca6Comnet$Hour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Ca6Comnet$Hour$pStoreHeader = F2(
	function (canonGroupStoresTables, visibility) {
		var storeIdToDisplayName = function (store) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.fh;
					},
					A2($elm$core$Dict$get, store, canonGroupStoresTables.gL)));
		};
		var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.e2);
		var canonGroupToStores = function (canonGroup) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
		};
		var hasVisibleStore = function (canonGroup) {
			return A2(
				$elm$core$List$any,
				function (store) {
					return A2($elm$core$Set$member, store, visibility.aN);
				},
				canonGroupToStores(canonGroup));
		};
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {hj: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (canonGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {
								hj: canonGroup,
								kS: storeIdToDisplayName(store)
							};
						},
						A2(
							$elm$core$List$filter,
							function (store) {
								return A2($elm$core$Set$member, store, visibility.aN);
							},
							canonGroupToStores(canonGroup)));
				},
				A2(
					$elm$core$List$filter,
					function (canonGroup) {
						return hasVisibleStore(canonGroup);
					},
					canonGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: A2(
				$elm$core$List$map,
				function ($) {
					return $.kS;
				},
				storeHeader),
			no: A2(
				$elm$core$List$concatMap,
				function (row) {
					var indices = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(
							'DisplayAll',
							_List_fromArray(
								[0, 1, 2, 3])),
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (dispToValue) {
								return _Utils_eq(dispToValue.a, selectedDisplayStyle);
							},
							$author$project$Pages$Users$Ca6Comnet$Hour$displayStyleToValues)).b;
					var numrow = A2(
						$elm$core$List$take,
						$elm$core$List$length(indices),
						_List_fromArray(
							[0, 1, 2, 3]));
					return A2(
						$elm$core$List$map,
						function (ind) {
							return A2(
								$elm$core$List$map,
								function (cell) {
									switch (cell.$) {
										case 0:
											var data = cell.a;
											return A2(
												$elm$core$Maybe$withDefault,
												{jP: '', m: -1},
												A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
										case 1:
											var data = cell.a;
											return data.hQ;
										case 2:
											return '';
										default:
											var data = cell.a;
											return A2(
												$elm$core$Maybe$withDefault,
												{jP: '', m: -1},
												A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
									}
								},
								row);
						},
						numrow);
				},
				priceRows)
		};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$filterProducts = function (model) {
	return A4($author$project$Utils$Helpers$filterBySelector, model.eh, model.ig, model.gD, model.c1);
};
var $author$project$Pages$Users$Ca6Comnet$Hour$updateMultiselect = function (model) {
	return _Utils_update(
		model,
		{
			E: A3(
				$inkuzmin$elm_multiselect$Multiselect$populateValues,
				model.E,
				A2(
					$elm$core$List$map,
					function (p) {
						return _Utils_Tuple2(p.kl, p.nk);
					},
					$author$project$Pages$Users$Ca6Comnet$Hour$filterProducts(model)),
				_List_Nil)
		});
};
var $author$project$Pages$Users$Ca6Comnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.mj.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.mj.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var bigCategoryId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ig: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(bigCategoryId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Hour$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 13:
				var smallCategoryId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						gD: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(smallCategoryId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Hour$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 14:
				var makerId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						eh: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(makerId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Hour$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					var rawCanonGroupStores = initResponse.i2;
					var visibility = {
						aU: $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.hj;
								},
								rawCanonGroupStores)),
						aN: $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.iw;
								},
								rawCanonGroupStores))
					};
					var canonGroupStoresTables = function () {
						var group = function (xs) {
							return A3(
								$elm$core$List$foldr,
								F2(
									function (_v4, dict) {
										var k = _v4.a;
										var v = _v4.b;
										return A3(
											$elm$core$Dict$update,
											k,
											function (maybeList) {
												if (!maybeList.$) {
													var vs = maybeList.a;
													return $elm$core$Maybe$Just(
														A2($elm$core$List$cons, v, vs));
												} else {
													return $elm$core$Maybe$Just(
														_List_fromArray(
															[v]));
												}
											},
											dict);
									}),
								$elm$core$Dict$empty,
								xs);
						};
						return {
							e2: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(rawcgs.hj, rawcgs.i1);
									},
									rawCanonGroupStores)),
							cc: group(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(rawcgs.hj, rawcgs.iw);
									},
									rawCanonGroupStores)),
							gL: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(
											rawcgs.iw,
											{fh: rawcgs.kQ, kS: rawcgs.kS});
									},
									rawCanonGroupStores))
						};
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								dr: canonGroupStoresTables,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL,
								aF: visibility
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.jb, kn: getPriceResponse.kn, gN: model.bS, gO: model.bi}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 15:
				var sub = msg.a;
				var _v7 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v7.a;
				var subCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Ca6Comnet$Hour$OnChangeMultiselectProducts, subCmd));
			case 3:
				var canonGroup = msg.a;
				var toggle = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: function () {
								var visibility = model.aF;
								var toggleKey = F2(
									function (key, set) {
										return toggle ? A2($elm$core$Set$insert, key, set) : A2($elm$core$Set$remove, key, set);
									});
								var toggleKeys = F2(
									function (keys, set) {
										return A3($elm$core$List$foldl, toggleKey, set, keys);
									});
								var canonGroupToStores = model.dr.cc;
								return {
									aU: A2(toggleKey, canonGroup, visibility.aU),
									aN: A2(
										toggleKeys,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2($elm$core$Dict$get, canonGroup, canonGroupToStores)),
										visibility.aN)
								};
							}()
						}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var store = msg.a;
				var toggle = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: function () {
								var visibility = model.aF;
								var toggleKey = F2(
									function (key, set) {
										return toggle ? A2($elm$core$Set$insert, key, set) : A2($elm$core$Set$remove, key, set);
									});
								return {
									aU: visibility.aU,
									aN: A2(toggleKey, store, visibility.aN)
								};
							}()
						}),
					$author$project$Api$createFixedMidashi(0));
			case 11:
				var storeHeader = A2($author$project$Pages$Users$Ca6Comnet$Hour$pStoreHeader, model.dr, model.aF);
				var priceRows = $author$project$Pages$Users$Ca6Comnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Ca6Comnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeMultiselectProducts = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Ca6Comnet$Hour2$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Ca6Comnet$Hour2$ProductKatabanHeader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$Ca6Comnet$Hour2$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Ca6Comnet$Hour2$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Ca6Comnet$Hour2$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var hyoujiKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(basePriceIncludeTax));
				var sankouKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(
						$elm$core$Basics$round((basePriceIncludeTax * 9) / 10)));
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Ca6Comnet$Hour2$ProductKatabanHeader(
							{jB: hyoujiKakaku, hQ: product.nk, ky: sankouKakaku}),
							$author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Ca6Comnet$Hour2$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Ca6Comnet$Hour2$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													var data = cell.a;
													return data.hQ;
												case 2:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													var data = cell.a;
													return data.hQ;
												case 2:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$filterProducts = function (model) {
	return A4($author$project$Utils$Helpers$filterBySelector, model.eh, model.ig, model.gD, model.c1);
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$updateMultiselect = function (model) {
	return _Utils_update(
		model,
		{
			E: A3(
				$inkuzmin$elm_multiselect$Multiselect$populateValues,
				model.E,
				A2(
					$elm$core$List$map,
					function (p) {
						return _Utils_Tuple2(p.kl, p.nk);
					},
					$author$project$Pages$Users$Ca6Comnet$Hour2$filterProducts(model)),
				_List_Nil)
		});
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.mk.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$Hour2$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$Hour2$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.mk.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$Hour2$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$Hour2$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ig: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(bigCategoryId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Hour2$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						gD: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(smallCategoryId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Hour2$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						eh: A2(
							$elm$core$Maybe$andThen,
							$elm$core$Maybe$Just,
							$elm$core$String$toInt(makerId))
					});
				return _Utils_Tuple2(
					$author$project$Pages$Users$Ca6Comnet$Hour2$updateMultiselect(newModel),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 14:
				var sub = msg.a;
				var _v5 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v5.a;
				var subCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeMultiselectProducts, subCmd));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Ca6Comnet$Hour2$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Ca6Comnet$Hour2$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Ca6Comnet$Hour2$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Pages$Users$Ca6Comnet$Items$escapeCsvCell = function (cell) {
	return '\"' + (A3($elm$core$String$replace, '\"', '\"\"', cell) + '\"');
};
var $author$project$Pages$Users$Ca6Comnet$Items$csvRowToString = function (row) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $author$project$Pages$Users$Ca6Comnet$Items$escapeCsvCell, row));
};
var $author$project$Pages$Users$Ca6Comnet$Items$itemToCsvRow = function (item) {
	return _List_fromArray(
		[
			item.nk,
			item.kl,
			item.hf,
			item.iq,
			$elm$core$String$fromInt(item.kg)
		]);
};
var $author$project$Pages$Users$Ca6Comnet$Items$itemsToCsv = function (items) {
	var csvHeader = _List_fromArray(
		['商品名', 'JANコード', '大分類', '小分類', '参考価格']);
	return '\uFEFF' + A2(
		$elm$core$String$join,
		'\r\n',
		A2(
			$elm$core$List$map,
			$author$project$Pages$Users$Ca6Comnet$Items$csvRowToString,
			A2(
				$elm$core$List$cons,
				csvHeader,
				A2($elm$core$List$map, $author$project$Pages$Users$Ca6Comnet$Items$itemToCsvRow, items))));
};
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Pages$Users$Ca6Comnet$Items$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var result = msg.a;
			if (!result.$) {
				var response = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cv: false, mx: response.mx}),
					$elm$core$Platform$Cmd$none);
			} else {
				var error = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							H: $elm$core$Maybe$Just(
								$author$project$Utils$Helpers$errToStr(error)),
							cv: false
						}),
					$elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(
				model,
				A3(
					$elm$file$File$Download$string,
					'netgate_取得一覧',
					'text/csv;charset=utf-8',
					$author$project$Pages$Users$Ca6Comnet$Items$itemsToCsv(model.mx)));
		}
	});
var $author$project$Pages$Users$Ca6Comnet$Low$ListRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Low$Row = F5(
	function (productName, storeName, kijunPrice, price, url) {
		return {fM: kijunPrice, kg: price, nk: productName, kS: storeName, eD: url};
	});
var $author$project$Pages$Users$Ca6Comnet$Low$rowDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Ca6Comnet$Low$Row,
	A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'kijun_price', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$Ca6Comnet$Low$listResponseDecoder = $elm$json$Json$Decode$list($author$project$Pages$Users$Ca6Comnet$Low$rowDecoder);
var $author$project$Pages$Users$Ca6Comnet$Low$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var result = msg.a;
				if (!result.$) {
					var rows = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, fx: true, dP: false, gv: rows}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v2.$) {
							var dateTimeParts = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.mE.mB(
									_List_fromArray(
										[
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2($elm$url$Url$Builder$string, 'ratio', model.ed)
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$Low$listResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$Low$ListRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 5:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dA: checked}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dB: checked}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ek: checked}),
					$elm$core$Platform$Cmd$none);
			default:
				var ratio = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ed: ratio}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$GetPriceResponse = F2(
	function (dictPrice, products) {
		return {jb: dictPrice, kn: products};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$Price = function (productId) {
	return function (storeId) {
		return function (dateTime) {
			return function (price) {
				return function (priceIncludeTax) {
					return function (point) {
						return function (priceWithoutPoint) {
							return function (coupon) {
								return function (isLatest) {
									return function (url) {
										return {i9: coupon, lP: dateTime, fH: isLatest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'is_latest', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$Price)))))))))));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$priceDecoder)));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$getPriceResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductKatabanHeader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pProductPriceRows = function (model) {
	var visibility = model.aF;
	var products = model.kn;
	var canonGroupStoresTables = model.dr;
	var canonGroupToStores = function (canonGroup) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
	};
	var hasVisibleStore = function (canonGroup) {
		return A2(
			$elm$core$List$any,
			function (store) {
				return A2($elm$core$Set$member, store, visibility.aN);
			},
			canonGroupToStores(canonGroup));
	};
	var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.e2);
	var stores = A2(
		$elm$core$List$concatMap,
		function (canonGroup) {
			return A2(
				$elm$core$List$filter,
				function (store) {
					return A2($elm$core$Set$member, store, visibility.aN);
				},
				canonGroupToStores(canonGroup));
		},
		A2(
			$elm$core$List$filter,
			function (canonGroup) {
				return hasVisibleStore(canonGroup);
			},
			canonGroups));
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜', m: 0},
						{jP: '税込', m: 1},
						{jP: 'ポイント(/ク)', m: 2},
						{jP: 'P適用後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var hyoujiKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(basePriceIncludeTax));
				var sankouKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(
						$elm$core$Basics$round((basePriceIncludeTax * 9) / 10)));
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductKatabanHeader(
							{jB: hyoujiKakaku, hQ: product.nk, ky: sankouKakaku}),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pStoreHeader = F2(
	function (canonGroupStoresTables, visibility) {
		var storeIdToDisplayName = function (store) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.fh;
					},
					A2($elm$core$Dict$get, store, canonGroupStoresTables.gL)));
		};
		var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.e2);
		var canonGroupToStores = function (canonGroup) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
		};
		var hasVisibleStore = function (canonGroup) {
			return A2(
				$elm$core$List$any,
				function (store) {
					return A2($elm$core$Set$member, store, visibility.aN);
				},
				canonGroupToStores(canonGroup));
		};
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {hj: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (canonGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {
								hj: canonGroup,
								kS: storeIdToDisplayName(store)
							};
						},
						A2(
							$elm$core$List$filter,
							function (store) {
								return A2($elm$core$Set$member, store, visibility.aN);
							},
							canonGroupToStores(canonGroup)));
				},
				A2(
					$elm$core$List$filter,
					function (canonGroup) {
						return hasVisibleStore(canonGroup);
					},
					canonGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													var data = cell.a;
													return data.hQ;
												case 2:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													var data = cell.a;
													return data.hQ;
												case 2:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.iH.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.iH.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					var rawCanonGroupStores = initResponse.i2;
					var visibility = {
						aU: $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.hj;
								},
								rawCanonGroupStores)),
						aN: $elm$core$Set$fromList(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.iw;
								},
								rawCanonGroupStores))
					};
					var canonGroupStoresTables = function () {
						var group = function (xs) {
							return A3(
								$elm$core$List$foldr,
								F2(
									function (_v4, dict) {
										var k = _v4.a;
										var v = _v4.b;
										return A3(
											$elm$core$Dict$update,
											k,
											function (maybeList) {
												if (!maybeList.$) {
													var vs = maybeList.a;
													return $elm$core$Maybe$Just(
														A2($elm$core$List$cons, v, vs));
												} else {
													return $elm$core$Maybe$Just(
														_List_fromArray(
															[v]));
												}
											},
											dict);
									}),
								$elm$core$Dict$empty,
								xs);
						};
						return {
							e2: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(rawcgs.hj, rawcgs.i1);
									},
									rawCanonGroupStores)),
							cc: group(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(rawcgs.hj, rawcgs.iw);
									},
									rawCanonGroupStores)),
							gL: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (rawcgs) {
										return _Utils_Tuple2(
											rawcgs.iw,
											{fh: rawcgs.kQ, kS: rawcgs.kS});
									},
									rawCanonGroupStores))
						};
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, dr: canonGroupStoresTables, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL, aF: visibility}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.jb, kn: getPriceResponse.kn, gN: model.bS, gO: model.bi}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var canonGroup = msg.a;
				var toggle = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: function () {
								var visibility = model.aF;
								var toggleKey = F2(
									function (key, set) {
										return toggle ? A2($elm$core$Set$insert, key, set) : A2($elm$core$Set$remove, key, set);
									});
								var toggleKeys = F2(
									function (keys, set) {
										return A3($elm$core$List$foldl, toggleKey, set, keys);
									});
								var canonGroupToStores = model.dr.cc;
								return {
									aU: A2(toggleKey, canonGroup, visibility.aU),
									aN: A2(
										toggleKeys,
										A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2($elm$core$Dict$get, canonGroup, canonGroupToStores)),
										visibility.aN)
								};
							}()
						}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var store = msg.a;
				var toggle = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aF: function () {
								var visibility = model.aF;
								var toggleKey = F2(
									function (key, set) {
										return toggle ? A2($elm$core$Set$insert, key, set) : A2($elm$core$Set$remove, key, set);
									});
								return {
									aU: visibility.aU,
									aN: A2(toggleKey, store, visibility.aN)
								};
							}()
						}),
					$author$project$Api$createFixedMidashi(0));
			case 11:
				var storeHeader = A2($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pStoreHeader, model.dr, model.aF);
				var priceRows = $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$Price = function (productId) {
	return function (storeId) {
		return function (dateTime) {
			return function (price) {
				return function (priceIncludeTax) {
					return function (point) {
						return function (priceWithoutPoint) {
							return function (coupon) {
								return function (isLatest) {
									return function (url) {
										return {i9: coupon, lP: dateTime, fH: isLatest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'is_latest', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$Price)))))))))));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$priceDecoder)));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductKatabanHeader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var hyoujiKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(basePriceIncludeTax));
				var sankouKakaku = $author$project$Utils$Helpers$toCommmaSplited(
					$elm$core$String$fromInt(
						$elm$core$Basics$round((basePriceIncludeTax * 9) / 10)));
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductKatabanHeader(
							{jB: hyoujiKakaku, hQ: product.nk, ky: sankouKakaku}),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													var data = cell.a;
													return data.hQ;
												case 2:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													var data = cell.a;
													return data.hQ;
												case 2:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.n6.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$ca6ComnetEndpoints.n6.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$getPriceResponseDecoder,
								$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Common$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Common$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Common$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Common$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$Common$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Common$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$Common$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Common$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$Common$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Common$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Common$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 8:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(product.lt)),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$defaultEndpoints.aV._, model.C, body, $author$project$Pages$Users$Common$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Common$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$defaultEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$Common$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Common$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Common$Default$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Common$Default$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Common$Default$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Common$Default$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Common$Default$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Common$Default$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$Default$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Common$Default$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Common$Default$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Common$Default$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Common$Default$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Common$Default$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Common$Default$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Common$Default$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Common$Default$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Common$Default$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Common$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Common$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Common$Default$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Common$Default$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Common$Default$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Common$MailAddress$CompletedAddPermalinkGroup = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$CompletedAddTarget = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$CompletedBulkUpdatePermalinkGroups = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$CompletedDeletePermalinkGroup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$CompletedDeleteTarget = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$CompletedListTargets = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$CompletedUpdatePermalinkGroup = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$MailTarget = F5(
	function (mailTargetId, mailId, storeId, storeName, type_) {
		return {mF: mailId, hT: mailTargetId, iw: storeId, kS: storeName, gZ: type_};
	});
var $author$project$Pages$Users$Common$MailAddress$mailTargetDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Pages$Users$Common$MailAddress$MailTarget,
	A2($elm$json$Json$Decode$field, 'mail_target_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'mail_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$int));
var $author$project$Pages$Users$Common$MailAddress$mailTargetsDecoder = A2(
	$elm$json$Json$Decode$field,
	'targets',
	$elm$json$Json$Decode$list($author$project$Pages$Users$Common$MailAddress$mailTargetDecoder));
var $author$project$Pages$Users$Common$MailAddress$reloadMailAddresses = function (model) {
	return A4($author$project$Api$get, $author$project$Endpoints$User$mailAddressEndpoints.x, model.C, $author$project$Pages$Users$Common$MailAddress$initResponseDecoder, $author$project$Pages$Users$Common$MailAddress$InitRequestSent);
};
var $author$project$Pages$Users$Common$MailAddress$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$Common$MailAddress$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Common$MailAddress$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$Common$MailAddress$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dO: false, i: response.i, aN: response.aN}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								dO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 6:
				if (!msg.b.$) {
					var permalinkGroupId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								i: A3(
									$elm_community$list_extra$List$Extra$updateIf,
									function (pg) {
										return _Utils_eq(pg.T, permalinkGroupId);
									},
									function (pg) {
										return _Utils_update(
											pg,
											{R: false});
									},
									model.i)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 8:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false, ba: $author$project$Pages$Users$Common$MailAddress$initNewPermalinkGroup}),
						$author$project$Pages$Users$Common$MailAddress$reloadMailAddresses(model));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 7:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$author$project$Pages$Users$Common$MailAddress$reloadMailAddresses(model));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 9:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								i: A2(
									$elm$core$List$map,
									function (pg) {
										return _Utils_update(
											pg,
											{R: false});
									},
									model.i)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 10:
				var permalinkGroup = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$User$mailAddressEndpoints._,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'permalink_group_id',
									$elm$json$Json$Encode$int(permalinkGroup.T)),
									_Utils_Tuple2(
									'permalink_group_name',
									$elm$json$Json$Encode$string(permalinkGroup.as)),
									_Utils_Tuple2(
									'supervisor',
									$elm$json$Json$Encode$string(permalinkGroup.aE)),
									_Utils_Tuple2(
									'valid',
									$elm$json$Json$Encode$bool(permalinkGroup.aP))
								])),
						$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
						$author$project$Pages$Users$Common$MailAddress$CompletedUpdatePermalinkGroup(permalinkGroup.T)));
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$User$mailAddressEndpoints.lw,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'addresses',
									A2(
										$elm$json$Json$Encode$list,
										function (pg) {
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'mail_id',
														$elm$json$Json$Encode$int(pg.T)),
														_Utils_Tuple2(
														'address',
														$elm$json$Json$Encode$string(pg.as)),
														_Utils_Tuple2(
														'supervisor',
														$elm$json$Json$Encode$string(pg.aE)),
														_Utils_Tuple2(
														'valid',
														$elm$json$Json$Encode$bool(pg.aP))
													]));
										},
										model.i))
								])),
						$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
						$author$project$Pages$Users$Common$MailAddress$CompletedBulkUpdatePermalinkGroups));
			case 14:
				var valid = msg.a;
				var updatedGroups = A2(
					$elm$core$List$map,
					function (pg) {
						return _Utils_update(
							pg,
							{aP: valid});
					},
					model.i);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true, i: updatedGroups}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$User$mailAddressEndpoints.lw,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'addresses',
									A2(
										$elm$json$Json$Encode$list,
										function (pg) {
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'mail_id',
														$elm$json$Json$Encode$int(pg.T)),
														_Utils_Tuple2(
														'address',
														$elm$json$Json$Encode$string(pg.as)),
														_Utils_Tuple2(
														'supervisor',
														$elm$json$Json$Encode$string(pg.aE)),
														_Utils_Tuple2(
														'valid',
														$elm$json$Json$Encode$bool(pg.aP))
													]));
										},
										updatedGroups))
								])),
						$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
						$author$project$Pages$Users$Common$MailAddress$CompletedBulkUpdatePermalinkGroups));
			case 12:
				var newPermalinkGroup = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$User$mailAddressEndpoints.am,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'address',
									$elm$json$Json$Encode$string(newPermalinkGroup.as)),
									_Utils_Tuple2(
									'supervisor',
									$elm$json$Json$Encode$string(newPermalinkGroup.aE))
								])),
						$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
						$author$project$Pages$Users$Common$MailAddress$CompletedAddPermalinkGroup));
			case 11:
				var permalinkGroupId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$User$mailAddressEndpoints.ci,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'permalink_group_id',
									$elm$json$Json$Encode$int(permalinkGroupId))
								])),
						$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
						$author$project$Pages$Users$Common$MailAddress$CompletedDeletePermalinkGroup));
			case 1:
				var permalinkGroupId = msg.a;
				var name = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (pg) {
									return _Utils_eq(pg.T, permalinkGroupId);
								},
								function (pg) {
									return _Utils_update(
										pg,
										{R: true, as: name});
								},
								model.i)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var permalinkGroupId = msg.a;
				var supervisor = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (pg) {
									return _Utils_eq(pg.T, permalinkGroupId);
								},
								function (pg) {
									return _Utils_update(
										pg,
										{R: true, aE: supervisor});
								},
								model.i)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var permalinkGroupId = msg.a;
				var valid = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							i: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (pg) {
									return _Utils_eq(pg.T, permalinkGroupId);
								},
								function (pg) {
									return _Utils_update(
										pg,
										{R: true, aP: valid});
								},
								model.i)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var name = msg.a;
				var pg = model.ba;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ba: _Utils_update(
								pg,
								{R: true, as: name})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var supervisor = msg.a;
				var pg = model.ba;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ba: _Utils_update(
								pg,
								{R: true, aE: supervisor})
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var showValidOnly = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ej: showValidOnly}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var mailId = msg.a;
				var newExpandedMailIds = A2($elm$core$Set$member, mailId, model.a0) ? A2($elm$core$Set$remove, mailId, model.a0) : A2($elm$core$Set$insert, mailId, model.a0);
				var fetchCmd = function () {
					if (A2($elm$core$Set$member, mailId, model.a0)) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var _v1 = A2($elm$core$Dict$get, mailId, model.ae);
						if (!_v1.$) {
							return $elm$core$Platform$Cmd$none;
						} else {
							return A5(
								$author$project$Api$post,
								$author$project$Endpoints$User$mailAddressEndpoints.mD,
								model.C,
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'mail_id',
											$elm$json$Json$Encode$int(mailId))
										])),
								$author$project$Pages$Users$Common$MailAddress$mailTargetsDecoder,
								$author$project$Pages$Users$Common$MailAddress$CompletedListTargets(mailId));
						}
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a0: newExpandedMailIds}),
					fetchCmd);
			case 17:
				if (!msg.b.$) {
					var mailId = msg.a;
					var targets = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ae: A3($elm$core$Dict$insert, mailId, targets, model.ae)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 18:
				var mailId = msg.a;
				var storeIdStr = msg.b;
				var _v2 = $elm$core$String$toInt(storeIdStr);
				if (_v2.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var storeId = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cJ: A3($elm$core$Dict$insert, mailId, storeId, model.cJ)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 19:
				var mailId = msg.a;
				var _v3 = A2($elm$core$Dict$get, mailId, model.cJ);
				if (_v3.$ === 1) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var storeId = _v3.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$User$mailAddressEndpoints.li,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId)),
										_Utils_Tuple2(
										'store_id',
										$elm$json$Json$Encode$int(storeId)),
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$int(2))
									])),
							$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
							$author$project$Pages$Users$Common$MailAddress$CompletedAddTarget(mailId)));
				}
			case 20:
				if (!msg.b.$) {
					var mailId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								ae: A2($elm$core$Dict$remove, mailId, model.ae)
							}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$User$mailAddressEndpoints.mD,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId))
									])),
							$author$project$Pages$Users$Common$MailAddress$mailTargetsDecoder,
							$author$project$Pages$Users$Common$MailAddress$CompletedListTargets(mailId)));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 21:
				var mailId = msg.a;
				var mailTargetId = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5(
						$author$project$Api$post,
						$author$project$Endpoints$User$mailAddressEndpoints.lS,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mail_target_id',
									$elm$json$Json$Encode$int(mailTargetId))
								])),
						$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
						$author$project$Pages$Users$Common$MailAddress$CompletedDeleteTarget(mailId)));
			case 22:
				if (!msg.b.$) {
					var mailId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								k: false,
								ae: A2($elm$core$Dict$remove, mailId, model.ae)
							}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$User$mailAddressEndpoints.mD,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId))
									])),
							$author$project$Pages$Users$Common$MailAddress$mailTargetsDecoder,
							$author$project$Pages$Users$Common$MailAddress$CompletedListTargets(mailId)));
				} else {
					var err = msg.b.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var mailId = msg.a;
				var allStoresTarget = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (t) {
							return t.gZ === 1;
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Dict$get, mailId, model.ae))));
				var cmd = function () {
					if (!allStoresTarget.$) {
						var target = allStoresTarget.a;
						return A5(
							$author$project$Api$post,
							$author$project$Endpoints$User$mailAddressEndpoints.lS,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_target_id',
										$elm$json$Json$Encode$int(target.hT))
									])),
							$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
							$author$project$Pages$Users$Common$MailAddress$CompletedDeleteTarget(mailId));
					} else {
						return A5(
							$author$project$Api$post,
							$author$project$Endpoints$User$mailAddressEndpoints.li,
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'mail_id',
										$elm$json$Json$Encode$int(mailId)),
										_Utils_Tuple2(
										'store_id',
										$elm$json$Json$Encode$int(0)),
										_Utils_Tuple2(
										'type',
										$elm$json$Json$Encode$int(1))
									])),
							$author$project$Pages$Users$Common$MailAddress$updateResponseDecoder,
							$author$project$Pages$Users$Common$MailAddress$CompletedAddTarget(mailId));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					cmd);
		}
	});
var $author$project$Pages$Users$Common$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Common$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Common$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$Common$TimeSeq$Price)))))))))));
var $author$project$Pages$Users$Common$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Common$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$Common$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Common$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Common$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Common$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$Lower = 1;
var $author$project$Pages$Users$Common$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$Common$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Common$TimeSeq$Normal = 3;
var $author$project$Pages$Users$Common$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Common$TimeSeq$Unchanged = {$: 2};
var $author$project$Session$userName = function (session) {
	if (!session.$) {
		var name = session.c;
		return $elm$core$Maybe$Just(name);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Users$Common$TimeSeq$isFujiComnet = function (model) {
	return _Utils_eq(
		$author$project$Session$userName(model.C),
		$elm$core$Maybe$Just('fuji-comnet'));
};
var $author$project$Pages$Users$Common$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var priceWithoutPoint = function (price) {
		return price.be - (model.dI ? price.i9 : 0);
	};
	var nOfRows = function () {
		var _v12 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v12.a.$) && (!_v12.b.$)) {
			var dateTimePartsFrom = _v12.a.a;
			var dateTimePartsTo = _v12.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return priceWithoutPoint(price);
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Utils$Helpers$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {
									ls: yodobashiPrice.ka,
									lt: yodobashiPrice.kg,
									eY: yodobashiPrice.kh,
									cb: priceWithoutPoint(yodobashiPrice)
								};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(
													priceWithoutPoint(price),
													lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = function () {
											var _v9 = _Utils_Tuple3(isLowest, product.oc, maybeYodobashiPrice);
											if (_v9.a) {
												if (_v9.b && (!_v9.c.$)) {
													var yodobashiPrice = _v9.c.a;
													return _Utils_cmp(
														lowestPrice,
														priceWithoutPoint(yodobashiPrice)) > -1;
												} else {
													return _Utils_cmp(lowestPrice, product.cb) > -1;
												}
											} else {
												return false;
											}
										}();
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v8 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v8.a && (!_v8.b.$)) {
													var yodobashiPrice = _v8.b.a;
													return _Utils_cmp(
														priceWithoutPoint(price),
														priceWithoutPoint(yodobashiPrice)) < 0;
												} else {
													return _Utils_cmp(
														priceWithoutPoint(price),
														product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var findPrevPrice = function (prevNth) {
											findPrevPrice:
											while (true) {
												if (prevNth < 1) {
													return $elm$core$Maybe$Nothing;
												} else {
													var _v3 = A2(
														$elm$core$Dict$get,
														_Utils_Tuple3(product.kl, store.iw, prevNth),
														model.cQ);
													if (!_v3.$) {
														var prevPrice = _v3.a;
														return $elm$core$Maybe$Just(prevPrice);
													} else {
														var $temp$prevNth = prevNth - 1;
														prevNth = $temp$prevNth;
														continue findPrevPrice;
													}
												}
											}
										};
										var maybePrevPrice = $author$project$Pages$Users$Common$TimeSeq$isFujiComnet(model) ? findPrevPrice(nth - 1) : A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v6 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v6.a.$) && (!_v6.b.$)) {
												var currentPrice = _v6.a.a;
												var prevPrice = _v6.b.a;
												return (_Utils_cmp(
													priceWithoutPoint(currentPrice),
													priceWithoutPoint(prevPrice)) > 0) ? $author$project$Pages$Users$Common$TimeSeq$Increased(
													priceWithoutPoint(currentPrice) - priceWithoutPoint(prevPrice)) : ((_Utils_cmp(
													priceWithoutPoint(currentPrice),
													priceWithoutPoint(prevPrice)) < 0) ? $author$project$Pages$Users$Common$TimeSeq$Decreased(
													priceWithoutPoint(prevPrice) - priceWithoutPoint(currentPrice)) : $author$project$Pages$Users$Common$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Common$TimeSeq$Unchanged;
											}
										}();
										var comparedPriceType = function () {
											if ($author$project$Pages$Users$Common$TimeSeq$isFujiComnet(model)) {
												return 3;
											} else {
												var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
												if (_v5.a) {
													return 0;
												} else {
													if (_v5.b) {
														return 2;
													} else {
														if (_v5.c) {
															return 1;
														} else {
															return 3;
														}
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(
															priceWithoutPoint(price))),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Common$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Common$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Common$TimeSeq$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Common$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Common$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Common$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Common$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 16:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dI: checked}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 12:
				var storeHeader = A2($author$project$Pages$Users$Common$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Common$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Common$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Common$WeeklyProduct$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$autoReloadSlot = F2(
	function (interval, posix) {
		return $author$project$Utils$Helpers$formatDateTime(
			A2(
				$author$project$Utils$Helpers$roundByInterval,
				interval,
				A2(
					$justinmimbs$time_extra$Time$Extra$posixToParts,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					posix)));
	});
var $author$project$Pages$Users$Common$WeeklyProduct$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Common$WeeklyProduct$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Common$WeeklyProduct$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Common$WeeklyProduct$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Common$WeeklyProduct$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Common$WeeklyProduct$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (sg) {
				return A2($elm$core$Set$member, sg.iv, model.L) && (!$elm$core$List$isEmpty(sg.aN));
			},
			model.X));
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (ind, product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					$elm$core$Basics$min,
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Common$WeeklyProduct$displayStyleToValues)).b);
				};
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yp = _v1.b.a;
						return {ls: yp.ka, lt: yp.kg, eY: yp.kh, cb: yp.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Common$WeeklyProduct$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Common$WeeklyProduct$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Common$WeeklyProduct$ProductPriceHeader(
							filterItemList(itemList)),
							$author$project$Pages$Users$Common$WeeklyProduct$ProductPriceHeader(
							filterItemList(basePriceList))
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									function (p) {
										return _Utils_eq(p.be, lowestPrice);
									},
									maybePrice));
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yp = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yp.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var p = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yp = _v4.b.a;
										return _Utils_cmp(p.be, yp.be) < 0;
									} else {
										return _Utils_cmp(p.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: _Utils_ap(
											$elm$core$String$fromInt(price.ka),
											((!price.i9) || (price.iw === 1)) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								return $author$project$Pages$Users$Common$WeeklyProduct$ProductPriceData(
									{
										fH: price.fH,
										hL: isLower,
										hN: isLowest,
										jL: isLowestButHigherThanBase,
										h6: filterItemList(priceList),
										eD: price.eD
									});
							} else {
								return $author$project$Pages$Users$Common$WeeklyProduct$ProductPriceNoData;
							}
						},
						stores));
			}),
		model.kn);
};
var $author$project$Pages$Users$Common$WeeklyProduct$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (sg) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: sg.iv, kS: store.fh};
						},
						sg.aN);
				},
				A2(
					$elm$core$List$filter,
					function (sg) {
						return A2($elm$core$Set$member, sg.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(sg.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Common$WeeklyProduct$shouldAutoReload = F2(
	function (model, posix) {
		return model.fk && (model.dn && ((!model.dP) && (!_Utils_eq(
			model.dV,
			$elm$core$Maybe$Just(
				A2($author$project$Pages$Users$Common$WeeklyProduct$autoReloadSlot, model.ac, posix))))));
	});
var $author$project$Pages$Users$Common$WeeklyProduct$submitLatest = function (model) {
	var _v0 = model.fa;
	if (!_v0.$) {
		var time = _v0.a;
		var roundedParts = A2(
			$author$project$Utils$Helpers$roundByInterval,
			model.ac,
			A2(
				$justinmimbs$time_extra$Time$Extra$posixToParts,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				time));
		var selectedDate = A3($author$project$Utils$Helpers$formatDate, roundedParts.ob, roundedParts.mQ, roundedParts.fd);
		var selectedTime = A2($author$project$Utils$Helpers$formatTime, roundedParts.mj, roundedParts.mO);
		var to = $author$project$Utils$Helpers$formatDateTime(roundedParts);
		var from = $author$project$Utils$Helpers$formatDateTime(
			A2(
				$author$project$Utils$Helpers$roundByInterval,
				model.ac,
				A2(
					$justinmimbs$time_extra$Time$Extra$posixToParts,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						13,
						(-1) * model.ac,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						time))));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{dP: true, bS: selectedDate, bi: selectedTime}),
			A4(
				$author$project$Api$get,
				model.gf(
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'from', from),
							A2($elm$url$Url$Builder$string, 'to', to),
							A2(
							$elm$url$Url$Builder$string,
							'interval',
							$elm$core$String$fromInt(model.ac)),
							A2(
							$elm$url$Url$Builder$string,
							'usePast',
							model.g2 ? 'true' : ''),
							A2(
							$elm$url$Url$Builder$string,
							'bigCategory',
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, -1, model.ig))),
							A2(
							$elm$url$Url$Builder$string,
							'smallCategory',
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, -1, model.gD))),
							A2(
							$elm$url$Url$Builder$string,
							'maker',
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, -1, model.eh)))
						])),
				model.C,
				$author$project$Pages$Users$Common$WeeklyProduct$getPriceResponseDecoder,
				$author$project$Pages$Users$Common$WeeklyProduct$GetPriceRequestSent));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Pages$Users$Common$WeeklyProduct$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Common$WeeklyProduct$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									F2(
										function (ind, cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										}),
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Common$WeeklyProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								model.gf(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Common$WeeklyProduct$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$WeeklyProduct$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 8:
				return $author$project$Pages$Users$Common$WeeklyProduct$submitLatest(model);
			case 10:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				var updatedModel = _Utils_update(
					model,
					{
						fa: $elm$core$Maybe$Just(posix)
					});
				if (A2($author$project$Pages$Users$Common$WeeklyProduct$shouldAutoReload, updatedModel, posix)) {
					var nextSlot = A2($author$project$Pages$Users$Common$WeeklyProduct$autoReloadSlot, updatedModel.ac, posix);
					return $author$project$Pages$Users$Common$WeeklyProduct$submitLatest(
						_Utils_update(
							updatedModel,
							{
								dV: $elm$core$Maybe$Just(nextSlot)
							}));
				} else {
					return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 13:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dn: checked,
							dV: checked ? A2(
								$elm$core$Maybe$map,
								$author$project$Pages$Users$Common$WeeklyProduct$autoReloadSlot(model.ac),
								model.fa) : $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var storeHeader = A2($author$project$Pages$Users$Common$WeeklyProduct$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Common$WeeklyProduct$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Common$WeeklyProduct$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Dbi6Comnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Dbi6Comnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Dbi6Comnet$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Dbi6Comnet$Hour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Dbi6Comnet$Hour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Dbi6Comnet$Hour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Dbi6Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Dbi6Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Dbi6Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Dbi6Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Dbi6Comnet$Hour$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Dbi6Comnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Dbi6Comnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$Dbi6Comnet$TimeSeq$Price)))))))))));
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Dbi6Comnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Dbi6Comnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Dbi6Comnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Lower = 1;
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Normal = 3;
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v10 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v10.a.$) && (!_v10.b.$)) {
			var dateTimePartsFrom = _v10.a.a;
			var dateTimePartsTo = _v10.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Utils$Helpers$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v8 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v8.a.$) && (!_v8.b.$)) {
												var currentPrice = _v8.a.a;
												var prevPrice = _v8.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v6.a && (!_v6.b.$)) {
													var yodobashiPrice = _v6.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v4 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v4.a) {
												return 0;
											} else {
												if (_v4.b) {
													return 2;
												} else {
													if (_v4.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Dbi6Comnet$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Dbi6Comnet$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Dbi6Comnet$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 12:
				var storeHeader = A2($author$project$Pages$Users$Dbi6Comnet$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Dbi6Comnet$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Dbi6Comnet$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$createIsWeeklyList = F2(
	function (products, weeklyProducts) {
		return A2(
			$elm$core$List$map,
			function (product) {
				return {
					fK: A2($elm$core$List$member, product.kl, weeklyProducts),
					kl: product.kl
				};
			},
			products);
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Delonghi$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$Delonghi$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					var isWeelklyList = A2($author$project$Pages$Users$Delonghi$ChangeProduct$createIsWeeklyList, initResponse.kn, initResponse.aQ);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, cy: isWeelklyList, kn: initResponse.kn, aQ: initResponse.aQ}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Delonghi$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$Delonghi$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Delonghi$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Delonghi$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 8:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'product_id',
											$elm$json$Json$Encode$string(product.kl)),
											_Utils_Tuple2(
											'base_price',
											$elm$json$Json$Encode$int(product.lt)),
											_Utils_Tuple2(
											'base_point',
											$elm$json$Json$Encode$int(product.ls)),
											_Utils_Tuple2(
											'product_order',
											$elm$json$Json$Encode$int(index + 1)),
											_Utils_Tuple2(
											'yodobashi_base_price_flag',
											$elm$json$Json$Encode$bool(product.oc)),
											_Utils_Tuple2(
											'get_interval',
											$elm$json$Json$Encode$int(product.ju))
										]))),
								_Utils_Tuple2(
								'weekly_products',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, model.aQ))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$delonghiEndpoints.aV._, model.C, body, $author$project$Pages$Users$Delonghi$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Delonghi$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'products',
							A2(
								$elm$json$Json$Encode$list,
								function (product) {
									return $elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'product_id',
												$elm$json$Json$Encode$string(product.kl)),
												_Utils_Tuple2(
												'base_price',
												$elm$json$Json$Encode$int(product.lt)),
												_Utils_Tuple2(
												'base_point',
												$elm$json$Json$Encode$int(product.ls)),
												_Utils_Tuple2(
												'product_order',
												$elm$json$Json$Encode$int(product.nl)),
												_Utils_Tuple2(
												'yodobashi_base_price_flag',
												$elm$json$Json$Encode$bool(product.oc)),
												_Utils_Tuple2(
												'get_interval',
												$elm$json$Json$Encode$int(product.ju))
											]));
								},
								model.kn)),
							_Utils_Tuple2(
							'weekly_products',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, model.aQ))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$delonghiEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$Delonghi$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Delonghi$ChangeProduct$UpdateProductRequestSent));
			case 12:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var ind = msg.a;
				var val = msg.b;
				var newIsWeeklyList = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					ind,
					function (p) {
						return _Utils_update(
							p,
							{fK: val});
					},
					model.cy);
				var newWeeklyProducts = A2(
					$elm$core$List$map,
					function ($) {
						return $.kl;
					},
					A2(
						$elm$core$List$filter,
						function (product) {
							return product.fK;
						},
						newIsWeeklyList));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cy: newIsWeeklyList, aQ: newWeeklyProducts}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Delonghi$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Delonghi$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Delonghi$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Delonghi$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Delonghi$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Delonghi$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$filter,
		function (store) {
			return A2($elm$core$Set$member, store.iw, model.aa);
		},
		A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.aN;
			},
			A2(
				$elm$core$List$filter,
				function (storeGroup) {
					return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
				},
				model.X)));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Delonghi$Hour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Delonghi$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Delonghi$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Delonghi$Hour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Delonghi$Hour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Delonghi$Hour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Delonghi$Hour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Delonghi$Hour$pStoreHeader = F3(
	function (storeGroups, visibleStoreGroups, visibleStores) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$filterMap,
						function (store) {
							return A2($elm$core$Set$member, store.iw, visibleStores) ? $elm$core$Maybe$Just(
								{iv: storeGroup.iv, kS: store.fh}) : $elm$core$Maybe$Nothing;
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Utils$Helpers$findOpt = F2(
	function (f, list) {
		findOpt:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (f(x)) {
					return $elm$core$Maybe$Just(x);
				} else {
					var $temp$f = f,
						$temp$list = xs;
					f = $temp$f;
					list = $temp$list;
					continue findOpt;
				}
			}
		}
	});
var $author$project$Utils$Helpers$sortMakers = F2(
	function (makerName, unsortedMakers) {
		var makers = A2(
			$elm$core$List$sortBy,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mH;
				},
				$elm$core$String$toLower),
			unsortedMakers);
		var isDelonghi = function (maker) {
			return _Utils_eq(maker.mH, makerName);
		};
		var _v0 = A2($author$project$Utils$Helpers$findOpt, isDelonghi, makers);
		if (_v0.$ === 1) {
			return makers;
		} else {
			var delonghi = _v0.a;
			return A2(
				$elm$core$List$cons,
				delonghi,
				A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, isDelonghi),
					makers));
		}
	});
var $author$project$Pages$Users$Delonghi$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Delonghi$Hour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Delonghi$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A2($elm$url$Url$Builder$string, 'noStoreGroupSort', 'true')
										])),
								model.C,
								$author$project$Pages$Users$Delonghi$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Delonghi$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A2($elm$url$Url$Builder$string, 'noStoreGroupSort', 'true')
										])),
								model.C,
								$author$project$Pages$Users$Delonghi$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Delonghi$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: A2($author$project$Utils$Helpers$sortMakers, 'De’Longhi', initResponse.cE),
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								aN: A2(
									$elm$core$List$concatMap,
									function (sg) {
										return sg.aN;
									},
									getPriceResponse.X),
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								aa: $elm$core$Set$isEmpty(model.aa) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iw;
										},
										A2(
											$elm$core$List$concatMap,
											function ($) {
												return $.aN;
											},
											getPriceResponse.X))) : model.aa
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var checked = msg.a;
				var storeIdStr = msg.b;
				var storeId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeIdStr));
				var newVisibleStores = checked ? A2($elm$core$Set$insert, storeId, model.aa) : A2($elm$core$Set$remove, storeId, model.aa);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aa: newVisibleStores}),
					$author$project$Api$createFixedMidashi(0));
			case 11:
				var storeHeader = A3($author$project$Pages$Users$Delonghi$Hour$pStoreHeader, model.X, model.L, model.aa);
				var priceRows = $author$project$Pages$Users$Delonghi$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Delonghi$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Delonghi$NineAM$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Delonghi$NineAM$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Delonghi$NineAM$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Delonghi$NineAM$Price))))))))))));
var $author$project$Pages$Users$Delonghi$NineAM$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Delonghi$NineAM$priceDecoder)));
var $author$project$Pages$Users$Delonghi$NineAM$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Delonghi$NineAM$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Delonghi$NineAM$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Delonghi$NineAM$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$Lower = 1;
var $author$project$Pages$Users$Delonghi$NineAM$Lowest = 0;
var $author$project$Pages$Users$Delonghi$NineAM$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Delonghi$NineAM$Normal = 3;
var $author$project$Pages$Users$Delonghi$NineAM$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Delonghi$NineAM$Unchanged = {$: 2};
var $author$project$Pages$Users$Delonghi$NineAM$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Delonghi$NineAM$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				11,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return diff + 1;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Delonghi$NineAM$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Delonghi$NineAM$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Delonghi$NineAM$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Delonghi$NineAM$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			11,
																			nth - 1,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Delonghi$NineAM$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Delonghi$NineAM$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Delonghi$NineAM$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Delonghi$NineAM$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Delonghi$NineAM$Unchanged);
											} else {
												return $author$project$Pages$Users$Delonghi$NineAM$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Delonghi$NineAM$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Delonghi$NineAM$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Delonghi$NineAM$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Delonghi$NineAM$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Delonghi$NineAM$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$delonghiEndpoints.mU.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'timefrom', model.il),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'timeto', model.im),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'stores',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))
										])),
								model.C,
								$author$project$Pages$Users$Delonghi$NineAM$getPriceResponseDecoder,
								$author$project$Pages$Users$Delonghi$NineAM$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 7:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Delonghi$NineAM$OnChangeStore, subCmd));
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Delonghi$NineAM$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.iw),
												s.kS);
										},
										initResponse.b$),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 13:
				var storeHeader = A2($author$project$Pages$Users$Delonghi$NineAM$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Delonghi$NineAM$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Delonghi$NineAM$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$Helpers$defaultProduct = {ls: 0, lt: 0, eY: 0, cb: 0, e_: -1, js: $elm$core$Maybe$Nothing, bE: false, jW: -1, kl: '', nk: '', nl: $elm$core$Maybe$Nothing, ee: $elm$core$Maybe$Nothing, ir: -1, n$: false, oc: false};
var $author$project$Pages$Users$Delonghi$TimeSeq$GetPriceResponse = F2(
	function (dictPrice, stores) {
		return {jb: dictPrice, aN: stores};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$Price = F9(
	function (storeId, nth, dateTime, price, priceIncludeTax, point, priceWithoutPoint, coupon, url) {
		return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, iw: storeId, eD: url};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									$elm$json$Json$Decode$succeed($author$project$Pages$Users$Delonghi$TimeSeq$Price))))))))));
var $author$project$Pages$Users$Delonghi$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Delonghi$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$Delonghi$TimeSeq$getPriceResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$Delonghi$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Delonghi$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder));
var $author$project$Pages$Users$Delonghi$TimeSeq$ProductPriceData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$Delonghi$TimeSeq$StoreHeader = function (a) {
	return {$: 0, a: a};
};
var $elm_community$list_extra$List$Extra$minimumBy = F2(
	function (f, ls) {
		var minBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) < 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						minBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$orList = function (maybes) {
	orList:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (maybes.a.$ === 1) {
				var _v1 = maybes.a;
				var rest = maybes.b;
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue orList;
			} else {
				var answer = maybes.a.a;
				return $elm$core$Maybe$Just(answer);
			}
		}
	}
};
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Pages$Users$Delonghi$TimeSeq$pProductPriceRows = F4(
	function (stores, maxRowNum, prices, basePrice) {
		return A2(
			$elm$core$List$map,
			function (store) {
				return A2(
					$elm$core$List$cons,
					$author$project$Pages$Users$Delonghi$TimeSeq$StoreHeader(store.kS),
					A2(
						$elm$core$List$map,
						function (ind) {
							var prevMaybePrice = $elm_community$maybe_extra$Maybe$Extra$orList(
								$elm$core$List$reverse(
									A2(
										$elm$core$List$map,
										function (prevInd) {
											return A2(
												$elm$core$Dict$get,
												_Utils_Tuple2(store.iw, prevInd),
												prices);
										},
										A2($elm$core$List$range, 1, ind - 1))));
							var lowestPrice = A2(
								$elm$core$Maybe$withDefault,
								-1,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.be;
									},
									A2(
										$elm_community$list_extra$List$Extra$minimumBy,
										function ($) {
											return $.be;
										},
										$elm_community$maybe_extra$Maybe$Extra$values(
											A2(
												$elm$core$List$map,
												function (st) {
													return A2(
														$elm$core$Dict$get,
														_Utils_Tuple2(st.iw, ind),
														prices);
												},
												stores)))));
							var currentMaybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(store.iw, ind),
								prices);
							if (!currentMaybePrice.$) {
								var currentPrice = currentMaybePrice.a;
								return $author$project$Pages$Users$Delonghi$TimeSeq$ProductPriceData(
									{
										du: (_Utils_cmp(currentPrice.be, basePrice) < 0) ? (_Utils_eq(currentPrice.be, lowestPrice) ? 0 : 1) : (_Utils_eq(currentPrice.be, lowestPrice) ? 2 : 3),
										ka: currentPrice.ka,
										ge: function () {
											if (!prevMaybePrice.$) {
												var prevPrice = prevMaybePrice.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Common$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Common$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Common$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Common$TimeSeq$Unchanged;
											}
										}(),
										be: currentPrice.be,
										eD: currentPrice.eD
									});
							} else {
								return $author$project$Pages$Users$Delonghi$TimeSeq$ProductPriceNoData;
							}
						},
						A2($elm$core$List$range, 1, maxRowNum - 1)));
			},
			stores);
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$formatDateTimeWithoutYear = function (parts) {
	return A2(
		$elm$core$String$right,
		2,
		'0' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Utils$Helpers$monthToInt)(parts.mQ)) + ('月' + (A2(
		$elm$core$String$right,
		2,
		'0' + $elm$core$String$fromInt(parts.fd)) + ('日' + A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO))));
};
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $justinmimbs$time_extra$Time$Extra$rangeHelp = F6(
	function (interval, step, zone, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(
				$elm$time$Time$posixToMillis(current),
				$elm$time$Time$posixToMillis(until)) < 0) {
				var $temp$interval = interval,
					$temp$step = step,
					$temp$zone = zone,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = A4($justinmimbs$time_extra$Time$Extra$add, interval, step, zone, current);
				interval = $temp$interval;
				step = $temp$step;
				zone = $temp$zone;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$range = F5(
	function (interval, step, zone, start, until) {
		return A6(
			$justinmimbs$time_extra$Time$Extra$rangeHelp,
			interval,
			A2($elm$core$Basics$max, 1, step),
			zone,
			until,
			_List_Nil,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, interval, zone, start));
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$pStoreHeader = F3(
	function (maybeFromParts, maybeToParts, interval) {
		var _v0 = _Utils_Tuple2(maybeFromParts, maybeToParts);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fromParts = _v0.a.a;
			var toParts = _v0.b.a;
			var toPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				toParts);
			var fromPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				fromParts);
			return function (ls) {
				return A2($elm$core$List$cons, '', ls);
			}(
				A2(
					$elm$core$List$map,
					function (posix) {
						return $author$project$Pages$Users$Delonghi$TimeSeq$formatDateTimeWithoutYear(
							A2(
								$justinmimbs$time_extra$Time$Extra$posixToParts,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								posix));
					},
					A5(
						$justinmimbs$time_extra$Time$Extra$range,
						13,
						interval,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						fromPosix,
						toPosix)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$toCsv = F2(
	function (headerDateTimes, bodyProducts) {
		var header = headerDateTimes;
		var body = A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$elm$core$List$map,
					function (product) {
						switch (product.$) {
							case 0:
								var storeName = product.a;
								return storeName;
							case 1:
								var cell = product.a;
								return $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(cell.be));
							default:
								return '';
						}
					},
					productList);
			},
			bodyProducts);
		return {
			dE: _List_Nil,
			no: A2($elm$core$List$cons, header, body)
		};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var _v1 = model.ih;
				if (!_v1.$) {
					var product = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dP: true}),
						function () {
							var _v2 = _Utils_Tuple2(
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
							if ((!_v2.a.$) && (!_v2.b.$)) {
								var dateTimePartsFrom = _v2.a.a;
								var dateTimePartsTo = _v2.b.a;
								var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
								var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
								return A4(
									$author$project$Api$get,
									$author$project$Endpoints$User$delonghiEndpoints.iA.g(
										_List_fromArray(
											[
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'interval',
												$elm$core$String$fromInt(model.ac)),
												A3(
												$Herteby$url_builder_plus$UrlBuilderPlus$list,
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'products',
												_List_fromArray(
													[product]))
											])),
									model.C,
									$author$project$Pages$Users$Delonghi$TimeSeq$getPriceResponseDecoder,
									$author$project$Pages$Users$Delonghi$TimeSeq$GetPriceRequestSent);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dQ: true}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ig: selectedBigCategory}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gD: selectedSmallCategoryId}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var productId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dQ: true,
							ih: (productId === '-1') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(productId)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, kn: initResponse.kn, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.jb, aN: getPriceResponse.aN, en: model.cY, eo: model.cZ, ep: model.ih, eq: model.il, er: model.im}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var headerDateTimes = A3(
					$author$project$Pages$Users$Delonghi$TimeSeq$pStoreHeader,
					A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
					model.ac);
				var currentProduct = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Helpers$defaultProduct,
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kl;
							},
							$elm$core$Basics$eq(
								A2($elm$core$Maybe$withDefault, '', model.ep))),
						model.kn));
				var bodyProducts = A4(
					$author$project$Pages$Users$Delonghi$TimeSeq$pProductPriceRows,
					model.aN,
					$elm$core$List$length(headerDateTimes),
					model.cQ,
					currentProduct.lt);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A2($author$project$Pages$Users$Delonghi$TimeSeq$toCsv, headerDateTimes, bodyProducts))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Delonghi$TimeSeq2$Price))))))))))));
var $author$project$Pages$Users$Delonghi$TimeSeq2$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Delonghi$TimeSeq2$priceDecoder)));
var $author$project$Pages$Users$Delonghi$TimeSeq2$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Delonghi$TimeSeq2$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Delonghi$TimeSeq2$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Delonghi$TimeSeq2$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$Lower = 1;
var $author$project$Pages$Users$Delonghi$TimeSeq2$Lowest = 0;
var $author$project$Pages$Users$Delonghi$TimeSeq2$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Delonghi$TimeSeq2$Normal = 3;
var $author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Delonghi$TimeSeq2$Unchanged = {$: 2};
var $author$project$Pages$Users$Delonghi$TimeSeq2$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Delonghi$TimeSeq2$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Delonghi$TimeSeq2$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Delonghi$TimeSeq2$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Delonghi$TimeSeq2$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Delonghi$TimeSeq2$Unchanged);
											} else {
												return $author$project$Pages$Users$Delonghi$TimeSeq2$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Delonghi$TimeSeq2$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$delonghiEndpoints.nX.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'stores',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))
										])),
								model.C,
								$author$project$Pages$Users$Delonghi$TimeSeq2$getPriceResponseDecoder,
								$author$project$Pages$Users$Delonghi$TimeSeq2$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var makerId = msg.a;
				var newSelectedMaker = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							newSelectedMaker,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.jW),
							newSelectedMaker);
					},
					model.c1);
				var newMultiselectProducts = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.E,
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_Tuple2(p.kl, p.nk);
						},
						filteredProducts),
					_List_Nil);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: newMultiselectProducts, eh: newSelectedMaker}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeProduct, subCmd));
			case 7:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeStore, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.iw),
												s.kS);
										},
										initResponse.b$),
									_List_Nil),
								c1: initResponse.kn,
								io: initResponse.b$,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 13:
				var storeHeader = A2($author$project$Pages$Users$Delonghi$TimeSeq2$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Delonghi$TimeSeq2$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Delonghi$TimeSeq2$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Delonghi$Weekly$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$filterStoreGroups = function (storeGroups) {
	return A2(
		$elm$core$List$filter,
		function (storeGroup) {
			return storeGroup.iv !== 5;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return storeGroup.iv !== 2;
			},
			storeGroups));
};
var $author$project$Pages$Users$Delonghi$Weekly$filterStores = function (stores) {
	return A2(
		$elm$core$List$filter,
		function (store) {
			return store.iv !== 5;
		},
		A2(
			$elm$core$List$filter,
			function (store) {
				return store.iv !== 2;
			},
			stores));
};
var $author$project$Pages$Users$Delonghi$Weekly$GetPriceResponse = F4(
	function (dictPrice, storeGroups, products, downloadURL) {
		return {jb: dictPrice, ck: downloadURL, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Delonghi$Weekly$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Delonghi$Weekly$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$Delonghi$Weekly$Price)))))))))));
var $author$project$Pages$Users$Delonghi$Weekly$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Delonghi$Weekly$priceDecoder)));
var $author$project$Pages$Users$Delonghi$Weekly$getPriceResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Pages$Users$Delonghi$Weekly$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Delonghi$Weekly$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder),
	A2($elm$json$Json$Decode$field, 'downloadURL', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$Delonghi$Weekly$Decreased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$Lower = 0;
var $author$project$Pages$Users$Delonghi$Weekly$Normal = 1;
var $author$project$Pages$Users$Delonghi$Weekly$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Delonghi$Weekly$Unchanged = {$: 1};
var $author$project$Pages$Users$Delonghi$Weekly$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 4])),
		_Utils_Tuple2(
		'DisplayPriceIncludeTax',
		_List_fromArray(
			[1, 4])),
		_Utils_Tuple2(
		'DisplayPriceWithPoint',
		_List_fromArray(
			[2, 4])),
		_Utils_Tuple2(
		'DisplayPriceWithPointIncludeTax',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayPriceWithoutTime',
		_List_fromArray(
			[0]))
	]);
var $author$project$Pages$Users$Delonghi$Weekly$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v9 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v9.a.$) && (!_v9.b.$)) {
			var dateTimePartsFrom = _v9.a.a;
			var dateTimePartsTo = _v9.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '価格', m: 0},
								{jP: '価格', m: 1},
								{jP: '価格', m: 2},
								{jP: '価格', m: 3},
								{jP: '取得時刻', m: 4}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayPrice',
											_List_fromArray(
												[0, 4])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Delonghi$Weekly$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 3
							},
								{jP: '-', m: 4}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						var basePriceIncludeTaxList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 3
							},
								{jP: '-', m: 4}
							]);
						var filteredBasePriceIncludeTaxList = filterItemList(basePriceIncludeTaxList);
						var basePriceWithPointWithTax = ((basePriceIncludeTax * 100) / 90) | 0;
						var basePriceListWithPointIncludeTax = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithTax)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithTax)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithTax)),
								m: 3
							},
								{jP: '-', m: 4}
							]);
						var filteredBasePriceWithPointIncludeTaxList = filterItemList(basePriceListWithPointIncludeTax);
						var basePriceWithPointWithoutTax = ((basePriceIncludeTax * 100) / 99) | 0;
						var basePriceListWithPoint = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithoutTax)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithoutTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithoutTax)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithPointWithoutTax)),
								m: 3
							},
								{jP: '-', m: 4}
							]);
						var filteredBasePriceWithPointList = filterItemList(basePriceListWithPoint);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(filteredBasePriceList),
										$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(filteredBasePriceIncludeTaxList),
										$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(filteredBasePriceWithPointList),
										$author$project$Pages$Users$Delonghi$Weekly$ProductPriceHeader(filteredBasePriceWithPointIncludeTaxList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v7 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v7.a.$) && (!_v7.b.$)) {
												var currentPrice = _v7.a.a;
												var prevPrice = _v7.b.a;
												return ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) && (_Utils_cmp(currentPrice.be, product.cb) < 0)) ? $author$project$Pages$Users$Delonghi$Weekly$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Delonghi$Weekly$Unchanged;
											} else {
												return $author$project$Pages$Users$Delonghi$Weekly$Unchanged;
											}
										}();
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_cmp(price.be, product.cb) < 0;
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											if (isLower) {
												return 0;
											} else {
												return 1;
											}
										}();
										var priceWithoutTax = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return ((price.be * 100) / 110) | 0;
											} else {
												return 0;
											}
										}();
										var priceWithoutPointWithoutTax = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return ((price.be * (100 - price.ka)) / 100) | 0;
											} else {
												return 0;
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(priceWithoutTax)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 1
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Delonghi$Weekly$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Delonghi$Weekly$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Delonghi$Weekly$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '時刻', '項目', '基準価格(ポイント抜き)(税抜き)', '基準価格(ポイント抜き)(税込み)', '基準価格(10%ポイント)(税抜き)', '基準価格(10%ポイント)(税込み)'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Delonghi$Weekly$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayPrice',
												_List_fromArray(
													[0, 4])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		if (!_v3) {
																			return '※';
																		} else {
																			return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Delonghi$Weekly$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$delonghiEndpoints.lf.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'stores',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))
										])),
								model.C,
								$author$project$Pages$Users$Delonghi$Weekly$getPriceResponseDecoder,
								$author$project$Pages$Users$Delonghi$Weekly$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var makerId = msg.a;
				var newSelectedMaker = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							newSelectedMaker,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.jW),
							newSelectedMaker);
					},
					model.c1);
				var newMultiselectProducts = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.E,
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_Tuple2(p.kl, p.nk);
						},
						filteredProducts),
					_List_Nil);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: newMultiselectProducts, eh: newSelectedMaker}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Delonghi$Weekly$OnChangeProduct, subCmd));
			case 7:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Delonghi$Weekly$OnChangeStore, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.iw),
												s.kS);
										},
										$author$project$Pages$Users$Delonghi$Weekly$filterStores(initResponse.b$)),
									_List_Nil),
								c1: initResponse.kn,
								io: $author$project$Pages$Users$Delonghi$Weekly$filterStores(initResponse.b$),
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					var filteredStoreGroups = $author$project$Pages$Users$Delonghi$Weekly$filterStoreGroups(getPriceResponse.X);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ck: getPriceResponse.ck,
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: filteredStoreGroups,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										filteredStoreGroups)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 13:
				var storeHeader = A2($author$project$Pages$Users$Delonghi$Weekly$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Delonghi$Weekly$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Delonghi$Weekly$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Denon6Comnet$TimeSeq$Price))))))))))));
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Denon6Comnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Denon6Comnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Denon6Comnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Lower = 1;
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Normal = 3;
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Denon6Comnet$TimeSeq$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Denon6Comnet$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Denon6Comnet$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Denon6Comnet$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Denon6Comnet$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Denon6Comnet$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Denon6Comnet$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Denon6Comnet$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 12:
				var storeHeader = A2($author$project$Pages$Users$Denon6Comnet$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Denon6Comnet$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Denon6Comnet$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Denon6Comnet$Wide$Price))))))))))));
var $author$project$Pages$Users$Denon6Comnet$Wide$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Denon6Comnet$Wide$priceDecoder)));
var $author$project$Pages$Users$Denon6Comnet$Wide$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Denon6Comnet$Wide$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Denon6Comnet$Wide$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Denon6Comnet$Wide$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$Lower = 1;
var $author$project$Pages$Users$Denon6Comnet$Wide$Lowest = 0;
var $author$project$Pages$Users$Denon6Comnet$Wide$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Denon6Comnet$Wide$Normal = 3;
var $author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Denon6Comnet$Wide$Unchanged = {$: 2};
var $author$project$Pages$Users$Denon6Comnet$Wide$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Denon6Comnet$Wide$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Denon6Comnet$Wide$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Denon6Comnet$Wide$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Denon6Comnet$Wide$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Denon6Comnet$Wide$Unchanged);
											} else {
												return $author$project$Pages$Users$Denon6Comnet$Wide$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Denon6Comnet$Wide$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Denon6Comnet$Wide$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$succDate = function (dateString) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(dateString);
	if (!_v0.$) {
		var date = _v0.a;
		return $justinmimbs$date$Date$toIsoString(
			A3($justinmimbs$date$Date$add, 3, 1, date));
	} else {
		return dateString;
	}
};
var $author$project$Pages$Users$Denon6Comnet$Wide$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										var top_ind = function () {
											var _v6 = A2($elm_community$list_extra$List$Extra$getAt, 0, indices);
											if (!_v6.$) {
												var x = _v6.a;
												return x;
											} else {
												return 0;
											}
										}();
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		var res = function () {
																			var _v2 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return (_Utils_eq(ind, top_ind) && _Utils_eq(item.m, -1)) || _Utils_eq(item.m, ind);
																				},
																				data);
																			if (!_v2.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v2.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var res = function () {
																			var _v3 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return _Utils_eq(item.m, ind);
																				},
																				data.h6);
																			if (!_v3.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v3.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v5 = data.du;
																		switch (_v5) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date, cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:00'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Denon6Comnet$Wide$getPriceResponseDecoder,
								$author$project$Pages$Users$Denon6Comnet$Wide$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				var bigCategoryId = msg.a;
				var selectedBigCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategoryId);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var makerId = msg.a;
				var selectedMakerId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A4($author$project$Utils$Helpers$filterBySelector, selectedMakerId, model.ig, model.gD, model.c1)),
								_List_Nil),
							eh: selectedMakerId
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Denon6Comnet$Wide$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: $author$project$Pages$Users$Denon6Comnet$Wide$succDate(model.cY),
								et: '00:00',
								gQ: '00:00',
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 9:
				var storeHeader = A2($author$project$Pages$Users$Denon6Comnet$Wide$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Denon6Comnet$Wide$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Denon6Comnet$Wide$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$ElecComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$ElecComnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$ElecComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$ElecComnet$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$ElecComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$ElecComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 8:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(product.lt)),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index + 1)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV._, model.C, body, $author$project$Pages$Users$ElecComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$ElecComnet$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$ElecComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$ElecComnet$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ElecComnet$Excel$GetExcelRequestSent = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.nH));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $author$project$Api$getByte = F3(
	function (path, session, msg) {
		var apiConf = $author$project$Session$getConfig(session);
		var config = {
			dp: $elm$http$Http$emptyBody,
			dC: A2(
				$elm$http$Http$expectBytesResponse,
				msg,
				$author$project$Api$resolve($elm$core$Result$Ok)),
			dE: $author$project$Api$makeAuthHeader(session),
			d0: $author$project$Api$decodeHTTPMethod(0),
			ew: $elm$core$Maybe$Nothing,
			ez: $elm$core$Maybe$Nothing,
			eD: A3(
				$author$project$Api$makeEndpoint,
				apiConf,
				_List_fromArray(
					[path]),
				_List_Nil)
		};
		return $elm$http$Http$request(config);
	});
var $author$project$Pages$Users$ElecComnet$Excel$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 13:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A3(
								$author$project$Api$getByte,
								$author$project$Endpoints$User$elecComnetEndpoints.fn.em(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(60)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$ElecComnet$Excel$GetExcelRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 7:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$ElecComnet$Excel$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				if (!msg.a.$) {
					var bytes = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, dP: false}),
						A3($elm$file$File$Download$bytes, model.cY + ('〜' + (model.im + '.xlsx')), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', bytes));
				} else {
					var e = msg.a.a;
					var errMsg = function () {
						if ((e.$ === 3) && (e.a === 404)) {
							return '該当するデータが見つかりませんでした。検索条件を変更して再度お試しください。';
						} else {
							return $author$project$Utils$Helpers$errToStr(e);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(errMsg),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$ElecComnet$Hour$update = $author$project$Pages$Users$Common$Default$update;
var $author$project$Pages$Users$ElecComnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$GetPriceResponse = F2(
	function (dictPrice, stores) {
		return {jb: dictPrice, aN: stores};
	});
var $author$project$Pages$Users$ElecComnet$TimeSeq$Price = F9(
	function (storeId, nth, dateTime, price, priceIncludeTax, point, priceWithoutPoint, coupon, url) {
		return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, iw: storeId, eD: url};
	});
var $author$project$Pages$Users$ElecComnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									$elm$json$Json$Decode$succeed($author$project$Pages$Users$ElecComnet$TimeSeq$Price))))))))));
var $author$project$Pages$Users$ElecComnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$ElecComnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$ElecComnet$TimeSeq$getPriceResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$ElecComnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$ElecComnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder));
var $author$project$Pages$Users$ElecComnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$ElecComnet$TimeSeq$StoreHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$pProductPriceRows = F4(
	function (stores, maxRowNum, prices, basePrice) {
		return A2(
			$elm$core$List$map,
			function (store) {
				return A2(
					$elm$core$List$cons,
					$author$project$Pages$Users$ElecComnet$TimeSeq$StoreHeader(store.fh),
					A2(
						$elm$core$List$map,
						function (ind) {
							var prevMaybePrice = $elm_community$maybe_extra$Maybe$Extra$orList(
								$elm$core$List$reverse(
									A2(
										$elm$core$List$map,
										function (prevInd) {
											return A2(
												$elm$core$Dict$get,
												_Utils_Tuple2(store.iw, prevInd),
												prices);
										},
										A2($elm$core$List$range, 1, ind - 1))));
							var lowestPrice = A2(
								$elm$core$Maybe$withDefault,
								-1,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.be;
									},
									A2(
										$elm_community$list_extra$List$Extra$minimumBy,
										function ($) {
											return $.be;
										},
										$elm_community$maybe_extra$Maybe$Extra$values(
											A2(
												$elm$core$List$map,
												function (st) {
													return A2(
														$elm$core$Dict$get,
														_Utils_Tuple2(st.iw, ind),
														prices);
												},
												stores)))));
							var currentMaybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(store.iw, ind),
								prices);
							if (!currentMaybePrice.$) {
								var currentPrice = currentMaybePrice.a;
								return $author$project$Pages$Users$ElecComnet$TimeSeq$ProductPriceData(
									{
										du: (_Utils_cmp(currentPrice.be, basePrice) < 0) ? (_Utils_eq(currentPrice.be, lowestPrice) ? 0 : 1) : (_Utils_eq(currentPrice.be, lowestPrice) ? 2 : 3),
										ge: function () {
											if (!prevMaybePrice.$) {
												var prevPrice = prevMaybePrice.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Common$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Common$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Common$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Common$TimeSeq$Unchanged;
											}
										}(),
										be: currentPrice.be,
										eD: currentPrice.eD
									});
							} else {
								return $author$project$Pages$Users$ElecComnet$TimeSeq$ProductPriceNoData;
							}
						},
						A2($elm$core$List$range, 1, maxRowNum - 1)));
			},
			stores);
	});
var $author$project$Pages$Users$ElecComnet$TimeSeq$formatDateTimeWithoutYear = function (parts) {
	return A2(
		$elm$core$String$right,
		2,
		'0' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Utils$Helpers$monthToInt)(parts.mQ)) + ('月' + (A2(
		$elm$core$String$right,
		2,
		'0' + $elm$core$String$fromInt(parts.fd)) + ('日' + A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO))));
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$pStoreHeader = F3(
	function (maybeFromParts, maybeToParts, interval) {
		var _v0 = _Utils_Tuple2(maybeFromParts, maybeToParts);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fromParts = _v0.a.a;
			var toParts = _v0.b.a;
			var toPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				toParts);
			var fromPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				fromParts);
			return function (ls) {
				return A2($elm$core$List$cons, '', ls);
			}(
				A2(
					$elm$core$List$map,
					function (posix) {
						return $author$project$Pages$Users$ElecComnet$TimeSeq$formatDateTimeWithoutYear(
							A2(
								$justinmimbs$time_extra$Time$Extra$posixToParts,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								posix));
					},
					A5(
						$justinmimbs$time_extra$Time$Extra$range,
						13,
						interval,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						fromPosix,
						toPosix)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Users$ElecComnet$TimeSeq$toCsv = F2(
	function (headerDateTimes, bodyProducts) {
		var header = headerDateTimes;
		var body = A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$elm$core$List$map,
					function (product) {
						switch (product.$) {
							case 0:
								var storeName = product.a;
								return storeName;
							case 1:
								var cell = product.a;
								return A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$Helpers$toCommmaSplited)(cell.be);
							default:
								return '';
						}
					},
					productList);
			},
			bodyProducts);
		return {
			dE: _List_Nil,
			no: A2($elm$core$List$cons, header, body)
		};
	});
var $author$project$Pages$Users$ElecComnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var _v1 = model.ih;
				if (!_v1.$) {
					var product = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dP: true}),
						function () {
							var _v2 = _Utils_Tuple2(
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
							if ((!_v2.a.$) && (!_v2.b.$)) {
								var dateTimePartsFrom = _v2.a.a;
								var dateTimePartsTo = _v2.b.a;
								var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
								var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
								return A4(
									$author$project$Api$get,
									$author$project$Endpoints$User$elecComnetEndpoints.iA.g(
										_List_fromArray(
											[
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'interval',
												$elm$core$String$fromInt(model.ac)),
												A3(
												$Herteby$url_builder_plus$UrlBuilderPlus$list,
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'products',
												_List_fromArray(
													[product]))
											])),
									model.C,
									$author$project$Pages$Users$ElecComnet$TimeSeq$getPriceResponseDecoder,
									$author$project$Pages$Users$ElecComnet$TimeSeq$GetPriceRequestSent);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dQ: true}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ig: selectedBigCategory}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gD: selectedSmallCategoryId}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var productId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dQ: true,
							ih: (productId === '-1') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(productId)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, kn: initResponse.kn, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.jb, aN: getPriceResponse.aN, en: model.cY, eo: model.cZ, ep: model.ih, eq: model.il, er: model.im}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var headerDateTimes = A3(
					$author$project$Pages$Users$ElecComnet$TimeSeq$pStoreHeader,
					A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
					model.ac);
				var currentProduct = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Helpers$defaultProduct,
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kl;
							},
							$elm$core$Basics$eq(
								A2($elm$core$Maybe$withDefault, '', model.ep))),
						model.kn));
				var bodyProducts = A4(
					$author$project$Pages$Users$ElecComnet$TimeSeq$pProductPriceRows,
					model.aN,
					$elm$core$List$length(headerDateTimes),
					model.cQ,
					currentProduct.lt);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A2($author$project$Pages$Users$ElecComnet$TimeSeq$toCsv, headerDateTimes, bodyProducts))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateAllProducts = {$: 7};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$encodeProduct = function (product) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'product_id',
				$elm$json$Json$Encode$string(product.kl)),
				_Utils_Tuple2(
				'base_price',
				$elm$json$Json$Encode$int(product.lt)),
				_Utils_Tuple2(
				'base_point',
				$elm$json$Json$Encode$int(product.ls)),
				_Utils_Tuple2(
				'product_order',
				$elm$json$Json$Encode$int(product.nl)),
				_Utils_Tuple2(
				'week30_product_order',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, product.bn))),
				_Utils_Tuple2(
				'yodobashi_base_price_flag',
				$elm$json$Json$Encode$bool(product.oc)),
				_Utils_Tuple2(
				'get_interval',
				$elm$json$Json$Encode$int(product.js))
			]));
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var _v0 = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!_v0.$) {
			var product = _v0.a;
			return _Utils_update(
				model,
				{
					kn: A3(
						$elm_community$list_extra$List$Extra$setAt,
						ind,
						f(product),
						model.kn)
				});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$FujiComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$FujiComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$FujiComnet$ChangeProduct$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					if (!msg.a.$) {
						var initResponse = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cv: false, kn: initResponse.kn}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										$author$project$Utils$Helpers$errToStr(err)),
									cv: false
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 1:
					if (!msg.a.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{k: false}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										$author$project$Utils$Helpers$errToStr(err)),
									k: false
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 2:
					var ind = msg.a;
					var val = msg.b;
					var newBasePrice = A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(val));
					return _Utils_Tuple2(
						A3(
							$author$project$Pages$Users$FujiComnet$ChangeProduct$updateProduct,
							ind,
							model,
							function (product) {
								return _Utils_update(
									product,
									{
										ls: (!newBasePrice) ? 0 : ((!product.lt) ? 10 : product.ls),
										lt: newBasePrice,
										bn: (!newBasePrice) ? $elm$core$Maybe$Nothing : product.bn
									});
							}),
						$elm$core$Platform$Cmd$none);
				case 3:
					var ind = msg.a;
					var val = msg.b;
					return _Utils_Tuple2(
						A3(
							$author$project$Pages$Users$FujiComnet$ChangeProduct$updateProduct,
							ind,
							model,
							function (product) {
								return _Utils_update(
									product,
									{
										ls: A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toInt(val))
									});
							}),
						$elm$core$Platform$Cmd$none);
				case 4:
					var ind = msg.a;
					var val = msg.b;
					return _Utils_Tuple2(
						A3(
							$author$project$Pages$Users$FujiComnet$ChangeProduct$updateProduct,
							ind,
							model,
							function (product) {
								return _Utils_update(
									product,
									{
										bn: $elm$core$String$toInt(val)
									});
							}),
						$elm$core$Platform$Cmd$none);
				case 5:
					var index = msg.a;
					var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
					if (!_v1.$) {
						var product = _v1.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{k: true}),
							A5(
								$author$project$Api$post,
								$author$project$Endpoints$User$fujiComnetEndpoints.aV._,
								model.C,
								$author$project$Pages$Users$FujiComnet$ChangeProduct$encodeProduct(product),
								$author$project$Pages$Users$FujiComnet$ChangeProduct$updateProductResponseDecoder,
								$author$project$Pages$Users$FujiComnet$ChangeProduct$UpdateProductRequestSent));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 6:
					var index = msg.a;
					var $temp$msg = $author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateProduct(index),
						$temp$model = _Utils_update(
						model,
						{
							kn: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (product) {
									return _Utils_update(
										product,
										{ls: 0, lt: 0, bn: $elm$core$Maybe$Nothing});
								},
								model.kn)
						});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 7:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$User$fujiComnetEndpoints.aV.iE,
							model.C,
							A2($elm$json$Json$Encode$list, $author$project$Pages$Users$FujiComnet$ChangeProduct$encodeProduct, model.kn),
							$author$project$Pages$Users$FujiComnet$ChangeProduct$updateProductResponseDecoder,
							$author$project$Pages$Users$FujiComnet$ChangeProduct$UpdateProductRequestSent));
				default:
					var $temp$msg = $author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateAllProducts,
						$temp$model = _Utils_update(
						model,
						{
							kn: A2(
								$elm$core$List$map,
								function (product) {
									return _Utils_update(
										product,
										{ls: 0, lt: 0, bn: $elm$core$Maybe$Nothing});
								},
								model.kn)
						});
					msg = $temp$msg;
					model = $temp$model;
					continue update;
			}
		}
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$FujiComnet$Fifteen$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$FujiComnet$Fifteen$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$FujiComnet$Fifteen$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$FujiComnet$Fifteen$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$FujiComnet$Fifteen$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$FujiComnet$Fifteen$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$FujiComnet$Fifteen$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiComnetEndpoints.l7.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$FujiComnet$Fifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$FujiComnet$Fifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiComnetEndpoints.l7.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$FujiComnet$Fifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$FujiComnet$Fifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$FujiComnet$Fifteen$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$FujiComnet$Fifteen$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$FujiComnet$Fifteen$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$FujiComnet$LatestStore$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$PricesResponse = function (prices) {
	return {cQ: prices};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$PriceRow = F8(
	function (dateTime, productName, productId, smallCategoryName, price, point, priceWithoutPoint, url) {
		return {lP: dateTime, ka: point, kg: price, be: priceWithoutPoint, kl: productId, nk: productName, nF: smallCategoryName, eD: url};
	});
var $author$project$Pages$Users$FujiComnet$LatestStore$priceRowDecoder = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Pages$Users$FujiComnet$LatestStore$PriceRow,
	A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'small_category_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$FujiComnet$LatestStore$pricesResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$FujiComnet$LatestStore$PricesResponse,
	A2(
		$elm$json$Json$Decode$field,
		'prices',
		$elm$json$Json$Decode$list($author$project$Pages$Users$FujiComnet$LatestStore$priceRowDecoder)));
var $author$project$Pages$Users$FujiComnet$LatestStore$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, 15))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var storeIdStr = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: $elm$core$String$toInt(storeIdStr)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var smallCategoryIdStr = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: $elm$core$String$toInt(smallCategoryIdStr)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										-15,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiComnetEndpoints.jR.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'storeId',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, 0, model.aB))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD)))
										])),
								model.C,
								$author$project$Pages$Users$FujiComnet$LatestStore$pricesResponseDecoder,
								$author$project$Pages$Users$FujiComnet$LatestStore$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									15,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									15,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											-15,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiComnetEndpoints.jR.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'storeId',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, 0, model.aB))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD)))
										])),
								model.C,
								$author$project$Pages$Users$FujiComnet$LatestStore$pricesResponseDecoder,
								$author$project$Pages$Users$FujiComnet$LatestStore$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cv: false, aB: $elm$core$Maybe$Nothing, kL: initResponse.kL, aN: initResponse.aN}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.cQ}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$FujiComnet$Week30$UpdateRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$FujiComnet$Week30$httpErrorToString = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'Bad URL: ' + url;
		case 1:
			return 'Request timed out';
		case 2:
			return 'Network error';
		case 3:
			var status = error.a;
			return 'Bad status: ' + $elm$core$String$fromInt(status);
		default:
			var body = error.a;
			return 'Bad body: ' + body;
	}
};
var $author$project$Pages$Users$FujiComnet$Week30$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$FujiComnet$Week30$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$FujiComnet$Week30$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$FujiComnet$Week30$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								dO: false,
								kn: response.kn,
								ij: $elm$core$Set$fromList(response.lc)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Pages$Users$FujiComnet$Week30$httpErrorToString(error)),
								dO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var response = result.a;
					return response.nO ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								a7: false,
								dc: $elm$core$Maybe$Just('更新しました')
							}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just('更新に失敗しました'),
								a7: false
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Pages$Users$FujiComnet$Week30$httpErrorToString(error)),
								a7: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var productId = msg.a;
				var checked = msg.b;
				var newSelected = checked ? A2($elm$core$Set$insert, productId, model.ij) : A2($elm$core$Set$remove, productId, model.ij);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ij: newSelected, dc: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'week30_products',
							A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$string,
								$elm$core$Set$toList(model.ij)))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a7: true, dc: $elm$core$Maybe$Nothing}),
					A5($author$project$Api$post, $author$project$Endpoints$User$fujiComnetEndpoints.lb._, model.C, body, $author$project$Pages$Users$FujiComnet$Week30$updateResponseDecoder, $author$project$Pages$Users$FujiComnet$Week30$UpdateRequestSent));
		}
	});
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$PricesResponse = function (prices) {
	return {cQ: prices};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$PriceRow = F8(
	function (dateTime, productName, productId, smallCategoryName, price, point, priceWithoutPoint, url) {
		return {lP: dateTime, ka: point, kg: price, be: priceWithoutPoint, kl: productId, nk: productName, nF: smallCategoryName, eD: url};
	});
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$priceRowDecoder = A9(
	$elm$json$Json$Decode$map8,
	$author$project$Pages$Users$FujiinstaxComnet$LatestStore$PriceRow,
	A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'small_category_name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$pricesResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$FujiinstaxComnet$LatestStore$PricesResponse,
	A2(
		$elm$json$Json$Decode$field,
		'prices',
		$elm$json$Json$Decode$list($author$project$Pages$Users$FujiinstaxComnet$LatestStore$priceRowDecoder)));
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, 15))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var storeIdStr = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aB: $elm$core$String$toInt(storeIdStr)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var smallCategoryIdStr = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: $elm$core$String$toInt(smallCategoryIdStr)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										-15,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiinstaxComnetEndpoints.jR.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'storeId',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, 0, model.aB))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD)))
										])),
								model.C,
								$author$project$Pages$Users$FujiinstaxComnet$LatestStore$pricesResponseDecoder,
								$author$project$Pages$Users$FujiinstaxComnet$LatestStore$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									15,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									15,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											-15,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiinstaxComnetEndpoints.jR.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'storeId',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, 0, model.aB))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD)))
										])),
								model.C,
								$author$project$Pages$Users$FujiinstaxComnet$LatestStore$pricesResponseDecoder,
								$author$project$Pages$Users$FujiinstaxComnet$LatestStore$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cv: false, aB: $elm$core$Maybe$Nothing, kL: initResponse.kL, aN: initResponse.aN}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.cQ}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$FujiinstaxComnet$Thirty$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$FujiinstaxComnet$Thirty$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$FujiinstaxComnet$Thirty$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$FujiinstaxComnet$Thirty$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiinstaxComnetEndpoints.nU.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$FujiinstaxComnet$Thirty$getPriceResponseDecoder,
								$author$project$Pages$Users$FujiinstaxComnet$Thirty$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$fujiinstaxComnetEndpoints.nU.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$FujiinstaxComnet$Thirty$getPriceResponseDecoder,
								$author$project$Pages$Users$FujiinstaxComnet$Thirty$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$FujiinstaxComnet$Thirty$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$FujiinstaxComnet$Thirty$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$FujiinstaxComnet$Thirty$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$FujiinstaxComnet$Week30$UpdateRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$httpErrorToString = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'Bad URL: ' + url;
		case 1:
			return 'Request timed out';
		case 2:
			return 'Network error';
		case 3:
			var status = error.a;
			return 'Bad status: ' + $elm$core$String$fromInt(status);
		default:
			var body = error.a;
			return 'Bad body: ' + body;
	}
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$UpdateResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$updateResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$FujiinstaxComnet$Week30$UpdateResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$FujiinstaxComnet$Week30$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var response = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								dO: false,
								kn: response.kn,
								ij: $elm$core$Set$fromList(response.lc)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Pages$Users$FujiinstaxComnet$Week30$httpErrorToString(error)),
								dO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var response = result.a;
					return response.nO ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								a7: false,
								dc: $elm$core$Maybe$Just('更新しました')
							}),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just('更新に失敗しました'),
								a7: false
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Pages$Users$FujiinstaxComnet$Week30$httpErrorToString(error)),
								a7: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var productId = msg.a;
				var checked = msg.b;
				var newSelected = checked ? A2($elm$core$Set$insert, productId, model.ij) : A2($elm$core$Set$remove, productId, model.ij);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ij: newSelected, dc: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'week30_products',
							A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$string,
								$elm$core$Set$toList(model.ij)))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a7: true, dc: $elm$core$Maybe$Nothing}),
					A5($author$project$Api$post, $author$project$Endpoints$User$fujiinstaxComnetEndpoints.lb._, model.C, body, $author$project$Pages$Users$FujiinstaxComnet$Week30$updateResponseDecoder, $author$project$Pages$Users$FujiinstaxComnet$Week30$UpdateRequestSent));
		}
	});
var $author$project$Pages$Users$Hi24Comnet$Day$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi24Comnet$Day$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$Day$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$Day$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi24Comnet$Day$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi24Comnet$Day$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4},
						{jP: '工事費', m: 5}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Hi24Comnet$Day$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4},
						{jP: '-', m: 5}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi24Comnet$Day$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Hi24Comnet$Day$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Hi24Comnet$Day$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Hi24Comnet$Day$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v7.a && (!_v7.b.$)) {
										var yodobashiPrice = _v7.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v5 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v5.a && (!_v5.b.$)) {
										var yodobashiPrice = _v5.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									},
										{
										jP: function () {
											var _v3 = price.lG;
											if (_v3.$ === 1) {
												return '0';
											} else {
												var constructionCost = _v3.a;
												return $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(constructionCost));
											}
										}(),
										m: 5
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Hi24Comnet$Day$ProductPriceData(
									{hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Hi24Comnet$Day$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi24Comnet$Day$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$Day$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Hi24Comnet$Day$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Hi24Comnet$Day$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:00'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$hi24ComnetEndpoints.fd.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'stores',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedBigCategory,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.e_),
								selectedBigCategory);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedSmallCategoryId,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.ir),
								selectedSmallCategoryId);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.S);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(subModel)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							model.ig,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.e_),
							model.ig);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
						},
						model.c1));
				var newMultiselectProducts = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.E,
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_Tuple2(p.kl, p.nk);
						},
						filteredProducts),
					_List_Nil);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: subModel, E: newMultiselectProducts}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$Day$OnChangeMaker, subCmd));
			case 6:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$Day$OnChangeProduct, subCmd));
			case 7:
				var sub = msg.a;
				var _v4 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v4.a;
				var subCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$Day$OnChangeStore, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					var filteredProducts = A2(
						$elm$core$List$filter,
						function (product) {
							return product.nk !== 'blank';
						},
						initResponse.kn);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								S: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.S,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.jW),
												s.mH);
										},
										initResponse.cE),
									_List_Nil),
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.iw),
												s.kS);
										},
										initResponse.b$),
									_List_Nil),
								c1: filteredProducts,
								io: initResponse.b$,
								kL: initResponse.kL,
								b$: initResponse.b$
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 13:
				var storeHeader = A2($author$project$Pages$Users$Hi24Comnet$Day$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Hi24Comnet$Day$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Hi24Comnet$Day$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi24Comnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi24Comnet$Hour$hi24Groups = _List_fromArray(
	[187, 189, 203, 204, 252]);
var $author$project$Pages$Users$Hi24Comnet$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function (storeGroup) {
			return A2(
				$elm$core$List$filter,
				function (store) {
					return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$Hour$hi24Groups)) || model.jx;
				},
				storeGroup.aN);
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜', m: 0},
						{jP: '税込', m: 1},
						{jP: 'ポイント(/ク)', m: 2},
						{jP: 'P適用後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Hi24Comnet$Hour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Hi24Comnet$Hour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi24Comnet$Hour$pStoreHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						A2(
							$elm$core$List$filter,
							function (store) {
								return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$Hour$hi24Groups)) || hi24GroupsVisible;
							},
							storeGroup.aN));
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: A2(
				$elm$core$List$map,
				function ($) {
					return $.kS;
				},
				storeHeader),
			no: A2(
				$elm$core$List$concatMap,
				function (row) {
					var indices = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(
							'DisplayAll',
							_List_fromArray(
								[0, 1, 2, 3])),
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (dispToValue) {
								return _Utils_eq(dispToValue.a, selectedDisplayStyle);
							},
							$author$project$Pages$Users$Hi24Comnet$Hour$displayStyleToValues)).b;
					var numrow = A2(
						$elm$core$List$take,
						$elm$core$List$length(indices),
						_List_fromArray(
							[0, 1, 2, 3]));
					return A2(
						$elm$core$List$map,
						function (ind) {
							return A2(
								$elm$core$List$map,
								function (cell) {
									switch (cell.$) {
										case 0:
											var data = cell.a;
											return A2(
												$elm$core$Maybe$withDefault,
												{jP: '', m: -1},
												A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
										case 1:
											return '';
										default:
											var data = cell.a;
											return A2(
												$elm$core$Maybe$withDefault,
												{jP: '', m: -1},
												A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
									}
								},
								row);
						},
						numrow);
				},
				priceRows)
		};
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var hi24toggle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jx: hi24toggle}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 11:
				var storeHeader = A3($author$project$Pages$Users$Hi24Comnet$Hour$pStoreHeader, model.X, model.L, model.jx);
				var priceRows = $author$project$Pages$Users$Hi24Comnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Hi24Comnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeMaker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Hi24Comnet$HourSeq$Price))))))))))));
var $author$project$Pages$Users$Hi24Comnet$HourSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Hi24Comnet$HourSeq$priceDecoder)));
var $author$project$Pages$Users$Hi24Comnet$HourSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$HourSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Hi24Comnet$HourSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Lower = 1;
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Lowest = 0;
var $author$project$Pages$Users$Hi24Comnet$HourSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Normal = 3;
var $author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi24Comnet$HourSeq$hi24Groups = _List_fromArray(
	[187, 189, 203, 204, 252]);
var $author$project$Pages$Users$Hi24Comnet$HourSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function (storeGroup) {
			return A2(
				$elm$core$List$filter,
				function (store) {
					return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$HourSeq$hi24Groups)) || model.jx;
				},
				storeGroup.aN);
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Hi24Comnet$HourSeq$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Hi24Comnet$HourSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Hi24Comnet$HourSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Hi24Comnet$HourSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Hi24Comnet$HourSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Hi24Comnet$HourSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$pStoreHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						A2(
							$elm$core$List$filter,
							function (store) {
								return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$HourSeq$hi24Groups)) || hi24GroupsVisible;
							},
							storeGroup.aN));
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$hi24ComnetEndpoints.mm.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$HourSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$HourSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedBigCategory,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.e_),
								selectedBigCategory);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedSmallCategoryId,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.ir),
								selectedSmallCategoryId);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.S);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(subModel)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							model.ig,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.e_),
							model.ig);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
						},
						model.c1));
				var newMultiselectProducts = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.E,
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_Tuple2(p.kl, p.nk);
						},
						filteredProducts),
					_List_Nil);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: subModel, E: newMultiselectProducts}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeMaker, subCmd));
			case 7:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								S: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.S,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.jW),
												s.mH);
										},
										initResponse.cE),
									_List_Nil),
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var hi24toggle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jx: hi24toggle}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var storeHeader = A2($author$project$Pages$Users$Hi24Comnet$HourSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Hi24Comnet$HourSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3(
								$author$project$Pages$Users$Hi24Comnet$HourSeq$toCsv,
								storeHeader(model.jx),
								priceRows,
								model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeMaker = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$SixHour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi24Comnet$SixHour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi24Comnet$SixHour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Hi24Comnet$SixHour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Hi24Comnet$SixHour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Hi24Comnet$SixHour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$hi24ComnetEndpoints.nE.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$SixHour$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$SixHour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$hi24ComnetEndpoints.nE.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$SixHour$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$SixHour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.S);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeMaker, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								S: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.S,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.jW),
												s.mH);
										},
										initResponse.cE),
									_List_Nil),
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Hi24Comnet$SixHour$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Hi24Comnet$SixHour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Hi24Comnet$SixHour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeMaker = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$getNthSize = function (model) {
	var _v0 = _Utils_Tuple2(
		A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
		A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var dateTimePartsFrom = _v0.a.a;
		var dateTimePartsTo = _v0.b.a;
		var diff = A4(
			$justinmimbs$time_extra$Time$Extra$diff,
			11,
			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
			A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				dateTimePartsFrom),
			A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				dateTimePartsTo));
		return diff + 1;
	} else {
		return 1;
	}
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Hi24Comnet$TenAM$Price))))))))))));
var $author$project$Pages$Users$Hi24Comnet$TenAM$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Hi24Comnet$TenAM$priceDecoder)));
var $author$project$Pages$Users$Hi24Comnet$TenAM$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$TenAM$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Hi24Comnet$TenAM$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$TenAM$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$Normal = 3;
var $author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi24Comnet$TenAM$Unchanged = {$: 2};
var $author$project$Pages$Users$Hi24Comnet$TenAM$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi24Comnet$TenAM$hi24Groups = _List_fromArray(
	[187, 189, 203, 204, 252]);
var $author$project$Pages$Users$Hi24Comnet$TenAM$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$filter,
		function (store) {
			return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$TenAM$hi24Groups)) || model.jx;
		},
		A2(
			$elm$core$List$filter,
			function (store) {
				return A2($elm$core$Set$member, store.iv, model.L);
			},
			model.aN));
	var products = model.kn;
	var nOfCols = $author$project$Pages$Users$Hi24Comnet$TenAM$getNthSize(model);
	var filterItemList = function (list) {
		return A2(
			$elm$core$Tuple$pair,
			1,
			A2(
				$elm$core$List$map,
				function (i) {
					return A2(
						$elm$core$Maybe$withDefault,
						{jP: '', m: -1},
						A2($elm_community$list_extra$List$Extra$getAt, i, list));
				},
				A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						'DisplayAll',
						_List_fromArray(
							[0, 1, 2, 3, 4, 5])),
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (dispToValue) {
							return _Utils_eq(dispToValue.a, model.c_);
						},
						$author$project$Pages$Users$Hi24Comnet$TenAM$displayStyleToValues)).b));
	};
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return _Utils_ap(
					function () {
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filteredItemList = filterItemList(itemList);
						return _List_fromArray(
							[
								$author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceHeader(
								_Utils_Tuple2(
									1,
									_List_fromArray(
										[
											{
											jP: $elm$core$String$fromInt(ind + 1),
											m: -1
										}
										]))),
								$author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceHeader(
								_Utils_Tuple2(
									1,
									_List_fromArray(
										[
											{jP: product.nk, m: -1}
										]))),
								$author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceHeader(filteredItemList)
							]);
					}(),
					$elm$core$List$concat(
						A2(
							$elm$core$List$map,
							function (nth) {
								var maybeYodobashiPrice = A2(
									$elm$core$Dict$get,
									_Utils_Tuple3(product.kl, 7, nth),
									model.cQ);
								var lowestPrice = A3(
									$elm$core$List$foldl,
									function (price) {
										return function (m) {
											return A2($elm$core$Basics$min, m, price);
										};
									},
									A2($elm$core$Basics$pow, 2, 30),
									A2(
										$elm$core$List$map,
										function (maybePrice) {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return price.be;
											} else {
												return A2($elm$core$Basics$pow, 2, 30);
											}
										},
										A2(
											$elm$core$List$map,
											function (store) {
												return A2(
													$elm$core$Dict$get,
													_Utils_Tuple3(product.kl, store.iw, nth),
													model.cQ);
											},
											stores)));
								var _v0 = function () {
									var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v1.a && (!_v1.b.$)) {
										var yodobashiPrice = _v1.b.a;
										return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
									} else {
										return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
									}
								}();
								var basePrice = _v0.lt;
								var basePriceIncludeTax = _v0.eY;
								var basePoint = _v0.ls;
								var basePriceWithoutPoint = _v0.cb;
								var basePriceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(basePrice)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(basePriceIncludeTax)),
										m: 1
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(basePoint)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(basePriceWithoutPoint)),
										m: 3
									},
										{jP: '-', m: 4},
										{jP: '-', m: 5}
									]);
								return A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v4 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v4.a.$) && (!_v4.b.$)) {
												var currentPrice = _v4.a.a;
												var prevPrice = _v4.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Hi24Comnet$TenAM$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Hi24Comnet$TenAM$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Hi24Comnet$TenAM$Unchanged);
											} else {
												return $author$project$Pages$Users$Hi24Comnet$TenAM$Unchanged;
											}
										}();
										var comparedPriceType = 3;
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v3 = price.lG;
														if (_v3.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v3.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Hi24Comnet$TenAM$ProductPriceNoData;
										}
									},
									stores);
							},
							A2($elm$core$List$range, 1, nOfCols))));
			};
		},
		products);
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$pStoreHeader = F4(
	function (stores, length, visibleStoreGroups, hi24GroupsVisible) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '項目'])),
			$elm$core$List$concat(
				A2(
					$elm$core$List$repeat,
					length,
					A2(
						$elm$core$List$map,
						function (store) {
							return {iv: store.iv, kS: store.fh};
						},
						A2(
							$elm$core$List$filter,
							function (store) {
								return (A2($elm$core$Set$member, store.iv, visibleStoreGroups) && (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$TenAM$hi24Groups))) || hi24GroupsVisible;
							},
							stores)))));
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				$elm$core$List$concat(
					A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								var indices = A2(
									$elm$core$Maybe$withDefault,
									_Utils_Tuple2(
										'DisplayAll',
										_List_fromArray(
											[0, 1, 2, 3, 4, 5])),
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (dispToValue) {
											return _Utils_eq(dispToValue.a, selectedDisplayStyle);
										},
										$author$project$Utils$Helpers$displayStyleToValues)).b;
								return A2(
									$elm$core$List$map,
									function (lst) {
										return (!(!rowInd)) ? lst : lst;
									},
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (ind) {
												return A2(
													$elm$core$List$map,
													function (cell) {
														switch (cell.$) {
															case 0:
																var _v1 = cell.a;
																var data = _v1.b;
																return A2(
																	$elm$core$Maybe$withDefault,
																	{jP: '', m: -1},
																	A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
															case 1:
																return '';
															default:
																var data = cell.a;
																return A2(
																	$elm$core$Maybe$withDefault,
																	{jP: '', m: -1},
																	A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
														}
													},
													row);
											},
											indices),
										_List_fromArray(
											[
												A2(
												$elm$core$List$indexedMap,
												function (ind) {
													return function (cell) {
														var fixedInd = (!(!rowInd)) ? ind : ind;
														switch (cell.$) {
															case 0:
																return (fixedInd === 3) ? '最低● 基準※' : '';
															case 1:
																return '';
															default:
																var data = cell.a;
																var _v3 = data.du;
																switch (_v3) {
																	case 0:
																		return '●';
																	case 1:
																		return '※';
																	default:
																		return '';
																}
														}
													};
												},
												row)
											])));
							};
						},
						priceRows)))
		};
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 19:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$hi24ComnetEndpoints.nS.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'timefrom', model.il),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'timeto', model.im),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'stores',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$TenAM$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$TenAM$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 8:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeStore, subCmd));
			case 15:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedBigCategory,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.e_),
								selectedBigCategory);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedSmallCategoryId,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.ir),
								selectedSmallCategoryId);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.S);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(subModel)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							model.ig,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.e_),
							model.ig);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
						},
						model.c1));
				var newMultiselectProducts = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.E,
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_Tuple2(p.kl, p.nk);
						},
						filteredProducts),
					_List_Nil);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: subModel, E: newMultiselectProducts}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeMaker, subCmd));
			case 7:
				var sub = msg.a;
				var _v4 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v4.a;
				var subCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								S: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.S,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.jW),
												s.mH);
										},
										initResponse.cE),
									_List_Nil),
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.iw),
												s.kS);
										},
										initResponse.b$),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								aN: A2(
									$elm$core$List$concatMap,
									function ($) {
										return $.aN;
									},
									getPriceResponse.X),
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 18:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var hi24toggle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jx: hi24toggle}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var priceRows = $author$project$Pages$Users$Hi24Comnet$TenAM$pProductPriceRows(model);
				var nthSize = $author$project$Pages$Users$Hi24Comnet$TenAM$getNthSize(model);
				var storeHeader = A4($author$project$Pages$Users$Hi24Comnet$TenAM$pStoreHeader, model.aN, nthSize, model.L, model.jx);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Hi24Comnet$TenAM$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Hi24Comnet$TimeSeq$Price))))))))))));
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Hi24Comnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Hi24Comnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Lower = 1;
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Normal = 3;
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$hi24Groups = _List_fromArray(
	[187, 189, 203, 204, 252]);
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function (storeGroup) {
			return A2(
				$elm$core$List$filter,
				function (store) {
					return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$TimeSeq$hi24Groups)) || model.jx;
				},
				storeGroup.aN);
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Hi24Comnet$TimeSeq$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Hi24Comnet$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Hi24Comnet$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Hi24Comnet$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Hi24Comnet$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Hi24Comnet$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$pStoreHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						A2(
							$elm$core$List$filter,
							function (store) {
								return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$TimeSeq$hi24Groups)) || hi24GroupsVisible;
							},
							storeGroup.aN));
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var hi24toggle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jx: hi24toggle}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var storeHeader = A2($author$project$Pages$Users$Hi24Comnet$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Hi24Comnet$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3(
								$author$project$Pages$Users$Hi24Comnet$TimeSeq$toCsv,
								storeHeader(model.jx),
								priceRows,
								model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$Price = function (productId) {
	return function (storeId) {
		return function (dateTime) {
			return function (price) {
				return function (priceIncludeTax) {
					return function (point) {
						return function (priceWithoutPoint) {
							return function (coupon) {
								return function (isLatest) {
									return function (url) {
										return {i9: coupon, lP: dateTime, fH: isLatest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'is_latest', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$Price)))))))))));
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$priceDecoder)));
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$hi24Groups = _List_fromArray(
	[187, 189, 203, 204, 252]);
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function (storeGroup) {
			return A2(
				$elm$core$List$filter,
				function (store) {
					return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$hi24Groups)) || model.jx;
				},
				storeGroup.aN);
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pStoreHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						A2(
							$elm$core$List$filter,
							function (store) {
								return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$hi24Groups)) || hi24GroupsVisible;
							},
							storeGroup.aN));
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$hi24ComnetEndpoints.lf.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$hi24ComnetEndpoints.lf.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var hi24toggle = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jx: hi24toggle}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var storeHeader = A2($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3(
								$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$toCsv,
								storeHeader(model.jx),
								priceRows,
								model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi3Comnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi3Comnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi3Comnet$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4},
						{jP: '工事費', m: 5}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Hi3Comnet$Hour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4},
						{jP: '-', m: 5}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v7.a && (!_v7.b.$)) {
										var yodobashiPrice = _v7.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v5 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v5.a && (!_v5.b.$)) {
										var yodobashiPrice = _v5.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									},
										{
										jP: function () {
											var _v3 = price.lG;
											if (_v3.$ === 1) {
												return '0';
											} else {
												var constructionCost = _v3.a;
												return $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(constructionCost));
											}
										}(),
										m: 5
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Hi3Comnet$Hour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi3Comnet$Hour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Hi3Comnet$Hour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Hi3Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi3Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Hi3Comnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi3Comnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Hi3Comnet$Hour$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Hi3Comnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Hi3Comnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$Hi3Comnet$TimeSeq$Price))))))))))));
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Hi3Comnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Hi3Comnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Hi3Comnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Lower = 1;
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Normal = 3;
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$Hi3Comnet$TimeSeq$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Hi3Comnet$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Hi3Comnet$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Hi3Comnet$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Hi3Comnet$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Hi3Comnet$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Hi3Comnet$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Hi3Comnet$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 12:
				var storeHeader = A2($author$project$Pages$Users$Hi3Comnet$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Hi3Comnet$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Hi3Comnet$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hisense$Amazon$OnReceived = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Hisense$Amazon$TableRow = function (category) {
	return function (jan) {
		return function (rank) {
			return function (asin) {
				return function (rating) {
					return function (rateNum) {
						return function (kakaku) {
							return function (date) {
								return function (kataban) {
									return function (makerName) {
										return function (url) {
											return function (text) {
												return {hd: asin, hl: category, hp: date, hO: jan, hP: kakaku, hQ: kataban, mH: makerName, h9: rank, ia: rateNum, ib: rating, kY: text, eD: url};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Pages$Users$Hisense$Amazon$amazonRankingDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'maker_name', $elm$json$Json$Decode$string),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'kataban', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'date', $elm$json$Json$Decode$string),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'kakaku', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'rating_num', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'rating', $elm$json$Json$Decode$float),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'asin', $elm$json$Json$Decode$string),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'rank', $elm$json$Json$Decode$int),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2(
													$elm$json$Json$Decode$field,
													'jan',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'category', $elm$json$Json$Decode$int),
													$elm$json$Json$Decode$succeed($author$project$Pages$Users$Hisense$Amazon$TableRow))))))))))))));
var $author$project$Pages$Users$Hisense$Amazon$categories = _List_fromArray(
	['テレビ', '冷蔵庫', '洗濯機', '冷凍庫', 'エアコン']);
var $author$project$Pages$Users$Hisense$Amazon$tableHeader = _List_fromArray(
	['ランキング', 'カテゴリー', '型番', 'ASIN', '評価', '評価数', '価格', 'メーカー', 'JANコード', '取得時間']);
var $author$project$Pages$Users$Hisense$Amazon$toCsv = function (tableRows) {
	return {
		dE: _List_Nil,
		no: A2(
			$elm$core$List$cons,
			$author$project$Pages$Users$Hisense$Amazon$tableHeader,
			A2(
				$elm$core$List$map,
				function (row) {
					return _List_fromArray(
						[
							$elm$core$String$fromInt(row.h9),
							A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm_community$list_extra$List$Extra$getAt, row.hl - 1, $author$project$Pages$Users$Hisense$Amazon$categories)),
							row.hQ,
							row.hd,
							$elm$core$String$fromFloat(row.ib),
							$elm$core$String$fromInt(row.ia),
							$elm$core$String$fromInt(row.hP),
							row.mH,
							A2($elm$core$Maybe$withDefault, '', row.hO),
							row.hp
						]);
				},
				tableRows))
	};
};
var $author$project$Pages$Users$Hisense$Amazon$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cX: A2(
								$elm$core$Maybe$withDefault,
								-1,
								$elm$core$String$toInt(val))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: val}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var val = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: val}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
				if (!_v1.$) {
					var dateTimeParts = _v1.a;
					var date = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dO: true}),
						A4(
							$author$project$Api$get,
							$author$project$Endpoints$User$hisenseEndpoints.hy(
								_List_fromArray(
									[
										A2(
										$elm$url$Url$Builder$string,
										'category',
										$elm$core$String$fromInt(model.cX)),
										A2($elm$url$Url$Builder$string, 'dateTime', date)
									])),
							model.C,
							$author$project$Pages$Users$Hisense$Amazon$amazonRankingDecoder,
							$author$project$Pages$Users$Hisense$Amazon$OnReceived));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, 60))
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var result = msg.a;
				if (!result.$) {
					var tableRows = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dO: false,
								eu: $elm$core$Maybe$Just(tableRows)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dO: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var _v3 = model.eu;
				if (!_v3.$) {
					var tableRows = _v3.a;
					var csv = $elm$bytes$Bytes$Encode$encode(
						function (byteCsv) {
							return $elm$bytes$Bytes$Encode$sequence(
								_List_fromArray(
									[
										$elm$bytes$Bytes$Encode$unsignedInt8(239),
										$elm$bytes$Bytes$Encode$unsignedInt8(187),
										$elm$bytes$Bytes$Encode$unsignedInt8(191),
										$elm$bytes$Bytes$Encode$bytes(byteCsv)
									]));
						}(
							$commonmind$elm_csv_encode$Csv$Encode$toBytes(
								$author$project$Pages$Users$Hisense$Amazon$toCsv(tableRows))));
					return _Utils_Tuple2(
						model,
						A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hisense$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$Hisense$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Hisense$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$Hisense$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Hisense$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$Hisense$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Hisense$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Hisense$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 8:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(product.lt)),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$hisenseEndpoints.aV._, model.C, body, $author$project$Pages$Users$Hisense$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Hisense$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$hisenseEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$Hisense$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Hisense$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hisense$Day$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2($elm$url$Url$Builder$string, 'maker', '-1')
										])),
								model.C,
								$author$project$Pages$Users$Common$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Common$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return A2($author$project$Pages$Users$Common$Default$update, msg, model);
		}
	});
var $author$project$Pages$Users$Hisense$Excel$GetExcelRequestSent = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 13:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im);
						if (!_v1.$) {
							var dateTimePartsTo = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimePartsTo))));
							return A3(
								$author$project$Api$getByte,
								$author$project$Endpoints$User$hisenseEndpoints.fn.em(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(60)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$Hisense$Excel$GetExcelRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 7:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$Hisense$Excel$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				if (!msg.a.$) {
					var bytes = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, dP: false}),
						A3($elm$file$File$Download$bytes, model.cY + (' ' + (model.im + '.xlsx')), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', bytes));
				} else {
					var e = msg.a.a;
					var errMsg = function () {
						if ((e.$ === 3) && (e.a === 404)) {
							return '該当するデータが見つかりませんでした。検索条件を変更して再度お試しください。';
						} else {
							return $author$project$Utils$Helpers$errToStr(e);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(errMsg),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$Hisense$Review$ReceiveResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Hisense$Review$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bz: function (p) {
								return A3($author$project$Utils$Helpers$formatDate, p.ob, p.mQ, p.fd);
							}(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										11,
										-3,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										posix))),
							bY: function (p) {
								return A3($author$project$Utils$Helpers$formatDate, p.ob, p.mQ, p.fd);
							}(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									posix))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bz: str}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var str = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bY: str}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					model,
					A3(
						$author$project$Api$getByte,
						$author$project$Endpoints$User$hisenseEndpoints.ns.mf(
							_List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'date_from', model.bz),
									A2($elm$url$Url$Builder$string, 'date_to', model.bY)
								])),
						model.C,
						$author$project$Pages$Users$Hisense$Review$ReceiveResponse));
			default:
				if (!msg.a.$) {
					var bytes = msg.a.a;
					return _Utils_Tuple2(
						model,
						A3($elm$file$File$Download$bytes, model.bz + ('〜' + (model.bY + '.xlsx')), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', bytes));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$Hisense$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$GetPriceResponse = F2(
	function (dictPrice, stores) {
		return {jb: dictPrice, aN: stores};
	});
var $author$project$Pages$Users$Hisense$TimeSeq$Price = F9(
	function (storeId, nth, dateTime, price, priceIncludeTax, point, priceWithoutPoint, coupon, url) {
		return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, iw: storeId, eD: url};
	});
var $author$project$Pages$Users$Hisense$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									$elm$json$Json$Decode$succeed($author$project$Pages$Users$Hisense$TimeSeq$Price))))))))));
var $author$project$Pages$Users$Hisense$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Hisense$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$Hisense$TimeSeq$getPriceResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$Hisense$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Hisense$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder));
var $author$project$Pages$Users$Hisense$TimeSeq$ProductPriceData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$Hisense$TimeSeq$StoreHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$pProductPriceRows = F4(
	function (stores, maxRowNum, prices, basePrice) {
		return A2(
			$elm$core$List$map,
			function (store) {
				return A2(
					$elm$core$List$cons,
					$author$project$Pages$Users$Hisense$TimeSeq$StoreHeader(store.fh),
					A2(
						$elm$core$List$map,
						function (ind) {
							var prevMaybePrice = $elm_community$maybe_extra$Maybe$Extra$orList(
								$elm$core$List$reverse(
									A2(
										$elm$core$List$map,
										function (prevInd) {
											return A2(
												$elm$core$Dict$get,
												_Utils_Tuple2(store.iw, prevInd),
												prices);
										},
										A2($elm$core$List$range, 1, ind - 1))));
							var lowestPrice = A2(
								$elm$core$Maybe$withDefault,
								-1,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.be;
									},
									A2(
										$elm_community$list_extra$List$Extra$minimumBy,
										function ($) {
											return $.be;
										},
										$elm_community$maybe_extra$Maybe$Extra$values(
											A2(
												$elm$core$List$map,
												function (st) {
													return A2(
														$elm$core$Dict$get,
														_Utils_Tuple2(st.iw, ind),
														prices);
												},
												stores)))));
							var currentMaybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(store.iw, ind),
								prices);
							if (!currentMaybePrice.$) {
								var currentPrice = currentMaybePrice.a;
								return $author$project$Pages$Users$Hisense$TimeSeq$ProductPriceData(
									{
										du: (_Utils_cmp(currentPrice.be, basePrice) < 0) ? (_Utils_eq(currentPrice.be, lowestPrice) ? 0 : 1) : (_Utils_eq(currentPrice.be, lowestPrice) ? 2 : 3),
										ge: function () {
											if (!prevMaybePrice.$) {
												var prevPrice = prevMaybePrice.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Common$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Common$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Common$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Common$TimeSeq$Unchanged;
											}
										}(),
										be: currentPrice.be,
										eD: currentPrice.eD
									});
							} else {
								return $author$project$Pages$Users$Hisense$TimeSeq$ProductPriceNoData;
							}
						},
						A2($elm$core$List$range, 1, maxRowNum - 1)));
			},
			stores);
	});
var $author$project$Pages$Users$Hisense$TimeSeq$formatDateTimeWithoutYear = function (parts) {
	return A2(
		$elm$core$String$right,
		2,
		'0' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Utils$Helpers$monthToInt)(parts.mQ)) + ('月' + (A2(
		$elm$core$String$right,
		2,
		'0' + $elm$core$String$fromInt(parts.fd)) + ('日' + A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO))));
};
var $author$project$Pages$Users$Hisense$TimeSeq$pStoreHeader = F3(
	function (maybeFromParts, maybeToParts, interval) {
		var _v0 = _Utils_Tuple2(maybeFromParts, maybeToParts);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fromParts = _v0.a.a;
			var toParts = _v0.b.a;
			var toPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				toParts);
			var fromPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				fromParts);
			return function (ls) {
				return A2($elm$core$List$cons, '', ls);
			}(
				A2(
					$elm$core$List$map,
					function (posix) {
						return $author$project$Pages$Users$Hisense$TimeSeq$formatDateTimeWithoutYear(
							A2(
								$justinmimbs$time_extra$Time$Extra$posixToParts,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								posix));
					},
					A5(
						$justinmimbs$time_extra$Time$Extra$range,
						13,
						interval,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						fromPosix,
						toPosix)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Users$Hisense$TimeSeq$toCsv = F2(
	function (headerDateTimes, bodyProducts) {
		var header = headerDateTimes;
		var body = A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$elm$core$List$map,
					function (product) {
						switch (product.$) {
							case 0:
								var storeName = product.a;
								return storeName;
							case 1:
								var cell = product.a;
								return A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$Helpers$toCommmaSplited)(cell.be);
							default:
								return '';
						}
					},
					productList);
			},
			bodyProducts);
		return {
			dE: _List_Nil,
			no: A2($elm$core$List$cons, header, body)
		};
	});
var $author$project$Pages$Users$Hisense$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var _v1 = model.ih;
				if (!_v1.$) {
					var product = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dP: true}),
						function () {
							var _v2 = _Utils_Tuple2(
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
							if ((!_v2.a.$) && (!_v2.b.$)) {
								var dateTimePartsFrom = _v2.a.a;
								var dateTimePartsTo = _v2.b.a;
								var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
								var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
								return A4(
									$author$project$Api$get,
									$author$project$Endpoints$User$jvcComnetEndpoints.iA.g(
										_List_fromArray(
											[
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'interval',
												$elm$core$String$fromInt(model.ac)),
												A3(
												$Herteby$url_builder_plus$UrlBuilderPlus$list,
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'products',
												_List_fromArray(
													[product]))
											])),
									model.C,
									$author$project$Pages$Users$Hisense$TimeSeq$getPriceResponseDecoder,
									$author$project$Pages$Users$Hisense$TimeSeq$GetPriceRequestSent);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dQ: true}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ig: selectedBigCategory}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gD: selectedSmallCategoryId}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var productId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dQ: true,
							ih: (productId === '-1') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(productId)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, kn: initResponse.kn, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.jb, aN: getPriceResponse.aN, en: model.cY, eo: model.cZ, ep: model.ih, eq: model.il, er: model.im}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var headerDateTimes = A3(
					$author$project$Pages$Users$Hisense$TimeSeq$pStoreHeader,
					A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
					model.ac);
				var currentProduct = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Helpers$defaultProduct,
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kl;
							},
							$elm$core$Basics$eq(
								A2($elm$core$Maybe$withDefault, '', model.ep))),
						model.kn));
				var bodyProducts = A4(
					$author$project$Pages$Users$Hisense$TimeSeq$pProductPriceRows,
					model.aN,
					$elm$core$List$length(headerDateTimes),
					model.cQ,
					currentProduct.eY);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A2($author$project$Pages$Users$Hisense$TimeSeq$toCsv, headerDateTimes, bodyProducts))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Hisense$TvHour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2($elm$url$Url$Builder$string, 'bigCategory', '-1'),
											A2($elm$url$Url$Builder$string, 'smallCategory', '-1'),
											A2($elm$url$Url$Builder$string, 'maker', '26')
										])),
								model.C,
								$author$project$Pages$Users$Common$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2($elm$url$Url$Builder$string, 'bigCategory', '-1'),
											A2($elm$url$Url$Builder$string, 'smallCategory', '-1'),
											A2($elm$url$Url$Builder$string, 'maker', '26')
										])),
								model.C,
								$author$project$Pages$Users$Common$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			default:
				return A2($author$project$Pages$Users$Common$Default$update, msg, model);
		}
	});
var $author$project$Pages$Users$JvcComnet$Amazon$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$GetPriceResponse = F3(
	function (dictPrice, stores, products) {
		return {jb: dictPrice, kn: products, aN: stores};
	});
var $author$project$Pages$Users$JvcComnet$Amazon$Price = F9(
	function (productName, nth, dateTime, price, priceIncludeTax, point, priceWithoutPoint, coupon, url) {
		return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, nk: productName, eD: url};
	});
var $author$project$Pages$Users$JvcComnet$Amazon$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Pages$Users$JvcComnet$Amazon$Price))))))))));
var $author$project$Pages$Users$JvcComnet$Amazon$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$JvcComnet$Amazon$priceDecoder)));
var $author$project$Pages$Users$JvcComnet$Amazon$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$JvcComnet$Amazon$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$JvcComnet$Amazon$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $inkuzmin$elm_multiselect$Multiselect$getValues = function (_v0) {
	var model = _v0;
	return model.w;
};
var $author$project$Pages$Users$JvcComnet$Amazon$ProductPriceData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$JvcComnet$Amazon$StoreHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$pProductPriceRows = F4(
	function (products, maxRowNum, prices, basePrice) {
		return A2(
			$elm$core$List$map,
			function (product) {
				return A2(
					$elm$core$List$cons,
					$author$project$Pages$Users$JvcComnet$Amazon$StoreHeader(product.nk),
					A2(
						$elm$core$List$map,
						function (ind) {
							var prevMaybePrice = $elm_community$maybe_extra$Maybe$Extra$orList(
								$elm$core$List$reverse(
									A2(
										$elm$core$List$map,
										function (prevInd) {
											return A2(
												$elm$core$Dict$get,
												_Utils_Tuple2(product.nk, prevInd),
												prices);
										},
										A2($elm$core$List$range, 1, ind - 1))));
							var lowestPrice = A2(
								$elm$core$Maybe$withDefault,
								-1,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.be;
									},
									A2(
										$elm_community$list_extra$List$Extra$minimumBy,
										function ($) {
											return $.be;
										},
										$elm_community$maybe_extra$Maybe$Extra$values(
											A2(
												$elm$core$List$map,
												function (st) {
													return A2(
														$elm$core$Dict$get,
														_Utils_Tuple2(product.nk, ind),
														prices);
												},
												products)))));
							var currentMaybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.nk, ind),
								prices);
							if (!currentMaybePrice.$) {
								var currentPrice = currentMaybePrice.a;
								return $author$project$Pages$Users$JvcComnet$Amazon$ProductPriceData(
									{
										du: (_Utils_cmp(currentPrice.be, basePrice) < 0) ? (_Utils_eq(currentPrice.be, lowestPrice) ? 0 : 1) : (_Utils_eq(currentPrice.be, lowestPrice) ? 2 : 3),
										lP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', currentPrice.lP))))),
										ka: $elm$core$String$fromInt(currentPrice.ka),
										kg: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(currentPrice.kg)),
										ge: function () {
											if (!prevMaybePrice.$) {
												var prevPrice = prevMaybePrice.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Common$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Common$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Common$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Common$TimeSeq$Unchanged;
											}
										}(),
										kh: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(currentPrice.kh)),
										be: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(currentPrice.be)),
										eD: currentPrice.eD
									});
							} else {
								return $author$project$Pages$Users$JvcComnet$Amazon$ProductPriceNoData;
							}
						},
						A2($elm$core$List$range, 1, maxRowNum - 1)));
			},
			products);
	});
var $author$project$Pages$Users$JvcComnet$Amazon$formatDateTimeWithoutYear = function (parts) {
	return A2(
		$elm$core$String$right,
		2,
		'0' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Utils$Helpers$monthToInt)(parts.mQ)) + ('月' + (A2(
		$elm$core$String$right,
		2,
		'0' + $elm$core$String$fromInt(parts.fd)) + ('日' + A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO))));
};
var $author$project$Pages$Users$JvcComnet$Amazon$pStoreHeader = F4(
	function (maybeFromParts, maybeToParts, interval, singleColumn) {
		var _v0 = _Utils_Tuple2(maybeFromParts, maybeToParts);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fromParts = _v0.a.a;
			var toParts = _v0.b.a;
			var toPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				toParts);
			var fromPosix = singleColumn ? A4(
				$justinmimbs$time_extra$Time$Extra$add,
				13,
				(-1) * interval,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					toParts)) : A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				fromParts);
			return function (ls) {
				return A2($elm$core$List$cons, '', ls);
			}(
				A2(
					$elm$core$List$map,
					function (posix) {
						return $author$project$Pages$Users$JvcComnet$Amazon$formatDateTimeWithoutYear(
							A2(
								$justinmimbs$time_extra$Time$Extra$posixToParts,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								posix));
					},
					A5(
						$justinmimbs$time_extra$Time$Extra$range,
						13,
						interval,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						fromPosix,
						toPosix)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Users$JvcComnet$Amazon$toCsv = F2(
	function (headerDateTimes, bodyProducts) {
		var header = headerDateTimes;
		var body = A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$elm$core$List$map,
					function (product) {
						switch (product.$) {
							case 0:
								var storeName = product.a;
								return storeName;
							case 1:
								var cell = product.a;
								return cell.be;
							default:
								return '';
						}
					},
					productList);
			},
			bodyProducts);
		return {
			dE: _List_Nil,
			no: A2($elm$core$List$cons, header, body)
		};
	});
var $author$project$Pages$Users$JvcComnet$Amazon$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var selectedProducts = $elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? $inkuzmin$elm_multiselect$Multiselect$getValues(model.E) : $inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E);
							var from = model.ak ? $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											A2(
												$justinmimbs$time_extra$Time$Extra$partsToPosix,
												$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
												dateTimePartsTo))))) : $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$jvcComnetEndpoints.lp.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2($elm$core$List$map, $elm$core$Tuple$first, selectedProducts))
										])),
								model.C,
								$author$project$Pages$Users$JvcComnet$Amazon$getPriceResponseDecoder,
								$author$project$Pages$Users$JvcComnet$Amazon$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$JvcComnet$Amazon$OnChangeProduct, subCmd));
			case 16:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ak: checked}),
					function () {
						if (model.hA) {
							var _v3 = _Utils_Tuple2(
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
							if ((!_v3.a.$) && (!_v3.b.$)) {
								var dateTimePartsFrom = _v3.a.a;
								var dateTimePartsTo = _v3.b.a;
								var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
								var selectedProducts = $elm$core$List$isEmpty(
									$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? $inkuzmin$elm_multiselect$Multiselect$getValues(model.E) : $inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E);
								var from = (!model.ak) ? $author$project$Utils$Helpers$formatDateTime(
									A2(
										$author$project$Utils$Helpers$roundByInterval,
										model.ac,
										A2(
											$justinmimbs$time_extra$Time$Extra$posixToParts,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											A4(
												$justinmimbs$time_extra$Time$Extra$add,
												13,
												(-1) * model.ac,
												$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
												A2(
													$justinmimbs$time_extra$Time$Extra$partsToPosix,
													$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
													dateTimePartsTo))))) : $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
								return A4(
									$author$project$Api$get,
									$author$project$Endpoints$User$jvcComnetEndpoints.lp.g(
										_List_fromArray(
											[
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'interval',
												$elm$core$String$fromInt(model.ac)),
												A3(
												$Herteby$url_builder_plus$UrlBuilderPlus$list,
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'products',
												A2($elm$core$List$map, $elm$core$Tuple$first, selectedProducts))
											])),
									model.C,
									$author$project$Pages$Users$JvcComnet$Amazon$getPriceResponseDecoder,
									$author$project$Pages$Users$JvcComnet$Amazon$GetPriceRequestSent);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.jb, kn: getPriceResponse.kn, aN: getPriceResponse.aN, en: model.cY, eo: model.cZ, ep: model.ih, eq: model.il, er: model.im}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var headerDateTimes = A4(
					$author$project$Pages$Users$JvcComnet$Amazon$pStoreHeader,
					A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
					model.ac,
					model.ak);
				var currentProduct = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Helpers$defaultProduct,
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kl;
							},
							$elm$core$Basics$eq(
								A2($elm$core$Maybe$withDefault, '', model.ep))),
						model.kn));
				var bodyProducts = A4(
					$author$project$Pages$Users$JvcComnet$Amazon$pProductPriceRows,
					model.kn,
					$elm$core$List$length(headerDateTimes),
					model.cQ,
					currentProduct.eY);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A2($author$project$Pages$Users$JvcComnet$Amazon$toCsv, headerDateTimes, bodyProducts))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$JvcComnet$Default$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$JvcComnet$Default$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$JvcComnet$Default$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$JvcComnet$Default$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$JvcComnet$Default$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$JvcComnet$Default$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var useYodobashiBasePriceFlag = model.eE || product.oc;
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$JvcComnet$Default$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(useYodobashiBasePriceFlag, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$JvcComnet$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$JvcComnet$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$JvcComnet$Default$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$JvcComnet$Default$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(useYodobashiBasePriceFlag, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(useYodobashiBasePriceFlag, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$JvcComnet$Default$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$JvcComnet$Default$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$JvcComnet$Default$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$JvcComnet$Default$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$JvcComnet$Default$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$JvcComnet$Default$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$JvcComnet$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$JvcComnet$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$JvcComnet$Default$getPriceResponseDecoder,
								$author$project$Pages$Users$JvcComnet$Default$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$JvcComnet$Default$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$JvcComnet$Default$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$JvcComnet$Default$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			case 15:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{eE: checked}),
					$author$project$Api$createFixedMidashi(0));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$GetPriceDropRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$Helpers$dateTimeStringToPosix = F2(
	function (date, time) {
		return A2(
			$elm$core$Maybe$map,
			$justinmimbs$time_extra$Time$Extra$partsToPosix(
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0)),
			A2($author$project$Utils$Helpers$dateTimeToParts, date, time));
	});
var $author$project$Utils$Helpers$floorPosixByInterval = F2(
	function (posix, interval) {
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
			A2(
				$author$project$Utils$Helpers$floorTimeByInterval,
				A2(
					$justinmimbs$time_extra$Time$Extra$posixToParts,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					posix),
				interval));
	});
var $author$project$Utils$Helpers$formatPosix = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$time_extra$Time$Extra$posixToParts(
		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0)),
	$author$project$Utils$Helpers$formatDateTime);
var $author$project$Pages$Users$JvcComnet$PriceDrop$DropPrice = F3(
	function (storeName, priceBefore, priceAfter) {
		return {gc: priceAfter, gd: priceBefore, kS: storeName};
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$GetPriceDropResponse = F3(
	function (priceDrops, uniquePriceDrops, stores) {
		return {ea: priceDrops, aN: stores, dg: uniquePriceDrops};
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$PriceDrop = F4(
	function (productName, storeName, priceBefore, priceAfter) {
		return {gc: priceAfter, gd: priceBefore, nk: productName, kS: storeName};
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$Store = F4(
	function (storeId, storeName, displayName, storeGroupId) {
		return {fh: displayName, iv: storeGroupId, iw: storeId, kS: storeName};
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$UniquePriceDrop = F2(
	function (productName, drops) {
		return {jh: drops, nk: productName};
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$getPriceDropResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$JvcComnet$PriceDrop$GetPriceDropResponse,
	A2(
		$elm$json$Json$Decode$field,
		'price_drops',
		$elm$json$Json$Decode$list(
			A5(
				$elm$json$Json$Decode$map4,
				$author$project$Pages$Users$JvcComnet$PriceDrop$PriceDrop,
				A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'price_before', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'price_after', $elm$json$Json$Decode$int)))),
	A2(
		$elm$json$Json$Decode$field,
		'unique_price_drops',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Pages$Users$JvcComnet$PriceDrop$UniquePriceDrop,
				A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
				A2(
					$elm$json$Json$Decode$field,
					'drops',
					$elm$json$Json$Decode$list(
						A4(
							$elm$json$Json$Decode$map3,
							$author$project$Pages$Users$JvcComnet$PriceDrop$DropPrice,
							A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'price_before', $elm$json$Json$Decode$int),
							A2($elm$json$Json$Decode$field, 'price_after', $elm$json$Json$Decode$int))))))),
	A2(
		$elm$json$Json$Decode$field,
		'stores',
		$elm$json$Json$Decode$list(
			A5(
				$elm$json$Json$Decode$map4,
				$author$project$Pages$Users$JvcComnet$PriceDrop$Store,
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'display_name', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_group_id', $elm$json$Json$Decode$int)))));
var $author$project$Utils$Helpers$posixToFormattedDateString = function (posix) {
	var parts = A2(
		$justinmimbs$time_extra$Time$Extra$posixToParts,
		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
		posix);
	var year = parts.ob;
	var month = parts.mQ;
	var day = parts.fd;
	return A3($author$project$Utils$Helpers$formatDate, year, month, day);
};
var $author$project$Utils$Helpers$posixToFormattedTimeString = function (posix) {
	var parts = A2(
		$justinmimbs$time_extra$Time$Extra$posixToParts,
		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
		posix);
	var minute = parts.mO;
	var hour = parts.mj;
	return A2($author$project$Utils$Helpers$formatTime, hour, minute);
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var now = msg.a;
				var yesterday = $author$project$Utils$Helpers$posixToFormattedDateString(
					A4(
						$justinmimbs$time_extra$Time$Extra$add,
						11,
						-1,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						now));
				var today = $author$project$Utils$Helpers$posixToFormattedDateString(now);
				var time = $author$project$Utils$Helpers$posixToFormattedTimeString(
					A2($author$project$Utils$Helpers$floorPosixByInterval, now, model.ac));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ay: today, az: yesterday, ah: time, ai: time}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var inputDateBefore = msg.a;
				var posixBefore = A2($author$project$Utils$Helpers$dateTimeStringToPosix, inputDateBefore, model.ai);
				var posixAfter = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.ay, model.ah);
				var isOkay = function () {
					var _v1 = _Utils_Tuple2(posixBefore, posixAfter);
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var before = _v1.a.a;
						var after = _v1.b.a;
						return A4(
							$justinmimbs$time_extra$Time$Extra$diff,
							15,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							before,
							after) > 0;
					} else {
						return false;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							az: isOkay ? inputDateBefore : ''
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var inputTimeBefore = msg.a;
				var posixBefore = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.az, inputTimeBefore);
				var posixAfter = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.ay, model.ah);
				var isOkay = function () {
					var _v2 = _Utils_Tuple2(posixBefore, posixAfter);
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var before = _v2.a.a;
						var after = _v2.b.a;
						return A4(
							$justinmimbs$time_extra$Time$Extra$diff,
							15,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							before,
							after) > 0;
					} else {
						return false;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ai: isOkay ? inputTimeBefore : ''
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var inputDateAfter = msg.a;
				var posixBefore = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.az, model.ai);
				var posixAfter = A2($author$project$Utils$Helpers$dateTimeStringToPosix, inputDateAfter, model.ah);
				var isOkay = function () {
					var _v3 = _Utils_Tuple2(posixBefore, posixAfter);
					if ((!_v3.a.$) && (!_v3.b.$)) {
						var before = _v3.a.a;
						var after = _v3.b.a;
						return A4(
							$justinmimbs$time_extra$Time$Extra$diff,
							15,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							before,
							after) > 0;
					} else {
						return false;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ay: isOkay ? inputDateAfter : ''
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var inputTimeAfter = msg.a;
				var posixBefore = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.az, model.ai);
				var posixAfter = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.ay, inputTimeAfter);
				var isOkay = function () {
					var _v4 = _Utils_Tuple2(posixBefore, posixAfter);
					if ((!_v4.a.$) && (!_v4.b.$)) {
						var before = _v4.a.a;
						var after = _v4.b.a;
						return A4(
							$justinmimbs$time_extra$Time$Extra$diff,
							15,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							before,
							after) > 0;
					} else {
						return false;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: isOkay ? inputTimeAfter : ''
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var maybePosixBefore = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.az, model.ai);
						var maybePosixAfter = A2($author$project$Utils$Helpers$dateTimeStringToPosix, model.ay, model.ah);
						var _v5 = _Utils_Tuple2(maybePosixBefore, maybePosixAfter);
						if ((!_v5.a.$) && (!_v5.b.$)) {
							var partsBefore = _v5.a.a;
							var partsAfter = _v5.b.a;
							var before = $author$project$Utils$Helpers$formatPosix(partsBefore);
							var after = $author$project$Utils$Helpers$formatPosix(partsAfter);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$priceDropEndpoint.hy(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'before', before),
											A2($elm$url$Url$Builder$string, 'after', after)
										])),
								model.C,
								$author$project$Pages$Users$JvcComnet$PriceDrop$getPriceDropResponseDecoder,
								$author$project$Pages$Users$JvcComnet$PriceDrop$GetPriceDropRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 1:
				var result = msg.a;
				if (!result.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, cv: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, ea: getPriceResponse.ea, aN: getPriceResponse.aN, dg: getPriceResponse.dg}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 8:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$GetPriceResponse = F2(
	function (dictPrice, stores) {
		return {jb: dictPrice, aN: stores};
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$Price = F9(
	function (storeId, nth, dateTime, price, priceIncludeTax, point, priceWithoutPoint, coupon, url) {
		return {i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, iw: storeId, eD: url};
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									$elm$json$Json$Decode$succeed($author$project$Pages$Users$JvcComnet$TimeSeq$Price))))))))));
var $author$project$Pages$Users$JvcComnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$JvcComnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$JvcComnet$TimeSeq$getPriceResponseDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$JvcComnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$JvcComnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'stores', $author$project$Utils$Decoders$storesDecoder));
var $author$project$Pages$Users$JvcComnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$ProductPriceNoData = {$: 2};
var $author$project$Pages$Users$JvcComnet$TimeSeq$StoreHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$pProductPriceRows = F4(
	function (stores, maxRowNum, prices, basePrice) {
		return A2(
			$elm$core$List$map,
			function (store) {
				return A2(
					$elm$core$List$cons,
					$author$project$Pages$Users$JvcComnet$TimeSeq$StoreHeader(store.fh),
					A2(
						$elm$core$List$map,
						function (ind) {
							var prevMaybePrice = $elm_community$maybe_extra$Maybe$Extra$orList(
								$elm$core$List$reverse(
									A2(
										$elm$core$List$map,
										function (prevInd) {
											return A2(
												$elm$core$Dict$get,
												_Utils_Tuple2(store.iw, prevInd),
												prices);
										},
										A2($elm$core$List$range, 1, ind - 1))));
							var lowestPrice = A2(
								$elm$core$Maybe$withDefault,
								-1,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.be;
									},
									A2(
										$elm_community$list_extra$List$Extra$minimumBy,
										function ($) {
											return $.be;
										},
										$elm_community$maybe_extra$Maybe$Extra$values(
											A2(
												$elm$core$List$map,
												function (st) {
													return A2(
														$elm$core$Dict$get,
														_Utils_Tuple2(st.iw, ind),
														prices);
												},
												stores)))));
							var currentMaybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(store.iw, ind),
								prices);
							if (!currentMaybePrice.$) {
								var currentPrice = currentMaybePrice.a;
								return $author$project$Pages$Users$JvcComnet$TimeSeq$ProductPriceData(
									{
										du: (_Utils_cmp(currentPrice.be, basePrice) < 0) ? (_Utils_eq(currentPrice.be, lowestPrice) ? 0 : 1) : (_Utils_eq(currentPrice.be, lowestPrice) ? 2 : 3),
										ge: function () {
											if (!prevMaybePrice.$) {
												var prevPrice = prevMaybePrice.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Common$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Common$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Common$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Common$TimeSeq$Unchanged;
											}
										}(),
										be: currentPrice.be,
										eD: currentPrice.eD
									});
							} else {
								return $author$project$Pages$Users$JvcComnet$TimeSeq$ProductPriceNoData;
							}
						},
						A2($elm$core$List$range, 1, maxRowNum - 1)));
			},
			stores);
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$formatDateTimeWithoutYear = function (parts) {
	return A2(
		$elm$core$String$right,
		2,
		'0' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Utils$Helpers$monthToInt)(parts.mQ)) + ('月' + (A2(
		$elm$core$String$right,
		2,
		'0' + $elm$core$String$fromInt(parts.fd)) + ('日' + A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO))));
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$pStoreHeader = F3(
	function (maybeFromParts, maybeToParts, interval) {
		var _v0 = _Utils_Tuple2(maybeFromParts, maybeToParts);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var fromParts = _v0.a.a;
			var toParts = _v0.b.a;
			var toPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				toParts);
			var fromPosix = A2(
				$justinmimbs$time_extra$Time$Extra$partsToPosix,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				fromParts);
			return function (ls) {
				return A2($elm$core$List$cons, '', ls);
			}(
				A2(
					$elm$core$List$map,
					function (posix) {
						return $author$project$Pages$Users$JvcComnet$TimeSeq$formatDateTimeWithoutYear(
							A2(
								$justinmimbs$time_extra$Time$Extra$posixToParts,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								posix));
					},
					A5(
						$justinmimbs$time_extra$Time$Extra$range,
						13,
						interval,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						fromPosix,
						toPosix)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$toCsv = F2(
	function (headerDateTimes, bodyProducts) {
		var header = headerDateTimes;
		var body = A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$elm$core$List$map,
					function (product) {
						switch (product.$) {
							case 0:
								var storeName = product.a;
								return storeName;
							case 1:
								var cell = product.a;
								return A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $author$project$Utils$Helpers$toCommmaSplited)(cell.be);
							default:
								return '';
						}
					},
					productList);
			},
			bodyProducts);
		return {
			dE: _List_Nil,
			no: A2($elm$core$List$cons, header, body)
		};
	});
var $author$project$Pages$Users$JvcComnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var _v1 = model.ih;
				if (!_v1.$) {
					var product = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dP: true}),
						function () {
							var _v2 = _Utils_Tuple2(
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
							if ((!_v2.a.$) && (!_v2.b.$)) {
								var dateTimePartsFrom = _v2.a.a;
								var dateTimePartsTo = _v2.b.a;
								var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
								var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
								return A4(
									$author$project$Api$get,
									$author$project$Endpoints$User$jvcComnetEndpoints.iA.g(
										_List_fromArray(
											[
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'interval',
												$elm$core$String$fromInt(model.ac)),
												A3(
												$Herteby$url_builder_plus$UrlBuilderPlus$list,
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'products',
												_List_fromArray(
													[product]))
											])),
									model.C,
									$author$project$Pages$Users$JvcComnet$TimeSeq$getPriceResponseDecoder,
									$author$project$Pages$Users$JvcComnet$TimeSeq$GetPriceRequestSent);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dQ: true}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ig: selectedBigCategory}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gD: selectedSmallCategoryId}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var productId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dQ: true,
							ih: (productId === '-1') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(productId)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, kn: initResponse.kn, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, hA: true, dP: false, cQ: getPriceResponse.jb, aN: getPriceResponse.aN, en: model.cY, eo: model.cZ, ep: model.ih, eq: model.il, er: model.im}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var headerDateTimes = A3(
					$author$project$Pages$Users$JvcComnet$TimeSeq$pStoreHeader,
					A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
					model.ac);
				var currentProduct = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Helpers$defaultProduct,
					A2(
						$elm_community$list_extra$List$Extra$find,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.kl;
							},
							$elm$core$Basics$eq(
								A2($elm$core$Maybe$withDefault, '', model.ep))),
						model.kn));
				var bodyProducts = A4(
					$author$project$Pages$Users$JvcComnet$TimeSeq$pProductPriceRows,
					model.aN,
					$elm$core$List$length(headerDateTimes),
					model.cQ,
					currentProduct.eY);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A2($author$project$Pages$Users$JvcComnet$TimeSeq$toCsv, headerDateTimes, bodyProducts))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$KinujoComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$KinujoComnet$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 6:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{bZ: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 7:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{bZ: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 10:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(product.lt)),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index + 1)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'trigger_flag',
								$elm$json$Json$Encode$bool(product.bZ)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV._, model.C, body, $author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$KinujoComnet$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'trigger_flag',
									$elm$json$Json$Encode$bool(product.bZ)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$KinujoComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$KinujoComnet$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$KinujoComnet$Excel$GetExcelRequestSent = function (a) {
	return {$: 12, a: a};
};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Pages$Users$KinujoComnet$Excel$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 13:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3(
								$author$project$Utils$Helpers$formatDate,
								date.ob,
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$elm$time$Time$utc,
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										3,
										-1,
										$elm$time$Time$utc,
										A2($justinmimbs$time_extra$Time$Extra$partsToPosix, $elm$time$Time$utc, date))).mQ,
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$elm$time$Time$utc,
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										3,
										-1,
										$elm$time$Time$utc,
										A2($justinmimbs$time_extra$Time$Extra$partsToPosix, $elm$time$Time$utc, date))).fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A3(
								$author$project$Api$getByte,
								$author$project$Endpoints$User$kinujoComnetEndpoints.fn.em(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(15)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$KinujoComnet$Excel$GetExcelRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 7:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$KinujoComnet$Excel$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				if (!msg.a.$) {
					var bytes = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, dP: false}),
						A3($elm$file$File$Download$bytes, model.cY + ('〜' + (model.im + '.xlsx')), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', bytes));
				} else {
					var e = msg.a.a;
					var errMsg = function () {
						if ((e.$ === 3) && (e.a === 404)) {
							return '該当するデータが見つかりませんでした。検索条件を変更して再度お試しください。';
						} else {
							return $author$project$Utils$Helpers$errToStr(e);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(errMsg),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$KinujoComnet$Fifteen$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$KinujoComnet$Fifteen$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$KinujoComnet$Fifteen$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$KinujoComnet$Fifteen$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple3(product.oc, product.n$, maybeYodobashiPrice);
									if (_v4.b) {
										if (_v4.a && (!_v4.c.$)) {
											var yodobashiPrice = _v4.c.a;
											return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
										} else {
											return _Utils_cmp(price.be, product.cb) < 0;
										}
									} else {
										if (_v4.a && (!_v4.c.$)) {
											var yodobashiPrice = _v4.c.a;
											return _Utils_cmp(price.kh, yodobashiPrice.kh) < 0;
										} else {
											return _Utils_cmp(price.kh, product.eY) < 0;
										}
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$KinujoComnet$Fifteen$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$KinujoComnet$Fifteen$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$KinujoComnet$Fifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$KinujoComnet$Fifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$KinujoComnet$Fifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$KinujoComnet$Fifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$KinujoComnet$Fifteen$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$KinujoComnet$Fifteen$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$KinujoComnet$Fifteen$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$GetPriceRequestSent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$AutoReload$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$Price = function (productId) {
	return function (storeId) {
		return function (dateTime) {
			return function (price) {
				return function (priceIncludeTax) {
					return function (point) {
						return function (priceWithoutPoint) {
							return function (coupon) {
								return function (isLatest) {
									return function (url) {
										return {i9: coupon, lP: dateTime, fH: isLatest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$MlnComnet$AutoReload$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'is_latest', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$MlnComnet$AutoReload$Price)))))))))));
var $author$project$Pages$Users$MlnComnet$AutoReload$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$MlnComnet$AutoReload$priceDecoder)));
var $author$project$Pages$Users$MlnComnet$AutoReload$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$MlnComnet$AutoReload$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$MlnComnet$AutoReload$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceNoData = {$: 1};
var $author$project$Utils$Helpers$compareProductBySortOption = F3(
	function (sortOption, p1, p2) {
		switch (sortOption) {
			case 0:
				var _v1 = _Utils_Tuple2(p1.ee, p2.ee);
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var d1 = _v1.a.a;
						var d2 = _v1.b.a;
						return (_Utils_cmp(
							$elm$time$Time$posixToMillis(d1),
							$elm$time$Time$posixToMillis(d2)) < 0) ? 2 : 0;
					} else {
						var _v2 = _v1.b;
						return 0;
					}
				} else {
					if (!_v1.b.$) {
						var _v3 = _v1.a;
						return 2;
					} else {
						return 1;
					}
				}
			case 1:
				return (_Utils_cmp(p1.nk, p2.nk) < 0) ? 0 : 2;
			default:
				return 1;
		}
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Pages$Users$MlnComnet$AutoReload$pProductPriceRows = F4(
	function (response, visibleStoreGroups, selectedDisplayStyle, selectedSortOption) {
		var stores = A2(
			$elm$core$List$concatMap,
			function ($) {
				return $.aN;
			},
			A2(
				$elm$core$List$filter,
				function (storeGroup) {
					return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
				},
				response.X));
		var products = response.kn;
		return A2(
			$elm$core$List$indexedMap,
			function (ind) {
				return function (product) {
					var maybeYodobashiPrice = A2(
						$elm$core$Dict$get,
						_Utils_Tuple2(product.kl, 7),
						response.jb);
					var lowestPrice = A3(
						$elm$core$List$foldl,
						function (price) {
							return function (m) {
								return A2($elm$core$Basics$min, m, price);
							};
						},
						A2($elm$core$Basics$pow, 2, 30),
						A2(
							$elm$core$List$map,
							function (maybePrice) {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
								} else {
									return A2($elm$core$Basics$pow, 2, 30);
								}
							},
							A2(
								$elm$core$List$map,
								function (store) {
									return A2(
										$elm$core$Dict$get,
										_Utils_Tuple2(product.kl, store.iw),
										response.jb);
								},
								stores)));
					var itemList = _List_fromArray(
						[
							{jP: '税抜き', m: 0},
							{jP: '税込み', m: 1},
							{jP: 'P/クーポン', m: 2},
							{jP: 'P後', m: 3},
							{jP: '取得時刻', m: 4}
						]);
					var filterItemList = function (list) {
						return A2(
							$elm$core$List$map,
							function (i) {
								return A2(
									$elm$core$Maybe$withDefault,
									{jP: '', m: -1},
									A2($elm_community$list_extra$List$Extra$getAt, i, list));
							},
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(
									'DisplayAll',
									_List_fromArray(
										[0, 1, 2, 3, 4])),
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (dispToValue) {
										return _Utils_eq(dispToValue.a, selectedDisplayStyle);
									},
									$author$project$Pages$Users$MlnComnet$AutoReload$displayStyleToValues)).b);
					};
					var filteredItemList = filterItemList(itemList);
					var _v0 = function () {
						var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
						if (_v1.a && (!_v1.b.$)) {
							var yodobashiPrice = _v1.b.a;
							return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
						} else {
							return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
						}
					}();
					var basePrice = _v0.lt;
					var basePriceIncludeTax = _v0.eY;
					var basePoint = _v0.ls;
					var basePriceWithoutPoint = _v0.cb;
					var basePriceList = _List_fromArray(
						[
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePrice)),
							m: 0
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePriceIncludeTax)),
							m: 1
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePoint)),
							m: 2
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePriceWithoutPoint)),
							m: 3
						},
							{jP: '-', m: 4}
						]);
					var filteredBasePriceList = filterItemList(basePriceList);
					return _Utils_ap(
						_List_fromArray(
							[
								$author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceHeader(
								_List_fromArray(
									[
										{
										jP: $elm$core$String$fromInt(ind + 1),
										m: 0
									}
									])),
								$author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceHeader(
								_List_fromArray(
									[
										{jP: product.nk, m: 0}
									])),
								$author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceHeader(filteredItemList),
								$author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceHeader(filteredBasePriceList)
							]),
						A2(
							$elm$core$List$map,
							function (store) {
								var maybePrice = A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									response.jb);
								var isLowest = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return _Utils_eq(price.be, lowestPrice);
									} else {
										return false;
									}
								}();
								var isLowestButHigherThanBase = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
										if (_v6.a && (!_v6.b.$)) {
											var yodobashiPrice = _v6.b.a;
											return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
										} else {
											return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										}
									} else {
										return false;
									}
								}();
								var isLower = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
										if (_v4.a && (!_v4.b.$)) {
											var yodobashiPrice = _v4.b.a;
											return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
										} else {
											return _Utils_cmp(price.be, product.cb) < 0;
										}
									} else {
										return false;
									}
								}();
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var priceList = _List_fromArray(
										[
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.kg)),
											m: 0
										},
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.kh)),
											m: 1
										},
											{
											jP: function (point) {
												return _Utils_ap(
													point,
													(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
											}(
												$elm$core$String$fromInt(price.ka)),
											m: 2
										},
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.be)),
											m: 3
										},
											{
											jP: A2(
												$elm$core$Maybe$withDefault,
												'',
												$elm$core$List$head(
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														$elm$core$List$tail(
															A2($elm$core$String$split, ' ', price.lP))))),
											m: 4
										}
										]);
									var filteredPriceList = filterItemList(priceList);
									return $author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceData(
										{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
								} else {
									return $author$project$Pages$Users$MlnComnet$AutoReload$ProductPriceNoData;
								}
							},
							stores));
				};
			},
			A2(
				$elm$core$List$sortWith,
				$author$project$Utils$Helpers$compareProductBySortOption(selectedSortOption),
				products));
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '形番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.kS};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$MlnComnet$AutoReload$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $krisajenkins$remotedata$RemoteData$Success(getPriceResponse),
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bR: $krisajenkins$remotedata$RemoteData$Failure(
									$author$project$Utils$Helpers$errToStr(error))
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				var now = msg.a;
				var submit = function () {
					var dateTimeParts = function (n) {
						return _Utils_update(
							n,
							{mO: ((n.mO / 30) | 0) * 30});
					}(
						A2(
							$justinmimbs$time_extra$Time$Extra$posixToParts,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							now));
					var from = $author$project$Utils$Helpers$formatDateTime(
						A2(
							$justinmimbs$time_extra$Time$Extra$posixToParts,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							A4(
								$justinmimbs$time_extra$Time$Extra$add,
								13,
								(-1) * 30,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								A2(
									$justinmimbs$time_extra$Time$Extra$partsToPosix,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									dateTimeParts))));
					var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fN: $elm$core$Maybe$Just(now),
								bR: $krisajenkins$remotedata$RemoteData$Loading
							}),
						A4(
							$author$project$Api$get,
							$author$project$Endpoints$User$defaultEndpoints.g(
								_List_fromArray(
									[
										A2($elm$url$Url$Builder$string, 'from', from),
										A2($elm$url$Url$Builder$string, 'to', to),
										A2(
										$elm$url$Url$Builder$string,
										'interval',
										$elm$core$String$fromInt(30)),
										A2($elm$url$Url$Builder$string, 'usePast', 'true'),
										A2($elm$url$Url$Builder$string, 'queryOnlyAlertProduct', 'true')
									])),
							model.C,
							$author$project$Pages$Users$MlnComnet$AutoReload$getPriceResponseDecoder,
							$author$project$Pages$Users$MlnComnet$AutoReload$GetPriceRequestSent));
				}();
				var _v2 = model.fN;
				if (!_v2.$) {
					var latest = _v2.a;
					var nowMinute = function (t) {
						return (t.mO / 30) | 0;
					}(
						A2(
							$justinmimbs$time_extra$Time$Extra$posixToParts,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							now));
					var latestMinute = function (t) {
						return (t.mO / 30) | 0;
					}(
						A2(
							$justinmimbs$time_extra$Time$Extra$posixToParts,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							latest));
					return (!_Utils_eq(latestMinute, nowMinute)) ? submit : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return submit;
				}
			case 2:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var opt = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: opt}),
					$author$project$Api$createFixedMidashi(0));
			case 1:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			default:
				return _Utils_Tuple2(
					model,
					A3(
						$krisajenkins$remotedata$RemoteData$unwrap,
						$elm$core$Platform$Cmd$none,
						function (response) {
							var storeHeader = A2($author$project$Pages$Users$MlnComnet$AutoReload$pStoreHeader, response.X, model.L);
							var priceRows = A4($author$project$Pages$Users$MlnComnet$AutoReload$pProductPriceRows, response, model.L, model.c_, model.kG);
							var csvFileName = 'data.csv';
							var csv = $elm$bytes$Bytes$Encode$encode(
								function (byteCsv) {
									return $elm$bytes$Bytes$Encode$sequence(
										_List_fromArray(
											[
												$elm$bytes$Bytes$Encode$unsignedInt8(239),
												$elm$bytes$Bytes$Encode$unsignedInt8(187),
												$elm$bytes$Bytes$Encode$unsignedInt8(191),
												$elm$bytes$Bytes$Encode$bytes(byteCsv)
											]));
								}(
									$commonmind$elm_csv_encode$Csv$Encode$toBytes(
										A3($author$project$Pages$Users$MlnComnet$AutoReload$toCsv, storeHeader, priceRows, model.c_))));
							return A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv);
						},
						model.bR));
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangeMail$FourTimesPerDay = 0;
var $author$project$Pages$Users$MlnComnet$ChangeMail$Nop = {$: 5};
var $author$project$Pages$Users$MlnComnet$ChangeMail$OncePerHour = 1;
var $author$project$Pages$Users$MlnComnet$ChangeMail$mapMailColType = function (colType) {
	return (!colType) ? 'FourTimesPerDay' : 'OncePerHour';
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {ms: index, mI: match, mW: number, nM: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{ly: false, mT: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Pages$Users$MlnComnet$ChangeMail$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\S+@\\S+\\.\\S+$'));
var $author$project$Pages$Users$MlnComnet$ChangeMail$validateEmails = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split(','),
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map($elm$core$String$trim),
		$elm$core$List$all(
			$elm$regex$Regex$contains($author$project$Pages$Users$MlnComnet$ChangeMail$emailRegex))));
var $author$project$Pages$Users$MlnComnet$ChangeMail$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fC: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var q = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: q}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var productID = msg.a;
				var mailColType = msg.b;
				var newEmails = msg.c;
				return A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (initResponse) {
						var newPms = A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (pm) {
								return _Utils_eq(pm.bL.kl, productID);
							},
							function (pm) {
								return (mailColType === 1) ? _Utils_update(
									pm,
									{
										bG: A3($elm$core$String$replace, ' ', '', newEmails)
									}) : _Utils_update(
									pm,
									{
										bF: A3($elm$core$String$replace, ' ', '', newEmails)
									});
							},
							initResponse.gg);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fC: $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											initResponse,
											{gg: newPms}))
								}),
							$elm$core$Platform$Cmd$none);
					},
					model.fC);
			case 5:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var productID = msg.a;
				var fourTimesPerDayMails = msg.b;
				var oncePerHourMails = msg.c;
				return ($author$project$Pages$Users$MlnComnet$ChangeMail$validateEmails(fourTimesPerDayMails) && $author$project$Pages$Users$MlnComnet$ChangeMail$validateEmails(oncePerHourMails)) ? _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A4(
								$author$project$Api$postWhatever,
								$author$project$Endpoints$User$mlnComnetEndpoints.lj.k6(_List_Nil),
								model.C,
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'productId',
											$elm$json$Json$Encode$string(productID)),
											_Utils_Tuple2(
											'mailAddressList',
											A2(
												$elm$json$Json$Encode$list,
												$elm$json$Json$Encode$string,
												A2(
													$elm$core$String$split,
													',',
													A3($elm$core$String$replace, ' ', '', fourTimesPerDayMails)))),
											_Utils_Tuple2(
											'frequency',
											$elm$json$Json$Encode$string(
												$author$project$Pages$Users$MlnComnet$ChangeMail$mapMailColType(0)))
										])),
								$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMail$Nop)),
								A4(
								$author$project$Api$postWhatever,
								$author$project$Endpoints$User$mlnComnetEndpoints.lj.k6(_List_Nil),
								model.C,
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'productId',
											$elm$json$Json$Encode$string(productID)),
											_Utils_Tuple2(
											'mailAddressList',
											A2(
												$elm$json$Json$Encode$list,
												$elm$json$Json$Encode$string,
												A2(
													$elm$core$String$split,
													',',
													A3($elm$core$String$replace, ' ', '', oncePerHourMails)))),
											_Utils_Tuple2(
											'frequency',
											$elm$json$Json$Encode$string(
												$author$project$Pages$Users$MlnComnet$ChangeMail$mapMailColType(1)))
										])),
								$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMail$Nop))
							]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var opt = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: opt}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$AddMailsProductsRequestSent = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$OnChangeQuery = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$OnUpdateProduct = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$SaveFormSnapshot = {$: 14};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$SelectUserRequestSent = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$filteredProducts = function (model) {
	return A2(
		$elm$core$List$filter,
		function (p) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(model.bN),
				$elm$core$String$toLower(p.nk));
		},
		A2(
			$elm$core$List$filter,
			function (p) {
				return (!model.aC) || (model.aC && p.dZ);
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.kl;
				},
				model.kn)));
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$SelectUserResponse = function (products) {
	return {kn: products};
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$selectUserResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$MlnComnet$ChangeMailTest$SelectUserResponse,
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$MlnComnet$ChangeMailTest$productsDecoder));
var $author$project$Utils$Helpers$compareMailProductBySortOption = F3(
	function (sortOption, p1, p2) {
		switch (sortOption) {
			case 0:
				var _v1 = _Utils_Tuple2(p1.ee, p2.ee);
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var d1 = _v1.a.a;
						var d2 = _v1.b.a;
						return (_Utils_cmp(
							$elm$time$Time$posixToMillis(d1),
							$elm$time$Time$posixToMillis(d2)) < 0) ? 2 : 0;
					} else {
						var _v2 = _v1.b;
						return 0;
					}
				} else {
					if (!_v1.b.$) {
						var _v3 = _v1.a;
						return 2;
					} else {
						return 1;
					}
				}
			case 1:
				return (_Utils_cmp(p1.nk, p2.nk) < 0) ? 0 : 2;
			default:
				var _v4 = _Utils_Tuple2(p1.nl, p2.nl);
				if (!_v4.a.$) {
					if (!_v4.b.$) {
						var o1 = _v4.a.a;
						var o2 = _v4.b.a;
						return (_Utils_cmp(o1, o2) < 0) ? 0 : ((_Utils_cmp(o1, o2) > 0) ? 2 : 1);
					} else {
						var _v5 = _v4.b;
						return 0;
					}
				} else {
					if (!_v4.b.$) {
						var _v6 = _v4.a;
						return 2;
					} else {
						return 1;
					}
				}
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$sortedFilteredProducts = function (model) {
	return A2(
		$elm$core$List$sortWith,
		$author$project$Utils$Helpers$compareMailProductBySortOption(model.kG),
		$author$project$Pages$Users$MlnComnet$ChangeMailTest$filteredProducts(model));
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2(
			$elm_community$list_extra$List$Extra$getAt,
			ind,
			$author$project$Pages$Users$MlnComnet$ChangeMailTest$sortedFilteredProducts(model));
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3(
				$elm_community$list_extra$List$Extra$setIf,
				function (p) {
					return _Utils_eq(p.kl, newProduct.kl);
				},
				newProduct,
				model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cv: false,
								kn: initResponse.kn,
								gg: initResponse.gg,
								c4: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.kJ;
										},
										initResponse.hx)),
								aC: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.aC;
										},
										initResponse.hx))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var b = msg.b;
				var maybeProduct = A2(
					$elm_community$list_extra$List$Extra$getAt,
					ind,
					$author$project$Pages$Users$MlnComnet$ChangeMailTest$sortedFilteredProducts(model));
				var f = function (product) {
					return _Utils_update(
						product,
						{jV: b});
				};
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'mail_id',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, model.aA))),
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'mail_enable',
								$elm$json$Json$Encode$bool(b)),
								_Utils_Tuple2(
								'frequency',
								$elm$json$Json$Encode$string('OncePerHour'))
							]));
					return _Utils_Tuple2(
						A3($author$project$Pages$Users$MlnComnet$ChangeMailTest$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4($author$project$Api$postWhatever, $author$project$Endpoints$User$mlnComnetEndpoints.lk.iM, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeMailTest$AddMailsProductsRequestSent),
									A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(
										A2(
											$author$project$Pages$Users$MlnComnet$ChangeMailTest$OnUpdateProduct,
											ind,
											f(product))),
									$elm$core$Task$succeed(0))
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var ind = msg.a;
				var b = msg.b;
				var maybeProduct = A2(
					$elm_community$list_extra$List$Extra$getAt,
					ind,
					$author$project$Pages$Users$MlnComnet$ChangeMailTest$sortedFilteredProducts(model));
				var f = function (product) {
					return _Utils_update(
						product,
						{dZ: b});
				};
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'mail_id',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, model.aA))),
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'mail_enable',
								$elm$json$Json$Encode$bool(b)),
								_Utils_Tuple2(
								'frequency',
								$elm$json$Json$Encode$string('FourTimesPerDay'))
							]));
					return _Utils_Tuple2(
						A3($author$project$Pages$Users$MlnComnet$ChangeMailTest$updateProduct, ind, model, f),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4($author$project$Api$postWhatever, $author$project$Endpoints$User$mlnComnetEndpoints.lk.iM, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeMailTest$AddMailsProductsRequestSent),
									A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always(
										A2(
											$author$project$Pages$Users$MlnComnet$ChangeMailTest$OnUpdateProduct,
											ind,
											f(product))),
									$elm$core$Task$succeed(0))
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 7:
				var index = msg.a;
				var product = msg.b;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var filteredProduct = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 17:
				var checkedProducts = A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dZ;
						},
						$elm$core$Basics$eq(true)),
					$author$project$Pages$Users$MlnComnet$ChangeMailTest$filteredProducts(model));
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'mail_id',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, model.aA))),
							_Utils_Tuple2(
							'product_ids',
							A2(
								$elm$json$Json$Encode$list,
								$elm$core$Basics$identity,
								A2(
									$elm$core$List$map,
									$elm$json$Json$Encode$string,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.kl;
										},
										checkedProducts))))
						]));
				return _Utils_Tuple2(
					model,
					A4($author$project$Api$postWhatever, $author$project$Endpoints$User$mlnComnetEndpoints.lk.iM, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeMailTest$AddMailsProductsRequestSent));
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 9:
				var mailIdStr = msg.a;
				var selectedMailId = function (c) {
					return _Utils_eq(
						c,
						$elm$core$Maybe$Just(-1)) ? $elm$core$Maybe$Nothing : c;
				}(
					$elm$core$String$toInt(mailIdStr));
				if (!selectedMailId.$) {
					var mailId = selectedMailId.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'mail_id',
								$elm$json$Json$Encode$int(mailId))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aA: selectedMailId}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$post, $author$project$Endpoints$User$mlnComnetEndpoints.lk.nz, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeMailTest$selectUserResponseDecoder, $author$project$Pages$Users$MlnComnet$ChangeMailTest$SelectUserRequestSent),
									A2(
									$elm$core$Task$perform,
									$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMailTest$SaveFormSnapshot),
									$elm$core$Task$succeed(0))
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aA: selectedMailId}),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMailTest$SaveFormSnapshot),
							$elm$core$Task$succeed(0)));
				}
			case 10:
				var opt = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: opt}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var query = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: query}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c4: !model.c4}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMailTest$SaveFormSnapshot),
						$elm$core$Task$succeed(0)));
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aC: !model.aC}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMailTest$SaveFormSnapshot),
						$elm$core$Task$succeed(0)));
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 15:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				if (!msg.a.$) {
					var selectUserResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kn: selectUserResponse.kn}),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								$author$project$Pages$Users$MlnComnet$ChangeMailTest$OnChangeQuery(model.bN)),
							$elm$core$Task$succeed(0)));
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err))
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangePassword$GotResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var p = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dv: p, aO: $krisajenkins$remotedata$RemoteData$NotAsked}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var p = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a9: p, aO: $krisajenkins$remotedata$RemoteData$NotAsked}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var p = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ef: p, aO: $krisajenkins$remotedata$RemoteData$NotAsked}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aO: $krisajenkins$remotedata$RemoteData$Loading}),
					A4(
						$author$project$Api$postWhatever,
						$author$project$Endpoints$User$mlnComnetEndpoints.n1._(_List_Nil),
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'currentPassword',
									$elm$json$Json$Encode$string(model.dv)),
									_Utils_Tuple2(
									'newPassword',
									$elm$json$Json$Encode$string(model.a9))
								])),
						$author$project$Pages$Users$MlnComnet$ChangePassword$GotResponse));
			default:
				if (msg.a.$ === 1) {
					var err = msg.a.a;
					var errStr = function () {
						if (err.$ === 3) {
							var code = err.a;
							if (code === 409) {
								return '現在のパスワードが間違っています';
							} else {
								return 'エラーが発生しました';
							}
						} else {
							return 'エラーが発生しました';
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aO: $krisajenkins$remotedata$RemoteData$Failure(errStr)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aO: $krisajenkins$remotedata$RemoteData$Success(0)
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateProduct = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$SaveFormSnapshot = {$: 15};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$SaveFormSnapshotSent = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts = function (model) {
	return A2(
		$elm$core$List$filter,
		function (p) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				true,
				function (bigCategory) {
					return _Utils_eq(bigCategory, p.e_);
				},
				model.ig) && (A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				true,
				function (smallCategory) {
					return _Utils_eq(smallCategory, p.ir);
				},
				model.gD) && A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(model.bN),
				$elm$core$String$toLower(p.nk)));
		},
		A2(
			$elm$core$List$filter,
			function (p) {
				return (!model.aC) || (model.aC && p.bE);
			},
			A2(
				$elm$core$List$filter,
				function (p) {
					return (!model.c4) || (model.c4 && (!(!p.lt)));
				},
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.kl;
					},
					model.kn))));
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{
					nl: $elm$core$Maybe$Just(newOrd)
				});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(
						p.nl,
						$elm$core$Maybe$Just(newOrd));
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(
						p.nl,
						$elm$core$Maybe$Just(newOrd));
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2(
			$elm_community$list_extra$List$Extra$getAt,
			ind,
			$author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts(model));
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3(
				$elm_community$list_extra$List$Extra$setIf,
				function (p) {
					return _Utils_eq(p.kl, newProduct.kl);
				},
				newProduct,
				model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$MlnComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$MlnComnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								cv: false,
								kn: initResponse.kn,
								ig: $elm_community$maybe_extra$Maybe$Extra$join(
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.e_;
										},
										initResponse.hx)),
								gD: $elm_community$maybe_extra$Maybe$Extra$join(
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.ir;
										},
										initResponse.hx)),
								c4: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.kJ;
										},
										initResponse.hx)),
								aC: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.aC;
										},
										initResponse.hx)),
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var maybeProduct = A2(
					$elm_community$list_extra$List$Extra$getAt,
					ind,
					$author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts(model));
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								A2($author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateProduct, ind, product)),
							$elm$core$Task$succeed(0)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var ind = msg.a;
				var b = msg.b;
				var maybeProduct = A2(
					$elm_community$list_extra$List$Extra$getAt,
					ind,
					$author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts(model));
				var f = function (product) {
					return _Utils_update(
						product,
						{bE: b});
				};
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					return _Utils_Tuple2(
						A3($author$project$Pages$Users$MlnComnet$ChangeProduct$updateProduct, ind, model, f),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								A2(
									$author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateProduct,
									ind,
									f(product))),
							$elm$core$Task$succeed(0)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				var maybeProduct = A2(
					$elm_community$list_extra$List$Extra$getAt,
					ind,
					$author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts(model));
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					return _Utils_Tuple2(
						A3(
							$author$project$Pages$Users$MlnComnet$ChangeProduct$updateOrder,
							ind,
							model,
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(newOrder))),
						A2(
							$elm$core$Task$perform,
							$elm$core$Basics$always(
								A2($author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateProduct, ind, product)),
							$elm$core$Task$succeed(0)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				var index = msg.a;
				var product = msg.b;
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'product_id',
							$elm$json$Json$Encode$string(product.kl)),
							_Utils_Tuple2(
							'base_price',
							$elm$json$Json$Encode$int(product.cb)),
							_Utils_Tuple2(
							'base_point',
							$elm$json$Json$Encode$int(product.ls)),
							_Utils_Tuple2(
							'product_order',
							$elm$json$Json$Encode$int(index + 1)),
							_Utils_Tuple2(
							'yodobashi_base_price_flag',
							$elm$json$Json$Encode$bool(false)),
							_Utils_Tuple2(
							'mail_enabled',
							$elm$json$Json$Encode$bool(product.bE)),
							_Utils_Tuple2(
							'get_interval',
							A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, product.js))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$mlnComnetEndpoints.aV._, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$MlnComnet$ChangeProduct$UpdateProductRequestSent));
			case 7:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(false)),
									_Utils_Tuple2(
									'mail_enabled',
									$elm$json$Json$Encode$bool(product.bE)),
									_Utils_Tuple2(
									'get_interval',
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, product.js))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$mlnComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$MlnComnet$ChangeProduct$UpdateProductRequestSent));
			case 3:
				var filteredProduct = msg.a;
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.cb)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(false)),
									_Utils_Tuple2(
									'mail_enabled',
									$elm$json$Json$Encode$bool(product.bE)),
									_Utils_Tuple2(
									'get_interval',
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$int, product.js))
								]));
					},
					filteredProduct);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$mlnComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$MlnComnet$ChangeProduct$UpdateProductRequestSent));
			case 8:
				var ind = msg.a;
				var input = msg.b;
				var newPriceWithoutPoint = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(input));
				var calcPrice = function (point) {
					return (((((100 * newPriceWithoutPoint) / (100 - point)) | 0) * 100) / (100 + 10)) | 0;
				};
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: calcPrice(product.ls),
							cb: newPriceWithoutPoint
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$MlnComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 9:
				var bigCategoryId = msg.a;
				var selectedBigCategory = function (c) {
					return _Utils_eq(
						c,
						$elm$core$Maybe$Just(-1)) ? $elm$core$Maybe$Nothing : c;
				}(
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ig: selectedBigCategory, gD: $elm$core$Maybe$Nothing}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeProduct$SaveFormSnapshot),
						$elm$core$Task$succeed(0)));
			case 10:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = function (c) {
					return _Utils_eq(
						c,
						$elm$core$Maybe$Just(-1)) ? $elm$core$Maybe$Nothing : c;
				}(
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gD: selectedSmallCategoryId}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeProduct$SaveFormSnapshot),
						$elm$core$Task$succeed(0)));
			case 11:
				var opt = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: opt}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var query = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: query}),
					$elm$core$Platform$Cmd$none);
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c4: !model.c4}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeProduct$SaveFormSnapshot),
						$elm$core$Task$succeed(0)));
			case 14:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aC: !model.aC}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeProduct$SaveFormSnapshot),
						$elm$core$Task$succeed(0)));
			case 15:
				var body = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'big_category_id',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, model.ig))),
							_Utils_Tuple2(
							'small_category_id',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, model.gD))),
							_Utils_Tuple2(
							'display_only_base_price_enabled',
							$elm$json$Json$Encode$bool(model.c4)),
							_Utils_Tuple2(
							'display_only_mail_enabled',
							$elm$json$Json$Encode$bool(model.aC))
						]));
				return _Utils_Tuple2(
					model,
					A4($author$project$Api$postWhatever, $author$project$Endpoints$User$mlnComnetEndpoints.aV.nu, model.C, body, $author$project$Pages$Users$MlnComnet$ChangeProduct$SaveFormSnapshotSent));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$MlnComnet$Chronological$AttemptPollingExcelProcessingStatus = F2(
	function (a, b) {
		return {$: 44, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$Chronological$Failure = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$GetExcelRequestSent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$GetPriceRequestSent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$GotCreateSelectorSnapshotResult = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$GotDownloadExcel = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$GotExcelProcessingStatusPollingResult = F2(
	function (a, b) {
		return {$: 43, a: a, b: b};
	});
var $justinmimbs$time_extra$Time$Extra$Monday = 4;
var $author$project$Pages$Users$MlnComnet$Chronological$NotReady = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$time_extra$Time$Extra$Thursday = 7;
var $Herteby$url_builder_plus$UrlBuilderPlus$bool = F2(
	function (key, value) {
		return A2(
			$Herteby$url_builder_plus$UrlBuilderPlus$QueryParameter,
			$elm$url$Url$percentEncode(key),
			value ? 'true' : 'false');
	});
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Pages$Users$MlnComnet$Chronological$Ready = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$excelProcessingStatusDecoder = function (res) {
	return A2(
		$elm$json$Json$Decode$map,
		function (s) {
			switch (s) {
				case 'ready':
					return $author$project$Pages$Users$MlnComnet$Chronological$Ready(res);
				case 'not-ready':
					return $author$project$Pages$Users$MlnComnet$Chronological$NotReady(res);
				case 'failure':
					return $author$project$Pages$Users$MlnComnet$Chronological$Failure('内部エラーが発生しました。');
				default:
					return $author$project$Pages$Users$MlnComnet$Chronological$Failure('予期せぬエラーが発生しました。');
			}
		},
		A2($elm$json$Json$Decode$field, 'status', $elm$json$Json$Decode$string));
};
var $author$project$Pages$Users$MlnComnet$Chronological$ExcelRequestResponse = F2(
	function (downloadURL, filename) {
		return {ck: downloadURL, hu: filename};
	});
var $author$project$Pages$Users$MlnComnet$Chronological$excelRequestResponse = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Pages$Users$MlnComnet$Chronological$ExcelRequestResponse,
	A2($elm$json$Json$Decode$field, 'downloadURL', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'filename', $elm$json$Json$Decode$string));
var $elm_community$list_extra$List$Extra$andThen = $elm$core$List$concatMap;
var $elm_community$list_extra$List$Extra$lift2 = F3(
	function (f, la, lb) {
		return A2(
			$elm_community$list_extra$List$Extra$andThen,
			function (a) {
				return A2(
					$elm_community$list_extra$List$Extra$andThen,
					function (b) {
						return _List_fromArray(
							[
								A2(f, a, b)
							]);
					},
					lb);
			},
			la);
	});
var $elm_community$list_extra$List$Extra$cartesianProduct = function (ll) {
	if (!ll.b) {
		return _List_fromArray(
			[_List_Nil]);
	} else {
		var xs = ll.a;
		var xss = ll.b;
		return A3(
			$elm_community$list_extra$List$Extra$lift2,
			$elm$core$List$cons,
			xs,
			$elm_community$list_extra$List$Extra$cartesianProduct(xss));
	}
};
var $author$project$Pages$Users$MlnComnet$Chronological$filteredTimes = A2(
	$elm$core$List$map,
	function (hm) {
		if (!hm.b) {
			return '';
		} else {
			if (!hm.b.b) {
				return '';
			} else {
				if (!hm.b.b.b) {
					var h = hm.a;
					var _v1 = hm.b;
					var m = _v1.a;
					return A2($author$project$Utils$Helpers$formatTime, h, m);
				} else {
					return '';
				}
			}
		}
	},
	$elm_community$list_extra$List$Extra$cartesianProduct(
		_List_fromArray(
			[
				A2($elm$core$List$range, 0, 23),
				_List_fromArray(
				[0, 30])
			])));
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return _Utils_eq(x, y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($elm_community$list_extra$List$Extra$remove, x, ys));
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Modal$Show = 0;
var $frandibar$elm_bootstrap$Bootstrap$Modal$shown = 0;
var $author$project$Pages$Users$MlnComnet$Chronological$SubmitResponse = F3(
	function (rows, hasReachedlimit, hitDateTimes) {
		return {mg: hasReachedlimit, hD: hitDateTimes, gv: rows};
	});
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (!_v0.$) {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Pages$Users$MlnComnet$Chronological$Row = F9(
	function (productId, storeId, category, productName, storeName, storeGroupName, url, alertPrice, productPrices) {
		return {iO: alertPrice, hl: category, kl: productId, nk: productName, km: productPrices, kR: storeGroupName, iw: storeId, kS: storeName, eD: url};
	});
var $author$project$Pages$Users$MlnComnet$Chronological$Cell = function (dateTime) {
	return function (price) {
		return function (priceIncludeTax) {
			return function (point) {
				return function (priceWithoutPoint) {
					return function (coupon) {
						return function (isLower) {
							return function (isLowest) {
								return function (isDecreased) {
									return function (isIncreased) {
										return {i9: coupon, lP: dateTime, jJ: isDecreased, jK: isIncreased, hL: isLower, hN: isLowest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$MlnComnet$Chronological$cellDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'is_increased', $elm$json$Json$Decode$bool),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'is_decreased', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'is_lowest', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'is_lower', $elm$json$Json$Decode$bool),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'date_time', $elm_community$json_extra$Json$Decode$Extra$datetime),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$MlnComnet$Chronological$Cell)))))))))));
var $author$project$Pages$Users$MlnComnet$Chronological$rowDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'productPrices',
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$maybe($author$project$Pages$Users$MlnComnet$Chronological$cellDecoder))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'alert_price', $elm$json$Json$Decode$int),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'store_group_name', $elm$json$Json$Decode$string),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'category', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Pages$Users$MlnComnet$Chronological$Row))))))))));
var $author$project$Pages$Users$MlnComnet$Chronological$submitResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$MlnComnet$Chronological$SubmitResponse,
	A2(
		$elm$json$Json$Decode$field,
		'productPriceTimeSeries',
		$elm$json$Json$Decode$list($author$project$Pages$Users$MlnComnet$Chronological$rowDecoder)),
	A2($elm$json$Json$Decode$field, 'has_reached_limit', $elm$json$Json$Decode$bool),
	A2(
		$elm$json$Json$Decode$field,
		'hit_date_times',
		$elm$json$Json$Decode$list($elm_community$json_extra$Json$Decode$Extra$datetime)));
var $krisajenkins$remotedata$RemoteData$succeed = $krisajenkins$remotedata$RemoteData$Success;
var $author$project$Pages$Users$MlnComnet$Chronological$update = F2(
	function (msg, model) {
		_v0$51:
		while (true) {
			switch (msg.$) {
				case 52:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 0:
					var date = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
								cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
								il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
								im: function (parts) {
									return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
								}(
									A2($author$project$Utils$Helpers$floorTimeByInterval, date, 60)),
								gW: $elm$core$Maybe$Just(
									A2(
										$justinmimbs$time_extra$Time$Extra$partsToPosix,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										date))
							}),
						$elm$core$Platform$Cmd$none);
				case 12:
					var date = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cY: date}),
						$elm$core$Platform$Cmd$none);
				case 13:
					var time = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{il: time}),
						$elm$core$Platform$Cmd$none);
				case 14:
					var date = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cZ: date}),
						$elm$core$Platform$Cmd$none);
				case 15:
					var time = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{im: time}),
						$elm$core$Platform$Cmd$none);
				case 16:
					var time = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gE: time}),
						$elm$core$Platform$Cmd$none);
				case 17:
					var isHourly = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								db: model.a1 ? $krisajenkins$remotedata$RemoteData$NotAsked : $krisajenkins$remotedata$RemoteData$Loading
							}),
						function () {
							var _v1 = _Utils_Tuple2(
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
								A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
							if ((!_v1.a.$) && (!_v1.b.$)) {
								var dateTimePartsFrom = _v1.a.a;
								var dateTimePartsTo = _v1.b.a;
								var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
								var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
								return (!model.a1) ? A4(
									$author$project$Api$get,
									$author$project$Endpoints$User$mlnComnetEndpoints.lC.em(
										_List_fromArray(
											[
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'interval',
												isHourly ? '60' : $elm$core$String$fromInt(model.ac)),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'bigCategory',
												$elm$core$String$fromInt(model.ig)),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'smallCategory',
												$elm$core$String$fromInt(model.gD)),
												A2(
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'maker',
												$elm$core$String$fromInt(
													A2($elm$core$Maybe$withDefault, -1, model.eh))),
												A3($Herteby$url_builder_plus$UrlBuilderPlus$list, $Herteby$url_builder_plus$UrlBuilderPlus$string, 'products', model.ij),
												A3(
												$Herteby$url_builder_plus$UrlBuilderPlus$list,
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'stores',
												A2(
													$elm$core$List$map,
													$elm$core$Tuple$first,
													$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p))),
												A3(
												$Herteby$url_builder_plus$UrlBuilderPlus$list,
												$Herteby$url_builder_plus$UrlBuilderPlus$string,
												'filteredTimes',
												$elm$core$Set$toList(model.O)),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$bool, 'queryOnlyAlertProduct', model.bO),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$bool, 'queryOnlyLowest', model.bP),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$bool, 'queryOnlyMoved', model.bQ),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$bool, 'priceEnabled', model.aw),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$bool, 'pointEnabled', model.au),
												A2($Herteby$url_builder_plus$UrlBuilderPlus$bool, 'priceWithoutPointEnabled', model.ax)
											])),
									model.C,
									$author$project$Pages$Users$MlnComnet$Chronological$submitResponseDecoder,
									$author$project$Pages$Users$MlnComnet$Chronological$GetPriceRequestSent) : A5(
									$author$project$Api$post,
									$author$project$Endpoints$User$mlnComnetEndpoints.lC.l1(_List_Nil),
									model.C,
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'from',
												$elm$json$Json$Encode$string(from)),
												_Utils_Tuple2(
												'to',
												$elm$json$Json$Encode$string(to)),
												_Utils_Tuple2(
												'interval',
												$elm$json$Json$Encode$string(
													isHourly ? '60' : $elm$core$String$fromInt(model.ac))),
												_Utils_Tuple2(
												'bigCategory',
												$elm$json$Json$Encode$string(
													$elm$core$String$fromInt(model.ig))),
												_Utils_Tuple2(
												'smallCategory',
												$elm$json$Json$Encode$string(
													$elm$core$String$fromInt(model.gD))),
												_Utils_Tuple2(
												'maker',
												$elm$json$Json$Encode$string(
													$elm$core$String$fromInt(
														A2($elm$core$Maybe$withDefault, -1, model.eh)))),
												_Utils_Tuple2(
												'products',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, model.ij)),
												_Utils_Tuple2(
												'stores',
												A2(
													$elm$json$Json$Encode$list,
													$elm$json$Json$Encode$string,
													A2(
														$elm$core$List$map,
														$elm$core$Tuple$first,
														$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))),
												_Utils_Tuple2(
												'separateSheet',
												$elm$json$Json$Encode$bool(model.c3)),
												_Utils_Tuple2(
												'specificTime',
												$elm$json$Json$Encode$string(model.gE)),
												_Utils_Tuple2(
												'priceEnabled',
												$elm$json$Json$Encode$bool(model.aw)),
												_Utils_Tuple2(
												'pointEnabled',
												$elm$json$Json$Encode$bool(model.au)),
												_Utils_Tuple2(
												'priceWithoutPointEnabled',
												$elm$json$Json$Encode$bool(model.ax)),
												_Utils_Tuple2(
												'filteredTimes',
												A2(
													$elm$json$Json$Encode$list,
													$elm$json$Json$Encode$string,
													$elm$core$Set$toList(model.O))),
												_Utils_Tuple2(
												'queryOnlyAlertProduct',
												$elm$json$Json$Encode$bool(model.bO)),
												_Utils_Tuple2(
												'queryOnlyLowest',
												$elm$json$Json$Encode$bool(model.bP)),
												_Utils_Tuple2(
												'queryOnlyMoved',
												$elm$json$Json$Encode$bool(model.bQ))
											])),
									$author$project$Pages$Users$MlnComnet$Chronological$excelRequestResponse,
									$author$project$Pages$Users$MlnComnet$Chronological$GetExcelRequestSent);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				case 9:
					var bigCategoryId = msg.a;
					var selectedBigCategory = A2(
						$elm$core$Maybe$withDefault,
						-1,
						$elm$core$String$toInt(bigCategoryId));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ig: selectedBigCategory, gD: -1}),
						$elm$core$Platform$Cmd$none);
				case 10:
					var smallCategoryId = msg.a;
					var selectedSmallCategoryId = A2(
						$elm$core$Maybe$withDefault,
						-1,
						$elm$core$String$toInt(smallCategoryId));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gD: selectedSmallCategoryId}),
						$elm$core$Platform$Cmd$none);
				case 11:
					var makerId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eh: A2(
									$elm$core$Maybe$andThen,
									$elm$core$Maybe$Just,
									$elm$core$String$toInt(makerId))
							}),
						$elm$core$Platform$Cmd$none);
				case 49:
					var productId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ij: _Utils_ap(
									model.ij,
									_List_fromArray(
										[productId]))
							}),
						$elm$core$Platform$Cmd$none);
				case 50:
					var productId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ij: A2($elm_community$list_extra$List$Extra$remove, productId, model.ij)
							}),
						$elm$core$Platform$Cmd$none);
				case 8:
					var sub = msg.a;
					var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
					var subModel = _v2.a;
					var subCmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{p: subModel}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$MlnComnet$Chronological$OnChangeStore, subCmd));
				case 1:
					var result = msg.a;
					if (!result.$) {
						var initResponse = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aH: $krisajenkins$remotedata$RemoteData$succeed(initResponse),
									p: A3(
										$inkuzmin$elm_multiselect$Multiselect$populateValues,
										model.p,
										A2(
											$elm$core$List$map,
											function (p) {
												return _Utils_Tuple2(
													$elm$core$String$fromInt(p.iw),
													p.kS);
											},
											initResponse.aN),
										_List_Nil)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aH: $krisajenkins$remotedata$RemoteData$Failure(error)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 2:
					var result = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bV: $krisajenkins$remotedata$RemoteData$fromResult(result)
							}),
						$elm$core$Platform$Cmd$none);
				case 5:
					var result = msg.a;
					if (!result.$) {
						var res = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									db: $krisajenkins$remotedata$RemoteData$Success(res),
									es: model.cY,
									gP: model.cZ,
									et: model.il,
									gQ: model.im
								}),
							$author$project$Api$createFixedMidashi(0));
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									db: $krisajenkins$remotedata$RemoteData$Failure(error)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 6:
					if (!msg.a.$) {
						var res = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bw: $author$project$Pages$Users$MlnComnet$Chronological$NotReady(res),
									a$: $frandibar$elm_bootstrap$Bootstrap$Modal$shown
								}),
							A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always(
									A2(
										$author$project$Pages$Users$MlnComnet$Chronological$GotExcelProcessingStatusPollingResult,
										1000.0,
										$elm$core$Result$Ok(
											$author$project$Pages$Users$MlnComnet$Chronological$NotReady(res)))),
								$elm$core$Task$succeed(0)));
					} else {
						var e = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bw: $author$project$Pages$Users$MlnComnet$Chronological$Failure('request.failed'),
									a$: $frandibar$elm_bootstrap$Bootstrap$Modal$shown
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 43:
					if (!msg.b.$) {
						var pollingInterval = msg.a;
						var status = msg.b.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bw: status}),
							function () {
								switch (status.$) {
									case 0:
										return $elm$core$Platform$Cmd$none;
									case 1:
										var res = status.a;
										return A2(
											$elm$core$Task$perform,
											$elm$core$Basics$always(
												A2($author$project$Pages$Users$MlnComnet$Chronological$AttemptPollingExcelProcessingStatus, 10 * 1000.0, res)),
											$elm$core$Process$sleep(pollingInterval));
									case 2:
										var res = status.a;
										return A3(
											$author$project$Api$getByte,
											A2($author$project$Endpoints$User$mlnComnetEndpoints.lC.l0, res.hu, _List_Nil),
											model.C,
											$author$project$Pages$Users$MlnComnet$Chronological$GotDownloadExcel);
									default:
										return $elm$core$Platform$Cmd$none;
								}
							}());
					} else {
						break _v0$51;
					}
				case 44:
					var nextPollingInterval = msg.a;
					var res = msg.b;
					return _Utils_Tuple2(
						model,
						A4(
							$author$project$Api$get,
							A2($author$project$Endpoints$User$mlnComnetEndpoints.lC.l2, res.hu, _List_Nil),
							model.C,
							$author$project$Pages$Users$MlnComnet$Chronological$excelProcessingStatusDecoder(res),
							$author$project$Pages$Users$MlnComnet$Chronological$GotExcelProcessingStatusPollingResult(nextPollingInterval)));
				case 22:
					var posix = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fa: $elm$core$Maybe$Just(posix)
							}),
						$elm$core$Platform$Cmd$none);
				case 18:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a1: !model.a1}),
						$elm$core$Platform$Cmd$none);
				case 19:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bP: !model.bP}),
						$elm$core$Platform$Cmd$none);
				case 20:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bQ: !model.bQ}),
						$elm$core$Platform$Cmd$none);
				case 21:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bO: !model.bO}),
						$elm$core$Platform$Cmd$none);
				case 23:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aw: !model.aw}),
						$elm$core$Platform$Cmd$none);
				case 24:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{au: !model.au}),
						$elm$core$Platform$Cmd$none);
				case 25:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ax: !model.ax}),
						$elm$core$Platform$Cmd$none);
				case 26:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c3: !model.c3}),
						$elm$core$Platform$Cmd$none);
				case 29:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bq: $frandibar$elm_bootstrap$Bootstrap$Modal$shown, aM: ''}),
						$elm$core$Platform$Cmd$none);
				case 32:
					var _v6 = model.ag;
					if (!_v6.$) {
						var selectedSnapshotId = _v6.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									aM: A3(
										$krisajenkins$remotedata$RemoteData$unwrap,
										'',
										A2(
											$elm$core$Basics$composeR,
											$elm_community$list_extra$List$Extra$find(
												function (snapshot) {
													return _Utils_eq(
														$elm$core$String$fromInt(snapshot.gG),
														selectedSnapshotId);
												}),
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Maybe$map(
													function ($) {
														return $.jZ;
													}),
												$elm$core$Maybe$withDefault(''))),
										model.bV),
									b_: $frandibar$elm_bootstrap$Bootstrap$Modal$shown
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 28:
					var dropdownState = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eg: dropdownState}),
						$elm$core$Platform$Cmd$none);
				case 30:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bq: _Utils_eq(model.bq, $frandibar$elm_bootstrap$Bootstrap$Modal$shown) ? $frandibar$elm_bootstrap$Bootstrap$Modal$hidden : $frandibar$elm_bootstrap$Bootstrap$Modal$shown
							}),
						$elm$core$Platform$Cmd$none);
				case 31:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b_: _Utils_eq(model.b_, $frandibar$elm_bootstrap$Bootstrap$Modal$shown) ? $frandibar$elm_bootstrap$Bootstrap$Modal$hidden : $frandibar$elm_bootstrap$Bootstrap$Modal$shown
							}),
						$elm$core$Platform$Cmd$none);
				case 37:
					var snapshotId = msg.a;
					var _v7 = A3(
						$krisajenkins$remotedata$RemoteData$unwrap,
						$elm$core$Maybe$Nothing,
						$elm_community$list_extra$List$Extra$find(
							function (s) {
								return _Utils_eq(
									$elm$core$String$fromInt(s.gG),
									snapshotId);
							}),
						model.bV);
					if (!_v7.$) {
						var snapshot = _v7.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									p: A3(
										$inkuzmin$elm_multiselect$Multiselect$populateValues,
										model.p,
										A2(
											$elm$core$List$map,
											function (s) {
												return _Utils_Tuple2(
													$elm$core$String$fromInt(s.iw),
													s.kS);
											},
											A3(
												$krisajenkins$remotedata$RemoteData$unwrap,
												_List_Nil,
												function ($) {
													return $.aN;
												},
												model.aH)),
										A2(
											$elm$core$List$map,
											function (s) {
												return _Utils_Tuple2(
													$elm$core$String$fromInt(s.iw),
													s.kS);
											},
											A2(
												$elm$core$List$filter,
												function (s) {
													return A2(
														$elm$core$List$member,
														$elm$core$String$fromInt(s.iw),
														snapshot.nK);
												},
												A3(
													$krisajenkins$remotedata$RemoteData$unwrap,
													_List_Nil,
													function ($) {
														return $.aN;
													},
													model.aH)))),
									ig: A2($elm$core$Maybe$withDefault, -1, snapshot.e_),
									ij: snapshot.nj,
									gD: A2($elm$core$Maybe$withDefault, -1, snapshot.ir),
									ag: $elm$core$Maybe$Just(snapshotId)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ag: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					}
				case 33:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bq: $frandibar$elm_bootstrap$Bootstrap$Modal$hidden}),
						A5(
							$author$project$Api$post,
							$author$project$Endpoints$User$mlnComnetEndpoints.nA.lL(_List_Nil),
							model.C,
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'pageName',
										$elm$json$Json$Encode$string($author$project$Pages$Users$MlnComnet$Chronological$pageName)),
										_Utils_Tuple2(
										'bigCategoryId',
										$elm$json$Json$Encode$int(model.ig)),
										_Utils_Tuple2(
										'smallCategoryId',
										$elm$json$Json$Encode$int(model.gD)),
										_Utils_Tuple2(
										'productIds',
										A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, model.ij)),
										_Utils_Tuple2(
										'storeIds',
										A2(
											$elm$json$Json$Encode$list,
											$elm$json$Json$Encode$string,
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))),
										_Utils_Tuple2(
										'selectorSnapshotName',
										$elm$json$Json$Encode$string(model.aM))
									])),
							$author$project$Utils$Decoders$selectorSnapshotDecoder,
							$author$project$Pages$Users$MlnComnet$Chronological$GotCreateSelectorSnapshotResult));
				case 34:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b_: $frandibar$elm_bootstrap$Bootstrap$Modal$hidden}),
						function () {
							var _v8 = model.ag;
							if (!_v8.$) {
								var selectedSnapshotId = _v8.a;
								return A5(
									$author$project$Api$post,
									$author$project$Endpoints$User$mlnComnetEndpoints.nA.nt(_List_Nil),
									model.C,
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'selectorSnapshotId',
												$elm$json$Json$Encode$string(selectedSnapshotId)),
												_Utils_Tuple2(
												'pageName',
												$elm$json$Json$Encode$string($author$project$Pages$Users$MlnComnet$Chronological$pageName)),
												_Utils_Tuple2(
												'bigCategoryId',
												$elm$json$Json$Encode$int(model.ig)),
												_Utils_Tuple2(
												'smallCategoryId',
												$elm$json$Json$Encode$int(model.gD)),
												_Utils_Tuple2(
												'productIds',
												A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, model.ij)),
												_Utils_Tuple2(
												'storeIds',
												A2(
													$elm$json$Json$Encode$list,
													$elm$json$Json$Encode$string,
													A2(
														$elm$core$List$map,
														$elm$core$Tuple$first,
														$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))),
												_Utils_Tuple2(
												'selectorSnapshotName',
												$elm$json$Json$Encode$string(model.aM))
											])),
									$author$project$Utils$Decoders$selectorSnapshotDecoder,
									$author$project$Pages$Users$MlnComnet$Chronological$GotCreateSelectorSnapshotResult);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				case 35:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ag: $elm$core$Maybe$Nothing}),
						function () {
							var _v9 = model.ag;
							if (!_v9.$) {
								var selectedSnapshotId = _v9.a;
								return A5(
									$author$project$Api$post,
									$author$project$Endpoints$User$mlnComnetEndpoints.nA.ie(_List_Nil),
									model.C,
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'selectorSnapshotId',
												$elm$json$Json$Encode$string(selectedSnapshotId))
											])),
									$author$project$Utils$Decoders$selectorSnapshotDecoder,
									$author$project$Pages$Users$MlnComnet$Chronological$GotCreateSelectorSnapshotResult);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}());
				case 3:
					return _Utils_Tuple2(
						model,
						A4(
							$author$project$Api$get,
							$author$project$Endpoints$User$mlnComnetEndpoints.nA.hy(
								_List_fromArray(
									[
										A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'pageName', $author$project$Pages$Users$MlnComnet$Chronological$pageName)
									])),
							model.C,
							A2($elm$json$Json$Decode$field, 'selectorSnapshots', $author$project$Utils$Decoders$selectorSnapshotsDecoder),
							$author$project$Pages$Users$MlnComnet$Chronological$GotGetSelectorSnapshot));
				case 36:
					var name = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aM: name}),
						$elm$core$Platform$Cmd$none);
				case 38:
					if (model.ao) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{ao: false}),
							$elm$core$Platform$Cmd$none);
					} else {
						var _v10 = model.gW;
						if (!_v10.$) {
							var today = _v10.a;
							var prevThursdayParts = A2(
								$justinmimbs$time_extra$Time$Extra$posixToParts,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								A3(
									$justinmimbs$time_extra$Time$Extra$floor,
									7,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									today));
							var prevMondayOrNowParts = function (mondayParts) {
								var adjustedMondayParts = _Utils_update(
									mondayParts,
									{mj: 10, mM: 0, mO: 0, ny: 0});
								return (_Utils_cmp(
									$elm$time$Time$posixToMillis(
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											adjustedMondayParts)),
									$elm$time$Time$posixToMillis(today)) < 0) ? A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									today) : adjustedMondayParts;
							}(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A3(
										$justinmimbs$time_extra$Time$Extra$floor,
										4,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										today)));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ao: true,
										cY: A3($author$project$Utils$Helpers$formatDate, prevThursdayParts.ob, prevThursdayParts.mQ, prevThursdayParts.fd),
										cZ: A3($author$project$Utils$Helpers$formatDate, prevMondayOrNowParts.ob, prevMondayOrNowParts.mQ, prevMondayOrNowParts.fd),
										il: A2($author$project$Utils$Helpers$formatTime, 10, 0),
										im: function (parts) {
											return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
										}(
											A2($author$project$Utils$Helpers$floorTimeByInterval, prevMondayOrNowParts, model.ac))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}
				case 39:
					var timeStr = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								O: A2($elm$core$Set$member, timeStr, model.O) ? A2($elm$core$Set$remove, timeStr, model.O) : A2($elm$core$Set$insert, timeStr, model.O)
							}),
						$elm$core$Platform$Cmd$none);
				case 40:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								O: $elm$core$Set$fromList($author$project$Pages$Users$MlnComnet$Chronological$filteredTimes)
							}),
						$elm$core$Platform$Cmd$none);
				case 41:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								O: $elm$core$Set$fromList(
									A2(
										$elm$core$List$filter,
										function (str) {
											return A2($elm$core$String$endsWith, '00', str);
										},
										$author$project$Pages$Users$MlnComnet$Chronological$filteredTimes))
							}),
						$elm$core$Platform$Cmd$none);
				case 42:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{O: $elm$core$Set$empty}),
						$elm$core$Platform$Cmd$none);
				case 45:
					if (!msg.a.$) {
						var bytes = msg.a.a;
						return _Utils_Tuple2(
							model,
							A3($elm$file$File$Download$bytes, model.cY + ('〜' + (model.im + '.xlsx')), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', bytes));
					} else {
						break _v0$51;
					}
				case 46:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a$: _Utils_eq(model.a$, $frandibar$elm_bootstrap$Bootstrap$Modal$hidden) ? $frandibar$elm_bootstrap$Bootstrap$Modal$shown : $frandibar$elm_bootstrap$Bootstrap$Modal$hidden
							}),
						$elm$core$Platform$Cmd$none);
				case 47:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a$: $frandibar$elm_bootstrap$Bootstrap$Modal$hidden}),
						$elm$core$Platform$Cmd$none);
				case 48:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								eb: _Utils_eq(model.eb, $frandibar$elm_bootstrap$Bootstrap$Modal$hidden) ? $frandibar$elm_bootstrap$Bootstrap$Modal$shown : $frandibar$elm_bootstrap$Bootstrap$Modal$hidden
							}),
						$elm$core$Platform$Cmd$none);
				case 51:
					var text = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{h7: text}),
						$elm$core$Platform$Cmd$none);
				default:
					break _v0$51;
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Users$MlnComnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$MlnComnet$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$MlnComnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$MlnComnet$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$MlnComnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$MlnComnet$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = A2(
		$elm$core$List$sortWith,
		$author$project$Utils$Helpers$compareProductBySortOption(model.kG),
		model.kn);
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜', m: 0},
						{jP: '税込', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後(税込)', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$MlnComnet$Hour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$MlnComnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$MlnComnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$MlnComnet$Hour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$MlnComnet$Hour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$MlnComnet$Hour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$MlnComnet$Hour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$MlnComnet$Hour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '形名', '項目', '閾値'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$MlnComnet$Hour$storeGroupId2Ord = function (storeGroupId) {
	switch (storeGroupId) {
		case 1:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 2:
			return 4;
		case 5:
			return 5;
		default:
			return 6;
	}
};
var $author$project$Pages$Users$MlnComnet$Hour$sortStoreGroups = function (storeGroups) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Pages$Users$MlnComnet$Hour$storeGroupId2Ord,
			function ($) {
				return $.iv;
			}),
		storeGroups);
};
var $author$project$Pages$Users$MlnComnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$MlnComnet$Hour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$MlnComnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$MlnComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$MlnComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$MlnComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$MlnComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: $author$project$Pages$Users$MlnComnet$Hour$sortStoreGroups(getPriceResponse.X),
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 5:
				var option = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: option}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 11:
				var storeHeader = A2($author$project$Pages$Users$MlnComnet$Hour$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$MlnComnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$MlnComnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$MlnComnet$HourYamada$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$MlnComnet$HourYamada$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$MlnComnet$HourYamada$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$MlnComnet$HourYamada$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$MlnComnet$HourYamada$pProductPriceRows = function (model) {
	var storesTarget = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return !$elm$core$List$isEmpty(storeGroup.aN);
			},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return _Utils_update(
						storeGroup,
						{
							aN: A2(
								$elm$core$List$filter,
								function (store) {
									return store.iw === 1;
								},
								storeGroup.aN)
						});
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return storeGroup.iv === 1;
					},
					model.X))));
	var storesAll = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return !$elm$core$List$isEmpty(storeGroup.aN);
			},
			model.X));
	var products = A2(
		$elm$core$List$sortWith,
		$author$project$Utils$Helpers$compareProductBySortOption(model.kG),
		model.kn);
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							storesAll)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜', m: 0},
						{jP: '税込', m: 1},
						{jP: 'P/下取り', m: 2},
						{jP: 'P後(税込)', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$MlnComnet$HourYamada$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$MlnComnet$HourYamada$ProductPriceNoData;
							}
						},
						storesTarget));
			};
		},
		products);
};
var $author$project$Pages$Users$MlnComnet$HourYamada$pStoreHeader = function (storeGroups) {
	return _Utils_ap(
		A2(
			$elm$core$List$map,
			function (str) {
				return {iv: -1, kS: str};
			},
			_List_fromArray(
				['#', '形名', '項目', '閾値'])),
		A2(
			$elm$core$List$concatMap,
			function (storeGroup) {
				return A2(
					$elm$core$List$map,
					function (store) {
						return {iv: storeGroup.iv, kS: store.fh};
					},
					storeGroup.aN);
			},
			A2(
				$elm$core$List$filter,
				function (storeGroup) {
					return !$elm$core$List$isEmpty(storeGroup.aN);
				},
				A2(
					$elm$core$List$map,
					function (storeGroup) {
						return _Utils_update(
							storeGroup,
							{
								aN: A2(
									$elm$core$List$filter,
									function (store) {
										return store.iw === 1;
									},
									storeGroup.aN)
							});
					},
					A2(
						$elm$core$List$filter,
						function (storeGroup) {
							return storeGroup.iv === 1;
						},
						storeGroups)))));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$storeGroupId2Ord = function (storeGroupId) {
	switch (storeGroupId) {
		case 1:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 2:
			return 4;
		case 5:
			return 5;
		default:
			return 6;
	}
};
var $author$project$Pages$Users$MlnComnet$HourYamada$sortStoreGroups = function (storeGroups) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Pages$Users$MlnComnet$HourYamada$storeGroupId2Ord,
			function ($) {
				return $.iv;
			}),
		storeGroups);
};
var $author$project$Pages$Users$MlnComnet$HourYamada$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$MlnComnet$HourYamada$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$MlnComnet$HourYamada$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$MlnComnet$HourYamada$getPriceResponseDecoder,
								$author$project$Pages$Users$MlnComnet$HourYamada$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$MlnComnet$HourYamada$getPriceResponseDecoder,
								$author$project$Pages$Users$MlnComnet$HourYamada$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: $author$project$Pages$Users$MlnComnet$HourYamada$sortStoreGroups(getPriceResponse.X),
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 4:
				var option = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kG: option}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = $author$project$Pages$Users$MlnComnet$HourYamada$pStoreHeader(model.X);
				var priceRows = $author$project$Pages$Users$MlnComnet$HourYamada$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$MlnComnet$HourYamada$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$AddRequestSent = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$MlnComnet$MailSetting$DeleteRequestSent = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$Nop = {$: 10};
var $author$project$Pages$Users$MlnComnet$MailSetting$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\S+@\\S+\\.\\S+$'));
var $author$project$Pages$Users$MlnComnet$MailSetting$validateEmail = $elm$regex$Regex$contains($author$project$Pages$Users$MlnComnet$MailSetting$emailRegex);
var $author$project$Pages$Users$MlnComnet$MailSetting$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fC: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var q = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bN: q}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var newMail = msg.a;
				return A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					function (initResponse) {
						var newMails = A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (mail) {
								return _Utils_eq(mail.mF, newMail.mF);
							},
							$elm$core$Basics$always(newMail),
							initResponse.bF);
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fC: $krisajenkins$remotedata$RemoteData$Success(
										_Utils_update(
											initResponse,
											{bF: newMails}))
								}),
							A4(
								$author$project$Api$postWhatever,
								$author$project$Endpoints$User$mlnComnetEndpoints.mG._,
								model.C,
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'mail_id',
											$elm$json$Json$Encode$int(newMail.mF)),
											_Utils_Tuple2(
											'mail_address',
											$elm$json$Json$Encode$string(newMail.jU)),
											_Utils_Tuple2(
											'enabled',
											$elm$json$Json$Encode$bool(newMail.fl)),
											_Utils_Tuple2(
											'start_time',
											A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, newMail.gK)),
											_Utils_Tuple2(
											'end_time',
											A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, newMail.fm))
										])),
								$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$MailSetting$Nop)));
					},
					model.fC);
			case 3:
				var mailId = msg.a;
				return _Utils_Tuple2(
					model,
					A4(
						$author$project$Api$postWhatever,
						$author$project$Endpoints$User$mlnComnetEndpoints.mG.ci,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mail_id',
									$elm$json$Json$Encode$int(mailId))
								])),
						$author$project$Pages$Users$MlnComnet$MailSetting$DeleteRequestSent(mailId)));
			case 4:
				var mailId = msg.a;
				var result = msg.b;
				if (!result.$) {
					return A3(
						$krisajenkins$remotedata$RemoteData$unwrap,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						function (initResponse) {
							var newMails = A2(
								$elm$core$List$filter,
								function (mail) {
									return !_Utils_eq(mail.mF, mailId);
								},
								initResponse.bF);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										fC: $krisajenkins$remotedata$RemoteData$Success(
											_Utils_update(
												initResponse,
												{bF: newMails}))
									}),
								$elm$core$Platform$Cmd$none);
						},
						model.fC);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var address = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bI: address}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var hourStr = msg.a;
				var minuteStr = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cH: hourStr + (':' + minuteStr)}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var hourStr = msg.a;
				var minuteStr = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cG: hourStr + (':' + minuteStr)}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return $author$project$Pages$Users$MlnComnet$MailSetting$validateEmail(model.bI) ? _Utils_Tuple2(
					model,
					A4(
						$author$project$Api$postWhatever,
						$author$project$Endpoints$User$mlnComnetEndpoints.mG.am,
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'mail_address',
									$elm$json$Json$Encode$string(model.bI)),
									_Utils_Tuple2(
									'enabled',
									$elm$json$Json$Encode$bool(true)),
									_Utils_Tuple2(
									'start_time',
									$elm$json$Json$Encode$string(model.cH)),
									_Utils_Tuple2(
									'end_time',
									$elm$json$Json$Encode$string(model.cG))
								])),
						$author$project$Pages$Users$MlnComnet$MailSetting$AddRequestSent)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 9:
				var result = msg.a;
				if (!result.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cG: '00:00', bI: '', cH: '00:00'}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4(
									$author$project$Api$get,
									$author$project$Endpoints$User$mlnComnetEndpoints.mG.x(_List_Nil),
									model.C,
									$author$project$Pages$Users$MlnComnet$MailSetting$initResponseDecoder,
									$author$project$Pages$Users$MlnComnet$MailSetting$InitRequestSent)
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$MlnComnet$Yahoo$GotDirectURLs = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$MlnComnet$Yahoo$GotSubmitResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$MlnComnet$Yahoo$DirectURL = F6(
	function (productID, storeID, productName, storeName, url, enabled) {
		return {fl: enabled, cR: productID, nk: productName, da: storeID, kS: storeName, eD: url};
	});
var $author$project$Pages$Users$MlnComnet$Yahoo$directURLsDecoder = $elm$json$Json$Decode$list(
	A7(
		$elm$json$Json$Decode$map6,
		$author$project$Pages$Users$MlnComnet$Yahoo$DirectURL,
		A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'store_name', $elm$json$Json$Decode$string),
		A2(
			$elm$json$Json$Decode$field,
			'direct_url',
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(''),
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string))),
		A2($elm$json$Json$Decode$field, 'enabled', $elm$json$Json$Decode$bool)));
var $author$project$Pages$Users$MlnComnet$Yahoo$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fC: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: $krisajenkins$remotedata$RemoteData$fromResult(result)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var productID = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ii: productID}),
					A4(
						$author$project$Api$get,
						$author$project$Endpoints$User$mlnComnetEndpoints.oa.mc(
							_List_fromArray(
								[
									A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'product_id', productID)
								])),
						model.C,
						$author$project$Pages$Users$MlnComnet$Yahoo$directURLsDecoder,
						$author$project$Pages$Users$MlnComnet$Yahoo$GotDirectURLs));
			case 3:
				var productID = msg.a;
				var storeID = msg.b;
				var url = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2(
									$elm_community$list_extra$List$Extra$updateIf,
									function (data) {
										return _Utils_eq(data.cR, productID) && _Utils_eq(data.da, storeID);
									},
									function (data) {
										return _Utils_update(
											data,
											{eD: url});
									}),
								model.aY)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var productID = msg.a;
				var storeID = msg.b;
				var enabled = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aY: A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2(
									$elm_community$list_extra$List$Extra$updateIf,
									function (data) {
										return _Utils_eq(data.cR, productID) && _Utils_eq(data.da, storeID);
									},
									function (data) {
										return _Utils_update(
											data,
											{fl: enabled});
									}),
								model.aY)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var directURL = msg.a;
				return _Utils_Tuple2(
					model,
					A4(
						$author$project$Api$postWhatever,
						$author$project$Endpoints$User$mlnComnetEndpoints.oa._(_List_Nil),
						model.C,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(directURL.cR)),
									_Utils_Tuple2(
									'store_id',
									$elm$json$Json$Encode$int(directURL.da)),
									_Utils_Tuple2(
									'direct_url',
									$elm$json$Json$Encode$string(directURL.eD)),
									_Utils_Tuple2(
									'enabled',
									$elm$json$Json$Encode$bool(directURL.fl))
								])),
						$author$project$Pages$Users$MlnComnet$Yahoo$GotSubmitResponse));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$ShaComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$ShaComnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					var filteredProducts = A2(
						$elm$core$List$filter,
						function (product) {
							return product.nk !== 'blank';
						},
						initResponse.kn);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: filteredProducts}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$ShaComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$ShaComnet$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$ShaComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$ShaComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 8:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(product.lt)),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$defaultEndpoints.aV._, model.C, body, $author$project$Pages$Users$ShaComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$ShaComnet$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$defaultEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$ShaComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$ShaComnet$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ShaComnet$Day$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$ShaComnet$Day$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ShaComnet$Day$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ShaComnet$Day$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$ShaComnet$Day$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$ShaComnet$Day$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4},
						{jP: '工事費', m: 5}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$ShaComnet$Day$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4},
						{jP: '-', m: 5}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$ShaComnet$Day$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$ShaComnet$Day$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$ShaComnet$Day$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$ShaComnet$Day$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v7.a && (!_v7.b.$)) {
										var yodobashiPrice = _v7.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v5 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v5.a && (!_v5.b.$)) {
										var yodobashiPrice = _v5.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									},
										{
										jP: function () {
											var _v3 = price.lG;
											if (_v3.$ === 1) {
												return '0';
											} else {
												var constructionCost = _v3.a;
												return $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(constructionCost));
											}
										}(),
										m: 5
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$ShaComnet$Day$ProductPriceData(
									{hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$ShaComnet$Day$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$ShaComnet$Day$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$Day$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$ShaComnet$Day$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$ShaComnet$Day$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:00'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$shaComnetEndpoints.fd.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'stores',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))
										])),
								model.C,
								$author$project$Pages$Users$ShaComnet$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$ShaComnet$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var makerId = msg.a;
				var newSelectedMaker = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							newSelectedMaker,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.jW),
							newSelectedMaker);
					},
					model.c1);
				var newMultiselectProducts = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.E,
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_Tuple2(p.kl, p.nk);
						},
						filteredProducts),
					_List_Nil);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: newMultiselectProducts, eh: newSelectedMaker}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$ShaComnet$Day$OnChangeProduct, subCmd));
			case 7:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$ShaComnet$Day$OnChangeStore, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					var filteredProducts = A2(
						$elm$core$List$filter,
						function (product) {
							return product.nk !== 'blank';
						},
						initResponse.kn);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.iw),
												s.kS);
										},
										initResponse.b$),
									_List_Nil),
								c1: filteredProducts,
								io: initResponse.b$,
								kL: initResponse.kL,
								b$: initResponse.b$
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 13:
				var storeHeader = A2($author$project$Pages$Users$ShaComnet$Day$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$ShaComnet$Day$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$ShaComnet$Day$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ShaComnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$ShaComnet$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ShaComnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ShaComnet$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$ShaComnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$ShaComnet$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				if (product.nk === 'blank') {
					return _List_Nil;
				} else {
					var maybeYodobashiPrice = A2(
						$elm$core$Dict$get,
						_Utils_Tuple2(product.kl, 7),
						model.cQ);
					var lowestPrice = A3(
						$elm$core$List$foldl,
						function (price) {
							return function (m) {
								return A2($elm$core$Basics$min, m, price);
							};
						},
						A2($elm$core$Basics$pow, 2, 30),
						A2(
							$elm$core$List$map,
							function (maybePrice) {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
								} else {
									return A2($elm$core$Basics$pow, 2, 30);
								}
							},
							A2(
								$elm$core$List$map,
								function (store) {
									return A2(
										$elm$core$Dict$get,
										_Utils_Tuple2(product.kl, store.iw),
										model.cQ);
								},
								stores)));
					var itemList = _List_fromArray(
						[
							{jP: '税抜き', m: 0},
							{jP: '税込み', m: 1},
							{jP: 'P/クーポン', m: 2},
							{jP: 'P後', m: 3},
							{jP: '取得時刻', m: 4},
							{jP: '工事費', m: 5}
						]);
					var filterItemList = function (list) {
						return A2(
							$elm$core$List$map,
							function (i) {
								return A2(
									$elm$core$Maybe$withDefault,
									{jP: '', m: -1},
									A2($elm_community$list_extra$List$Extra$getAt, i, list));
							},
							A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(
									'DisplayAll',
									_List_fromArray(
										[0, 1, 2, 3, 4, 5])),
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (dispToValue) {
										return _Utils_eq(dispToValue.a, model.c_);
									},
									$author$project$Pages$Users$ShaComnet$Hour$displayStyleToValues)).b);
					};
					var filteredItemList = filterItemList(itemList);
					var _v0 = function () {
						var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
						if (_v1.a && (!_v1.b.$)) {
							var yodobashiPrice = _v1.b.a;
							return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
						} else {
							return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
						}
					}();
					var basePrice = _v0.lt;
					var basePriceIncludeTax = _v0.eY;
					var basePoint = _v0.ls;
					var basePriceWithoutPoint = _v0.cb;
					var basePriceList = _List_fromArray(
						[
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePrice)),
							m: 0
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePriceIncludeTax)),
							m: 1
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePoint)),
							m: 2
						},
							{
							jP: $author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePriceWithoutPoint)),
							m: 3
						},
							{jP: '-', m: 4},
							{jP: '-', m: 5}
						]);
					var filteredBasePriceList = filterItemList(basePriceList);
					return _Utils_ap(
						_List_fromArray(
							[
								$author$project$Pages$Users$ShaComnet$Hour$ProductPriceHeader(
								_List_fromArray(
									[
										{
										jP: $elm$core$String$fromInt(ind + 1),
										m: 0
									}
									])),
								$author$project$Pages$Users$ShaComnet$Hour$ProductPriceHeader(
								_List_fromArray(
									[
										{jP: product.nk, m: 0}
									])),
								$author$project$Pages$Users$ShaComnet$Hour$ProductPriceHeader(filteredItemList),
								$author$project$Pages$Users$ShaComnet$Hour$ProductPriceHeader(filteredBasePriceList)
							]),
						A2(
							$elm$core$List$map,
							function (store) {
								var maybePrice = A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
								var isLowest = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return _Utils_eq(price.be, lowestPrice);
									} else {
										return false;
									}
								}();
								var isLowestButHigherThanBase = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
										if (_v7.a && (!_v7.b.$)) {
											var yodobashiPrice = _v7.b.a;
											return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
										} else {
											return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										}
									} else {
										return false;
									}
								}();
								var isLower = function () {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										var _v5 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
										if (_v5.a && (!_v5.b.$)) {
											var yodobashiPrice = _v5.b.a;
											return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
										} else {
											return _Utils_cmp(price.be, product.cb) < 0;
										}
									} else {
										return false;
									}
								}();
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var priceList = _List_fromArray(
										[
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.kg)),
											m: 0
										},
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.kh)),
											m: 1
										},
											{
											jP: function (point) {
												return _Utils_ap(
													point,
													(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
											}(
												$elm$core$String$fromInt(price.ka)),
											m: 2
										},
											{
											jP: $author$project$Utils$Helpers$toCommmaSplited(
												$elm$core$String$fromInt(price.be)),
											m: 3
										},
											{
											jP: A2(
												$elm$core$Maybe$withDefault,
												'',
												$elm$core$List$head(
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														$elm$core$List$tail(
															A2($elm$core$String$split, ' ', price.lP))))),
											m: 4
										},
											{
											jP: function () {
												var _v3 = price.lG;
												if (_v3.$ === 1) {
													return '0';
												} else {
													var constructionCost = _v3.a;
													return $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(constructionCost));
												}
											}(),
											m: 5
										}
										]);
									var filteredPriceList = filterItemList(priceList);
									return $author$project$Pages$Users$ShaComnet$Hour$ProductPriceData(
										{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
								} else {
									return $author$project$Pages$Users$ShaComnet$Hour$ProductPriceNoData;
								}
							},
							stores));
				}
			};
		},
		products);
};
var $author$project$Pages$Users$ShaComnet$Hour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$ShaComnet$Hour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$ShaComnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$ShaComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$ShaComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$ShaComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$ShaComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$ShaComnet$Hour$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$ShaComnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$ShaComnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$ShaComnet$TimeSeq$Price))))))))))));
var $author$project$Pages$Users$ShaComnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$ShaComnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$ShaComnet$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ShaComnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$ShaComnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ShaComnet$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$Lower = 1;
var $author$project$Pages$Users$ShaComnet$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$ShaComnet$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$ShaComnet$TimeSeq$Normal = 3;
var $author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$ShaComnet$TimeSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$ShaComnet$TimeSeq$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$ShaComnet$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return (product.nk === 'blank') ? _List_Nil : A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$ShaComnet$TimeSeq$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$ShaComnet$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$ShaComnet$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$ShaComnet$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$ShaComnet$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$ShaComnet$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$ShaComnet$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$ShaComnet$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					var filteredProducts = A2(
						$elm$core$List$filter,
						function (product) {
							return product.nk !== 'blank';
						},
						initResponse.kn);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: filteredProducts,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 12:
				var storeHeader = A2($author$project$Pages$Users$ShaComnet$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$ShaComnet$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$ShaComnet$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$Price = function (productId) {
	return function (storeId) {
		return function (dateTime) {
			return function (price) {
				return function (priceIncludeTax) {
					return function (point) {
						return function (priceWithoutPoint) {
							return function (coupon) {
								return function (isLatest) {
									return function (url) {
										return {i9: coupon, lP: dateTime, fH: isLatest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'is_latest', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$ShaComnet$WeeklyProduct$Price)))))))))));
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$ShaComnet$WeeklyProduct$priceDecoder)));
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ShaComnet$WeeklyProduct$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$ShaComnet$WeeklyProduct$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filteredProductName = (product.nk === 'blank') ? '__blank__' : product.nk;
				var filterItemList = function (list) {
					return (product.nk === 'blank') ? _List_Nil : A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$ShaComnet$WeeklyProduct$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: filteredProductName, m: 0}
								])),
							$author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$ShaComnet$WeeklyProduct$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$ShaComnet$WeeklyProduct$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$shaComnetEndpoints.iH.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$ShaComnet$WeeklyProduct$getPriceResponseDecoder,
								$author$project$Pages$Users$ShaComnet$WeeklyProduct$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$shaComnetEndpoints.iH.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$ShaComnet$WeeklyProduct$getPriceResponseDecoder,
								$author$project$Pages$Users$ShaComnet$WeeklyProduct$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 12:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$ShaComnet$WeeklyProduct$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$ShaComnet$WeeklyProduct$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$ShaComnet$WeeklyProduct$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$ShaComnet$Wide$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$ShaComnet$Wide$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$ShaComnet$Wide$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$ShaComnet$Wide$Price))))))))))));
var $author$project$Pages$Users$ShaComnet$Wide$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$ShaComnet$Wide$priceDecoder)));
var $author$project$Pages$Users$ShaComnet$Wide$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$ShaComnet$Wide$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$ShaComnet$Wide$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$ShaComnet$Wide$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$Lower = 1;
var $author$project$Pages$Users$ShaComnet$Wide$Lowest = 0;
var $author$project$Pages$Users$ShaComnet$Wide$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$ShaComnet$Wide$Normal = 3;
var $author$project$Pages$Users$ShaComnet$Wide$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$ShaComnet$Wide$Unchanged = {$: 2};
var $author$project$Pages$Users$ShaComnet$Wide$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$ShaComnet$Wide$saiyasuList = _List_fromArray(
	[10, 14, 97]);
var $author$project$Pages$Users$ShaComnet$Wide$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return (product.nk === 'blank') ? _List_Nil : A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$ShaComnet$Wide$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$ShaComnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$ShaComnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$ShaComnet$Wide$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$ShaComnet$Wide$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$ShaComnet$Wide$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$ShaComnet$Wide$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$ShaComnet$Wide$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$ShaComnet$Wide$Unchanged);
											} else {
												return $author$project$Pages$Users$ShaComnet$Wide$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return (!A2($elm$core$List$member, price.iw, $author$project$Pages$Users$ShaComnet$Wide$saiyasuList)) && _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$ShaComnet$Wide$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$ShaComnet$Wide$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$ShaComnet$Wide$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$Wide$succDate = function (dateString) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(dateString);
	if (!_v0.$) {
		var date = _v0.a;
		return $justinmimbs$date$Date$toIsoString(
			A3($justinmimbs$date$Date$add, 3, 1, date));
	} else {
		return dateString;
	}
};
var $author$project$Pages$Users$ShaComnet$Wide$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										var top_ind = function () {
											var _v6 = A2($elm_community$list_extra$List$Extra$getAt, 0, indices);
											if (!_v6.$) {
												var x = _v6.a;
												return x;
											} else {
												return 0;
											}
										}();
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		var res = function () {
																			var _v2 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return (_Utils_eq(ind, top_ind) && _Utils_eq(item.m, -1)) || _Utils_eq(item.m, ind);
																				},
																				data);
																			if (!_v2.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v2.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var res = function () {
																			var _v3 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return _Utils_eq(item.m, ind);
																				},
																				data.h6);
																			if (!_v3.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v3.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v5 = data.du;
																		switch (_v5) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$ShaComnet$Wide$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date, cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:59'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$ShaComnet$Wide$getPriceResponseDecoder,
								$author$project$Pages$Users$ShaComnet$Wide$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				var bigCategoryId = msg.a;
				var selectedBigCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				var sendable = ((!_Utils_eq(
					model.eh,
					$elm$core$Maybe$Just(-1))) && (!_Utils_eq(
					selectedBigCategoryId,
					$elm$core$Maybe$Just(-1)))) ? true : false;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategoryId);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategoryId,
							gD: $elm$core$Maybe$Just(-1),
							c2: sendable
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				var sendable = ((!_Utils_eq(
					model.eh,
					$elm$core$Maybe$Just(-1))) && (!_Utils_eq(
					model.ig,
					$elm$core$Maybe$Just(-1)))) ? true : false;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId,
							c2: sendable
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var makerId = msg.a;
				var selectedMakerId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				var sendable = ((!_Utils_eq(
					selectedMakerId,
					$elm$core$Maybe$Just(-1))) && (!_Utils_eq(
					model.ig,
					$elm$core$Maybe$Just(-1)))) ? true : false;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A4($author$project$Utils$Helpers$filterBySelector, selectedMakerId, model.ig, model.gD, model.c1)),
								_List_Nil),
							eh: selectedMakerId,
							c2: sendable
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$ShaComnet$Wide$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: $author$project$Pages$Users$ShaComnet$Wide$succDate(model.cY),
								et: '00:00',
								gQ: '00:00',
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 9:
				var storeHeader = A2($author$project$Pages$Users$ShaComnet$Wide$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$ShaComnet$Wide$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$ShaComnet$Wide$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$TescomComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$TescomComnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$TescomComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$TescomComnet$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$TescomComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$TescomComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 6:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{n$: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$TescomComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 9:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(product.lt)),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index + 1)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'trigger_flag',
								$elm$json$Json$Encode$bool(product.n$)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV._, model.C, body, $author$project$Pages$Users$TescomComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$TescomComnet$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'trigger_flag',
									$elm$json$Json$Encode$bool(product.n$)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$TescomComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$TescomComnet$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$TescomComnet$Excel$GetExcelRequestSent = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 13:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A3(
								$author$project$Api$getByte,
								$author$project$Endpoints$User$tescomComnetEndpoints.fn.em(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(60)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$TescomComnet$Excel$GetExcelRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 7:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$TescomComnet$Excel$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 11:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				if (!msg.a.$) {
					var bytes = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{H: $elm$core$Maybe$Nothing, dP: false}),
						A3($elm$file$File$Download$bytes, model.cY + ('〜' + (model.im + '.xlsx')), 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', bytes));
				} else {
					var e = msg.a.a;
					var errMsg = function () {
						if ((e.$ === 3) && (e.a === 404)) {
							return '該当するデータが見つかりませんでした。検索条件を変更して再度お試しください。';
						} else {
							return $author$project$Utils$Helpers$errToStr(e);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(errMsg),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Pages$Users$TescomComnet$Hour$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$TescomComnet$Hour$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$TescomComnet$Hour$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TescomComnet$Hour$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$TescomComnet$Hour$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$TescomComnet$Hour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.kh : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$TescomComnet$Hour$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$TescomComnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$TescomComnet$Hour$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$TescomComnet$Hour$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$TescomComnet$Hour$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.kh, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.kh) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.eY) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple3(product.oc, product.n$, maybeYodobashiPrice);
									if (_v4.b) {
										if (_v4.a && (!_v4.c.$)) {
											var yodobashiPrice = _v4.c.a;
											return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
										} else {
											return _Utils_cmp(price.be, product.cb) < 0;
										}
									} else {
										if (_v4.a && (!_v4.c.$)) {
											var yodobashiPrice = _v4.c.a;
											return _Utils_cmp(price.kh, yodobashiPrice.kh) < 0;
										} else {
											return _Utils_cmp(price.kh, product.eY) < 0;
										}
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$TescomComnet$Hour$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$TescomComnet$Hour$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$TescomComnet$Hour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TescomComnet$Hour$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$TescomComnet$Hour$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$TescomComnet$Hour$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$TescomComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$TescomComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$TescomComnet$Hour$getPriceResponseDecoder,
								$author$project$Pages$Users$TescomComnet$Hour$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$TescomComnet$Hour$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$TescomComnet$Hour$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$TescomComnet$Hour$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Test$Fifteen$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Test$Fifteen$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Test$Fifteen$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$Test$Fifteen$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Test$Fifteen$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Test$Fifteen$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Test$Fifteen$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Test$Fifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Test$Fifteen$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Test$Fifteen$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Test$Fifteen$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple3(product.oc, product.n$, maybeYodobashiPrice);
									if (_v4.b) {
										if (_v4.a && (!_v4.c.$)) {
											var yodobashiPrice = _v4.c.a;
											return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
										} else {
											return _Utils_cmp(price.be, product.cb) < 0;
										}
									} else {
										if (_v4.a && (!_v4.c.$)) {
											var yodobashiPrice = _v4.c.a;
											return _Utils_cmp(price.kh, yodobashiPrice.kh) < 0;
										} else {
											return _Utils_cmp(price.kh, product.eY) < 0;
										}
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : ((price.iw === 1) ? '' : (' / ' + $elm$core$String$fromInt(price.i9))));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Test$Fifteen$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Test$Fifteen$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Test$Fifteen$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Test$Fifteen$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Test$Fifteen$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Test$Fifteen$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Test$Fifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$Test$Fifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Test$Fifteen$getPriceResponseDecoder,
								$author$project$Pages$Users$Test$Fifteen$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Test$Fifteen$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Test$Fifteen$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Test$Fifteen$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$moveTo = F3(
	function (src, dst, ls) {
		return (_Utils_cmp(src, dst) < 0) ? A3(
			$author$project$Pages$Users$To24tclComnet$ChangeProduct$moveTo,
			src + 1,
			dst,
			A3($elm_community$list_extra$List$Extra$swapAt, src, src + 1, ls)) : ((_Utils_cmp(src, dst) > 0) ? A3(
			$author$project$Pages$Users$To24tclComnet$ChangeProduct$moveTo,
			src - 1,
			dst,
			A3($elm_community$list_extra$List$Extra$swapAt, src, src - 1, ls)) : ls);
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$To24tclComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$To24tclComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$To24tclComnet$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$To24tclComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$To24tclComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 8:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cl: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 9:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 10:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var products = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					destInd,
					function (product) {
						return _Utils_update(
							product,
							{dM: true});
					},
					A2(
						$elm$core$List$map,
						function (product) {
							return _Utils_update(
								product,
								{dM: false});
						},
						model.kn));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dy: $elm$core$Maybe$Just(destInd),
							kn: products
						}),
					$author$project$DragPorts$dragover(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cl: $elm$core$Maybe$Nothing,
							kn: function (ls) {
								var _v1 = _Utils_Tuple2(model.cl, model.dy);
								if ((!_v1.a.$) && (!_v1.b.$)) {
									var from = _v1.a.a;
									var to = _v1.b.a;
									return A3($author$project$Pages$Users$To24tclComnet$ChangeProduct$moveTo, from, to, ls);
								} else {
									return ls;
								}
							}(
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_update(
											p,
											{dM: false});
									},
									model.kn))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(product.lt)),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index + 1)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$to24tcmComnetEndpoints.aV._, model.C, body, $author$project$Pages$Users$To24tclComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$To24tclComnet$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 7:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$to24tcmComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$To24tclComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$To24tclComnet$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tclComnet$Day$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $author$project$Pages$Users$To24tclComnet$Day$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$To24tclComnet$Day$DictPriceRecord = F4(
	function (productId, storeId, hour, data_day) {
		return {dw: data_day, mj: hour, kl: productId, iw: storeId};
	});
var $author$project$Pages$Users$To24tclComnet$Day$gen_dictpricekey = function (record) {
	return _Utils_ap(
		record.kl,
		_Utils_ap(
			$elm$core$String$fromInt(record.iw),
			_Utils_ap(
				$elm$core$String$fromInt(record.mj),
				record.dw)));
};
var $author$project$Pages$Users$To24tclComnet$Day$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$Users$To24tclComnet$Day$gen_dictpricekey,
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Pages$Users$To24tclComnet$Day$DictPriceRecord,
					A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'hour', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'data_day', $elm$json$Json$Decode$string)))),
		$elm$json$Json$Decode$list($author$project$Utils$Decoders$priceDecoder)));
var $author$project$Pages$Users$To24tclComnet$Day$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tclComnet$Day$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$To24tclComnet$Day$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$To24tclComnet$Day$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$To24tclComnet$Day$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$To24tclComnet$Day$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return $elm$core$List$concat(
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				function (ind) {
					return function (product) {
						return A2(
							$elm$core$List$map,
							function (data_day) {
								return A2(
									$elm$core$List$map,
									function (hour) {
										var maybeYodobashiPrice = function () {
											var record = {dw: data_day, mj: hour, kl: product.kl, iw: 7};
											return A2(
												$elm$core$Dict$get,
												$author$project$Pages$Users$To24tclComnet$Day$gen_dictpricekey(record),
												model.cQ);
										}();
										var lowestPrice = A3(
											$elm$core$List$foldl,
											function (price) {
												return function (m) {
													return A2($elm$core$Basics$min, m, price);
												};
											},
											A2($elm$core$Basics$pow, 2, 30),
											A2(
												$elm$core$List$map,
												function (maybePrice) {
													if (!maybePrice.$) {
														var price = maybePrice.a;
														return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
													} else {
														return A2($elm$core$Basics$pow, 2, 30);
													}
												},
												A2(
													$elm$core$List$map,
													function (store) {
														var record = {dw: data_day, mj: hour, kl: product.kl, iw: store.iw};
														return A2(
															$elm$core$Dict$get,
															$author$project$Pages$Users$To24tclComnet$Day$gen_dictpricekey(record),
															model.cQ);
													},
													stores)));
										var itemList = _List_fromArray(
											[
												{jP: '税抜き', m: 0},
												{jP: '税込み', m: 1},
												{jP: 'P/クーポン', m: 2},
												{jP: 'P後', m: 3},
												{jP: '取得時刻', m: 4}
											]);
										var filterItemList = function (list) {
											return A2(
												$elm$core$List$map,
												function (i) {
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, i, list));
												},
												A2(
													$elm$core$Maybe$withDefault,
													_Utils_Tuple2(
														'DisplayAll',
														_List_fromArray(
															[0, 1, 2, 3, 4])),
													A2(
														$elm_community$list_extra$List$Extra$find,
														function (dispToValue) {
															return _Utils_eq(dispToValue.a, model.c_);
														},
														$author$project$Pages$Users$To24tclComnet$Day$displayStyleToValues)).b);
										};
										var filteredItemList = filterItemList(itemList);
										var _v0 = function () {
											var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
											if (_v1.a && (!_v1.b.$)) {
												var yodobashiPrice = _v1.b.a;
												return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
											} else {
												return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
											}
										}();
										var basePrice = _v0.lt;
										var basePriceIncludeTax = _v0.eY;
										var basePoint = _v0.ls;
										var basePriceWithoutPoint = _v0.cb;
										var basePriceList = _List_fromArray(
											[
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePrice)),
												m: 0
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePriceIncludeTax)),
												m: 1
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePoint)),
												m: 2
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePriceWithoutPoint)),
												m: 3
											},
												{
												jP: $elm$core$String$fromInt(hour) + '時',
												m: 4
											}
											]);
										var filteredBasePriceList = filterItemList(basePriceList);
										return _Utils_ap(
											((hour === 9) && (data_day === 'today')) ? _List_fromArray(
												[
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '本日', m: 0}
														]))
												]) : (((hour === 9) && (data_day === 'yesterday')) ? _List_fromArray(
												[
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{
															jP: $elm$core$String$fromInt(ind + 1),
															m: 0
														}
														])),
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: product.nk, m: 0}
														])),
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '昨日', m: 0}
														]))
												]) : _List_fromArray(
												[
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														]))
												])),
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(filteredItemList),
														$author$project$Pages$Users$To24tclComnet$Day$ProductPriceHeader(filteredBasePriceList)
													]),
												A2(
													$elm$core$List$map,
													function (store) {
														var maybePrice = function () {
															var record = {dw: data_day, mj: hour, kl: product.kl, iw: store.iw};
															return A2(
																$elm$core$Dict$get,
																$author$project$Pages$Users$To24tclComnet$Day$gen_dictpricekey(record),
																model.cQ);
														}();
														var isLowest = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																return _Utils_eq(price.be, lowestPrice);
															} else {
																return false;
															}
														}();
														var isLowestButHigherThanBase = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
																if (_v6.a && (!_v6.b.$)) {
																	var yodobashiPrice = _v6.b.a;
																	return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
																} else {
																	return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
																}
															} else {
																return false;
															}
														}();
														var isLower = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
																if (_v4.a && (!_v4.b.$)) {
																	var yodobashiPrice = _v4.b.a;
																	return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
																} else {
																	return _Utils_cmp(price.be, product.cb) < 0;
																}
															} else {
																return false;
															}
														}();
														if (!maybePrice.$) {
															var price = maybePrice.a;
															var priceList = _List_fromArray(
																[
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.kg)),
																	m: 0
																},
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.kh)),
																	m: 1
																},
																	{
																	jP: function (point) {
																		return _Utils_ap(
																			point,
																			(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
																	}(
																		$elm$core$String$fromInt(price.ka)),
																	m: 2
																},
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.be)),
																	m: 3
																},
																	{
																	jP: A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		$elm$core$List$head(
																			A2(
																				$elm$core$Maybe$withDefault,
																				_List_Nil,
																				$elm$core$List$tail(
																					A2($elm$core$String$split, ' ', price.lP))))),
																	m: 4
																}
																]);
															var filteredPriceList = filterItemList(priceList);
															return $author$project$Pages$Users$To24tclComnet$Day$ProductPriceData(
																{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
														} else {
															return $author$project$Pages$Users$To24tclComnet$Day$ProductPriceNoData;
														}
													},
													stores)));
									},
									_List_fromArray(
										[9, 15]));
							},
							_List_fromArray(
								['yesterday', 'today']));
					};
				},
				products)));
};
var $author$project$Pages$Users$To24tclComnet$Day$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '日にち', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tclComnet$Day$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$To24tclComnet$Day$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$To24tclComnet$Day$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$To24tclComnet$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tclComnet$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to_tmp_2 = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var to_tmp = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											0 * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var to4 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp_2),
										'16:00:00'
									]));
							var to3 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp_2),
										'10:00:00'
									]));
							var to2 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp),
										'16:00:00'
									]));
							var to1 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp),
										'10:00:00'
									]));
							var from_tmp_2 = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var from_tmp = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											0 * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var from4 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp_2),
										'15:00:00'
									]));
							var from3 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp_2),
										'9:00:00'
									]));
							var from2 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp),
										'15:00:00'
									]));
							var from1 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp),
										'9:00:00'
									]));
							var except_id = '(4904530109010, 4904530109959, 4904530108952)';
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$to24tcmComnetEndpoints.fd.jt(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from1', from1),
											A2($elm$url$Url$Builder$string, 'to1', to1),
											A2($elm$url$Url$Builder$string, 'from2', from2),
											A2($elm$url$Url$Builder$string, 'to2', to2),
											A2($elm$url$Url$Builder$string, 'from3', from3),
											A2($elm$url$Url$Builder$string, 'to3', to3),
											A2($elm$url$Url$Builder$string, 'from4', from4),
											A2($elm$url$Url$Builder$string, 'to4', to4),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A2($elm$url$Url$Builder$string, 'exception', except_id)
										])),
								model.C,
								$author$project$Pages$Users$To24tclComnet$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tclComnet$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$To24tclComnet$Day$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$To24tclComnet$Day$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$To24tclComnet$Day$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tclComnet$TimeSeq$csvStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			_List_fromArray(
				['型番', '']),
			$elm$core$List$concat(
				A2(
					$elm$core$List$concatMap,
					function (storeGroup) {
						return A2(
							$elm$core$List$map,
							function (store) {
								return _List_fromArray(
									[store.fh, '価格変動']);
							},
							storeGroup.aN);
					},
					A2(
						$elm$core$List$filter,
						function (storeGroup) {
							return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
						},
						storeGroups))));
	});
var $author$project$Pages$Users$To24tclComnet$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v10 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v10.a.$) && (!_v10.b.$)) {
			var dateTimePartsFrom = _v10.a.a;
			var dateTimePartsTo = _v10.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/下取り', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Utils$Helpers$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$Common$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v8 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v8.a.$) && (!_v8.b.$)) {
												var currentPrice = _v8.a.a;
												var prevPrice = _v8.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$Common$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$Common$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$Common$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$Common$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v6.a && (!_v6.b.$)) {
													var yodobashiPrice = _v6.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v4 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v4.a) {
												return 0;
											} else {
												if (_v4.b) {
													return 2;
												} else {
													if (_v4.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$Common$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$Common$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Pages$Users$To24tclComnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				storeHeader,
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return _Utils_ap(
													A2($elm$core$List$take, 2, lst),
													A2($elm$core$List$drop, 4, lst));
											},
											A2(
												$elm$core$List$map,
												function (lst) {
													return (!(!rowInd)) ? A2($elm$core$List$cons, '', lst) : A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														$elm$core$List$tail(lst));
												},
												A2(
													$elm$core$List$map,
													function (ind) {
														return $elm$core$List$concat(
															A2(
																$elm$core$List$map,
																function (cell) {
																	switch (cell.$) {
																		case 0:
																			var _v1 = cell.a;
																			var data = _v1.b;
																			return $elm$core$List$singleton(
																				A2(
																					$elm$core$Maybe$withDefault,
																					{jP: '', m: -1},
																					A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP);
																		case 1:
																			return _List_fromArray(
																				['', '']);
																		default:
																			var data = cell.a;
																			return function (label) {
																				var annotation = (!ind) ? _Utils_ap(
																					function () {
																						var _v2 = data.du;
																						switch (_v2) {
																							case 0:
																								return '●';
																							case 1:
																								return '※';
																							default:
																								return '';
																						}
																					}(),
																					function () {
																						var _v3 = data.ge;
																						switch (_v3.$) {
																							case 0:
																								return '▲';
																							case 1:
																								return '▼';
																							default:
																								return '';
																						}
																					}()) : '';
																				return _List_fromArray(
																					[label, annotation]);
																			}(
																				A2(
																					$elm$core$Maybe$withDefault,
																					{jP: '', m: -1},
																					A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP);
																	}
																},
																row));
													},
													indices)));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$To24tclComnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											(!_Utils_eq(
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E),
												_List_Nil)) ? A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) : _List_Nil)
										])),
								model.C,
								$author$project$Pages$Users$Common$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var storeHeader = A2($author$project$Pages$Users$To24tclComnet$TimeSeq$csvStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$To24tclComnet$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$To24tclComnet$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return A2($author$project$Pages$Users$Common$TimeSeq$update, msg, model);
		}
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$getIntervalSum = function (products) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (p) {
				return (60 / p.ju) | 0;
			},
			products));
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$To24tcmComnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ju: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 6:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 9:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var index = msg.a;
				if ($author$project$Pages$Users$To24tcmComnet$ChangeProduct$getIntervalSum(model.kn) > 140) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
					if (!maybeProduct.$) {
						var product = maybeProduct.a;
						var body = $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(product.lt)),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(index + 1)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju))
								]));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{k: true}),
							A5($author$project$Api$post, $author$project$Endpoints$User$to24tcmComnetEndpoints.aV._, model.C, body, $author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$To24tcmComnet$ChangeProduct$UpdateProductRequestSent));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}
			case 8:
				if ($author$project$Pages$Users$To24tcmComnet$ChangeProduct$getIntervalSum(model.kn) > 140) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var body = A2(
						$elm$json$Json$Encode$list,
						function (product) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'product_id',
										$elm$json$Json$Encode$string(product.kl)),
										_Utils_Tuple2(
										'base_price',
										$elm$json$Json$Encode$int(product.lt)),
										_Utils_Tuple2(
										'base_point',
										$elm$json$Json$Encode$int(product.ls)),
										_Utils_Tuple2(
										'product_order',
										$elm$json$Json$Encode$int(product.nl)),
										_Utils_Tuple2(
										'yodobashi_base_price_flag',
										$elm$json$Json$Encode$bool(product.oc)),
										_Utils_Tuple2(
										'get_interval',
										$elm$json$Json$Encode$int(product.ju))
									]));
						},
						model.kn);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$to24tcmComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$To24tcmComnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$To24tcmComnet$ChangeProduct$UpdateProductRequestSent));
				}
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tcmComnet$Csv$CsvRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$CsvResponse = function (csv) {
	return {ja: csv};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$csvResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$To24tcmComnet$Csv$CsvResponse,
	A2($elm$json$Json$Decode$field, 'csv', $elm$json$Json$Decode$string));
var $author$project$Pages$Users$To24tcmComnet$Csv$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							d_: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							d1: function (parts) {
								return A3($author$project$Utils$Helpers$formatDate, parts.ob, parts.mQ, parts.fd);
							}(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										11,
										-60,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											date)))),
							cY: function (parts) {
								return A3($author$project$Utils$Helpers$formatDate, parts.ob, parts.mQ, parts.fd);
							}(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										11,
										-3,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											date)))),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: '00:00',
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var val = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var fromDateTime = _v1.a.a;
							var toDateTime = _v1.b.a;
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$to24tcmComnetEndpoints.ja.bA(
									_List_fromArray(
										[
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'from',
											$author$project$Utils$Helpers$formatDateTime(fromDateTime)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'to',
											$author$project$Utils$Helpers$formatDateTime(toDateTime)),
											A3($Herteby$url_builder_plus$UrlBuilderPlus$list, $Herteby$url_builder_plus$UrlBuilderPlus$string, 'products', model.ij),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$int, 'interval', model.ac)
										])),
								$author$project$Pages$Users$To24tcmComnet$Csv$toSession(model),
								$author$project$Pages$Users$To24tcmComnet$Csv$csvResponseDecoder,
								$author$project$Pages$Users$To24tcmComnet$Csv$CsvRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 0:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var response = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{dP: false}),
						A3(
							$elm$file$File$Download$bytes,
							model.cY + (' ' + (model.il + ('_' + (model.cZ + (' ' + (model.im + '.csv')))))),
							'text/csv',
							$elm$bytes$Bytes$Encode$encode(
								$elm$bytes$Bytes$Encode$sequence(
									_List_fromArray(
										[
											$elm$bytes$Bytes$Encode$unsignedInt8(239),
											$elm$bytes$Bytes$Encode$unsignedInt8(187),
											$elm$bytes$Bytes$Encode$unsignedInt8(191),
											$elm$bytes$Bytes$Encode$string(response.ja)
										])))));
				} else {
					var errMsg = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just('Csvのダウンロードに失敗しました')
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.ds) : A2($elm$core$Set$remove, storeGroupId, model.ds);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ds: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			default:
				var selectedProducts = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ij: selectedProducts}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tcmComnet$Day$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$To24tcmComnet$Day$DictPriceRecord = F4(
	function (productId, storeId, hour, data_day) {
		return {dw: data_day, mj: hour, kl: productId, iw: storeId};
	});
var $author$project$Pages$Users$To24tcmComnet$Day$gen_dictpricekey = function (record) {
	return _Utils_ap(
		record.kl,
		_Utils_ap(
			$elm$core$String$fromInt(record.iw),
			_Utils_ap(
				$elm$core$String$fromInt(record.mj),
				record.dw)));
};
var $author$project$Pages$Users$To24tcmComnet$Day$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$Users$To24tcmComnet$Day$gen_dictpricekey,
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Pages$Users$To24tcmComnet$Day$DictPriceRecord,
					A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'hour', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'data_day', $elm$json$Json$Decode$string)))),
		$elm$json$Json$Decode$list($author$project$Utils$Decoders$priceDecoder)));
var $author$project$Pages$Users$To24tcmComnet$Day$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tcmComnet$Day$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$To24tcmComnet$Day$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$To24tcmComnet$Day$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$To24tcmComnet$Day$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$To24tcmComnet$Day$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return $elm$core$List$concat(
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				function (ind) {
					return function (product) {
						return A2(
							$elm$core$List$map,
							function (data_day) {
								return A2(
									$elm$core$List$map,
									function (hour) {
										var maybeYodobashiPrice = function () {
											var record = {dw: data_day, mj: hour, kl: product.kl, iw: 7};
											return A2(
												$elm$core$Dict$get,
												$author$project$Pages$Users$To24tcmComnet$Day$gen_dictpricekey(record),
												model.cQ);
										}();
										var lowestPrice = A3(
											$elm$core$List$foldl,
											function (price) {
												return function (m) {
													return A2($elm$core$Basics$min, m, price);
												};
											},
											A2($elm$core$Basics$pow, 2, 30),
											A2(
												$elm$core$List$map,
												function (maybePrice) {
													if (!maybePrice.$) {
														var price = maybePrice.a;
														return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
													} else {
														return A2($elm$core$Basics$pow, 2, 30);
													}
												},
												A2(
													$elm$core$List$map,
													function (store) {
														var record = {dw: data_day, mj: hour, kl: product.kl, iw: store.iw};
														return A2(
															$elm$core$Dict$get,
															$author$project$Pages$Users$To24tcmComnet$Day$gen_dictpricekey(record),
															model.cQ);
													},
													stores)));
										var itemList = _List_fromArray(
											[
												{jP: '税抜き', m: 0},
												{jP: '税込み', m: 1},
												{jP: 'P/クーポン', m: 2},
												{jP: 'P後', m: 3},
												{jP: '取得時刻', m: 4}
											]);
										var filterItemList = function (list) {
											return A2(
												$elm$core$List$map,
												function (i) {
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, i, list));
												},
												A2(
													$elm$core$Maybe$withDefault,
													_Utils_Tuple2(
														'DisplayAll',
														_List_fromArray(
															[0, 1, 2, 3, 4])),
													A2(
														$elm_community$list_extra$List$Extra$find,
														function (dispToValue) {
															return _Utils_eq(dispToValue.a, model.c_);
														},
														$author$project$Pages$Users$To24tcmComnet$Day$displayStyleToValues)).b);
										};
										var filteredItemList = filterItemList(itemList);
										var _v0 = function () {
											var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
											if (_v1.a && (!_v1.b.$)) {
												var yodobashiPrice = _v1.b.a;
												return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
											} else {
												return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
											}
										}();
										var basePrice = _v0.lt;
										var basePriceIncludeTax = _v0.eY;
										var basePoint = _v0.ls;
										var basePriceWithoutPoint = _v0.cb;
										var basePriceList = _List_fromArray(
											[
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePrice)),
												m: 0
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePriceIncludeTax)),
												m: 1
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePoint)),
												m: 2
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePriceWithoutPoint)),
												m: 3
											},
												{
												jP: $elm$core$String$fromInt(hour) + '時',
												m: 4
											}
											]);
										var filteredBasePriceList = filterItemList(basePriceList);
										return _Utils_ap(
											((hour === 9) && (data_day === 'today')) ? _List_fromArray(
												[
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '本日', m: 0}
														]))
												]) : (((hour === 9) && (data_day === 'yesterday')) ? _List_fromArray(
												[
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{
															jP: $elm$core$String$fromInt(ind + 1),
															m: 0
														}
														])),
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: product.nk, m: 0}
														])),
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '昨日', m: 0}
														]))
												]) : _List_fromArray(
												[
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														]))
												])),
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(filteredItemList),
														$author$project$Pages$Users$To24tcmComnet$Day$ProductPriceHeader(filteredBasePriceList)
													]),
												A2(
													$elm$core$List$map,
													function (store) {
														var maybePrice = function () {
															var record = {dw: data_day, mj: hour, kl: product.kl, iw: store.iw};
															return A2(
																$elm$core$Dict$get,
																$author$project$Pages$Users$To24tcmComnet$Day$gen_dictpricekey(record),
																model.cQ);
														}();
														var isLowest = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																return _Utils_eq(price.be, lowestPrice);
															} else {
																return false;
															}
														}();
														var isLowestButHigherThanBase = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
																if (_v6.a && (!_v6.b.$)) {
																	var yodobashiPrice = _v6.b.a;
																	return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
																} else {
																	return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
																}
															} else {
																return false;
															}
														}();
														var isLower = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
																if (_v4.a && (!_v4.b.$)) {
																	var yodobashiPrice = _v4.b.a;
																	return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
																} else {
																	return _Utils_cmp(price.be, product.cb) < 0;
																}
															} else {
																return false;
															}
														}();
														if (!maybePrice.$) {
															var price = maybePrice.a;
															var priceList = _List_fromArray(
																[
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.kg)),
																	m: 0
																},
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.kh)),
																	m: 1
																},
																	{
																	jP: function (point) {
																		return _Utils_ap(
																			point,
																			(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
																	}(
																		$elm$core$String$fromInt(price.ka)),
																	m: 2
																},
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.be)),
																	m: 3
																},
																	{
																	jP: A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		$elm$core$List$head(
																			A2(
																				$elm$core$Maybe$withDefault,
																				_List_Nil,
																				$elm$core$List$tail(
																					A2($elm$core$String$split, ' ', price.lP))))),
																	m: 4
																}
																]);
															var filteredPriceList = filterItemList(priceList);
															return $author$project$Pages$Users$To24tcmComnet$Day$ProductPriceData(
																{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
														} else {
															return $author$project$Pages$Users$To24tcmComnet$Day$ProductPriceNoData;
														}
													},
													stores)));
									},
									_List_fromArray(
										[9, 15]));
							},
							_List_fromArray(
								['yesterday', 'today']));
					};
				},
				products)));
};
var $author$project$Pages$Users$To24tcmComnet$Day$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '日にち', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmComnet$Day$storeGroupDisplayOrder = _List_fromArray(
	[1, 2, 3, 4, 17, 5]);
var $author$project$Pages$Users$To24tcmComnet$Day$sortStoreGroups = function (storeGroups) {
	var displayPosition = function (storeGroupId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$List$length($author$project$Pages$Users$To24tcmComnet$Day$storeGroupDisplayOrder),
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				$elm$core$Basics$eq(storeGroupId),
				$author$project$Pages$Users$To24tcmComnet$Day$storeGroupDisplayOrder));
	};
	return A2(
		$elm$core$List$sortBy,
		function (storeGroup) {
			return _Utils_Tuple2(
				displayPosition(storeGroup.iv),
				storeGroup.iv);
		},
		storeGroups);
};
var $author$project$Pages$Users$To24tcmComnet$Day$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$To24tcmComnet$Day$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$To24tcmComnet$Day$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$To24tcmComnet$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tcmComnet$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to_tmp_2 = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var to_tmp = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											0 * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var to4 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp_2),
										'16:00:00'
									]));
							var to3 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp_2),
										'10:00:00'
									]));
							var to2 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp),
										'16:00:00'
									]));
							var to1 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp),
										'10:00:00'
									]));
							var from_tmp_2 = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var from_tmp = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											0 * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var from4 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp_2),
										'15:00:00'
									]));
							var from3 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp_2),
										'9:00:00'
									]));
							var from2 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp),
										'15:00:00'
									]));
							var from1 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp),
										'9:00:00'
									]));
							var except_id = '(4904530112881, 4904530108839, 4904530108495, 4904530112317, 4904530112348, 4904530112881)';
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$to24tcmComnetEndpoints.fd.jt(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from1', from1),
											A2($elm$url$Url$Builder$string, 'to1', to1),
											A2($elm$url$Url$Builder$string, 'from2', from2),
											A2($elm$url$Url$Builder$string, 'to2', to2),
											A2($elm$url$Url$Builder$string, 'from3', from3),
											A2($elm$url$Url$Builder$string, 'to3', to3),
											A2($elm$url$Url$Builder$string, 'from4', from4),
											A2($elm$url$Url$Builder$string, 'to4', to4),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A2($elm$url$Url$Builder$string, 'exception', except_id)
										])),
								model.C,
								$author$project$Pages$Users$To24tcmComnet$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tcmComnet$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: $author$project$Pages$Users$To24tcmComnet$Day$sortStoreGroups(getPriceResponse.X),
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$To24tcmComnet$Day$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$To24tcmComnet$Day$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$To24tcmComnet$Day$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tcmComnet$Product$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$To24tcmComnet$Product$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tcmComnet$Product$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$To24tcmComnet$Product$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$To24tcmComnet$Product$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$To24tcmComnet$Product$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var priceWithoutPoint = function (price) {
		return price.be - (model.dI ? price.i9 : 0);
	};
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? priceWithoutPoint(price) : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$To24tcmComnet$Product$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {
							ls: yodobashiPrice.ka,
							lt: yodobashiPrice.kg,
							eY: yodobashiPrice.kh,
							cb: priceWithoutPoint(yodobashiPrice)
						};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$To24tcmComnet$Product$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$To24tcmComnet$Product$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$To24tcmComnet$Product$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$To24tcmComnet$Product$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(
										priceWithoutPoint(price),
										lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v6.a && (!_v6.b.$)) {
										var yodobashiPrice = _v6.b.a;
										return isLowest && (_Utils_cmp(
											lowestPrice,
											priceWithoutPoint(yodobashiPrice)) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v4.a && (!_v4.b.$)) {
										var yodobashiPrice = _v4.b.a;
										return _Utils_cmp(
											priceWithoutPoint(price),
											priceWithoutPoint(yodobashiPrice)) < 0;
									} else {
										return _Utils_cmp(
											priceWithoutPoint(price),
											product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(
												priceWithoutPoint(price))),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$To24tcmComnet$Product$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$To24tcmComnet$Product$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$To24tcmComnet$Product$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmComnet$Product$storeGroupDisplayOrder = _List_fromArray(
	[1, 2, 3, 4, 17, 5]);
var $author$project$Pages$Users$To24tcmComnet$Product$sortStoreGroups = function (storeGroups) {
	var displayPosition = function (storeGroupId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$List$length($author$project$Pages$Users$To24tcmComnet$Product$storeGroupDisplayOrder),
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				$elm$core$Basics$eq(storeGroupId),
				$author$project$Pages$Users$To24tcmComnet$Product$storeGroupDisplayOrder));
	};
	return A2(
		$elm$core$List$sortBy,
		function (storeGroup) {
			return _Utils_Tuple2(
				displayPosition(storeGroup.iv),
				storeGroup.iv);
		},
		storeGroups);
};
var $author$project$Pages$Users$To24tcmComnet$Product$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$To24tcmComnet$Product$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$To24tcmComnet$Product$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$To24tcmComnet$Product$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tcmComnet$Product$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$To24tcmComnet$Product$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tcmComnet$Product$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: $author$project$Pages$Users$To24tcmComnet$Product$sortStoreGroups(getPriceResponse.X),
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 15:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 14:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dI: checked}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$To24tcmComnet$Product$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$To24tcmComnet$Product$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$To24tcmComnet$Product$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$csvStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			_List_fromArray(
				['型番', '']),
			$elm$core$List$concat(
				A2(
					$elm$core$List$concatMap,
					function (storeGroup) {
						return A2(
							$elm$core$List$map,
							function (store) {
								return _List_fromArray(
									[store.fh, '価格変動']);
							},
							storeGroup.aN);
					},
					A2(
						$elm$core$List$filter,
						function (storeGroup) {
							return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
						},
						storeGroups))));
	});
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$storeGroupDisplayOrder = _List_fromArray(
	[1, 2, 3, 4, 17, 5]);
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$sortStoreGroups = function (storeGroups) {
	var displayPosition = function (storeGroupId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$List$length($author$project$Pages$Users$To24tcmComnet$TimeSeq$storeGroupDisplayOrder),
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				$elm$core$Basics$eq(storeGroupId),
				$author$project$Pages$Users$To24tcmComnet$TimeSeq$storeGroupDisplayOrder));
	};
	return A2(
		$elm$core$List$sortBy,
		function (storeGroup) {
			return _Utils_Tuple2(
				displayPosition(storeGroup.iv),
				storeGroup.iv);
		},
		storeGroups);
};
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				storeHeader,
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return _Utils_ap(
													A2($elm$core$List$take, 2, lst),
													A2($elm$core$List$drop, 4, lst));
											},
											A2(
												$elm$core$List$map,
												function (lst) {
													return (!(!rowInd)) ? A2($elm$core$List$cons, '', lst) : A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														$elm$core$List$tail(lst));
												},
												A2(
													$elm$core$List$map,
													function (ind) {
														return $elm$core$List$concat(
															A2(
																$elm$core$List$map,
																function (cell) {
																	switch (cell.$) {
																		case 0:
																			var _v1 = cell.a;
																			var data = _v1.b;
																			return $elm$core$List$singleton(
																				A2(
																					$elm$core$Maybe$withDefault,
																					{jP: '', m: -1},
																					A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP);
																		case 1:
																			return _List_fromArray(
																				['', '']);
																		default:
																			var data = cell.a;
																			return function (label) {
																				var annotation = (!ind) ? _Utils_ap(
																					function () {
																						var _v2 = data.du;
																						switch (_v2) {
																							case 0:
																								return '●';
																							case 1:
																								return '※';
																							default:
																								return '';
																						}
																					}(),
																					function () {
																						var _v3 = data.ge;
																						switch (_v3.$) {
																							case 0:
																								return '▲';
																							case 1:
																								return '▼';
																							default:
																								return '';
																						}
																					}()) : '';
																				return _List_fromArray(
																					[label, annotation]);
																			}(
																				A2(
																					$elm$core$Maybe$withDefault,
																					{jP: '', m: -1},
																					A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP);
																	}
																},
																row));
													},
													indices)));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var _v1 = A2($author$project$Pages$Users$Common$TimeSeq$update, msg, model);
				var updatedModel = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						updatedModel,
						{
							X: $author$project$Pages$Users$To24tcmComnet$TimeSeq$sortStoreGroups(updatedModel.X)
						}),
					cmd);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var dateTimePartsFrom = _v2.a.a;
							var dateTimePartsTo = _v2.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											(!_Utils_eq(
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E),
												_List_Nil)) ? A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) : _List_Nil)
										])),
								model.C,
								$author$project$Pages$Users$Common$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$Common$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 12:
				var storeHeader = A2($author$project$Pages$Users$To24tcmComnet$TimeSeq$csvStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Common$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$To24tcmComnet$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return A2($author$project$Pages$Users$Common$TimeSeq$update, msg, model);
		}
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tcmFridge$HourMix$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Utils$Decoders$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$To24tcmFridge$HourMix$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$To24tcmFridge$HourMix$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4},
						{jP: '工事費', m: 5}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$To24tcmFridge$HourMix$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = function () {
					var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
					if (_v1.a && (!_v1.b.$)) {
						var yodobashiPrice = _v1.b.a;
						return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
					} else {
						return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
					}
				}();
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4},
						{jP: '-', m: 5}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v7.a && (!_v7.b.$)) {
										var yodobashiPrice = _v7.b.a;
										return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
									} else {
										return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v5 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v5.a && (!_v5.b.$)) {
										var yodobashiPrice = _v5.b.a;
										return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
									} else {
										return _Utils_cmp(price.be, product.cb) < 0;
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									},
										{
										jP: function () {
											var _v3 = price.lG;
											if (_v3.$ === 1) {
												return '0';
											} else {
												var constructionCost = _v3.a;
												return $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(constructionCost));
											}
										}(),
										m: 5
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceData(
									{hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$To24tcmFridge$HourMix$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4, 5])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$To24tcmFridge$HourMix$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:00'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$to24tcmFridgeEndpoints.ml.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'stores',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)))
										])),
								model.C,
								$author$project$Pages$Users$To24tcmFridge$HourMix$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tcmFridge$HourMix$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 14:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedBigCategory,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.e_),
								selectedBigCategory);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return _Utils_eq(
								selectedSmallCategoryId,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								$elm$core$Maybe$Just(p.ir),
								selectedSmallCategoryId);
						},
						model.c1));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									filteredProducts),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.S);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				var newSelectedMakers = A2(
					$elm$core$List$filterMap,
					$elm$core$String$toInt,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$first,
						$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(subModel)));
				var filteredProducts = A2(
					$elm$core$List$filter,
					function (p) {
						return _Utils_eq(
							model.ig,
							$elm$core$Maybe$Just(-1)) || _Utils_eq(
							$elm$core$Maybe$Just(p.e_),
							model.ig);
					},
					A2(
						$elm$core$List$filter,
						function (p) {
							return $elm$core$List$isEmpty(newSelectedMakers) || A2($elm$core$List$member, p.jW, newSelectedMakers);
						},
						model.c1));
				var newMultiselectProducts = A3(
					$inkuzmin$elm_multiselect$Multiselect$populateValues,
					model.E,
					A2(
						$elm$core$List$map,
						function (p) {
							return _Utils_Tuple2(p.kl, p.nk);
						},
						filteredProducts),
					_List_Nil);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{S: subModel, E: newMultiselectProducts}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeMaker, subCmd));
			case 6:
				var sub = msg.a;
				var _v3 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v3.a;
				var subCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeProduct, subCmd));
			case 7:
				var sub = msg.a;
				var _v4 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.p);
				var subModel = _v4.a;
				var subCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p: subModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeStore, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					var filteredProducts = A2(
						$elm$core$List$filter,
						function (product) {
							return product.nk !== 'blank';
						},
						initResponse.kn);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								S: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.S,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.jW),
												s.mH);
										},
										initResponse.cE),
									_List_Nil),
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								p: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.p,
									A2(
										$elm$core$List$map,
										function (s) {
											return _Utils_Tuple2(
												$elm$core$String$fromInt(s.iw),
												s.kS);
										},
										initResponse.b$),
									_List_Nil),
								c1: filteredProducts,
								io: initResponse.b$,
								kL: initResponse.kL,
								b$: initResponse.b$
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 17:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 13:
				var storeHeader = A2($author$project$Pages$Users$To24tcmFridge$HourMix$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$To24tcmFridge$HourMix$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$To24tcmFridge$HourMix$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$DictPriceRecord = F4(
	function (productId, storeId, hour, data_day) {
		return {dw: data_day, mj: hour, kl: productId, iw: storeId};
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$gen_dictpricekey = function (record) {
	return _Utils_ap(
		record.kl,
		_Utils_ap(
			$elm$core$String$fromInt(record.iw),
			_Utils_ap(
				$elm$core$String$fromInt(record.mj),
				record.dw)));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Pages$Users$To24tcmKitchen$Day$gen_dictpricekey,
				A5(
					$elm$json$Json$Decode$map4,
					$author$project$Pages$Users$To24tcmKitchen$Day$DictPriceRecord,
					A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
					A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'hour', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'data_day', $elm$json$Json$Decode$string)))),
		$elm$json$Json$Decode$list($author$project$Utils$Decoders$priceDecoder)));
var $author$project$Pages$Users$To24tcmKitchen$Day$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$To24tcmKitchen$Day$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$To24tcmKitchen$Day$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$To24tcmKitchen$Day$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$To24tcmKitchen$Day$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return $elm$core$List$concat(
		$elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				function (ind) {
					return function (product) {
						return A2(
							$elm$core$List$map,
							function (data_day) {
								return A2(
									$elm$core$List$map,
									function (hour) {
										var maybeYodobashiPrice = function () {
											var record = {dw: data_day, mj: hour, kl: product.kl, iw: 7};
											return A2(
												$elm$core$Dict$get,
												$author$project$Pages$Users$To24tcmKitchen$Day$gen_dictpricekey(record),
												model.cQ);
										}();
										var lowestPrice = A3(
											$elm$core$List$foldl,
											function (price) {
												return function (m) {
													return A2($elm$core$Basics$min, m, price);
												};
											},
											A2($elm$core$Basics$pow, 2, 30),
											A2(
												$elm$core$List$map,
												function (maybePrice) {
													if (!maybePrice.$) {
														var price = maybePrice.a;
														return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
													} else {
														return A2($elm$core$Basics$pow, 2, 30);
													}
												},
												A2(
													$elm$core$List$map,
													function (store) {
														var record = {dw: data_day, mj: hour, kl: product.kl, iw: store.iw};
														return A2(
															$elm$core$Dict$get,
															$author$project$Pages$Users$To24tcmKitchen$Day$gen_dictpricekey(record),
															model.cQ);
													},
													stores)));
										var itemList = _List_fromArray(
											[
												{jP: '税抜き', m: 0},
												{jP: '税込み', m: 1},
												{jP: 'P/クーポン', m: 2},
												{jP: 'P後', m: 3},
												{jP: '取得時刻', m: 4}
											]);
										var filterItemList = function (list) {
											return A2(
												$elm$core$List$map,
												function (i) {
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, i, list));
												},
												A2(
													$elm$core$Maybe$withDefault,
													_Utils_Tuple2(
														'DisplayAll',
														_List_fromArray(
															[0, 1, 2, 3, 4])),
													A2(
														$elm_community$list_extra$List$Extra$find,
														function (dispToValue) {
															return _Utils_eq(dispToValue.a, model.c_);
														},
														$author$project$Pages$Users$To24tcmKitchen$Day$displayStyleToValues)).b);
										};
										var filteredItemList = filterItemList(itemList);
										var _v0 = function () {
											var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
											if (_v1.a && (!_v1.b.$)) {
												var yodobashiPrice = _v1.b.a;
												return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
											} else {
												return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
											}
										}();
										var basePrice = _v0.lt;
										var basePriceIncludeTax = _v0.eY;
										var basePoint = _v0.ls;
										var basePriceWithoutPoint = _v0.cb;
										var basePriceList = _List_fromArray(
											[
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePrice)),
												m: 0
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePriceIncludeTax)),
												m: 1
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePoint)),
												m: 2
											},
												{
												jP: $author$project$Utils$Helpers$toCommmaSplited(
													$elm$core$String$fromInt(basePriceWithoutPoint)),
												m: 3
											},
												{
												jP: $elm$core$String$fromInt(hour) + '時',
												m: 4
											}
											]);
										var filteredBasePriceList = filterItemList(basePriceList);
										return _Utils_ap(
											((hour === 9) && (data_day === 'today')) ? _List_fromArray(
												[
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '本日', m: 0}
														]))
												]) : (((hour === 9) && (data_day === 'yesterday')) ? _List_fromArray(
												[
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{
															jP: $elm$core$String$fromInt(ind + 1),
															m: 0
														}
														])),
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: product.nk, m: 0}
														])),
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '昨日', m: 0}
														]))
												]) : _List_fromArray(
												[
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														])),
													$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(
													_List_fromArray(
														[
															{jP: '', m: 0}
														]))
												])),
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(filteredItemList),
														$author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceHeader(filteredBasePriceList)
													]),
												A2(
													$elm$core$List$map,
													function (store) {
														var maybePrice = function () {
															var record = {dw: data_day, mj: hour, kl: product.kl, iw: store.iw};
															return A2(
																$elm$core$Dict$get,
																$author$project$Pages$Users$To24tcmKitchen$Day$gen_dictpricekey(record),
																model.cQ);
														}();
														var isLowest = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																return _Utils_eq(price.be, lowestPrice);
															} else {
																return false;
															}
														}();
														var isLowestButHigherThanBase = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																var _v6 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
																if (_v6.a && (!_v6.b.$)) {
																	var yodobashiPrice = _v6.b.a;
																	return isLowest && (_Utils_cmp(lowestPrice, yodobashiPrice.be) > -1);
																} else {
																	return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
																}
															} else {
																return false;
															}
														}();
														var isLower = function () {
															if (!maybePrice.$) {
																var price = maybePrice.a;
																var _v4 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
																if (_v4.a && (!_v4.b.$)) {
																	var yodobashiPrice = _v4.b.a;
																	return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
																} else {
																	return _Utils_cmp(price.be, product.cb) < 0;
																}
															} else {
																return false;
															}
														}();
														if (!maybePrice.$) {
															var price = maybePrice.a;
															var priceList = _List_fromArray(
																[
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.kg)),
																	m: 0
																},
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.kh)),
																	m: 1
																},
																	{
																	jP: function (point) {
																		return _Utils_ap(
																			point,
																			(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
																	}(
																		$elm$core$String$fromInt(price.ka)),
																	m: 2
																},
																	{
																	jP: $author$project$Utils$Helpers$toCommmaSplited(
																		$elm$core$String$fromInt(price.be)),
																	m: 3
																},
																	{
																	jP: A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		$elm$core$List$head(
																			A2(
																				$elm$core$Maybe$withDefault,
																				_List_Nil,
																				$elm$core$List$tail(
																					A2($elm$core$String$split, ' ', price.lP))))),
																	m: 4
																}
																]);
															var filteredPriceList = filterItemList(priceList);
															return $author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceData(
																{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
														} else {
															return $author$project$Pages$Users$To24tcmKitchen$Day$ProductPriceNoData;
														}
													},
													stores)));
									},
									_List_fromArray(
										[9, 15]));
							},
							_List_fromArray(
								['yesterday', 'today']));
					};
				},
				products)));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '日にち', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$To24tcmKitchen$Day$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$To24tcmKitchen$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tcmKitchen$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to_tmp_2 = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var to_tmp = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											0 * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var to4 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp_2),
										'16:00:00'
									]));
							var to3 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp_2),
										'10:00:00'
									]));
							var to2 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp),
										'16:00:00'
									]));
							var to1 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, to_tmp),
										'10:00:00'
									]));
							var from_tmp_2 = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var from_tmp = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											0 * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							var from4 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp_2),
										'15:00:00'
									]));
							var from3 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp_2),
										'9:00:00'
									]));
							var from2 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp),
										'15:00:00'
									]));
							var from1 = $elm$core$String$concat(
								_List_fromArray(
									[
										A3($elm$core$String$slice, 0, 11, from_tmp),
										'9:00:00'
									]));
							var except_id = '';
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$to24tcmComnetEndpoints.fd.jt(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from1', from1),
											A2($elm$url$Url$Builder$string, 'to1', to1),
											A2($elm$url$Url$Builder$string, 'from2', from2),
											A2($elm$url$Url$Builder$string, 'to2', to2),
											A2($elm$url$Url$Builder$string, 'from3', from3),
											A2($elm$url$Url$Builder$string, 'to3', to3),
											A2($elm$url$Url$Builder$string, 'from4', from4),
											A2($elm$url$Url$Builder$string, 'to4', to4),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A2($elm$url$Url$Builder$string, 'exception', except_id)
										])),
								model.C,
								$author$project$Pages$Users$To24tcmKitchen$Day$getPriceResponseDecoder,
								$author$project$Pages$Users$To24tcmKitchen$Day$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$To24tcmKitchen$Day$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$To24tcmKitchen$Day$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$To24tcmKitchen$Day$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$TsBat$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$TsBat$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$TsBat$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$TsBat$TimeSeq$Price))))))))))));
var $author$project$Pages$Users$TsBat$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$TsBat$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$TsBat$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$TsBat$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$TsBat$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TsBat$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$Lower = 1;
var $author$project$Pages$Users$TsBat$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$TsBat$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$TsBat$TimeSeq$Normal = 3;
var $author$project$Pages$Users$TsBat$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$TsBat$TimeSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$TsBat$TimeSeq$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Users$TsBat$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nthList = $elm$core$Set$toList(
		$elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function (_v12) {
					var nth = _v12.c;
					return nth;
				},
				$elm$core$Dict$keys(model.cQ))));
	var nOfRows = $elm$core$List$length(nthList);
	var firstNth = A2(
		$elm$core$Maybe$withDefault,
		1,
		$elm$core$List$minimum(nthList));
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$TsBat$TimeSeq$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							_Utils_eq(nth, firstNth) ? _List_fromArray(
								[
									$author$project$Pages$Users$TsBat$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$TsBat$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$TsBat$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$TsBat$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$TsBat$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = function () {
											var _v10 = A2(
												$elm$core$Dict$get,
												_Utils_Tuple3(product.kl, store.iw, nth - 1),
												model.cQ);
											if (!_v10.$) {
												var prevPrice = _v10.a;
												return $elm$core$Maybe$Just(prevPrice);
											} else {
												return A2(
													$elm$core$Dict$get,
													_Utils_Tuple3(product.kl, store.iw, nth - 3),
													model.cQ);
											}
										}();
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$TsBat$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$TsBat$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$TsBat$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$TsBat$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$TsBat$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$TsBat$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					nthList);
			};
		},
		products);
};
var $author$project$Pages$Users$TsBat$TimeSeq$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TsBat$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$TsBat$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$TsBat$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$TsBat$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$TsBat$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 12:
				var storeHeader = A2($author$project$Pages$Users$TsBat$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$TsBat$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$TsBat$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$TsBat$Wide$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$TsBat$Wide$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$TsBat$Wide$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$TsBat$Wide$Price))))))))))));
var $author$project$Pages$Users$TsBat$Wide$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$TsBat$Wide$priceDecoder)));
var $author$project$Pages$Users$TsBat$Wide$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$TsBat$Wide$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$TsBat$Wide$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TsBat$Wide$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$Lower = 1;
var $author$project$Pages$Users$TsBat$Wide$Lowest = 0;
var $author$project$Pages$Users$TsBat$Wide$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$TsBat$Wide$Normal = 3;
var $author$project$Pages$Users$TsBat$Wide$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$TsBat$Wide$Unchanged = {$: 2};
var $author$project$Pages$Users$TsBat$Wide$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$TsBat$Wide$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nthList = $elm$core$Set$toList(
		$elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				function (_v12) {
					var nth = _v12.c;
					return nth;
				},
				$elm$core$Dict$keys(model.cQ))));
	var nOfRows = $elm$core$List$length(nthList);
	var firstNth = A2(
		$elm$core$Maybe$withDefault,
		1,
		$elm$core$List$minimum(nthList));
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$TsBat$Wide$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							_Utils_eq(nth, firstNth) ? _List_fromArray(
								[
									$author$project$Pages$Users$TsBat$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$TsBat$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$TsBat$Wide$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$TsBat$Wide$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$TsBat$Wide$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = function () {
											var _v10 = A2(
												$elm$core$Dict$get,
												_Utils_Tuple3(product.kl, store.iw, nth - 1),
												model.cQ);
											if (!_v10.$) {
												var prevPrice = _v10.a;
												return $elm$core$Maybe$Just(prevPrice);
											} else {
												return A2(
													$elm$core$Dict$get,
													_Utils_Tuple3(product.kl, store.iw, nth - 3),
													model.cQ);
											}
										}();
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$TsBat$Wide$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$TsBat$Wide$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$TsBat$Wide$Unchanged);
											} else {
												return $author$project$Pages$Users$TsBat$Wide$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$TsBat$Wide$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$TsBat$Wide$ProductPriceNoData;
										}
									},
									stores)));
					},
					nthList);
			};
		},
		products);
};
var $author$project$Pages$Users$TsBat$Wide$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TsBat$Wide$succDate = function (dateString) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(dateString);
	if (!_v0.$) {
		var date = _v0.a;
		return $justinmimbs$date$Date$toIsoString(
			A3($justinmimbs$date$Date$add, 3, 1, date));
	} else {
		return dateString;
	}
};
var $author$project$Pages$Users$TsBat$Wide$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										var top_ind = function () {
											var _v6 = A2($elm_community$list_extra$List$Extra$getAt, 0, indices);
											if (!_v6.$) {
												var x = _v6.a;
												return x;
											} else {
												return 0;
											}
										}();
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		var res = function () {
																			var _v2 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return (_Utils_eq(ind, top_ind) && _Utils_eq(item.m, -1)) || _Utils_eq(item.m, ind);
																				},
																				data);
																			if (!_v2.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v2.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var res = function () {
																			var _v3 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return _Utils_eq(item.m, ind);
																				},
																				data.h6);
																			if (!_v3.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v3.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v5 = data.du;
																		switch (_v5) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$TsBat$Wide$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date, cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:00'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$TsBat$Wide$getPriceResponseDecoder,
								$author$project$Pages$Users$TsBat$Wide$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				var bigCategoryId = msg.a;
				var selectedBigCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategoryId);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var makerId = msg.a;
				var selectedMakerId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A4($author$project$Utils$Helpers$filterBySelector, selectedMakerId, model.ig, model.gD, model.c1)),
								_List_Nil),
							eh: selectedMakerId
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$TsBat$Wide$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: $author$project$Pages$Users$TsBat$Wide$succDate(model.cY),
								et: '00:00',
								gQ: '00:00',
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 9:
				var storeHeader = A2($author$project$Pages$Users$TsBat$Wide$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$TsBat$Wide$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$TsBat$Wide$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$TstComnet$TimeSeq$Price))))))))))));
var $author$project$Pages$Users$TstComnet$TimeSeq$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$TstComnet$TimeSeq$priceDecoder)));
var $author$project$Pages$Users$TstComnet$TimeSeq$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$TstComnet$TimeSeq$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$TstComnet$TimeSeq$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TstComnet$TimeSeq$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$Lower = 1;
var $author$project$Pages$Users$TstComnet$TimeSeq$Lowest = 0;
var $author$project$Pages$Users$TstComnet$TimeSeq$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$TstComnet$TimeSeq$Normal = 3;
var $author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$TstComnet$TimeSeq$Unchanged = {$: 2};
var $author$project$Pages$Users$TstComnet$TimeSeq$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$TstComnet$TimeSeq$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$TstComnet$TimeSeq$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$TstComnet$TimeSeq$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$TstComnet$TimeSeq$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$TstComnet$TimeSeq$Unchanged);
											} else {
												return $author$project$Pages$Users$TstComnet$TimeSeq$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$TstComnet$TimeSeq$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$TstComnet$TimeSeq$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		return A2(
																			$elm$core$Maybe$withDefault,
																			{jP: '', m: -1},
																			A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v3 = data.du;
																		switch (_v3) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{il: time}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: time}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, model.il),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, model.im));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$TstComnet$TimeSeq$getPriceResponseDecoder,
								$author$project$Pages$Users$TstComnet$TimeSeq$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 13:
				var bigCategoryId = msg.a;
				var selectedBigCategory = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategory,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategory);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategory
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$TstComnet$TimeSeq$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: model.cZ,
								et: model.il,
								gQ: model.im,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 16:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 12:
				var storeHeader = A2($author$project$Pages$Users$TstComnet$TimeSeq$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$TstComnet$TimeSeq$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$TstComnet$TimeSeq$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$TstComnet$Wide$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$TstComnet$Wide$Price = function (productId) {
	return function (storeId) {
		return function (nth) {
			return function (dateTime) {
				return function (price) {
					return function (priceIncludeTax) {
						return function (point) {
							return function (priceWithoutPoint) {
								return function (coupon) {
									return function (url) {
										return function (constructionCost) {
											return {lG: constructionCost, i9: coupon, lP: dateTime, mV: nth, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$TstComnet$Wide$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'construction_cost',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Pages$Users$TstComnet$Wide$Price))))))))))));
var $author$project$Pages$Users$TstComnet$Wide$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				F3(
					function (a, b, c) {
						return _Utils_Tuple3(a, b, c);
					}),
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'nth', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$TstComnet$Wide$priceDecoder)));
var $author$project$Pages$Users$TstComnet$Wide$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$TstComnet$Wide$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$TstComnet$Wide$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Utils$Decoders$productsDecoder));
var $author$project$Pages$Users$TstComnet$Wide$Decreased = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$Increased = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$Lower = 1;
var $author$project$Pages$Users$TstComnet$Wide$Lowest = 0;
var $author$project$Pages$Users$TstComnet$Wide$LowestButHigherThanBasePrice = 2;
var $author$project$Pages$Users$TstComnet$Wide$Normal = 3;
var $author$project$Pages$Users$TstComnet$Wide$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$TstComnet$Wide$Unchanged = {$: 2};
var $author$project$Pages$Users$TstComnet$Wide$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4, 5])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$TstComnet$Wide$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	var nOfRows = function () {
		var _v11 = _Utils_Tuple2(
			A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et),
			A2($author$project$Utils$Helpers$dateTimeToParts, model.gP, model.gQ));
		if ((!_v11.a.$) && (!_v11.b.$)) {
			var dateTimePartsFrom = _v11.a.a;
			var dateTimePartsTo = _v11.b.a;
			var diff = A4(
				$justinmimbs$time_extra$Time$Extra$diff,
				13,
				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsFrom),
				A2(
					$justinmimbs$time_extra$Time$Extra$partsToPosix,
					$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
					dateTimePartsTo));
			return (diff / model.ac) | 0;
		} else {
			return 1;
		}
	}();
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				return A2(
					$elm$core$List$map,
					function (nth) {
						var maybeYodobashiPrice = A2(
							$elm$core$Dict$get,
							_Utils_Tuple3(product.kl, 7, nth),
							model.cQ);
						var lowestPrice = A3(
							$elm$core$List$foldl,
							function (price) {
								return function (m) {
									return A2($elm$core$Basics$min, m, price);
								};
							},
							A2($elm$core$Basics$pow, 2, 30),
							A2(
								$elm$core$List$map,
								function (maybePrice) {
									if (!maybePrice.$) {
										var price = maybePrice.a;
										return price.be;
									} else {
										return A2($elm$core$Basics$pow, 2, 30);
									}
								},
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
									},
									stores)));
						var itemList = _List_fromArray(
							[
								{jP: '税抜き', m: 0},
								{jP: '税込み', m: 1},
								{jP: 'P/クーポン', m: 2},
								{jP: 'P後', m: 3},
								{jP: '取得時刻', m: 4},
								{jP: '工事費', m: 5}
							]);
						var filterItemList = function (list) {
							return A2(
								$elm$core$Tuple$pair,
								1,
								A2(
									$elm$core$List$map,
									function (i) {
										return A2(
											$elm$core$Maybe$withDefault,
											{jP: '', m: -1},
											A2($elm_community$list_extra$List$Extra$getAt, i, list));
									},
									A2(
										$elm$core$Maybe$withDefault,
										_Utils_Tuple2(
											'DisplayAll',
											_List_fromArray(
												[0, 1, 2, 3, 4, 5])),
										A2(
											$elm_community$list_extra$List$Extra$find,
											function (dispToValue) {
												return _Utils_eq(dispToValue.a, model.c_);
											},
											$author$project$Pages$Users$TstComnet$Wide$displayStyleToValues)).b));
						};
						var filteredItemList = filterItemList(itemList);
						var _v0 = function () {
							var _v1 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
							if (_v1.a && (!_v1.b.$)) {
								var yodobashiPrice = _v1.b.a;
								return {ls: yodobashiPrice.ka, lt: yodobashiPrice.kg, eY: yodobashiPrice.kh, cb: yodobashiPrice.be};
							} else {
								return {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
							}
						}();
						var basePrice = _v0.lt;
						var basePriceIncludeTax = _v0.eY;
						var basePoint = _v0.ls;
						var basePriceWithoutPoint = _v0.cb;
						var basePriceList = _List_fromArray(
							[
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePrice)),
								m: 0
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceIncludeTax)),
								m: 1
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePoint)),
								m: 2
							},
								{
								jP: $author$project$Utils$Helpers$toCommmaSplited(
									$elm$core$String$fromInt(basePriceWithoutPoint)),
								m: 3
							},
								{jP: '-', m: 4},
								{jP: '-', m: 5}
							]);
						var filteredBasePriceList = filterItemList(basePriceList);
						return _Utils_ap(
							(nth === 1) ? _List_fromArray(
								[
									$author$project$Pages$Users$TstComnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{
												jP: $elm$core$String$fromInt(ind + 1),
												m: -1
											}
											]))),
									$author$project$Pages$Users$TstComnet$Wide$ProductPriceHeader(
									_Utils_Tuple2(
										nOfRows,
										_List_fromArray(
											[
												{jP: product.nk, m: -1}
											])))
								]) : _List_Nil,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Pages$Users$TstComnet$Wide$ProductPriceHeader(
										_Utils_Tuple2(
											1,
											_List_fromArray(
												[
													{
													jP: function () {
														var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
														var date = function () {
															if (!datetimeParts.$) {
																var part = datetimeParts.a;
																return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
																	A2(
																		$justinmimbs$time_extra$Time$Extra$posixToParts,
																		$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																		A4(
																			$justinmimbs$time_extra$Time$Extra$add,
																			13,
																			(nth - 1) * model.ac,
																			$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																			A2(
																				$justinmimbs$time_extra$Time$Extra$partsToPosix,
																				$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
																				part))));
															} else {
																return '';
															}
														}();
														return date;
													}(),
													m: -1
												}
												]))),
										$author$project$Pages$Users$TstComnet$Wide$ProductPriceHeader(filteredItemList),
										$author$project$Pages$Users$TstComnet$Wide$ProductPriceHeader(filteredBasePriceList)
									]),
								A2(
									$elm$core$List$map,
									function (store) {
										var maybePrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth),
											model.cQ);
										var maybePrevPrice = A2(
											$elm$core$Dict$get,
											_Utils_Tuple3(product.kl, store.iw, nth - 1),
											model.cQ);
										var priceChangingType = function () {
											var _v9 = _Utils_Tuple2(maybePrice, maybePrevPrice);
											if ((!_v9.a.$) && (!_v9.b.$)) {
												var currentPrice = _v9.a.a;
												var prevPrice = _v9.b.a;
												return (_Utils_cmp(currentPrice.be, prevPrice.be) > 0) ? $author$project$Pages$Users$TstComnet$Wide$Increased(currentPrice.be - prevPrice.be) : ((_Utils_cmp(currentPrice.be, prevPrice.be) < 0) ? $author$project$Pages$Users$TstComnet$Wide$Decreased(prevPrice.be - currentPrice.be) : $author$project$Pages$Users$TstComnet$Wide$Unchanged);
											} else {
												return $author$project$Pages$Users$TstComnet$Wide$Unchanged;
											}
										}();
										var isLowest = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												return _Utils_eq(price.be, lowestPrice);
											} else {
												return false;
											}
										}();
										var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
										var isLower = function () {
											if (!maybePrice.$) {
												var price = maybePrice.a;
												var _v7 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
												if (_v7.a && (!_v7.b.$)) {
													var yodobashiPrice = _v7.b.a;
													return _Utils_cmp(price.be, yodobashiPrice.be) < 0;
												} else {
													return _Utils_cmp(price.be, product.cb) < 0;
												}
											} else {
												return false;
											}
										}();
										var comparedPriceType = function () {
											var _v5 = _Utils_Tuple3(isLowest, isLowestButHigherThanBase, isLower);
											if (_v5.a) {
												return 0;
											} else {
												if (_v5.b) {
													return 2;
												} else {
													if (_v5.c) {
														return 1;
													} else {
														return 3;
													}
												}
											}
										}();
										if (!maybePrice.$) {
											var price = maybePrice.a;
											var priceList = _List_fromArray(
												[
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kg)),
													m: 0
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.kh)),
													m: 1
												},
													{
													jP: function (point) {
														return _Utils_ap(
															point,
															(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
													}(
														$elm$core$String$fromInt(price.ka)),
													m: 2
												},
													{
													jP: $author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price.be)),
													m: 3
												},
													{
													jP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$elm$core$List$head(
															A2(
																$elm$core$Maybe$withDefault,
																_List_Nil,
																$elm$core$List$tail(
																	A2($elm$core$String$split, ' ', price.lP))))),
													m: 4
												},
													{
													jP: function () {
														var _v4 = price.lG;
														if (_v4.$ === 1) {
															return '0';
														} else {
															var constructionCost = _v4.a;
															return $author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(constructionCost));
														}
													}(),
													m: 5
												}
												]);
											var filteredPriceList = filterItemList(priceList).b;
											return $author$project$Pages$Users$TstComnet$Wide$ProductPriceData(
												{du: comparedPriceType, ge: priceChangingType, h6: filteredPriceList, eD: price.eD});
										} else {
											return $author$project$Pages$Users$TstComnet$Wide$ProductPriceNoData;
										}
									},
									stores)));
					},
					A2($elm$core$List$range, 1, nOfRows));
			};
		},
		products);
};
var $author$project$Pages$Users$TstComnet$Wide$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['', '型番', '時刻', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TstComnet$Wide$succDate = function (dateString) {
	var _v0 = $justinmimbs$date$Date$fromIsoString(dateString);
	if (!_v0.$) {
		var date = _v0.a;
		return $justinmimbs$date$Date$toIsoString(
			A3($justinmimbs$date$Date$add, 3, 1, date));
	} else {
		return dateString;
	}
};
var $author$project$Pages$Users$TstComnet$Wide$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (priceRow) {
						return $elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (rowInd) {
									return function (row) {
										var indices = A2(
											$elm$core$Maybe$withDefault,
											_Utils_Tuple2(
												'DisplayAll',
												_List_fromArray(
													[0, 1, 2, 3, 4, 5])),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (dispToValue) {
													return _Utils_eq(dispToValue.a, selectedDisplayStyle);
												},
												$author$project$Utils$Helpers$displayStyleToValues)).b;
										var top_ind = function () {
											var _v6 = A2($elm_community$list_extra$List$Extra$getAt, 0, indices);
											if (!_v6.$) {
												var x = _v6.a;
												return x;
											} else {
												return 0;
											}
										}();
										return A2(
											$elm$core$List$map,
											function (lst) {
												return (!(!rowInd)) ? _Utils_ap(
													_List_fromArray(
														['', '']),
													lst) : lst;
											},
											_Utils_ap(
												A2(
													$elm$core$List$map,
													function (ind) {
														return A2(
															$elm$core$List$map,
															function (cell) {
																switch (cell.$) {
																	case 0:
																		var _v1 = cell.a;
																		var data = _v1.b;
																		var res = function () {
																			var _v2 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return (_Utils_eq(ind, top_ind) && _Utils_eq(item.m, -1)) || _Utils_eq(item.m, ind);
																				},
																				data);
																			if (!_v2.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v2.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var res = function () {
																			var _v3 = A2(
																				$elm$core$List$filter,
																				function (item) {
																					return _Utils_eq(item.m, ind);
																				},
																				data.h6);
																			if (!_v3.b) {
																				return $elm$core$Maybe$Nothing;
																			} else {
																				var x = _v3.a;
																				return $elm$core$Maybe$Just(x.jP);
																			}
																		}();
																		return A2($elm$core$Maybe$withDefault, '', res);
																}
															},
															row);
													},
													indices),
												_List_fromArray(
													[
														A2(
														$elm$core$List$indexedMap,
														function (ind) {
															return function (cell) {
																var fixedInd = (!(!rowInd)) ? (ind + 2) : ind;
																switch (cell.$) {
																	case 0:
																		return (fixedInd === 3) ? '最低● 基準※' : '';
																	case 1:
																		return '';
																	default:
																		var data = cell.a;
																		var _v5 = data.du;
																		switch (_v5) {
																			case 0:
																				return '●';
																			case 1:
																				return '※';
																			default:
																				return '';
																		}
																}
															};
														},
														row)
													])));
									};
								},
								priceRow));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$TstComnet$Wide$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cY: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							cZ: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							il: A2($author$project$Utils$Helpers$formatTime, 0, 0),
							im: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cY: date, cZ: date}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = _Utils_Tuple2(
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cY, '00:00'),
							A2($author$project$Utils$Helpers$dateTimeToParts, model.cZ, '23:00'));
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var dateTimePartsFrom = _v1.a.a;
							var dateTimePartsTo = _v1.b.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimePartsTo);
							var from = $author$project$Utils$Helpers$formatDateTime(dateTimePartsFrom);
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$timeSeqEndpoints.g(
									_List_fromArray(
										[
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'from', from),
											A2($Herteby$url_builder_plus$UrlBuilderPlus$string, 'to', to),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh))),
											A3(
											$Herteby$url_builder_plus$UrlBuilderPlus$list,
											$Herteby$url_builder_plus$UrlBuilderPlus$string,
											'products',
											A2(
												$elm$core$List$map,
												$elm$core$Tuple$first,
												$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)))
										])),
								model.C,
								$author$project$Pages$Users$TstComnet$Wide$getPriceResponseDecoder,
								$author$project$Pages$Users$TstComnet$Wide$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 10:
				var bigCategoryId = msg.a;
				var selectedBigCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(bigCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedBigCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.e_),
												selectedBigCategoryId);
										},
										model.c1)),
								_List_Nil),
							ig: selectedBigCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var smallCategoryId = msg.a;
				var selectedSmallCategoryId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(smallCategoryId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A2(
										$elm$core$List$filter,
										function (p) {
											return _Utils_eq(
												selectedSmallCategoryId,
												$elm$core$Maybe$Just(-1)) || _Utils_eq(
												$elm$core$Maybe$Just(p.ir),
												selectedSmallCategoryId);
										},
										model.c1)),
								_List_Nil),
							gD: selectedSmallCategoryId
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var makerId = msg.a;
				var selectedMakerId = A2(
					$elm$core$Maybe$andThen,
					$elm$core$Maybe$Just,
					$elm$core$String$toInt(makerId));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: A3(
								$inkuzmin$elm_multiselect$Multiselect$populateValues,
								model.E,
								A2(
									$elm$core$List$map,
									function (p) {
										return _Utils_Tuple2(p.kl, p.nk);
									},
									A4($author$project$Utils$Helpers$filterBySelector, selectedMakerId, model.ig, model.gD, model.c1)),
								_List_Nil),
							eh: selectedMakerId
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var sub = msg.a;
				var _v2 = A2($inkuzmin$elm_multiselect$Multiselect$update, sub, model.E);
				var subModel = _v2.a;
				var subCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E: subModel, ha: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Users$TstComnet$Wide$OnChangeProduct, subCmd));
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								iW: initResponse.iW,
								H: $elm$core$Maybe$Nothing,
								cv: false,
								cE: initResponse.cE,
								E: A3(
									$inkuzmin$elm_multiselect$Multiselect$populateValues,
									model.E,
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_Tuple2(p.kl, p.nk);
										},
										initResponse.kn),
									_List_Nil),
								c1: initResponse.kn,
								kL: initResponse.kL
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								es: model.cY,
								gP: $author$project$Pages$Users$TstComnet$Wide$succDate(model.cY),
								et: '00:00',
								gQ: '00:00',
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L,
								ha: false
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 13:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 9:
				var storeHeader = A2($author$project$Pages$Users$TstComnet$Wide$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$TstComnet$Wide$pProductPriceRows(model);
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$TstComnet$Wide$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, 'data.csv', 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$UpdateProductRequestSent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$Constants$tax = 10;
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateOrder = F3(
	function (ind, model, newOrd) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = _Utils_update(
				product,
				{nl: newOrd});
			var maybeNewOrdProductInd = A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var maybeNewOrdProduct = A2(
				$elm_community$list_extra$List$Extra$find,
				function (p) {
					return _Utils_eq(p.nl, newOrd);
				},
				model.kn);
			var newProducts = function () {
				var _v1 = _Utils_Tuple2(maybeNewOrdProduct, maybeNewOrdProductInd);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var newOrdProduct = _v1.a.a;
					var newOrdProductInd = _v1.b.a;
					var newOrdProduct_ = _Utils_update(
						newOrdProduct,
						{nl: product.nl});
					return A3(
						$elm_community$list_extra$List$Extra$setAt,
						newOrdProductInd,
						newOrdProduct_,
						A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn));
				} else {
					return A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
				}
			}();
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProduct = F3(
	function (ind, model, f) {
		var maybeCorrespondingProduct = A2($elm_community$list_extra$List$Extra$getAt, ind, model.kn);
		if (!maybeCorrespondingProduct.$) {
			var product = maybeCorrespondingProduct.a;
			var newProduct = f(product);
			var newProducts = A3($elm_community$list_extra$List$Extra$setAt, ind, newProduct, model.kn);
			return _Utils_update(
				model,
				{kn: newProducts});
		} else {
			return model;
		}
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$UpdateProductResponse = function (succeeded) {
	return {nO: succeeded};
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProductResponseDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Pages$Users$Tv24Comnet$ChangeProduct$UpdateProductResponse,
	A2($elm$json$Json$Decode$field, 'succeeded', $elm$json$Json$Decode$bool));
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var initResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: false, kn: initResponse.kn}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 1:
				if (!msg.a.$) {
					var updateProductResponse = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: false}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(err)),
								k: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							lt: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 3:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ec: $elm$core$String$toInt(val)
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 5:
				var ind = msg.a;
				var newOrder = msg.b;
				return _Utils_Tuple2(
					A3(
						$author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateOrder,
						ind,
						model,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(newOrder))),
					$elm$core$Platform$Cmd$none);
			case 4:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{
							ls: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(val))
						});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 6:
				var ind = msg.a;
				var val = msg.b;
				var f = function (product) {
					return _Utils_update(
						product,
						{oc: val});
				};
				return _Utils_Tuple2(
					A3($author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProduct, ind, model, f),
					$elm$core$Platform$Cmd$none);
			case 9:
				var ind = msg.a;
				var effectAllowed = msg.b;
				var value = msg.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Just(ind)
						}),
					$author$project$DragPorts$dragstart(
						A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$startPortData, effectAllowed, value)));
			case 10:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var destInd = msg.a;
				var dropEffect = msg.b;
				var value = msg.c;
				var _v1 = model.jg;
				if (!_v1.$) {
					var sourceInd = _v1.a;
					var dragStatusIncVal = (_Utils_cmp(sourceInd, destInd) < 0) ? 1 : (-1);
					var products = A3(
						$elm_community$list_extra$List$Extra$swapAt,
						sourceInd,
						destInd,
						A3(
							$elm_community$list_extra$List$Extra$updateAt,
							destInd,
							function (product) {
								return _Utils_update(
									product,
									{lY: product.lY + dragStatusIncVal});
							},
							model.kn));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								jg: $elm$core$Maybe$Just(destInd),
								kn: products
							}),
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				} else {
					return _Utils_Tuple2(
						model,
						$author$project$DragPorts$dragover(
							A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$overPortData, dropEffect, value)));
				}
			case 12:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jg: $elm$core$Maybe$Nothing,
							kn: A2(
								$elm$core$List$map,
								function (p) {
									return _Utils_update(
										p,
										{lY: 0});
								},
								model.kn)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var index = msg.a;
				var maybeProduct = A2($elm_community$list_extra$List$Extra$getAt, index, model.kn);
				if (!maybeProduct.$) {
					var product = maybeProduct.a;
					var body = $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'product_id',
								$elm$json$Json$Encode$string(product.kl)),
								_Utils_Tuple2(
								'base_price',
								$elm$json$Json$Encode$int(
									$elm$core$Basics$round(product.lt * ((100 + $author$project$Utils$Constants$tax) * 0.01)))),
								_Utils_Tuple2(
								'base_point',
								$elm$json$Json$Encode$int(product.ls)),
								_Utils_Tuple2(
								'product_order',
								$elm$json$Json$Encode$int(index + 1)),
								_Utils_Tuple2(
								'yodobashi_base_price_flag',
								$elm$json$Json$Encode$bool(product.oc)),
								_Utils_Tuple2(
								'get_interval',
								$elm$json$Json$Encode$int(product.ju)),
								_Utils_Tuple2(
								'r_tyousei',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, product.ec))
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{k: true}),
						A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV._, model.C, body, $author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Tv24Comnet$ChangeProduct$UpdateProductRequestSent));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var body = A2(
					$elm$json$Json$Encode$list,
					function (product) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'product_id',
									$elm$json$Json$Encode$string(product.kl)),
									_Utils_Tuple2(
									'base_price',
									$elm$json$Json$Encode$int(
										$elm$core$Basics$round(product.lt * ((100 + $author$project$Utils$Constants$tax) * 0.01)))),
									_Utils_Tuple2(
									'base_point',
									$elm$json$Json$Encode$int(product.ls)),
									_Utils_Tuple2(
									'product_order',
									$elm$json$Json$Encode$int(product.nl)),
									_Utils_Tuple2(
									'yodobashi_base_price_flag',
									$elm$json$Json$Encode$bool(product.oc)),
									_Utils_Tuple2(
									'get_interval',
									$elm$json$Json$Encode$int(product.ju)),
									_Utils_Tuple2(
									'r_tyousei',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, product.ec))
								]));
					},
					model.kn);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{k: true}),
					A5($author$project$Api$post, $author$project$Endpoints$User$tv24ComnetEndpoints.aV.iE, model.C, body, $author$project$Pages$Users$Tv24Comnet$ChangeProduct$updateProductResponseDecoder, $author$project$Pages$Users$Tv24Comnet$ChangeProduct$UpdateProductRequestSent));
			default:
				var point = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iR: $elm$core$String$toInt(point)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$GetPriceRequestSent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$GetPriceResponse = F3(
	function (dictPrice, storeGroups, products) {
		return {jb: dictPrice, kn: products, X: storeGroups};
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$Price = function (productId) {
	return function (storeId) {
		return function (dateTime) {
			return function (price) {
				return function (priceIncludeTax) {
					return function (point) {
						return function (priceWithoutPoint) {
							return function (coupon) {
								return function (isLatest) {
									return function (url) {
										return {i9: coupon, lP: dateTime, fH: isLatest, ka: point, kg: price, kh: priceIncludeTax, be: priceWithoutPoint, kl: productId, iw: storeId, eD: url};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$priceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'is_latest', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'coupon', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'price_without_point', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'point', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'price_include_tax', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'price', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'date_time', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Pages$Users$Tv24Comnet$Thirty$Price)))))))))));
var $author$project$Pages$Users$Tv24Comnet$Thirty$dictPriceDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Dict$fromList,
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$List$map2($elm$core$Tuple$pair),
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$field, 'store_id', $elm$json$Json$Decode$int))),
		$elm$json$Json$Decode$list($author$project$Pages$Users$Tv24Comnet$Thirty$priceDecoder)));
var $author$project$Pages$Users$Tv24Comnet$Thirty$ProductR = function (productId) {
	return function (productName) {
		return function (basePrice) {
			return function (basePriceIncludeTax) {
				return function (basePoint) {
					return function (basePriceWithoutPoint) {
						return function (makerId) {
							return function (smallCategoryId) {
								return function (bigCategoryId) {
									return function (yodobashiFlag) {
										return function (r_tyousei) {
											return {ls: basePoint, lt: basePrice, eY: basePriceIncludeTax, cb: basePriceWithoutPoint, e_: bigCategoryId, jW: makerId, kl: productId, nk: productName, h8: r_tyousei, ir: smallCategoryId, oc: yodobashiFlag};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$productRsDecoder = $elm$json$Json$Decode$list(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'r_tyousei',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'yodobashi_base_price_flag', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'big_category_id', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'small_category_id', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'maker_id', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'base_price_without_point', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'base_point', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'base_price_include_tax', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'base_price', $elm$json$Json$Decode$int),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'product_name', $elm$json$Json$Decode$string),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'product_id', $elm$json$Json$Decode$string),
												$elm$json$Json$Decode$succeed($author$project$Pages$Users$Tv24Comnet$Thirty$ProductR)))))))))))));
var $author$project$Pages$Users$Tv24Comnet$Thirty$getPriceResponseDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Pages$Users$Tv24Comnet$Thirty$GetPriceResponse,
	A2($elm$json$Json$Decode$field, 'prices', $author$project$Pages$Users$Tv24Comnet$Thirty$dictPriceDecoder),
	A2($elm$json$Json$Decode$field, 'storeGroups', $author$project$Utils$Decoders$storeGroupsDecoder),
	A2($elm$json$Json$Decode$field, 'products', $author$project$Pages$Users$Tv24Comnet$Thirty$productRsDecoder));
var $author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceHeader = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceNoData = {$: 1};
var $author$project$Pages$Users$Tv24Comnet$Thirty$displayStyleToValues = _List_fromArray(
	[
		_Utils_Tuple2(
		'DisplayAll',
		_List_fromArray(
			[0, 1, 2, 3, 4])),
		_Utils_Tuple2(
		'DisplayPrice',
		_List_fromArray(
			[0, 1, 4])),
		_Utils_Tuple2(
		'DisplayPriceAndPoint',
		_List_fromArray(
			[0, 1, 2, 4])),
		_Utils_Tuple2(
		'DisplayAfterP',
		_List_fromArray(
			[3, 4])),
		_Utils_Tuple2(
		'DisplayAfterPWithoutTime',
		_List_fromArray(
			[3]))
	]);
var $author$project$Pages$Users$Tv24Comnet$Thirty$max_int = A2($elm$core$Basics$pow, 2, 30);
var $author$project$Pages$Users$Tv24Comnet$Thirty$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (ind, product) {
				var rtyousei = function () {
					var _v8 = product.h8;
					if (!_v8.$) {
						var price = _v8.a;
						return $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(price));
					} else {
						return '-';
					}
				}();
				var maybeYodobashiPrice = A2(
					$elm$core$Dict$get,
					_Utils_Tuple2(product.kl, 7),
					model.cQ);
				var lowestPrice = A3(
					$elm$core$List$foldl,
					F2(
						function (price, m) {
							return A2($elm$core$Basics$min, m, price);
						}),
					$author$project$Pages$Users$Tv24Comnet$Thirty$max_int,
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : $author$project$Pages$Users$Tv24Comnet$Thirty$max_int;
							} else {
								return $author$project$Pages$Users$Tv24Comnet$Thirty$max_int;
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Tv24Comnet$Thirty$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceHeader(filteredBasePriceList),
							$author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: rtyousei, m: 0}
								]))
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return (price.iw === 4) ? _Utils_eq(price.kh, lowestPrice) : _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
							var isLowerRtyousei = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v5 = product.h8;
									if (!_v5.$) {
										var r_price = _v5.a;
										return (price.iw === 4) ? (_Utils_cmp(price.kh, r_price) < 0) : (_Utils_cmp(price.be, r_price) < 0);
									} else {
										return false;
									}
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									var _v3 = _Utils_Tuple2(product.oc, maybeYodobashiPrice);
									if (_v3.a && (!_v3.b.$)) {
										var yodobashiPrice = _v3.b.a;
										return (price.iw === 4) ? (_Utils_cmp(price.kh, yodobashiPrice.be) < 0) : (_Utils_cmp(price.be, yodobashiPrice.be) < 0);
									} else {
										return (price.iw === 4) ? (_Utils_cmp(price.kh, product.cb) < 0) : (_Utils_cmp(price.be, product.cb) < 0);
									}
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: (price.iw === 4) ? '0' : function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: (price.iw === 4) ? $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)) : $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceData(
									{fH: price.fH, hL: isLower, hM: isLowerRtyousei, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Tv24Comnet$Thirty$ProductPriceNoData;
							}
						},
						stores));
			}),
		products);
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格', 'R調整価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$toCsv = F3(
	function (storeHeader, priceRows, selectedDisplayStyle) {
		return {
			dE: _List_Nil,
			no: A2(
				$elm$core$List$cons,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.kS;
					},
					storeHeader),
				A2(
					$elm$core$List$concatMap,
					function (row) {
						var indices = A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, selectedDisplayStyle);
								},
								$author$project$Pages$Users$Tv24Comnet$Thirty$displayStyleToValues)).b;
						var numrow = A2(
							$elm$core$List$take,
							$elm$core$List$length(indices),
							_List_fromArray(
								[0, 1, 2, 3, 4, 5]));
						return _Utils_ap(
							A2(
								$elm$core$List$map,
								function (ind) {
									return A2(
										$elm$core$List$map,
										function (cell) {
											switch (cell.$) {
												case 0:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data)).jP;
												case 1:
													return '';
												default:
													var data = cell.a;
													return A2(
														$elm$core$Maybe$withDefault,
														{jP: '', m: -1},
														A2($elm_community$list_extra$List$Extra$getAt, ind, data.h6)).jP;
											}
										},
										row);
								},
								numrow),
							_List_fromArray(
								[
									A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (cell) {
											switch (cell.$) {
												case 0:
													return (ind === 2) ? '最低● 基準※' : '';
												case 1:
													return '';
												default:
													var data = cell.a;
													return data.hN ? '●' : (data.hL ? '※' : '');
											}
										};
									},
									row)
								]));
					},
					priceRows))
		};
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bS: A3($author$project$Utils$Helpers$formatDate, date.ob, date.mQ, date.fd),
							bi: function (parts) {
								return A2($author$project$Utils$Helpers$formatTime, parts.mj, parts.mO);
							}(
								A2($author$project$Utils$Helpers$floorTimeByInterval, date, model.ac))
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bS: date}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bi: time}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v1 = A2($author$project$Utils$Helpers$dateTimeToParts, model.bS, model.bi);
						if (!_v1.$) {
							var dateTimeParts = _v1.a;
							var to = $author$project$Utils$Helpers$formatDateTime(dateTimeParts);
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$justinmimbs$time_extra$Time$Extra$posixToParts,
									$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
									A4(
										$justinmimbs$time_extra$Time$Extra$add,
										13,
										(-1) * model.ac,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A2(
											$justinmimbs$time_extra$Time$Extra$partsToPosix,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											dateTimeParts))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Tv24Comnet$Thirty$getPriceResponseDecoder,
								$author$project$Pages$Users$Tv24Comnet$Thirty$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dP: true}),
					function () {
						var _v2 = model.fa;
						if (!_v2.$) {
							var time = _v2.a;
							var to = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										time)));
							var from = $author$project$Utils$Helpers$formatDateTime(
								A2(
									$author$project$Utils$Helpers$roundByInterval,
									model.ac,
									A2(
										$justinmimbs$time_extra$Time$Extra$posixToParts,
										$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
										A4(
											$justinmimbs$time_extra$Time$Extra$add,
											13,
											(-1) * model.ac,
											$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
											time))));
							return A4(
								$author$project$Api$get,
								$author$project$Endpoints$User$defaultEndpoints.g(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'from', from),
											A2($elm$url$Url$Builder$string, 'to', to),
											A2(
											$elm$url$Url$Builder$string,
											'interval',
											$elm$core$String$fromInt(model.ac)),
											A2(
											$elm$url$Url$Builder$string,
											'usePast',
											model.g2 ? 'true' : ''),
											A2(
											$elm$url$Url$Builder$string,
											'bigCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.ig))),
											A2(
											$elm$url$Url$Builder$string,
											'smallCategory',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.gD))),
											A2(
											$elm$url$Url$Builder$string,
											'maker',
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, -1, model.eh)))
										])),
								model.C,
								$author$project$Pages$Users$Tv24Comnet$Thirty$getPriceResponseDecoder,
								$author$project$Pages$Users$Tv24Comnet$Thirty$GetPriceRequestSent);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 11:
				var bigCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ig: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(bigCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var smallCategoryId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gD: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(smallCategoryId))
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var makerId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eh: A2(
								$elm$core$Maybe$andThen,
								$elm$core$Maybe$Just,
								$elm$core$String$toInt(makerId))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var result = msg.a;
				if (!result.$) {
					var initResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iW: initResponse.iW, H: $elm$core$Maybe$Nothing, cv: false, cE: initResponse.cE, kL: initResponse.kL}),
						$elm$core$Platform$Cmd$none);
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								cv: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 2:
				var result = msg.a;
				if (!result.$) {
					var getPriceResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Nothing,
								hA: true,
								dP: false,
								cQ: getPriceResponse.jb,
								kn: getPriceResponse.kn,
								X: getPriceResponse.X,
								gN: model.bS,
								gO: model.bi,
								L: $elm$core$Set$isEmpty(model.L) ? $elm$core$Set$fromList(
									A2(
										$elm$core$List$map,
										function ($) {
											return $.iv;
										},
										getPriceResponse.X)) : model.L
							}),
						$author$project$Api$createFixedMidashi(0));
				} else {
					var error = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									$author$project$Utils$Helpers$errToStr(error)),
								dP: false
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 14:
				var posix = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fa: $elm$core$Maybe$Just(posix)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var disp = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: disp}),
					$author$project$Api$createFixedMidashi(0));
			case 3:
				var checked = msg.a;
				var storeGroupIdStr = msg.b;
				var storeGroupId = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(storeGroupIdStr));
				var newStoreGroups = checked ? A2($elm$core$Set$insert, storeGroupId, model.L) : A2($elm$core$Set$remove, storeGroupId, model.L);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: newStoreGroups}),
					$author$project$Api$createFixedMidashi(0));
			case 10:
				var storeHeader = A2($author$project$Pages$Users$Tv24Comnet$Thirty$pStoreHeader, model.X, model.L);
				var priceRows = $author$project$Pages$Users$Tv24Comnet$Thirty$pProductPriceRows(model);
				var csvFileName = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'data.csv',
					A2(
						$elm$core$Basics$composeR,
						$author$project$Utils$Helpers$formatDateTime,
						A2($author$project$Utils$Helpers$flip, $elm$core$String$append, '.csv')),
					A2($author$project$Utils$Helpers$dateTimeToParts, model.gN, model.gO));
				var csv = $elm$bytes$Bytes$Encode$encode(
					function (byteCsv) {
						return $elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									$elm$bytes$Bytes$Encode$unsignedInt8(239),
									$elm$bytes$Bytes$Encode$unsignedInt8(187),
									$elm$bytes$Bytes$Encode$unsignedInt8(191),
									$elm$bytes$Bytes$Encode$bytes(byteCsv)
								]));
					}(
						$commonmind$elm_csv_encode$Csv$Encode$toBytes(
							A3($author$project$Pages$Users$Tv24Comnet$Thirty$toCsv, storeHeader, priceRows, model.c_))));
				return _Utils_Tuple2(
					model,
					A3($elm$file$File$Download$bytes, csvFileName, 'text/csv', csv));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$User$updateWithUserModel = F4(
	function (toMsg, cmsModel, news, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_Tuple3(cmsModel, subModel, news),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd));
	});
var $author$project$Pages$User$update = F2(
	function (msg, model) {
		var fail = _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		var _v0 = model;
		var userModel = _v0.a;
		var navModel = _v0.b;
		var news = _v0.c;
		switch (msg.$) {
			case 35:
				var result = msg.a;
				if (!result.$) {
					var res = result.a;
					return _Utils_Tuple2(
						_Utils_Tuple3(userModel, navModel, res.j$),
						$elm$core$Platform$Cmd$none);
				} else {
					return fail;
				}
			case 0:
				var defaultMsg = msg.a;
				if (userModel.$ === 1) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$DefaultModel,
						$author$project$Pages$User$GotDefaultMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Common$Default$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 1:
				var defaultMsg = msg.a;
				if (userModel.$ === 2) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TimeSeqModel,
						$author$project$Pages$User$GotTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Common$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 11:
				var defaultMsg = msg.a;
				if (userModel.$ === 12) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ChangeProductModel,
						$author$project$Pages$User$GotChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Common$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 12:
				var defaultMsg = msg.a;
				if (userModel.$ === 13) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tcmComnetTimeSeqModel,
						$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tcmComnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 14:
				var defaultMsg = msg.a;
				if (userModel.$ === 15) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tcmComnetDayModel,
						$author$project$Pages$User$GotTo24tcmComnetDayMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tcmComnet$Day$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 13:
				var defaultMsg = msg.a;
				if (userModel.$ === 14) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tcmComnetCsvModel,
						$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tcmComnet$Csv$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 15:
				var defaultMsg = msg.a;
				if (userModel.$ === 16) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tcmComnetChangeProductModel,
						$author$project$Pages$User$GotTo24tcmComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tcmComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 16:
				var defaultMsg = msg.a;
				if (userModel.$ === 17) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tcmComnetProductModel,
						$author$project$Pages$User$GotTo24tcmComnetProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tcmComnet$Product$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 59:
				var defaultMsg = msg.a;
				if (userModel.$ === 58) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tcmKitchenDayModel,
						$author$project$Pages$User$GotTo24tcmKitchenDayMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tcmKitchen$Day$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 60:
				var defaultMsg = msg.a;
				if (userModel.$ === 59) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tcmFridgeHourMixModel,
						$author$project$Pages$User$GotTo24tcmFridgeHourMixMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tcmFridge$HourMix$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 17:
				var defaultMsg = msg.a;
				if (userModel.$ === 18) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tclComnetChangeProductModel,
						$author$project$Pages$User$GotTo24tclComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tclComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 18:
				var defaultMsg = msg.a;
				if (userModel.$ === 19) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tclComnetDayModel,
						$author$project$Pages$User$GotTo24tclComnetDayMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tclComnet$Day$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 19:
				var defaultMsg = msg.a;
				if (userModel.$ === 20) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$To24tclComnetTimeSeqModel,
						$author$project$Pages$User$GotTo24tclComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$To24tclComnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 20:
				var defaultMsg = msg.a;
				if (userModel.$ === 21) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$JvcComnetTimeSeqModel,
						$author$project$Pages$User$GotJvcComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$JvcComnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 21:
				var defaultMsg = msg.a;
				if (userModel.$ === 22) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$JvcComnetDefaultModel,
						$author$project$Pages$User$GotJvcComnetDefaultMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$JvcComnet$Default$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 22:
				var defaultMsg = msg.a;
				if (userModel.$ === 23) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$JvcComnetAmazonModel,
						$author$project$Pages$User$GotJvcComnetAmazonMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$JvcComnet$Amazon$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 23:
				var defaultMsg = msg.a;
				if (userModel.$ === 24) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$JvcComnetPriceDropModel,
						$author$project$Pages$User$GotJvcComnetPriceDropMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$JvcComnet$PriceDrop$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 2:
				var defaultMsg = msg.a;
				if (userModel.$ === 3) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi24ComnetHourModel,
						$author$project$Pages$User$GotHi24ComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi24Comnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 3:
				var defaultMsg = msg.a;
				if (userModel.$ === 4) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi24ComnetTimeSeqModel,
						$author$project$Pages$User$GotHi24ComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi24Comnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 4:
				var defaultMsg = msg.a;
				if (userModel.$ === 5) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi24ComnetHourSeqModel,
						$author$project$Pages$User$GotHi24ComnetHourSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi24Comnet$HourSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 5:
				var defaultMsg = msg.a;
				if (userModel.$ === 6) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi24ComnetWeeklyProductFifteenModel,
						$author$project$Pages$User$GotHi24ComnetWeeklyProductFifteenMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 6:
				var defaultMsg = msg.a;
				if (userModel.$ === 7) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi24ComnetTenAMModel,
						$author$project$Pages$User$GotHi24ComnetTenAMMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi24Comnet$TenAM$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 7:
				var defaultMsg = msg.a;
				if (userModel.$ === 8) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi24ComnetDayModel,
						$author$project$Pages$User$GotHi24ComnetDayMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi24Comnet$Day$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 8:
				var defaultMsg = msg.a;
				if (userModel.$ === 9) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi24ComnetSixHourModel,
						$author$project$Pages$User$GotHi24ComnetSixHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi24Comnet$SixHour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 9:
				var defaultMsg = msg.a;
				if (userModel.$ === 10) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi3ComnetHourModel,
						$author$project$Pages$User$GotHi3ComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi3Comnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 10:
				var defaultMsg = msg.a;
				if (userModel.$ === 11) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Hi3ComnetTimeSeqModel,
						$author$project$Pages$User$GotHi3ComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hi3Comnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 24:
				var defaultMsg = msg.a;
				if (userModel.$ === 25) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$HisenseDayModel,
						$author$project$Pages$User$GotHisenseDayMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hisense$Day$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 25:
				var defaultMsg = msg.a;
				if (userModel.$ === 26) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$HisenseTvHourModel,
						$author$project$Pages$User$GotHisenseTvHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hisense$TvHour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 29:
				var defaultMsg = msg.a;
				if (userModel.$ === 29) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$HisenseTimeSeqModel,
						$author$project$Pages$User$GotHisenseTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hisense$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 26:
				var defaultMsg = msg.a;
				if (userModel.$ === 28) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$HisenseAmazonModel,
						$author$project$Pages$User$GotHisenseAmazonMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hisense$Amazon$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 27:
				var defaultMsg = msg.a;
				if (userModel.$ === 30) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$HisenseChangeProductModel,
						$author$project$Pages$User$GotHisenseChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hisense$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 28:
				var defaultMsg = msg.a;
				if (userModel.$ === 27) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$HisenseReviewModel,
						$author$project$Pages$User$GotHisenseReviewMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hisense$Review$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 30:
				var defaultMsg = msg.a;
				if (userModel.$ === 31) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$HisenseExcelModel,
						$author$project$Pages$User$GotHisenseExcelMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Hisense$Excel$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 32:
				var defaultMsg = msg.a;
				if (userModel.$ === 32) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TescomComnetHourModel,
						$author$project$Pages$User$GotTescomComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$TescomComnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 33:
				var defaultMsg = msg.a;
				if (userModel.$ === 33) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TescomComnetExcelModel,
						$author$project$Pages$User$GotTescomComnetExcelMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$TescomComnet$Excel$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 34:
				var defaultMsg = msg.a;
				if (userModel.$ === 34) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TescomComnetChangeProductModel,
						$author$project$Pages$User$GotTescomComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$TescomComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 31:
				var navMsg = msg.a;
				return A4(
					$author$project$Pages$User$updateWithUserModel,
					$author$project$Pages$User$GotNavBarMsg,
					userModel,
					news,
					A2($author$project$Components$NavBar$update, navMsg, navModel));
			case 36:
				var defaultMsg = msg.a;
				if (userModel.$ === 35) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Ca6ComnetHourModel,
						$author$project$Pages$User$GotCa6ComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Ca6Comnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 37:
				var defaultMsg = msg.a;
				if (userModel.$ === 36) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Ca6ComnetHour2Model,
						$author$project$Pages$User$GotCa6ComnetHour2Msg,
						navModel,
						news,
						A2($author$project$Pages$Users$Ca6Comnet$Hour2$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 38:
				var defaultMsg = msg.a;
				if (userModel.$ === 37) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Ca6ComnetCsvModel,
						$author$project$Pages$User$GotCa6ComnetCsvMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Ca6Comnet$Csv$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 39:
				var defaultMsg = msg.a;
				if (userModel.$ === 38) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Ca6ComnetWeeklyProductModel,
						$author$project$Pages$User$GotCa6ComnetWeeklyProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 40:
				var defaultMsg = msg.a;
				if (userModel.$ === 39) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Ca6ComnetWeeklyProduct2Model,
						$author$project$Pages$User$GotCa6ComnetWeeklyProduct2Msg,
						navModel,
						news,
						A2($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 41:
				var defaultMsg = msg.a;
				if (userModel.$ === 40) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Ca6ComnetItemsModel,
						$author$project$Pages$User$GotCa6ComnetItemsMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Ca6Comnet$Items$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 42:
				var defaultMsg = msg.a;
				if (userModel.$ === 41) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Ca6ComnetLowModel,
						$author$project$Pages$User$GotCa6ComnetLowMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Ca6Comnet$Low$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 43:
				var defaultMsg = msg.a;
				if (userModel.$ === 42) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetChangeProductModel,
						$author$project$Pages$User$GotMlnComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 44:
				var defaultMsg = msg.a;
				if (userModel.$ === 46) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetChangeMailModel,
						$author$project$Pages$User$GotMlnComnetChangeMailMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$ChangeMail$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 45:
				var defaultMsg = msg.a;
				if (userModel.$ === 47) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetChangeMailTestModel,
						$author$project$Pages$User$GotMlnComnetChangeMailTestMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$ChangeMailTest$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 51:
				var defaultMsg = msg.a;
				if (userModel.$ === 50) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetChangePasswordModel,
						$author$project$Pages$User$GotMlnComnetChangePasswordMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$ChangePassword$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 46:
				var defaultMsg = msg.a;
				if (userModel.$ === 43) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetChronologicalModel,
						$author$project$Pages$User$GotMlnComnetChronologicalMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$Chronological$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 47:
				var defaultMsg = msg.a;
				if (userModel.$ === 44) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetHourModel,
						$author$project$Pages$User$GotMlnComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 48:
				var defaultMsg = msg.a;
				if (userModel.$ === 45) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetHourYamadaModel,
						$author$project$Pages$User$GotMlnComnetHourYamadaMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$HourYamada$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 49:
				var defaultMsg = msg.a;
				if (userModel.$ === 48) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetAutoReloadModel,
						$author$project$Pages$User$GotMlnComnetAutoReloadMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$AutoReload$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 50:
				var defaultMsg = msg.a;
				if (userModel.$ === 49) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetMailSettingModel,
						$author$project$Pages$User$GotMlnComnetMailSettingMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$MailSetting$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 52:
				var defaultMsg = msg.a;
				if (userModel.$ === 51) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$MlnComnetYahooModel,
						$author$project$Pages$User$GotMlnComnetYahooMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$MlnComnet$Yahoo$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 53:
				var defaultMsg = msg.a;
				if (userModel.$ === 52) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Tv24ComnetChangeProductModel,
						$author$project$Pages$User$GotTv24ComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Tv24Comnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 54:
				var defaultMsg = msg.a;
				if (userModel.$ === 53) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Tv24ComnetThirtyModel,
						$author$project$Pages$User$GotTv24ComnetThirtyMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Tv24Comnet$Thirty$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 55:
				var defaultMsg = msg.a;
				if (userModel.$ === 54) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ElecComnetHourModel,
						$author$project$Pages$User$GotElecComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ElecComnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 56:
				var defaultMsg = msg.a;
				if (userModel.$ === 55) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ElecComnetExcelModel,
						$author$project$Pages$User$GotElecComnetExcelMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ElecComnet$Excel$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 57:
				var defaultMsg = msg.a;
				if (userModel.$ === 56) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ElecComnetChangeProductModel,
						$author$project$Pages$User$GotElecComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ElecComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 58:
				var defaultMsg = msg.a;
				if (userModel.$ === 57) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ElecComnetTimeSeqModel,
						$author$project$Pages$User$GotElecComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ElecComnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 61:
				var defaultMsg = msg.a;
				if (userModel.$ === 60) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$DelonghiHourModel,
						$author$project$Pages$User$GotDelonghiHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Delonghi$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 62:
				var defaultMsg = msg.a;
				if (userModel.$ === 61) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$DelonghiChangeProductModel,
						$author$project$Pages$User$GotDelonghiChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Delonghi$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 63:
				var defaultMsg = msg.a;
				if (userModel.$ === 62) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$DelonghiTimeSeqModel,
						$author$project$Pages$User$GotDelonghiTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Delonghi$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 64:
				var defaultMsg = msg.a;
				if (userModel.$ === 63) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$DelonghiTimeSeq2Model,
						$author$project$Pages$User$GotDelonghiTimeSeq2Msg,
						navModel,
						news,
						A2($author$project$Pages$Users$Delonghi$TimeSeq2$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 65:
				var defaultMsg = msg.a;
				if (userModel.$ === 64) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$DelonghiNineAMModel,
						$author$project$Pages$User$GotDelonghiNineAMMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Delonghi$NineAM$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 66:
				var defaultMsg = msg.a;
				if (userModel.$ === 65) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$DelonghiWeeklyModel,
						$author$project$Pages$User$GotDelonghiWeeklyMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Delonghi$Weekly$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 67:
				var defaultMsg = msg.a;
				if (userModel.$ === 66) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$KinujoComnetExcelModel,
						$author$project$Pages$User$GotKinujoComnetExcelMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$KinujoComnet$Excel$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 68:
				var defaultMsg = msg.a;
				if (userModel.$ === 67) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$KinujoComnetChangeProductModel,
						$author$project$Pages$User$GotKinujoComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$KinujoComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 69:
				var defaultMsg = msg.a;
				if (userModel.$ === 68) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$KinujoComnetFifteenModel,
						$author$project$Pages$User$GotKinujoComnetFifteeenMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$KinujoComnet$Fifteen$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 70:
				var defaultMsg = msg.a;
				if (userModel.$ === 69) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ShaComnetWideModel,
						$author$project$Pages$User$GotShaComnetWideMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ShaComnet$Wide$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 71:
				var defaultMsg = msg.a;
				if (userModel.$ === 70) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ShaComnetHourModel,
						$author$project$Pages$User$GotShaComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ShaComnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 72:
				var defaultMsg = msg.a;
				if (userModel.$ === 71) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ShaComnetTimeSeqModel,
						$author$project$Pages$User$GotShaComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ShaComnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 73:
				var defaultMsg = msg.a;
				if (userModel.$ === 72) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ShaComnetWeeklyProductModel,
						$author$project$Pages$User$GotShaComnetWeeklyProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ShaComnet$WeeklyProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 74:
				var defaultMsg = msg.a;
				if (userModel.$ === 73) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ShaComnetDayModel,
						$author$project$Pages$User$GotShaComnetDayMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ShaComnet$Day$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 75:
				var defaultMsg = msg.a;
				if (userModel.$ === 74) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ShaComnetChangeProductModel,
						$author$project$Pages$User$GotShaComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$ShaComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 76:
				var defaultMsg = msg.a;
				if (userModel.$ === 75) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TstComnetTimeSeqModel,
						$author$project$Pages$User$GotTstComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$TstComnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 77:
				var defaultMsg = msg.a;
				if (userModel.$ === 76) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TstComnetWideModel,
						$author$project$Pages$User$GotTstComnetWideMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$TstComnet$Wide$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 78:
				var defaultMsg = msg.a;
				if (userModel.$ === 77) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Dbi6ComnetHourModel,
						$author$project$Pages$User$GotDbi6ComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Dbi6Comnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 79:
				var defaultMsg = msg.a;
				if (userModel.$ === 78) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Dbi6ComnetTimeSeqModel,
						$author$project$Pages$User$GotDbi6ComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Dbi6Comnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 80:
				var defaultMsg = msg.a;
				if (userModel.$ === 80) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Denon6ComnetWideModel,
						$author$project$Pages$User$GotDenon6ComnetWideMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Denon6Comnet$Wide$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 81:
				var defaultMsg = msg.a;
				if (userModel.$ === 79) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Denon6ComnetTimeSeqModel,
						$author$project$Pages$User$GotDenon6ComnetTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Denon6Comnet$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 82:
				var reiMsg = msg.a;
				if (userModel.$ === 81) {
					var reiModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$EditProductsPermalinks,
						$author$project$Pages$User$GotEditProductsPermalinks,
						navModel,
						news,
						A2($author$project$Pages$Cms$Products$EditProductsPermalinks$update, reiMsg, reiModel));
				} else {
					return fail;
				}
			case 83:
				var reiMsg = msg.a;
				if (userModel.$ === 82) {
					var reiModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$ChangeUserProductModel,
						$author$project$Pages$User$GotChangeUserProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Cms$Products$ChangeUserProduct$update, reiMsg, reiModel));
				} else {
					return fail;
				}
			case 84:
				var reiMsg = msg.a;
				if (userModel.$ === 83) {
					var reiModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$AddProductConfigModel,
						$author$project$Pages$User$GotAddProductConfigMsg,
						navModel,
						news,
						A2($author$project$Pages$Cms$Products$AddProductConfig$update, reiMsg, reiModel));
				} else {
					return fail;
				}
			case 85:
				var reiMsg = msg.a;
				if (userModel.$ === 84) {
					var reiModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$EditProductsModel,
						$author$project$Pages$User$GotEditProductsMsg,
						navModel,
						news,
						A2($author$project$Pages$Cms$Products$EditProducts$update, reiMsg, reiModel));
				} else {
					return fail;
				}
			case 86:
				var yMsg = msg.a;
				if (userModel.$ === 85) {
					var yModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$Yahoo,
						$author$project$Pages$User$GotYahooMsg,
						navModel,
						news,
						A2($author$project$Pages$Cms$Stores$Yahoo$update, yMsg, yModel));
				} else {
					return fail;
				}
			case 87:
				var reiMsg = msg.a;
				if (userModel.$ === 86) {
					var reiModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$EditSoldoutProductsModel,
						$author$project$Pages$User$GotEditSoldoutProductsMsg,
						navModel,
						news,
						A2($author$project$Pages$Cms$Products$EditSoldoutProducts$update, reiMsg, reiModel));
				} else {
					return fail;
				}
			case 88:
				var defaultMsg = msg.a;
				if (userModel.$ === 87) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$BraunComnetHourModel,
						$author$project$Pages$User$GotBraunComnetHourMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$BraunComnet$Hour$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 89:
				var defaultMsg = msg.a;
				if (userModel.$ === 88) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$BraunComnetWideModel,
						$author$project$Pages$User$GotBraunComnetWideMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$BraunComnet$Wide$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 90:
				var defaultMsg = msg.a;
				if (userModel.$ === 90) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TsBatWideModel,
						$author$project$Pages$User$GotTsBatWideMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$TsBat$Wide$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 91:
				var defaultMsg = msg.a;
				if (userModel.$ === 89) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TsBatTimeSeqModel,
						$author$project$Pages$User$GotTsBatTimeSeqMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$TsBat$TimeSeq$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 92:
				var defaultMsg = msg.a;
				if (userModel.$ === 91) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiComnetFifteenModel,
						$author$project$Pages$User$GotFujiComnetFifteenMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$FujiComnet$Fifteen$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 93:
				var defaultMsg = msg.a;
				if (userModel.$ === 92) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiComnetWeek30Model,
						$author$project$Pages$User$GotFujiComnetWeek30Msg,
						navModel,
						news,
						A2($author$project$Pages$Users$FujiComnet$Week30$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 94:
				var defaultMsg = msg.a;
				if (userModel.$ === 93) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiComnetChangeProductModel,
						$author$project$Pages$User$GotFujiComnetChangeProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$FujiComnet$ChangeProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 95:
				var defaultMsg = msg.a;
				if (userModel.$ === 94) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiComnetLatestStoreModel,
						$author$project$Pages$User$GotFujiComnetLatestStoreMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$FujiComnet$LatestStore$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 96:
				var defaultMsg = msg.a;
				if (userModel.$ === 95) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiComnetMailAddressModel,
						$author$project$Pages$User$GotFujiComnetMailAddressMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Common$MailAddress$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 97:
				var defaultMsg = msg.a;
				if (userModel.$ === 96) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$CommonWeeklyProductModel,
						$author$project$Pages$User$GotCommonWeeklyProductMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Common$WeeklyProduct$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 98:
				var defaultMsg = msg.a;
				if (userModel.$ === 97) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiinstaxComnetThirtyModel,
						$author$project$Pages$User$GotFujiinstaxComnetThirtyMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$FujiinstaxComnet$Thirty$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 99:
				var defaultMsg = msg.a;
				if (userModel.$ === 98) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiinstaxComnetWeek30Model,
						$author$project$Pages$User$GotFujiinstaxComnetWeek30Msg,
						navModel,
						news,
						A2($author$project$Pages$Users$FujiinstaxComnet$Week30$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			case 100:
				var defaultMsg = msg.a;
				if (userModel.$ === 99) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$FujiinstaxComnetLatestStoreModel,
						$author$project$Pages$User$GotFujiinstaxComnetLatestStoreMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$FujiinstaxComnet$LatestStore$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
			default:
				var defaultMsg = msg.a;
				if (userModel.$ === 100) {
					var defaultModel = userModel.a;
					return A5(
						$author$project$Pages$User$updateWithNavModel,
						$author$project$Pages$User$TestFifteenModel,
						$author$project$Pages$User$GotTestFifteeenMsg,
						navModel,
						news,
						A2($author$project$Pages$Users$Test$Fifteen$update, defaultMsg, defaultModel));
				} else {
					return fail;
				}
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 3:
					var urlRequest = _v0.a.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								$author$project$Session$navKey(
									$author$project$Main$toSession(model)),
								url.nc));
					} else {
						var href = urlRequest.a;
						return _Utils_Tuple2(
							model,
							$elm$browser$Browser$Navigation$load(href));
					}
				case 4:
					var url = _v0.a.a;
					return A2($author$project$Main$changeRouteTo, url, model);
				case 0:
					if (_v0.b.$ === 1) {
						var loginMsg = _v0.a.a;
						var loginModel = _v0.b.a;
						return A3(
							$author$project$Main$updateWith,
							$author$project$Main$Login,
							$author$project$Main$GotLoginMsg,
							A2($author$project$Pages$Login$update, loginMsg, loginModel));
					} else {
						break _v0$7;
					}
				case 1:
					if (_v0.b.$ === 2) {
						var cmsMsg = _v0.a.a;
						var cmsModel = _v0.b.a;
						return A3(
							$author$project$Main$updateWith,
							$author$project$Main$Cms,
							$author$project$Main$GotCmsMsg,
							A2($author$project$Pages$Cms$update, cmsMsg, cmsModel));
					} else {
						break _v0$7;
					}
				case 2:
					if (_v0.b.$ === 3) {
						var userMsg = _v0.a.a;
						var userModel = _v0.b.a;
						return A3(
							$author$project$Main$updateWith,
							$author$project$Main$User,
							$author$project$Main$GotUserMsg,
							A2($author$project$Pages$User$update, userMsg, userModel));
					} else {
						break _v0$7;
					}
				case 5:
					var resultUserInfo = _v0.a.a;
					if (!resultUserInfo.$) {
						var userInfo = resultUserInfo.a;
						var loggedInSession = A5(
							$author$project$Session$login,
							$author$project$Main$toSession(model),
							userInfo.iC,
							userInfo.hK,
							userInfo.n2,
							userInfo.$8);
						return _Utils_Tuple2(
							$author$project$Main$Redirect(loggedInSession),
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								$author$project$Session$navKey(
									$author$project$Main$toSession(model)),
								'/'));
					} else {
						var errMsg = resultUserInfo.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				default:
					var _v3 = _v0.a;
					return _Utils_Tuple2(
						$author$project$Main$Redirect(
							$author$project$Session$logout(
								$author$project$Main$toSession(model))),
						$elm$browser$Browser$Navigation$load('/'));
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.lQ) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.jZ, record.lQ, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{lQ: decl, jZ: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.i5;
	var imports = _v0.jC;
	var namespaces = _v0.j_;
	var declarations = _v0.lR;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {i5: charset, lR: finalDeclarations, jC: imports, j_: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.jn + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.m)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.jZ;
			var declaration = decl.a.lQ;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.i5;
	var imports = _v0.jC;
	var namespaces = _v0.j_;
	var declarations = _v0.lR;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {cd: charsProcessed, ct: hash, W: seed, nC: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.ct)) ? (data.W ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.ct)))) : data.W;
	var h0 = acc ^ data.cd;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.ct | ((255 & $elm$core$Char$toCode(c)) << data.nC);
		var _v0 = data.nC;
		if (_v0 === 24) {
			return {
				cd: data.cd + 1,
				ct: 0,
				W: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.W, res),
				nC: 0
			};
		} else {
			return {cd: data.cd + 1, ct: res, W: data.W, nC: data.nC + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{lQ: str, jZ: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.i5;
	var imports = _v0.jC;
	var namespaces = _v0.j_;
	var snippets = _v0.kO;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {i5: charset, lR: declarations, jC: imports, j_: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {i5: $elm$core$Maybe$Nothing, jC: _List_Nil, j_: _List_Nil, kO: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Page$view = function (pageRequired) {
	return {
		dp: _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$toUnstyled(
				A2(
					$rtfeldman$elm_css$Html$Styled$h1,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(pageRequired.iB)
						]))),
				$rtfeldman$elm_css$Html$Styled$toUnstyled(pageRequired.lI)
			]),
		iB: pageRequired.iB
	};
};
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$NodeNS = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $rtfeldman$elm_css$VirtualDom$Styled$mapAttribute = F2(
	function (transform, _v0) {
		var prop = _v0.a;
		var styles = _v0.b;
		var classname = _v0.c;
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$mapAttribute, transform, prop),
			styles,
			classname);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$map = F2(
	function (transform, vdomNode) {
		switch (vdomNode.$) {
			case 0:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$Node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 1:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$NodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$map(transform),
						children));
			case 2:
				var elemType = vdomNode.a;
				var properties = vdomNode.b;
				var children = vdomNode.c;
				return A3(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var key = _v1.a;
							var child = _v1.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			case 3:
				var ns = vdomNode.a;
				var elemType = vdomNode.b;
				var properties = vdomNode.c;
				var children = vdomNode.d;
				return A4(
					$rtfeldman$elm_css$VirtualDom$Styled$KeyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$mapAttribute(transform),
						properties),
					A2(
						$elm$core$List$map,
						function (_v2) {
							var key = _v2.a;
							var child = _v2.b;
							return _Utils_Tuple2(
								key,
								A2($rtfeldman$elm_css$VirtualDom$Styled$map, transform, child));
						},
						children));
			default:
				var vdom = vdomNode.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
					A2($elm$virtual_dom$VirtualDom$map, transform, vdom));
		}
	});
var $rtfeldman$elm_css$Html$Styled$map = $rtfeldman$elm_css$VirtualDom$Styled$map;
var $author$project$Components$NavBar$Logout = {$: 1};
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Config = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$updateOptions = F2(
	function (mapper, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				j7: mapper(conf.j7)
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$attrs = F2(
	function (attrs_, conf) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$updateOptions,
			function (opt) {
				return _Utils_update(
					opt,
					{
						eW: _Utils_ap(opt.eW, attrs_)
					});
			},
			conf);
	});
var $frandibar$elm_bootstrap$Bootstrap$Internal$Role$Light = 6;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Light = 1;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Roled = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$XS = 0;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$config = function (toMsg) {
	return {
		dq: $elm$core$Maybe$Nothing,
		fb: _List_Nil,
		mx: _List_Nil,
		j7: {
			eW: _List_Nil,
			cp: $elm$core$Maybe$Nothing,
			fF: false,
			gy: $elm$core$Maybe$Just(
				{
					eZ: $frandibar$elm_bootstrap$Bootstrap$Navbar$Roled(6),
					fS: 1
				}),
			ey: 0
		},
		gV: toMsg,
		b2: false
	};
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$CustomItem = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$customItem = function (elem) {
	return elem;
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$updateConfig = F2(
	function (mapper, _v0) {
		var conf = _v0;
		return mapper(conf);
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$customItems = F2(
	function (items_, config_) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$updateConfig,
			function (conf) {
				return _Utils_update(
					conf,
					{fb: items_});
			},
			config_);
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Top = 0;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$fixTop = function (conf) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Navbar$updateOptions,
		function (opts) {
			return _Utils_update(
				opts,
				{
					cp: $elm$core$Maybe$Just(0)
				});
		},
		conf);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Item = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$itemLink = F2(
	function (attributes, children) {
		return $frandibar$elm_bootstrap$Bootstrap$Navbar$Item(
			{eW: attributes, i6: children});
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$items = F2(
	function (items_, config_) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$updateConfig,
			function (conf) {
				return _Utils_update(
					conf,
					{mx: items_});
			},
			config_);
	});
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Dark = 0;
var $frandibar$elm_bootstrap$Bootstrap$Internal$Role$Primary = 0;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$scheme = F3(
	function (modifier, bgColor, conf) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$updateOptions,
			function (opt) {
				return _Utils_update(
					opt,
					{
						gy: $elm$core$Maybe$Just(
							{eZ: bgColor, fS: modifier})
					});
			},
			conf);
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$primary = A2(
	$frandibar$elm_bootstrap$Bootstrap$Navbar$scheme,
	0,
	$frandibar$elm_bootstrap$Bootstrap$Navbar$Roled(0));
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $frandibar$elm_bootstrap$Bootstrap$Navbar$maybeBrand = function (brand_) {
	if (!brand_.$) {
		var b = brand_.a;
		return _List_fromArray(
			[b]);
	} else {
		return _List_Nil;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$sizeToComparable = function (size) {
	switch (size) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		default:
			return 5;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$LG = 3;
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$MD = 2;
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$SM = 1;
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$XL = 4;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$toScreenSize = function (windowWidth) {
	return (windowWidth <= 576) ? 0 : ((windowWidth <= 768) ? 1 : ((windowWidth <= 992) ? 2 : ((windowWidth <= 1200) ? 3 : 4)));
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$shouldHideMenu = F2(
	function (_v0, _v1) {
		var windowWidth = _v0.eK;
		var options = _v1.j7;
		var winMedia = function () {
			if (!windowWidth.$) {
				var s = windowWidth.a;
				return $frandibar$elm_bootstrap$Bootstrap$Navbar$toScreenSize(s);
			} else {
				return 0;
			}
		}();
		return _Utils_cmp(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$sizeToComparable(winMedia),
			$frandibar$elm_bootstrap$Bootstrap$Navbar$sizeToComparable(options.ey)) > 0;
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$Shown = 5;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$StartDown = 1;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$StartUp = 3;
var $frandibar$elm_bootstrap$Bootstrap$Navbar$visibilityTransition = F2(
	function (withAnimation_, visibility) {
		var _v0 = _Utils_Tuple2(withAnimation_, visibility);
		if (_v0.a) {
			switch (_v0.b) {
				case 0:
					var _v1 = _v0.b;
					return 1;
				case 1:
					var _v2 = _v0.b;
					return 2;
				case 2:
					var _v3 = _v0.b;
					return 5;
				case 5:
					var _v4 = _v0.b;
					return 3;
				case 3:
					var _v5 = _v0.b;
					return 4;
				default:
					var _v6 = _v0.b;
					return 0;
			}
		} else {
			switch (_v0.b) {
				case 0:
					var _v7 = _v0.b;
					return 5;
				case 5:
					var _v8 = _v0.b;
					return 0;
				default:
					return 0;
			}
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$transitionHandler = F2(
	function (state, configRec) {
		return $elm$json$Json$Decode$succeed(
			configRec.gV(
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Navbar$mapState,
					function (s) {
						return _Utils_update(
							s,
							{
								aF: A2($frandibar$elm_bootstrap$Bootstrap$Navbar$visibilityTransition, configRec.b2, s.aF)
							});
					},
					state)));
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$transitionStyle = function (maybeHeight) {
	var pixelHeight = A2(
		$elm$core$Maybe$withDefault,
		'0',
		A2(
			$elm$core$Maybe$map,
			function (v) {
				return $elm$core$String$fromFloat(v) + 'px';
			},
			maybeHeight));
	return _List_fromArray(
		[
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'relative'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', pixelHeight),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'overflow', 'hidden'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-webkit-transition-timing-function', 'ease'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-o-transition-timing-function', 'ease'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'transition-timing-function', 'ease'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-webkit-transition-duration', '0.35s'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-o-transition-duration', '0.35s'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'transition-duration', '0.35s'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-webkit-transition-property', 'height'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, '-o-transition-property', 'height'),
			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'transition-property', 'height')
		]);
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$menuAttributes = F2(
	function (state, configRec) {
		var visibility = state.aF;
		var height = state.jw;
		var defaults = _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('collapse navbar-collapse')
			]);
		switch (visibility) {
			case 0:
				if (height.$ === 1) {
					return ((!configRec.b2) || A2($frandibar$elm_bootstrap$Bootstrap$Navbar$shouldHideMenu, state, configRec)) ? defaults : _List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '0'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'overflow', 'hidden'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%')
						]);
				} else {
					return defaults;
				}
			case 1:
				return $frandibar$elm_bootstrap$Bootstrap$Navbar$transitionStyle($elm$core$Maybe$Nothing);
			case 2:
				return _Utils_ap(
					$frandibar$elm_bootstrap$Bootstrap$Navbar$transitionStyle(height),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$on,
							'transitionend',
							A2($frandibar$elm_bootstrap$Bootstrap$Navbar$transitionHandler, state, configRec))
						]));
			case 4:
				return _Utils_ap(
					$frandibar$elm_bootstrap$Bootstrap$Navbar$transitionStyle($elm$core$Maybe$Nothing),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$on,
							'transitionend',
							A2($frandibar$elm_bootstrap$Bootstrap$Navbar$transitionHandler, state, configRec))
						]));
			case 3:
				return $frandibar$elm_bootstrap$Bootstrap$Navbar$transitionStyle(height);
			default:
				return _Utils_ap(
					defaults,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('show')
						]));
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$menuWrapperAttributes = F2(
	function (state, confRec) {
		var visibility = state.aF;
		var height = state.jw;
		var styleBlock = _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%')
			]);
		var display = function () {
			if (height.$ === 1) {
				return ((!confRec.b2) || A2($frandibar$elm_bootstrap$Bootstrap$Navbar$shouldHideMenu, state, confRec)) ? 'flex' : 'block';
			} else {
				return 'flex';
			}
		}();
		switch (visibility) {
			case 0:
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', display),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%')
					]);
			case 1:
				return styleBlock;
			case 2:
				return styleBlock;
			case 4:
				return styleBlock;
			case 3:
				return styleBlock;
			default:
				return ((!confRec.b2) || A2($frandibar$elm_bootstrap$Bootstrap$Navbar$shouldHideMenu, state, confRec)) ? _List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('collapse navbar-collapse show')
					]) : _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block')
					]);
		}
	});
var $rtfeldman$elm_css$Html$Styled$nav = $rtfeldman$elm_css$Html$Styled$node('nav');
var $rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('sm');
		case 2:
			return $elm$core$Maybe$Just('md');
		case 3:
			return $elm$core$Maybe$Just('lg');
		default:
			return $elm$core$Maybe$Just('xl');
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$expandOption = function (size) {
	var toClass = function (sz) {
		return $rtfeldman$elm_css$Html$Styled$Attributes$class(
			'navbar-expand' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (s) {
						return '-' + s;
					},
					$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(sz))));
	};
	switch (size) {
		case 0:
			return _List_fromArray(
				[
					toClass(1)
				]);
		case 1:
			return _List_fromArray(
				[
					toClass(2)
				]);
		case 2:
			return _List_fromArray(
				[
					toClass(3)
				]);
		case 3:
			return _List_fromArray(
				[
					toClass(4)
				]);
		default:
			return _List_Nil;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$fixOption = function (fix) {
	if (!fix) {
		return 'fixed-top';
	} else {
		return 'fixed-bottom';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass = F2(
	function (prefix, role) {
		return $rtfeldman$elm_css$Html$Styled$Attributes$class(
			prefix + ('-' + function () {
				switch (role) {
					case 0:
						return 'primary';
					case 1:
						return 'secondary';
					case 2:
						return 'success';
					case 3:
						return 'info';
					case 4:
						return 'warning';
					case 5:
						return 'danger';
					case 6:
						return 'light';
					default:
						return 'dark';
				}
			}()));
	});
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$backgroundColorOption = function (bgClass) {
	switch (bgClass.$) {
		case 0:
			var role = bgClass.a;
			return A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg', role);
		case 1:
			var color = bgClass.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$Attributes$style,
				'background-color',
				$avh4$elm_color$Color$toCssString(color));
		default:
			var classString = bgClass.a;
			return $rtfeldman$elm_css$Html$Styled$Attributes$class(classString);
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$linkModifierClass = function (modifier) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		function () {
			if (!modifier) {
				return 'navbar-dark';
			} else {
				return 'navbar-light';
			}
		}());
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$schemeAttributes = function (_v0) {
	var modifier = _v0.fS;
	var bgColor = _v0.eZ;
	return _List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Navbar$linkModifierClass(modifier),
			$frandibar$elm_bootstrap$Bootstrap$Navbar$backgroundColorOption(bgColor)
		]);
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$navbarAttributes = function (options) {
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('navbar', true),
						_Utils_Tuple2('container', options.fF)
					]))
			]),
		_Utils_ap(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$expandOption(options.ey),
			_Utils_ap(
				function () {
					var _v0 = options.gy;
					if (!_v0.$) {
						var scheme_ = _v0.a;
						return $frandibar$elm_bootstrap$Bootstrap$Navbar$schemeAttributes(scheme_);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v1 = options.cp;
						if (!_v1.$) {
							var fix = _v1.a;
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									$frandibar$elm_bootstrap$Bootstrap$Navbar$fixOption(fix))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					options.eW))));
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$renderCustom = function (items_) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var item = _v0;
			return item;
		},
		items_);
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$getOrInitDropdownStatus = F2(
	function (id, _v0) {
		var dropdowns = _v0.bu;
		return A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Dict$get, id, dropdowns));
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$toggleOpen = F3(
	function (state, id, _v0) {
		var toMsg = _v0.gV;
		var currStatus = A2($frandibar$elm_bootstrap$Bootstrap$Navbar$getOrInitDropdownStatus, id, state);
		var newStatus = function () {
			switch (currStatus) {
				case 0:
					return 2;
				case 1:
					return 2;
				default:
					return 0;
			}
		}();
		return toMsg(
			A2(
				$frandibar$elm_bootstrap$Bootstrap$Navbar$mapState,
				function (s) {
					return _Utils_update(
						s,
						{
							bu: A3($elm$core$Dict$insert, id, newStatus, s.bu)
						});
				},
				state));
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$renderDropdownToggle = F4(
	function (state, id, configRec, _v0) {
		var attributes = _v0.eW;
		var children = _v0.i6;
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('nav-link dropdown-toggle'),
						$rtfeldman$elm_css$Html$Styled$Attributes$href('#'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$custom,
						'click',
						$elm$json$Json$Decode$succeed(
							{
								mJ: A3($frandibar$elm_bootstrap$Bootstrap$Navbar$toggleOpen, state, id, configRec),
								ni: true,
								nJ: false
							}))
					]),
				attributes),
			children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$renderDropdown = F3(
	function (state, configRec, _v0) {
		var ddRec = _v0;
		var needsDropup = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (fix) {
					if (fix === 1) {
						return true;
					} else {
						return false;
					}
				},
				configRec.j7.cp));
		var isShown = A2($frandibar$elm_bootstrap$Bootstrap$Navbar$getOrInitDropdownStatus, ddRec.dH, state) !== 2;
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('nav-item', true),
							_Utils_Tuple2('dropdown', true),
							_Utils_Tuple2('shown', isShown),
							_Utils_Tuple2('dropup', needsDropup)
						]))
				]),
			_List_fromArray(
				[
					A4($frandibar$elm_bootstrap$Bootstrap$Navbar$renderDropdownToggle, state, ddRec.dH, configRec, ddRec.k$),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('dropdown-menu', true),
									_Utils_Tuple2('show', isShown)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var item = _v1;
							return item;
						},
						ddRec.mx))
				]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$renderItemLink = function (_v0) {
	var attributes = _v0.eW;
	var children = _v0.i6;
	return A2(
		$rtfeldman$elm_css$Html$Styled$li,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('nav-item')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('nav-link')
						]),
					attributes),
				children)
			]));
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$renderNav = F3(
	function (state, configRec, navItems) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('navbar-nav mr-auto')
				]),
			A2(
				$elm$core$List$map,
				function (item) {
					if (!item.$) {
						var item_ = item.a;
						return $frandibar$elm_bootstrap$Bootstrap$Navbar$renderItemLink(item_);
					} else {
						var dropdown_ = item.a;
						return A3($frandibar$elm_bootstrap$Bootstrap$Navbar$renderDropdown, state, configRec, dropdown_);
					}
				},
				navItems));
	});
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $frandibar$elm_bootstrap$Bootstrap$Navbar$heightDecoder = function () {
	var tagDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (tag, val) {
				return _Utils_Tuple2(tag, val);
			}),
		A2($elm$json$Json$Decode$field, 'tagName', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$value);
	var resToDec = function (res) {
		if (!res.$) {
			var v = res.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			var err = res.a;
			return $elm$json$Json$Decode$fail(
				$elm$json$Json$Decode$errorToString(err));
		}
	};
	var fromNavDec = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['childNodes', '2', 'childNodes', '0', 'offsetHeight']),
				$elm$json$Json$Decode$float),
				A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['childNodes', '1', 'childNodes', '0', 'offsetHeight']),
				$elm$json$Json$Decode$float)
			]));
	var fromButtonDec = $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$parentElement(fromNavDec);
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var tag = _v0.a;
			var val = _v0.b;
			switch (tag) {
				case 'NAV':
					return resToDec(
						A2($elm$json$Json$Decode$decodeValue, fromNavDec, val));
				case 'BUTTON':
					return resToDec(
						A2($elm$json$Json$Decode$decodeValue, fromButtonDec, val));
				default:
					return $elm$json$Json$Decode$succeed(0);
			}
		},
		$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$target(
			$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$parentElement(tagDecoder)));
}();
var $frandibar$elm_bootstrap$Bootstrap$Navbar$toggleHandler = F2(
	function (state, configRec) {
		var height = state.jw;
		var updState = function (h) {
			return A2(
				$frandibar$elm_bootstrap$Bootstrap$Navbar$mapState,
				function (s) {
					return _Utils_update(
						s,
						{
							jw: $elm$core$Maybe$Just(h),
							aF: A2($frandibar$elm_bootstrap$Bootstrap$Navbar$visibilityTransition, configRec.b2, s.aF)
						});
				},
				state);
		};
		return A2(
			$rtfeldman$elm_css$Html$Styled$Events$on,
			'click',
			A2(
				$elm$json$Json$Decode$andThen,
				function (v) {
					return $elm$json$Json$Decode$succeed(
						configRec.gV(
							(v > 0) ? updState(v) : updState(
								A2($elm$core$Maybe$withDefault, 0, height))));
				},
				$frandibar$elm_bootstrap$Bootstrap$Navbar$heightDecoder));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $frandibar$elm_bootstrap$Bootstrap$Navbar$view = F2(
	function (state, conf) {
		var configRec = conf;
		return A2(
			$rtfeldman$elm_css$Html$Styled$nav,
			$frandibar$elm_bootstrap$Bootstrap$Navbar$navbarAttributes(configRec.j7),
			_Utils_ap(
				$frandibar$elm_bootstrap$Bootstrap$Navbar$maybeBrand(configRec.dq),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									'navbar-toggler' + A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											function (_v0) {
												return ' navbar-toggler-right';
											},
											configRec.dq))),
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
									A2($frandibar$elm_bootstrap$Bootstrap$Navbar$toggleHandler, state, configRec)
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('navbar-toggler-icon')
										]),
									_List_Nil)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							A2($frandibar$elm_bootstrap$Bootstrap$Navbar$menuAttributes, state, configRec),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									A2($frandibar$elm_bootstrap$Bootstrap$Navbar$menuWrapperAttributes, state, configRec),
									_Utils_ap(
										_List_fromArray(
											[
												A3($frandibar$elm_bootstrap$Bootstrap$Navbar$renderNav, state, configRec, configRec.mx)
											]),
										$frandibar$elm_bootstrap$Bootstrap$Navbar$renderCustom(configRec.fb)))
								]))
						]))));
	});
var $frandibar$elm_bootstrap$Bootstrap$Navbar$withAnimation = function (config_) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Navbar$updateConfig,
		function (conf) {
			return _Utils_update(
				conf,
				{b2: true});
		},
		config_);
};
var $author$project$Components$NavBar$view = F2(
	function (model, barElements) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Navbar$view,
			model.d3,
			A2(
				$frandibar$elm_bootstrap$Bootstrap$Navbar$customItems,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Navbar$customItem(
						A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('nav navbar-nav ml-auto')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$li,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('nav-item')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('nav-link text-white btn'),
													$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Components$NavBar$Logout)
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('ログアウト')
												]))
										]))
								])))
					]),
				A3(
					$elm$core$Basics$apR,
					A2(
						$elm$core$List$map,
						function (_v0) {
							var label = _v0.jP;
							var url = _v0.eD;
							return A2(
								$frandibar$elm_bootstrap$Bootstrap$Navbar$itemLink,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href(url),
										$rtfeldman$elm_css$Html$Styled$Attributes$class('text-white')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(label)
									]));
						},
						barElements),
					$frandibar$elm_bootstrap$Bootstrap$Navbar$items,
					$frandibar$elm_bootstrap$Bootstrap$Navbar$withAnimation(
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Navbar$attrs,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('navBar')
								]),
							$frandibar$elm_bootstrap$Bootstrap$Navbar$primary(
								$frandibar$elm_bootstrap$Bootstrap$Navbar$fixTop(
									$frandibar$elm_bootstrap$Bootstrap$Navbar$config($author$project$Components$NavBar$NavbarMsg))))))));
	});
var $author$project$Pages$Cms$cmsNavBar = function (navModel) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$map,
		$author$project$Pages$Cms$GotNavBarMsg,
		A2(
			$author$project$Components$NavBar$view,
			navModel,
			_List_fromArray(
				[
					{jP: 'Top', eD: '/cms'}
				])));
};
var $author$project$Page$RootPageRequired = F2(
	function (title, content) {
		return {lI: content, iB: title};
	});
var $author$project$Page$map = F2(
	function (f, rootPageRequired) {
		return A2(
			$author$project$Page$RootPageRequired,
			rootPageRequired.iB,
			A2($rtfeldman$elm_css$Html$Styled$map, f, rootPageRequired.lI));
	});
var $author$project$Pages$Cms$Others$EditMailAddress$OnChangeSelectedUser = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$OnToggleShowValidOnly = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitBulkSetValid = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitBulkUpdatePermalinkGroups = {$: 15};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Attrs = function (a) {
	return {$: 4, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Button$attrs = function (attrs_) {
	return $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Attrs(attrs_);
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Attrs = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Form$attrs = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size = modifier.a;
				return _Utils_update(
					options,
					{
						kK: $elm$core$Maybe$Just(size)
					});
			case 1:
				var coloring = modifier.a;
				return _Utils_update(
					options,
					{
						aX: $elm$core$Maybe$Just(coloring)
					});
			case 2:
				return _Utils_update(
					options,
					{e0: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{fg: val});
			default:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions = {eW: _List_Nil, e0: false, aX: $elm$core$Maybe$Nothing, fg: false, kK: $elm$core$Maybe$Nothing};
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$roleClass = function (role) {
	switch (role) {
		case 0:
			return 'primary';
		case 1:
			return 'secondary';
		case 2:
			return 'success';
		case 3:
			return 'info';
		case 4:
			return 'warning';
		case 5:
			return 'danger';
		case 6:
			return 'dark';
		case 7:
			return 'light';
		default:
			return 'link';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Internal$Button$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('btn', true),
						_Utils_Tuple2('btn-block', options.e0),
						_Utils_Tuple2('disabled', options.fg)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(options.fg)
			]),
		_Utils_ap(
			function () {
				var _v0 = A2($elm$core$Maybe$andThen, $frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption, options.kK);
				if (!_v0.$) {
					var s = _v0.a;
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('btn-' + s)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.aX;
					if (!_v1.$) {
						if (!_v1.a.$) {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									'btn-' + $frandibar$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						} else {
							var role = _v1.a.a;
							return _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class(
									'btn-outline-' + $frandibar$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
				options.eW)));
};
var $frandibar$elm_bootstrap$Bootstrap$Button$button = F2(
	function (options, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			$frandibar$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options),
			children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Checkbox = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$create = F2(
	function (options, label_) {
		return {jP: label_, j7: options};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Label = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$label = F2(
	function (attributes, children) {
		return {eW: attributes, i6: children};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var val = modifier.a;
				return _Utils_update(
					options,
					{
						dH: $elm$core$Maybe$Just(val)
					});
			case 1:
				var val = modifier.a;
				return _Utils_update(
					options,
					{u: val});
			case 2:
				return _Utils_update(
					options,
					{dJ: true});
			case 3:
				var toMsg = modifier.a;
				return _Utils_update(
					options,
					{
						f$: $elm$core$Maybe$Just(toMsg)
					});
			case 4:
				return _Utils_update(
					options,
					{P: true});
			case 5:
				var val = modifier.a;
				return _Utils_update(
					options,
					{fg: val});
			case 6:
				var validation = modifier.a;
				return _Utils_update(
					options,
					{
						g8: $elm$core$Maybe$Just(validation)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Off = 1;
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$defaultOptions = {eW: _List_Nil, P: false, fg: false, dH: $elm$core$Maybe$Nothing, dJ: false, f$: $elm$core$Maybe$Nothing, u: 1, g8: $elm$core$Maybe$Nothing};
var $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Html$Styled$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $rtfeldman$elm_css$Html$Styled$Events$onCheck = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetChecked));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$attribute = $rtfeldman$elm_css$VirtualDom$Styled$attribute;
var $rtfeldman$elm_css$Html$Styled$Attributes$checked = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('checked');
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$stateAttribute = function (state) {
	switch (state) {
		case 0:
			return $rtfeldman$elm_css$Html$Styled$Attributes$checked(true);
		case 1:
			return $rtfeldman$elm_css$Html$Styled$Attributes$checked(false);
		default:
			return A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'indeterminate', 'true');
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString = function (validation) {
	if (!validation) {
		return 'is-valid';
	} else {
		return 'is-invalid';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$toAttributes = function (options) {
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check-input', !options.P),
						_Utils_Tuple2('custom-control-input', options.P)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(options.fg),
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$stateAttribute(options.u)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Events$onCheck, options.f$),
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$id, options.dH)
					])),
			_Utils_ap(
				function () {
					var _v0 = options.g8;
					if (!_v0.$) {
						var v = _v0.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								$frandibar$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(v))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				options.eW)));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$view = function (_v0) {
	var chk = _v0;
	var opts = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$defaultOptions, chk.j7);
	var _v1 = chk.jP;
	var label_ = _v1;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-check', !opts.P),
						_Utils_Tuple2('form-check-inline', (!opts.P) && opts.dJ),
						_Utils_Tuple2('custom-control', opts.P),
						_Utils_Tuple2('custom-checkbox', opts.P),
						_Utils_Tuple2('custom-control-inline', opts.dJ && opts.P)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$toAttributes(opts),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$label,
				_Utils_ap(
					label_.eW,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('form-check-label', !opts.P),
										_Utils_Tuple2('custom-control-label', opts.P)
									]))
							]),
						function () {
							var _v2 = opts.dH;
							if (!_v2.$) {
								var v = _v2.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for(v)
									]);
							} else {
								return _List_Nil;
							}
						}())),
				label_.i6)
			]));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox = F2(
	function (options, labelText) {
		return $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$view(
			A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$create,
				options,
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$label,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(labelText)
						]))));
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$On = 0;
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Value = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked = function (isCheck) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Value(
		isCheck ? 0 : 1);
};
var $rtfeldman$elm_css$Html$Styled$form = $rtfeldman$elm_css$Html$Styled$node('form');
var $frandibar$elm_bootstrap$Bootstrap$Form$form = F2(
	function (attributes, children) {
		return A2($rtfeldman$elm_css$Html$Styled$form, attributes, children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$formInline = function (attributes) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$form(
		A2(
			$elm$core$List$cons,
			$rtfeldman$elm_css$Html$Styled$Attributes$class('form-inline'),
			attributes));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$applyModifier = F2(
	function (modifier, options) {
		var value = modifier;
		return _Utils_update(
			options,
			{
				eW: _Utils_ap(options.eW, value)
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$defaultOptions = {eW: _List_Nil};
var $frandibar$elm_bootstrap$Bootstrap$Form$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Form$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Form$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('form-group')
			]),
		options.eW);
};
var $frandibar$elm_bootstrap$Bootstrap$Form$group = F2(
	function (options, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			$frandibar$elm_bootstrap$Bootstrap$Form$toAttributes(options),
			children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Id = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id = function (theId) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Id(theId);
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Form$label = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('form-control-label'),
				attributes),
			children);
	});
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.m);
	});
var $rtfeldman$elm_css$Css$animationDuration = function (arg) {
	return A2($rtfeldman$elm_css$Css$prop1, 'animation-duration', arg);
};
var $rtfeldman$elm_css$Css$animationIterationCount = function (arg) {
	return A2($rtfeldman$elm_css$Css$prop1, 'animation-iteration-count', arg);
};
var $rtfeldman$elm_css$Css$Preprocess$WithKeyframes = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$animationName = function (arg) {
	return ((arg.m === 'none') || ((arg.m === 'inherit') || ((arg.m === 'unset') || (arg.m === 'initial')))) ? A2($rtfeldman$elm_css$Css$prop1, 'animation-name', arg) : $rtfeldman$elm_css$Css$Preprocess$WithKeyframes(arg.m);
};
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$auto = {ll: 0, c: 0, cq: 0, fD: 0, my: 0, cA: 0, a8: 0, aI: 0, cK: 0, av: 0, gR: 0, df: 0, Z: 0, m: 'auto'};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.m);
};
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.m, argB.m, argC.m])));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$borderTop3 = $rtfeldman$elm_css$Css$prop3('border-top');
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var $rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return $elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
				$rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					$elm$core$List$singleton(
						$rtfeldman$elm_css$Css$Preprocess$stylesheet(
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		$elm$virtual_dom$VirtualDom$property,
		'className',
		$elm$json$Json$Encode$string(classname));
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$Css$fixed = {$7: 0, d9: 0, gR: 0, m: 'fixed'};
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		b6: 1,
		hh: 0,
		hm: 0,
		hz: 0,
		id: 0,
		m: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				b6: alpha / 255,
				hh: blue,
				hm: 0,
				hz: green,
				id: red,
				m: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		bD: 0,
		aI: 0,
		mW: 0,
		fU: 0,
		bd: val,
		dh: '',
		eC: 0,
		m: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			iK: 0,
			i0: 0,
			cq: 0,
			I: 0,
			bB: 0,
			cA: 0,
			a8: 0,
			cB: 0,
			cC: 0,
			bC: 0,
			bD: 0,
			aI: 0,
			bd: numericValue,
			de: 0,
			dh: unitLabel,
			eC: units,
			m: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ', ', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			b6: alpha,
			hh: b,
			hm: 0,
			hz: g,
			id: r,
			m: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $rtfeldman$elm_css$Css$sec = function (amount) {
	return {
		ji: 0,
		m: $elm$core$String$fromFloat(amount) + 's'
	};
};
var $rtfeldman$elm_css$Css$solid = {N: 0, bW: 0, m: 'solid'};
var $rtfeldman$elm_css$Css$Internal$printKeyframeSelector = function (_v0) {
	var percentage = _v0.a;
	var properties = _v0.b;
	var propertiesStr = A2(
		$elm$core$String$join,
		'',
		A2(
			$elm$core$List$map,
			function (_v1) {
				var prop = _v1;
				return prop + ';';
			},
			properties));
	var percentageStr = $elm$core$String$fromInt(percentage) + '%';
	return percentageStr + (' {' + (propertiesStr + '}'));
};
var $rtfeldman$elm_css$Css$Internal$compileKeyframes = function (tuples) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Internal$printKeyframeSelector, tuples));
};
var $rtfeldman$elm_css$Css$Animations$keyframes = function (tuples) {
	return $elm$core$List$isEmpty(tuples) ? {hR: 0, hX: 0, m: 'none'} : {
		hR: 0,
		hX: 0,
		m: $rtfeldman$elm_css$Css$Internal$compileKeyframes(tuples)
	};
};
var $rtfeldman$elm_css$Css$Internal$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Animations$property = F2(
	function (key, value) {
		return key + (':' + value);
	});
var $author$project$Components$Loading$spinKeyframe = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'rotate(0deg)')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'rotate(360deg)')
				]))
		]));
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$Components$Loading$loadingCenter = function (diameter) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
						$rtfeldman$elm_css$Css$top(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$left(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$bottom(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$right(
						$rtfeldman$elm_css$Css$px(0)),
						$rtfeldman$elm_css$Css$backgroundColor(
						A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.3))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed),
								$rtfeldman$elm_css$Css$top(
								$rtfeldman$elm_css$Css$pct(50)),
								$rtfeldman$elm_css$Css$left(
								$rtfeldman$elm_css$Css$pct(50)),
								A3(
								$rtfeldman$elm_css$Css$border3,
								$rtfeldman$elm_css$Css$px(diameter / 12),
								$rtfeldman$elm_css$Css$solid,
								$rtfeldman$elm_css$Css$hex('fff')),
								A3(
								$rtfeldman$elm_css$Css$borderTop3,
								$rtfeldman$elm_css$Css$px(diameter / 12),
								$rtfeldman$elm_css$Css$solid,
								$rtfeldman$elm_css$Css$hex('007bff')),
								$rtfeldman$elm_css$Css$borderRadius(
								$rtfeldman$elm_css$Css$pct(50)),
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$px(diameter)),
								$rtfeldman$elm_css$Css$height(
								$rtfeldman$elm_css$Css$px(diameter)),
								$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$auto),
								$rtfeldman$elm_css$Css$animationName($author$project$Components$Loading$spinKeyframe),
								$rtfeldman$elm_css$Css$animationDuration(
								$rtfeldman$elm_css$Css$sec(2)),
								$rtfeldman$elm_css$Css$animationIterationCount(
								$rtfeldman$elm_css$Css$num(300))
							]))
					]),
				_List_Nil)
			]));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$OnChecked = function (a) {
	return {$: 3, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck = function (toMsg) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$OnChecked(toMsg);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $frandibar$elm_bootstrap$Bootstrap$Button$onClick = function (message) {
	return $frandibar$elm_bootstrap$Bootstrap$Button$attrs(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
				'click',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(message, true)))
			]));
};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Primary = 0;
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Button$primary = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled(0));
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Secondary = 1;
var $frandibar$elm_bootstrap$Bootstrap$Button$secondary = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled(1));
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Size = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Button$small = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Size(1);
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Success = 2;
var $frandibar$elm_bootstrap$Bootstrap$Button$success = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled(2));
var $rtfeldman$elm_css$Html$Styled$table = $rtfeldman$elm_css$Html$Styled$node('table');
var $rtfeldman$elm_css$Html$Styled$tbody = $rtfeldman$elm_css$Html$Styled$node('tbody');
var $rtfeldman$elm_css$Html$Styled$th = $rtfeldman$elm_css$Html$Styled$node('th');
var $rtfeldman$elm_css$Html$Styled$thead = $rtfeldman$elm_css$Html$Styled$node('thead');
var $rtfeldman$elm_css$Html$Styled$tr = $rtfeldman$elm_css$Html$Styled$node('tr');
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$Attrs = function (a) {
	return {$: 6, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs = function (attrs_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Select$Attrs(attrs_);
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$Item = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$item = F2(
	function (attributes, children) {
		return A2($rtfeldman$elm_css$Html$Styled$option, attributes, children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$Select = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$create = F2(
	function (options, items) {
		return {mx: items, j7: options};
	});
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size_ = modifier.a;
				return _Utils_update(
					options,
					{
						kK: $elm$core$Maybe$Just(size_)
					});
			case 1:
				var id_ = modifier.a;
				return _Utils_update(
					options,
					{
						dH: $elm$core$Maybe$Just(id_)
					});
			case 2:
				return _Utils_update(
					options,
					{P: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{fg: val});
			case 4:
				var onChange_ = modifier.a;
				return _Utils_update(
					options,
					{
						j3: $elm$core$Maybe$Just(onChange_)
					});
			case 5:
				var validation_ = modifier.a;
				return _Utils_update(
					options,
					{
						g8: $elm$core$Maybe$Just(validation_)
					});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$customEventOnChange = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$defaultOptions = {eW: _List_Nil, P: false, fg: false, dH: $elm$core$Maybe$Nothing, j3: $elm$core$Maybe$Nothing, kK: $elm$core$Maybe$Nothing, g8: $elm$core$Maybe$Nothing};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$sizeAttribute = F2(
	function (isCustom, size_) {
		var prefix = isCustom ? 'custom-select-' : 'form-control-';
		return A2(
			$elm$core$Maybe$map,
			function (s) {
				return $rtfeldman$elm_css$Html$Styled$Attributes$class(
					_Utils_ap(prefix, s));
			},
			$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size_));
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$validationAttribute = function (validation_) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		$frandibar$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(validation_));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Form$Select$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Form$Select$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('form-control', !options.P),
						_Utils_Tuple2('custom-select', options.P)
					])),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(options.fg)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$id, options.dH),
						A2(
						$elm$core$Maybe$andThen,
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$sizeAttribute(options.P),
						options.kK),
						A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$Form$Select$customEventOnChange, options.j3),
						A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$Form$Select$validationAttribute, options.g8)
					])),
			options.eW));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$view = function (_v0) {
	var options = _v0.j7;
	var items = _v0.mx;
	return A2(
		$rtfeldman$elm_css$Html$Styled$select,
		$frandibar$elm_bootstrap$Bootstrap$Form$Select$toAttributes(options),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var e = _v1;
				return e;
			},
			items));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$select = F2(
	function (options, items) {
		return $frandibar$elm_bootstrap$Bootstrap$Form$Select$view(
			A2($frandibar$elm_bootstrap$Bootstrap$Form$Select$create, options, items));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$selected = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('selected');
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Components$UserSelector$userSelector = F3(
	function (users, selectedUser, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(selectedUser))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (user) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(user.k7)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedUser),
												user.k7))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(user.n2)
										]));
							},
							users)))
				]));
	});
var $author$project$Pages$Cms$Others$EditMailAddress$OnUpdateNewPermalinkGroupName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$OnUpdateNewSupervisor = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitAddPermalinkGroup = function (a) {
	return {$: 14, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$OnInput = function (a) {
	return {$: 5, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput = function (toMsg) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Input$OnInput(toMsg);
};
var $rtfeldman$elm_css$Html$Styled$td = $rtfeldman$elm_css$Html$Styled$node('td');
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Text = 0;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Input = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Type = function (a) {
	return {$: 2, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$create = F2(
	function (tipe, options) {
		return {
			j7: A2(
				$elm$core$List$cons,
				$frandibar$elm_bootstrap$Bootstrap$Form$Input$Type(tipe),
				options)
		};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size_ = modifier.a;
				return _Utils_update(
					options,
					{
						kK: $elm$core$Maybe$Just(size_)
					});
			case 1:
				var id_ = modifier.a;
				return _Utils_update(
					options,
					{
						dH: $elm$core$Maybe$Just(id_)
					});
			case 2:
				var tipe = modifier.a;
				return _Utils_update(
					options,
					{ex: tipe});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{fg: val});
			case 4:
				var value_ = modifier.a;
				return _Utils_update(
					options,
					{
						m: $elm$core$Maybe$Just(value_)
					});
			case 7:
				var value_ = modifier.a;
				return _Utils_update(
					options,
					{
						gb: $elm$core$Maybe$Just(value_)
					});
			case 5:
				var onInput_ = modifier.a;
				return _Utils_update(
					options,
					{
						aK: $elm$core$Maybe$Just(onInput_)
					});
			case 6:
				var validation_ = modifier.a;
				return _Utils_update(
					options,
					{
						g8: $elm$core$Maybe$Just(validation_)
					});
			case 8:
				var val = modifier.a;
				return _Utils_update(
					options,
					{gr: val});
			case 9:
				var val = modifier.a;
				return _Utils_update(
					options,
					{d8: val});
			default:
				var attrs_ = modifier.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$defaultOptions = {eW: _List_Nil, fg: false, dH: $elm$core$Maybe$Nothing, aK: $elm$core$Maybe$Nothing, gb: $elm$core$Maybe$Nothing, d8: false, gr: false, kK: $elm$core$Maybe$Nothing, ex: 0, g8: $elm$core$Maybe$Nothing, m: $elm$core$Maybe$Nothing};
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $rtfeldman$elm_css$Html$Styled$Attributes$readonly = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('readOnly');
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$sizeAttribute = function (size) {
	return A2(
		$elm$core$Maybe$map,
		function (s) {
			return $rtfeldman$elm_css$Html$Styled$Attributes$class('form-control-' + s);
		},
		$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$typeAttribute = function (inputType) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$type_(
		function () {
			switch (inputType) {
				case 0:
					return 'text';
				case 1:
					return 'password';
				case 2:
					return 'datetime-local';
				case 3:
					return 'date';
				case 4:
					return 'month';
				case 5:
					return 'time';
				case 6:
					return 'week';
				case 7:
					return 'number';
				case 8:
					return 'email';
				case 9:
					return 'url';
				case 10:
					return 'search';
				case 11:
					return 'tel';
				default:
					return 'color';
			}
		}());
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$validationAttribute = function (validation) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		$frandibar$elm_bootstrap$Bootstrap$Form$FormInternal$validationToString(validation));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$toAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Form$Input$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Form$Input$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
				options.d8 ? 'form-control-plaintext' : 'form-control'),
				$rtfeldman$elm_css$Html$Styled$Attributes$disabled(options.fg),
				$rtfeldman$elm_css$Html$Styled$Attributes$readonly(options.gr || options.d8),
				$frandibar$elm_bootstrap$Bootstrap$Form$Input$typeAttribute(options.ex)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$id, options.dH),
						A2($elm$core$Maybe$andThen, $frandibar$elm_bootstrap$Bootstrap$Form$Input$sizeAttribute, options.kK),
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$value, options.m),
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Attributes$placeholder, options.gb),
						A2($elm$core$Maybe$map, $rtfeldman$elm_css$Html$Styled$Events$onInput, options.aK),
						A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$Form$Input$validationAttribute, options.g8)
					])),
			options.eW));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$view = function (_v0) {
	var options = _v0.j7;
	return A2(
		$rtfeldman$elm_css$Html$Styled$input,
		$frandibar$elm_bootstrap$Bootstrap$Form$Input$toAttributes(options),
		_List_Nil);
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$input = F2(
	function (tipe, options) {
		return $frandibar$elm_bootstrap$Bootstrap$Form$Input$view(
			A2($frandibar$elm_bootstrap$Bootstrap$Form$Input$create, tipe, options));
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$text = $frandibar$elm_bootstrap$Bootstrap$Form$Input$input(0);
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Value = function (a) {
	return {$: 4, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$value = function (value_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Input$Value(value_);
};
var $author$project$Pages$Cms$Others$EditMailAddress$viewAddPermalinkGroup = function (permalinkGroup) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.aE),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Others$EditMailAddress$OnUpdateNewSupervisor)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.as),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Others$EditMailAddress$OnUpdateNewPermalinkGroupName)
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_Utils_ap(
							permalinkGroup.R ? _List_fromArray(
								[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Others$EditMailAddress$SubmitAddPermalinkGroup(permalinkGroup))
								])),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Add')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Cms$Others$EditMailAddress$OnUpdatePermalinkGroupName = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$OnUpdateSupervisor = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$OnUpdateValid = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitDeletePermalinkGroup = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitUpdatePermalinkGroup = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$ToggleExpand = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$OnSelectNewTargetStore = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitAddTarget = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitDeleteTarget = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Pages$Cms$Others$EditMailAddress$SubmitToggleAllStores = function (a) {
	return {$: 25, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$colspan = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Components$Atoms$ToggleSwitch$view = function (_v0) {
	var isOn = _v0.mu;
	var onClick = _v0.mY;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Events$onClick(onClick),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'relative'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'inline-block'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '46px'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '24px'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'cursor', 'pointer'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'flex-shrink', '0')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'absolute'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'top', '0'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'left', '0'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'right', '0'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'bottom', '0'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$style,
						'background-color',
						isOn ? '#2196F3' : '#ccc'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border-radius', '24px')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'absolute'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '20px'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '20px'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'bottom', '2px'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$style,
						'left',
						isOn ? '24px' : '2px'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', 'white'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border-radius', '50%')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Cms$Others$EditMailAddress$viewTargetsRow = F4(
	function (stores, targets, newTargetStoreIds, mailId) {
		var selectedStoreId = A2($elm$core$Dict$get, mailId, newTargetStoreIds);
		var individualTargets = A2(
			$elm$core$List$filter,
			function (t) {
				return t.gZ === 2;
			},
			targets);
		var hasAllStores = A2(
			$elm$core$List$any,
			function (t) {
				return t.gZ === 1;
			},
			targets);
		var availableStores = A2(
			$elm$core$List$filter,
			function (s) {
				return !A2(
					$elm$core$List$any,
					function (t) {
						return _Utils_eq(t.iw, s.iw);
					},
					individualTargets);
			},
			stores);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$colspan(6),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '4px 4px 8px 40px')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex align-items-center mb-2')
								]),
							_List_fromArray(
								[
									$author$project$Components$Atoms$ToggleSwitch$view(
									{
										mu: hasAllStores,
										mY: $author$project$Pages$Cms$Others$EditMailAddress$SubmitToggleAllStores(mailId)
									}),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-left', '8px'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '16px'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '0.95em')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('全店舗送信')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$select,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput(
											$author$project$Pages$Cms$Others$EditMailAddress$OnSelectNewTargetStore(mailId)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '4px')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('-- 個別店舗を追加 --')
												])),
										A2(
											$elm$core$List$map,
											function (s) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$option,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$value(
															$elm$core$String$fromInt(s.iw))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(s.kS)
														]));
											},
											availableStores))),
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Button$button,
									_Utils_ap(
										$elm_community$maybe_extra$Maybe$Extra$isJust(selectedStoreId) ? _List_fromArray(
											[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
												$author$project$Pages$Cms$Others$EditMailAddress$SubmitAddTarget(mailId))
											])),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Add')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-wrap')
								]),
							A2(
								$elm$core$List$map,
								function (t) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'inline-flex'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'align-items', 'center'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', '#c8e6c9'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border-radius', '4px'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '3px 6px'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '6px'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '4px')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', '#1b5e20')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(t.kS)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$button,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Events$onClick(
														A2($author$project$Pages$Cms$Others$EditMailAddress$SubmitDeleteTarget, mailId, t.hT)),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background', 'none'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border', 'none'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'cursor', 'pointer'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '0 0 0 6px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', '#888'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '1em')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('×')
													]))
											]));
								},
								individualTargets))
						]))
				]));
	});
var $author$project$Pages$Cms$Others$EditMailAddress$viewPermalinkGroup = F5(
	function (stores, expandedMailIds, mailTargets, newTargetStoreIds, permalinkGroup) {
		var mailId = permalinkGroup.T;
		var targets = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, mailId, mailTargets));
		var isExpanded = A2($elm$core$Set$member, mailId, expandedMailIds);
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Cms$Others$EditMailAddress$ToggleExpand(mailId))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										isExpanded ? '▲' : '▼')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.aE),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
										$author$project$Pages$Cms$Others$EditMailAddress$OnUpdateSupervisor(mailId))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.as),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
										$author$project$Pages$Cms$Others$EditMailAddress$OnUpdatePermalinkGroupName(mailId))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(permalinkGroup.aP),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$author$project$Pages$Cms$Others$EditMailAddress$OnUpdateValid(mailId))
									]),
								'')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_Utils_ap(
									permalinkGroup.R ? _List_fromArray(
										[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
											$author$project$Pages$Cms$Others$EditMailAddress$SubmitUpdatePermalinkGroup(permalinkGroup))
										])),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Update')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Cms$Others$EditMailAddress$SubmitDeletePermalinkGroup(mailId))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Delete')
									]))
							]))
					])),
			isExpanded ? _List_fromArray(
				[
					A4($author$project$Pages$Cms$Others$EditMailAddress$viewTargetsRow, stores, targets, newTargetStoreIds, mailId)
				]) : _List_Nil);
	});
var $author$project$Pages$Cms$Others$EditMailAddress$viewContent = function (model) {
	var displayedGroups = model.ej ? A2(
		$elm$core$List$filter,
		function ($) {
			return $.aP;
		},
		model.i) : model.i;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'text-align', 'center')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'max-width', '1100px'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '0 auto')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- CRUD table users mailaddress')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('User')
											])),
										A3(
										$author$project$Components$UserSelector$userSelector,
										model.k8,
										model.$9,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Others$EditMailAddress$OnChangeSelectedUser)
											]))
									]))
							])),
						(!_Utils_eq(model.$9, $elm$core$Maybe$Nothing)) ? A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-2 d-flex justify-content-between align-items-center')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('show-valid-only'),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.ej),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Cms$Others$EditMailAddress$OnToggleShowValidOnly)
									]),
								'有効のみ表示'),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex')
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$success,
												$frandibar$elm_bootstrap$Bootstrap$Button$small,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
												$author$project$Pages$Cms$Others$EditMailAddress$SubmitBulkSetValid(true)),
												$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '4px')
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て有効')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$secondary,
												$frandibar$elm_bootstrap$Bootstrap$Button$small,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
												$author$project$Pages$Cms$Others$EditMailAddress$SubmitBulkSetValid(false)),
												$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '8px')
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て無効')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$primary,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Others$EditMailAddress$SubmitBulkUpdatePermalinkGroups)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('一括更新')
											]))
									]))
							])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '50px')
													]),
												_List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Name')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Address')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '60px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Valid')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Update')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Delete')
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									$author$project$Pages$Cms$Others$EditMailAddress$viewAddPermalinkGroup(model.ba),
									A2(
										$elm$core$List$concatMap,
										A4($author$project$Pages$Cms$Others$EditMailAddress$viewPermalinkGroup, model.aN, model.a0, model.ae, model.cJ),
										displayedGroups)))
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Others$EditMailAddress$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Others$EditMailAddress$viewContent(model),
		iB: 'Mailing List'
	};
};
var $author$project$Pages$Cms$Others$GetAccessCount$OnChangeSelectedDateFrom = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Cms$Others$GetAccessCount$OnChangeSelectedDateTo = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$Others$GetAccessCount$OnChangeSelectedUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Others$GetAccessCount$OnSend = {$: 5};
var $rtfeldman$elm_css$Html$Styled$Attributes$align = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('align');
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Attrs = function (a) {
	return {$: 10, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs = function (attrs_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Input$Attrs(attrs_);
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Date = 3;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$date = $frandibar$elm_bootstrap$Bootstrap$Form$Input$input(3);
var $author$project$Pages$Cms$Others$GetAccessCount$userNameOfId = F2(
	function (maybeUserId, users) {
		if (!maybeUserId.$) {
			var userId = maybeUserId.a;
			return 'ユーザ : ' + A2(
				$elm$core$Maybe$withDefault,
				{k7: -1, n2: ''},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (user) {
							return _Utils_eq(user.k7, userId);
						},
						users))).n2;
		} else {
			return '';
		}
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$Pages$Cms$Others$GetAccessCount$viewTrEachDay = function (accessCountsEachDays) {
	var extractDate = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('(\\d+)-0?(\\d+)-0?(\\d+)T.*'));
	var formatDate = function (s) {
		var _v0 = A2($elm$regex$Regex$find, extractDate, s);
		if (_v0.b) {
			var firstMatch = _v0.a;
			var _v1 = firstMatch.nM;
			if (((((_v1.b && (!_v1.a.$)) && _v1.b.b) && (!_v1.b.a.$)) && _v1.b.b.b) && (!_v1.b.b.a.$)) {
				var year = _v1.a.a;
				var _v2 = _v1.b;
				var month = _v2.a.a;
				var _v3 = _v2.b;
				var day = _v3.a.a;
				return $elm$core$String$concat(
					_List_fromArray(
						[year, '年', month, '月', day, '日']));
			} else {
				return 'regex error';
			}
		} else {
			return 'regex error';
		}
	};
	var rowOfDay = function (accessCountsEachDay) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							formatDate(
								A2($elm$core$Maybe$withDefault, '', accessCountsEachDay.iL)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, 0, accessCountsEachDay.dl)))
						]))
				]));
	};
	return A2($elm$core$List$map, rowOfDay, accessCountsEachDays);
};
var $author$project$Pages$Cms$Others$GetAccessCount$viewTrTotal = function (accessCountsTotal) {
	return _List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('合計')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, 0, accessCountsTotal.dl)))
						]))
				]))
		]);
};
var $author$project$Pages$Cms$Others$GetAccessCount$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				model.cv ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('User')
									])),
								A3(
								$author$project$Components$UserSelector$userSelector,
								model.k8,
								model.$9,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Others$GetAccessCount$OnChangeSelectedUser)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('From')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Others$GetAccessCount$OnChangeSelectedDateFrom)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('To')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Others$GetAccessCount$OnChangeSelectedDateTo)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Others$GetAccessCount$OnSend)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Pages$Cms$Others$GetAccessCount$userNameOfId, model.b3.iF, model.k8))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('日付')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('アクセス回数')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						_Utils_ap(
							$author$project$Pages$Cms$Others$GetAccessCount$viewTrEachDay(model.b3.hc),
							$author$project$Pages$Cms$Others$GetAccessCount$viewTrTotal(model.b3.hb)))
					]))
			]));
};
var $author$project$Pages$Cms$Others$GetAccessCount$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Others$GetAccessCount$viewContent(model),
		iB: 'アクセス数カウント'
	};
};
var $author$project$Pages$Cms$Products$AddProductConfig$Add = {$: 6};
var $author$project$Pages$Cms$Products$AddProductConfig$AddChangeJan = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Cms$Products$AddProductConfig$AddChangeKataban = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$Products$AddProductConfig$OnChangeMaker = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Html$Styled$hr = $rtfeldman$elm_css$Html$Styled$node('hr');
var $author$project$Components$MakerSelector$makerSelector = F3(
	function (makers, selectedMaker, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(selectedMaker))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (maker) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(maker.jW)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedMaker),
												maker.jW))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(maker.mH)
										]));
							},
							makers)))
				]));
	});
var $author$project$Pages$Cms$Products$AddProductConfig$OnChangeBigCategory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Cms$Products$AddProductConfig$OnChangeSmallCategory = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$Products$AddProductConfig$OnChangeUserId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CategorySelector$bigCategorySelector = F3(
	function (bigCategories, selectedBigCategory, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(
										A2($elm$core$Maybe$withDefault, -1, selectedBigCategory),
										-1))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (bigCategory) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(bigCategory.e_)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedBigCategory),
												bigCategory.e_))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(bigCategory.lu)
										]));
							},
							bigCategories)))
				]));
	});
var $author$project$Components$CategorySelector$smallCategorySelector = F4(
	function (smallCategories, selectedSmallCategory, selectedBigCategory, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(
										A2($elm$core$Maybe$withDefault, -1, selectedSmallCategory),
										-1))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (smallCategory) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(smallCategory.ir)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedSmallCategory),
												smallCategory.ir))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(smallCategory.nF)
										]));
							},
							A2(
								$elm$core$List$filter,
								function (smallCategory) {
									return _Utils_eq(
										selectedBigCategory,
										$elm$core$Maybe$Just(-1)) || _Utils_eq(
										A2($elm$core$Maybe$withDefault, -1, selectedBigCategory),
										smallCategory.e_);
								},
								smallCategories))))
				]));
	});
var $author$project$Pages$Cms$Products$AddProductConfig$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('')
							])),
						A3(
						$author$project$Components$UserSelector$userSelector,
						model.k8,
						model.gF,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Cms$Products$AddProductConfig$OnChangeUserId, $elm$core$String$toInt))
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$AddProductConfig$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$AddProductConfig$OnChangeSmallCategory)
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Products$AddProductConfig$viewContent = function (model) {
	var addkataban = A2(
		$rtfeldman$elm_css$Html$Styled$input,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
				$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('Input 型番'),
				$rtfeldman$elm_css$Html$Styled$Attributes$value(model.b5),
				$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$AddProductConfig$AddChangeKataban)
			]),
		_List_Nil);
	var addJan = A2(
		$rtfeldman$elm_css$Html$Styled$input,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
				$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('Input JAN-CODE'),
				$rtfeldman$elm_css$Html$Styled$Attributes$value(model.b4),
				$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$AddProductConfig$AddChangeJan)
			]),
		_List_Nil);
	var add = A2(
		$frandibar$elm_bootstrap$Bootstrap$Button$button,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$AddProductConfig$Add)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('　　add　　')
			]));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JANコード')
											])),
										addJan
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('　型番：')
											])),
										addkataban
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('メーカー')
											])),
										A3(
										$author$project$Components$MakerSelector$makerSelector,
										model.cE,
										model.eh,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$AddProductConfig$OnChangeMaker)
											]))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$AddProductConfig$viewProductFilter(model),
						A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
						(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
						(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							])) : A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[add]))
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Products$AddProductConfig$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$AddProductConfig$viewContent(model),
		iB: '商品の追加'
	};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnChangeUserId = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ユーザ')
							])),
						A3(
						$author$project$Components$UserSelector$userSelector,
						model.k8,
						model.gF,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnChangeUserId, $elm$core$String$toInt))
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$ChangeDisplayInterval$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$ChangeDisplayInterval$OnChangeSmallCategory)
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateAllProducts = {$: 9};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$UpdateAnyPoint = function (a) {
	return {$: 18, a: a};
};
var $rtfeldman$elm_css$Html$Styled$br = $rtfeldman$elm_css$Html$Styled$node('br');
var $rtfeldman$elm_css$Html$Styled$Attributes$max = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('max');
var $rtfeldman$elm_css$Html$Styled$Attributes$min = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('min');
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Number = 7;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$number = $frandibar$elm_bootstrap$Bootstrap$Form$Input$input(7);
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateDisplayInterval = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateInterval = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateProduct = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Utils$Helpers$calculatePriceWithoutPoint = F2(
	function (price, point) {
		return ((price * (100 - point)) / 100) | 0;
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Disabled = function (a) {
	return {$: 5, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled = function (disabled_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Disabled(disabled_);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$draggable = $rtfeldman$elm_css$VirtualDom$Styled$attribute('draggable');
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$DragStart = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$Drop = {$: 17};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Cms$Products$ChangeDisplayInterval$Drop),
		m7: $author$project$Pages$Cms$Products$ChangeDisplayInterval$DragStart(ind)
	};
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$DragOver = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$MoveOnDrop = 1;
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Cms$Products$ChangeDisplayInterval$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Cms$Products$ChangeDisplayInterval$DragOver(ind)
	};
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute = function (prop) {
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, prop, _List_Nil, '');
};
var $rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledAttribute;
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$intToOption = F2(
	function (selected_v, v) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(
					$elm$core$String$fromInt(v)),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(v, selected_v))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(v))
				]));
	});
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$Event = F2(
	function (dataTransfer, mouseEvent) {
		return {lO: dataTransfer, mR: mouseEvent};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$DataTransfer = F3(
	function (files, types, dropEffect) {
		return {lZ: dropEffect, l8: files, eA: types};
	});
var $elm$file$File$decoder = _File_decoder;
var $mpizenberg$elm_pointer_events$Internal$Decode$all = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf = function (itemDecoder) {
	var decodeOne = function (n) {
		return A2(
			$elm$json$Json$Decode$field,
			$elm$core$String$fromInt(n),
			itemDecoder);
	};
	var decodeN = function (n) {
		return $mpizenberg$elm_pointer_events$Internal$Decode$all(
			A2(
				$elm$core$List$map,
				decodeOne,
				A2($elm$core$List$range, 0, n - 1)));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeN,
		A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$fileListDecoder = $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$dataTransferDecoder = A4(
	$elm$json$Json$Decode$map3,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$DataTransfer,
	A2(
		$elm$json$Json$Decode$field,
		'files',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$fileListDecoder($elm$file$File$decoder)),
	A2(
		$elm$json$Json$Decode$field,
		'types',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'dropEffect', $elm$json$Json$Decode$string));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event = F6(
	function (keys, button, clientPos, offsetPos, pagePos, screenPos) {
		return {lx: button, lE: clientPos, mz: keys, mX: offsetPos, nb: pagePos, nv: screenPos};
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$BackButton = 4;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ErrorButton = 0;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$ForwardButton = 5;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MainButton = 1;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$MiddleButton = 2;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$SecondButton = 3;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId = function (id) {
	switch (id) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		default:
			return 0;
	}
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder = A2(
	$elm$json$Json$Decode$map,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonFromId,
	A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
var $mpizenberg$elm_pointer_events$Internal$Decode$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys = F3(
	function (alt, ctrl, shift) {
		return {ln: alt, lM: ctrl, nC: shift};
	});
var $mpizenberg$elm_pointer_events$Internal$Decode$keys = A4(
	$elm$json$Json$Decode$map3,
	$mpizenberg$elm_pointer_events$Internal$Decode$Keys,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$pagePos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$screenPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'screenX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'screenY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder = A7($elm$json$Json$Decode$map6, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$Event, $mpizenberg$elm_pointer_events$Internal$Decode$keys, $mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$buttonDecoder, $mpizenberg$elm_pointer_events$Internal$Decode$clientPos, $mpizenberg$elm_pointer_events$Internal$Decode$offsetPos, $mpizenberg$elm_pointer_events$Internal$Decode$pagePos, $mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$eventDecoder = A3(
	$elm$json$Json$Decode$map2,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$Event,
	A2($elm$json$Json$Decode$field, 'dataTransfer', $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$dataTransferDecoder),
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Mouse$eventDecoder);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$on = F2(
	function (event, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (ev) {
					return {
						mJ: tag(ev),
						ni: true,
						nJ: true
					};
				},
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$eventDecoder));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$valuePreventedOn = F2(
	function (event, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (value) {
					return {
						mJ: tag(value),
						ni: true,
						nJ: true
					};
				},
				$elm$json$Json$Decode$value));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget = function (config) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				A2(
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$valuePreventedOn,
					'dragover',
					config.m6(config.lZ))),
				$elm$core$Maybe$Just(
				A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$on, 'drop', config.m1)),
				A2(
				$elm$core$Maybe$map,
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$on('dragenter'),
				config.m3),
				A2(
				$elm$core$Maybe$map,
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$on('dragleave'),
				config.m4)
			]));
};
var $elm$html$Html$Attributes$draggable = _VirtualDom_attribute('draggable');
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$valueOn = F2(
	function (event, tag) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (value) {
					return {
						mJ: tag(value),
						ni: false,
						nJ: true
					};
				},
				$elm$json$Json$Decode$value));
	});
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag = function (config) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				$elm$core$Maybe$Just(
				$elm$html$Html$Attributes$draggable('true')),
				$elm$core$Maybe$Just(
				A2(
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$valueOn,
					'dragstart',
					config.m7(config.l_))),
				$elm$core$Maybe$Just(
				A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$on, 'dragend', config.m2)),
				A2(
				$elm$core$Maybe$map,
				$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$on('drag'),
				config.mZ)
			]));
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Cms$Products$ChangeDisplayInterval$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Cms$Products$ChangeDisplayInterval$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateInterval(ind)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Pages$Cms$Products$ChangeDisplayInterval$intToOption(product.ju),
								_List_fromArray(
									[15, 60, 360])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
									A2($elm$core$List$member, 60, product.lW)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(60 <= product.ju),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									A2($author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateDisplayInterval, ind, 60))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
									A2($elm$core$List$member, 360, product.lW)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(360 <= product.ju),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									A2($author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateDisplayInterval, ind, 360))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(base_price_without_point)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 101) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 102) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 103) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 105) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 107) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 110) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								if (!anyPoint.$) {
									var point = anyPoint.a;
									return $author$project$Utils$Helpers$toCommmaSplited(
										$elm$core$String$fromInt(((base_price_without_point * (100 + point)) / 100) | 0));
								} else {
									return '';
								}
							}())
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$viewTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は想定売価（税抜き）です')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$ChangeDisplayInterval$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										function () {
										var intervalSum = $author$project$Pages$Cms$Products$ChangeDisplayInterval$getIntervalSum(model.kn);
										return A2(
											$rtfeldman$elm_css$Html$Styled$th,
											(intervalSum > 120) ? _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', '#f33'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', '#fb4')
												]) : _List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													(intervalSum > 120) ? _List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('取得間隔'),
															A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
															$rtfeldman$elm_css$Html$Styled$text('【上限超過】')
														]) : _List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('取得間隔')
														])),
													A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$elm$core$String$fromInt(
																$author$project$Pages$Cms$Products$ChangeDisplayInterval$getIntervalSum(model.kn)) + '/120')
														]))
												]));
									}(),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示間隔'),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												$rtfeldman$elm_css$Html$Styled$text('【60】')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示間隔'),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												$rtfeldman$elm_css$Html$Styled$text('【360】')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込 P後')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('1%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('2%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('3%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('5%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('7%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('10%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('small float-left')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('任意%入力')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$ChangeDisplayInterval$UpdateAnyPoint),
														$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
														_List_fromArray(
															[
																A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px'),
																$rtfeldman$elm_css$Html$Styled$Attributes$max('100'),
																$rtfeldman$elm_css$Html$Styled$Attributes$min('0')
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ヨドバシ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Cms$Products$ChangeDisplayInterval$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Cms$Products$ChangeDisplayInterval$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$ChangeDisplayInterval$viewTable(model)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Cms$Products$ChangeDisplayInterval$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$ChangeDisplayInterval$viewContent(model),
		iB: '商品の表示間隔の追加設定'
	};
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$OnChangeUserId = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ユーザ')
							])),
						A3(
						$author$project$Components$UserSelector$userSelector,
						model.k8,
						model.gF,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Cms$Products$ChangeDisplayOrder$OnChangeUserId, $elm$core$String$toInt))
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$OnUpdateAllProducts = {$: 4};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$OnUpdateOrder = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$viewTr = F2(
	function (product, ind) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.nl)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '70px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$ChangeDisplayOrder$OnUpdateOrder(ind))
								]))
						]))
				]));
	});
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$viewTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 表示順を表す数値を入力し，更新を押すことで表示順を変更できます')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 文字列を消しても空欄にならず「0」が必ず残ってしまいます．仕様です．')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 表示順は被らないように入力してください')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$ChangeDisplayOrder$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示順')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A2($author$project$Pages$Cms$Products$ChangeDisplayOrder$viewTr, product, ind);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Cms$Products$ChangeDisplayOrder$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$ChangeDisplayOrder$viewTable(model)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Cms$Products$ChangeDisplayOrder$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$ChangeDisplayOrder$viewContent(model),
		iB: '商品の表示順の設定'
	};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnChangeUserId = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ユーザ')
							])),
						A3(
						$author$project$Components$UserSelector$userSelector,
						model.k8,
						model.gF,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Cms$Products$ChangeUserProduct$OnChangeUserId, $elm$core$String$toInt))
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnResetAllProducts = {$: 16};
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnAddProduct = {$: 13};
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateAddProductId = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateDisplayFlag = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateGetFlag = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateInterval = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateProductOrder = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$intToOption = F2(
	function (selected_v, v) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(
					$elm$core$String$fromInt(v)),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(v, selected_v))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(v))
				]));
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$addUserProduct = function (product) {
	var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(product.kl),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateAddProductId)
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$select,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateInterval(-1)),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Pages$Cms$Products$ChangeUserProduct$intToOption(product.ju),
							_List_fromArray(
								[0, 15, 60, 360])))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										$elm$core$String$fromInt(product.lt)),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
								$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateBasePrice(-1))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										$elm$core$String$fromInt(product.ls)),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
								$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateBasePoint(-1))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										$elm$core$String$fromInt(product.nl)),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
								$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateProductOrder(-1))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(base_price_without_point)))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.a6),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
								$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateGetFlag(-1))
							]),
						'')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.a_),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
								$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateDisplayFlag(-1))
							]),
						'')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
								$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateYodobashiFlag(-1))
							]),
						'')
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$ChangeUserProduct$OnAddProduct)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('追加')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnDeleteProduct = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateDisplayInterval = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateProduct = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$Drop = {$: 24};
var $author$project$Pages$Cms$Products$ChangeUserProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Cms$Products$ChangeUserProduct$Drop),
		m7: $author$project$Pages$Cms$Products$ChangeUserProduct$DragStart(ind)
	};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 23, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Cms$Products$ChangeUserProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Cms$Products$ChangeUserProduct$DragOver(ind)
	};
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
					$rtfeldman$elm_css$Html$Styled$Attributes$class(
					function () {
						if (!draggingProductInd.$) {
							var draggingInd = draggingProductInd.a;
							return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
						} else {
							return '';
						}
					}())
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$button,
							_Utils_ap(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true')
									]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
											$author$project$Pages$Cms$Products$ChangeUserProduct$dropSourceConfig(ind))),
									A2(
										$elm$core$List$map,
										$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
										$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
											$author$project$Pages$Cms$Products$ChangeUserProduct$dropTargetConfig(ind))))),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('⇅')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.kl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateInterval(ind)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Pages$Cms$Products$ChangeUserProduct$intToOption(product.ju),
								_List_fromArray(
									[0, 15, 60, 360])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
									A2($elm$core$List$member, 60, product.lW)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(60 <= product.ju),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									A2($author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateDisplayInterval, ind, 60))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
									A2($elm$core$List$member, 360, product.lW)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(360 <= product.ju),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									A2($author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateDisplayInterval, ind, 360))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.nl)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateProductOrder(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(base_price_without_point)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.a6),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateGetFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.a_),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateDisplayFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.dk),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(true)
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Products$ChangeUserProduct$OnDeleteProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('削除')
								]))
						]))
				]));
	});
var $author$project$Pages$Cms$Products$ChangeUserProduct$viewTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は想定売価（税抜き）です')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、ドラッグボタンをドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$ChangeUserProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$secondary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$ChangeUserProduct$OnResetAllProducts),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-2')
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括リセット')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ドラッグ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JANコード')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得間隔')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示間隔'),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												$rtfeldman$elm_css$Html$Styled$text('【60】')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示間隔'),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												$rtfeldman$elm_css$Html$Styled$text('【360】')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示順')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込 P後')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得フラグ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示フラグ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ヨドバシフラグ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('week30フラグ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('削除')
											]))
									]))
							])),
						$author$project$Pages$Cms$Products$ChangeUserProduct$addUserProduct(model.ab),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Cms$Products$ChangeUserProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Cms$Products$ChangeUserProduct$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$ChangeUserProduct$viewTable(model)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Cms$Products$ChangeUserProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$ChangeUserProduct$viewContent(model),
		iB: 'ユーザーごとの商品変更'
	};
};
var $author$project$Pages$Cms$Products$EditProducts$OnChangeProductId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$EditProducts$OnChangeProductName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$EditProducts$Send = {$: 5};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$Growing = 1;
var $frandibar$elm_bootstrap$Bootstrap$Spinner$Kind = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$grow = $frandibar$elm_bootstrap$Bootstrap$Spinner$Kind(1);
var $frandibar$elm_bootstrap$Bootstrap$Spinner$Large = 2;
var $frandibar$elm_bootstrap$Bootstrap$Spinner$Size = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$large = $frandibar$elm_bootstrap$Bootstrap$Spinner$Size(2);
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Placeholder = function (a) {
	return {$: 7, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder = function (value_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Input$Placeholder(value_);
};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var spinnerKind = modifier.a;
				return _Utils_update(
					options,
					{dU: spinnerKind});
			case 1:
				var spinnerSize = modifier.a;
				return _Utils_update(
					options,
					{kK: spinnerSize});
			case 2:
				var color_ = modifier.a;
				return _Utils_update(
					options,
					{
						hm: $elm$core$Maybe$Just(color_)
					});
			default:
				var list = modifier.a;
				return _Utils_update(
					options,
					{eW: list});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Spinner$Border = 0;
var $frandibar$elm_bootstrap$Bootstrap$Spinner$Normal = 0;
var $frandibar$elm_bootstrap$Bootstrap$Spinner$defaultOptions = {eW: _List_Nil, hm: $elm$core$Maybe$Nothing, dU: 0, kK: 0};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$kindClassName = function (kind_) {
	if (!kind_) {
		return 'spinner-border';
	} else {
		return 'spinner-grow';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$kindClass = A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Html$Styled$Attributes$class, $frandibar$elm_bootstrap$Bootstrap$Spinner$kindClassName);
var $frandibar$elm_bootstrap$Bootstrap$Spinner$sizeAttributes = F2(
	function (size_, kind_) {
		switch (size_) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							$frandibar$elm_bootstrap$Bootstrap$Spinner$kindClassName(kind_) + '-sm')
						]));
			default:
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '3rem'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '3rem')
						]));
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Internal$Text$textColorClass = function (color) {
	if (color.$ === 1) {
		return $rtfeldman$elm_css$Html$Styled$Attributes$class('text-white');
	} else {
		var role = color.a;
		return A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'text', role);
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$toAttributes = function (options) {
	return _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$frandibar$elm_bootstrap$Bootstrap$Spinner$kindClass(options.dU)),
					A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$Internal$Text$textColorClass, options.hm)
				])),
		_Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($frandibar$elm_bootstrap$Bootstrap$Spinner$sizeAttributes, options.kK, options.dU)),
			_Utils_ap(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'status')
					]),
				options.eW)));
};
var $frandibar$elm_bootstrap$Bootstrap$Spinner$spinner = F2(
	function (options, children) {
		var opts = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Spinner$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Spinner$defaultOptions, options);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			$frandibar$elm_bootstrap$Bootstrap$Spinner$toAttributes(opts),
			children);
	});
var $author$project$Pages$Cms$Products$EditProducts$viewContent = function (model) {
	if (model.fB) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Spinner$spinner,
			_List_fromArray(
				[$frandibar$elm_bootstrap$Bootstrap$Spinner$grow, $frandibar$elm_bootstrap$Bootstrap$Spinner$large]),
			_List_Nil);
	} else {
		var sendButton = A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$EditProducts$Send)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('送信')
				]));
		var modelNumText = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input Model-Number'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.dL),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$EditProducts$OnChangeProductName)
				]));
		var janText = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input JAN-CODE'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.dK),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$EditProducts$OnChangeProductId)
				]));
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
								]))
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('JANコード')
								])),
							janText
						])),
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
								]))
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('型番')
								])),
							modelNumText
						])),
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
								]))
						]),
					_List_fromArray(
						[sendButton]))
				]));
	}
};
var $author$project$Pages$Cms$Products$EditProducts$OnUpdateMaker = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$EditProducts$OnUpdateProductName = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$EditProducts$OnUpdateSmallCategory = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Products$EditProducts$SubmitUpdateProductGeneralInformations = function (a) {
	return {$: 12, a: a};
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Pages$Cms$Products$EditProducts$viewTr = F4(
	function (productsGeneralInformation, index, makers, small_categories) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(productsGeneralInformation.bf)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(productsGeneralInformation.bM),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$EditProducts$OnUpdateProductName(index))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput(
											function (makerIdString) {
												return A2(
													$author$project$Pages$Cms$Products$EditProducts$OnUpdateMaker,
													index,
													A2(
														$elm$core$Maybe$withDefault,
														0,
														$elm$core$String$toInt(makerIdString)));
											})
										]))
								]),
							A2(
								$elm$core$List$map,
								function (maker) {
									return A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												$elm$core$String$fromInt(maker.ap)),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(productsGeneralInformation.ap, maker.ap))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(maker.jX)
											]));
								},
								makers))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var category_names = $elm_community$list_extra$List$Extra$unique(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.e4;
									},
									small_categories));
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (cname) {
										return function (items) {
											return A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Events$onInput(
																function (scIdstring) {
																	return A3(
																		$author$project$Pages$Cms$Products$EditProducts$OnUpdateSmallCategory,
																		index,
																		cname,
																		$elm$core$String$toInt(scIdstring));
																})
															]))
													]),
												A2(
													$elm$core$List$cons,
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
																$rtfeldman$elm_css$Html$Styled$Attributes$selected(false)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(cname + (' > ' + '無し'))
															])),
													items));
										}(
											A2(
												$elm$core$List$map,
												function (sc) {
													return A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(sc.c6)),
																$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																A2(
																	$elm$core$List$member,
																	sc.c6,
																	A2(
																		$elm$core$List$filterMap,
																		function (query) {
																			switch (query.$) {
																				case 0:
																					var newId = query.a;
																					return $elm$core$Maybe$Just(newId);
																				case 1:
																					var oldId = query.a;
																					var newId = query.b;
																					return $elm$core$Maybe$Just(newId);
																				default:
																					var oldId = query.a;
																					return $elm$core$Maybe$Nothing;
																			}
																		},
																		$elm$core$Dict$values(productsGeneralInformation.t))))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																cname + (' > ' + (sc.iX + ('  >  ' + A3($elm$core$String$replace, '-', 'ー', sc.kN)))))
															]));
												},
												A2(
													$elm$core$List$filter,
													function (sc) {
														return _Utils_eq(sc.e4, cname);
													},
													small_categories)));
									},
									category_names));
						}()
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_Utils_ap(
								function () {
									var pgi = productsGeneralInformation;
									var isAnySelected = A2(
										$elm$core$List$any,
										function (query) {
											switch (query.$) {
												case 0:
													return true;
												case 1:
													var oldId = query.a;
													var newId = query.b;
													return true;
												default:
													return false;
											}
										},
										$elm$core$Dict$values(pgi.t));
									var hasChanges = A2(
										$elm$core$List$any,
										function (query) {
											switch (query.$) {
												case 0:
													return true;
												case 1:
													var oldId = query.a;
													var newId = query.b;
													return !_Utils_eq(oldId, newId);
												default:
													return true;
											}
										},
										$elm$core$Dict$values(pgi.t));
									return (pgi.R && (isAnySelected && hasChanges)) ? _List_fromArray(
										[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil;
								}(),
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Cms$Products$EditProducts$SubmitUpdateProductGeneralInformations(index))
									])),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Update')
								]))
						]))
				]));
	});
var $author$project$Pages$Cms$Products$EditProducts$viewTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JANCODE')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('メーカー名')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('小分類')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Update')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (ind, perm) {
									return A4($author$project$Pages$Cms$Products$EditProducts$viewTr, perm, ind, model.cE, model.kL);
								}),
							model.bg))
					]))
			]));
};
var $author$project$Pages$Cms$Products$EditProducts$viewContents = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$EditProducts$viewContent(model)
					])),
				model.fI ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$EditProducts$viewTable(model)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Cms$Products$EditProducts$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$EditProducts$viewContents(model),
		iB: '商品の型番，メーカー，小分類の変更'
	};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$Nop = {$: 14};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeProductId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeProductName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeSearchModeSwitcher = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$Send = {$: 6};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$UserAndStores = 1;
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $rtfeldman$elm_css$Html$Styled$h5 = $rtfeldman$elm_css$Html$Styled$node('h5');
var $rtfeldman$elm_css$Html$Styled$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Utils$Helpers$preventDefaultEnter = function (nop) {
	var filterKey = function (code) {
		return (code === 13) ? $elm$json$Json$Decode$succeed(0) : $elm$json$Json$Decode$fail('ignore');
	};
	var decoder = A2(
		$elm$json$Json$Decode$map,
		function (_v0) {
			return {mJ: nop, ni: true, nJ: true};
		},
		A2($elm$json$Json$Decode$andThen, filterKey, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
	return A2($rtfeldman$elm_css$Html$Styled$Events$custom, 'keydown', decoder);
};
var $inkuzmin$elm_multiselect$Multiselect$ClickOnComponent = {$: 2};
var $inkuzmin$elm_multiselect$Multiselect$Focused = 1;
var $inkuzmin$elm_multiselect$Multiselect$Toggle = {$: 4};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$borderBottomWidth = $rtfeldman$elm_css$Css$prop1('border-bottom-width');
var $rtfeldman$elm_css$Css$borderColor3 = F3(
	function (c1, c2, c3) {
		var value = A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[c1.m, c2.m, c3.m]));
		return A2($rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var $rtfeldman$elm_css$Css$borderLeftWidth = $rtfeldman$elm_css$Css$prop1('border-left-width');
var $rtfeldman$elm_css$Css$borderRightWidth = $rtfeldman$elm_css$Css$prop1('border-right-width');
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $rtfeldman$elm_css$Css$borderTopWidth = $rtfeldman$elm_css$Css$prop1('border-top-width');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$inlineBlock = {q: 0, m: 'inline-block'};
var $rtfeldman$elm_css$Css$relative = {d9: 0, m: 'relative'};
var $rtfeldman$elm_css$Css$transparent = {hm: 0, m: 'transparent'};
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$zero = {bB: 0, cA: 0, a8: 0, cB: 0, cC: 0, bC: 0, bD: 0, mW: 0, bd: 0, f8: 0, dh: '', eC: 0, m: '0'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#999'),
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]));
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-2.5))
		]));
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$middle = $rtfeldman$elm_css$Css$prop1('middle');
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $rtfeldman$elm_css$Css$pointer = {c: 0, m: 'pointer'};
var $rtfeldman$elm_css$Css$tableCell = {q: 0, m: 'table-cell'};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(5))
		]));
var $inkuzmin$elm_multiselect$Multiselect$withOptions = F2(
	function (options, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			function (m) {
				return {mJ: m, ni: options.ni, nJ: options.nJ};
			},
			decoder);
	});
var $inkuzmin$elm_multiselect$Multiselect$onClickNoDefault = function (message) {
	var config = {ni: true, nJ: true};
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'click',
		A2(
			$inkuzmin$elm_multiselect$Multiselect$withOptions,
			config,
			$elm$json$Json$Decode$succeed(message)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$rel = $rtfeldman$elm_css$VirtualDom$Styled$attribute('rel');
var $inkuzmin$elm_multiselect$Multiselect$arrow = function (_v0) {
	var model = _v0;
	var arrowRel = (model.al === 2) ? 'arrowUpside' : 'arrow';
	var arrowCss = (model.al === 2) ? _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowUpside]) : _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$arrow]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$arrowWrap])),
				$inkuzmin$elm_multiselect$Multiselect$onClickNoDefault($inkuzmin$elm_multiselect$Multiselect$Toggle)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(arrowCss),
						$rtfeldman$elm_css$Html$Styled$Attributes$rel(arrowRel)
					]),
				_List_Nil)
			]));
};
var $inkuzmin$elm_multiselect$Multiselect$Clear = {$: 7};
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$clear = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1))
		]));
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.m);
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(17)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color(
					$rtfeldman$elm_css$Css$hex('#D0021B'))
				]))
		]));
var $inkuzmin$elm_multiselect$Multiselect$clear = function (_v0) {
	var model = _v0;
	return (!$elm$core$List$isEmpty(model.kC)) ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$clearWrap])),
				$inkuzmin$elm_multiselect$Multiselect$onClickNoDefault($inkuzmin$elm_multiselect$Multiselect$Clear)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$inkuzmin$elm_multiselect$Multiselect$SelectCss$clear]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('×')
					]))
			])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
};
var $rtfeldman$elm_css$Css$table = {q: 0, m: 'table'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$container = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#d9d9d9'),
			$rtfeldman$elm_css$Css$hex('#ccc'),
			$rtfeldman$elm_css$Css$hex('#b3b3b3')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333')),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(34)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$table)
		]));
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.m);
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom = function (p) {
	return A2($rtfeldman$elm_css$Css$property, 'box-shadow', p);
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$focused = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#007eff')),
			$inkuzmin$elm_multiselect$Multiselect$SelectCss$boxShadowCustom('inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1)')
		]));
var $inkuzmin$elm_multiselect$Multiselect$Adjust = function (a) {
	return {$: 11, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Filter = function (a) {
	return {$: 10, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$Shortcut = function (a) {
	return {$: 13, a: a};
};
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $rtfeldman$elm_css$Css$initial = {iQ: 0, B: 0, $7: 0, iU: 0, b9: 0, iV: 0, ca: 0, aT: 0, N: 0, e1: 0, hm: 0, c: 0, q: 0, cq: 0, hv: 0, dD: 0, fo: 0, bx: 0, I: 0, cr: 0, j: 0, a4: 0, fD: 0, jO: 0, hR: 0, bB: 0, cA: 0, a8: 0, cB: 0, cC: 0, bC: 0, bD: 0, aI: 0, fQ: 0, e: 0, d: 0, hX: 0, mW: 0, bd: 0, f8: 0, cK: 0, av: 0, gR: 0, dd: 0, bW: 0, de: 0, df: 0, bX: 0, Z: 0, dh: '', eC: 0, m: 'initial', aF: 0, bo: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{m: 'inherit'});
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		a4: 0,
		fD: 0,
		bD: 0,
		aI: 0,
		mW: 0,
		fU: 0,
		bd: val,
		dh: '',
		eC: 0,
		m: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$none = {b9: 0, i_: 0, N: 0, c: 0, q: 0, mn: 0, jF: 0, hR: 0, cC: 0, bC: 0, aI: 0, e: 0, d: 0, hX: 0, f8: 0, ne: 0, av: 0, gt: 0, nw: 0, dd: 0, bX: 0, Z: 0, gY: 0, n0: 0, m: 'none'};
var $rtfeldman$elm_css$Css$outlineStyle = $rtfeldman$elm_css$Css$prop1('outline-style');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$input = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$outlineStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $rtfeldman$elm_css$Css$absolute = {d9: 0, m: 'absolute'};
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.m;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$normal = {ht: 0, cr: 0, a4: 0, h1: 0, m: 'normal', bo: 0};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $rtfeldman$elm_css$Css$scroll = {$7: 0, i_: 0, jF: 0, cK: 0, nx: 0, m: 'scroll'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$int(1))
		]));
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$previousSibling = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'previousSibling', decoder);
};
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $inkuzmin$elm_multiselect$Multiselect$onKeyDown = function (tagger) {
	var domF = $debois$elm_dom$DOM$target(
		$debois$elm_dom$DOM$previousSibling($debois$elm_dom$DOM$offsetWidth));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keypress',
		A2($elm$json$Json$Decode$map, tagger, domF));
};
var $inkuzmin$elm_multiselect$Multiselect$onKeyPress = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $inkuzmin$elm_multiselect$Multiselect$onKeyUp = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue));
};
var $inkuzmin$elm_multiselect$Multiselect$Start = {$: 0};
var $inkuzmin$elm_multiselect$Multiselect$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons = function () {
	var options = {ni: true, nJ: false};
	var filterKey = function (code) {
		return (_Utils_eq(code, $inkuzmin$elm_multiselect$Multiselect$Keycodes$upArrow) || _Utils_eq(code, $inkuzmin$elm_multiselect$Multiselect$Keycodes$downArrow)) ? $elm$core$Result$Ok(code) : $elm$core$Result$Err('ignored input');
	};
	var decoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$always($inkuzmin$elm_multiselect$Multiselect$Start),
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, filterKey, $inkuzmin$elm_multiselect$Multiselect$fromResult),
			$rtfeldman$elm_css$Html$Styled$Events$keyCode));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'keydown',
		A2($inkuzmin$elm_multiselect$Multiselect$withOptions, options, decoder));
}();
var $rtfeldman$elm_css$Html$Styled$Attributes$property = $rtfeldman$elm_css$VirtualDom$Styled$property;
var $inkuzmin$elm_multiselect$Multiselect$input = function (_v0) {
	var model = _v0;
	var w = $elm$core$String$fromFloat(model.hJ + 23.0);
	var inputStyle = A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', w + 'px');
	var forceClear = function () {
		var _v1 = model.jH;
		if (_v1.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$Attributes$value('');
		} else {
			return $rtfeldman$elm_css$Html$Styled$Attributes$classList(_List_Nil);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$inkuzmin$elm_multiselect$Multiselect$preventDefaultButtons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$inputWrap]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$inkuzmin$elm_multiselect$Multiselect$SelectCss$inputMirrow]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.jH))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectInput' + model.A),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$inkuzmin$elm_multiselect$Multiselect$SelectCss$input])),
						$inkuzmin$elm_multiselect$Multiselect$onKeyDown($inkuzmin$elm_multiselect$Multiselect$Adjust),
						$inkuzmin$elm_multiselect$Multiselect$onKeyPress($inkuzmin$elm_multiselect$Multiselect$Shortcut),
						$inkuzmin$elm_multiselect$Multiselect$onKeyUp($inkuzmin$elm_multiselect$Multiselect$Filter),
						inputStyle,
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$property,
						'type',
						$elm$json$Json$Encode$string('text')),
						forceClear
					]),
				_List_Nil)
			]));
};
var $inkuzmin$elm_multiselect$Multiselect$OnHover = function (a) {
	return {$: 12, a: a};
};
var $inkuzmin$elm_multiselect$Multiselect$OnSelect = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$borderBottomLeftRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
var $rtfeldman$elm_css$Css$borderBottomRightRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
var $rtfeldman$elm_css$Css$borderTopColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-top-color', c.m);
};
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.m, argB.m, argC.m, argD.m])));
	});
var $rtfeldman$elm_css$Css$boxShadow4 = $rtfeldman$elm_css$Css$prop4('box-shadow');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menu = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomRightRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$borderBottomLeftRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderTopColor(
			$rtfeldman$elm_css$Css$hex('#e6e6e6')),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$zero,
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.06)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-1)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($inkuzmin$elm_multiselect$Multiselect$SelectCss$menuHeight)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
		]));
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2(
			$rtfeldman$elm_css$Css$property,
			key,
			A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					[argA.m, argB.m])));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#666')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($inkuzmin$elm_multiselect$Multiselect$SelectCss$itemHeight))
		]));
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.08)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333'))
		]));
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $inkuzmin$elm_multiselect$Multiselect$menu = function (_v0) {
	var model = _v0;
	var _v1 = model.al;
	if (_v1 === 2) {
		var hovered = function () {
			var _v3 = model.o;
			if (_v3.$ === 1) {
				return '';
			} else {
				var _v4 = _v3.a;
				var id = _v4.a;
				return id;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$inkuzmin$elm_multiselect$Multiselect$SelectCss$menu])),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectMenu' + model.A)
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var name = _v2.a;
					var value = _v2.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_eq(name, hovered) ? _List_fromArray(
									[$inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItemHovered, $inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem]) : _List_fromArray(
									[$inkuzmin$elm_multiselect$Multiselect$SelectCss$menuItem])),
								$inkuzmin$elm_multiselect$Multiselect$onClickNoDefault(
								$inkuzmin$elm_multiselect$Multiselect$OnSelect(
									_Utils_Tuple2(name, value))),
								$rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
								$inkuzmin$elm_multiselect$Multiselect$OnHover(
									_Utils_Tuple2(name, value)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(value)
							]));
				},
				model.n));
	} else {
		return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	}
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$opened = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomLeftRadius($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$borderBottomRightRadius($rtfeldman$elm_css$Css$zero)
		]));
var $inkuzmin$elm_multiselect$Multiselect$RemoveItem = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$border2 = $rtfeldman$elm_css$Css$prop2('border');
var $rtfeldman$elm_css$Css$EmUnits = 0;
var $rtfeldman$elm_css$Css$em = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'em');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tag = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#007eff')),
			A2(
			$rtfeldman$elm_css$Css$border2,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(2)),
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.08)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$em(0.9)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1.4)),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$top)
		]));
var $rtfeldman$elm_css$Css$borderRight3 = $rtfeldman$elm_css$Css$prop3('border-right');
var $rtfeldman$elm_css$Css$padding3 = $rtfeldman$elm_css$Css$prop3('padding');
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$backgroundColor(
					$rtfeldman$elm_css$Css$hex('#d8eafd'))
				])),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A3(
			$rtfeldman$elm_css$Css$borderRight3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.24)),
			A3(
			$rtfeldman$elm_css$Css$padding3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$px(5),
			$rtfeldman$elm_css$Css$px(3)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
		]));
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(2),
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle)
		]));
var $inkuzmin$elm_multiselect$Multiselect$tag = F2(
	function (name, value) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tag]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tagIcon])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$inkuzmin$elm_multiselect$Multiselect$RemoveItem(
								_Utils_Tuple2(name, value)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('×')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tagLabel]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(value)
						]))
				]));
	});
var $rtfeldman$elm_css$Css$inline = {q: 0, m: 'inline'};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inline)
		]));
var $inkuzmin$elm_multiselect$Multiselect$tags = function (_v0) {
	var model = _v0;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$tagWrap]))
			]),
		A2(
			$elm$core$List$map,
			function (_v1) {
				var name = _v1.a;
				var value = _v1.b;
				return A2($inkuzmin$elm_multiselect$Multiselect$tag, name, value);
			},
			model.kC));
};
var $inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]));
var $inkuzmin$elm_multiselect$Multiselect$styledView = function (_v0) {
	var model = _v0;
	var inputCss = (model.al === 1) ? _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$container, $inkuzmin$elm_multiselect$Multiselect$SelectCss$focused]) : ((model.al === 2) ? _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$container, $inkuzmin$elm_multiselect$Multiselect$SelectCss$opened]) : _List_fromArray(
		[$inkuzmin$elm_multiselect$Multiselect$SelectCss$container]));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$inkuzmin$elm_multiselect$Multiselect$SelectCss$wrap])),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($inkuzmin$elm_multiselect$Multiselect$ClickOnComponent)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(inputCss)
					]),
				_List_fromArray(
					[
						$inkuzmin$elm_multiselect$Multiselect$tags(model),
						$inkuzmin$elm_multiselect$Multiselect$input(model),
						$inkuzmin$elm_multiselect$Multiselect$clear(model),
						$inkuzmin$elm_multiselect$Multiselect$arrow(model)
					])),
				$inkuzmin$elm_multiselect$Multiselect$menu(model)
			]));
};
var $inkuzmin$elm_multiselect$Multiselect$view = A2($elm$core$Basics$composeR, $inkuzmin$elm_multiselect$Multiselect$styledView, $rtfeldman$elm_css$Html$Styled$toUnstyled);
var $author$project$Pages$Cms$Products$EditProductsPermalinks$viewContent = function (model) {
	if (model.fB) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Spinner$spinner,
			_List_fromArray(
				[$frandibar$elm_bootstrap$Bootstrap$Spinner$grow, $frandibar$elm_bootstrap$Bootstrap$Spinner$large]),
			_List_Nil);
	} else {
		var userSelector = A3(
			$author$project$Components$UserSelector$userSelector,
			model.k8,
			model.gF,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(
					A2($elm$core$Basics$composeL, $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeUserId, $elm$core$String$toInt))
				]));
		var sendButton = A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$EditProductsPermalinks$Send)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('検索')
				]));
		var searchMode = model.bh;
		var searchModeSwitcher = A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-inline-flex border rounded overflow-hidden ml-3 mr-3')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							'px-3 py-1 border-0 ' + ((!searchMode) ? 'bg-primary text-white' : 'bg-white text-dark')),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeSearchModeSwitcher(0))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('JANまたは型番から検索')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('border-left')
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							'px-3 py-1 border-0 ' + ((searchMode === 1) ? 'bg-primary text-white' : 'bg-white text-dark')),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeSearchModeSwitcher(1))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('ユーザと量販店から検索')
						]))
				]));
		var modelNumText = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input Model-Number'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.c0),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeProductName)
				]));
		var janText = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input JAN-CODE'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.c$),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeProductId)
				]));
		var userGroup = A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$label,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('ユーザ')
						])),
					userSelector
				]));
		var sendGroup = A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
						]))
				]),
			_List_fromArray(
				[sendButton]));
		var searchValidationErrorMessage = '　' + function () {
			var _v1 = model.cW;
			if (!_v1.$) {
				return '入力が不適当か不足しています';
			} else {
				return '';
			}
		}();
		var multiSelectStoreGroup = A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3'),
							$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Cms$Products$EditProductsPermalinks$Nop)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$label,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A3($author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode, '表示する量販店を選択\u3000(プルダウンは矢印クリックで消えます(仮))', '量販店\u3000(プルダウンは矢印クリックで消えます(仮))', searchMode))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer text-left'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class(
							model.ha ? 'multiSelectWarning' : ''),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '400px')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$map,
							$author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangeStore,
							$rtfeldman$elm_css$Html$Styled$fromUnstyled(
								$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
							$elm$core$List$isEmpty(
							$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? (model.ad ? A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode, 'ユーザが取得するすべての量販店', '表示する量販店を選択 (複数選択可)', searchMode))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A3($author$project$Pages$Cms$Products$EditProductsPermalinks$chooseBySearchMode, '全て選択', 'ユーザを選択してください', searchMode))
								]))) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
						]))
				]));
		var modelNumGroup = A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$label,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('型番')
						])),
					modelNumText
				]));
		var janGroup = A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$label,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('JANコード')
						])),
					janText
				]));
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start')
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2 mb-3 d-flex align-items-center')
						]),
					_List_fromArray(
						[
							searchModeSwitcher,
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-0')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('(「JANまたは型番から検索」が旧画面での検索です)')
										]))
								]))
						])),
					function () {
					if (!searchMode) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-1')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('　JANコードまたは型番を指定して検索します。あいまい検索ができます。')
												]))
										])),
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end mb-1 justify-content-start')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$h5,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('　　　')
														]))
												])),
											janGroup,
											modelNumGroup,
											sendGroup
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-1')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-weight', 'bold'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', 'red')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(searchValidationErrorMessage)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-3 mb-1')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('　ユーザを指定すると、そのユーザが取得している量販店のみに絞り込んで表示します。')
												]))
										])),
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end justify-content-start')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$h5,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('　　　量販店で絞り込み：　')
														]))
												])),
											userGroup,
											multiSelectStoreGroup
										]))
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-1')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('　ユーザと量販店を指定して検索します。')
												]))
										])),
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end mb-5 justify-content-start')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$h5,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('　　　')
														]))
												])),
											userGroup,
											multiSelectStoreGroup,
											sendGroup
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-weight', 'bold'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', 'red')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(searchValidationErrorMessage)
												]))
										]))
								]));
					}
				}()
				]));
	}
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangePermalink = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$OnUpdatePermalink = function (a) {
	return {$: 10, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$target = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('target');
var $author$project$Pages$Cms$Products$EditProductsPermalinks$viewTr = F2(
	function (sendResponse, index) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(sendResponse.bL.bM)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(sendResponse.at.U))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(sendResponse.eD),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(sendResponse.at.j8)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(sendResponse.ga),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Products$EditProductsPermalinks$OnChangePermalink(index))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Products$EditProductsPermalinks$OnUpdatePermalink(index))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Cms$Products$EditProductsPermalinks$viewTable = function (model) {
	var usePermalinkInfos = $elm$core$List$isEmpty(
		$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? (model.ad ? model.aj : model.s) : A3($author$project$Pages$Cms$Products$EditProductsPermalinks$filterBySelectedStores, model.s, model.aN, model.p);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ID')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('グループ名')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('パーマリンク')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (ind, perm) {
									return A2($author$project$Pages$Cms$Products$EditProductsPermalinks$viewTr, perm, ind);
								}),
							usePermalinkInfos))
					]))
			]));
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$viewContents = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$EditProductsPermalinks$viewContent(model)
					])),
				model.fI ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$EditProductsPermalinks$viewTable(model)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Cms$Products$EditProductsPermalinks$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$EditProductsPermalinks$viewContents(model),
		iB: 'パーマリンクの追加'
	};
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$OnChangeProductId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$OnChangeProductName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$Send = {$: 5};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$viewContent = function (model) {
	if (model.fB) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Spinner$spinner,
			_List_fromArray(
				[$frandibar$elm_bootstrap$Bootstrap$Spinner$grow, $frandibar$elm_bootstrap$Bootstrap$Spinner$large]),
			_List_Nil);
	} else {
		var sendButton = A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$EditSoldoutProducts$Send)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('送信')
				]));
		var modelNumText = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input Model-Number'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.dL),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$EditSoldoutProducts$OnChangeProductName)
				]));
		var janText = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input JAN-CODE'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.dK),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Products$EditSoldoutProducts$OnChangeProductId)
				]));
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
								]))
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('JANコード')
								])),
							janText
						])),
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
								]))
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('型番')
								])),
							modelNumText
						])),
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
								]))
						]),
					_List_fromArray(
						[sendButton]))
				]));
	}
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$OnUpdateSoldoutFlag = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$SubmitUpdateSoldoutInfo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$viewTr = F4(
	function (soldoutInfo, index, makers, small_categories) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(soldoutInfo.bf)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(soldoutInfo.bM)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$a,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$href(
									A2($elm$core$Maybe$withDefault, '', soldoutInfo.eD)),
									$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', soldoutInfo.el))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(soldoutInfo.fL),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Cms$Products$EditSoldoutProducts$OnUpdateSoldoutFlag(index))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_Utils_ap(
								soldoutInfo.R ? _List_fromArray(
									[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Cms$Products$EditSoldoutProducts$SubmitUpdateSoldoutInfo(index))
									])),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Update')
								]))
						]))
				]));
	});
var $author$project$Pages$Cms$Products$EditSoldoutProducts$viewTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 販売終了となった商品を管理するページです。')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 販売終了フラグにチェックがついている商品は現在取得していない商品です。')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JANCODE')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('STORE')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('販売終了フラグ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('UPDATE')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (ind, perm) {
									return A4($author$project$Pages$Cms$Products$EditSoldoutProducts$viewTr, perm, ind, model.cE, model.kL);
								}),
							model.aD))
					]))
			]));
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$viewContents = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$EditSoldoutProducts$viewContent(model)
					])),
				model.fI ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Cms$Products$EditSoldoutProducts$viewTable(model)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Cms$Products$EditSoldoutProducts$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$EditSoldoutProducts$viewContents(model),
		iB: '販売終了商品の変更'
	};
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$Add = {$: 1};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$AddChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$Remove = {$: 2};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$RmChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$renderProducts = function (lst) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$ul,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (l) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(l.kl),
									$rtfeldman$elm_css$Html$Styled$text('  '),
									$rtfeldman$elm_css$Html$Styled$text(l.nk)
								]))
						]));
			},
			lst));
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$viewContent = function (model) {
	if (model.fB) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Spinner$spinner,
			_List_fromArray(
				[$frandibar$elm_bootstrap$Bootstrap$Spinner$grow, $frandibar$elm_bootstrap$Bootstrap$Spinner$large]),
			_List_Nil);
	} else {
		var removeText = A2(
			$rtfeldman$elm_css$Html$Styled$input,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
					$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('Input JAN-CODE'),
					$rtfeldman$elm_css$Html$Styled$Attributes$value(model.cV),
					$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$RakutenExcludedItems$RmChange)
				]),
			_List_Nil);
		var remove = A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Pages$Cms$Products$RakutenExcludedItems$Remove)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('remove')
				]));
		var products = $author$project$Pages$Cms$Products$RakutenExcludedItems$renderProducts(model.kn);
		var addText = A2(
			$rtfeldman$elm_css$Html$Styled$input,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$type_('text'),
					$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('Input JAN-CODE'),
					$rtfeldman$elm_css$Html$Styled$Attributes$value(model.b4),
					$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$RakutenExcludedItems$AddChange)
				]),
			_List_Nil);
		var add = A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Pages$Cms$Products$RakutenExcludedItems$Add)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('add')
				]));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[addText, add])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[removeText, remove])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[products]))
				]));
	}
};
var $author$project$Pages$Cms$Products$RakutenExcludedItems$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$RakutenExcludedItems$viewContent(model),
		iB: 'Linuxで楽天から取得しない商品の設定'
	};
};
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnPressCsvUpload = {$: 0};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Disabled = function (a) {
	return {$: 3, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Button$disabled = function (disabled_) {
	return $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Disabled(disabled_);
};
var $author$project$Components$Loading$loading = function (diameter) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(diameter / 12),
						$rtfeldman$elm_css$Css$solid,
						$rtfeldman$elm_css$Css$hex('f3f3f3')),
						A3(
						$rtfeldman$elm_css$Css$borderTop3,
						$rtfeldman$elm_css$Css$px(diameter / 12),
						$rtfeldman$elm_css$Css$solid,
						$rtfeldman$elm_css$Css$hex('333')),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(diameter)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(diameter)),
						$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$auto),
						$rtfeldman$elm_css$Css$animationName($author$project$Components$Loading$spinKeyframe),
						$rtfeldman$elm_css$Css$animationDuration(
						$rtfeldman$elm_css$Css$sec(1)),
						A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
						A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'linear')
					]))
			]),
		_List_Nil);
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Warning = 4;
var $frandibar$elm_bootstrap$Bootstrap$Button$warning = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled(4));
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.cD, model.nO);
				if (_v0.a) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$warning,
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Loading$loading(23)
							]));
				} else {
					if (_v0.b) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$success,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Succeeded!')
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$OnPressCsvUpload)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Press to Upload')
								]));
					}
				}
			}()
			]));
};
var $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$viewContent(model),
		iB: 'Netgate/富士フイルム 今週の商品の変更(CSV upload)'
	};
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnChangeBigCategory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnPressCsvUpload = {$: 0};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('大分類')
									])),
								A3(
								$author$project$Components$CategorySelector$bigCategorySelector,
								model.iW,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnChangeBigCategory)
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.cD, model.nO);
				if (_v0.a) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$warning,
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Loading$loading(23)
							]));
				} else {
					if (_v0.b) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$success,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Succeeded!')
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$OnPressCsvUpload)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Press to Upload')
								]));
					}
				}
			}()
			]));
};
var $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$viewContent(model),
		iB: 'Netgate/日立 商品の順序の変更'
	};
};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnPressCsvUpload = {$: 0};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.cD, model.nO);
				if (_v0.a) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$warning,
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Loading$loading(23)
							]));
				} else {
					if (_v0.b) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$success,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Succeeded!')
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$OnPressCsvUpload)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Press to Upload')
								]));
					}
				}
			}()
			]));
};
var $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$viewContent(model),
		iB: 'Netgate/日立 今週の商品の変更'
	};
};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnPressCsvUpload = {$: 0};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.cD, model.nO);
				if (_v0.a) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$warning,
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Loading$loading(23)
							]));
				} else {
					if (_v0.b) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$success,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Succeeded!')
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$OnPressCsvUpload)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Press to Upload')
								]));
					}
				}
			}()
			]));
};
var $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$viewContent(model),
		iB: 'Netgate/Sharp 今週の商品の変更'
	};
};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnPressCsvUpload = {$: 0};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.cD, model.nO);
				if (_v0.a) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$warning,
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Loading$loading(23)
							]));
				} else {
					if (_v0.b) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$success,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Success!')
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$OnPressCsvUpload)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('アップロード')
								]));
					}
				}
			}()
			]));
};
var $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$viewContent(model),
		iB: 'Netgate/Tescom 今週の商品の変更(CSV upload)'
	};
};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnPressCsvUpload = {$: 0};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.cD, model.nO);
				if (_v0.a) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$warning,
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Loading$loading(23)
							]));
				} else {
					if (_v0.b) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$success,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Success!')
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$UpdateTletProductsByCsv$OnPressCsvUpload)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('アップロード')
								]));
					}
				}
			}()
			]));
};
var $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UpdateTletProductsByCsv$viewContent(model),
		iB: 'Netgate/東芝LET 今週の商品の変更(CSV upload)'
	};
};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnPressCsvUpload = {$: 0};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-2')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.cD, model.nO);
				if (_v0.a) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$warning,
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Loading$loading(23)
							]));
				} else {
					if (_v0.b) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$success,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Succeeded!')
								]));
					} else {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-1 w-25')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Products$UpdateWeek30ByCsv$OnPressCsvUpload)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Press to Upload')
								]));
					}
				}
			}()
			]));
};
var $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UpdateWeek30ByCsv$viewContent(model),
		iB: 'Netgate/キャノン 今週の商品の変更(CSV upload)'
	};
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$viewUserPages = function (model) {
	var _v0 = model.gF;
	_v0$7:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 1:
					return A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateWeek30ByCsvEndpoints.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('キャノン 今週の品目更新')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateTletProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('東芝LET 今週の品目更新')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateTescomProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Tescom 今週の品目更新')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateSharpProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Sharp 今週の品目更新')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateHitachiWeeklyProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('日立 今週の品目更新')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateHitachiProductsOrder.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('日立 商品順序更新')
											]))
									]))
							]));
				case 2:
					return A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateHitachiWeeklyProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('日立 今週の品目更新')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateHitachiProductsOrder.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('日立 商品順序更新')
											]))
									]))
							]));
				case 6:
					return A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateWeek30ByCsvEndpoints.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('キャノン 今週の品目更新')
											]))
									]))
							]));
				case 7:
					return A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateFujiWeeklyProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('富士フイルム 今週の品目更新')
											]))
									]))
							]));
				case 16:
					return A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateTletProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('東芝LET 今週の品目更新')
											]))
									]))
							]));
				case 23:
					return A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateTescomProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Tescom 今週の品目更新')
											]))
									]))
							]));
				case 31:
					return A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$updateSharpProducts.l)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Sharp 今週の品目更新')
											]))
									]))
							]));
				default:
					break _v0$7;
			}
		} else {
			break _v0$7;
		}
	}
	return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$OnChangeUserId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$viewUserSelector = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ユーザ')
							])),
						A3(
						$author$project$Components$UserSelector$userSelector,
						model.k8,
						model.gF,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Cms$Products$UserSpecificRouting$OnChangeUserId, $elm$core$String$toInt))
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- adminを選択すると一覧が表示されます')
							]))
					])),
				$author$project$Pages$Cms$Products$UserSpecificRouting$viewUserSelector(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				$author$project$Pages$Cms$Products$UserSpecificRouting$viewUserPages(model)
			]));
};
var $author$project$Pages$Cms$Products$UserSpecificRouting$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Products$UserSpecificRouting$viewContent(model),
		iB: 'ユーザーごとの作業'
	};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$OnUpdateNewPermalinkGroupName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$SubmitAddPermalinkGroup = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$viewAddPermalinkGroup = function (permalinkGroup) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.as),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Stores$EditPermalinkGroups$OnUpdateNewPermalinkGroupName)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_Utils_ap(
							permalinkGroup.R ? _List_fromArray(
								[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Stores$EditPermalinkGroups$SubmitAddPermalinkGroup(permalinkGroup))
								])),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Add')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$OnUpdatePermalinkGroupName = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$SubmitDeletePermalinkGroup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$SubmitUpdatePermalinkGroup = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$viewPermalinkGroup = function (permalinkGroup) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(permalinkGroup.T))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.as),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
								$author$project$Pages$Cms$Stores$EditPermalinkGroups$OnUpdatePermalinkGroupName(permalinkGroup.T))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_Utils_ap(
							permalinkGroup.R ? _List_fromArray(
								[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Stores$EditPermalinkGroups$SubmitUpdatePermalinkGroup(permalinkGroup))
								])),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Update')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
								$author$project$Pages$Cms$Stores$EditPermalinkGroups$SubmitDeletePermalinkGroup(permalinkGroup.T))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Delete')
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- CRUD table permalink_groups')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Id')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Name')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Update')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Delete')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$author$project$Pages$Cms$Stores$EditPermalinkGroups$viewAddPermalinkGroup(model.ba),
							A2($elm$core$List$map, $author$project$Pages$Cms$Stores$EditPermalinkGroups$viewPermalinkGroup, model.i)))
					]))
			]));
};
var $author$project$Pages$Cms$Stores$EditPermalinkGroups$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Stores$EditPermalinkGroups$viewContent(model),
		iB: 'Permalink Group'
	};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$OnUpdateNewStoreGroupName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$SubmitAddStoreGroup = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$viewAddStoreGroup = function (storeGroup) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(storeGroup.kR),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Stores$EditStoreGroups$OnUpdateNewStoreGroupName)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_Utils_ap(
							storeGroup.R ? _List_fromArray(
								[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Stores$EditStoreGroups$SubmitAddStoreGroup(storeGroup))
								])),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Add')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$OnUpdateStoreGroupName = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreGroups$SubmitDeleteStoreGroup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$SubmitUpdateStoreGroup = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$viewStoreGroup = function (storeGroup) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(storeGroup.iv))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(storeGroup.kR),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
								$author$project$Pages$Cms$Stores$EditStoreGroups$OnUpdateStoreGroupName(storeGroup.iv))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_Utils_ap(
							storeGroup.R ? _List_fromArray(
								[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Stores$EditStoreGroups$SubmitUpdateStoreGroup(storeGroup))
								])),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Update')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
								$author$project$Pages$Cms$Stores$EditStoreGroups$SubmitDeleteStoreGroup(storeGroup.iv))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Delete')
							]))
					]))
			]));
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- CRUD table store_groups')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Id')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Name')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Update')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Delete')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$author$project$Pages$Cms$Stores$EditStoreGroups$viewAddStoreGroup(model.cI),
							A2($elm$core$List$map, $author$project$Pages$Cms$Stores$EditStoreGroups$viewStoreGroup, model.X)))
					]))
			]));
};
var $author$project$Pages$Cms$Stores$EditStoreGroups$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Stores$EditStoreGroups$viewContent(model),
		iB: 'Store Group'
	};
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$RowAttrs = function (a) {
	return {$: 2, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Row$attrs = function (attrs_) {
	return $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$RowAttrs(attrs_);
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Column = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$col = F2(
	function (options, children) {
		return $frandibar$elm_bootstrap$Bootstrap$Grid$Column(
			{i6: children, j7: options});
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$container = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('container')
					]),
				attributes),
			children);
	});
var $elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5 = F6(
	function (fn, arg1, arg2, arg3, arg4, arg5) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A5(fn, arg1, arg2, arg3, arg4, arg5));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy5 = F6(
	function (fn, arg1, arg2, arg3, arg4, arg5) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A7($elm$virtual_dom$VirtualDom$lazy6, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp5, fn, arg1, arg2, arg3, arg4, arg5));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy5 = $rtfeldman$elm_css$VirtualDom$Styled$lazy5;
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$Col = 0;
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$Width = F2(
	function (screenSize, columnCount) {
		return {i8: columnCount, kB: screenSize};
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign = F2(
	function (align_, options) {
		var _v0 = align_.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						eS: $elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						eQ: $elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						eP: $elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						eO: $elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						eR: $elm$core$Maybe$Just(align_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset = F2(
	function (offset_, options) {
		var _v0 = offset_.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						f_: $elm$core$Maybe$Just(offset_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						fX: $elm$core$Maybe$Just(offset_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						fW: $elm$core$Maybe$Just(offset_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						fV: $elm$core$Maybe$Just(offset_)
					});
			default:
				return _Utils_update(
					options,
					{
						fZ: $elm$core$Maybe$Just(offset_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder = F2(
	function (order_, options) {
		var _v0 = order_.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						f5: $elm$core$Maybe$Just(order_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						f3: $elm$core$Maybe$Just(order_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						f2: $elm$core$Maybe$Just(order_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						f1: $elm$core$Maybe$Just(order_)
					});
			default:
				return _Utils_update(
					options,
					{
						f4: $elm$core$Maybe$Just(order_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull = F2(
	function (pull_, options) {
		var _v0 = pull_.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						gl: $elm$core$Maybe$Just(pull_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						gj: $elm$core$Maybe$Just(pull_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						gi: $elm$core$Maybe$Just(pull_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						gh: $elm$core$Maybe$Just(pull_)
					});
			default:
				return _Utils_update(
					options,
					{
						gk: $elm$core$Maybe$Just(pull_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush = F2(
	function (push_, options) {
		var _v0 = push_.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						gq: $elm$core$Maybe$Just(push_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						go: $elm$core$Maybe$Just(push_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						gn: $elm$core$Maybe$Just(push_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						gm: $elm$core$Maybe$Just(push_)
					});
			default:
				return _Utils_update(
					options,
					{
						gp: $elm$core$Maybe$Just(push_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth = F2(
	function (width_, options) {
		var _v0 = width_.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						eJ: $elm$core$Maybe$Just(width_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						eH: $elm$core$Maybe$Just(width_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						eG: $elm$core$Maybe$Just(width_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						eF: $elm$core$Maybe$Just(width_)
					});
			default:
				return _Utils_update(
					options,
					{
						eI: $elm$core$Maybe$Just(width_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 6:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs)
					});
			case 0:
				var width_ = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth, width_, options);
			case 1:
				var offset_ = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset, offset_, options);
			case 2:
				var pull_ = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull, pull_, options);
			case 3:
				var push_ = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush, push_, options);
			case 4:
				var order_ = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder, order_, options);
			case 5:
				var align = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign, align, options);
			default:
				var align = modifier.a;
				return _Utils_update(
					options,
					{
						gS: $elm$core$Maybe$Just(align)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption = function (size) {
	switch (size) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('1');
		case 2:
			return $elm$core$Maybe$Just('2');
		case 3:
			return $elm$core$Maybe$Just('3');
		case 4:
			return $elm$core$Maybe$Just('4');
		case 5:
			return $elm$core$Maybe$Just('5');
		case 6:
			return $elm$core$Maybe$Just('6');
		case 7:
			return $elm$core$Maybe$Just('7');
		case 8:
			return $elm$core$Maybe$Just('8');
		case 9:
			return $elm$core$Maybe$Just('9');
		case 10:
			return $elm$core$Maybe$Just('10');
		case 11:
			return $elm$core$Maybe$Just('11');
		case 12:
			return $elm$core$Maybe$Just('12');
		default:
			return $elm$core$Maybe$Just('auto');
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass = function (_v0) {
	var screenSize = _v0.kB;
	var columnCount = _v0.i8;
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		'col' + (A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption(columnCount)))));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes = function (widths) {
	var width_ = function (w) {
		return A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass, w);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, width_, widths));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions = {eO: $elm$core$Maybe$Nothing, eP: $elm$core$Maybe$Nothing, eQ: $elm$core$Maybe$Nothing, eR: $elm$core$Maybe$Nothing, eS: $elm$core$Maybe$Nothing, eW: _List_Nil, fV: $elm$core$Maybe$Nothing, fW: $elm$core$Maybe$Nothing, fX: $elm$core$Maybe$Nothing, fZ: $elm$core$Maybe$Nothing, f_: $elm$core$Maybe$Nothing, f1: $elm$core$Maybe$Nothing, f2: $elm$core$Maybe$Nothing, f3: $elm$core$Maybe$Nothing, f4: $elm$core$Maybe$Nothing, f5: $elm$core$Maybe$Nothing, gh: $elm$core$Maybe$Nothing, gi: $elm$core$Maybe$Nothing, gj: $elm$core$Maybe$Nothing, gk: $elm$core$Maybe$Nothing, gl: $elm$core$Maybe$Nothing, gm: $elm$core$Maybe$Nothing, gn: $elm$core$Maybe$Nothing, go: $elm$core$Maybe$Nothing, gp: $elm$core$Maybe$Nothing, gq: $elm$core$Maybe$Nothing, gS: $elm$core$Maybe$Nothing, eF: $elm$core$Maybe$Nothing, eG: $elm$core$Maybe$Nothing, eH: $elm$core$Maybe$Nothing, eI: $elm$core$Maybe$Nothing, eJ: $elm$core$Maybe$Nothing};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		default:
			return '11';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString = function (screenSize) {
	var _v0 = $frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize);
	if (!_v0.$) {
		var s = _v0.a;
		return '-' + (s + '-');
	} else {
		return '-';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass = function (_v0) {
	var screenSize = _v0.kB;
	var offsetCount = _v0.j2;
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		'offset' + ($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption(offsetCount)));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes = function (offsets) {
	var offset_ = function (m) {
		return A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass, m);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, offset_, offsets));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption = function (size) {
	switch (size) {
		case 0:
			return 'first';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		case 12:
			return '12';
		default:
			return 'last';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes = function (orders) {
	var order_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.kB;
			var moveCount = m.a.cF;
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
					'order' + ($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, order_, orders));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		default:
			return '12';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes = function (pulls) {
	var pull_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.kB;
			var moveCount = m.a.cF;
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
					'pull' + ($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, pull_, pulls));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes = function (pushes) {
	var push_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.kB;
			var moveCount = m.a.cF;
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
					'push' + ($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, push_, pushes));
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption = function (dir) {
	switch (dir) {
		case 1:
			return 'center';
		case 0:
			return 'left';
		default:
			return 'right';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass = function (_v0) {
	var dir = _v0.jc;
	var size = _v0.kK;
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		'text' + (A2(
			$elm$core$Maybe$withDefault,
			'-',
			A2(
				$elm$core$Maybe$map,
				function (s) {
					return '-' + (s + '-');
				},
				$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size))) + $frandibar$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption(dir)));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		default:
			return 'end';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass = F2(
	function (prefix, _v0) {
		var align = _v0.iP;
		var screenSize = _v0.kB;
		return $rtfeldman$elm_css$Html$Styled$Attributes$class(
			_Utils_ap(
				prefix,
				_Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function (v) {
								return v + '-';
							},
							$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))),
					$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption(align))));
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes = F2(
	function (prefix, aligns) {
		var align = function (a) {
			return A2(
				$elm$core$Maybe$map,
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass(prefix),
				a);
		};
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2($elm$core$List$map, align, aligns));
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption, $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions, modifiers);
	var shouldAddDefaultXs = !$elm$core$List$length(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[options.eJ, options.eH, options.eG, options.eF, options.eI])));
	return _Utils_ap(
		$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes(
			_List_fromArray(
				[
					shouldAddDefaultXs ? $elm$core$Maybe$Just(
					A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$Width, 0, 0)) : options.eJ,
					options.eH,
					options.eG,
					options.eF,
					options.eI
				])),
		_Utils_ap(
			$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes(
				_List_fromArray(
					[options.f_, options.fX, options.fW, options.fV, options.fZ])),
			_Utils_ap(
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes(
					_List_fromArray(
						[options.gl, options.gj, options.gi, options.gh, options.gk])),
				_Utils_ap(
					$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes(
						_List_fromArray(
							[options.gq, options.go, options.gn, options.gm, options.gp])),
					_Utils_ap(
						$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes(
							_List_fromArray(
								[options.f5, options.f3, options.f2, options.f1, options.f4])),
						_Utils_ap(
							A2(
								$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
								'align-self-',
								_List_fromArray(
									[options.eS, options.eQ, options.eP, options.eO, options.eR])),
							_Utils_ap(
								function () {
									var _v0 = options.gS;
									if (!_v0.$) {
										var a = _v0.a;
										return _List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(a)
											]);
									} else {
										return _List_Nil;
									}
								}(),
								options.eW)))))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$keyedNode = $rtfeldman$elm_css$VirtualDom$Styled$KeyedNode;
var $rtfeldman$elm_css$Html$Styled$Keyed$node = $rtfeldman$elm_css$VirtualDom$Styled$keyedNode;
var $frandibar$elm_bootstrap$Bootstrap$Grid$renderCol = function (column) {
	switch (column.$) {
		case 0:
			var options = column.a.j7;
			var children = column.a.i6;
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
				children);
		case 1:
			var e = column.a;
			return e;
		default:
			var options = column.a.j7;
			var children = column.a.i6;
			return A3(
				$rtfeldman$elm_css$Html$Styled$Keyed$node,
				'div',
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
				children);
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign = F2(
	function (align, options) {
		var _v0 = align.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						fv: $elm$core$Maybe$Just(align)
					});
			case 1:
				return _Utils_update(
					options,
					{
						ft: $elm$core$Maybe$Just(align)
					});
			case 2:
				return _Utils_update(
					options,
					{
						fs: $elm$core$Maybe$Just(align)
					});
			case 3:
				return _Utils_update(
					options,
					{
						fr: $elm$core$Maybe$Just(align)
					});
			default:
				return _Utils_update(
					options,
					{
						fu: $elm$core$Maybe$Just(align)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign = F2(
	function (align_, options) {
		var _v0 = align_.kB;
		switch (_v0) {
			case 0:
				return _Utils_update(
					options,
					{
						g7: $elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						g5: $elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						g4: $elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						g3: $elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						g6: $elm$core$Maybe$Just(align_)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 2:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs)
					});
			case 0:
				var align = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign, align, options);
			default:
				var align = modifier.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign, align, options);
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions = {eW: _List_Nil, fr: $elm$core$Maybe$Nothing, fs: $elm$core$Maybe$Nothing, ft: $elm$core$Maybe$Nothing, fu: $elm$core$Maybe$Nothing, fv: $elm$core$Maybe$Nothing, g3: $elm$core$Maybe$Nothing, g4: $elm$core$Maybe$Nothing, g5: $elm$core$Maybe$Nothing, g6: $elm$core$Maybe$Nothing, g7: $elm$core$Maybe$Nothing};
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		case 2:
			return 'end';
		case 3:
			return 'around';
		default:
			return 'between';
	}
};
var $frandibar$elm_bootstrap$Bootstrap$General$Internal$hAlignClass = function (_v0) {
	var align = _v0.iP;
	var screenSize = _v0.kB;
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		'justify-content-' + (A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (v) {
					return v + '-';
				},
				$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + $frandibar$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption(align)));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes = function (aligns) {
	var align = function (a) {
		return A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$General$Internal$hAlignClass, a);
	};
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		A2($elm$core$List$map, align, aligns));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption, $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('row')
			]),
		_Utils_ap(
			A2(
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
				'align-items-',
				_List_fromArray(
					[options.g7, options.g5, options.g4, options.g3, options.g6])),
			_Utils_ap(
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes(
					_List_fromArray(
						[options.fv, options.ft, options.fs, options.fr, options.fu])),
				options.eW)));
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$row = F2(
	function (options, cols) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes(options),
			A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Grid$renderCol, cols));
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnClickApplyButton = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnClickDeleteButton = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnClickResetButton = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateConstantPoint = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateConvertTypeId = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateDriverId = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePointRegex = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePointSelector = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePriceRegex = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePriceSelector = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePropertyName = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateSleepTime = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateSoldoutRegex = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateSoldoutSelector = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$Config = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$mapOptions = F2(
	function (mapper, _v0) {
		var conf = _v0;
		var options = conf.j7;
		return _Utils_update(
			conf,
			{
				j7: mapper(options)
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup = $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$mapOptions(
	function (opts) {
		return _Utils_update(
			opts,
			{fG: true});
	});
var $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$ColAttrs = function (a) {
	return {$: 6, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs = function (attrs_) {
	return $frandibar$elm_bootstrap$Bootstrap$Grid$Internal$ColAttrs(attrs_);
};
var $frandibar$elm_bootstrap$Bootstrap$Card$Config = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$CardBlock = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$applyBlockModifier = F2(
	function (option, options) {
		switch (option.$) {
			case 0:
				var align = option.a;
				return _Utils_update(
					options,
					{
						aR: $elm$core$Maybe$Just(align)
					});
			case 1:
				var role = option.a;
				return _Utils_update(
					options,
					{
						aX: $elm$core$Maybe$Just(role)
					});
			case 2:
				var color = option.a;
				return _Utils_update(
					options,
					{
						bk: $elm$core$Maybe$Just(color)
					});
			default:
				var attrs = option.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$defaultBlockOptions = {aR: $elm$core$Maybe$Nothing, eW: _List_Nil, aX: $elm$core$Maybe$Nothing, bk: $elm$core$Maybe$Nothing};
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$blockAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Card$Internal$applyBlockModifier, $frandibar$elm_bootstrap$Bootstrap$Card$Internal$defaultBlockOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('card-body')
			]),
		_Utils_ap(
			function () {
				var _v0 = options.aR;
				if (!_v0.$) {
					var align = _v0.a;
					return _List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(align)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.aX;
					if (!_v1.$) {
						var role = _v1.a;
						return _List_fromArray(
							[
								A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg', role)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v2 = options.bk;
						if (!_v2.$) {
							var color = _v2.a;
							return _List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Internal$Text$textColorClass(color)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					options.eW))));
};
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$block = F2(
	function (options, items) {
		return $frandibar$elm_bootstrap$Bootstrap$Card$Internal$CardBlock(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				$frandibar$elm_bootstrap$Bootstrap$Card$Internal$blockAttributes(options),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var e = _v0;
						return e;
					},
					items)));
	});
var $frandibar$elm_bootstrap$Bootstrap$Card$block = F3(
	function (options, items, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				hg: _Utils_ap(
					conf.hg,
					_List_fromArray(
						[
							A2($frandibar$elm_bootstrap$Bootstrap$Card$Internal$block, options, items)
						]))
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$mapConfig = F2(
	function (mapper, _v0) {
		var configRec = _v0;
		return mapper(configRec);
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children = function (children_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$mapConfig(
		function (conf) {
			return _Utils_update(
				conf,
				{i6: children_});
		});
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Col = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Form$col = F2(
	function (options, children) {
		return {i6: children, jj: $rtfeldman$elm_css$Html$Styled$div, j7: options};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$colLabel = F2(
	function (options, children) {
		return {
			i6: children,
			jj: $rtfeldman$elm_css$Html$Styled$label,
			j7: A2(
				$elm$core$List$cons,
				$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('col-form-label')
						])),
				options)
		};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$colLabelSm = function (options) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$colLabel(
		A2(
			$elm$core$List$cons,
			$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('col-form-label-sm')
					])),
			options));
};
var $frandibar$elm_bootstrap$Bootstrap$Card$config = function (options) {
	return {hg: _List_Nil, hw: $elm$core$Maybe$Nothing, fz: $elm$core$Maybe$Nothing, hE: $elm$core$Maybe$Nothing, hF: $elm$core$Maybe$Nothing, j7: options};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config = {
	i6: _List_Nil,
	fO: $elm$core$Maybe$Nothing,
	j7: {eW: _List_Nil, fg: false, fG: false}
};
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$BlockItem = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Card$Block$custom = function (element) {
	return element;
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Danger = 5;
var $frandibar$elm_bootstrap$Bootstrap$Button$danger = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled(5));
var $frandibar$elm_bootstrap$Bootstrap$Card$Header = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Card$headerPrivate = F4(
	function (elemFn, attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				fz: $elm$core$Maybe$Just(
					A2(
						elemFn,
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_css$Html$Styled$Attributes$class('card-header'),
							attributes),
						children))
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Card$header = $frandibar$elm_bootstrap$Bootstrap$Card$headerPrivate($rtfeldman$elm_css$Html$Styled$div);
var $rtfeldman$elm_css$Html$Styled$legend = $rtfeldman$elm_css$Html$Styled$node('legend');
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend = F2(
	function (attributes, children_) {
		return $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$mapConfig(
			function (conf) {
				return _Utils_update(
					conf,
					{
						fO: $elm$core$Maybe$Just(
							A2($rtfeldman$elm_css$Html$Styled$legend, attributes, children_))
					});
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$Coloring = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$Roled = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Card$light = $frandibar$elm_bootstrap$Bootstrap$Card$Internal$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Card$Internal$Roled(6));
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$OnChange = function (a) {
	return {$: 4, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange = function (toMsg) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Select$OnChange(toMsg);
};
var $frandibar$elm_bootstrap$Bootstrap$Button$resetButton = F2(
	function (options, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('reset'),
				$frandibar$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options)),
			children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$renderCol = function (_v0) {
	var elemFn = _v0.jj;
	var options = _v0.j7;
	var children = _v0.i6;
	return A2(
		elemFn,
		$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
		children);
};
var $frandibar$elm_bootstrap$Bootstrap$Form$row = F2(
	function (options, cols) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$class('form-group'),
				$frandibar$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes(options)),
			A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Form$renderCol, cols));
	});
var $frandibar$elm_bootstrap$Bootstrap$Button$submitButton = F2(
	function (options, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			A2(
				$elm$core$List$cons,
				$rtfeldman$elm_css$Html$Styled$Attributes$type_('submit'),
				$frandibar$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options)),
			children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$applyModifier = F2(
	function (option, options) {
		switch (option.$) {
			case 0:
				var align = option.a;
				return _Utils_update(
					options,
					{
						aR: $elm$core$Maybe$Just(align)
					});
			case 1:
				var coloring = option.a;
				return _Utils_update(
					options,
					{
						aX: $elm$core$Maybe$Just(coloring)
					});
			case 2:
				var coloring = option.a;
				return _Utils_update(
					options,
					{
						bk: $elm$core$Maybe$Just(coloring)
					});
			default:
				var attrs = option.a;
				return _Utils_update(
					options,
					{
						eW: _Utils_ap(options.eW, attrs)
					});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$defaultOptions = {aR: $elm$core$Maybe$Nothing, eW: _List_Nil, aX: $elm$core$Maybe$Nothing, bk: $elm$core$Maybe$Nothing};
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$cardAttributes = function (modifiers) {
	var options = A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Card$Internal$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Card$Internal$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('card')
			]),
		_Utils_ap(
			function () {
				var _v0 = options.aX;
				if (!_v0.$) {
					if (!_v0.a.$) {
						var role = _v0.a.a;
						return _List_fromArray(
							[
								A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg', role)
							]);
					} else {
						var role = _v0.a.a;
						return _List_fromArray(
							[
								A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'border', role)
							]);
					}
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = options.bk;
					if (!_v1.$) {
						var color = _v1.a;
						return _List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Internal$Text$textColorClass(color)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v2 = options.aR;
						if (!_v2.$) {
							var align = _v2.a;
							return _List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(align)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					options.eW))));
};
var $frandibar$elm_bootstrap$Bootstrap$Card$Internal$renderBlocks = function (blocks) {
	return A2(
		$elm$core$List$map,
		function (block_) {
			if (!block_.$) {
				var e = block_.a;
				return e;
			} else {
				var e = block_.a;
				return e;
			}
		},
		blocks);
};
var $frandibar$elm_bootstrap$Bootstrap$Card$view = function (_v0) {
	var conf = _v0;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		$frandibar$elm_bootstrap$Bootstrap$Card$Internal$cardAttributes(conf.j7),
		_Utils_ap(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var e = _v1;
							return e;
						},
						conf.fz),
						A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var e = _v2;
							return e;
						},
						conf.hF)
					])),
			_Utils_ap(
				$frandibar$elm_bootstrap$Bootstrap$Card$Internal$renderBlocks(conf.hg),
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$map,
							function (_v3) {
								var e = _v3;
								return e;
							},
							conf.hw),
							A2(
							$elm$core$Maybe$map,
							function (_v4) {
								var e = _v4;
								return e;
							},
							conf.hE)
						])))));
};
var $rtfeldman$elm_css$Html$Styled$fieldset = $rtfeldman$elm_css$Html$Styled$node('fieldset');
var $frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view = function (_v0) {
	var rec = _v0;
	var options = rec.j7;
	return A2(
		$rtfeldman$elm_css$Html$Styled$fieldset,
		_Utils_ap(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-group', options.fG)
						])),
					$rtfeldman$elm_css$Html$Styled$Attributes$disabled(options.fg)
				]),
			options.eW),
		function (xs) {
			return A2($elm$core$List$append, xs, rec.i6);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (e) {
						return _List_fromArray(
							[e]);
					},
					rec.fO))));
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$viewCard = F5(
	function (convertTypes, drivers, updateRequestState, updatingPropertyId, storeProperty) {
		return $frandibar$elm_bootstrap$Bootstrap$Card$view(
			A3(
				$frandibar$elm_bootstrap$Bootstrap$Card$block,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Card$Block$custom(
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$form,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('selector')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(storeProperty.cP),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePriceSelector(storeProperty.nm))
																			]))
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('regex')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(storeProperty.cO),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePriceRegex(storeProperty.nm))
																			]))
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('price')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												])),
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('selector')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
																				A2($elm$core$Maybe$withDefault, '', storeProperty.cM)),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePointSelector(storeProperty.nm))
																			]))
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('regex')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
																				A2($elm$core$Maybe$withDefault, '', storeProperty.cL)),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePointRegex(storeProperty.nm))
																			]))
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('point')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												])),
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('selector')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
																				A2($elm$core$Maybe$withDefault, '', storeProperty.c9)),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateSoldoutSelector(storeProperty.nm))
																			]))
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('regex')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
																				A2($elm$core$Maybe$withDefault, '', storeProperty.c8)),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateSoldoutRegex(storeProperty.nm))
																			]))
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('soldout')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												])),
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('constant point')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
																				$elm$core$String$fromInt(storeProperty.cf)),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateConstantPoint(storeProperty.nm))
																			]))
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('sleep time')
																			])),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
																				$elm$core$String$fromInt(storeProperty.c5)),
																				$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateSleepTime(storeProperty.nm))
																			]))
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('\u3000')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												])),
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('convert type')
																			])),
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateConvertTypeId(storeProperty.nm))
																			]),
																		A2(
																			$elm$core$List$map,
																			function (convertType) {
																				return A2(
																					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$Attributes$value(
																							$elm$core$String$fromInt(convertType.e9.dR)),
																							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																							_Utils_eq(convertType.e9.dR, storeProperty.cg))
																						]),
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$text(convertType.e9.jP)
																						]));
																			},
																			convertTypes))
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('driver id')
																			])),
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
																		_List_fromArray(
																			[
																				$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange(
																				$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateDriverId(storeProperty.nm))
																			]),
																		A2(
																			$elm$core$List$map,
																			function (driver) {
																				return A2(
																					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$Attributes$value(
																							$elm$core$String$fromInt(driver.dR)),
																							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																							_Utils_eq(driver.dR, storeProperty.cm)),
																							$rtfeldman$elm_css$Html$Styled$Events$onInput(
																							$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdateDriverId(storeProperty.nm))
																						]),
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$text(driver.jP)
																						]));
																			},
																			drivers))
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('\u3000')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												]))
										]))
								])))
					]),
				A3(
					$frandibar$elm_bootstrap$Bootstrap$Card$header,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('align-items-center')
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$form,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$row,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Grid$Row$attrs(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('align-items-center')
												]))
										]),
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$colLabelSm,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-auto')
															]))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$elm$core$String$fromInt(storeProperty.nm))
													])),
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$col,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-lg-8')
															]))
													]),
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																$author$project$Pages$Cms$Stores$EditStoreProperties$OnUpdatePropertyName(storeProperty.nm)),
																$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(storeProperty.cT)
															]))
													])),
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$col,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-auto')
															]))
													]),
												_List_fromArray(
													[
														((updateRequestState === 1) && _Utils_eq(
														updatingPropertyId,
														$elm$core$Maybe$Just(storeProperty.nm))) ? A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$submitButton,
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Button$primary,
																$frandibar$elm_bootstrap$Bootstrap$Button$small,
																$frandibar$elm_bootstrap$Bootstrap$Button$disabled(true)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('loading')
															])) : (((updateRequestState === 2) && _Utils_eq(
														updatingPropertyId,
														$elm$core$Maybe$Just(storeProperty.nm))) ? A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$submitButton,
														_List_fromArray(
															[$frandibar$elm_bootstrap$Bootstrap$Button$primary, $frandibar$elm_bootstrap$Bootstrap$Button$small, $frandibar$elm_bootstrap$Bootstrap$Button$success]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('ok!')
															])) : (((updateRequestState === 3) && _Utils_eq(
														updatingPropertyId,
														$elm$core$Maybe$Just(storeProperty.nm))) ? A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$submitButton,
														_List_fromArray(
															[$frandibar$elm_bootstrap$Bootstrap$Button$primary, $frandibar$elm_bootstrap$Bootstrap$Button$small, $frandibar$elm_bootstrap$Bootstrap$Button$danger]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('failed!')
															])) : A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$submitButton,
														_Utils_ap(
															_List_fromArray(
																[
																	$frandibar$elm_bootstrap$Bootstrap$Button$small,
																	$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
																	$author$project$Pages$Cms$Stores$EditStoreProperties$OnClickApplyButton(storeProperty.nm))
																]),
															storeProperty.R ? _List_fromArray(
																[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil),
														_List_fromArray(
															[
																_Utils_eq(storeProperty.nm, -1) ? $rtfeldman$elm_css$Html$Styled$text('Add') : $rtfeldman$elm_css$Html$Styled$text('Apply')
															]))))
													])),
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$col,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-auto')
															]))
													]),
												_List_fromArray(
													[
														A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$resetButton,
														_Utils_ap(
															_List_fromArray(
																[
																	$frandibar$elm_bootstrap$Bootstrap$Button$small,
																	$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Events$onClick(
																			$author$project$Pages$Cms$Stores$EditStoreProperties$OnClickResetButton(storeProperty.nm))
																		]))
																]),
															storeProperty.R ? _List_fromArray(
																[$frandibar$elm_bootstrap$Bootstrap$Button$danger]) : _List_Nil),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('Reset')
															]))
													]))
											]),
										_Utils_eq(storeProperty.nm, -1) ? _List_Nil : _List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$col,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-auto')
															]))
													]),
												_List_fromArray(
													[
														A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$resetButton,
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Button$danger,
																$frandibar$elm_bootstrap$Bootstrap$Button$small,
																$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Events$onClick(
																		$author$project$Pages$Cms$Stores$EditStoreProperties$OnClickDeleteButton(storeProperty.nm))
																	]))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('Delete')
															]))
													]))
											])))
								]))
						]),
					$frandibar$elm_bootstrap$Bootstrap$Card$config(
						_List_fromArray(
							[$frandibar$elm_bootstrap$Bootstrap$Card$light])))));
	});
var $author$project$Pages$Cms$Stores$EditStoreProperties$viewContent = function (model) {
	return model.fB ? A2(
		$frandibar$elm_bootstrap$Bootstrap$Spinner$spinner,
		_List_fromArray(
			[$frandibar$elm_bootstrap$Bootstrap$Spinner$grow, $frandibar$elm_bootstrap$Bootstrap$Spinner$large]),
		_List_Nil) : A2(
		$frandibar$elm_bootstrap$Bootstrap$Grid$container,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			A2(
				$frandibar$elm_bootstrap$Bootstrap$Grid$row,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Grid$Row$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								A6($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$Pages$Cms$Stores$EditStoreProperties$viewCard, model.bp, model.bt, model.F, model.bm, model.bb)
							]))
					])),
			A2(
				$elm$core$List$map,
				function (storeProperty) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Grid$row,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Grid$Row$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Grid$col,
								_List_Nil,
								_List_fromArray(
									[
										A6($rtfeldman$elm_css$Html$Styled$Lazy$lazy5, $author$project$Pages$Cms$Stores$EditStoreProperties$viewCard, model.bp, model.bt, model.F, model.bm, storeProperty)
									]))
							]));
				},
				$elm$core$Dict$values(model.Y))));
};
var $author$project$Pages$Cms$Stores$EditStoreProperties$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Stores$EditStoreProperties$viewContent(model),
		iB: 'Netgate/取得店舗の属性の設定'
	};
};
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			A2(fn, arg1, arg2));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy2 = F3(
	function (fn, arg1, arg2) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A4($elm$virtual_dom$VirtualDom$lazy3, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp2, fn, arg1, arg2));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy2 = $rtfeldman$elm_css$VirtualDom$Styled$lazy2;
var $author$project$Pages$Cms$Stores$EditStores$Add = {$: 8};
var $author$project$Pages$Cms$Stores$EditStores$Delete = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$Stores$EditStores$OnUpdateDisplayName = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStores$OnUpdateExhibitionName = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStores$OnUpdatePermalinkGroupId = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStores$OnUpdateStoreGroupId = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStores$OnUpdateStoreName = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStores$OnUpdateStorePropertyId = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStores$OnUpdateUrl = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditStores$Update = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Cms$Stores$EditStores$permalinkGroupsSelector = F3(
	function (permalinkGroups, selectedPermalinkGroupId, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(selectedPermalinkGroupId))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (permgrp) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(permgrp.U)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedPermalinkGroupId),
												permgrp.U))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(permgrp.j8)
										]));
							},
							permalinkGroups)))
				]));
	});
var $author$project$Pages$Cms$Stores$EditStores$propertiesSelector = F3(
	function (storeProperties, selectedPropertyId, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(selectedPropertyId))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (property) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(property.nm)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedPropertyId),
												property.nm))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(property.cT)
										]));
							},
							$elm$core$Dict$values(storeProperties))))
				]));
	});
var $author$project$Pages$Cms$Stores$EditStores$storeGroupsSelector = F3(
	function (storeGroups, selectedStoreGroupId, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(selectedStoreGroupId))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (storegrp) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(storegrp.nL)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedStoreGroupId),
												storegrp.nL))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(storegrp.kU)
										]));
							},
							storeGroups)))
				]));
	});
var $author$project$Pages$Cms$Stores$EditStores$viewCard = F2(
	function (model, store) {
		var url = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input url'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
					A2($elm$core$Maybe$withDefault, '', store.eD)),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
					$author$project$Pages$Cms$Stores$EditStores$OnUpdateUrl(store.gM))
				]));
		var storePropertySelectors = A3(
			$author$project$Pages$Cms$Stores$EditStores$propertiesSelector,
			model.Y,
			store.nm,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Pages$Cms$Stores$EditStores$OnUpdateStorePropertyId(store.gM),
						$elm$core$String$toInt))
				]));
		var storeName = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input store_name'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
					A2($elm$core$Maybe$withDefault, '', store.el)),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
					$author$project$Pages$Cms$Stores$EditStores$OnUpdateStoreName(store.gM))
				]));
		var storeGroupsSelectors = A3(
			$author$project$Pages$Cms$Stores$EditStores$storeGroupsSelector,
			model.X,
			store.nL,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Pages$Cms$Stores$EditStores$OnUpdateStoreGroupId(store.gM),
						$elm$core$String$toInt))
				]));
		var permalinkGroupsSelectors = A3(
			$author$project$Pages$Cms$Stores$EditStores$permalinkGroupsSelector,
			model.i,
			store.U,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onInput(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Pages$Cms$Stores$EditStores$OnUpdatePermalinkGroupId(store.gM),
						$elm$core$String$toInt))
				]));
		var exhibitionName = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input exhibition_name'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
					A2($elm$core$Maybe$withDefault, '', store.l3)),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
					$author$project$Pages$Cms$Stores$EditStores$OnUpdateExhibitionName(store.gM))
				]));
		var displayName = $frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$placeholder('Input display_name'),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
					A2($elm$core$Maybe$withDefault, '', store.jd)),
					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
					$author$project$Pages$Cms$Stores$EditStores$OnUpdateDisplayName(store.gM))
				]));
		return $frandibar$elm_bootstrap$Bootstrap$Card$view(
			A3(
				$frandibar$elm_bootstrap$Bootstrap$Card$block,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Card$Block$custom(
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$form,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('store_groups')
																			])),
																		storeGroupsSelectors
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('url')
																			])),
																		url
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												])),
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('store_property')
																			])),
																		storePropertySelectors
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('store_name')
																			])),
																		storeName
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												])),
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$col,
											_List_Nil,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$view(
													A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$children,
														_List_fromArray(
															[
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('permalink_group_id')
																			])),
																		permalinkGroupsSelectors
																	])),
																A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$group,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('exhibition_name')
																			])),
																		exhibitionName
																	]))
															]),
														A3(
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$legend,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('')
																]),
															$frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$asGroup($frandibar$elm_bootstrap$Bootstrap$Form$Fieldset$config))))
												]))
										]))
								])))
					]),
				A3(
					$frandibar$elm_bootstrap$Bootstrap$Card$header,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('align-items-center')
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$form,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$row,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Grid$Row$attrs(
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('align-items-center')
												]))
										]),
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$colLabelSm,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-auto')
															]))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$elm$core$String$fromInt(store.gM))
													])),
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$col,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-lg-8')
															]))
													]),
												_List_fromArray(
													[displayName])),
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$col,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-auto')
															]))
													]),
												_List_fromArray(
													[
														_Utils_eq(store.gM, -1) ? A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$button,
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Button$primary,
																$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Cms$Stores$EditStores$Add)
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('Add')
															])) : A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$button,
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Button$secondary,
																$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
																$author$project$Pages$Cms$Stores$EditStores$Update(store.gM))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('Update')
															]))
													]))
											]),
										_Utils_eq(store.gM, -1) ? _List_Nil : _List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$col,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Grid$Col$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('col-auto')
															]))
													]),
												_List_fromArray(
													[
														A2(
														$frandibar$elm_bootstrap$Bootstrap$Button$resetButton,
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Button$danger,
																$frandibar$elm_bootstrap$Bootstrap$Button$small,
																$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
																$author$project$Pages$Cms$Stores$EditStores$Delete(store.gM))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('Delete')
															]))
													]))
											])))
								]))
						]),
					$frandibar$elm_bootstrap$Bootstrap$Card$config(
						_List_fromArray(
							[$frandibar$elm_bootstrap$Bootstrap$Card$light])))));
	});
var $author$project$Pages$Cms$Stores$EditStores$viewContent = function (model) {
	return model.fB ? A2(
		$frandibar$elm_bootstrap$Bootstrap$Spinner$spinner,
		_List_fromArray(
			[$frandibar$elm_bootstrap$Bootstrap$Spinner$grow, $frandibar$elm_bootstrap$Bootstrap$Spinner$large]),
		_List_Nil) : A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.F === 1) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'fixed'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'top', '50%'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'left', '50%'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'transform', 'translate(-50%, -50%)'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'z-index', '1000')
					]),
				_List_fromArray(
					[
						$author$project$Components$Loading$loadingCenter(50.0)
					])) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Grid$container,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$frandibar$elm_bootstrap$Bootstrap$Grid$row,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Grid$Row$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Grid$col,
								_List_Nil,
								_List_fromArray(
									[
										A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Pages$Cms$Stores$EditStores$viewCard, model, model.bJ)
									]))
							])),
					A2(
						$elm$core$List$map,
						function (store) {
							return A2(
								$frandibar$elm_bootstrap$Bootstrap$Grid$row,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Grid$Row$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Grid$col,
										_List_Nil,
										_List_fromArray(
											[
												A3($rtfeldman$elm_css$Html$Styled$Lazy$lazy2, $author$project$Pages$Cms$Stores$EditStores$viewCard, model, store)
											]))
									]));
						},
						$elm$core$Dict$values(model.aN))))
			]));
};
var $author$project$Pages$Cms$Stores$EditStores$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Stores$EditStores$viewContent(model),
		iB: 'Storesの編集'
	};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$OnChangeSelectedUser = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$OnChangeSelectedNewStore = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$OnChangeSelectedNewStoreGroup = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateNewGetEnabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateNewGetInterval = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateNewStoreOrder = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$SubmitAddUserStore = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$viewAddUserStore = F5(
	function (userStores, selectedNewUserStore, stores, storeGroups, userStore) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(userStore.iw))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Stores$EditUsersStores$OnChangeSelectedNewStore)
										]))
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											$elm_community$maybe_extra$Maybe$Extra$isNothing(selectedNewUserStore))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('選択してください')
										])),
								A2(
									$elm$core$List$map,
									function (store) {
										return A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value(
													$elm$core$String$fromInt(store.iw)),
													$rtfeldman$elm_css$Html$Styled$Attributes$selected(
													_Utils_eq(
														selectedNewUserStore,
														$elm$core$Maybe$Just(store.iw)))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(store.kS)
												]));
									},
									A2(
										$elm$core$List$filter,
										function (s) {
											return A2(
												$elm$core$List$all,
												function (us) {
													return !_Utils_eq(s.iw, us.iw);
												},
												userStores);
										},
										stores))))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
									$elm$core$String$fromInt(userStore.kT)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateNewStoreOrder)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$String$fromInt, userStore.js)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateNewGetInterval)
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(userStore.jr),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateNewGetEnabled)
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Stores$EditUsersStores$OnChangeSelectedNewStoreGroup)
										]))
								]),
							A2(
								$elm$core$List$map,
								function (sg) {
									return A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												$elm$core$String$fromInt(sg.iv)),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(userStore.iv, sg.iv))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(sg.kR)
											]));
								},
								storeGroups))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_Utils_ap(
								userStore.R ? _List_fromArray(
									[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Cms$Stores$EditUsersStores$SubmitAddUserStore(userStore))
									])),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Add')
								]))
						])),
					A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateGetEnabled = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateGetInterval = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateStoreGroupId = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateStoreOrder = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$SubmitDeleteUserStore = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$SubmitUpdateUserStore = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Cms$Stores$EditUsersStores$viewUserStore = F3(
	function (stores, storeGroups, userStore) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(userStore.iw))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(userStore.kS)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
									$elm$core$String$fromInt(userStore.kT)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateStoreOrder(userStore.iw))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$core$String$fromInt, userStore.js)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateGetInterval(userStore.iw))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(userStore.jr),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateGetEnabled(userStore.iw))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput(
											$author$project$Pages$Cms$Stores$EditUsersStores$OnUpdateStoreGroupId(userStore.iw))
										]))
								]),
							A2(
								$elm$core$List$map,
								function (sg) {
									return A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												$elm$core$String$fromInt(sg.iv)),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(userStore.iv, sg.iv))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(sg.kR)
											]));
								},
								storeGroups))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_Utils_ap(
								userStore.R ? _List_fromArray(
									[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Cms$Stores$EditUsersStores$SubmitUpdateUserStore(userStore))
									])),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Update')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Cms$Stores$EditUsersStores$SubmitDeleteUserStore(userStore.iw))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Pages$Cms$Stores$EditUsersStores$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- CRUD table users_stores')
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('ユーザ')
									])),
								A3(
								$author$project$Components$UserSelector$userSelector,
								model.k8,
								model.$9,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Cms$Stores$EditUsersStores$OnChangeSelectedUser)
									]))
							]))
					])),
				$elm_community$maybe_extra$Maybe$Extra$isNothing(model.$9) ? A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil) : A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('store_id')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('店名')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示順番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得間隔')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('有効')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Store Group')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Update')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Delete')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A5($author$project$Pages$Cms$Stores$EditUsersStores$viewAddUserStore, model.b$, model.gC, model.aN, model.X, model.y),
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Cms$Stores$EditUsersStores$viewUserStore, model.aN, model.X),
								model.b$)))
					]))
			]));
};
var $author$project$Pages$Cms$Stores$EditUsersStores$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Stores$EditUsersStores$viewContent(model),
		iB: '取得量販店の変更'
	};
};
var $author$project$Pages$Cms$Stores$Yahoo$OnChangeDirectURL = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Stores$Yahoo$OnEnableDirectURL = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Pages$Cms$Stores$Yahoo$OnSubmit = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Cms$Stores$Yahoo$SelectProduct = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Cms$Stores$Yahoo$SelectUser = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Molecules$UserSelector$Config = $elm$core$Basics$identity;
var $author$project$Components$Molecules$UserSelector$custom = {iD: '全て選択'};
var $frandibar$elm_bootstrap$Bootstrap$Form$FormInternal$Danger = 1;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Validation = function (a) {
	return {$: 6, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$danger = $frandibar$elm_bootstrap$Bootstrap$Form$Input$Validation(1);
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $rtfeldman$elm_css$Css$row = {hv: 0, dD: 0, m: 'row'};
var $frandibar$elm_bootstrap$Bootstrap$Form$FormInternal$Success = 0;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$success = $frandibar$elm_bootstrap$Bootstrap$Form$Input$Validation(0);
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Url = 9;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$url = $frandibar$elm_bootstrap$Bootstrap$Form$Input$input(9);
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$Disabled = function (a) {
	return {$: 3, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Select$disabled = function (disabled_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Select$Disabled(disabled_);
};
var $author$project$Components$Molecules$UserSelector$view = F3(
	function (props, attrs, _v0) {
		var conf = _v0;
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs),
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$disabled(true),
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange,
					props.j3)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							$elm_community$maybe_extra$Maybe$Extra$isNothing(props.$9))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(conf.iD)
						])),
				A2(
					$elm$core$List$map,
					function (user) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									$elm$core$String$fromInt(user.k7)),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(
										A2($elm$core$Maybe$withDefault, -1, props.$9),
										user.k7))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(user.n2)
								]));
					},
					props.k8)));
	});
var $author$project$Components$Molecules$UserSelector$withUnselectedLabel = F2(
	function (label, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{iD: label});
	});
var $author$project$Pages$Cms$Stores$Yahoo$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$marginRight(
										$rtfeldman$elm_css$Css$px(16))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('ユーザー')
									])),
								A3(
								$author$project$Components$Molecules$UserSelector$view,
								{
									j3: $elm$core$Maybe$Just($author$project$Pages$Cms$Stores$Yahoo$SelectUser),
									$9: $elm$core$String$toInt(model.bU),
									k8: A3(
										$krisajenkins$remotedata$RemoteData$unwrap,
										_List_Nil,
										function (res) {
											return res.k8;
										},
										model.fC)
								},
								_List_Nil,
								A2($author$project$Components$Molecules$UserSelector$withUnselectedLabel, '選択してください', $author$project$Components$Molecules$UserSelector$custom))
							]))
					])),
				(model.fJ && (!model.cx)) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.kn;
						if (_v0.$ === 3) {
							var products = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$marginTop(
												$rtfeldman$elm_css$Css$px(24)),
												$rtfeldman$elm_css$Css$marginBottom(
												$rtfeldman$elm_css$Css$px(40)),
												$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$auto)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('商品の一覧')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$table,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table '),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'word-break', 'keep-all')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('商品名')
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('選択')
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$tbody,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (product) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(product.nk)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$frandibar$elm_bootstrap$Bootstrap$Button$button,
																			_List_fromArray(
																				[
																					$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
																					$author$project$Pages$Cms$Stores$Yahoo$SelectProduct(product.kl))
																				]),
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text('選択')
																				]))
																		]))
																]));
													},
													products))
											]))
									]));
						} else {
							return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
						}
					}()
					])) : (model.cx ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v1 = model.aY;
						if (_v1.$ === 3) {
							var urls = _v1.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$marginTop(
												$rtfeldman$elm_css$Css$px(24)),
												$rtfeldman$elm_css$Css$marginBottom(
												$rtfeldman$elm_css$Css$px(40)),
												$rtfeldman$elm_css$Css$marginLeft($rtfeldman$elm_css$Css$auto)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('YahooのURLを設定してください')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$td,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Button$button,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
														$author$project$Pages$Cms$Stores$Yahoo$SelectUser(model.bU))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('戻る')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$table,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table '),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'word-break', 'keep-all')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$thead,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('店舗名')
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Css$width(
																		$rtfeldman$elm_css$Css$px(600))
																	]))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('URL')
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('有効')
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$th,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('更新')
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$tbody,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (url) {
														var inputStatus = (url.eD === '') ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(_List_Nil) : ((A2($elm$core$String$startsWith, 'http://', url.eD) || A2($elm$core$String$startsWith, 'https://', url.eD)) ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$success : $frandibar$elm_bootstrap$Bootstrap$Form$Input$danger);
														return A2(
															$rtfeldman$elm_css$Html$Styled$tr,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(url.kS)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$css(
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Css$width(
																					$rtfeldman$elm_css$Css$px(600))
																				]))
																		]),
																	_List_fromArray(
																		[
																			$frandibar$elm_bootstrap$Bootstrap$Form$Input$url(
																			_List_fromArray(
																				[
																					$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(url.eD),
																					$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																					A2($author$project$Pages$Cms$Stores$Yahoo$OnChangeDirectURL, url.cR, url.da)),
																					inputStatus
																				]))
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$rtfeldman$elm_css$Html$Styled$input,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
																					$rtfeldman$elm_css$Html$Styled$Attributes$checked(url.fl),
																					$rtfeldman$elm_css$Html$Styled$Events$onCheck(
																					A2($author$project$Pages$Cms$Stores$Yahoo$OnEnableDirectURL, url.cR, url.da))
																				]),
																			_List_Nil)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$frandibar$elm_bootstrap$Bootstrap$Button$button,
																			_List_fromArray(
																				[
																					$frandibar$elm_bootstrap$Bootstrap$Button$disabled(
																					_Utils_eq(inputStatus, $frandibar$elm_bootstrap$Bootstrap$Form$Input$danger)),
																					$frandibar$elm_bootstrap$Bootstrap$Button$secondary,
																					$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
																					$author$project$Pages$Cms$Stores$Yahoo$OnSubmit(url))
																				]),
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text('更新')
																				]))
																		]))
																]));
													},
													urls))
											]))
									]));
						} else {
							return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
						}
					}()
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Cms$Stores$Yahoo$view = function (model) {
	return {
		lI: $author$project$Pages$Cms$Stores$Yahoo$viewContent(model),
		iB: 'Yahoo 直接取得URL設定'
	};
};
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$Pages$Cms$viewTop = {
	lI: A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$h3,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('商品管理')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$userSpecificRoutingEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('ユーザーごとの作業')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$changeUserProductEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('ユーザーごとの取得間隔，基準価格などの変更')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$addProductConfigEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('商品の追加')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editProductsEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('商品の型番，メーカー，小分類の変更')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editProductsPermalinksEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Edit products_permalinks')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editSoldoutProductsEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('販売終了商品の変更')
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$h3,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('取得店舗の管理')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editStorePropertiesEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Edit store_properties')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editPermalinkGroupsEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Edit permalink_groups')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editStoreGroupsEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Edit store_groups')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editUsersStoresEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Edit users_stores')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editStoresEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Edit stores')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href(
										$author$project$Endpoints$Cms$yahooEndpoints.l(_List_Nil))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Yahoo個別取得URL')
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$h3,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('その他の管理')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$editMailAddressEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Edit mailaddress')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$a,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$href($author$project$Endpoints$Cms$getAccessCountEndpoints.l)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('アクセス数カウント')
									]))
							]))
					]))
			])),
	iB: '管理ページ'
};
var $author$project$Pages$Cms$view = function (_v0) {
	var cmsModel = _v0.a;
	var navModel = _v0.b;
	return function (rootPageRequired) {
		return _Utils_update(
			rootPageRequired,
			{
				lI: A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Cms$cmsNavBar(navModel),
							rootPageRequired.lI
						]))
			});
	}(
		function () {
			switch (cmsModel.$) {
				case 0:
					var session = cmsModel.a;
					return $author$project$Pages$Cms$viewTop;
				case 1:
					var espModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditStorePropertiesMsg,
						$author$project$Pages$Cms$Stores$EditStoreProperties$view(espModel));
				case 2:
					var espModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditPermalinkGroupsMsg,
						$author$project$Pages$Cms$Stores$EditPermalinkGroups$view(espModel));
				case 3:
					var espModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditStoreGroupsMsg,
						$author$project$Pages$Cms$Stores$EditStoreGroups$view(espModel));
				case 4:
					var espModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditMailAddressMsg,
						$author$project$Pages$Cms$Others$EditMailAddress$view(espModel));
				case 5:
					var espModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotGetAccessCountMsg,
						$author$project$Pages$Cms$Others$GetAccessCount$view(espModel));
				case 6:
					var espModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditUsersStoresMsg,
						$author$project$Pages$Cms$Stores$EditUsersStores$view(espModel));
				case 21:
					var espModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditStoresMsg,
						$author$project$Pages$Cms$Stores$EditStores$view(espModel));
				case 10:
					var uwModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUpdateWeek30ByCsv,
						$author$project$Pages$Cms$Products$UpdateWeek30ByCsv$view(uwModel));
				case 11:
					var model = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUpdateTletProductsByCsv,
						$author$project$Pages$Cms$Products$UpdateTletProductsByCsv$view(model));
				case 12:
					var model = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUpdateTescomProductsByCsv,
						$author$project$Pages$Cms$Products$UpdateTescomProductsByCsv$view(model));
				case 9:
					var model = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUpdateSharpProductsByCsv,
						$author$project$Pages$Cms$Products$UpdateSharpProductsByCsv$view(model));
				case 7:
					var model = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUpdateHitachiWeeklyProductsByCsv,
						$author$project$Pages$Cms$Products$UpdateHitachiWeeklyProductsByCsv$view(model));
				case 8:
					var model = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUpdateHIitachiProductsOrderByCsv,
						$author$project$Pages$Cms$Products$UpdateHitachiProductsOrderByCsv$view(model));
				case 13:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUserSpecificRoutingMsg,
						$author$project$Pages$Cms$Products$UserSpecificRouting$view(reiModel));
				case 14:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotRakutenExcludedItems,
						$author$project$Pages$Cms$Products$RakutenExcludedItems$view(reiModel));
				case 15:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotChangeDisplayIntervalMsg,
						$author$project$Pages$Cms$Products$ChangeDisplayInterval$view(reiModel));
				case 17:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotAddProductConfigMsg,
						$author$project$Pages$Cms$Products$AddProductConfig$view(reiModel));
				case 18:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotChangeDisplayOrderMsg,
						$author$project$Pages$Cms$Products$ChangeDisplayOrder$view(reiModel));
				case 16:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotChangeUserProductMsg,
						$author$project$Pages$Cms$Products$ChangeUserProduct$view(reiModel));
				case 19:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditProductsPermalinks,
						$author$project$Pages$Cms$Products$EditProductsPermalinks$view(reiModel));
				case 20:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditProducts,
						$author$project$Pages$Cms$Products$EditProducts$view(reiModel));
				case 22:
					var yModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotYahooMsg,
						$author$project$Pages$Cms$Stores$Yahoo$view(yModel));
				case 23:
					var reiModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotEditSoldoutProductsMsg,
						$author$project$Pages$Cms$Products$EditSoldoutProducts$view(reiModel));
				default:
					var uwModel = cmsModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$Cms$GotUpdateFujiWeeklyProductsByCsv,
						$author$project$Pages$Cms$Products$UpdateFujiWeeklyProductsByCsv$view(uwModel));
			}
		}());
};
var $author$project$Pages$Login$EnteredPassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Login$EnteredUserName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Login$SubmittedForm = {$: 0};
var $rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $rtfeldman$elm_css$Html$Styled$Events$onSubmit = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Password = 1;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$password = $frandibar$elm_bootstrap$Bootstrap$Form$Input$input(1);
var $author$project$Pages$Login$formContent = F3(
	function (userName, password, errMsg) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$form,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Events$onSubmit($author$project$Pages$Login$SubmittedForm),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('mx-auto col-lg-4')
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('ユーザーID')
								])),
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Login$EnteredUserName),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(userName)
										]))
								]))
						])),
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$group,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('パスワード')
								])),
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$password(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Login$EnteredPassword),
											$rtfeldman$elm_css$Html$Styled$Attributes$value(password)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$span,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger small')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									A2($elm$core$Maybe$withDefault, '', errMsg))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$submitButton,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Login$SubmittedForm),
									$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('float-right')
										]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('Submit')
								]))
						]))
				]));
	});
var $author$project$Pages$Login$view = function (model) {
	return {
		lI: A3($author$project$Pages$Login$formContent, model.a5.n2, model.a5.d7, model.H),
		iB: 'Netgate/ログインページ'
	};
};
var $author$project$Pages$User$fujiComnetPriceNav = _List_fromArray(
	[
		{jP: '15分取得', eD: '/user/fuji-comnet/fifteen'},
		{jP: '15分時系列', eD: '/user/fuji-comnet/time-seq-fifteen'},
		{jP: '今週の品目 15分取得', eD: '/user/fuji-comnet/weekly-product-15min'},
		{jP: '販売店別', eD: '/user/fuji-comnet/latest-store'},
		{jP: '各種設定', eD: '/user/fuji-comnet/week30'}
	]);
var $author$project$Pages$User$fujiComnetSettingsNav = _List_fromArray(
	[
		{jP: '優先型番の設定', eD: '/user/fuji-comnet/week30'},
		{jP: '価格・ポイント設定', eD: '/user/fuji-comnet/change-product'},
		{jP: 'メール管理', eD: '/user/fuji-comnet/mail-address'}
	]);
var $author$project$Pages$User$fujiComnetPagesFor = function (userModel) {
	switch (userModel.$) {
		case 92:
			return $author$project$Pages$User$fujiComnetSettingsNav;
		case 93:
			return $author$project$Pages$User$fujiComnetSettingsNav;
		case 95:
			return $author$project$Pages$User$fujiComnetSettingsNav;
		default:
			return $author$project$Pages$User$fujiComnetPriceNav;
	}
};
var $author$project$Pages$User$mlnAdmin = _List_fromArray(
	[
		{jP: 'WEB価格', eD: '/user/mln-comnet/hour'},
		{jP: 'WEB価格（自動更新）', eD: '/user/mln-comnet/auto-reload'},
		{jP: '時系列データ', eD: '/user/mln-comnet/chronological-30min'},
		{jP: '価格/アラート設定', eD: '/user/mln-comnet/change-product'},
		{jP: '送信先設定', eD: '/user/mln-comnet/change-mail'},
		{jP: '送信時間設定', eD: '/user/mln-comnet/mail-setting'},
		{jP: 'パスワード変更', eD: '/user/mln-comnet/change-password'}
	]);
var $author$project$Pages$User$mlnView = _List_fromArray(
	[
		{jP: 'WEB価格', eD: '/user/mln-comnet/hour'},
		{jP: '時系列データ', eD: '/user/mln-comnet/chronological-30min'},
		{jP: 'パスワード変更', eD: '/user/mln-comnet/change-password'}
	]);
var $author$project$Pages$User$pagesByUserId = F2(
	function (userName, userModel) {
		switch (userName) {
			case 'to24tcm-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/to24tcm-comnet/fifteen'},
						{jP: '60分取得', eD: '/user/to24tcm-comnet/hour'},
						{jP: '15分時系列', eD: '/user/to24tcm-comnet/fifteen-seq'},
						{jP: '60分時系列', eD: '/user/to24tcm-comnet/hour-seq'},
						{jP: '期間指定CSV', eD: '/user/to24tcm-comnet/csv'},
						{jP: '商品の変更', eD: '/user/to24tcm-comnet/change-product'},
						{jP: '一日取得', eD: '/user/to24tcm-comnet/day'}
					]);
			case 'to24tcl-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/to24tcl-comnet/fifteen'},
						{jP: '15分時系列', eD: '/user/to24tcl-comnet/fifteen-seq'},
						{jP: '期間指定CSV', eD: '/user/to24tcl-comnet/csv'},
						{jP: '商品の変更', eD: '/user/to24tcl-comnet/change-product'},
						{jP: '一日取得', eD: '/user/to24tcl-comnet/day'}
					]);
			case 'to24tcm-fridge':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/to24tcm-fridge/fifteen'},
						{jP: '60分取得', eD: '/user/to24tcm-fridge/hour'},
						{jP: '他社60分取得', eD: '/user/to24tcm-fridge/hour-mix'},
						{jP: '15分時系列', eD: '/user/to24tcm-fridge/fifteen-seq'},
						{jP: '60分時系列', eD: '/user/to24tcm-fridge/hour-seq'},
						{jP: '期間指定CSV', eD: '/user/to24tcm-fridge/csv'},
						{jP: '商品の変更', eD: '/user/to24tcm-fridge/change-product'},
						{jP: '一日取得', eD: '/user/to24tcm-fridge/day'}
					]);
			case 'to24tcm-kitchen':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/to24tcm-kitchen/fifteen'},
						{jP: '60分取得', eD: '/user/to24tcm-kitchen/hour'},
						{jP: '15分時系列', eD: '/user/to24tcm-kitchen/fifteen-seq'},
						{jP: '60分時系列', eD: '/user/to24tcm-kitchen/hour-seq'},
						{jP: '期間指定CSV', eD: '/user/to24tcm-kitchen/csv'},
						{jP: '商品の変更', eD: '/user/to24tcm-kitchen/change-product'},
						{jP: '一日取得', eD: '/user/to24tcm-kitchen/day'}
					]);
			case 'hisense':
				return _List_fromArray(
					[
						{jP: '一日取得', eD: '/user/hisense/day'},
						{jP: '時系列取得', eD: '/user/hisense/time-seq'},
						{jP: 'レビュー', eD: '/user/hisense/review'},
						{jP: 'Amazonランキング', eD: '/user/hisense/amazon-ranking'},
						{jP: '60分取得/ハイセンス4商品', eD: '/user/hisense/tv-hour'},
						{jP: '商品の編集', eD: '/user/hisense/change-product'},
						{jP: 'エクセル', eD: '/user/hisense/excel'}
					]);
			case 'jvc-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/jvc-comnet/fifteen'},
						{jP: '60分取得', eD: '/user/jvc-comnet/hour'},
						{jP: '15分 時系列', eD: '/user/jvc-comnet/time-seq-fifteen'},
						{jP: '60分 時系列', eD: '/user/jvc-comnet/time-seq-hour'},
						{jP: '15分 Amazon', eD: '/user/jvc-comnet/amazon-fifteen'},
						{jP: '60分 Amazon', eD: '/user/jvc-comnet/amazon'},
						{jP: '値下がり', eD: '/user/jvc-comnet/price-drop'}
					]);
			case 'mln-comnet':
				return _List_fromArray(
					[
						{jP: 'WEB価格', eD: '/user/mln-comnet/hour'},
						{jP: 'WEB価格（自動更新）', eD: '/user/mln-comnet/auto-reload'},
						{jP: 'ヤマダ下取り価格', eD: '/user/mln-comnet/hour-yamada'},
						{jP: '時系列データ', eD: '/user/mln-comnet/chronological-30min'},
						{jP: '価格/アラート設定', eD: '/user/mln-comnet/change-product'},
						{jP: '送信先設定', eD: '/user/mln-comnet/change-mail'},
						{jP: '送信先設定 (test)', eD: '/user/mln-comnet/change-mail-test'},
						{jP: '送信時間設定', eD: '/user/mln-comnet/mail-setting'}
					]);
			case 'minetec':
				return $author$project$Pages$User$mlnAdmin;
			case 'minetgate':
				return $author$project$Pages$User$mlnView;
			case 'ln936502':
				return $author$project$Pages$User$mlnAdmin;
			case 'ln124003':
				return $author$project$Pages$User$mlnAdmin;
			case 'ln234088':
				return $author$project$Pages$User$mlnAdmin;
			case 'ca6-comnet':
				return _List_fromArray(
					[
						{jP: '1時間取得', eD: '/user/ca6-comnet/hour'},
						{jP: '1時間取得(本サイト/モール順)', eD: '/user/ca6-comnet/hour2'},
						{jP: '今週の品目', eD: '/user/ca6-comnet/weekly-product'},
						{jP: '今週の品目(本サイト/モール順)', eD: '/user/ca6-comnet/weekly-product2'},
						{jP: '期間指定CSV', eD: '/user/ca6-comnet/csv'},
						{jP: '取得一覧', eD: '/user/ca6-comnet/items'},
						{jP: '低価格抽出', eD: '/user/ca6-comnet/low'}
					]);
			case 'tescom-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/tescom-comnet/15min'},
						{jP: '60分取得', eD: '/user/tescom-comnet/hour'},
						{jP: 'エクセル', eD: '/user/tescom-comnet/excel'},
						{jP: '商品の変更', eD: '/user/tescom-comnet/change-product'}
					]);
			case 'tv24-comnet':
				return _List_fromArray(
					[
						{jP: '30分取得', eD: '/user/tv24-comnet/thirty'},
						{jP: '期間指定CSV', eD: '/user/tv24-comnet/csv'},
						{jP: '商品の変更', eD: '/user/tv24-comnet/change-product'}
					]);
			case 'elec-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/elec-comnet/15min'},
						{jP: '60分取得', eD: '/user/elec-comnet/hour'},
						{jP: '15分 時系列', eD: '/user/elec-comnet/time-seq-fifteen'},
						{jP: '60分 時系列', eD: '/user/elec-comnet/time-seq-hour'},
						{jP: 'エクセル', eD: '/user/elec-comnet/excel'},
						{jP: '商品の変更', eD: '/user/elec-comnet/change-product'}
					]);
			case 'to24tcm-air':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/to24tcm-air/fifteen'},
						{jP: '60分取得', eD: '/user/to24tcm-air/hour'},
						{jP: '60分時系列', eD: '/user/to24tcm-air/hour-seq'},
						{jP: '期間指定CSV', eD: '/user/to24tcm-air/csv'},
						{jP: '商品の変更', eD: '/user/to24tcm-air/change-product'}
					]);
			case 'hi3-comnet':
				return _List_fromArray(
					[
						{jP: '60分取得', eD: '/user/hi3-comnet/hour'},
						{jP: '60分時系列', eD: '/user/hi3-comnet/hour-seq'},
						{jP: '商品の変更', eD: '/user/hi3-comnet/change-product'}
					]);
			case 'delonghi':
				return _List_fromArray(
					[
						{jP: '60分取得', eD: '/user/delonghi/hour'},
						{jP: '60分 時系列', eD: '/user/delonghi/time-seq-hour'},
						{jP: '60分 新時系列', eD: '/user/delonghi/time-seq-2-hour'},
						{jP: '9時の状況', eD: '/user/delonghi/nine-am'},
						{jP: 'トラッキング', eD: '/user/delonghi/weekly'},
						{jP: '商品の変更', eD: '/user/delonghi/change-product'}
					]);
			case 'kinujo-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/kinujo-comnet/fifteen'},
						{jP: 'エクセル', eD: '/user/kinujo-comnet/excel'},
						{jP: '商品の変更', eD: '/user/kinujo-comnet/change-product'}
					]);
			case 'hi24-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/hi24-comnet/hour'},
						{jP: '15分 時系列', eD: '/user/hi24-comnet/time-seq'},
						{jP: '今週の品目 15分取得', eD: '/user/hi24-comnet/weekly-product-15min'},
						{jP: '10時の状況', eD: '/user/hi24-comnet/ten-am'},
						{jP: '一日4回取得', eD: '/user/hi24-comnet/six-hour'},
						{jP: '60分取得', eD: '/user/hi24-comnet/day'},
						{jP: '60分 時系列', eD: '/user/hi24-comnet/hour-seq'}
					]);
			case 'sha-comnet':
				return _List_fromArray(
					[
						{jP: 'WIDE(24回)', eD: '/user/sha-comnet/wide'},
						{jP: '60分取得', eD: '/user/sha-comnet/hour'},
						{jP: '60分時系列', eD: '/user/sha-comnet/hour-seq'},
						{jP: '取り組み機種', eD: '/user/sha-comnet/weekly-product'},
						{jP: '販売店検索', eD: '/user/sha-comnet/day'},
						{jP: '商品の変更', eD: '/user/sha-comnet/change-product'}
					]);
			case 'tst-comnet':
				return _List_fromArray(
					[
						{jP: 'WIDE(24回)', eD: '/user/tst-comnet/wide'},
						{jP: '時系列', eD: '/user/tst-comnet/time-seq'}
					]);
			case 'dbi6-comnet':
				return _List_fromArray(
					[
						{jP: '60分取得', eD: '/user/dbi6-comnet/hour'},
						{jP: '60分時系列', eD: '/user/dbi6-comnet/time-seq'}
					]);
			case 'denon6-comnet':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: 'http://www2.digitalmedia.jp/users/15min'},
						{jP: '15分時系列', eD: 'http://www2.digitalmedia.jp/users/15min'},
						{jP: '60分取得', eD: '/user/denon6-comnet/wide'},
						{jP: '60分時系列', eD: '/user/denon6-comnet/time-seq'}
					]);
			case 'braun-comnet':
				return _List_fromArray(
					[
						{jP: 'WIDE(24回)', eD: '/user/braun-comnet/wide'},
						{jP: '60分取得', eD: '/user/braun-comnet/hour'}
					]);
			case 'ts-bat':
				return _List_fromArray(
					[
						{jP: 'WIDE(2回)', eD: '/user/ts-bat/wide'},
						{jP: '2回時系列', eD: '/user/ts-bat/time-seq'}
					]);
			case 'fuji-comnet':
				return $author$project$Pages$User$fujiComnetPagesFor(userModel);
			case 'fujiinstax-comnet':
				return _List_fromArray(
					[
						{jP: '30分取得', eD: '/user/fujiinstax-comnet/thirty'},
						{jP: '30分時系列', eD: '/user/fujiinstax-comnet/time-seq-thirty'},
						{jP: '優先型番の設定', eD: '/user/fujiinstax-comnet/week30'},
						{jP: '販売店別', eD: '/user/fujiinstax-comnet/latest-store'}
					]);
			case 'test':
				return _List_fromArray(
					[
						{jP: '15分取得', eD: '/user/test/fifteen'}
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$Pages$User$userNavBar = F3(
	function (userName, userModel, navModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$map,
			$author$project$Pages$User$GotNavBarMsg,
			A2(
				$author$project$Components$NavBar$view,
				navModel,
				A2(
					$elm$core$List$cons,
					{jP: 'TOP', eD: '/user'},
					A2($author$project$Pages$User$pagesByUserId, userName, userModel))));
	});
var $author$project$Pages$Users$BraunComnet$Hour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$BraunComnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$BraunComnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$BraunComnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$BraunComnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$BraunComnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$BraunComnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$BraunComnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$BraunComnet$Hour$OnSubmit = {$: 8};
var $author$project$Pages$Users$BraunComnet$Hour$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$BraunComnet$Hour$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$BraunComnet$Hour$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$TimeSelector$timeSelector = F3(
	function (interval, initVal, attrs) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
				]),
			A2(
				$elm_community$list_extra$List$Extra$andThen,
				function (hour) {
					return A2(
						$elm_community$list_extra$List$Extra$andThen,
						function (minute) {
							var val = A2(
								$elm$core$String$right,
								2,
								'0' + $elm$core$String$fromInt(hour)) + (':' + A2(
								$elm$core$String$right,
								2,
								'0' + $elm$core$String$fromInt(minute)));
							return _List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(val),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(val, initVal))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(val)
										]))
								]);
						},
						A2(
							$elm$core$List$filter,
							function (min) {
								return !A2($elm$core$Basics$modBy, interval, min);
							},
							A2($elm$core$List$range, 0, 59)));
				},
				A2($elm$core$List$range, 0, 23)));
	});
var $author$project$Pages$Users$BraunComnet$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$BraunComnet$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$BraunComnet$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$BraunComnet$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$BraunComnet$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$BraunComnet$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$BraunComnet$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$BraunComnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$BraunComnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$BraunComnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$BraunComnet$Hour$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$BraunComnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$BraunComnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$BraunComnet$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Attrs = function (a) {
	return {$: 7, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs = function (attrs_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Attrs(attrs_);
};
var $author$project$Pages$Users$BraunComnet$Hour$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$BraunComnet$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$BraunComnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$BraunComnet$Hour$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$BraunComnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$BraunComnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$BraunComnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$BraunComnet$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$BraunComnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$BraunComnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$BraunComnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$BraunComnet$Hour$viewContent, model, $author$project$Pages$Users$BraunComnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$BraunComnet$Hour$pStoreHeader, $author$project$Pages$Users$BraunComnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$BraunComnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$BraunComnet$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$BraunComnet$Wide$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$rowspan = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'rowspan',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$Users$BraunComnet$Wide$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$BraunComnet$Wide$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$BraunComnet$Wide$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$BraunComnet$Wide$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$BraunComnet$Wide$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$BraunComnet$Wide$OnChangeBigCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$OnChangeMaker = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$OnChangeSmallCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$BraunComnet$Wide$OnSubmit = {$: 8};
var $author$project$Pages$Users$BraunComnet$Wide$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CategorySelector$makerSelector = F3(
	function (makers, selectedMaker, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(
										A2($elm$core$Maybe$withDefault, -1, selectedMaker),
										-1))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('全て選択')
								])),
						A2(
							$elm$core$List$map,
							function (maker) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(maker.jW)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedMaker),
												maker.jW))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(maker.mH)
										]));
							},
							makers)))
				]));
	});
var $author$project$Pages$Users$BraunComnet$Wide$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$BraunComnet$Wide$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$BraunComnet$Wide$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$BraunComnet$Wide$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$BraunComnet$Wide$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$BraunComnet$Wide$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$BraunComnet$Wide$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Helpers$displayStyleList = _List_fromArray(
	[
		_Utils_Tuple2('全てを表示', 'DisplayAll'),
		_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
		_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
		_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
		_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
	]);
var $author$project$Pages$Users$BraunComnet$Wide$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$BraunComnet$Wide$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$BraunComnet$Wide$OnPressDownloadCSV = {$: 9};
var $author$project$Pages$Users$BraunComnet$Wide$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$BraunComnet$Wide$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$BraunComnet$Wide$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$BraunComnet$Wide$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$BraunComnet$Wide$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$BraunComnet$Wide$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$BraunComnet$Wide$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$BraunComnet$Wide$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$BraunComnet$Wide$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$BraunComnet$Wide$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$BraunComnet$Wide$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$BraunComnet$Wide$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$BraunComnet$Wide$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$BraunComnet$Wide$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$BraunComnet$Wide$viewTableControl(model),
						$author$project$Pages$Users$BraunComnet$Wide$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$BraunComnet$Wide$view = function (model) {
	return {
		lI: $author$project$Pages$Users$BraunComnet$Wide$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return 'NET-WIDE 掲載された機種と価格の時間変化(24回版)';
			}
		}()
	};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$Latest = 1;
var $author$project$Pages$Users$Ca6Comnet$Csv$Normal = 0;
var $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeBigCategory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeMaker = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeSmallCategory = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnSubmit = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateDateFrom = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateDateTo = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateTimeFrom = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateTimeTo = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnToggleCanonGroupVisibility = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$OnToggleStoreVisibility = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{z: nodeList, r: nodeListSize, v: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Pages$Users$Ca6Comnet$Csv$canonGroupColors = $elm$core$Array$fromList(
	_List_fromArray(
		['#ffd7d7', '#d2ff89', '#5e9ed6', '#fe9e00', '#ffff66']));
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Pages$Users$Ca6Comnet$Csv$viewCanonCheckbox = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$form,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-inline-flex flex-column align-items-stretch')
					]),
				function () {
					var canonGroupStoresTables = model.dr;
					var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.cc);
					var viewStoreCheckbox = function (store) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
									A2($elm$core$Set$member, store, model.aF.aN)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$Ca6Comnet$Csv$OnToggleStoreVisibility(store))
								]),
							A2(
								$elm$core$Maybe$withDefault,
								'STORE NAME NOT FOUND',
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.fh;
									},
									A2($elm$core$Dict$get, store, canonGroupStoresTables.gL))));
					};
					var viewCanonGroupCheckbox = function (canonGroup) {
						var stores = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
						var expanded = canonGroup === 1;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$style,
									'background-color',
									A2(
										$elm$core$Maybe$withDefault,
										'#000000',
										A2($elm$core$Array$get, canonGroup - 1, $author$project$Pages$Users$Ca6Comnet$Csv$canonGroupColors)))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'flex')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '12px')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													A2(
														$elm$core$Maybe$withDefault,
														'GROUP NAME NOT FOUND',
														A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.e2)))
												])),
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
													A2($elm$core$Set$member, canonGroup, model.aF.aU)),
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
													$author$project$Pages$Users$Ca6Comnet$Csv$OnToggleCanonGroupVisibility(canonGroup))
												]),
											'')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'grid'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'grid-template-columns', 'repeat(8, 170px)'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'justify-items', 'start'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '14px'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-left', '12pt')
										]),
									expanded ? A2($elm$core$List$map, viewStoreCheckbox, stores) : _List_Nil)
								]));
					};
					return A2($elm$core$List$map, viewCanonGroupCheckbox, canonGroups);
				}())
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Csv$ClickedFilename = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$viewCsvDownloadButtons = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'flex'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'flex-direction', 'column'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'align-items', 'flex-start')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-weight', 'bold'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '8px')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('以下をクリックしてダウンロード：')
					])),
			A2(
				$elm$core$List$map,
				function (filename) {
					return A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('btn btn-link')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
								$author$project$Pages$Users$Ca6Comnet$Csv$ClickedFilename(filename))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(filename + 'リスト型CSVデータのダウンロードはここから')
							]));
				},
				model.ch.co)));
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeOutputMode = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$viewOutputSelector = function (model) {
	var stringToOutputMode = function (s) {
		switch (s) {
			case 'AllStoreGroups':
				return 0;
			case 'SelectedStores':
				return 1;
			default:
				return 2;
		}
	};
	var outputModeList = _List_fromArray(
		[
			_Utils_Tuple2('各店舗グループごとに出力', 'AllStoreGroups'),
			_Utils_Tuple2('店舗を指定して出力', 'SelectedStores'),
			_Utils_Tuple2('各店舗ごとに出力', 'AllStores')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('align-self-start')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('表示形式')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange(
								A2($elm$core$Basics$composeR, stringToOutputMode, $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeOutputMode)),
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('')
									]))
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var label = _v0.a;
								var v = _v0.b;
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												stringToOutputMode(v),
												model.bT))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(label)
										]));
							},
							outputModeList))
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeProductSource = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Csv$Week30 = 1;
var $author$project$Pages$Users$Ca6Comnet$Csv$viewProductSourceSelector = function (model) {
	var stringToProductSource = function (s) {
		switch (s) {
			case 'All':
				return 0;
			case 'Week30':
				return 1;
			default:
				return 0;
		}
	};
	var productSourceList = _List_fromArray(
		[
			_Utils_Tuple2('全品目から取得', 'All'),
			_Utils_Tuple2('今週の品目から取得', 'Week30')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('align-self-start')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得対象品目')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange(
								A2($elm$core$Basics$composeR, stringToProductSource, $author$project$Pages$Users$Ca6Comnet$Csv$OnChangeProductSource)),
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('')
									]))
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var label = _v0.a;
								var v = _v0.b;
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												stringToProductSource(v),
												model.ei))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(label)
										]));
							},
							productSourceList))
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Csv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-1')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$Ca6Comnet$Csv$viewProductSourceSelector(model),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
							]),
						_List_Nil),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('メーカー')
									])),
								A3(
								$author$project$Components$CategorySelector$makerSelector,
								model.cE,
								model.eh,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Csv$OnChangeMaker)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('大分類')
									])),
								A3(
								$author$project$Components$CategorySelector$bigCategorySelector,
								model.iW,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Csv$OnChangeBigCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('小分類')
									])),
								A4(
								$author$project$Components$CategorySelector$smallCategorySelector,
								model.kL,
								model.gD,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Csv$OnChangeSmallCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 ')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('型番')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer wide')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Pages$Users$Ca6Comnet$Csv$OnChangeProduct,
										$rtfeldman$elm_css$Html$Styled$fromUnstyled(
											$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
										$elm$core$List$isEmpty(
										$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て選択')
											])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
							]),
						_List_Nil),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date'),
												$rtfeldman$elm_css$Html$Styled$Attributes$max(model.d_),
												$rtfeldman$elm_css$Html$Styled$Attributes$min(model.d1)
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateDateFrom)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-2')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.il,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateTimeFrom)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('〜')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start ml-2 mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date'),
												$rtfeldman$elm_css$Html$Styled$Attributes$max(model.d_),
												$rtfeldman$elm_css$Html$Styled$Attributes$min(model.d1)
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateDateTo)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.im,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Csv$OnUpdateTimeTo)
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
							]),
						_List_Nil),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								$author$project$Pages$Users$Ca6Comnet$Csv$viewOutputSelector(model)
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
								$author$project$Pages$Users$Ca6Comnet$Csv$OnSubmit(0))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
								$author$project$Pages$Users$Ca6Comnet$Csv$OnSubmit(1))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
							]),
						_List_Nil),
						function () {
						var _v0 = model.bT;
						switch (_v0) {
							case 0:
								return $rtfeldman$elm_css$Html$Styled$text('各店舗グループごとに価格情報をまとめて、それぞれCSVに出力します。');
							case 1:
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('選択された店舗の価格情報を一つのCSVにまとめて出力します。'),
											$author$project$Pages$Users$Ca6Comnet$Csv$viewCanonCheckbox(model)
										]));
							default:
								return $rtfeldman$elm_css$Html$Styled$text('各店舗ごとに価格情報をまとめて、それぞれCSVに出力します。');
						}
					}()
					])),
				(model.cv || model.dP) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				($elm$core$List$isEmpty(model.ch.co) || (!_Utils_eq(model.ch.h0, model.bT))) ? $rtfeldman$elm_css$Html$Styled$text('') : $author$project$Pages$Users$Ca6Comnet$Csv$viewCsvDownloadButtons(model)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Csv$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Ca6Comnet$Csv$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '期間指定CSV';
			}
		}()
	};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$pStoreGroupsHeader = F2(
	function (canonGroupStoresTables, visibility) {
		var canonIdToName = function (canonGroup) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.e2));
		};
		var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.e2);
		var canonGroupToStores = function (canonGroup) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
		};
		var hasVisibleStore = function (canonGroup) {
			return A2(
				$elm$core$List$any,
				function (store) {
					return A2($elm$core$Set$member, store, visibility.aN);
				},
				canonGroupToStores(canonGroup));
		};
		return A2(
			$elm$core$List$cons,
			{hj: -1, i1: '', bB: 4},
			A2(
				$elm$core$List$map,
				function (canonGroup) {
					return {
						hj: canonGroup,
						i1: canonIdToName(canonGroup),
						bB: $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (store) {
									return A2($elm$core$Set$member, store, visibility.aN);
								},
								canonGroupToStores(canonGroup)))
					};
				},
				A2(
					$elm$core$List$filter,
					function (canonGroup) {
						return hasVisibleStore(canonGroup);
					},
					canonGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											var data = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('katabanHeader')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '1px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(data.hQ)
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'line-height', '1.2'),
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '4px')
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('表示価格: ' + data.jB)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('参考価格: ' + data.ky)
																		]))
																]))
														]))
												]);
										case 2:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Ca6Comnet$Hour$canonGroupColors = $elm$core$Array$fromList(
	_List_fromArray(
		['#ffd7d7', '#d2ff89', '#5e9ed6', '#fe9e00', '#ffff66']));
var $author$project$Pages$Users$Ca6Comnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{hj: 0, i1: '', bB: 0},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								var attrs = function () {
									if (!ind) {
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader'),
												$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
											]);
									} else {
										var backgroundColor = A2(
											$elm$core$Maybe$withDefault,
											'#000000',
											A2($elm$core$Array$get, headerStoreGroup.hj - 1, $author$project$Pages$Users$Ca6Comnet$Hour$canonGroupColors));
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(
												'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.hj)),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', backgroundColor),
												$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
											]);
									}
								}();
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									attrs,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.i1)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								var backgroundColor = A2(
									$elm$core$Maybe$withDefault,
									'#000000',
									A2($elm$core$Array$get, store.hj - 1, $author$project$Pages$Users$Ca6Comnet$Hour$canonGroupColors));
								var attrs = function () {
									if (_Utils_cmp(ind, colsNum) < 0) {
										switch (ind) {
											case 0:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('numberHeader rowHeader')
													]);
											case 1:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('katabanHeader rowHeader')
													]);
											case 2:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('itemHeader rowHeader')
													]);
											case 3:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('basePriceHeader rowHeader')
													]);
											default:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class(
														'storeGroupHeader' + $elm$core$String$fromInt(store.hj)),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', backgroundColor)
													]);
										}
									} else {
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(
												'storeGroupHeader' + $elm$core$String$fromInt(store.hj)),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', backgroundColor)
											]);
									}
								}();
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									attrs,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{hj: 0, i1: '', bB: 0},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Ca6Comnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Ca6Comnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour$Nop = {$: 17};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnChangeMaker = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnSubmit = {$: 9};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnSubmitLatest = {$: 10};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnToggleCanonGroupVisibility = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$OnToggleStoreVisibility = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$OnUpdateDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnUpdateTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$viewProductFilter = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('メーカー')
									])),
								A3(
								$author$project$Components$CategorySelector$makerSelector,
								model.cE,
								model.eh,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour$OnChangeMaker)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('大分類')
									])),
								A3(
								$author$project$Components$CategorySelector$bigCategorySelector,
								model.iW,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour$OnChangeBigCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('小分類')
									])),
								A4(
								$author$project$Components$CategorySelector$smallCategorySelector,
								model.kL,
								model.gD,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour$OnChangeSmallCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3'),
										$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Ca6Comnet$Hour$Nop)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('商品\u3000(プルダウンは矢印クリックで消えます(仮))')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer text-left'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class(''),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '400px')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Pages$Users$Ca6Comnet$Hour$OnChangeMultiselectProducts,
										$rtfeldman$elm_css$Html$Styled$fromUnstyled(
											$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
										$elm$core$List$isEmpty(
										$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て選択')
											])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
									]))
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Ca6Comnet$Hour$OnUpdateDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.bi,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour$OnUpdateTime)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Hour$OnSubmit)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Hour$OnSubmitLatest)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding-top', '10px')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-inline-flex flex-column align-items-stretch')
							]),
						function () {
							var canonGroupStoresTables = model.dr;
							var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.cc);
							var viewStoreCheckbox = function (store) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
											A2($elm$core$Set$member, store, model.aF.aN)),
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
											$author$project$Pages$Users$Ca6Comnet$Hour$OnToggleStoreVisibility(store))
										]),
									A2(
										$elm$core$Maybe$withDefault,
										'STORE NAME NOT FOUND',
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.fh;
											},
											A2($elm$core$Dict$get, store, canonGroupStoresTables.gL))));
							};
							var viewCanonGroupCheckbox = function (canonGroup) {
								var stores = A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
								var expanded = canonGroup === 1;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$style,
											'background-color',
											A2(
												$elm$core$Maybe$withDefault,
												'#000000',
												A2($elm$core$Array$get, canonGroup - 1, $author$project$Pages$Users$Ca6Comnet$Hour$canonGroupColors)))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'flex')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '12px')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$elm$core$Maybe$withDefault,
																'GROUP NAME NOT FOUND',
																A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.e2)))
														])),
													A2(
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
													_List_fromArray(
														[
															$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
															A2($elm$core$Set$member, canonGroup, model.aF.aU)),
															$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
															$author$project$Pages$Users$Ca6Comnet$Hour$OnToggleCanonGroupVisibility(canonGroup))
														]),
													'')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'grid'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'grid-template-columns', 'repeat(8, 170px)'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'justify-items', 'start'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '14px'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-left', '12pt')
												]),
											expanded ? A2($elm$core$List$map, viewStoreCheckbox, stores) : _List_Nil)
										]));
							};
							return A2($elm$core$List$map, viewCanonGroupCheckbox, canonGroups);
						}())
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Ca6Comnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour$OnPressDownloadCSV = {$: 11};
var $author$project$Pages$Users$Ca6Comnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Ca6Comnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-1 mb-1')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Ca6Comnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Ca6Comnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.dr, model.aF);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.dr, model.aF);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Ca6Comnet$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$Ca6Comnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Ca6Comnet$Hour$viewContent, model, $author$project$Pages$Users$Ca6Comnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$Ca6Comnet$Hour$pStoreHeader, $author$project$Pages$Users$Ca6Comnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$Ca6Comnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Ca6Comnet$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得xxx';
			}
		}()
	};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											var data = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('katabanHeader')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '1px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(data.hQ)
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'line-height', '1.2'),
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '4px')
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('表示価格: ' + data.jB)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('参考価格: ' + data.ky)
																		]))
																]))
														]))
												]);
										case 2:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Ca6Comnet$Hour2$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Ca6Comnet$Hour2$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$Nop = {$: 16};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeMaker = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnSubmit = {$: 8};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewProductFilter = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('メーカー')
									])),
								A3(
								$author$project$Components$CategorySelector$makerSelector,
								model.cE,
								model.eh,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeMaker)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('大分類')
									])),
								A3(
								$author$project$Components$CategorySelector$bigCategorySelector,
								model.iW,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeBigCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('小分類')
									])),
								A4(
								$author$project$Components$CategorySelector$smallCategorySelector,
								model.kL,
								model.gD,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeSmallCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3'),
										$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Ca6Comnet$Hour2$Nop)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('商品\u3000(プルダウンは矢印クリックで消えます(仮))')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer text-left'),
										$rtfeldman$elm_css$Html$Styled$Attributes$class(''),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '400px')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeMultiselectProducts,
										$rtfeldman$elm_css$Html$Styled$fromUnstyled(
											$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
										$elm$core$List$isEmpty(
										$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て選択')
											])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
									]))
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Ca6Comnet$Hour2$OnUpdateDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.bi,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Hour2$OnUpdateTime)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Hour2$OnSubmit)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Hour2$OnSubmitLatest)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
							]))
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Ca6Comnet$Hour2$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Hour2$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Ca6Comnet$Hour2$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Ca6Comnet$Hour2$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-1 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Ca6Comnet$Hour2$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Ca6Comnet$Hour2$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Ca6Comnet$Hour2$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Ca6Comnet$Hour2$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$Hour2$viewTableControl(model),
							$author$project$Pages$Users$Ca6Comnet$Hour2$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$Hour2$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Ca6Comnet$Hour2$viewContent, model, $author$project$Pages$Users$Ca6Comnet$Hour2$pStoreGroupsHeader, $author$project$Pages$Users$Ca6Comnet$Hour2$pStoreHeader, $author$project$Pages$Users$Ca6Comnet$Hour2$pProductPriceRows);
};
var $author$project$Pages$Users$Ca6Comnet$Hour2$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Ca6Comnet$Hour2$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Ca6Comnet$Items$OnPressDownloadCSV = {$: 1};
var $author$project$Pages$Users$Ca6Comnet$Items$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-center ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Items$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Ca6Comnet$Items$viewTr = function (item) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(item.nk)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(item.kl)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(item.hf)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(item.iq)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(item.kg))
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Items$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				model.cv ? $author$project$Components$Loading$loadingCenter(50.0) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])),
				$author$project$Pages$Users$Ca6Comnet$Items$viewDownloadCSVButton,
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('商品名称')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JANコード')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('大分類')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('小分類')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('参考価格')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Pages$Users$Ca6Comnet$Items$viewTr, model.mx))
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Items$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Ca6Comnet$Items$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return 'NOTHING';
			}
		}()
	};
};
var $author$project$Pages$Users$Ca6Comnet$Low$SetExcludeKakakucom = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Low$SetExcludeSaiyasu = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Low$SetSortByRatio = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Low$viewOptions = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-center'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'column-gap', '20px')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.dA),
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Ca6Comnet$Low$SetExcludeKakakucom)
					]),
				'価格COM系を除く'),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.dB),
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Ca6Comnet$Low$SetExcludeSaiyasu)
					]),
				'最安系を除く'),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.ek),
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Ca6Comnet$Low$SetSortByRatio)
					]),
				'基準価格との乖離が大きい順に並べる')
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Low$OnSubmit = {$: 4};
var $author$project$Pages$Users$Ca6Comnet$Low$OnUpdateDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Low$OnUpdateTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Low$SetRatio = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$Low$viewSearchForm = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Ca6Comnet$Low$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$Low$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('基準価格比')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Ca6Comnet$Low$SetRatio)
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value('0.3')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('30%未満')
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value('0.5')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('50%未満')
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										$elm$core$String$fromFloat(2 / 3)),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										_Utils_eq(
											model.ed,
											$elm$core$String$fromFloat(2 / 3)))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('2/3(約67%)未満')
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value('0.75')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('75%未満')
									]))
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$Low$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Low$viewTr = function (row) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(row.nk)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(row.kS)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$elm$core$String$fromInt(row.fM))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$a,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$href(row.eD),
								$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$elm$core$String$fromInt(row.kg))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var mydiv = F2(
							function (x, y) {
								return $elm$core$Basics$round((x / y) * 1000) / 10;
							});
						var ratio = A2(mydiv, row.kg, row.fM);
						return $rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromFloat(ratio) + '%');
					}()
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Low$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-2'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				model.dP ? $author$project$Components$Loading$loadingCenter(50.0) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])),
				$author$project$Pages$Users$Ca6Comnet$Low$viewSearchForm(model),
				$author$project$Pages$Users$Ca6Comnet$Low$viewOptions(model),
				model.fx ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '20px')
							]),
						_List_Nil),
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('商品')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('店舗')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('現在価格')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格比')
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Pages$Users$Ca6Comnet$Low$viewTr,
									function (rows) {
										return model.ek ? A2(
											$elm$core$List$sortBy,
											function (row) {
												return row.kg / row.fM;
											},
											rows) : rows;
									}(
										A2(
											$elm$core$List$filter,
											function (row) {
												return ((!model.dA) || (!A2($elm$core$String$contains, '価格COM', row.kS))) && ((!model.dB) || (!A2($elm$core$String$contains, '最安', row.kS)));
											},
											model.gv))))
							]))
					])) : $rtfeldman$elm_css$Html$Styled$text('')
			]));
};
var $author$project$Pages$Users$Ca6Comnet$Low$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Ca6Comnet$Low$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return 'NOTHING';
			}
		}()
	};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pStoreGroupsHeader = F2(
	function (canonGroupStoresTables, visibility) {
		var canonIdToName = function (canonGroup) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.e2));
		};
		var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.e2);
		var canonGroupToStores = function (canonGroup) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
		};
		var hasVisibleStore = function (canonGroup) {
			return A2(
				$elm$core$List$any,
				function (store) {
					return A2($elm$core$Set$member, store, visibility.aN);
				},
				canonGroupToStores(canonGroup));
		};
		return A2(
			$elm$core$List$cons,
			{hj: -1, i1: '', bB: 4},
			A2(
				$elm$core$List$map,
				function (canonGroup) {
					return {
						hj: canonGroup,
						i1: canonIdToName(canonGroup),
						bB: $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (store) {
									return A2($elm$core$Set$member, store, visibility.aN);
								},
								canonGroupToStores(canonGroup)))
					};
				},
				A2(
					$elm$core$List$filter,
					function (canonGroup) {
						return hasVisibleStore(canonGroup);
					},
					canonGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											var data = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('katabanHeader')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '1px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(data.hQ)
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'line-height', '1.2'),
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '4px')
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('表示価格: ' + data.jB)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('参考価格: ' + data.ky)
																		]))
																]))
														]))
												]);
										case 2:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$canonGroupColors = $elm$core$Array$fromList(
	_List_fromArray(
		['#ffd7d7', '#d2ff89', '#5e9ed6', '#fe9e00', '#ffff66']));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{hj: 0, i1: '', bB: 0},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								var attrs = function () {
									if (!ind) {
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader'),
												$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
											]);
									} else {
										var backgroundColor = A2(
											$elm$core$Maybe$withDefault,
											'#000000',
											A2($elm$core$Array$get, headerStoreGroup.hj - 1, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$canonGroupColors));
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(
												'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.hj)),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', backgroundColor),
												$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
											]);
									}
								}();
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									attrs,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.i1)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								var backgroundColor = A2(
									$elm$core$Maybe$withDefault,
									'#000000',
									A2($elm$core$Array$get, store.hj - 1, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$canonGroupColors));
								var attrs = function () {
									if (_Utils_cmp(ind, colsNum) < 0) {
										switch (ind) {
											case 0:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('numberHeader rowHeader')
													]);
											case 1:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('katabanHeader rowHeader')
													]);
											case 2:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('itemHeader rowHeader')
													]);
											case 3:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('basePriceHeader rowHeader')
													]);
											default:
												return _List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class(
														'storeGroupHeader' + $elm$core$String$fromInt(store.hj)),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', backgroundColor)
													]);
										}
									} else {
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(
												'storeGroupHeader' + $elm$core$String$fromInt(store.hj)),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', backgroundColor)
											]);
									}
								}();
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									attrs,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{hj: 0, i1: '', bB: 0},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnChangeBigCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnChangeSmallCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnSubmit = {$: 9};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnSubmitLatest = {$: 10};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnToggleCanonGroupVisibility = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnToggleStoreVisibility = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnUpdateDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnUpdateTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewProductFilter = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('大分類')
									])),
								A3(
								$author$project$Components$CategorySelector$bigCategorySelector,
								model.iW,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnChangeBigCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('小分類')
									])),
								A4(
								$author$project$Components$CategorySelector$smallCategorySelector,
								model.kL,
								model.gD,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnChangeSmallCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnUpdateDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.bi,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnUpdateTime)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnSubmit)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnSubmitLatest)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding-top', '10px')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-inline-flex flex-column align-items-stretch')
							]),
						function () {
							var canonGroupStoresTables = model.dr;
							var canonGroups = $elm$core$Dict$keys(canonGroupStoresTables.cc);
							var viewStoreCheckbox = function (store) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
											A2($elm$core$Set$member, store, model.aF.aN)),
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
											$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnToggleStoreVisibility(store))
										]),
									A2(
										$elm$core$Maybe$withDefault,
										'STORE NAME NOT FOUND',
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.fh;
											},
											A2($elm$core$Dict$get, store, canonGroupStoresTables.gL))));
							};
							var viewCanonGroupCheckbox = function (canonGroup) {
								var stores = A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.cc));
								var expanded = canonGroup === 1;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$Attributes$style,
											'background-color',
											A2(
												$elm$core$Maybe$withDefault,
												'#000000',
												A2($elm$core$Array$get, canonGroup - 1, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$canonGroupColors)))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'flex')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '12px')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															A2(
																$elm$core$Maybe$withDefault,
																'GROUP NAME NOT FOUND',
																A2($elm$core$Dict$get, canonGroup, canonGroupStoresTables.e2)))
														])),
													A2(
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
													_List_fromArray(
														[
															$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
															A2($elm$core$Set$member, canonGroup, model.aF.aU)),
															$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
															$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnToggleCanonGroupVisibility(canonGroup))
														]),
													'')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'grid'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'grid-template-columns', 'repeat(8, 170px)'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'justify-items', 'start'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '14px'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-left', '12pt')
												]),
											expanded ? A2($elm$core$List$map, viewStoreCheckbox, stores) : _List_Nil)
										]));
							};
							return A2($elm$core$List$map, viewCanonGroupCheckbox, canonGroups);
						}())
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnPressDownloadCSV = {$: 11};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-1 mb-1')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.dr, model.aF);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.dr, model.aF);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewTableControl(model),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewContent, model, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pStoreGroupsHeader, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pStoreHeader, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$pProductPriceRows);
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Ca6Comnet$WeeklyProduct$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											var data = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('katabanHeader')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '1px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(data.hQ)
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'line-height', '1.2'),
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '4px')
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('表示価格: ' + data.jB)
																		])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('参考価格: ' + data.ky)
																		]))
																]))
														]))
												]);
										case 2:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnSubmit = {$: 8};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewTableControl(model),
							$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewContent, model, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pStoreGroupsHeader, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pStoreHeader, $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$pProductPriceRows);
};
var $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Common$ChangeProduct$OnUpdateAllProducts = {$: 7};
var $author$project$Pages$Users$Common$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Common$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$Common$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Common$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Common$ChangeProduct$Drop = {$: 11};
var $author$project$Pages$Users$Common$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$Common$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$Common$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$Common$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Common$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$Common$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$Common$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$Common$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$Common$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$Common$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Common$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Common$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$Common$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Common$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$Common$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$Common$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Common$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$Common$Default$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Common$Default$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Common$Default$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Common$Default$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Common$Default$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Common$Default$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Common$Default$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Common$Default$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Common$Default$OnSubmit = {$: 8};
var $author$project$Pages$Users$Common$Default$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Common$Default$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Common$Default$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Common$Default$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$Default$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$Default$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$Default$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$Default$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$Default$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$Default$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Common$Default$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Common$Default$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Common$Default$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Common$Default$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Common$Default$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$Default$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Common$Default$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Common$Default$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Common$Default$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Common$Default$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Common$Default$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Common$Default$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Common$Default$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Common$Default$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Common$Default$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Common$Default$viewTableControl(model),
							$author$project$Pages$Users$Common$Default$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Common$Default$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Common$Default$viewContent, model, $author$project$Pages$Users$Common$Default$pStoreGroupsHeader, $author$project$Pages$Users$Common$Default$pStoreHeader, $author$project$Pages$Users$Common$Default$pProductPriceRows);
};
var $author$project$Pages$Users$Common$Default$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Common$Default$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Common$MailAddress$OnToggleShowValidOnly = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$SubmitBulkSetValid = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$SubmitBulkUpdatePermalinkGroups = {$: 13};
var $author$project$Pages$Users$Common$MailAddress$OnUpdateNewPermalinkGroupName = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$OnUpdateNewSupervisor = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$SubmitAddPermalinkGroup = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$viewAddPermalinkGroup = function (permalinkGroup) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.aE),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$MailAddress$OnUpdateNewSupervisor)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.as),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$MailAddress$OnUpdateNewPermalinkGroupName)
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_Utils_ap(
							permalinkGroup.R ? _List_fromArray(
								[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$Common$MailAddress$SubmitAddPermalinkGroup(permalinkGroup))
								])),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('Add')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Users$Common$MailAddress$OnUpdatePermalinkGroupName = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$OnUpdateSupervisor = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$OnUpdateValid = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$SubmitDeletePermalinkGroup = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$SubmitUpdatePermalinkGroup = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$ToggleExpand = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$OnSelectNewTargetStore = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$SubmitAddTarget = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$SubmitDeleteTarget = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Pages$Users$Common$MailAddress$SubmitToggleAllStores = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Users$Common$MailAddress$viewTargetsRow = F4(
	function (stores, targets, newTargetStoreIds, mailId) {
		var selectedStoreId = A2($elm$core$Dict$get, mailId, newTargetStoreIds);
		var individualTargets = A2(
			$elm$core$List$filter,
			function (t) {
				return t.gZ === 2;
			},
			targets);
		var hasAllStores = A2(
			$elm$core$List$any,
			function (t) {
				return t.gZ === 1;
			},
			targets);
		var availableStores = A2(
			$elm$core$List$filter,
			function (s) {
				return !A2(
					$elm$core$List$any,
					function (t) {
						return _Utils_eq(t.iw, s.iw);
					},
					individualTargets);
			},
			stores);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$colspan(6),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '4px 4px 8px 40px')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex align-items-center mb-2')
								]),
							_List_fromArray(
								[
									$author$project$Components$Atoms$ToggleSwitch$view(
									{
										mu: hasAllStores,
										mY: $author$project$Pages$Users$Common$MailAddress$SubmitToggleAllStores(mailId)
									}),
									A2(
									$rtfeldman$elm_css$Html$Styled$span,
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-left', '8px'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '16px'),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '0.95em')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('全店舗送信')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$select,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onInput(
											$author$project$Pages$Users$Common$MailAddress$OnSelectNewTargetStore(mailId)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '4px')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$rtfeldman$elm_css$Html$Styled$option,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$value('')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('-- 個別店舗を追加 --')
												])),
										A2(
											$elm$core$List$map,
											function (s) {
												return A2(
													$rtfeldman$elm_css$Html$Styled$option,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$value(
															$elm$core$String$fromInt(s.iw))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(s.kS)
														]));
											},
											availableStores))),
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Button$button,
									_Utils_ap(
										$elm_community$maybe_extra$Maybe$Extra$isJust(selectedStoreId) ? _List_fromArray(
											[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
												$author$project$Pages$Users$Common$MailAddress$SubmitAddTarget(mailId))
											])),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Add')
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-wrap')
								]),
							A2(
								$elm$core$List$map,
								function (t) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$span,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'inline-flex'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'align-items', 'center'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', '#c8e6c9'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border-radius', '4px'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '3px 6px'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '6px'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-bottom', '4px')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', '#1b5e20')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(t.kS)
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$button,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Events$onClick(
														A2($author$project$Pages$Users$Common$MailAddress$SubmitDeleteTarget, mailId, t.hT)),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background', 'none'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'border', 'none'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'cursor', 'pointer'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'padding', '0 0 0 6px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', '#888'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '1em')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('×')
													]))
											]));
								},
								individualTargets))
						]))
				]));
	});
var $author$project$Pages$Users$Common$MailAddress$viewPermalinkGroup = F5(
	function (stores, expandedMailIds, mailTargets, newTargetStoreIds, permalinkGroup) {
		var mailId = permalinkGroup.T;
		var targets = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Dict$get, mailId, mailTargets));
		var isExpanded = A2($elm$core$Set$member, mailId, expandedMailIds);
		return A2(
			$elm$core$List$cons,
			A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Users$Common$MailAddress$ToggleExpand(mailId))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										isExpanded ? '▲' : '▼')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.aE),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
										$author$project$Pages$Users$Common$MailAddress$OnUpdateSupervisor(mailId))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(permalinkGroup.as),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
										$author$project$Pages$Users$Common$MailAddress$OnUpdatePermalinkGroupName(mailId))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(permalinkGroup.aP),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$author$project$Pages$Users$Common$MailAddress$OnUpdateValid(mailId))
									]),
								'')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_Utils_ap(
									permalinkGroup.R ? _List_fromArray(
										[$frandibar$elm_bootstrap$Bootstrap$Button$primary]) : _List_Nil,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
											$author$project$Pages$Users$Common$MailAddress$SubmitUpdatePermalinkGroup(permalinkGroup))
										])),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Update')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$td,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
										$author$project$Pages$Users$Common$MailAddress$SubmitDeletePermalinkGroup(mailId))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('Delete')
									]))
							]))
					])),
			isExpanded ? _List_fromArray(
				[
					A4($author$project$Pages$Users$Common$MailAddress$viewTargetsRow, stores, targets, newTargetStoreIds, mailId)
				]) : _List_Nil);
	});
var $author$project$Pages$Users$Common$MailAddress$viewContent = function (model) {
	var displayedGroups = model.ej ? A2(
		$elm$core$List$filter,
		function ($) {
			return $.aP;
		},
		model.i) : model.i;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5')
			]),
		_List_fromArray(
			[
				(model.dO || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'text-align', 'center')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'max-width', '1100px'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '0 auto')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-2 d-flex justify-content-between align-items-center')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('mail-show-valid-only'),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.ej),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Common$MailAddress$OnToggleShowValidOnly)
									]),
								'有効のみ表示'),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex')
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$success,
												$frandibar$elm_bootstrap$Bootstrap$Button$small,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
												$author$project$Pages$Users$Common$MailAddress$SubmitBulkSetValid(true)),
												$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '4px')
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て有効')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$secondary,
												$frandibar$elm_bootstrap$Bootstrap$Button$small,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
												$author$project$Pages$Users$Common$MailAddress$SubmitBulkSetValid(false)),
												$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin-right', '8px')
													]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て無効')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$primary,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$MailAddress$SubmitBulkUpdatePermalinkGroups)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('一括更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet'),
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '50px')
													]),
												_List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Name')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Address')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '60px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Valid')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Update')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('Delete')
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									$author$project$Pages$Users$Common$MailAddress$viewAddPermalinkGroup(model.ba),
									A2(
										$elm$core$List$concatMap,
										A4($author$project$Pages$Users$Common$MailAddress$viewPermalinkGroup, model.aN, model.a0, model.ae, model.cJ),
										displayedGroups)))
							]))
					]))
			]));
};
var $author$project$Pages$Users$Common$MailAddress$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Common$MailAddress$viewContent(model),
		iB: 'メールアドレス管理'
	};
};
var $author$project$Pages$Users$Common$TimeSeq$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Common$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Common$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Common$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Common$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Common$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Common$TimeSeq$Nop = {$: 18};
var $author$project$Pages$Users$Common$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$Common$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Common$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Common$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Common$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Common$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Common$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$Common$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Common$TimeSeq$OnToggleIncludeCouponPrice = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Common$TimeSeq$viewIncludeCouponPriceCheckbox = function (includeCouponPrice) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mb-2')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(includeCouponPrice),
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value('1')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Common$TimeSeq$OnToggleIncludeCouponPrice)
					]),
				'クーポン価格を含む')
			]));
};
var $author$project$Pages$Users$Common$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Common$TimeSeq$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Common$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Common$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mb-1')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column mr-3')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$Common$TimeSeq$viewIncludeCouponPriceCheckbox(model.dI),
						A2($author$project$Pages$Users$Common$TimeSeq$viewStoreGroupCheckbox, model.X, model.L)
					])),
				$author$project$Pages$Users$Common$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Common$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Common$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Common$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Common$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Common$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Common$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						$author$project$Pages$Users$Common$TimeSeq$isFujiComnet(model) ? 'fuji-comnet' : '')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$Common$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$Common$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Common$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Common$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Common$WeeklyProduct$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (sg) {
					return {
						bB: $elm$core$List$length(sg.aN),
						iv: sg.iv,
						kR: sg.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (sg) {
						return A2($elm$core$Set$member, sg.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(sg.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Common$WeeklyProduct$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (ind, cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																(!price.fH) ? 'pastPriceTd ' : '',
																_Utils_ap(
																	price.hN ? 'lowestPriceTd ' : '',
																	_Utils_ap(
																		price.jL ? 'lowestButHigherThanBasePriceTd ' : '',
																		price.hL ? 'lowerPriceTd ' : ''))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								}),
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Common$WeeklyProduct$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (ind, hsg) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											(!ind) ? 'rowHeader' : ('storeGroupHeader' + $elm$core$String$fromInt(hsg.iv))),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(hsg.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(hsg.kR)
										]));
							}),
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (ind, store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							}),
						headerStores))
				]));
	});
var $author$project$Pages$Users$Common$WeeklyProduct$viewPriceTable = function (req) {
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, req.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:2;cols:' + colsNum)
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Common$WeeklyProduct$viewTableHeader, req.fA, req.hC),
				$author$project$Pages$Users$Common$WeeklyProduct$viewTableBody(req.hi)
			]));
};
var $author$project$Pages$Users$Common$WeeklyProduct$OnChangeBigCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$OnChangeSmallCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$OnSubmit = {$: 7};
var $author$project$Pages$Users$Common$WeeklyProduct$OnSubmitLatest = {$: 8};
var $author$project$Pages$Users$Common$WeeklyProduct$OnToggleAutoReload = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$OnUpdateDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$OnUpdateTime = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$WeeklyProduct$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$WeeklyProduct$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$WeeklyProduct$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$WeeklyProduct$OnUpdateTime)
							]))
					])),
				model.fk ? A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('自動更新')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.dn),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Common$WeeklyProduct$OnToggleAutoReload)
							]),
						'15分ごとに最新時刻で再読込')
					])) : $rtfeldman$elm_css$Html$Styled$text(''),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$WeeklyProduct$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$WeeklyProduct$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Common$WeeklyProduct$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Common$WeeklyProduct$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Common$WeeklyProduct$OnChangeDisplayStyle)
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Common$WeeklyProduct$OnPressDownloadCSV = {$: 9};
var $author$project$Pages$Users$Common$WeeklyProduct$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$WeeklyProduct$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Common$WeeklyProduct$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Common$WeeklyProduct$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Common$WeeklyProduct$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Common$WeeklyProduct$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Common$WeeklyProduct$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Common$WeeklyProduct$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Common$WeeklyProduct$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Common$WeeklyProduct$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Common$WeeklyProduct$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Common$WeeklyProduct$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Common$WeeklyProduct$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Common$WeeklyProduct$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Common$WeeklyProduct$viewTableControl(model),
						$author$project$Pages$Users$Common$WeeklyProduct$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Common$WeeklyProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Common$WeeklyProduct$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Dbi6Comnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Dbi6Comnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeMaker = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnSubmit = {$: 8};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Dbi6Comnet$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Dbi6Comnet$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Dbi6Comnet$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Dbi6Comnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Dbi6Comnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Dbi6Comnet$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Dbi6Comnet$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Dbi6Comnet$Hour$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Dbi6Comnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Dbi6Comnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Dbi6Comnet$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Dbi6Comnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$Dbi6Comnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Dbi6Comnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Dbi6Comnet$Hour$viewContent, model, $author$project$Pages$Users$Dbi6Comnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$Dbi6Comnet$Hour$pStoreHeader, $author$project$Pages$Users$Dbi6Comnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$Dbi6Comnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Dbi6Comnet$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$Nop = {$: 17};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeMaker = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$MakerSelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Dbi6Comnet$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Dbi6Comnet$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Dbi6Comnet$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Dbi6Comnet$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Dbi6Comnet$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Dbi6Comnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Dbi6Comnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateAllProducts = {$: 7};
var $author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateIsWeekly = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$Drop = {$: 11};
var $author$project$Pages$Users$Delonghi$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$Delonghi$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$Delonghi$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$Delonghi$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$Delonghi$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$viewTr = F5(
	function (product, isWeeklyList, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$Delonghi$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$Delonghi$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
									A2(
										$elm$core$Maybe$withDefault,
										false,
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.fK;
											},
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (p) {
													return _Utils_eq(p.kl, product.kl);
												},
												isWeeklyList)))),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateIsWeekly(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Delonghi$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('トラッキング')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A5($author$project$Pages$Users$Delonghi$ChangeProduct$viewTr, product, model.cy, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$Delonghi$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Delonghi$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$Delonghi$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Delonghi$Hour$viewTableHeader = function (headerStores) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_Nil,
				A2(
					$elm$core$List$indexedMap,
					function (ind) {
						return function (store) {
							return A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class(
										function () {
											switch (ind) {
												case 0:
													return 'numberHeader rowHeader';
												case 1:
													return 'katabanHeader rowHeader';
												case 2:
													return 'itemHeader rowHeader';
												case 3:
													return 'basePriceHeader rowHeader';
												default:
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
											}
										}())
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(store.kS)
									]));
						};
					},
					headerStores))
			]));
};
var $author$project$Pages$Users$Delonghi$Hour$viewPriceTable = function (priceTableRequired) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:1;cols:4'),
				$rtfeldman$elm_css$Html$Styled$Attributes$class('delonghi')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Delonghi$Hour$viewTableHeader(priceTableRequired.hC),
				$author$project$Pages$Users$Delonghi$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Delonghi$Hour$OnChangeBigCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$OnChangeMaker = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$OnChangeSmallCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$OnSubmit = {$: 9};
var $author$project$Pages$Users$Delonghi$Hour$OnSubmitLatest = {$: 10};
var $author$project$Pages$Users$Delonghi$Hour$OnUpdateDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$OnUpdateTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ブランド')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Hour$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Delonghi$Hour$OnToggleStore = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Delonghi$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$advancedCheckbox = F2(
	function (options, label_) {
		return $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$view(
			A2($frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$create, options, label_));
	});
var $author$project$Pages$Users$Delonghi$Hour$gatherStoresInStoreGroups = function (storeGroups) {
	var addStoreGroup = F2(
		function (sg, maybeSG) {
			if (maybeSG.$ === 1) {
				return sg;
			} else {
				var sg2 = maybeSG.a;
				return _Utils_update(
					sg,
					{
						aN: _Utils_ap(sg.aN, sg2.aN)
					});
			}
		});
	return $elm$core$Dict$values(
		A3(
			$elm$core$List$foldr,
			function (sg) {
				return A2(
					$elm$core$Dict$update,
					sg.iv,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Maybe$Just,
						addStoreGroup(sg)));
			},
			$elm$core$Dict$empty,
			storeGroups));
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Inline = {$: 2};
var $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline = $frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$Inline;
var $author$project$Pages$Users$Delonghi$Hour$viewStoreGroupCheckbox = F3(
	function (storeGroups, visibleStoreGroups, visibleStores) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$table,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('table table-light table-bordered viewStoreGroupCheckbox')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									var isVisible = A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups);
									return A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class(
														'storeGroupHeader' + $elm$core$String$fromInt(storeGroup.iv))
													]),
												_List_fromArray(
													[
														A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$advancedCheckbox,
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id(
																'visibleStoreGroup' + $elm$core$String$fromInt(storeGroup.iv)),
																$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(isVisible),
																$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$value(
																		$elm$core$String$fromInt(storeGroup.iv)),
																		A2(
																		$rtfeldman$elm_css$Html$Styled$Events$on,
																		'click',
																		A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Delonghi$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
																	]))
															]),
														A2(
															$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$label,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(storeGroup.kR)
																])))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$td,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('')
													]),
												A2(
													$elm$core$List$map,
													function (store) {
														return A2(
															$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$advancedCheckbox,
															_List_fromArray(
																[
																	$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id(
																	'visibleStore' + $elm$core$String$fromInt(store.iw)),
																	$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
																	A2($elm$core$Set$member, store.iw, visibleStores)),
																	$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
																	$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(!isVisible),
																	$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$value(
																			$elm$core$String$fromInt(store.iw)),
																			A2(
																			$rtfeldman$elm_css$Html$Styled$Events$on,
																			'click',
																			A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Delonghi$Hour$OnToggleStore, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
																		]))
																]),
															A2(
																$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$label,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(store.kS)
																	])));
													},
													storeGroup.aN))
											]));
								},
								$author$project$Pages$Users$Delonghi$Hour$gatherStoresInStoreGroups(storeGroups)))
						]))
				]));
	});
var $author$project$Pages$Users$Delonghi$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Delonghi$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Delonghi$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Delonghi$Hour$OnPressDownloadCSV = {$: 11};
var $author$project$Pages$Users$Delonghi$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Delonghi$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Delonghi$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Delonghi$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Delonghi$Hour$viewContent = F3(
	function (model, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A3(pStoreHeader_, model.X, model.L, model.aa);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Delonghi$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Pages$Users$Delonghi$Hour$viewStoreGroupCheckbox, model.X, model.L, model.aa),
							$author$project$Pages$Users$Delonghi$Hour$viewTableControl(model),
							$author$project$Pages$Users$Delonghi$Hour$viewPriceTable(
							{hi: bodyProducts, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Delonghi$Hour$viewContentDefault = function (model) {
	return A3($author$project$Pages$Users$Delonghi$Hour$viewContent, model, $author$project$Pages$Users$Delonghi$Hour$pStoreHeader, $author$project$Pages$Users$Delonghi$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$Delonghi$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Delonghi$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Delonghi$NineAM$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Delonghi$NineAM$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Delonghi$NineAM$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Delonghi$NineAM$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Delonghi$NineAM$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Delonghi$NineAM$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Delonghi$NineAM$Nop = {$: 18};
var $author$project$Pages$Users$Delonghi$NineAM$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$OnSubmit = {$: 12};
var $author$project$Pages$Users$Delonghi$NineAM$OnUpdateDateFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$OnUpdateDateTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Delonghi$NineAM$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('量販店')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Delonghi$NineAM$OnChangeStore,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$NineAM$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$NineAM$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Delonghi$NineAM$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Delonghi$NineAM$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$NineAM$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$NineAM$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$NineAM$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Delonghi$NineAM$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Delonghi$NineAM$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Delonghi$NineAM$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Delonghi$NineAM$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$Delonghi$NineAM$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$NineAM$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Delonghi$NineAM$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Delonghi$NineAM$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Delonghi$NineAM$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Delonghi$NineAM$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Delonghi$NineAM$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Delonghi$NineAM$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Delonghi$NineAM$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Delonghi$NineAM$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Delonghi$NineAM$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Delonghi$NineAM$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Delonghi$NineAM$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Delonghi$NineAM$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Delonghi$NineAM$viewTableControl(model),
						$author$project$Pages$Users$Delonghi$NineAM$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Delonghi$NineAM$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Delonghi$NineAM$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$Delonghi$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Button$button,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Button$primary,
			$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$TimeSeq$OnPressDownloadCSV)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
		]));
var $author$project$Pages$Users$Delonghi$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (product) {
							switch (product.$) {
								case 0:
									var storeName = product.a;
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('colStoreHeader')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(storeName)
											]));
								case 1:
									var cell = product.a;
									var priceChangingTypeClass = function () {
										var _v2 = cell.ge;
										switch (_v2.$) {
											case 0:
												return 'increasedPriceTd';
											case 1:
												return 'decreasedPriceTd';
											default:
												return '';
										}
									}();
									var comparedPriceTypeClass = function () {
										var _v1 = cell.du;
										switch (_v1) {
											case 0:
												return 'lowestPriceTd';
											case 1:
												return 'lowerPriceTd';
											case 2:
												return 'lowestButHigherThanBasePriceTd';
											default:
												return '';
										}
									}();
									return A2(
										$rtfeldman$elm_css$Html$Styled$td,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceTypeClass),
												$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$Utils$Helpers$toCommmaSplited(
															$elm$core$String$fromInt(cell.be)))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														$author$project$Utils$Helpers$toCommmaSplited(
															$elm$core$String$fromInt(cell.ka)))
													]))
											]));
								default:
									return A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil);
							}
						},
						productList));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Delonghi$TimeSeq$viewTableHeader = function (headerDateTimes) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader')
					]),
				A2(
					$elm$core$List$map,
					function (datetime) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(datetime)
								]));
					},
					headerDateTimes))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq$viewPriceTable = function (priceTableRequired) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('priceTableContainer')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:1;cols:1')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$Delonghi$TimeSeq$viewTableHeader(priceTableRequired.hB),
						$author$project$Pages$Users$Delonghi$TimeSeq$viewTableBody(priceTableRequired.hi)
					]))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CategorySelector$productSelector = F5(
	function (products, selectedBigCategory, selectedSmallCategory, selectedProduct, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									A2($elm$core$Maybe$withDefault, '-1', selectedProduct) === '-1')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('選択してください')
								])),
						A2(
							$elm$core$List$map,
							function (product) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(product.kl),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, '', selectedProduct),
												product.kl))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(product.nk)
										]));
							},
							A2(
								$elm$core$List$filter,
								function (product) {
									return _Utils_eq(
										selectedSmallCategory,
										$elm$core$Maybe$Just(-1)) || _Utils_eq(
										A2($elm$core$Maybe$withDefault, -1, selectedSmallCategory),
										product.ir);
								},
								A2(
									$elm$core$List$filter,
									function (product) {
										return _Utils_eq(
											selectedBigCategory,
											$elm$core$Maybe$Just(-1)) || _Utils_eq(
											A2($elm$core$Maybe$withDefault, -1, selectedBigCategory),
											product.e_);
									},
									products)))))
				]));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$required = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('required');
var $author$project$Pages$Users$Delonghi$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex position-relative flex-column align-items-start mr-3 ')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A5(
						$author$project$Components$CategorySelector$productSelector,
						model.kn,
						model.ig,
						model.gD,
						model.ih,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq$OnChangeProduct),
								$rtfeldman$elm_css$Html$Styled$Attributes$required(true)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-err-msg')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(model.dQ && $elm_community$maybe_extra$Maybe$Extra$isNothing(model.ih)) ? '商品を選択してください' : '')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq$viewContent = function (model) {
	var headerDateTimes = A3(
		$author$project$Pages$Users$Delonghi$TimeSeq$pStoreHeader,
		A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
		A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
		model.ac);
	var currentProduct = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Helpers$defaultProduct,
		A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kl;
				},
				$elm$core$Basics$eq(
					A2($elm$core$Maybe$withDefault, '', model.ep))),
			model.kn));
	var bodyProducts = A4(
		$author$project$Pages$Users$Delonghi$TimeSeq$pProductPriceRows,
		model.aN,
		$elm$core$List$length(headerDateTimes),
		model.cQ,
		currentProduct.lt);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Delonghi$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('モデル:\u3000\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(currentProduct.nk)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格:\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(currentProduct.lt))
													]))
											]))
									])),
								$author$project$Pages$Users$Delonghi$TimeSeq$viewDownloadCSVButton
							])),
						$author$project$Pages$Users$Delonghi$TimeSeq$viewPriceTable(
						{hi: bodyProducts, hB: headerDateTimes})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Delonghi$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Delonghi$TimeSeq2$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Delonghi$TimeSeq2$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$Nop = {$: 18};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeMaker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnSubmit = {$: 12};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateDateFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateDateTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateTimeFrom = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateTimeTo = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ブランド')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Delonghi$TimeSeq2$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Delonghi$TimeSeq2$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('販売店')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeStore,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$TimeSeq2$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$TimeSeq2$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Delonghi$TimeSeq2$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$TimeSeq2$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Delonghi$TimeSeq2$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Delonghi$TimeSeq2$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Delonghi$TimeSeq2$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Delonghi$TimeSeq2$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Delonghi$TimeSeq2$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Delonghi$TimeSeq2$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Delonghi$TimeSeq2$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Delonghi$TimeSeq2$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Delonghi$TimeSeq2$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Delonghi$TimeSeq2$viewTableControl(model),
						$author$project$Pages$Users$Delonghi$TimeSeq2$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Delonghi$TimeSeq2$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Delonghi$TimeSeq2$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 新時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Delonghi$Weekly$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 8, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Delonghi$Weekly$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					case 5:
																						return 'basePriceIncludeTaxHeader';
																					case 6:
																						return 'basePriceWithPointHeader';
																					case 7:
																						return 'basePriceWithPointIncludeTaxHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																if (!_v5.$) {
																	return 'decreasedPriceTd ';
																} else {
																	return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																if (!_v4) {
																	return 'lowestPriceTd';
																} else {
																	return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Delonghi$Weekly$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														case 5:
															return 'basePriceIncludeTaxHeader rowHeader';
														case 6:
															return 'basePriceWithPointHeader rowHeader';
														case 7:
															return 'basePriceWithPointIncludeTaxHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Delonghi$Weekly$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Delonghi$Weekly$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Delonghi$Weekly$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Delonghi$Weekly$Nop = {$: 18};
var $author$project$Pages$Users$Delonghi$Weekly$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$OnChangeMaker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$OnSubmit = {$: 12};
var $author$project$Pages$Users$Delonghi$Weekly$OnUpdateDateFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$OnUpdateDateTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$OnUpdateTimeFrom = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$OnUpdateTimeTo = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Weekly$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Weekly$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('ブランド')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Weekly$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Delonghi$Weekly$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Delonghi$Weekly$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Delonghi$Weekly$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('販売店')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Delonghi$Weekly$OnChangeStore,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$Weekly$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Weekly$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Delonghi$Weekly$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Delonghi$Weekly$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$Weekly$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Delonghi$Weekly$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Delonghi$Weekly$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('税抜価格(ポイント後)', 'DisplayPrice'),
			_Utils_Tuple2('税込価格(ポイント後)', 'DisplayPriceIncludeTax')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Delonghi$Weekly$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Delonghi$Weekly$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$Delonghi$Weekly$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Delonghi$Weekly$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Delonghi$Weekly$viewDownloadExcelButton = function (downloadURL) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('form-group d-flex flex-column ml-5')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-group d-flex flex-column ml-5')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-group d-flex flex-column ml-5')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('form-group d-flex flex-column ml-5')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$a,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(downloadURL),
						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('Excelダウンロード')
					])),
				$rtfeldman$elm_css$Html$Styled$text('')
			]));
};
var $author$project$Pages$Users$Delonghi$Weekly$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Delonghi$Weekly$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Delonghi$Weekly$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Delonghi$Weekly$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Delonghi$Weekly$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Delonghi$Weekly$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Delonghi$Weekly$viewDownloadCSVButton,
				$author$project$Pages$Users$Delonghi$Weekly$viewDownloadExcelButton(model.ck)
			]));
};
var $author$project$Pages$Users$Delonghi$Weekly$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Delonghi$Weekly$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Delonghi$Weekly$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Delonghi$Weekly$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Delonghi$Weekly$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Delonghi$Weekly$viewTableControl(model),
						$author$project$Pages$Users$Delonghi$Weekly$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Delonghi$Weekly$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Delonghi$Weekly$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return 'トラッキング';
			}
		}()
	};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Denon6Comnet$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Denon6Comnet$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$Nop = {$: 17};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Denon6Comnet$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Denon6Comnet$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Denon6Comnet$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Denon6Comnet$TimeSeq$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Denon6Comnet$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Denon6Comnet$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Denon6Comnet$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Denon6Comnet$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Denon6Comnet$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Denon6Comnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Denon6Comnet$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$Denon6Comnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Denon6Comnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Denon6Comnet$Wide$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Denon6Comnet$Wide$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Denon6Comnet$Wide$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnChangeBigCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnChangeMaker = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnChangeSmallCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnSubmit = {$: 8};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Denon6Comnet$Wide$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Denon6Comnet$Wide$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Denon6Comnet$Wide$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Denon6Comnet$Wide$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Denon6Comnet$Wide$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Denon6Comnet$Wide$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Denon6Comnet$Wide$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$Wide$OnPressDownloadCSV = {$: 9};
var $author$project$Pages$Users$Denon6Comnet$Wide$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Denon6Comnet$Wide$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Denon6Comnet$Wide$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Denon6Comnet$Wide$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Denon6Comnet$Wide$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Denon6Comnet$Wide$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Denon6Comnet$Wide$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Denon6Comnet$Wide$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Denon6Comnet$Wide$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Denon6Comnet$Wide$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Denon6Comnet$Wide$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Denon6Comnet$Wide$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Denon6Comnet$Wide$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Denon6Comnet$Wide$viewTableControl(model),
						$author$project$Pages$Users$Denon6Comnet$Wide$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Denon6Comnet$Wide$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Denon6Comnet$Wide$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '60分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateAllProducts = {$: 7};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$Drop = {$: 11};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$ElecComnet$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$ElecComnet$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$ElecComnet$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$ElecComnet$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$ElecComnet$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$ElecComnet$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$ElecComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ElecComnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table elec-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('ヨドバシを')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格に')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$ElecComnet$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$ElecComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ElecComnet$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Role$Danger = 5;
var $frandibar$elm_bootstrap$Bootstrap$Alert$Shown = 0;
var $frandibar$elm_bootstrap$Bootstrap$Alert$Config = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Alert$attrs = F2(
	function (attributes, _v0) {
		var configRec = _v0;
		return _Utils_update(
			configRec,
			{eW: attributes});
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$children = F2(
	function (children_, _v0) {
		var configRec = _v0;
		return _Utils_update(
			configRec,
			{i6: children_});
	});
var $frandibar$elm_bootstrap$Bootstrap$Internal$Role$Secondary = 1;
var $frandibar$elm_bootstrap$Bootstrap$Alert$config = {eW: _List_Nil, i6: _List_Nil, bs: $elm$core$Maybe$Nothing, $8: 1, aF: 0, b2: false};
var $frandibar$elm_bootstrap$Bootstrap$Alert$role = F2(
	function (role_, _v0) {
		var configRec = _v0;
		return _Utils_update(
			configRec,
			{$8: role_});
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$Closed = 3;
var $frandibar$elm_bootstrap$Bootstrap$Alert$StartClose = 1;
var $frandibar$elm_bootstrap$Bootstrap$Alert$clickHandler = F2(
	function (visibility, configRec) {
		var handleClick = F2(
			function (viz, toMsg) {
				return $rtfeldman$elm_css$Html$Styled$Events$onClick(
					toMsg(viz));
			});
		var _v0 = configRec.bs;
		if (!_v0.$) {
			var dismissMsg = _v0.a;
			return _List_fromArray(
				[
					configRec.b2 ? A2(handleClick, 1, dismissMsg) : A2(handleClick, 3, dismissMsg)
				]);
		} else {
			return _List_Nil;
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$injectButton = F2(
	function (btn, children_) {
		if (children_.b) {
			var head = children_.a;
			var tail = children_.b;
			return A2(
				$elm$core$List$cons,
				head,
				A2($elm$core$List$cons, btn, tail));
		} else {
			return _List_fromArray(
				[btn]);
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$isDismissable = function (configRec) {
	var _v0 = configRec.bs;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Alert$maybeAddDismissButton = F3(
	function (visibilty, configRec, children_) {
		return $frandibar$elm_bootstrap$Bootstrap$Alert$isDismissable(configRec) ? A2(
			$frandibar$elm_bootstrap$Bootstrap$Alert$injectButton,
			A2(
				$rtfeldman$elm_css$Html$Styled$button,
				_Utils_ap(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
							$rtfeldman$elm_css$Html$Styled$Attributes$class('close'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-label', 'close')
						]),
					A2($frandibar$elm_bootstrap$Bootstrap$Alert$clickHandler, visibilty, configRec)),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'aria-hidden', 'true')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('×')
							]))
					])),
			children_) : children_;
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$viewAttributes = F2(
	function (visibility, configRec) {
		var visibiltyAttributes = (visibility === 3) ? _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'none')
			]) : _List_Nil;
		var animationAttributes = function () {
			if (configRec.b2) {
				var _v0 = configRec.bs;
				if (!_v0.$) {
					var dismissMsg = _v0.a;
					return _List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$on,
							'transitionend',
							$elm$json$Json$Decode$succeed(
								dismissMsg(3)))
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return _List_Nil;
			}
		}();
		var alertAttributes = _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'alert'),
				$rtfeldman$elm_css$Html$Styled$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('alert', true),
						_Utils_Tuple2(
						'alert-dismissible',
						$frandibar$elm_bootstrap$Bootstrap$Alert$isDismissable(configRec)),
						_Utils_Tuple2('fade', configRec.b2),
						_Utils_Tuple2('show', !visibility)
					])),
				A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'alert', configRec.$8)
			]);
		return $elm$core$List$concat(
			_List_fromArray(
				[configRec.eW, alertAttributes, visibiltyAttributes, animationAttributes]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$view = F2(
	function (visibility, _v0) {
		var configRec = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2($frandibar$elm_bootstrap$Bootstrap$Alert$viewAttributes, visibility, configRec),
			A3($frandibar$elm_bootstrap$Bootstrap$Alert$maybeAddDismissButton, visibility, configRec, configRec.i6));
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$simple = F3(
	function (role_, attributes, children_) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Alert$view,
			0,
			A2(
				$frandibar$elm_bootstrap$Bootstrap$Alert$children,
				children_,
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Alert$attrs,
					attributes,
					A2($frandibar$elm_bootstrap$Bootstrap$Alert$role, role_, $frandibar$elm_bootstrap$Bootstrap$Alert$config))));
	});
var $frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger = $frandibar$elm_bootstrap$Bootstrap$Alert$simple(5);
var $author$project$Pages$Users$ElecComnet$Excel$Nop = {$: 13};
var $author$project$Pages$Users$ElecComnet$Excel$OnChangeBigCategory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$OnChangeSmallCategory = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$OnSubmit = {$: 10};
var $author$project$Pages$Users$ElecComnet$Excel$OnUpdateDateFrom = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$OnUpdateDateTo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$OnUpdateTimeFrom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$OnUpdateTimeTo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ElecComnet$Excel$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$Excel$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$Excel$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$ElecComnet$Excel$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$ElecComnet$Excel$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ElecComnet$Excel$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$Excel$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ElecComnet$Excel$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$Excel$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ElecComnet$Excel$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$ElecComnet$Excel$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$ElecComnet$Excel$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Users$ElecComnet$Excel$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ElecComnet$Excel$viewContent(model),
		iB: 'エクセル出力'
	};
};
var $author$project$Pages$Users$ElecComnet$Hour$view = $author$project$Pages$Users$Common$Default$view;
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$ElecComnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Button$button,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Button$primary,
			$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ElecComnet$TimeSeq$OnPressDownloadCSV)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
		]));
var $author$project$Pages$Users$ElecComnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (product) {
							switch (product.$) {
								case 0:
									var storeName = product.a;
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('colStoreHeader')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(storeName)
											]));
								case 1:
									var cell = product.a;
									var priceChangingTypeClass = function () {
										var _v2 = cell.ge;
										switch (_v2.$) {
											case 0:
												return 'increasedPriceTd';
											case 1:
												return 'decreasedPriceTd';
											default:
												return '';
										}
									}();
									var comparedPriceTypeClass = function () {
										var _v1 = cell.du;
										switch (_v1) {
											case 0:
												return 'lowestPriceTd';
											case 1:
												return 'lowerPriceTd';
											case 2:
												return 'lowestButHigherThanBasePriceTd';
											default:
												return '';
										}
									}();
									return A2(
										$rtfeldman$elm_css$Html$Styled$td,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceTypeClass),
												$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(cell.be))
											]));
								default:
									return A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil);
							}
						},
						productList));
			},
			bodyProducts));
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$viewTableHeader = function (headerDateTimes) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader')
					]),
				A2(
					$elm$core$List$map,
					function (datetime) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(datetime)
								]));
					},
					headerDateTimes))
			]));
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('priceTableContainer')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:1;cols:1')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$ElecComnet$TimeSeq$viewTableHeader(priceTableRequired.hB),
						$author$project$Pages$Users$ElecComnet$TimeSeq$viewTableBody(priceTableRequired.hi)
					]))
			]));
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex position-relative flex-column align-items-start mr-3 ')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A5(
						$author$project$Components$CategorySelector$productSelector,
						model.kn,
						model.ig,
						model.gD,
						model.ih,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$TimeSeq$OnChangeProduct),
								$rtfeldman$elm_css$Html$Styled$Attributes$required(true)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-err-msg')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(model.dQ && $elm_community$maybe_extra$Maybe$Extra$isNothing(model.ih)) ? '商品を選択してください' : '')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ElecComnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ElecComnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$viewContent = function (model) {
	var headerDateTimes = A3(
		$author$project$Pages$Users$ElecComnet$TimeSeq$pStoreHeader,
		A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
		A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
		model.ac);
	var currentProduct = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Helpers$defaultProduct,
		A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kl;
				},
				$elm$core$Basics$eq(
					A2($elm$core$Maybe$withDefault, '', model.ep))),
			model.kn));
	var bodyProducts = A4(
		$author$project$Pages$Users$ElecComnet$TimeSeq$pProductPriceRows,
		model.aN,
		$elm$core$List$length(headerDateTimes),
		model.cQ,
		currentProduct.lt);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$ElecComnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('モデル:\u3000\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(currentProduct.nk)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格:\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(currentProduct.lt))
													]))
											]))
									])),
								$author$project$Pages$Users$ElecComnet$TimeSeq$viewDownloadCSVButton
							])),
						$author$project$Pages$Users$ElecComnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, hB: headerDateTimes})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$ElecComnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ElecComnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$OnResetAllProducts = {$: 8};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$OnResetProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateWeek30ProductOrder = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Disabled = function (a) {
	return {$: 3, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$disabled = function (disabled_) {
	return $frandibar$elm_bootstrap$Bootstrap$Form$Input$Disabled(disabled_);
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$viewTr = F2(
	function (product, ind) {
		var basePriceWithoutPoint = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.kl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, product.bn))),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$disabled(!product.lt),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateWeek30ProductOrder(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(basePriceWithoutPoint)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$FujiComnet$ChangeProduct$OnResetProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('リセット')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$FujiComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 表示順は基準価格が入っている商品のみ設定できます(今週の品目としての順序です)')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格を0にすると、今週の品目から自動的に外れます')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$secondary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$ChangeProduct$OnResetAllProducts),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-2')
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括リセット')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JANコード')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示順')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込 P後')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('リセット')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (ind, product) {
									return A2($author$project$Pages$Users$FujiComnet$ChangeProduct$viewTr, product, ind);
								}),
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$FujiComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$FujiComnet$ChangeProduct$viewContent(model),
		iB: '価格・ポイント設定'
	};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$FujiComnet$Fifteen$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$FujiComnet$Fifteen$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$FujiComnet$Fifteen$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnSubmit = {$: 8};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiComnet$Fifteen$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiComnet$Fifteen$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$FujiComnet$Fifteen$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiComnet$Fifteen$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$Fifteen$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$Fifteen$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$FujiComnet$Fifteen$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$FujiComnet$Fifteen$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$FujiComnet$Fifteen$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$FujiComnet$Fifteen$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$Fifteen$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$FujiComnet$Fifteen$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$FujiComnet$Fifteen$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$FujiComnet$Fifteen$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$FujiComnet$Fifteen$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$FujiComnet$Fifteen$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$FujiComnet$Fifteen$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$FujiComnet$Fifteen$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$FujiComnet$Fifteen$viewTableControl(model),
							$author$project$Pages$Users$FujiComnet$Fifteen$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$FujiComnet$Fifteen$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$FujiComnet$Fifteen$viewContent, model, $author$project$Pages$Users$FujiComnet$Fifteen$pStoreGroupsHeader, $author$project$Pages$Users$FujiComnet$Fifteen$pStoreHeader, $author$project$Pages$Users$FujiComnet$Fifteen$pProductPriceRows);
};
var $author$project$Pages$Users$FujiComnet$Fifteen$view = function (model) {
	return {
		lI: $author$project$Pages$Users$FujiComnet$Fifteen$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$viewPriceTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-center')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '0 auto')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得日時')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型名')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JAN')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('小分類')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('価格')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント還元済み価格')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (priceRow) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.lP)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.nk)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.kl)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.nF)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href(priceRow.eD),
															$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(priceRow.kg)))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(priceRow.ka)))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(priceRow.be)))
												]))
										]));
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.nk;
								},
								model.cQ)))
					]))
			]));
};
var $author$project$Pages$Users$FujiComnet$LatestStore$OnChangeSmallCategory = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$OnChangeStore = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$OnSubmit = {$: 7};
var $author$project$Pages$Users$FujiComnet$LatestStore$OnSubmitLatest = {$: 8};
var $author$project$Pages$Users$FujiComnet$LatestStore$OnUpdateDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$OnUpdateTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$FujiComnet$LatestStore$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('量販店')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$FujiComnet$LatestStore$OnChangeStore)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										_Utils_eq(model.aB, $elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('選択してください')
									])),
							A2(
								$elm$core$List$map,
								function (store) {
									return A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												$elm$core$String$fromInt(store.iw)),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(
													model.aB,
													$elm$core$Maybe$Just(store.iw)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(store.fh)
											]));
								},
								A2(
									$elm$core$List$sortBy,
									function (s) {
										return _Utils_Tuple2(s.iv, s.iw);
									},
									model.aN))))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						$elm$core$Maybe$Just(-1),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiComnet$LatestStore$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('日にち')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$FujiComnet$LatestStore$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						15,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiComnet$LatestStore$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$LatestStore$OnSubmit),
						$frandibar$elm_bootstrap$Bootstrap$Button$disabled(
						_Utils_eq(model.aB, $elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$LatestStore$OnSubmitLatest),
						$frandibar$elm_bootstrap$Bootstrap$Button$disabled(
						_Utils_eq(model.aB, $elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$FujiComnet$LatestStore$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$FujiComnet$LatestStore$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? $author$project$Pages$Users$FujiComnet$LatestStore$viewPriceTable(model) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$FujiComnet$LatestStore$view = function (model) {
	return {
		lI: $author$project$Pages$Users$FujiComnet$LatestStore$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '販売店別';
			}
		}()
	};
};
var $author$project$Pages$Users$FujiComnet$Week30$OnSubmit = {$: 3};
var $author$project$Pages$Users$FujiComnet$Week30$OnToggleProduct = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$FujiComnet$Week30$viewProductTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('型番')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('JANCODE')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('優先型番')
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$tbody,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (product) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(product.nk)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(product.kl)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('text-center')
										]),
									_List_fromArray(
										[
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
													A2($elm$core$Set$member, product.kl, model.ij)),
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
													$author$project$Pages$Users$FujiComnet$Week30$OnToggleProduct(product.kl))
												]),
											'')
										]))
								]));
					},
					model.kn))
			]));
};
var $author$project$Pages$Users$FujiComnet$Week30$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				model.dO ? $author$project$Components$Loading$loadingCenter(50.0) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.H;
						if (!_v0.$) {
							var err = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('alert alert-danger')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(err)
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						function () {
						var _v1 = model.dc;
						if (!_v1.$) {
							var msg = _v1.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('alert alert-success')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(msg)
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '800px'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('- チェックした製品は15分取得ページで上部に表示されます。')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('- 選択状態を保存するには「実行」ボタンを押してください')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$primary,
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiComnet$Week30$OnSubmit),
										$frandibar$elm_bootstrap$Bootstrap$Button$disabled(model.a7)
									]),
								_List_fromArray(
									[
										model.a7 ? $rtfeldman$elm_css$Html$Styled$text('実行中...') : $rtfeldman$elm_css$Html$Styled$text('実行')
									]))
							])),
						$author$project$Pages$Users$FujiComnet$Week30$viewProductTable(model)
					]))
			]));
};
var $author$project$Pages$Users$FujiComnet$Week30$view = function (model) {
	return {
		lI: $author$project$Pages$Users$FujiComnet$Week30$viewContent(model),
		iB: '優先型番の設定'
	};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$viewPriceTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-center')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '0 auto')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得日時')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型名')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JAN')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('小分類')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('価格')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント還元済み価格')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (priceRow) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.lP)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.nk)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.kl)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(priceRow.nF)
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href(priceRow.eD),
															$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Utils$Helpers$toCommmaSplited(
																$elm$core$String$fromInt(priceRow.kg)))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(priceRow.ka)))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(priceRow.be)))
												]))
										]));
							},
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.nk;
								},
								model.cQ)))
					]))
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnChangeSmallCategory = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnChangeStore = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnSubmit = {$: 7};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnSubmitLatest = {$: 8};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnUpdateDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnUpdateTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('量販店')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnChangeStore)
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
										$rtfeldman$elm_css$Html$Styled$Attributes$disabled(true),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										_Utils_eq(model.aB, $elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('選択してください')
									])),
							A2(
								$elm$core$List$map,
								function (store) {
									return A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(
												$elm$core$String$fromInt(store.iw)),
												$rtfeldman$elm_css$Html$Styled$Attributes$selected(
												_Utils_eq(
													model.aB,
													$elm$core$Maybe$Just(store.iw)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(store.fh)
											]));
								},
								A2(
									$elm$core$List$sortBy,
									function (s) {
										return _Utils_Tuple2(s.iv, s.iw);
									},
									model.aN))))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						$elm$core$Maybe$Just(-1),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('日にち')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						15,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnSubmit),
						$frandibar$elm_bootstrap$Bootstrap$Button$disabled(
						_Utils_eq(model.aB, $elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiinstaxComnet$LatestStore$OnSubmitLatest),
						$frandibar$elm_bootstrap$Bootstrap$Button$disabled(
						_Utils_eq(model.aB, $elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$FujiinstaxComnet$LatestStore$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? $author$project$Pages$Users$FujiinstaxComnet$LatestStore$viewPriceTable(model) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$LatestStore$view = function (model) {
	return {
		lI: $author$project$Pages$Users$FujiinstaxComnet$LatestStore$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '販売店別';
			}
		}()
	};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$FujiinstaxComnet$Thirty$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$FujiinstaxComnet$Thirty$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnSubmit = {$: 8};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiinstaxComnet$Thirty$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$FujiinstaxComnet$Thirty$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$FujiinstaxComnet$Thirty$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$FujiinstaxComnet$Thirty$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$FujiinstaxComnet$Thirty$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$FujiinstaxComnet$Thirty$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$FujiinstaxComnet$Thirty$viewTableControl(model),
							$author$project$Pages$Users$FujiinstaxComnet$Thirty$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$FujiinstaxComnet$Thirty$viewContent, model, $author$project$Pages$Users$FujiinstaxComnet$Thirty$pStoreGroupsHeader, $author$project$Pages$Users$FujiinstaxComnet$Thirty$pStoreHeader, $author$project$Pages$Users$FujiinstaxComnet$Thirty$pProductPriceRows);
};
var $author$project$Pages$Users$FujiinstaxComnet$Thirty$view = function (model) {
	return {
		lI: $author$project$Pages$Users$FujiinstaxComnet$Thirty$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$OnSubmit = {$: 3};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$OnToggleProduct = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$FujiinstaxComnet$Week30$viewProductTable = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$tr,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('型番')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('JANCODE')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('優先型番')
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$tbody,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (product) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(product.nk)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(product.kl)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('text-center')
										]),
									_List_fromArray(
										[
											A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
													A2($elm$core$Set$member, product.kl, model.ij)),
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
													$author$project$Pages$Users$FujiinstaxComnet$Week30$OnToggleProduct(product.kl))
												]),
											'')
										]))
								]));
					},
					model.kn))
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				model.dO ? $author$project$Components$Loading$loadingCenter(50.0) : A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.H;
						if (!_v0.$) {
							var err = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('alert alert-danger')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(err)
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						function () {
						var _v1 = model.dc;
						if (!_v1.$) {
							var msg = _v1.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('alert alert-success')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(msg)
									]));
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}(),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '800px'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('- チェックした製品は30分取得ページで上部に表示されます。')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('- 選択状態を保存するには「実行」ボタンを押してください')
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$primary,
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$FujiinstaxComnet$Week30$OnSubmit),
										$frandibar$elm_bootstrap$Bootstrap$Button$disabled(model.a7)
									]),
								_List_fromArray(
									[
										model.a7 ? $rtfeldman$elm_css$Html$Styled$text('実行中...') : $rtfeldman$elm_css$Html$Styled$text('実行')
									]))
							])),
						$author$project$Pages$Users$FujiinstaxComnet$Week30$viewProductTable(model)
					]))
			]));
};
var $author$project$Pages$Users$FujiinstaxComnet$Week30$view = function (model) {
	return {
		lI: $author$project$Pages$Users$FujiinstaxComnet$Week30$viewContent(model),
		iB: '優先型番の設定'
	};
};
var $author$project$Pages$Users$Hi24Comnet$Day$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$Day$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																lowestClass,
																_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass)))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Hi24Comnet$Day$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$Day$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$Day$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi24Comnet$Day$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Day$Nop = {$: 18};
var $author$project$Pages$Users$Hi24Comnet$Day$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$OnSubmit = {$: 12};
var $author$project$Pages$Users$Hi24Comnet$Day$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hi24Comnet$Day$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('量販店')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$Day$OnChangeStore,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$Day$OnChangeMaker,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.S))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$Day$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$Day$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hi24Comnet$Day$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$Day$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$Day$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Day$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Day$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi24Comnet$Day$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Day$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$Hi24Comnet$Day$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$Day$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi24Comnet$Day$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Hi24Comnet$Day$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi24Comnet$Day$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$Day$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$Day$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Hi24Comnet$Day$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi24Comnet$Day$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Day$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Hi24Comnet$Day$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Hi24Comnet$Day$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Hi24Comnet$Day$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Hi24Comnet$Day$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Hi24Comnet$Day$viewTableControl(model),
						$author$project$Pages$Users$Hi24Comnet$Day$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Day$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi24Comnet$Day$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '本日掲載された機種と価格';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$pStoreGroupsHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (store) {
									return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$Hour$hi24Groups)) || hi24GroupsVisible;
								},
								storeGroup.aN)),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Hi24Comnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi24Comnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnSubmit = {$: 9};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnSubmitLatest = {$: 10};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnUpdateDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnUpdateTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi24Comnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Hour$OnPressDownloadCSV = {$: 11};
var $author$project$Pages$Users$Hi24Comnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi24Comnet$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$OnTogglehi24GroupsVisible = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$Hour$viewStoreGroupCheckbox = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi24Comnet$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
								]),
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(hi24GroupsVisible),
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Hi24Comnet$Hour$OnTogglehi24GroupsVisible)
										]),
									'XPRICE, PREMOA 他')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A3($author$project$Pages$Users$Hi24Comnet$Hour$viewStoreGroupCheckbox, model.X, model.L, model.jx),
				$author$project$Pages$Users$Hi24Comnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi24Comnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi24Comnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A3(pStoreHeader_, model.X, model.L, model.jx);
		var headerStoreGroups = A3(pStoreGroupsHeader_, model.X, model.L, model.jx);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Hi24Comnet$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi24Comnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$Hi24Comnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Hi24Comnet$Hour$viewContent, model, $author$project$Pages$Users$Hi24Comnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$Hi24Comnet$Hour$pStoreHeader, $author$project$Pages$Users$Hi24Comnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$Hi24Comnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi24Comnet$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$pStoreGroupsHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (store) {
									return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$HourSeq$hi24Groups)) || hi24GroupsVisible;
								},
								storeGroup.aN)),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$HourSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi24Comnet$HourSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$Nop = {$: 18};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnSubmit = {$: 12};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateDateFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateDateTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateTimeFrom = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateTimeTo = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeMaker,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.S))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hi24Comnet$HourSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$HourSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$HourSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi24Comnet$HourSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$HourSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$OnTogglehi24GroupsVisible = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewStoreGroupCheckbox = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi24Comnet$HourSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
								]),
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(hi24GroupsVisible),
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Hi24Comnet$HourSeq$OnTogglehi24GroupsVisible)
										]),
									'XPRICE, PREMOA 他')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A3($author$project$Pages$Users$Hi24Comnet$HourSeq$viewStoreGroupCheckbox, model.X, model.L, model.jx),
				$author$project$Pages$Users$Hi24Comnet$HourSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi24Comnet$HourSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$viewContent = function (model) {
	var headerStores = A3($author$project$Pages$Users$Hi24Comnet$HourSeq$pStoreHeader, model.X, model.L, model.jx);
	var headerStoreGroups = A3($author$project$Pages$Users$Hi24Comnet$HourSeq$pStoreGroupsHeader, model.X, model.L, model.jx);
	var bodyProducts = $author$project$Pages$Users$Hi24Comnet$HourSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Hi24Comnet$HourSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Hi24Comnet$HourSeq$viewTableControl(model),
						$author$project$Pages$Users$Hi24Comnet$HourSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$HourSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi24Comnet$HourSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$SixHour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi24Comnet$SixHour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnSubmit = {$: 8};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeMaker,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.S))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$SixHour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$SixHour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$SixHour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$SixHour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi24Comnet$SixHour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$SixHour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi24Comnet$SixHour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi24Comnet$SixHour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$SixHour$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Hi24Comnet$SixHour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi24Comnet$SixHour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Hi24Comnet$SixHour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi24Comnet$SixHour$viewTableControl(model),
							$author$project$Pages$Users$Hi24Comnet$SixHour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$SixHour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Hi24Comnet$SixHour$viewContent, model, $author$project$Pages$Users$Hi24Comnet$SixHour$pStoreGroupsHeader, $author$project$Pages$Users$Hi24Comnet$SixHour$pStoreHeader, $author$project$Pages$Users$Hi24Comnet$SixHour$pProductPriceRows);
};
var $author$project$Pages$Users$Hi24Comnet$SixHour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi24Comnet$SixHour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$calculateDateTimeFromNth = F2(
	function (model, nth) {
		var datetimeParts = A2($author$project$Utils$Helpers$dateTimeToParts, model.es, model.et);
		var date = function () {
			if (!datetimeParts.$) {
				var part = datetimeParts.a;
				return $author$project$Utils$Helpers$formatDateTimeWithoutYear(
					A2(
						$justinmimbs$time_extra$Time$Extra$posixToParts,
						$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
						A4(
							$justinmimbs$time_extra$Time$Extra$add,
							11,
							nth - 1,
							$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
							A2(
								$justinmimbs$time_extra$Time$Extra$partsToPosix,
								$justinmimbs$timezone_data$TimeZone$asia__tokyo(0),
								part))));
			} else {
				return '';
			}
		}();
		return date;
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$pStoreGroupsHeader = F2(
	function (dateTimes, length) {
		return A2(
			$elm$core$List$cons,
			{lP: '', bB: 3},
			A2(
				$elm$core$List$map,
				function (dateTime) {
					return {lP: dateTime, bB: length};
				},
				dateTimes));
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$indexedMap,
			function (rowInd) {
				return function (row) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$tr,
						_List_Nil,
						$elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								function (ind) {
									return function (cell) {
										switch (cell.$) {
											case 0:
												var _v1 = cell.a;
												var rowspan = _v1.a;
												var itemList = _v1.b;
												return _List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class(
																function () {
																	switch (ind) {
																		case 0:
																			return 'numberHeader';
																		case 1:
																			return 'katabanHeader';
																		case 3:
																			return 'itemHeader';
																		default:
																			return '';
																	}
																}()),
																$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
															]),
														A2(
															$elm$core$List$map,
															function (item) {
																return A2(
																	$rtfeldman$elm_css$Html$Styled$p,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(item.jP)
																		]));
															},
															itemList))
													]);
											case 1:
												return _List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
													]);
											default:
												var price = cell.a;
												var priceChangingTypeClass = function () {
													var _v5 = price.ge;
													switch (_v5.$) {
														case 0:
															return 'increasedPriceTd ';
														case 1:
															return 'decreasedPriceTd ';
														default:
															return '';
													}
												}();
												var comparedPriceType = function () {
													var _v4 = price.du;
													switch (_v4) {
														case 0:
															return 'lowestPriceTd';
														case 2:
															return 'lowestButHigherThanBasePriceTd ';
														case 1:
															return 'lowerPriceTd';
														default:
															return '';
													}
												}();
												return _List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
															]),
														A2(
															$elm$core$List$map,
															function (item) {
																var _v3 = item.m;
																switch (_v3) {
																	case 2:
																		return A2(
																			$rtfeldman$elm_css$Html$Styled$p,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																				]),
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text(item.jP)
																				]));
																	case 4:
																		return A2(
																			$rtfeldman$elm_css$Html$Styled$p,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																				]),
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text(item.jP)
																				]));
																	default:
																		return A2(
																			$rtfeldman$elm_css$Html$Styled$p,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$rtfeldman$elm_css$Html$Styled$a,
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																						]),
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$text(item.jP)
																						]))
																				]));
																}
															},
															price.h6))
													]);
										}
									};
								},
								row)));
				};
			},
			bodyProducts));
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{lP: '', bB: 0},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader1';
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.lP)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{lP: '', bB: 0},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$TenAM$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi24Comnet$TenAM$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$Nop = {$: 19};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeBigCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeSmallCategory = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnSubmit = {$: 13};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnUpdateDateFrom = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnUpdateDateTo = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hi24Comnet$TenAM$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('量販店')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeStore,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeMaker,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.S))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hi24Comnet$TenAM$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$TenAM$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$TenAM$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$TenAM$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi24Comnet$TenAM$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnPressDownloadCSV = {$: 14};
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$TenAM$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$OnTogglehi24GroupsVisible = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewStoreGroupCheckbox = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi24Comnet$TenAM$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
								]),
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(hi24GroupsVisible),
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Hi24Comnet$TenAM$OnTogglehi24GroupsVisible)
										]),
									'XPRICE, PREMOA 他')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A3($author$project$Pages$Users$Hi24Comnet$TenAM$viewStoreGroupCheckbox, model.X, model.L, model.jx),
				$author$project$Pages$Users$Hi24Comnet$TenAM$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi24Comnet$TenAM$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$viewContent = function (model) {
	var nthSize = $author$project$Pages$Users$Hi24Comnet$TenAM$getNthSize(model);
	var headerStores = A4($author$project$Pages$Users$Hi24Comnet$TenAM$pStoreHeader, model.aN, nthSize, model.L, model.jx);
	var dateTimes = A2(
		$elm$core$List$map,
		$author$project$Pages$Users$Hi24Comnet$TenAM$calculateDateTimeFromNth(model),
		A2($elm$core$List$range, 1, nthSize));
	var headerStoreGroups = A2(
		$author$project$Pages$Users$Hi24Comnet$TenAM$pStoreGroupsHeader,
		dateTimes,
		$elm$core$List$length(model.aN) + 1);
	var bodyProducts = $author$project$Pages$Users$Hi24Comnet$TenAM$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Hi24Comnet$TenAM$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Hi24Comnet$TenAM$viewTableControl(model),
						$author$project$Pages$Users$Hi24Comnet$TenAM$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TenAM$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi24Comnet$TenAM$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$pStoreGroupsHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (store) {
									return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$TimeSeq$hi24Groups)) || hi24GroupsVisible;
								},
								storeGroup.aN)),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi24Comnet$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$Nop = {$: 18};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnSubmit = {$: 12};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hi24Comnet$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnTogglehi24GroupsVisible = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewStoreGroupCheckbox = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi24Comnet$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
								]),
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(hi24GroupsVisible),
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Hi24Comnet$TimeSeq$OnTogglehi24GroupsVisible)
										]),
									'XPRICE, PREMOA 他')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A3($author$project$Pages$Users$Hi24Comnet$TimeSeq$viewStoreGroupCheckbox, model.X, model.L, model.jx),
				$author$project$Pages$Users$Hi24Comnet$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi24Comnet$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewContent = function (model) {
	var headerStores = A3($author$project$Pages$Users$Hi24Comnet$TimeSeq$pStoreHeader, model.X, model.L, model.jx);
	var headerStoreGroups = A3($author$project$Pages$Users$Hi24Comnet$TimeSeq$pStoreGroupsHeader, model.X, model.L, model.jx);
	var bodyProducts = $author$project$Pages$Users$Hi24Comnet$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Hi24Comnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Hi24Comnet$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$Hi24Comnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi24Comnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pStoreGroupsHeader = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (store) {
									return (!A2($elm$core$List$member, store.iw, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$hi24Groups)) || hi24GroupsVisible;
								},
								storeGroup.aN)),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnChangeBigCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnChangeSmallCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnSubmit = {$: 9};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnSubmitLatest = {$: 10};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnUpdateDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnUpdateTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnChangeDisplayStyle = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnPressDownloadCSV = {$: 11};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnTogglehi24GroupsVisible = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewStoreGroupCheckbox = F3(
	function (storeGroups, visibleStoreGroups, hi24GroupsVisible) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups)),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
								]),
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(hi24GroupsVisible),
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$OnTogglehi24GroupsVisible)
										]),
									'XPRICE, PREMOA 他')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A3($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewStoreGroupCheckbox, model.X, model.L, model.jx),
				$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A3(pStoreHeader_, model.X, model.L, model.jx);
		var headerStoreGroups = A3(pStoreGroupsHeader_, model.X, model.L, model.jx);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewTableControl(model),
							$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewContent, model, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pStoreGroupsHeader, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pStoreHeader, $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$pProductPriceRows);
};
var $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Hi3Comnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi3Comnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi3Comnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnSubmit = {$: 8};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi3Comnet$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi3Comnet$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi3Comnet$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi3Comnet$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi3Comnet$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi3Comnet$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi3Comnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi3Comnet$Hour$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Hi3Comnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi3Comnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi3Comnet$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi3Comnet$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi3Comnet$Hour$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Hi3Comnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi3Comnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi3Comnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Hi3Comnet$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Hi3Comnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$Hi3Comnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Hi3Comnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Hi3Comnet$Hour$viewContent, model, $author$project$Pages$Users$Hi3Comnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$Hi3Comnet$Hour$pStoreHeader, $author$project$Pages$Users$Hi3Comnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$Hi3Comnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi3Comnet$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi3Comnet$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Hi3Comnet$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$Nop = {$: 17};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hi3Comnet$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hi3Comnet$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Hi3Comnet$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Hi3Comnet$TimeSeq$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Hi3Comnet$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Hi3Comnet$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Hi3Comnet$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Hi3Comnet$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Hi3Comnet$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Hi3Comnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Hi3Comnet$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$Hi3Comnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hi3Comnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hi3Comnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Hisense$Amazon$OnChangeCategory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$Hisense$Amazon$OnChangeDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hisense$Amazon$OnChangeTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hisense$Amazon$OnPressDownloadCSV = {$: 7};
var $author$project$Pages$Users$Hisense$Amazon$OnSubmit = {$: 3};
var $author$project$Pages$Users$Hisense$Amazon$categorySelector = F2(
	function (selectedCategory, attrs) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(selectedCategory, -1))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('カテゴリを選択')
						])),
				A2(
					$elm$core$List$indexedMap,
					function (ind) {
						return function (cate) {
							return A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(
										$elm$core$String$fromInt(ind + 1)),
										$rtfeldman$elm_css$Html$Styled$Attributes$selected(
										_Utils_eq(ind + 1, selectedCategory))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(cate)
									]));
						};
					},
					$author$project$Pages$Users$Hisense$Amazon$categories)));
	});
var $author$project$Pages$Users$Hisense$Amazon$rankingLinkPopup = function (content) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$span,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('popoverBottom')
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text(content)
			]));
};
var $author$project$Pages$Users$Hisense$Amazon$viewTable = function (tableRows) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('normalTable')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$tr,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (header) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(header)
										]));
							},
							$author$project$Pages$Users$Hisense$Amazon$tableHeader))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$tbody,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (row) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$a,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$href(row.eD),
													$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(row.h9))
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm_community$list_extra$List$Extra$getAt, row.hl - 1, $author$project$Pages$Users$Hisense$Amazon$categories)))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('popoverParent')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('dotUnderline')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$isEmpty(row.hQ) ? 'Spec, etc.' : row.hQ)
												])),
											$author$project$Pages$Users$Hisense$Amazon$rankingLinkPopup(row.kY)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(row.hd)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromFloat(row.ib))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(row.ia))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$elm$core$String$fromInt(row.hP))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(row.mH)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A2($elm$core$Maybe$withDefault, '', row.hO))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$td,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(row.hp)
										]))
								]));
					},
					tableRows))
			]));
};
var $author$project$Pages$Users$Hisense$Amazon$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('カテゴリ')
									])),
								A2(
								$author$project$Pages$Users$Hisense$Amazon$categorySelector,
								model.cX,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$Amazon$OnChangeCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hisense$Amazon$OnChangeDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								60,
								model.bi,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$Amazon$OnChangeTime)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hisense$Amazon$OnSubmit),
								$frandibar$elm_bootstrap$Bootstrap$Button$disabled(
								_Utils_eq(model.cX, -1))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				model.dO ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				function () {
				if ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H)) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]));
				} else {
					var _v0 = model.eu;
					if (!_v0.$) {
						var tableRows = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mt-3')
								]),
							_List_fromArray(
								[
									A2(
									$frandibar$elm_bootstrap$Bootstrap$Button$button,
									_List_fromArray(
										[
											$frandibar$elm_bootstrap$Bootstrap$Button$primary,
											$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hisense$Amazon$OnPressDownloadCSV)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-3')
										]),
									_List_Nil),
									$author$project$Pages$Users$Hisense$Amazon$viewTable(tableRows)
								]));
					} else {
						return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
					}
				}
			}()
			]));
};
var $author$project$Pages$Users$Hisense$Amazon$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hisense$Amazon$viewContent(model),
		iB: 'Amazon ランキング'
	};
};
var $author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateAllProducts = {$: 7};
var $author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hisense$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$Drop = {$: 11};
var $author$project$Pages$Users$Hisense$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$Hisense$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$Hisense$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$Hisense$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$Hisense$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$Hisense$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$Hisense$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$Hisense$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$Hisense$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Hisense$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hisense$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$Hisense$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$Hisense$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hisense$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$Hisense$Day$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Common$Default$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(filteredItemList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Common$Default$ProductPriceData(
									{fH: price.fH, hL: false, hN: false, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Common$Default$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Hisense$Day$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 3, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hisense$Day$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hisense$Day$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Hisense$Day$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Hisense$Day$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Hisense$Day$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('大分類')
									])),
								A3(
								$author$project$Components$CategorySelector$bigCategorySelector,
								model.iW,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$Default$OnChangeBigCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('小分類')
									])),
								A4(
								$author$project$Components$CategorySelector$smallCategorySelector,
								model.kL,
								model.gD,
								model.ig,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$Default$OnChangeSmallCategory)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$Default$OnUpdateDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$Default$OnSubmit)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				model.dP ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Common$Default$viewTableControl(model),
						$author$project$Pages$Users$Common$Default$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hisense$Day$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hisense$Day$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Hisense$Excel$Nop = {$: 13};
var $author$project$Pages$Users$Hisense$Excel$OnChangeBigCategory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$OnChangeSmallCategory = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$OnSubmit = {$: 10};
var $author$project$Pages$Users$Hisense$Excel$OnUpdateDateTo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$OnUpdateTimeTo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hisense$Excel$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$Excel$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$Excel$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$Hisense$Excel$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Hisense$Excel$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hisense$Excel$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$Excel$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hisense$Excel$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Hisense$Excel$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Hisense$Excel$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Users$Hisense$Excel$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hisense$Excel$viewContent(model),
		iB: 'エクセル出力'
	};
};
var $author$project$Pages$Users$Hisense$Review$Submit = {$: 3};
var $author$project$Pages$Users$Hisense$Review$UpdateFromDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$Hisense$Review$UpdateToDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$Hisense$Review$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('開始日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bz),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '300px')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hisense$Review$UpdateFromDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('終了日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bY),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '300px')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hisense$Review$UpdateToDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$submitButton,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$primary,
										$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hisense$Review$Submit)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('エクセルでダウンロード')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Users$Hisense$Review$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hisense$Review$viewContent(model),
		iB: '価格COM レビュー'
	};
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$Hisense$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Button$button,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Button$primary,
			$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hisense$TimeSeq$OnPressDownloadCSV)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
		]));
var $author$project$Pages$Users$Hisense$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (product) {
							switch (product.$) {
								case 0:
									var storeName = product.a;
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('colStoreHeader')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(storeName)
											]));
								case 1:
									var cell = product.a;
									var priceChangingTypeClass = function () {
										var _v2 = cell.ge;
										switch (_v2.$) {
											case 0:
												return 'increasedPriceTd';
											case 1:
												return 'decreasedPriceTd';
											default:
												return '';
										}
									}();
									var comparedPriceTypeClass = function () {
										var _v1 = cell.du;
										switch (_v1) {
											case 0:
												return 'lowestPriceTd';
											case 1:
												return 'lowerPriceTd';
											case 2:
												return 'lowestButHigherThanBasePriceTd';
											default:
												return '';
										}
									}();
									return A2(
										$rtfeldman$elm_css$Html$Styled$td,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceTypeClass),
												$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(cell.be))
											]));
								default:
									return A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil);
							}
						},
						productList));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Hisense$TimeSeq$viewTableHeader = function (headerDateTimes) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader')
					]),
				A2(
					$elm$core$List$map,
					function (datetime) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(datetime)
								]));
					},
					headerDateTimes))
			]));
};
var $author$project$Pages$Users$Hisense$TimeSeq$viewPriceTable = function (priceTableRequired) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('priceTableContainer')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:1;cols:1'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('hisense')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$Hisense$TimeSeq$viewTableHeader(priceTableRequired.hB),
						$author$project$Pages$Users$Hisense$TimeSeq$viewTableBody(priceTableRequired.hi)
					]))
			]));
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$Hisense$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$Hisense$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex position-relative flex-column align-items-start mr-3 ')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A5(
						$author$project$Components$CategorySelector$productSelector,
						model.kn,
						model.ig,
						model.gD,
						model.ih,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$TimeSeq$OnChangeProduct),
								$rtfeldman$elm_css$Html$Styled$Attributes$required(true)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-err-msg')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(model.dQ && $elm_community$maybe_extra$Maybe$Extra$isNothing(model.ih)) ? '商品を選択してください' : '')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hisense$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Hisense$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Hisense$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Hisense$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$Hisense$TimeSeq$viewContent = function (model) {
	var headerDateTimes = A3(
		$author$project$Pages$Users$Hisense$TimeSeq$pStoreHeader,
		A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
		A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
		model.ac);
	var currentProduct = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Helpers$defaultProduct,
		A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kl;
				},
				$elm$core$Basics$eq(
					A2($elm$core$Maybe$withDefault, '', model.ep))),
			model.kn));
	var bodyProducts = A4(
		$author$project$Pages$Users$Hisense$TimeSeq$pProductPriceRows,
		model.aN,
		$elm$core$List$length(headerDateTimes),
		model.cQ,
		currentProduct.eY);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$Hisense$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('モデル:\u3000\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(currentProduct.nk)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格:\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(currentProduct.eY))
													]))
											]))
									])),
								$author$project$Pages$Users$Hisense$TimeSeq$viewDownloadCSVButton,
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowerPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を下回るものはピンク')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowestPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を下回っていて，最小値の場合は赤')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('decreasedPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('価格が低くなったら赤枠')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('increasedPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('価格が高くなったら青枠')
													]))
											]))
									]))
							])),
						$author$project$Pages$Users$Hisense$TimeSeq$viewPriceTable(
						{hi: bodyProducts, hB: headerDateTimes})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hisense$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hisense$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$Hisense$TvHour$pProductPriceRows = function (model) {
	var stores = A2(
		$elm$core$List$concatMap,
		function ($) {
			return $.aN;
		},
		A2(
			$elm$core$List$filter,
			function (storeGroup) {
				return A2($elm$core$Set$member, storeGroup.iv, model.L) && (!$elm$core$List$isEmpty(storeGroup.aN));
			},
			model.X));
	var products = model.kn;
	return A2(
		$elm$core$List$indexedMap,
		function (ind) {
			return function (product) {
				var lowestPrice = A3(
					$elm$core$List$foldl,
					function (price) {
						return function (m) {
							return A2($elm$core$Basics$min, m, price);
						};
					},
					A2($elm$core$Basics$pow, 2, 30),
					A2(
						$elm$core$List$map,
						function (maybePrice) {
							if (!maybePrice.$) {
								var price = maybePrice.a;
								return price.fH ? price.be : A2($elm$core$Basics$pow, 2, 30);
							} else {
								return A2($elm$core$Basics$pow, 2, 30);
							}
						},
						A2(
							$elm$core$List$map,
							function (store) {
								return A2(
									$elm$core$Dict$get,
									_Utils_Tuple2(product.kl, store.iw),
									model.cQ);
							},
							stores)));
				var itemList = _List_fromArray(
					[
						{jP: '税抜き', m: 0},
						{jP: '税込み', m: 1},
						{jP: 'P/クーポン', m: 2},
						{jP: 'P後', m: 3},
						{jP: '取得時刻', m: 4}
					]);
				var filterItemList = function (list) {
					return A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								{jP: '', m: -1},
								A2($elm_community$list_extra$List$Extra$getAt, i, list));
						},
						A2(
							$elm$core$Maybe$withDefault,
							_Utils_Tuple2(
								'DisplayAll',
								_List_fromArray(
									[0, 1, 2, 3, 4])),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (dispToValue) {
									return _Utils_eq(dispToValue.a, model.c_);
								},
								$author$project$Pages$Users$Common$Default$displayStyleToValues)).b);
				};
				var filteredItemList = filterItemList(itemList);
				var _v0 = {ls: product.ls, lt: product.lt, eY: product.eY, cb: product.cb};
				var basePrice = _v0.lt;
				var basePriceIncludeTax = _v0.eY;
				var basePoint = _v0.ls;
				var basePriceWithoutPoint = _v0.cb;
				var basePriceList = _List_fromArray(
					[
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePrice)),
						m: 0
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceIncludeTax)),
						m: 1
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePoint)),
						m: 2
					},
						{
						jP: $author$project$Utils$Helpers$toCommmaSplited(
							$elm$core$String$fromInt(basePriceWithoutPoint)),
						m: 3
					},
						{jP: '-', m: 4}
					]);
				var filteredBasePriceList = filterItemList(basePriceList);
				return _Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{
									jP: $elm$core$String$fromInt(ind + 1),
									m: 0
								}
								])),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(
							_List_fromArray(
								[
									{jP: product.nk, m: 0}
								])),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(filteredItemList),
							$author$project$Pages$Users$Common$Default$ProductPriceHeader(filteredBasePriceList)
						]),
					A2(
						$elm$core$List$map,
						function (store) {
							var maybePrice = A2(
								$elm$core$Dict$get,
								_Utils_Tuple2(product.kl, store.iw),
								model.cQ);
							var isLowest = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_eq(price.be, lowestPrice);
								} else {
									return false;
								}
							}();
							var isLowestButHigherThanBase = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return isLowest && (_Utils_cmp(lowestPrice, product.cb) > -1);
								} else {
									return false;
								}
							}();
							var isLower = function () {
								if (!maybePrice.$) {
									var price = maybePrice.a;
									return _Utils_cmp(price.be, product.cb) < 0;
								} else {
									return false;
								}
							}();
							if (!maybePrice.$) {
								var price = maybePrice.a;
								var priceList = _List_fromArray(
									[
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kg)),
										m: 0
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.kh)),
										m: 1
									},
										{
										jP: function (point) {
											return _Utils_ap(
												point,
												(!price.i9) ? '' : (' / ' + $elm$core$String$fromInt(price.i9)));
										}(
											$elm$core$String$fromInt(price.ka)),
										m: 2
									},
										{
										jP: $author$project$Utils$Helpers$toCommmaSplited(
											$elm$core$String$fromInt(price.be)),
										m: 3
									},
										{
										jP: A2(
											$elm$core$Maybe$withDefault,
											'',
											$elm$core$List$head(
												A2(
													$elm$core$Maybe$withDefault,
													_List_Nil,
													$elm$core$List$tail(
														A2($elm$core$String$split, ' ', price.lP))))),
										m: 4
									}
									]);
								var filteredPriceList = filterItemList(priceList);
								return $author$project$Pages$Users$Common$Default$ProductPriceData(
									{fH: price.fH, hL: isLower, hN: isLowest, jL: isLowestButHigherThanBase, h6: filteredPriceList, eD: price.eD});
							} else {
								return $author$project$Pages$Users$Common$Default$ProductPriceNoData;
							}
						},
						stores));
			};
		},
		products);
};
var $author$project$Pages$Users$Hisense$TvHour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hisense$TvHour$pStoreHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (str) {
					return {iv: -1, kS: str};
				},
				_List_fromArray(
					['#', '型番', '項目', '基準価格'])),
			A2(
				$elm$core$List$concatMap,
				function (storeGroup) {
					return A2(
						$elm$core$List$map,
						function (store) {
							return {iv: storeGroup.iv, kS: store.fh};
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Hisense$TvHour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Common$Default$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Common$Default$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Common$Default$viewDownloadCSVButton,
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lowerPriceTd')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('基準価格を下回るものはピンク')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('lowestPriceTd')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('基準価格を下回っていて，最小値の場合は赤')
							]))
					]))
			]));
};
var $author$project$Pages$Users$Hisense$TvHour$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Hisense$TvHour$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Hisense$TvHour$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Hisense$TvHour$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$Default$OnUpdateDate)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.bi,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$Default$OnUpdateTime)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$Default$OnSubmit)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$Default$OnSubmitLatest)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
							]))
					])),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				model.dP ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('hisense')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$Hisense$TvHour$viewTableControl(model),
						$author$project$Pages$Users$Common$Default$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$Hisense$TvHour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Hisense$TvHour$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$JvcComnet$Amazon$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$JvcComnet$Amazon$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Button$button,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Button$primary,
			$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$Amazon$OnPressDownloadCSV)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
		]));
var $author$project$Pages$Users$JvcComnet$Amazon$viewTableBody = F2(
	function (bodyProducts, singleColumn) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tbody,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (productList) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$tr,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (product) {
								switch (product.$) {
									case 0:
										var storeName = product.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('colStoreHeader')
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(storeName)
												]));
									case 1:
										var cell = product.a;
										var priceChangingTypeClass = function () {
											var _v2 = cell.ge;
											switch (_v2.$) {
												case 0:
													return 'increasedPriceTd';
												case 1:
													return 'decreasedPriceTd';
												default:
													return '';
											}
										}();
										var comparedPriceTypeClass = function () {
											var _v1 = cell.du;
											switch (_v1) {
												case 0:
													return 'lowestPriceTd';
												case 1:
													return 'lowerPriceTd';
												case 2:
													return 'lowestButHigherThanBasePriceTd';
												default:
													return '';
											}
										}();
										return singleColumn ? A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceTypeClass),
													$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$a,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$href(cell.eD),
																	$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(cell.kg)
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$a,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$href(cell.eD),
																	$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(cell.be)
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(cell.ka)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$a,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$href(cell.eD),
																	$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(cell.be)
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(cell.lP)
														]))
												])) : A2(
											$rtfeldman$elm_css$Html$Styled$td,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceTypeClass),
													$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$a,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$href(cell.eD),
																	$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(cell.be)
																]))
														]))
												]));
									default:
										return A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil);
								}
							},
							productList));
				},
				bodyProducts));
	});
var $author$project$Pages$Users$JvcComnet$Amazon$viewTableHeader = function (headerDateTimes) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader')
					]),
				A2(
					$elm$core$List$map,
					function (datetime) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(datetime)
								]));
					},
					headerDateTimes))
			]));
};
var $author$project$Pages$Users$JvcComnet$Amazon$viewPriceTable = F2(
	function (priceTableRequired, singleColumn) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('priceTableContainer')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
							A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:1;cols:1')
						]),
					_List_fromArray(
						[
							$author$project$Pages$Users$JvcComnet$Amazon$viewTableHeader(priceTableRequired.hB),
							A2($author$project$Pages$Users$JvcComnet$Amazon$viewTableBody, priceTableRequired.hi, singleColumn)
						]))
				]));
	});
var $author$project$Pages$Users$JvcComnet$Amazon$Nop = {$: 18};
var $author$project$Pages$Users$JvcComnet$Amazon$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$OnChangeSingleColumnFlag = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$OnSubmit = {$: 11};
var $author$project$Pages$Users$JvcComnet$Amazon$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$JvcComnet$Amazon$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$Amazon$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$Amazon$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$JvcComnet$Amazon$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$JvcComnet$Amazon$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$JvcComnet$Amazon$OnUpdateDateFrom),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$disabled(model.ak)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$Amazon$OnUpdateTimeFrom),
								$rtfeldman$elm_css$Html$Styled$Attributes$disabled(model.ak)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$JvcComnet$Amazon$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$Amazon$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.ak),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$Events$on,
										'click',
										A2($elm$json$Json$Decode$map, $author$project$Pages$Users$JvcComnet$Amazon$OnChangeSingleColumnFlag, $rtfeldman$elm_css$Html$Styled$Events$targetChecked))
									]))
							]),
						'1列だけ表示')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$Amazon$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$JvcComnet$Amazon$viewContent = function (model) {
	var headerDateTimes = A4(
		$author$project$Pages$Users$JvcComnet$Amazon$pStoreHeader,
		A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
		A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
		model.ac,
		model.ak);
	var currentProduct = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Helpers$defaultProduct,
		A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kl;
				},
				$elm$core$Basics$eq(
					A2($elm$core$Maybe$withDefault, '', model.ep))),
			model.kn));
	var bodyProducts = A4(
		$author$project$Pages$Users$JvcComnet$Amazon$pProductPriceRows,
		model.kn,
		$elm$core$List$length(headerDateTimes),
		model.cQ,
		currentProduct.eY);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$JvcComnet$Amazon$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mb-3')
							]),
						_List_fromArray(
							[
								$author$project$Pages$Users$JvcComnet$Amazon$viewDownloadCSVButton,
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowerPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を下回るものはピンク')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowestButHigherThanBasePriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を上回っているが最小値の場合は緑')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowestPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を下回っていて，最小値の場合は赤')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('decreasedPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('価格が低くなったら赤枠')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('increasedPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('価格が高くなったら青枠')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Pages$Users$JvcComnet$Amazon$viewPriceTable,
						{hi: bodyProducts, hB: headerDateTimes},
						model.ak)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$JvcComnet$Amazon$view = function (model) {
	return {
		lI: $author$project$Pages$Users$JvcComnet$Amazon$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 Amazon';
			}
		}()
	};
};
var $author$project$Pages$Users$JvcComnet$Default$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$JvcComnet$Default$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$JvcComnet$Default$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$JvcComnet$Default$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$JvcComnet$Default$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$JvcComnet$Default$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$JvcComnet$Default$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$OnSubmit = {$: 8};
var $author$project$Pages$Users$JvcComnet$Default$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$JvcComnet$Default$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$Default$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$Default$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$JvcComnet$Default$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$Default$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$Default$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$Default$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$JvcComnet$Default$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$JvcComnet$Default$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$JvcComnet$Default$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$JvcComnet$Default$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$Default$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$JvcComnet$Default$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$JvcComnet$Default$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$JvcComnet$Default$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$JvcComnet$Default$OnChangeUsingYodobashiBasePrice = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$JvcComnet$Default$viewYodobashiBasePriceCheckbox = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('基準価格')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.eE),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$Events$on,
										'click',
										A2($elm$json$Json$Decode$map, $author$project$Pages$Users$JvcComnet$Default$OnChangeUsingYodobashiBasePrice, $rtfeldman$elm_css$Html$Styled$Events$targetChecked))
									]))
							]),
						'ヨドバシ価格を使用')
					]))
			]));
};
var $author$project$Pages$Users$JvcComnet$Default$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$JvcComnet$Default$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$JvcComnet$Default$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$JvcComnet$Default$viewYodobashiBasePriceCheckbox(model),
				$author$project$Pages$Users$JvcComnet$Default$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$JvcComnet$Default$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$JvcComnet$Default$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$JvcComnet$Default$viewTableControl(model),
							$author$project$Pages$Users$JvcComnet$Default$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$JvcComnet$Default$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$JvcComnet$Default$viewContent, model, $author$project$Pages$Users$JvcComnet$Default$pStoreGroupsHeader, $author$project$Pages$Users$JvcComnet$Default$pStoreHeader, $author$project$Pages$Users$JvcComnet$Default$pProductPriceRows);
};
var $author$project$Pages$Users$JvcComnet$Default$view = function (model) {
	return {
		lI: $author$project$Pages$Users$JvcComnet$Default$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$OnSubmit = {$: 7};
var $author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateDateAfter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateDateBefore = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateTimeAfter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateTimeBefore = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$viewForms = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('前回日付')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.az),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateDateBefore)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('前回時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.ai,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.ai),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateTimeBefore)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('今回日付')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.ay),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateDateAfter)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('今回時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.ah,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.ah),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$PriceDrop$OnUpdateTimeAfter)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$PriceDrop$OnSubmit),
						$frandibar$elm_bootstrap$Bootstrap$Button$disabled((model.az === '') || ((model.ai === '') || ((model.ay === '') || (model.ah === ''))))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$viewTransferedPriceTableBody = F2(
	function (stores, uniquePriceDrops) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tbody,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (store) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$tr,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$rtfeldman$elm_css$Html$Styled$th,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class(
										'storeGroupHeader' + $elm$core$String$fromInt(store.iv))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(store.kS)
									])),
							A3(
								$elm$core$List$foldr,
								F2(
									function (uniquePriceDrop, acc) {
										var maybePriceDrop = A2(
											$elm_community$list_extra$List$Extra$find,
											function (drop) {
												return _Utils_eq(drop.kS, store.fh);
											},
											uniquePriceDrop.jh);
										if (!maybePriceDrop.$) {
											var priceDrop = maybePriceDrop.a;
											var priceToHTML = function (price) {
												return $rtfeldman$elm_css$Html$Styled$text(
													$author$project$Utils$Helpers$toCommmaSplited(
														$elm$core$String$fromInt(price)));
											};
											return A2(
												$elm$core$List$cons,
												A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_Nil,
													_List_fromArray(
														[
															priceToHTML(priceDrop.gd)
														])),
												A2(
													$elm$core$List$cons,
													A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																priceToHTML(priceDrop.gc)
															])),
													acc));
										} else {
											return A2(
												$elm$core$List$cons,
												A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('-')
														])),
												A2(
													$elm$core$List$cons,
													A2(
														$rtfeldman$elm_css$Html$Styled$td,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('-')
															])),
													acc));
										}
									}),
								_List_Nil,
								uniquePriceDrops)));
				},
				stores));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$height = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$viewTransferedPriceTableHeader = function (uniquePriceDrops) {
	var productNamesHeader = A2(
		$elm$core$List$map,
		function (uniquePriceDrop) {
			return A2(
				$rtfeldman$elm_css$Html$Styled$th,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$colspan(2),
						$rtfeldman$elm_css$Html$Styled$Attributes$height(70)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(uniquePriceDrop.nk)
					]));
		},
		uniquePriceDrops);
	var pricesHeader = A3(
		$elm$core$List$foldr,
		F2(
			function (_v0, acc) {
				return A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$th,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('前回')
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('今回')
								])),
						acc));
			}),
		_List_Nil,
		uniquePriceDrops);
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$rtfeldman$elm_css$Html$Styled$th,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(2)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('店名')
							])),
					productNamesHeader)),
				A2($rtfeldman$elm_css$Html$Styled$tr, _List_Nil, pricesHeader)
			]));
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$viewTransferedPriceTable = F2(
	function (stores, uniquePriceDrops) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$table,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:2;cols:1'),
					$rtfeldman$elm_css$Html$Styled$Attributes$class('drop')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$JvcComnet$PriceDrop$viewTransferedPriceTableHeader(uniquePriceDrops),
					A2($author$project$Pages$Users$JvcComnet$PriceDrop$viewTransferedPriceTableBody, stores, uniquePriceDrops)
				]));
	});
var $author$project$Pages$Users$JvcComnet$PriceDrop$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$JvcComnet$PriceDrop$viewForms(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Pages$Users$JvcComnet$PriceDrop$viewTransferedPriceTable, model.aN, model.dg)
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$viewContentDefault = function (model) {
	return $author$project$Pages$Users$JvcComnet$PriceDrop$viewContent(model);
};
var $author$project$Pages$Users$JvcComnet$PriceDrop$view = function (model) {
	return {
		lI: $author$project$Pages$Users$JvcComnet$PriceDrop$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '値下がり';
			}
		}()
	};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$JvcComnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Button$button,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Button$primary,
			$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$TimeSeq$OnPressDownloadCSV)
		]),
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
		]));
var $author$project$Pages$Users$JvcComnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (productList) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (product) {
							switch (product.$) {
								case 0:
									var storeName = product.a;
									return A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('colStoreHeader')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(storeName)
											]));
								case 1:
									var cell = product.a;
									var priceChangingTypeClass = function () {
										var _v2 = cell.ge;
										switch (_v2.$) {
											case 0:
												return 'increasedPriceTd';
											case 1:
												return 'decreasedPriceTd';
											default:
												return '';
										}
									}();
									var comparedPriceTypeClass = function () {
										var _v1 = cell.du;
										switch (_v1) {
											case 0:
												return 'lowestPriceTd';
											case 1:
												return 'lowerPriceTd';
											case 2:
												return 'lowestButHigherThanBasePriceTd';
											default:
												return '';
										}
									}();
									return A2(
										$rtfeldman$elm_css$Html$Styled$td,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceTypeClass),
												$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(cell.be))
											]));
								default:
									return A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil);
							}
						},
						productList));
			},
			bodyProducts));
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$viewTableHeader = function (headerDateTimes) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$tr,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('rowHeader')
					]),
				A2(
					$elm$core$List$map,
					function (datetime) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$th,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(datetime)
								]));
					},
					headerDateTimes))
			]));
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('priceTableContainer')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:1;cols:1')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$JvcComnet$TimeSeq$viewTableHeader(priceTableRequired.hB),
						$author$project$Pages$Users$JvcComnet$TimeSeq$viewTableBody(priceTableRequired.hi)
					]))
			]));
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnChangeProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex position-relative flex-column align-items-start mr-3 ')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A5(
						$author$project$Components$CategorySelector$productSelector,
						model.kn,
						model.ig,
						model.gD,
						model.ih,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$TimeSeq$OnChangeProduct),
								$rtfeldman$elm_css$Html$Styled$Attributes$required(true)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('form-err-msg')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								(model.dQ && $elm_community$maybe_extra$Maybe$Extra$isNothing(model.ih)) ? '商品を選択してください' : '')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$JvcComnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$JvcComnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$viewContent = function (model) {
	var headerDateTimes = A3(
		$author$project$Pages$Users$JvcComnet$TimeSeq$pStoreHeader,
		A2($author$project$Utils$Helpers$dateTimeToParts, model.en, model.eq),
		A2($author$project$Utils$Helpers$dateTimeToParts, model.eo, model.er),
		model.ac);
	var currentProduct = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Helpers$defaultProduct,
		A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kl;
				},
				$elm$core$Basics$eq(
					A2($elm$core$Maybe$withDefault, '', model.ep))),
			model.kn));
	var bodyProducts = A4(
		$author$project$Pages$Users$JvcComnet$TimeSeq$pProductPriceRows,
		model.aN,
		$elm$core$List$length(headerDateTimes),
		model.cQ,
		currentProduct.eY);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$JvcComnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mb-3')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('モデル:\u3000\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(currentProduct.nk)
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格:\u3000')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(currentProduct.eY))
													]))
											]))
									])),
								$author$project$Pages$Users$JvcComnet$TimeSeq$viewDownloadCSVButton,
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowerPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を下回るものはピンク')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowestButHigherThanBasePriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を上回っているが最小値の場合は緑')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('lowestPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格を下回っていて，最小値の場合は赤')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-5'),
												$rtfeldman$elm_css$Html$Styled$Attributes$class('description')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('decreasedPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('価格が低くなったら赤枠')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('increasedPriceTd')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('価格が高くなったら青枠')
													]))
											]))
									]))
							])),
						$author$project$Pages$Users$JvcComnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, hB: headerDateTimes})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$JvcComnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$JvcComnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateAllProducts = {$: 9};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateCouponTriggerFlag = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdatePointTriggerFlag = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$Drop = {$: 13};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$KinujoComnet$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$KinujoComnet$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$KinujoComnet$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$KinujoComnet$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$KinujoComnet$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$KinujoComnet$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.bZ),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdatePointTriggerFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.bZ),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateCouponTriggerFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$KinujoComnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table tescom-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('ヨドバシを')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格に')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('トリガーを')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('P算入後に')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('トリガーを')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('クーポン算入後に')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$KinujoComnet$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$KinujoComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$KinujoComnet$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$KinujoComnet$Excel$Nop = {$: 13};
var $author$project$Pages$Users$KinujoComnet$Excel$OnChangeBigCategory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$OnChangeSmallCategory = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$OnSubmit = {$: 10};
var $author$project$Pages$Users$KinujoComnet$Excel$OnUpdateDateFrom = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$OnUpdateDateTo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$OnUpdateTimeFrom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$OnUpdateTimeTo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Excel$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$KinujoComnet$Excel$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$KinujoComnet$Excel$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$KinujoComnet$Excel$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$KinujoComnet$Excel$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$KinujoComnet$Excel$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$KinujoComnet$Excel$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$KinujoComnet$Excel$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$KinujoComnet$Excel$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$KinujoComnet$Excel$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$KinujoComnet$Excel$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$KinujoComnet$Excel$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Users$KinujoComnet$Excel$view = function (model) {
	return {
		lI: $author$project$Pages$Users$KinujoComnet$Excel$viewContent(model),
		iB: 'エクセル出力'
	};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$KinujoComnet$Fifteen$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$KinujoComnet$Fifteen$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnSubmit = {$: 8};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$KinujoComnet$Fifteen$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$KinujoComnet$Fifteen$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$KinujoComnet$Fifteen$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$KinujoComnet$Fifteen$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$KinujoComnet$Fifteen$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$KinujoComnet$Fifteen$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$KinujoComnet$Fifteen$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$KinujoComnet$Fifteen$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$KinujoComnet$Fifteen$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$KinujoComnet$Fifteen$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$KinujoComnet$Fifteen$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$KinujoComnet$Fifteen$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$KinujoComnet$Fifteen$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$KinujoComnet$Fifteen$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$KinujoComnet$Fifteen$viewTableControl(model),
							$author$project$Pages$Users$KinujoComnet$Fifteen$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$KinujoComnet$Fifteen$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$KinujoComnet$Fifteen$viewContent, model, $author$project$Pages$Users$KinujoComnet$Fifteen$pStoreGroupsHeader, $author$project$Pages$Users$KinujoComnet$Fifteen$pStoreHeader, $author$project$Pages$Users$KinujoComnet$Fifteen$pProductPriceRows);
};
var $author$project$Pages$Users$KinujoComnet$Fifteen$view = function (model) {
	return {
		lI: $author$project$Pages$Users$KinujoComnet$Fifteen$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$MlnComnet$AutoReload$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$MlnComnet$AutoReload$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$MlnComnet$AutoReload$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$MlnComnet$AutoReload$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$MlnComnet$AutoReload$OnChangeDisplayStyle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$AutoReload$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column mr-3')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$MlnComnet$AutoReload$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$MlnComnet$AutoReload$OnPressDownloadCSV = {$: 4};
var $author$project$Pages$Users$MlnComnet$AutoReload$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$AutoReload$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$MlnComnet$AutoReload$OnChangeSortOption = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$Types$ProductOrderAsc = 2;
var $author$project$Components$Molecules$SortTableSelector$decodeSortOption = function (sortOption) {
	switch (sortOption) {
		case 'release-date-desc':
			return $elm$core$Maybe$Just(0);
		case 'product-name-asc':
			return $elm$core$Maybe$Just(1);
		case 'product-order-asc':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Molecules$SortTableSelector$encodeSortOption = function (sortOption) {
	switch (sortOption) {
		case 0:
			return 'release-date-desc';
		case 1:
			return 'product-name-asc';
		default:
			return 'product-order-asc';
	}
};
var $author$project$Components$Molecules$SortTableSelector$toStringSortOption = function (sortOption) {
	switch (sortOption) {
		case 0:
			return '登録日順';
		case 1:
			return '形名順';
		default:
			return '並び順';
	}
};
var $author$project$Components$Molecules$SortTableSelector$sortOptions = _List_fromArray(
	[
		_Utils_Tuple2(
		$author$project$Components$Molecules$SortTableSelector$encodeSortOption(0),
		$author$project$Components$Molecules$SortTableSelector$toStringSortOption(0)),
		_Utils_Tuple2(
		$author$project$Components$Molecules$SortTableSelector$encodeSortOption(1),
		$author$project$Components$Molecules$SortTableSelector$toStringSortOption(1)),
		_Utils_Tuple2(
		$author$project$Components$Molecules$SortTableSelector$encodeSortOption(2),
		$author$project$Components$Molecules$SortTableSelector$toStringSortOption(2))
	]);
var $author$project$Components$Molecules$SortTableSelector$sortTableSelector = function (props) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
		_List_fromArray(
			[
				A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$disabled(true),
				function (onChange) {
					return $frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Components$Molecules$SortTableSelector$decodeSortOption,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$withDefault(0),
								onChange)));
				},
				props.j3),
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(_List_Nil)
			]),
		A2(
			$elm$core$List$map,
			function (_v0) {
				var v = _v0.a;
				var label = _v0.b;
				return A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(
								v,
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$Components$Molecules$SortTableSelector$encodeSortOption(0),
									$author$project$Components$Molecules$SortTableSelector$encodeSortOption,
									props.kG)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(label)
						]));
			},
			$author$project$Components$Molecules$SortTableSelector$sortOptions));
};
var $author$project$Pages$Users$MlnComnet$AutoReload$viewSortSelector = function (selectedSortOption) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示順')
					])),
				$author$project$Components$Molecules$SortTableSelector$sortTableSelector(
				{
					j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$AutoReload$OnChangeSortOption),
					kG: $elm$core$Maybe$Just(selectedSortOption)
				})
			]));
};
var $author$project$Pages$Users$MlnComnet$AutoReload$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$MlnComnet$AutoReload$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$viewTableControl = F4(
	function (storeGroups, visibleStoreGroups, selectedDisplayStyle, selectedSortOption) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$form,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$Users$MlnComnet$AutoReload$viewStoreGroupCheckbox, storeGroups, visibleStoreGroups),
					$author$project$Pages$Users$MlnComnet$AutoReload$viewDisplayStyleSelector(selectedDisplayStyle),
					$author$project$Pages$Users$MlnComnet$AutoReload$viewSortSelector(selectedSortOption),
					$author$project$Pages$Users$MlnComnet$AutoReload$viewDownloadCSVButton
				]));
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.bR;
					switch (_v0.$) {
						case 0:
							return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
						case 1:
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Loading$loading(30.0)
									]));
						case 3:
							var res = _v0.a;
							var headerStores = A2(pStoreHeader_, res.X, model.L);
							var headerStoreGroups = A2(pStoreGroupsHeader_, res.X, model.L);
							var bodyProducts = A4(pProductPriceRows_, res, model.L, model.c_, model.kG);
							return A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A4($author$project$Pages$Users$MlnComnet$AutoReload$viewTableControl, res.X, model.L, model.c_, model.kG),
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row description')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 lowerPriceTd')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('参考価格を下回る')
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 lowestPriceTd')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('当該機種の最低価格')
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 lowestButHigherThanBasePriceTd')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('最低価格だが参考価格より上')
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 pastPriceTd')
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('当該時刻に取得できず参考として前回価格を表示')
															]))
													]))
											])),
										$author$project$Pages$Users$MlnComnet$AutoReload$viewPriceTable(
										{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
									]));
						default:
							var e = _v0.a;
							return A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(e)
									]));
					}
				}()
				]));
	});
var $author$project$Pages$Users$MlnComnet$AutoReload$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$MlnComnet$AutoReload$viewContent, model, $author$project$Pages$Users$MlnComnet$AutoReload$pStoreGroupsHeader, $author$project$Pages$Users$MlnComnet$AutoReload$pStoreHeader, $author$project$Pages$Users$MlnComnet$AutoReload$pProductPriceRows);
};
var $author$project$Pages$Users$MlnComnet$AutoReload$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$AutoReload$viewContentDefault(model),
		iB: 'WEB価格(自動更新)'
	};
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$OnChangeSelectedSortOption = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$OnInputQuery = function (a) {
	return {$: 1, a: a};
};
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled(
			fn(arg));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$lazy = F2(
	function (fn, arg) {
		return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
			A3($elm$virtual_dom$VirtualDom$lazy2, $rtfeldman$elm_css$VirtualDom$Styled$lazyHelp, fn, arg));
	});
var $rtfeldman$elm_css$Html$Styled$Lazy$lazy = $rtfeldman$elm_css$VirtualDom$Styled$lazy;
var $author$project$Pages$Users$MlnComnet$ChangeMail$OnChangeMail = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMail$UpdateMail = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$Email = 8;
var $frandibar$elm_bootstrap$Bootstrap$Form$Input$email = $frandibar$elm_bootstrap$Bootstrap$Form$Input$input(8);
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Info = 3;
var $frandibar$elm_bootstrap$Bootstrap$Button$info = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled(3));
var $author$project$Pages$Users$MlnComnet$ChangeMail$viewTr = function (pm) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(pm.bL.nk)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '600px')
					]),
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$email(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(pm.bF),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('form-control-emph')
									])),
								(pm.bF === '') ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(_List_Nil) : ($author$project$Pages$Users$MlnComnet$ChangeMail$validateEmails(pm.bF) ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$success : $frandibar$elm_bootstrap$Bootstrap$Form$Input$danger),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
								A2($author$project$Pages$Users$MlnComnet$ChangeMail$OnChangeMail, pm.bL.kl, 0))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '600px')
					]),
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$email(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(pm.bG),
								(pm.bG === '') ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(_List_Nil) : ($author$project$Pages$Users$MlnComnet$ChangeMail$validateEmails(pm.bG) ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$success : $frandibar$elm_bootstrap$Bootstrap$Form$Input$danger),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
								A2($author$project$Pages$Users$MlnComnet$ChangeMail$OnChangeMail, pm.bL.kl, 1))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '60px')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$info,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
								A3($author$project$Pages$Users$MlnComnet$ChangeMail$UpdateMail, pm.bL.kl, pm.bF, pm.bG))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('更新')
							]))
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$viewKeyedTr = function (pm) {
	return _Utils_Tuple2(
		pm.bL.kl,
		A2($rtfeldman$elm_css$Html$Styled$Lazy$lazy, $author$project$Pages$Users$MlnComnet$ChangeMail$viewTr, pm));
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.fC;
				switch (_v0.$) {
					case 0:
						return $author$project$Components$Loading$loadingCenter(50.0);
					case 1:
						return $author$project$Components$Loading$loadingCenter(50.0);
					case 2:
						var e = _v0.a;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Utils$Helpers$errToStr(e))
								]));
					default:
						var res = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1500px')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-2 d-flex flex-direction-row justify-content-between')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-direction-row align-items-center mr-3')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-2')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('検索:')
														])),
													$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
													_List_fromArray(
														[
															$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '400px')
																])),
															$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$ChangeMail$OnInputQuery)
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-direction-row align-items-center ')
												]),
											_List_fromArray(
												[
													$author$project$Components$Molecules$SortTableSelector$sortTableSelector(
													{
														j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$ChangeMail$OnChangeSelectedSortOption),
														kG: $elm$core$Maybe$Just(model.kG)
													})
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table nonscroll')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('形名')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '600px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('送信先アドレス(4回)')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '600px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('送信先アドレス(1時間ごと)')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '60px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('更新')
																]))
														]))
												])),
											A3(
											$rtfeldman$elm_css$Html$Styled$Keyed$node,
											'tbody',
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (pm) {
													return $author$project$Pages$Users$MlnComnet$ChangeMail$viewKeyedTr(pm);
												},
												A2(
													$elm$core$List$filter,
													function (pm) {
														return (model.bN === '') ? true : (A2(
															$elm$core$String$contains,
															$elm$core$String$toLower(model.bN),
															$elm$core$String$toLower(pm.bL.nk)) ? true : (A2(
															$elm$core$List$any,
															function (mail) {
																return A2(
																	$elm$core$String$contains,
																	$elm$core$String$toLower(model.bN),
																	$elm$core$String$toLower(mail));
															},
															A2($elm$core$String$split, ',', pm.bF)) ? true : (A2(
															$elm$core$List$any,
															function (mail) {
																return A2(
																	$elm$core$String$contains,
																	$elm$core$String$toLower(model.bN),
																	$elm$core$String$toLower(mail));
															},
															A2($elm$core$String$split, ',', pm.bG)) ? true : false)));
													},
													A2(
														$elm$core$List$sortWith,
														F2(
															function (pm1, pm2) {
																return A3($author$project$Utils$Helpers$compareProductBySortOption, model.kG, pm1.bL, pm2.bL);
															}),
														res.gg))))
										]))
								]));
				}
			}()
			]));
};
var $author$project$Pages$Users$MlnComnet$ChangeMail$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$ChangeMail$viewContent(model),
		iB: '送信先設定'
	};
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$OnChangeMailAddress = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$OnChangeSortOption = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$ToggleShowOnlyBasePriceProduct = {$: 12};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$ToggleShowOnlyMailEnabled = {$: 13};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$alertedProductsNum = function (model) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (p) {
				return p.dZ;
			},
			model.kn));
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$mailAddressSelector = F3(
	function (mailAddresses, selectedMailId, attrs) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									$elm_community$maybe_extra$Maybe$Extra$isNothing(selectedMailId))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('アドレスを選択してください')
								])),
						A2(
							$elm$core$List$map,
							function (mailAddress) {
								return A2(
									$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(mailAddress.mF)),
											$rtfeldman$elm_css$Html$Styled$Attributes$selected(
											_Utils_eq(
												A2($elm$core$Maybe$withDefault, -1, selectedMailId),
												mailAddress.mF))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(mailAddress.jU)
										]));
							},
							mailAddresses)))
				]));
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$OnUpdateMailEnabledFour = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$OnUpdateMailEnabledOnce = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$viewTr = F3(
	function (model, product, ind) {
		var isMailDisabled = _Utils_eq(
			model.aA,
			$elm$core$Maybe$Just(-1)) || _Utils_eq(model.aA, $elm$core$Maybe$Nothing);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(ind + 1))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px')
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.dZ),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$MlnComnet$ChangeMailTest$OnUpdateMailEnabledFour(ind)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(isMailDisabled)
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px')
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.jV),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$MlnComnet$ChangeMailTest$OnUpdateMailEnabledOnce(ind)),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(isMailDisabled)
								]),
							'')
						]))
				]));
	});
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				model.cv ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-3 d-flex flex-row align-items-end')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('メールアドレス')
											])),
										A3(
										$author$project$Pages$Users$MlnComnet$ChangeMailTest$mailAddressSelector,
										model.gg,
										model.aA,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$ChangeMailTest$OnChangeMailAddress)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('検索')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bN),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$ChangeMailTest$OnChangeQuery)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('show-only-having-baseprice'),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
												$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMailTest$ToggleShowOnlyBasePriceProduct)),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.c4)
											]),
										'基準価格入のみ表示'),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('show-only-mail-enalbed'),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
												$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeMailTest$ToggleShowOnlyMailEnabled)),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.aC)
											]),
										'アラート対象のみ表示')
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										'アラート対象の型番数：' + $elm$core$String$fromInt(
											$author$project$Pages$Users$MlnComnet$ChangeMailTest$alertedProductsNum(model)))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$px(300)),
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$px(10))
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Molecules$SortTableSelector$sortTableSelector(
								{
									j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$ChangeMailTest$OnChangeSortOption),
									kG: $elm$core$Maybe$Just(model.kG)
								})
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table nonscroll')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'white-space', 'pre-line')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														'No.\n(totla:' + ($elm$core$String$fromInt(
															$elm$core$List$length(
																$author$project$Pages$Users$MlnComnet$ChangeMailTest$filteredProducts(model))) + ')'))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('形名')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'white-space', 'pre-line')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('メール(4回)\n有効化')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'white-space', 'pre-line')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('メール(1回)\n有効化')
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (product) {
											return A3($author$project$Pages$Users$MlnComnet$ChangeMailTest$viewTr, model, product, ind);
										};
									},
									$author$project$Pages$Users$MlnComnet$ChangeMailTest$sortedFilteredProducts(model)))
							]))
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$ChangeMailTest$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$ChangeMailTest$viewContent(model),
		iB: '価格/アラート設定'
	};
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$SubmitForm = {$: 3};
var $author$project$Pages$Users$MlnComnet$ChangePassword$UpdateCurrentPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$UpdateNewPassword = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$UpdateRetypedNewPassword = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$validateForm = function (model) {
	return (!_Utils_eq(model.a9, model.ef)) ? $elm$core$Result$Err('パスワードが一致しません') : (((model.a9 !== '') && (!function (reg) {
		return A2($elm$regex$Regex$contains, reg, model.a9);
	}(
		A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			$elm$regex$Regex$fromString('^[0-9a-zA-Z]{6,}$'))))) ? $elm$core$Result$Err('パスワードは6文字以上の英数字です') : $elm$core$Result$Ok(0));
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$viewContent = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('mx-auto ml-3 mr-3 mb-5 w-1 col-lg-4')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$ul,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-5 ')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('パスワードを入力し送信ボタンを押してください。')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('パスワードには半角英数字が使用可能です。（6字以上）')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('パスワード失念時は、営企部業務G宛にお問い合わせください。')
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('現在のパスワード')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$password(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.dv),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$ChangePassword$UpdateCurrentPassword)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('新しいパスワード')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$password(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.a9),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$ChangePassword$UpdateNewPassword)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('新しいパスワード(確認)')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$password(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.ef),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$ChangePassword$UpdateRetypedNewPassword)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Pages$Users$MlnComnet$ChangePassword$validateForm(model);
						if (_v0.$ === 1) {
							var msg = _v0.a;
							return $rtfeldman$elm_css$Html$Styled$text(msg);
						} else {
							return $rtfeldman$elm_css$Html$Styled$text('');
						}
					}()
					])),
				function () {
				var _v1 = model.aO;
				switch (_v1.$) {
					case 3:
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('text-success')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('パスワードを更新しました')
								]));
					case 2:
						var errStr = _v1.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(errStr)
								]));
					default:
						return A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil);
				}
			}(),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$submitButton,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$ChangePassword$SubmitForm),
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('float-right')
									]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							]))
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$ChangePassword$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$ChangePassword$viewContent(model),
		iB: 'パスワードの変更'
	};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeBigCategory = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeQuery = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeSmallCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeSortOption = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateFilteredProducts = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$ToggleShowOnlyBasePriceProduct = {$: 13};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$ToggleShowOnlyMailEnabled = {$: 14};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$alertedProductsNum = function (model) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			function (p) {
				return p.bE;
			},
			model.kn));
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeBasePrice = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateBasePrice = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateMailEnabled = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$viewTr = F2(
	function (product, ind) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(ind + 1))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.bE),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateMailEnabled(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
						]),
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.cb)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '180px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$MlnComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				model.cv ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-3 d-flex flex-row align-items-end')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('大分類')
											])),
										A3(
										$author$project$Components$CategorySelector$bigCategorySelector,
										model.iW,
										model.ig,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeBigCategory)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('中分類')
											])),
										A4(
										$author$project$Components$CategorySelector$smallCategorySelector,
										model.kL,
										model.gD,
										model.ig,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeSmallCategory)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('検索')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bN),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeQuery)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('show-only-having-baseprice'),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
												$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeProduct$ToggleShowOnlyBasePriceProduct)),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.c4)
											]),
										'基準価格入のみ表示'),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('show-only-mail-enalbed'),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
												$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$ChangeProduct$ToggleShowOnlyMailEnabled)),
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.aC)
											]),
										'アラート対象のみ表示')
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										'アラート対象の型番数：' + $elm$core$String$fromInt(
											$author$project$Pages$Users$MlnComnet$ChangeProduct$alertedProductsNum(model))),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$primary,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
												$author$project$Pages$Users$MlnComnet$ChangeProduct$OnUpdateFilteredProducts(
													$author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts(model)))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('一括更新')
											]))
									]))
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$width(
										$rtfeldman$elm_css$Css$px(300)),
										$rtfeldman$elm_css$Css$marginBottom(
										$rtfeldman$elm_css$Css$px(10))
									]))
							]),
						_List_fromArray(
							[
								$author$project$Components$Molecules$SortTableSelector$sortTableSelector(
								{
									j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$ChangeProduct$OnChangeSortOption),
									kG: $elm$core$Maybe$Just(model.kG)
								})
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table nonscroll')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'white-space', 'pre-line')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text(
														'No.\n(totla:' + ($elm$core$String$fromInt(
															$elm$core$List$length(
																$author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts(model))) + ')'))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'white-space', 'pre-line')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('メール\n有効化')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('形名')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('閾値')
															])),
														A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
														A2(
														$rtfeldman$elm_css$Html$Styled$span,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text('（ポイント無し）')
															]))
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px'),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'white-space', 'pre-line')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('更新')
													]))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$indexedMap,
									function (ind) {
										return function (product) {
											return A2($author$project$Pages$Users$MlnComnet$ChangeProduct$viewTr, product, ind);
										};
									},
									A2(
										$elm$core$List$sortWith,
										$author$project$Utils$Helpers$compareProductBySortOption(model.kG),
										$author$project$Pages$Users$MlnComnet$ChangeProduct$filteredProducts(model))))
							]))
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$ChangeProduct$viewContent(model),
		iB: '価格/アラート設定'
	};
};
var $author$project$Pages$Users$MlnComnet$Chronological$Nop = {$: 52};
var $author$project$Pages$Users$MlnComnet$Chronological$OnChangeBigCategory = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnChangeSearchText = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnChangeSmallCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnChangeSnapshotName = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnClickExcelProcessingStatusModal = {$: 47};
var $author$project$Pages$Users$MlnComnet$Chronological$OnSelectProduct = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnSubmitCreateSnapshot = {$: 33};
var $author$project$Pages$Users$MlnComnet$Chronological$OnSubmitSaveSnapshot = {$: 34};
var $author$project$Pages$Users$MlnComnet$Chronological$OnUnselectProduct = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleCreateSnapshotModal = {$: 30};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleExcelProcessingStatusModal = {$: 46};
var $author$project$Pages$Users$MlnComnet$Chronological$TogglePointEnabled = {$: 24};
var $author$project$Pages$Users$MlnComnet$Chronological$TogglePriceEnabled = {$: 23};
var $author$project$Pages$Users$MlnComnet$Chronological$TogglePriceWithoutPointEnabled = {$: 25};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleProductFilterModal = {$: 48};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleUpdateSnapshotModal = {$: 31};
var $frandibar$elm_bootstrap$Bootstrap$Table$TableAttr = function (a) {
	return {$: 7, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$attr = function (attr_) {
	return $frandibar$elm_bootstrap$Bootstrap$Table$TableAttr(attr_);
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$Body = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Modal$Config = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Modal$body = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				dp: $elm$core$Maybe$Just(
					{eW: attributes, i6: children})
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Table$Bordered = {$: 2};
var $frandibar$elm_bootstrap$Bootstrap$Table$bordered = $frandibar$elm_bootstrap$Bootstrap$Table$Bordered;
var $frandibar$elm_bootstrap$Bootstrap$Table$CellAttr = function (a) {
	return {$: 2, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$cellAttr = function (attr_) {
	return $frandibar$elm_bootstrap$Bootstrap$Table$CellAttr(attr_);
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$config = function (closeMsg) {
	return {
		dp: $elm$core$Maybe$Nothing,
		dt: closeMsg,
		hw: $elm$core$Maybe$Nothing,
		fz: $elm$core$Maybe$Nothing,
		j7: {eX: _List_Nil, e5: true, dF: true, d2: $elm$core$Maybe$Nothing, gA: false},
		b2: $elm$core$Maybe$Nothing
	};
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$Footer = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Modal$footer = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				hw: $elm$core$Maybe$Just(
					{eW: attributes, i6: children})
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Modal$Header = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Modal$header = F3(
	function (attributes, children, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{
				fz: $elm$core$Maybe$Just(
					{eW: attributes, i6: children})
			});
	});
var $frandibar$elm_bootstrap$Bootstrap$Modal$titledHeader = F3(
	function (itemFn, attributes, children) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Modal$header,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					itemFn,
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_css$Html$Styled$Attributes$class('modal-title'),
						attributes),
					children)
				]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Modal$h5 = $frandibar$elm_bootstrap$Bootstrap$Modal$titledHeader($rtfeldman$elm_css$Html$Styled$h5);
var $frandibar$elm_bootstrap$Bootstrap$Table$HeadAttr = function (a) {
	return {$: 2, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$headAttr = function (attr_) {
	return $frandibar$elm_bootstrap$Bootstrap$Table$HeadAttr(attr_);
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$large = function (_v0) {
	var conf = _v0;
	var options = conf.j7;
	return _Utils_update(
		conf,
		{
			j7: _Utils_update(
				options,
				{
					d2: $elm$core$Maybe$Just(3)
				})
		});
};
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Outlined = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Button$outlineInfo = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Outlined(3));
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Components$Molecules$BigCategorySelector$Config = $elm$core$Basics$identity;
var $author$project$Components$Molecules$BigCategorySelector$custom = {iD: '全て選択'};
var $author$project$Components$Molecules$BigCategorySelector$view = F3(
	function (props, attrs, _v0) {
		var conf = _v0;
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
			_List_fromArray(
				[
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$disabled(true),
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange,
					props.j3),
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(props.ig, -1))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(conf.iD)
						])),
				A2(
					$elm$core$List$map,
					function (bigCategory) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									$elm$core$String$fromInt(bigCategory.e_)),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(props.ig, bigCategory.e_))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(bigCategory.lu)
								]));
					},
					props.iW)));
	});
var $author$project$Components$Molecules$BigCategorySelector$bigCategorySelector = F2(
	function (props, attrs) {
		return A3($author$project$Components$Molecules$BigCategorySelector$view, props, attrs, $author$project$Components$Molecules$BigCategorySelector$custom);
	});
var $rtfeldman$elm_css$Svg$Styled$Attributes$d = $rtfeldman$elm_css$VirtualDom$Styled$attribute('d');
var $rtfeldman$elm_css$Svg$Styled$Attributes$height = $rtfeldman$elm_css$VirtualDom$Styled$attribute('height');
var $rtfeldman$elm_css$VirtualDom$Styled$nodeNS = $rtfeldman$elm_css$VirtualDom$Styled$NodeNS;
var $rtfeldman$elm_css$Svg$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$nodeNS('http://www.w3.org/2000/svg');
var $rtfeldman$elm_css$Svg$Styled$path = $rtfeldman$elm_css$Svg$Styled$node('path');
var $rtfeldman$elm_css$Svg$Styled$svg = $rtfeldman$elm_css$Svg$Styled$node('svg');
var $rtfeldman$elm_css$Svg$Styled$Attributes$viewBox = $rtfeldman$elm_css$VirtualDom$Styled$attribute('viewBox');
var $rtfeldman$elm_css$Svg$Styled$Attributes$width = $rtfeldman$elm_css$VirtualDom$Styled$attribute('width');
var $author$project$Icons$CloseIcon$closeIcon = A2(
	$rtfeldman$elm_css$Svg$Styled$svg,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Svg$Styled$Attributes$viewBox('0 0 320 512'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$width('16'),
			$rtfeldman$elm_css$Svg$Styled$Attributes$height('16')
		]),
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Svg$Styled$path,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Svg$Styled$Attributes$d('M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z')
				]),
			_List_Nil)
		]));
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{m: 'column'});
var $author$project$Components$Organisms$ProductFilterModal$findProductById = F2(
	function (productId, products) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.kl;
				},
				$elm$core$Basics$eq(productId)),
			products);
	});
var $rtfeldman$elm_css$Css$flex = $rtfeldman$elm_css$Css$prop1('flex');
var $rtfeldman$elm_css$Css$flexStart = $rtfeldman$elm_css$Css$prop1('flex-start');
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$minHeight = $rtfeldman$elm_css$Css$prop1('min-height');
var $rtfeldman$elm_css$Css$minWidth = $rtfeldman$elm_css$Css$prop1('min-width');
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $author$project$Components$Molecules$SmallCategorySelector$Config = $elm$core$Basics$identity;
var $author$project$Components$Molecules$SmallCategorySelector$custom = {iD: '全て選択'};
var $author$project$Components$Molecules$SmallCategorySelector$view = F3(
	function (props, attrs, _v0) {
		var conf = _v0;
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
			_List_fromArray(
				[
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$disabled(true),
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange,
					props.j3),
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(props.gD, -1))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(conf.iD)
						])),
				A2(
					$elm$core$List$map,
					function (smallCategory) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(
									$elm$core$String$fromInt(smallCategory.ir)),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(props.gD, smallCategory.ir))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(smallCategory.nF)
								]));
					},
					A2(
						$elm$core$List$filter,
						function (smallCategory) {
							return _Utils_eq(props.ig, -1) || _Utils_eq(props.ig, smallCategory.e_);
						},
						props.kL))));
	});
var $author$project$Components$Molecules$SmallCategorySelector$smallCategorySelector = F2(
	function (props, attrs) {
		return A3($author$project$Components$Molecules$SmallCategorySelector$view, props, attrs, $author$project$Components$Molecules$SmallCategorySelector$custom);
	});
var $frandibar$elm_bootstrap$Bootstrap$Modal$StartClose = 1;
var $frandibar$elm_bootstrap$Bootstrap$Modal$getCloseMsg = function (config_) {
	var _v0 = config_.b2;
	if (!_v0.$) {
		var animationMsg = _v0.a;
		return animationMsg(1);
	} else {
		return config_.dt;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$isFade = function (conf) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (_v0) {
				return true;
			},
			conf.b2));
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$backdrop = F2(
	function (visibility, conf) {
		var attributes = function () {
			switch (visibility) {
				case 0:
					return _Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal-backdrop', true),
										_Utils_Tuple2(
										'fade',
										$frandibar$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
										_Utils_Tuple2('show', true)
									]))
							]),
						conf.j7.dF ? _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$frandibar$elm_bootstrap$Bootstrap$Modal$getCloseMsg(conf))
							]) : _List_Nil);
				case 1:
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', true)
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', true),
									_Utils_Tuple2('fade', true),
									_Utils_Tuple2('show', false)
								]))
						]);
				default:
					return _List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal-backdrop', false),
									_Utils_Tuple2(
									'fade',
									$frandibar$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
									_Utils_Tuple2('show', false)
								]))
						]);
			}
		}();
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$div, attributes, _List_Nil)
			]);
	});
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$className = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['className']),
	$elm$json$Json$Decode$string);
var $frandibar$elm_bootstrap$Bootstrap$Modal$containerClickDecoder = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (c) {
			return A2($elm$core$String$contains, 'elm-bootstrap-modal', c) ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignoring');
		},
		$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$target($frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$className));
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$display = F2(
	function (visibility, conf) {
		switch (visibility) {
			case 0:
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'pointer-events', 'none'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$frandibar$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'pointer-events', 'none'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', true)
							]))
					]);
			case 2:
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'pointer-events', 'none'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2('fade', true),
								_Utils_Tuple2('show', false)
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$on,
						'transitionend',
						$elm$json$Json$Decode$succeed(conf.dt))
					]);
			default:
				return _List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '0px'),
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'block'),
						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('modal', true),
								_Utils_Tuple2(
								'fade',
								$frandibar$elm_bootstrap$Bootstrap$Modal$isFade(conf)),
								_Utils_Tuple2('show', false)
							]))
					]);
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Modal$modalClass = function (size) {
	var _v0 = $frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size);
	if (!_v0.$) {
		var s = _v0.a;
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('modal-' + s)
			]);
	} else {
		return _List_Nil;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$modalAttributes = function (options) {
	return _Utils_ap(
		options.eX,
		_Utils_ap(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal-dialog', true),
							_Utils_Tuple2('modal-dialog-centered', options.e5),
							_Utils_Tuple2('modal-dialog-scrollable', options.gA)
						])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'pointer-events', 'auto')
				]),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $frandibar$elm_bootstrap$Bootstrap$Modal$modalClass, options.d2))));
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$renderBody = function (maybeBody) {
	if (!maybeBody.$) {
		var cfg = maybeBody.a;
		return $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modal-body'),
					cfg.eW),
				cfg.i6));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$renderFooter = function (maybeFooter) {
	if (!maybeFooter.$) {
		var cfg = maybeFooter.a;
		return $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modal-footer'),
					cfg.eW),
				cfg.i6));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$closeButton = function (closeMsg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$button,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('close'),
				$rtfeldman$elm_css$Html$Styled$Events$onClick(closeMsg)
			]),
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$text('×')
			]));
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$renderHeader = function (conf_) {
	var _v0 = conf_.fz;
	if (!_v0.$) {
		var cfg = _v0.a;
		return $elm$core$Maybe$Just(
			A2(
				$rtfeldman$elm_css$Html$Styled$div,
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Html$Styled$Attributes$class('modal-header'),
					cfg.eW),
				_Utils_ap(
					cfg.i6,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Modal$closeButton(
							$frandibar$elm_bootstrap$Bootstrap$Modal$getCloseMsg(conf_))
						]))));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Html$Styled$Attributes$tabindex = function (n) {
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$view = F2(
	function (visibility, _v0) {
		var conf = _v0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_Utils_ap(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$tabindex(-1)
								]),
							A2($frandibar$elm_bootstrap$Bootstrap$Modal$display, visibility, conf)),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_Utils_ap(
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'role', 'document'),
											$rtfeldman$elm_css$Html$Styled$Attributes$class('elm-bootstrap-modal')
										]),
									_Utils_ap(
										$frandibar$elm_bootstrap$Bootstrap$Modal$modalAttributes(conf.j7),
										conf.j7.dF ? _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$Events$on,
												'click',
												$frandibar$elm_bootstrap$Bootstrap$Modal$containerClickDecoder(conf.dt))
											]) : _List_Nil)),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('modal-content')
											]),
										A2(
											$elm$core$List$filterMap,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Modal$renderHeader(conf),
													$frandibar$elm_bootstrap$Bootstrap$Modal$renderBody(conf.dp),
													$frandibar$elm_bootstrap$Bootstrap$Modal$renderFooter(conf.hw)
												])))
									]))
							]))
					]),
				A2($frandibar$elm_bootstrap$Bootstrap$Modal$backdrop, visibility, conf)));
	});
var $author$project$Components$Organisms$ProductFilterModal$productFilterModal = function (props) {
	var filteredProducts = A2(
		$elm$core$List$filter,
		function (p) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(props.h7),
				$elm$core$String$toLower(p.nk));
		},
		A2(
			$elm$core$List$filter,
			function (p) {
				return _Utils_eq(props.gJ.gD, -1) || _Utils_eq(props.gJ.gD, p.ir);
			},
			A2(
				$elm$core$List$filter,
				function (p) {
					return _Utils_eq(props.e$.ig, -1) || _Utils_eq(props.e$.ig, p.e_);
				},
				A2(
					$elm$core$List$filter,
					function (p) {
						return !A2($elm$core$List$member, p.kl, props.ij);
					},
					props.kn))));
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Modal$view,
		props.jY,
		A3(
			$frandibar$elm_bootstrap$Bootstrap$Modal$footer,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Button$button,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Button$outlineInfo,
							$frandibar$elm_bootstrap$Bootstrap$Button$onClick(props.h_)
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('閉じる')
						]))
				]),
			A3(
				$frandibar$elm_bootstrap$Bootstrap$Modal$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$form,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Css$displayFlex,
										$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
										$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
												$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$group,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$displayFlex,
																$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
																$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
																$rtfeldman$elm_css$Css$marginRight(
																$rtfeldman$elm_css$Css$px(24))
															]))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$label,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('大分類')
													])),
												A2($author$project$Components$Molecules$BigCategorySelector$bigCategorySelector, props.e$, _List_Nil)
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$group,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$displayFlex,
																$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
																$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart)
															]))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$label,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('中分類')
													])),
												A2($author$project$Components$Molecules$SmallCategorySelector$smallCategorySelector, props.gJ, _List_Nil)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$displayFlex,
												$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
												$rtfeldman$elm_css$Css$width(
												$rtfeldman$elm_css$Css$pct(100)),
												A2($rtfeldman$elm_css$Css$property, 'column-gap', '24px')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$group,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$width(
																$rtfeldman$elm_css$Css$pct(100))
															]))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$label,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('形名')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$displayFlex,
																$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
																A2($rtfeldman$elm_css$Css$property, 'column-gap', '24px')
															]))
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Css$displayFlex,
																		$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
																		$rtfeldman$elm_css$Css$flex(
																		$rtfeldman$elm_css$Css$int(1))
																	]))
															]),
														_List_fromArray(
															[
																$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
																_List_fromArray(
																	[
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(props.j4),
																		$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(props.h7)
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$div,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('border'),
																		$rtfeldman$elm_css$Html$Styled$Attributes$css(
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Css$marginTop(
																				$rtfeldman$elm_css$Css$px(24)),
																				$rtfeldman$elm_css$Css$minHeight(
																				$rtfeldman$elm_css$Css$px(240)),
																				$rtfeldman$elm_css$Css$maxHeight(
																				$rtfeldman$elm_css$Css$px(240)),
																				$rtfeldman$elm_css$Css$flex(
																				$rtfeldman$elm_css$Css$int(1)),
																				$rtfeldman$elm_css$Css$displayFlex,
																				$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
																				$rtfeldman$elm_css$Css$padding(
																				$rtfeldman$elm_css$Css$px(8)),
																				A2($rtfeldman$elm_css$Css$property, 'row-gap', '8px'),
																				$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
																			]))
																	]),
																A2(
																	$elm$core$List$map,
																	function (product) {
																		return A2(
																			$rtfeldman$elm_css$Html$Styled$span,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$css(
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
																							$rtfeldman$elm_css$Css$hover(
																							_List_fromArray(
																								[
																									$rtfeldman$elm_css$Css$opacity(
																									$rtfeldman$elm_css$Css$num(0.7))
																								]))
																						])),
																					$rtfeldman$elm_css$Html$Styled$Events$onClick(
																					props.j5(product.kl))
																				]),
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text(product.nk)
																				]));
																	},
																	filteredProducts))
															]))
													]))
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$group,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$displayFlex,
																$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
																$rtfeldman$elm_css$Css$width(
																$rtfeldman$elm_css$Css$pct(100))
															]))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$label,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('選択済み')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('border'),
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Css$flex(
																$rtfeldman$elm_css$Css$int(1)),
																$rtfeldman$elm_css$Css$displayFlex,
																$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column),
																$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart),
																$rtfeldman$elm_css$Css$maxHeight(
																$rtfeldman$elm_css$Css$px(302)),
																$rtfeldman$elm_css$Css$padding(
																$rtfeldman$elm_css$Css$px(8)),
																A2($rtfeldman$elm_css$Css$property, 'row-gap', '8px'),
																$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
															]))
													]),
												A2(
													$elm$core$List$map,
													function (product) {
														return A2(
															$rtfeldman$elm_css$Html$Styled$div,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('border'),
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Css$displayFlex,
																			$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row),
																			$rtfeldman$elm_css$Css$height(
																			$rtfeldman$elm_css$Css$px(40)),
																			$rtfeldman$elm_css$Css$minWidth(
																			$rtfeldman$elm_css$Css$px(200)),
																			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer)
																		])),
																	$rtfeldman$elm_css$Html$Styled$Events$onClick(
																	props.j6(product.kl))
																]),
															_List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class('border-right'),
																			$rtfeldman$elm_css$Html$Styled$Attributes$css(
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Css$width(
																					$rtfeldman$elm_css$Css$px(40)),
																					$rtfeldman$elm_css$Css$height(
																					$rtfeldman$elm_css$Css$px(40)),
																					$rtfeldman$elm_css$Css$displayFlex,
																					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
																					$rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center)
																				]))
																		]),
																	_List_fromArray(
																		[$author$project$Icons$CloseIcon$closeIcon])),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$css(
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Css$displayFlex,
																					$rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center),
																					A2(
																					$rtfeldman$elm_css$Css$padding2,
																					$rtfeldman$elm_css$Css$px(0),
																					$rtfeldman$elm_css$Css$px(16))
																				]))
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(product.nk)
																		]))
																]));
													},
													A2(
														$elm$core$List$filterMap,
														function (selectedProduct) {
															return A2($author$project$Components$Organisms$ProductFilterModal$findProductById, selectedProduct, props.kn);
														},
														props.ij)))
											]))
									]))
							]))
					]),
				A3(
					$frandibar$elm_bootstrap$Bootstrap$Modal$h5,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text('大分類・中分類・形名を選択')
						]),
					$frandibar$elm_bootstrap$Bootstrap$Modal$large(
						$frandibar$elm_bootstrap$Bootstrap$Modal$config(props.h_))))));
};
var $frandibar$elm_bootstrap$Bootstrap$Modal$small = function (_v0) {
	var conf = _v0;
	var options = conf.j7;
	return _Utils_update(
		conf,
		{
			j7: _Utils_update(
				options,
				{
					d2: $elm$core$Maybe$Just(1)
				})
		});
};
var $author$project$Components$Atoms$Spinner$Config = $elm$core$Basics$identity;
var $author$project$Components$Atoms$Spinner$custom = {
	hm: $rtfeldman$elm_css$Css$hex('333'),
	cj: 30
};
var $author$project$Components$Atoms$Spinner$spinKeyframe = $rtfeldman$elm_css$Css$Animations$keyframes(
	_List_fromArray(
		[
			_Utils_Tuple2(
			0,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'rotate(0deg)')
				])),
			_Utils_Tuple2(
			100,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Animations$property, 'transform', 'rotate(360deg)')
				]))
		]));
var $author$project$Components$Atoms$Spinner$view = function (_v0) {
	var conf = _v0;
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						A3(
						$rtfeldman$elm_css$Css$border3,
						$rtfeldman$elm_css$Css$px(conf.cj / 12),
						$rtfeldman$elm_css$Css$solid,
						$rtfeldman$elm_css$Css$hex('f3f3f3')),
						A3(
						$rtfeldman$elm_css$Css$borderTop3,
						$rtfeldman$elm_css$Css$px(conf.cj / 12),
						$rtfeldman$elm_css$Css$solid,
						conf.hm),
						$rtfeldman$elm_css$Css$borderRadius(
						$rtfeldman$elm_css$Css$pct(50)),
						$rtfeldman$elm_css$Css$width(
						$rtfeldman$elm_css$Css$px(conf.cj)),
						$rtfeldman$elm_css$Css$height(
						$rtfeldman$elm_css$Css$px(conf.cj)),
						$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$auto),
						$rtfeldman$elm_css$Css$animationName($author$project$Components$Atoms$Spinner$spinKeyframe),
						$rtfeldman$elm_css$Css$animationDuration(
						$rtfeldman$elm_css$Css$sec(1)),
						A2($rtfeldman$elm_css$Css$property, 'animation-iteration-count', 'infinite'),
						A2($rtfeldman$elm_css$Css$property, 'animation-timing-function', 'linear')
					]))
			]),
		_List_Nil);
};
var $author$project$Components$Atoms$Spinner$spinner = $author$project$Components$Atoms$Spinner$view($author$project$Components$Atoms$Spinner$custom);
var $frandibar$elm_bootstrap$Bootstrap$Table$Striped = {$: 1};
var $frandibar$elm_bootstrap$Bootstrap$Table$striped = $frandibar$elm_bootstrap$Bootstrap$Table$Striped;
var $frandibar$elm_bootstrap$Bootstrap$Table$Inversed = {$: 0};
var $frandibar$elm_bootstrap$Bootstrap$Table$isResponsive = function (option) {
	if (option.$ === 5) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$KeyedTBody = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$TBody = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$InversedRow = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$KeyedRow = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$Row = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$InversedCell = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$Td = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$Th = function (a) {
	return {$: 1, a: a};
};
var $frandibar$elm_bootstrap$Bootstrap$Table$mapInversedCell = function (cell) {
	var inverseOptions = function (options) {
		return A2(
			$elm$core$List$map,
			function (opt) {
				if (!opt.$) {
					var role = opt.a;
					return $frandibar$elm_bootstrap$Bootstrap$Table$InversedCell(role);
				} else {
					return opt;
				}
			},
			options);
	};
	if (cell.$ === 1) {
		var cellCfg = cell.a;
		return $frandibar$elm_bootstrap$Bootstrap$Table$Th(
			_Utils_update(
				cellCfg,
				{
					j7: inverseOptions(cellCfg.j7)
				}));
	} else {
		var cellCfg = cell.a;
		return $frandibar$elm_bootstrap$Bootstrap$Table$Td(
			_Utils_update(
				cellCfg,
				{
					j7: inverseOptions(cellCfg.j7)
				}));
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$mapInversedRow = function (row) {
	var inversedOptions = function (options) {
		return A2(
			$elm$core$List$map,
			function (opt) {
				if (!opt.$) {
					var role = opt.a;
					return $frandibar$elm_bootstrap$Bootstrap$Table$InversedRow(role);
				} else {
					return opt;
				}
			},
			options);
	};
	if (!row.$) {
		var options = row.a.j7;
		var cells = row.a.G;
		return $frandibar$elm_bootstrap$Bootstrap$Table$Row(
			{
				G: A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$mapInversedCell, cells),
				j7: inversedOptions(options)
			});
	} else {
		var options = row.a.j7;
		var cells = row.a.G;
		return $frandibar$elm_bootstrap$Bootstrap$Table$KeyedRow(
			{
				G: A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var cell = _v1.b;
						return _Utils_Tuple2(
							key,
							$frandibar$elm_bootstrap$Bootstrap$Table$mapInversedCell(cell));
					},
					cells),
				j7: inversedOptions(options)
			});
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$maybeMapInversedTBody = F2(
	function (isTableInversed, tbody_) {
		var _v0 = _Utils_Tuple2(isTableInversed, tbody_);
		if (!_v0.a) {
			return tbody_;
		} else {
			if (!_v0.b.$) {
				var body = _v0.b.a;
				return $frandibar$elm_bootstrap$Bootstrap$Table$TBody(
					_Utils_update(
						body,
						{
							gv: A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$mapInversedRow, body.gv)
						}));
			} else {
				var keyedBody = _v0.b.a;
				return $frandibar$elm_bootstrap$Bootstrap$Table$KeyedTBody(
					_Utils_update(
						keyedBody,
						{
							gv: A2(
								$elm$core$List$map,
								function (_v1) {
									var key = _v1.a;
									var row = _v1.b;
									return _Utils_Tuple2(
										key,
										$frandibar$elm_bootstrap$Bootstrap$Table$mapInversedRow(row));
								},
								keyedBody.gv)
						}));
			}
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Table$InversedHead = {$: 0};
var $frandibar$elm_bootstrap$Bootstrap$Table$THead = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Table$maybeMapInversedTHead = F2(
	function (isTableInversed, _v0) {
		var thead_ = _v0;
		var isHeadInversed = A2(
			$elm$core$List$any,
			function (opt) {
				return _Utils_eq(opt, $frandibar$elm_bootstrap$Bootstrap$Table$InversedHead);
			},
			thead_.j7);
		return (isTableInversed || isHeadInversed) ? _Utils_update(
			thead_,
			{
				gv: A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$mapInversedRow, thead_.gv)
			}) : thead_;
	});
var $frandibar$elm_bootstrap$Bootstrap$Table$maybeWrapResponsive = F2(
	function (options, table_) {
		var responsiveClass = $rtfeldman$elm_css$Html$Styled$Attributes$class(
			'table-responsive' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return '-' + v;
					},
					A2(
						$elm$core$Maybe$andThen,
						$frandibar$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption,
						A2(
							$elm$core$Maybe$andThen,
							function (opt) {
								if (opt.$ === 5) {
									var val = opt.a;
									return val;
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							$elm$core$List$head(
								A2($elm$core$List$filter, $frandibar$elm_bootstrap$Bootstrap$Table$isResponsive, options)))))));
		return A2($elm$core$List$any, $frandibar$elm_bootstrap$Bootstrap$Table$isResponsive, options) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[responsiveClass]),
			_List_fromArray(
				[table_])) : table_;
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$scope = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('scope');
var $frandibar$elm_bootstrap$Bootstrap$Table$addScopeIfTh = function (cell) {
	if (cell.$ === 1) {
		var cellConfig = cell.a;
		return $frandibar$elm_bootstrap$Bootstrap$Table$Th(
			_Utils_update(
				cellConfig,
				{
					j7: A2(
						$elm$core$List$cons,
						$frandibar$elm_bootstrap$Bootstrap$Table$cellAttr(
							$rtfeldman$elm_css$Html$Styled$Attributes$scope('row')),
						cellConfig.j7)
				}));
	} else {
		return cell;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$maybeAddScopeToFirstCell = function (row) {
	if (!row.$) {
		var options = row.a.j7;
		var cells = row.a.G;
		if (!cells.b) {
			return row;
		} else {
			var first = cells.a;
			var rest = cells.b;
			return $frandibar$elm_bootstrap$Bootstrap$Table$Row(
				{
					G: A2(
						$elm$core$List$cons,
						$frandibar$elm_bootstrap$Bootstrap$Table$addScopeIfTh(first),
						rest),
					j7: options
				});
		}
	} else {
		var options = row.a.j7;
		var cells = row.a.G;
		if (!cells.b) {
			return row;
		} else {
			var _v3 = cells.a;
			var firstKey = _v3.a;
			var first = _v3.b;
			var rest = cells.b;
			return $frandibar$elm_bootstrap$Bootstrap$Table$KeyedRow(
				{
					G: A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							firstKey,
							$frandibar$elm_bootstrap$Bootstrap$Table$addScopeIfTh(first)),
						rest),
					j7: options
				});
		}
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$cellAttribute = function (option) {
	switch (option.$) {
		case 0:
			if (!option.a.$) {
				var role = option.a.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'table', role);
			} else {
				var _v1 = option.a;
				return $rtfeldman$elm_css$Html$Styled$Attributes$class('table-active');
			}
		case 1:
			if (!option.a.$) {
				var role = option.a.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg-', role);
			} else {
				var _v2 = option.a;
				return $rtfeldman$elm_css$Html$Styled$Attributes$class('bg-active');
			}
		default:
			var attr_ = option.a;
			return attr_;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$cellAttributes = function (options) {
	return A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$cellAttribute, options);
};
var $frandibar$elm_bootstrap$Bootstrap$Table$renderCell = function (cell) {
	if (!cell.$) {
		var options = cell.a.j7;
		var children = cell.a.i6;
		return A2(
			$rtfeldman$elm_css$Html$Styled$td,
			$frandibar$elm_bootstrap$Bootstrap$Table$cellAttributes(options),
			children);
	} else {
		var options = cell.a.j7;
		var children = cell.a.i6;
		return A2(
			$rtfeldman$elm_css$Html$Styled$th,
			$frandibar$elm_bootstrap$Bootstrap$Table$cellAttributes(options),
			children);
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$rowClass = function (option) {
	switch (option.$) {
		case 0:
			if (!option.a.$) {
				var role_ = option.a.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'table', role_);
			} else {
				var _v1 = option.a;
				return $rtfeldman$elm_css$Html$Styled$Attributes$class('table-active');
			}
		case 1:
			if (!option.a.$) {
				var role_ = option.a.a;
				return A2($frandibar$elm_bootstrap$Bootstrap$Internal$Role$toClass, 'bg', role_);
			} else {
				var _v2 = option.a;
				return $rtfeldman$elm_css$Html$Styled$Attributes$class('bg-active');
			}
		default:
			var attr_ = option.a;
			return attr_;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$rowAttributes = function (options) {
	return A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$rowClass, options);
};
var $frandibar$elm_bootstrap$Bootstrap$Table$renderRow = function (row) {
	if (!row.$) {
		var options = row.a.j7;
		var cells = row.a.G;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			$frandibar$elm_bootstrap$Bootstrap$Table$rowAttributes(options),
			A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$renderCell, cells));
	} else {
		var options = row.a.j7;
		var cells = row.a.G;
		return A3(
			$rtfeldman$elm_css$Html$Styled$Keyed$node,
			'tr',
			$frandibar$elm_bootstrap$Bootstrap$Table$rowAttributes(options),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var cell = _v1.b;
					return _Utils_Tuple2(
						key,
						$frandibar$elm_bootstrap$Bootstrap$Table$renderCell(cell));
				},
				cells));
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$renderTBody = function (body) {
	if (!body.$) {
		var attributes = body.a.eW;
		var rows = body.a.gv;
		return A2(
			$rtfeldman$elm_css$Html$Styled$tbody,
			attributes,
			A2(
				$elm$core$List$map,
				function (row) {
					return $frandibar$elm_bootstrap$Bootstrap$Table$renderRow(
						$frandibar$elm_bootstrap$Bootstrap$Table$maybeAddScopeToFirstCell(row));
				},
				rows));
	} else {
		var attributes = body.a.eW;
		var rows = body.a.gv;
		return A3(
			$rtfeldman$elm_css$Html$Styled$Keyed$node,
			'tbody',
			attributes,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var row = _v1.b;
					return _Utils_Tuple2(
						key,
						$frandibar$elm_bootstrap$Bootstrap$Table$renderRow(
							$frandibar$elm_bootstrap$Bootstrap$Table$maybeAddScopeToFirstCell(row)));
				},
				rows));
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$theadAttribute = function (option) {
	switch (option.$) {
		case 0:
			return $rtfeldman$elm_css$Html$Styled$Attributes$class('thead-dark');
		case 1:
			return $rtfeldman$elm_css$Html$Styled$Attributes$class('thead-default');
		default:
			var attr_ = option.a;
			return attr_;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$theadAttributes = function (options) {
	return A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$theadAttribute, options);
};
var $frandibar$elm_bootstrap$Bootstrap$Table$renderTHead = function (_v0) {
	var options = _v0.j7;
	var rows = _v0.gv;
	return A2(
		$rtfeldman$elm_css$Html$Styled$thead,
		$frandibar$elm_bootstrap$Bootstrap$Table$theadAttributes(options),
		A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$renderRow, rows));
};
var $frandibar$elm_bootstrap$Bootstrap$Table$tableClass = function (option) {
	switch (option.$) {
		case 0:
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class('table-dark'));
		case 1:
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class('table-striped'));
		case 2:
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class('table-bordered'));
		case 3:
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class('table-hover'));
		case 4:
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class('table-sm'));
		case 5:
			return $elm$core$Maybe$Nothing;
		case 6:
			return $elm$core$Maybe$Just(
				$rtfeldman$elm_css$Html$Styled$Attributes$class('table-reflow'));
		default:
			var attr_ = option.a;
			return $elm$core$Maybe$Just(attr_);
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Table$tableAttributes = function (options) {
	return A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Html$Styled$Attributes$class('table'),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2($elm$core$List$map, $frandibar$elm_bootstrap$Bootstrap$Table$tableClass, options)));
};
var $frandibar$elm_bootstrap$Bootstrap$Table$table = function (rec) {
	var isInversed = A2(
		$elm$core$List$any,
		function (opt) {
			return _Utils_eq(opt, $frandibar$elm_bootstrap$Bootstrap$Table$Inversed);
		},
		rec.j7);
	var classOptions = A2(
		$elm$core$List$filter,
		function (opt) {
			return !$frandibar$elm_bootstrap$Bootstrap$Table$isResponsive(opt);
		},
		rec.j7);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Table$maybeWrapResponsive,
		rec.j7,
		A2(
			$rtfeldman$elm_css$Html$Styled$table,
			$frandibar$elm_bootstrap$Bootstrap$Table$tableAttributes(classOptions),
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Table$renderTHead(
					A2($frandibar$elm_bootstrap$Bootstrap$Table$maybeMapInversedTHead, isInversed, rec.nT)),
					$frandibar$elm_bootstrap$Bootstrap$Table$renderTBody(
					A2($frandibar$elm_bootstrap$Bootstrap$Table$maybeMapInversedTBody, isInversed, rec.nR))
				])));
};
var $frandibar$elm_bootstrap$Bootstrap$Table$tbody = F2(
	function (attributes, rows) {
		return $frandibar$elm_bootstrap$Bootstrap$Table$TBody(
			{eW: attributes, gv: rows});
	});
var $frandibar$elm_bootstrap$Bootstrap$Table$td = F2(
	function (options, children) {
		return $frandibar$elm_bootstrap$Bootstrap$Table$Td(
			{i6: children, j7: options});
	});
var $frandibar$elm_bootstrap$Bootstrap$Table$th = F2(
	function (options, children) {
		return $frandibar$elm_bootstrap$Bootstrap$Table$Th(
			{i6: children, j7: options});
	});
var $frandibar$elm_bootstrap$Bootstrap$Table$thead = F2(
	function (options, rows) {
		return {j7: options, gv: rows};
	});
var $frandibar$elm_bootstrap$Bootstrap$Table$tr = F2(
	function (options, cells) {
		return $frandibar$elm_bootstrap$Bootstrap$Table$Row(
			{G: cells, j7: options});
	});
var $author$project$Pages$Users$MlnComnet$Chronological$OnCheckFilteredTime = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnCheckFromPreviousThursday = {$: 38};
var $author$project$Pages$Users$MlnComnet$Chronological$OnClickCreateSnapshot = {$: 29};
var $author$project$Pages$Users$MlnComnet$Chronological$OnClickDeselectAllFilteredTimesButton = {$: 42};
var $author$project$Pages$Users$MlnComnet$Chronological$OnClickPerhourFilteredTimesButton = {$: 41};
var $author$project$Pages$Users$MlnComnet$Chronological$OnClickRemoveSnapshot = {$: 35};
var $author$project$Pages$Users$MlnComnet$Chronological$OnClickSaveSnapshot = {$: 32};
var $author$project$Pages$Users$MlnComnet$Chronological$OnClickSelectAllFilteredTimesButton = {$: 40};
var $author$project$Pages$Users$MlnComnet$Chronological$OnSelectSavedSnapshot = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnSubmit = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnUpdateDateFrom = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnUpdateDateTo = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnUpdateTimeFrom = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$OnUpdateTimeTo = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleExportExcel = {$: 18};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleQueryOnlyAlertProduct = {$: 21};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleQueryOnlyLowest = {$: 19};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleQueryOnlyMoved = {$: 20};
var $author$project$Pages$Users$MlnComnet$Chronological$ToggleSeparateSheetByProductID = {$: 26};
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$DropdownItem = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$buttonItem = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dropdown-item')
					]),
				attributes),
			children);
	});
var $rtfeldman$elm_css$Html$Styled$details = $rtfeldman$elm_css$Html$Styled$node('details');
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$divider = A2(
	$rtfeldman$elm_css$Html$Styled$div,
	_List_fromArray(
		[
			$rtfeldman$elm_css$Html$Styled$Attributes$class('dropdown-divider')
		]),
	_List_Nil);
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$dropDir = function (maybeDir) {
	var toAttrs = function (dir) {
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class(
				'drop' + function () {
					if (!dir) {
						return 'left';
					} else {
						return 'right';
					}
				}())
			]);
	};
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2($elm$core$Maybe$map, toAttrs, maybeDir));
};
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$dropdownAttributes = F2(
	function (status, config) {
		return _Utils_ap(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('btn-group', true),
							_Utils_Tuple2('show', status !== 2),
							_Utils_Tuple2('dropup', config.dN)
						]))
				]),
			_Utils_ap(
				$frandibar$elm_bootstrap$Bootstrap$Dropdown$dropDir(config.dz),
				config.eW));
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$menuStyles = F2(
	function (_v0, config) {
		var status = _v0.al;
		var toggleSize = _v0.gX;
		var menuSize = _v0.d$;
		var px = function (n) {
			return $elm$core$String$fromFloat(n) + 'px';
		};
		var translate = F3(
			function (x, y, z) {
				return 'translate3d(' + (px(x) + (',' + (px(y) + (',' + (px(z) + ')')))));
			});
		var _default = _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'top', '0'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'left', '0')
			]);
		var _v1 = _Utils_Tuple2(config.dN, config.dz);
		_v1$0:
		while (true) {
			if (!_v1.b.$) {
				if (_v1.b.a === 1) {
					if (_v1.a) {
						break _v1$0;
					} else {
						var _v2 = _v1.b.a;
						return _default;
					}
				} else {
					if (_v1.a) {
						break _v1$0;
					} else {
						var _v3 = _v1.b.a;
						return _Utils_ap(
							_default,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$Attributes$style,
									'transform',
									A3(translate, (-toggleSize.lg) - menuSize.lg, 0, 0))
								]));
					}
				}
			} else {
				if (_v1.a) {
					break _v1$0;
				} else {
					return _Utils_ap(
						_default,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$Attributes$style,
								'transform',
								A3(translate, -toggleSize.lg, toggleSize.jw, 0))
							]));
				}
			}
		}
		return _Utils_ap(
			_default,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$Attributes$style,
					'transform',
					A3(translate, -toggleSize.lg, -menuSize.jw, 0))
				]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$dropdownMenu = F3(
	function (state, config, items) {
		var status = state.al;
		var menuSize = state.d$;
		var wrapperStyles = (status === 2) ? _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '0'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'overflow', 'hidden'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'relative')
			]) : _List_fromArray(
			[
				A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'position', 'relative')
			]);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			wrapperStyles,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('dropdown-menu', true),
										_Utils_Tuple2('dropdown-menu-right', config.fy),
										_Utils_Tuple2('show', status !== 2)
									]))
							]),
						_Utils_ap(
							A2($frandibar$elm_bootstrap$Bootstrap$Dropdown$menuStyles, state, config),
							config.fR)),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var x = _v0;
							return x;
						},
						items))
				]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$applyModifier = F2(
	function (option, options) {
		switch (option.$) {
			case 1:
				return _Utils_update(
					options,
					{fy: true});
			case 0:
				return _Utils_update(
					options,
					{dN: true});
			case 4:
				var attrs_ = option.a;
				return _Utils_update(
					options,
					{eW: attrs_});
			case 2:
				var dir = option.a;
				return _Utils_update(
					options,
					{
						dz: $elm$core$Maybe$Just(dir)
					});
			default:
				var attrs_ = option.a;
				return _Utils_update(
					options,
					{fR: attrs_});
		}
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$defaultOptions = {eW: _List_Nil, dz: $elm$core$Maybe$Nothing, fy: false, dN: false, fR: _List_Nil};
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$toConfig = function (options) {
	return A3($elm$core$List$foldl, $frandibar$elm_bootstrap$Bootstrap$Dropdown$applyModifier, $frandibar$elm_bootstrap$Bootstrap$Dropdown$defaultOptions, options);
};
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$dropdown = F2(
	function (state, _v0) {
		var status = state.al;
		var toggleMsg = _v0.nZ;
		var toggleButton = _v0.nY;
		var items = _v0.mx;
		var options = _v0.j7;
		var config = $frandibar$elm_bootstrap$Bootstrap$Dropdown$toConfig(options);
		var _v1 = toggleButton;
		var buttonFn = _v1;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			A2($frandibar$elm_bootstrap$Bootstrap$Dropdown$dropdownAttributes, status, config),
			_List_fromArray(
				[
					A2(buttonFn, toggleMsg, state),
					A3($frandibar$elm_bootstrap$Bootstrap$Dropdown$dropdownMenu, state, config, items)
				]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Light = 7;
var $frandibar$elm_bootstrap$Bootstrap$Button$light = $frandibar$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	$frandibar$elm_bootstrap$Bootstrap$Internal$Button$Roled(7));
var $author$project$Utils$Helpers$preventDefaultClick = function (onClick) {
	var decoder = $elm$json$Json$Decode$succeed(
		_Utils_Tuple2(onClick, true));
	return A2($rtfeldman$elm_css$Html$Styled$Events$preventDefaultOn, 'click', decoder);
};
var $rtfeldman$elm_css$Html$Styled$summary = $rtfeldman$elm_css$Html$Styled$node('summary');
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$DropdownToggle = $elm$core$Basics$identity;
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$Open = 0;
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$nextStatus = function (status) {
	switch (status) {
		case 0:
			return 2;
		case 1:
			return 2;
		default:
			return 0;
	}
};
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeft_, scrollTop_, offsetLeft_, offsetTop_) {
						return _Utils_Tuple2((x + offsetLeft_) - scrollLeft_, (y + offsetTop_) - scrollTop_);
					}),
				$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollLeft,
				$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$scrollTop,
				$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetLeft,
				$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetTop));
	});
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$boundingArea = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {jw: height, jS: x, k1: y, lg: width};
		}),
	A2($frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$position, 0, 0),
	$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetWidth,
	$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$offsetHeight);
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$childNode = function (idx) {
	return $elm$json$Json$Decode$at(
		_List_fromArray(
			[
				'childNodes',
				$elm$core$String$fromInt(idx)
			]));
};
var $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$nextSibling = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'nextSibling', decoder);
};
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$isToggle = A2(
	$elm$json$Json$Decode$andThen,
	function (_class) {
		return A2($elm$core$String$contains, 'dropdown-toggle', _class) ? $elm$json$Json$Decode$succeed(true) : $elm$json$Json$Decode$succeed(false);
	},
	$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$className);
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$toggler = F2(
	function (path, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$andThen,
					function (res) {
						return res ? A2($elm$json$Json$Decode$at, path, decoder) : $elm$json$Json$Decode$fail('');
					},
					A2($elm$json$Json$Decode$at, path, $frandibar$elm_bootstrap$Bootstrap$Dropdown$isToggle)),
					A2(
					$elm$json$Json$Decode$andThen,
					function (_v0) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Dropdown$toggler,
							_Utils_ap(
								path,
								_List_fromArray(
									['parentElement'])),
							decoder);
					},
					A2(
						$elm$json$Json$Decode$at,
						_Utils_ap(
							path,
							_List_fromArray(
								['parentElement'])),
						$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$className)),
					$elm$json$Json$Decode$fail('No toggler found')
				]));
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$sizeDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2(
		$frandibar$elm_bootstrap$Bootstrap$Dropdown$toggler,
		_List_fromArray(
			['target']),
		$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$boundingArea),
	A2(
		$frandibar$elm_bootstrap$Bootstrap$Dropdown$toggler,
		_List_fromArray(
			['target']),
		$frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$nextSibling(
			A2($frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$childNode, 0, $frandibar$elm_bootstrap$Bootstrap$Utilities$DomHelper$boundingArea))));
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$clickHandler = F2(
	function (toMsg, state) {
		var status = state.al;
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var b = _v0.a;
				var m = _v0.b;
				return $elm$json$Json$Decode$succeed(
					toMsg(
						{
							d$: m,
							al: $frandibar$elm_bootstrap$Bootstrap$Dropdown$nextStatus(status),
							gX: b
						}));
			},
			$frandibar$elm_bootstrap$Bootstrap$Dropdown$sizeDecoder);
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$togglePrivate = F4(
	function (buttonOptions, children, toggleMsg, state) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				$frandibar$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(buttonOptions),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('dropdown-toggle'),
						$rtfeldman$elm_css$Html$Styled$Attributes$type_('button'),
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$on,
						'click',
						A2($frandibar$elm_bootstrap$Bootstrap$Dropdown$clickHandler, toggleMsg, state))
					])),
			children);
	});
var $frandibar$elm_bootstrap$Bootstrap$Dropdown$toggle = F2(
	function (buttonOptions, children) {
		return A2($frandibar$elm_bootstrap$Bootstrap$Dropdown$togglePrivate, buttonOptions, children);
	});
var $author$project$Pages$Users$MlnComnet$Chronological$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.bV;
				if (_v0.$ === 2) {
					var e = _v0.a;
					return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
				} else {
					return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
				}
			}(),
				A3(
				$krisajenkins$remotedata$RemoteData$unwrap,
				A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				function (snapshots) {
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('出力条件の呼び出し')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$MlnComnet$Chronological$OnSelectSavedSnapshot)
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$value(''),
														$rtfeldman$elm_css$Html$Styled$Attributes$selected(
														_Utils_eq(model.ag, $elm$core$Maybe$Nothing))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('選択してください')
													])),
											A2(
												$elm$core$List$map,
												function (snapshot) {
													return A2(
														$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(snapshot.gG)),
																$rtfeldman$elm_css$Html$Styled$Attributes$selected(
																_Utils_eq(
																	model.ag,
																	$elm$core$Maybe$Just(
																		$elm$core$String$fromInt(snapshot.gG))))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(snapshot.jZ)
															]));
												},
												snapshots)))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('出力条件の保存/削除')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Dropdown$dropdown,
										model.eg,
										{
											mx: function () {
												var _v1 = model.ag;
												if (!_v1.$) {
													return _List_fromArray(
														[
															A2(
															$frandibar$elm_bootstrap$Bootstrap$Dropdown$buttonItem,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickSaveSnapshot)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('選択したフォームを上書き保存')
																])),
															A2(
															$frandibar$elm_bootstrap$Bootstrap$Dropdown$buttonItem,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickCreateSnapshot)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('現在のフォームを新規保存')
																])),
															$frandibar$elm_bootstrap$Bootstrap$Dropdown$divider,
															A2(
															$frandibar$elm_bootstrap$Bootstrap$Dropdown$buttonItem,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickRemoveSnapshot),
																	$rtfeldman$elm_css$Html$Styled$Attributes$class('text-danger')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('選択したフォームを削除')
																]))
														]);
												} else {
													return _List_fromArray(
														[
															A2(
															$frandibar$elm_bootstrap$Bootstrap$Dropdown$buttonItem,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickCreateSnapshot)
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('現在のフォームを新規保存')
																]))
														]);
												}
											}(),
											j7: _List_Nil,
											nY: A2(
												$frandibar$elm_bootstrap$Bootstrap$Dropdown$toggle,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('選択してください')
													])),
											nZ: $author$project$Pages$Users$MlnComnet$Chronological$GotDropdownMsg
										})
									]))
							]));
				},
				model.bV),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('形名')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$author$project$Utils$Helpers$preventDefaultClick($author$project$Pages$Users$MlnComnet$Chronological$ToggleProductFilterModal)
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$light,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Chronological$ToggleProductFilterModal)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('形名を表示')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column  align-items-start')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得日')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$disabled(model.ao),
														$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
													])),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$Chronological$OnUpdateDateFrom)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-2')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得時刻')
											])),
										A3(
										$author$project$Components$TimeSelector$timeSelector,
										60,
										model.il,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$Chronological$OnUpdateTimeFrom),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(model.ao)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-2')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('〜')
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得日')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$disabled(model.ao),
														$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
													])),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$Chronological$OnUpdateDateTo)
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('取得時刻')
											])),
										A3(
										$author$project$Components$TimeSelector$timeSelector,
										60,
										model.im,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
												$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$Chronological$OnUpdateTimeTo),
												$rtfeldman$elm_css$Html$Styled$Attributes$disabled(model.ao)
											]))
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
								$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$OnCheckFromPreviousThursday)),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.ao),
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('from-previous-thursday')
							]),
						'前週木曜日の10時から')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
										$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
								$author$project$Pages$Users$MlnComnet$Chronological$OnSubmit(false))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('送信')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vr')
							]),
						_List_Nil),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$ToggleQueryOnlyAlertProduct)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.bO),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('query-only-alert')
									]),
								'アラート対象のみ'),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$ToggleQueryOnlyLowest)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.bP),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('query-only-lowest')
									]),
								'最安のみ'),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$ToggleQueryOnlyMoved)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.bQ),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('query-only-moved')
									]),
								'変動があった時間帯のみ')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('vr')
							]),
						_List_Nil),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$ToggleExportExcel)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.a1),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('export-excel')
									]),
								'xlsx形式でダウンロード'),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(!model.a1),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$ToggleSeparateSheetByProductID)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.c3),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('separate-sheet-by-id')
									]),
								'機種ごとにシートを分割')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$details,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$summary,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('時間設定')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1100px')
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('pt-2 pb-2')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$info,
												$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-2')
													])),
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickSelectAllFilteredTimesButton)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て選択')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$info,
												$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-2')
													])),
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickPerhourFilteredTimesButton)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('1時間ごと')
											])),
										A2(
										$frandibar$elm_bootstrap$Bootstrap$Button$button,
										_List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Button$info,
												$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickDeselectAllFilteredTimesButton)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全て選択解除')
											]))
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$group,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (timeStr) {
										return A2(
											$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$inline,
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
													$elm$core$Basics$always(
														$author$project$Pages$Users$MlnComnet$Chronological$OnCheckFilteredTime(timeStr))),
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
													A2($elm$core$Set$member, timeStr, model.O)),
													$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('filtered-time-set-' + timeStr)
												]),
											timeStr);
									},
									$author$project$Pages$Users$MlnComnet$Chronological$filteredTimes))
							]))
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$Chronological$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$MlnComnet$Chronological$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$displayFlex,
								$rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$row)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Css$marginRight(
												$rtfeldman$elm_css$Css$px(24))
											]))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.aw),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$TogglePriceEnabled)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('price-enabled'),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(model.au || model.ax)
									]),
								'金額を表示'),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.au),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$TogglePointEnabled)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('point-enabled'),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(model.aw || model.ax)
									]),
								'ポイントを表示'),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(model.ax),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
										$elm$core$Basics$always($author$project$Pages$Users$MlnComnet$Chronological$TogglePriceWithoutPointEnabled)),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$id('price-without-point-enabled'),
										$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$disabled(model.au || model.aw)
									]),
								'金額-ポイント を表示')
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
										$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$MlnComnet$Chronological$Nop)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('法人')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$map,
										$author$project$Pages$Users$MlnComnet$Chronological$OnChangeStore,
										$rtfeldman$elm_css$Html$Styled$fromUnstyled(
											$inkuzmin$elm_multiselect$Multiselect$view(model.p)))
									]))
							]))
					])),
				function () {
				var _v0 = model.db;
				switch (_v0.$) {
					case 0:
						return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
					case 1:
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-3')
								]),
							_List_fromArray(
								[
									$author$project$Components$Loading$loading(30)
								]));
					case 2:
						var e = _v0.a;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										if ((e.$ === 3) && (e.a === 404)) {
											return '該当するデータが見つかりませんでした。検索条件を変更して再度お試しください';
										} else {
											return $author$project$Utils$Helpers$errToStr(e);
										}
									}())
								]));
					default:
						var data = _v0.a;
						var rowsNum = '2';
						var colsNum = '5';
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Table$table(
									{
										j7: _List_fromArray(
											[
												$frandibar$elm_bootstrap$Bootstrap$Table$bordered,
												$frandibar$elm_bootstrap$Bootstrap$Table$striped,
												$frandibar$elm_bootstrap$Bootstrap$Table$attr(
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mln-comnet text-nowrap')),
												$frandibar$elm_bootstrap$Bootstrap$Table$attr(
												$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable')),
												$frandibar$elm_bootstrap$Bootstrap$Table$attr(
												A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum))))
											]),
										nR: A2(
											$frandibar$elm_bootstrap$Bootstrap$Table$tbody,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (row) {
													return A2(
														$frandibar$elm_bootstrap$Bootstrap$Table$tr,
														_List_Nil,
														$elm$core$List$concat(
															_List_fromArray(
																[
																	_List_fromArray(
																	[
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Table$th,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(row.hl)
																			])),
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Table$th,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(row.nk)
																			])),
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Table$th,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(row.kS)
																			])),
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Table$th,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(row.kR)
																			])),
																		A2(
																		$frandibar$elm_bootstrap$Bootstrap$Table$th,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(
																				$elm$core$String$fromInt(row.iO))
																			]))
																	]),
																	A2(
																	$elm$core$List$map,
																	function (maybecell) {
																		if (!maybecell.$) {
																			var cell = maybecell.a;
																			return A2(
																				$frandibar$elm_bootstrap$Bootstrap$Table$td,
																				_List_fromArray(
																					[
																						$frandibar$elm_bootstrap$Bootstrap$Table$cellAttr(
																						$rtfeldman$elm_css$Html$Styled$Attributes$classList(
																							_List_fromArray(
																								[
																									_Utils_Tuple2('lowestPriceTdMln', cell.hN),
																									_Utils_Tuple2('increasedPriceTdMln', cell.jK),
																									_Utils_Tuple2('decreasedPriceTdMln', cell.jJ)
																								])))
																					]),
																				_List_fromArray(
																					[
																						model.aw ? A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_Nil,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(
																								A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(cell.kh))
																							])) : A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil),
																						model.au ? A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_Nil,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(
																								$elm$core$String$fromInt(cell.ka))
																							])) : A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil),
																						model.ax ? A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_Nil,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(
																								A2($elm$core$Basics$composeL, $author$project$Utils$Helpers$toCommmaSplited, $elm$core$String$fromInt)(cell.be))
																							])) : A2($rtfeldman$elm_css$Html$Styled$p, _List_Nil, _List_Nil)
																					]));
																		} else {
																			return A2($frandibar$elm_bootstrap$Bootstrap$Table$td, _List_Nil, _List_Nil);
																		}
																	},
																	row.km)
																])));
												},
												data.gv)),
										nT: A2(
											$frandibar$elm_bootstrap$Bootstrap$Table$thead,
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Table$headAttr(
													$rtfeldman$elm_css$Html$Styled$Attributes$class('storeGroupHeader1'))
												]),
											_List_fromArray(
												[
													A2(
													$frandibar$elm_bootstrap$Bootstrap$Table$tr,
													_List_Nil,
													$elm$core$List$concat(
														_List_fromArray(
															[
																_List_fromArray(
																[
																	A2($frandibar$elm_bootstrap$Bootstrap$Table$th, _List_Nil, _List_Nil),
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_fromArray(
																		[
																			$frandibar$elm_bootstrap$Bootstrap$Table$cellAttr(
																			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'min-width', '200px'))
																		]),
																	_List_Nil),
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_fromArray(
																		[
																			$frandibar$elm_bootstrap$Bootstrap$Table$cellAttr(
																			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'min-width', '200px'))
																		]),
																	_List_Nil),
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_fromArray(
																		[
																			$frandibar$elm_bootstrap$Bootstrap$Table$cellAttr(
																			A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'min-width', '100px'))
																		]),
																	_List_Nil),
																	A2($frandibar$elm_bootstrap$Bootstrap$Table$th, _List_Nil, _List_Nil)
																]),
																A2(
																$elm$core$List$map,
																function (date) {
																	return A2(
																		$frandibar$elm_bootstrap$Bootstrap$Table$th,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(
																				$author$project$Utils$Helpers$formatPosix(date))
																			]));
																},
																data.hD)
															]))),
													A2(
													$frandibar$elm_bootstrap$Bootstrap$Table$tr,
													_List_Nil,
													$elm$core$List$concat(
														_List_fromArray(
															[
																_List_fromArray(
																[
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('自社カテゴリ')
																		])),
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('商品名')
																		])),
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('店舗')
																		])),
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('サイト')
																		])),
																	A2(
																	$frandibar$elm_bootstrap$Bootstrap$Table$th,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text('アラート価格')
																		]))
																]),
																A2(
																$elm$core$List$map,
																$elm$core$Basics$always(
																	A2(
																		$frandibar$elm_bootstrap$Bootstrap$Table$th,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text('商品価格')
																			]))),
																data.hD)
															])))
												]))
									})
								]));
				}
			}(),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Modal$view,
				model.bq,
				A3(
					$frandibar$elm_bootstrap$Bootstrap$Modal$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnSubmitCreateSnapshot)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('送信')
								]))
						]),
					A3(
						$frandibar$elm_bootstrap$Bootstrap$Modal$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('保存名')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.aM),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$Chronological$OnChangeSnapshotName)
									]))
							]),
						A3(
							$frandibar$elm_bootstrap$Bootstrap$Modal$h5,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('設定を保存')
								]),
							$frandibar$elm_bootstrap$Bootstrap$Modal$small(
								$frandibar$elm_bootstrap$Bootstrap$Modal$config($author$project$Pages$Users$MlnComnet$Chronological$ToggleCreateSnapshotModal)))))),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Modal$view,
				model.b_,
				A3(
					$frandibar$elm_bootstrap$Bootstrap$Modal$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$primary,
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnSubmitSaveSnapshot)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('送信')
								]))
						]),
					A3(
						$frandibar$elm_bootstrap$Bootstrap$Modal$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('保存名')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.aM),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$Chronological$OnChangeSnapshotName)
									]))
							]),
						A3(
							$frandibar$elm_bootstrap$Bootstrap$Modal$h5,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('設定を更新')
								]),
							$frandibar$elm_bootstrap$Bootstrap$Modal$small(
								$frandibar$elm_bootstrap$Bootstrap$Modal$config($author$project$Pages$Users$MlnComnet$Chronological$ToggleUpdateSnapshotModal)))))),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Modal$view,
				model.a$,
				A3(
					$frandibar$elm_bootstrap$Bootstrap$Modal$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$outlineInfo,
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Chronological$OnClickExcelProcessingStatusModal)
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('閉じる')
								]))
						]),
					A3(
						$frandibar$elm_bootstrap$Bootstrap$Modal$body,
						_List_Nil,
						function () {
							var _v4 = model.bw;
							switch (_v4.$) {
								case 1:
									var res = _v4.a;
									return _List_fromArray(
										[
											$author$project$Components$Atoms$Spinner$spinner,
											A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('処理完了後に自動的にファイルを開きます。')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('または、一定時間が経過したら'),
													A2(
													$rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href(res.ck),
															$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('こちらのリンク')
														])),
													$rtfeldman$elm_css$Html$Styled$text('からダウンロードが可能です。')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('※ 広い期間を選択した場合、処理完了まで数分程度かかる場合がございます。')
												]))
										]);
								case 2:
									var res = _v4.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$a,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$href(res.ck),
															$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('こちらのリンク')
														])),
													$rtfeldman$elm_css$Html$Styled$text('からダウンロードが可能です。')
												]))
										]);
								case 3:
									var msg = _v4.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$p,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(msg)
												]))
										]);
								default:
									return _List_Nil;
							}
						}(),
						A3(
							$frandibar$elm_bootstrap$Bootstrap$Modal$h5,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									function () {
										var _v3 = model.bw;
										switch (_v3.$) {
											case 1:
												return 'Excelファイルの処理中です';
											case 2:
												return 'Excelファイルの処理が完了しました';
											case 3:
												return 'Excelファイルの処理中にエラーが発生しました';
											default:
												return '';
										}
									}())
								]),
							$frandibar$elm_bootstrap$Bootstrap$Modal$large(
								$frandibar$elm_bootstrap$Bootstrap$Modal$config($author$project$Pages$Users$MlnComnet$Chronological$ToggleExcelProcessingStatusModal)))))),
				$author$project$Components$Organisms$ProductFilterModal$productFilterModal(
				{
					e$: {
						iW: A3(
							$krisajenkins$remotedata$RemoteData$unwrap,
							_List_Nil,
							function ($) {
								return $.iW;
							},
							model.aH),
						j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$Chronological$OnChangeBigCategory),
						ig: model.ig
					},
					jY: model.eb,
					j4: $author$project$Pages$Users$MlnComnet$Chronological$OnChangeSearchText,
					j5: $author$project$Pages$Users$MlnComnet$Chronological$OnSelectProduct,
					h_: $author$project$Pages$Users$MlnComnet$Chronological$ToggleProductFilterModal,
					j6: $author$project$Pages$Users$MlnComnet$Chronological$OnUnselectProduct,
					h7: model.h7,
					kn: A3(
						$krisajenkins$remotedata$RemoteData$unwrap,
						_List_Nil,
						function ($) {
							return $.kn;
						},
						model.aH),
					ij: model.ij,
					gJ: {
						j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$Chronological$OnChangeSmallCategory),
						ig: model.ig,
						gD: model.gD,
						kL: A3(
							$krisajenkins$remotedata$RemoteData$unwrap,
							_List_Nil,
							function ($) {
								return $.kL;
							},
							model.aH)
					}
				})
			]));
};
var $author$project$Pages$Users$MlnComnet$Chronological$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$Chronological$viewContent(model),
		iB: '時系列データ'
	};
};
var $author$project$Pages$Users$MlnComnet$Hour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$MlnComnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$MlnComnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$MlnComnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$MlnComnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$MlnComnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$MlnComnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$OnSubmit = {$: 9};
var $author$project$Pages$Users$MlnComnet$Hour$OnSubmitLatest = {$: 10};
var $author$project$Pages$Users$MlnComnet$Hour$OnUpdateDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$OnUpdateTime = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('中分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column mr-3')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$MlnComnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$MlnComnet$Hour$OnPressDownloadCSV = {$: 11};
var $author$project$Pages$Users$MlnComnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$MlnComnet$Hour$OnChangeSortOption = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$MlnComnet$Hour$viewSortSelector = function (selectedSortOption) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示順')
					])),
				$author$project$Components$Molecules$SortTableSelector$sortTableSelector(
				{
					j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$Hour$OnChangeSortOption),
					kG: $elm$core$Maybe$Just(selectedSortOption)
				})
			]));
};
var $author$project$Pages$Users$MlnComnet$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$Hour$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$MlnComnet$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$MlnComnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$MlnComnet$Hour$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$MlnComnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$MlnComnet$Hour$viewSortSelector(model.kG),
				$author$project$Pages$Users$MlnComnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$MlnComnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$MlnComnet$Hour$viewProductFilter(model),
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row description')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 lowerPriceTd')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('参考価格を下回る')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 lowestPriceTd')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('当該機種の最低価格')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 lowestButHigherThanBasePriceTd')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('最低価格だが参考価格より上')
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3 pastPriceTd')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('当該時刻に取得できず参考として前回価格を表示')
										]))
								]))
						])),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$MlnComnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$MlnComnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$MlnComnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$MlnComnet$Hour$viewContent, model, $author$project$Pages$Users$MlnComnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$MlnComnet$Hour$pStoreHeader, $author$project$Pages$Users$MlnComnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$MlnComnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$Hour$viewContentDefault(model),
		iB: 'WEB価格'
	};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$pStoreGroupsHeader = function (storeGroups) {
	return A2(
		$elm$core$List$cons,
		{bB: 4, iv: -1, kR: ''},
		A2(
			$elm$core$List$map,
			function (storeGroup) {
				return {
					bB: $elm$core$List$length(storeGroup.aN),
					iv: storeGroup.iv,
					kR: storeGroup.kR
				};
			},
			A2(
				$elm$core$List$filter,
				function (storeGroup) {
					return A2(
						$elm$core$List$any,
						function (store) {
							return store.iw === 1;
						},
						storeGroup.aN);
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return !$elm$core$List$isEmpty(storeGroup.aN);
					},
					A2(
						$elm$core$List$map,
						function (storeGroup) {
							return _Utils_update(
								storeGroup,
								{
									aN: A2(
										$elm$core$List$filter,
										function (store) {
											return store.iw === 1;
										},
										storeGroup.aN)
								});
						},
						A2(
							$elm$core$List$filter,
							function (storeGroup) {
								return storeGroup.iv === 1;
							},
							storeGroups))))));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$MlnComnet$HourYamada$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$MlnComnet$HourYamada$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$MlnComnet$HourYamada$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnSubmit = {$: 8};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$HourYamada$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('中分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$HourYamada$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$HourYamada$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$MlnComnet$HourYamada$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$HourYamada$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$HourYamada$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnChangeDisplayStyle = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column mr-3')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$MlnComnet$HourYamada$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$HourYamada$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$MlnComnet$HourYamada$OnChangeSortOption = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewSortSelector = function (selectedSortOption) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示順')
					])),
				$author$project$Components$Molecules$SortTableSelector$sortTableSelector(
				{
					j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$HourYamada$OnChangeSortOption),
					kG: $elm$core$Maybe$Just(selectedSortOption)
				})
			]));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$MlnComnet$HourYamada$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$MlnComnet$HourYamada$viewSortSelector(model.kG),
				$author$project$Pages$Users$MlnComnet$HourYamada$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$MlnComnet$HourYamada$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = pStoreHeader_(model.X);
		var headerStoreGroups = pStoreGroupsHeader_(model.X);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$MlnComnet$HourYamada$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$MlnComnet$HourYamada$viewTableControl(model),
							$author$project$Pages$Users$MlnComnet$HourYamada$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$MlnComnet$HourYamada$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$MlnComnet$HourYamada$viewContent, model, $author$project$Pages$Users$MlnComnet$HourYamada$pStoreGroupsHeader, $author$project$Pages$Users$MlnComnet$HourYamada$pStoreHeader, $author$project$Pages$Users$MlnComnet$HourYamada$pProductPriceRows);
};
var $author$project$Pages$Users$MlnComnet$HourYamada$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$HourYamada$viewContentDefault(model),
		iB: 'ヤマダ下取り価格'
	};
};
var $author$project$Pages$Users$MlnComnet$MailSetting$OnInputQuery = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Users$MlnComnet$MailSetting$OnAddMail = {$: 8};
var $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeNewEndTime = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeNewStartTime = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$OnInputNewMailAddress = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$TimeSelector$parseTime = function (timeStr) {
	var _v0 = A2($elm$core$String$split, ':', timeStr);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var hour = _v0.a;
		var _v1 = _v0.b;
		var minute = _v1.a;
		return _Utils_Tuple2(hour, minute);
	} else {
		return _Utils_Tuple2('00', '00');
	}
};
var $author$project$Components$TimeSelector$timeSelectorDivide = F3(
	function (interval, initVal, toMsg) {
		var _v0 = $author$project$Components$TimeSelector$parseTime(initVal);
		var initHour = _v0.a;
		var initMinute = _v0.b;
		var hourOptions = A2(
			$elm$core$List$map,
			function (hour) {
				var hourStr = A2(
					$elm$core$String$right,
					2,
					'0' + $elm$core$String$fromInt(hour));
				return A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(hourStr),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(hourStr, initHour))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(hourStr)
						]));
			},
			A2($elm$core$List$range, 0, 23));
		var minuteOptions = A2(
			$elm$core$List$map,
			function (minute) {
				var minuteStr = A2(
					$elm$core$String$right,
					2,
					'0' + $elm$core$String$fromInt(minute));
				return A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value(minuteStr),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							_Utils_eq(minuteStr, initMinute))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(minuteStr)
						]));
			},
			A2(
				$elm$core$List$filter,
				function (min) {
					return !A2($elm$core$Basics$modBy, interval, min);
				},
				A2($elm$core$List$range, 0, 59)));
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'display', 'flex')
				]),
			_List_fromArray(
				[
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									function (h) {
										return A2(toMsg, h, initMinute);
									})
								]))
						]),
					hourOptions),
					$rtfeldman$elm_css$Html$Styled$text('：'),
					A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									function (m) {
										return A2(toMsg, initHour, m);
									})
								]))
						]),
					minuteOptions)
				]));
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$viewAddTr = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$px(20))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$px(400))
							]))
					]),
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bI),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$MailSetting$OnInputNewMailAddress)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$px(80))
							]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('')
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$px(200))
							]))
					]),
				_List_fromArray(
					[
						A3($author$project$Components$TimeSelector$timeSelectorDivide, 10, model.cH, $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeNewStartTime)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$width(
								$rtfeldman$elm_css$Css$px(200))
							]))
					]),
				_List_fromArray(
					[
						A3($author$project$Components$TimeSelector$timeSelectorDivide, 10, model.cG, $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeNewEndTime)
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$MlnComnet$MailSetting$OnAddMail)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('追加')
							]))
					]))
			]));
};
var $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeMail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Users$MlnComnet$MailSetting$OnDeleteAddress = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$MlnComnet$MailSetting$viewTr = F2(
	function (index, mail) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(20))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(index))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(400))
								]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(mail.jU)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(80))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(mail.fl),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									function (b) {
										return $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeMail(
											_Utils_update(
												mail,
												{fl: b}));
									})
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(200))
								]))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$TimeSelector$timeSelectorDivide,
							10,
							A2($elm$core$Maybe$withDefault, '00:00', mail.gK),
							F2(
								function (hourStr, minuteStr) {
									return $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeMail(
										_Utils_update(
											mail,
											{
												gK: $elm$core$Maybe$Just(hourStr + (':' + minuteStr))
											}));
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$width(
									$rtfeldman$elm_css$Css$px(200))
								]))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Components$TimeSelector$timeSelectorDivide,
							10,
							A2($elm$core$Maybe$withDefault, '00:00', mail.fm),
							F2(
								function (hourStr, minuteStr) {
									return $author$project$Pages$Users$MlnComnet$MailSetting$OnChangeMail(
										_Utils_update(
											mail,
											{
												fm: $elm$core$Maybe$Just(hourStr + (':' + minuteStr))
											}));
								}))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$MlnComnet$MailSetting$OnDeleteAddress(mail.mF))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('削除')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$MlnComnet$MailSetting$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.fC;
				switch (_v0.$) {
					case 0:
						return $author$project$Components$Loading$loadingCenter(50.0);
					case 1:
						return $author$project$Components$Loading$loadingCenter(50.0);
					case 2:
						var e = _v0.a;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Utils$Helpers$errToStr(e))
								]));
					default:
						var res = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '900px')
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5 mb-5'),
											$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
										]),
									_List_fromArray(
										[
											A2($rtfeldman$elm_css$Html$Styled$ul, _List_Nil, _List_Nil)
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-direction-row align-items-center mb-2')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$class('pr-2')
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('検索:')
														]))
												])),
											$frandibar$elm_bootstrap$Bootstrap$Form$Input$text(
											_List_fromArray(
												[
													$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
													_List_fromArray(
														[
															A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '400px')
														])),
													$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$MlnComnet$MailSetting$OnInputQuery)
												]))
										])),
									A2(
									$rtfeldman$elm_css$Html$Styled$table,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$thead,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$tr,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '20px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '400px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('メールアドレス')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('有効')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('開始時刻')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '200px')
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('終了時刻')
																])),
															A2(
															$rtfeldman$elm_css$Html$Styled$th,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('削除')
																]))
														]))
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$tbody,
											_List_Nil,
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Pages$Users$MlnComnet$MailSetting$viewAddTr(model)
													]),
												A2(
													$elm$core$List$indexedMap,
													F2(
														function (i, mail) {
															return A2($author$project$Pages$Users$MlnComnet$MailSetting$viewTr, i + 1, mail);
														}),
													A2(
														$elm$core$List$filter,
														function (mail) {
															return (model.bN === '') || A2(
																$elm$core$String$contains,
																$elm$core$String$toLower(model.bN),
																$elm$core$String$toLower(mail.jU));
														},
														res.bF))))
										]))
								]));
				}
			}()
			]));
};
var $author$project$Pages$Users$MlnComnet$MailSetting$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$MailSetting$viewContent(model),
		iB: '送信時間設定'
	};
};
var $author$project$Pages$Users$MlnComnet$Yahoo$OnChangeDirectURL = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$MlnComnet$Yahoo$OnEnableDirectURL = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$MlnComnet$Yahoo$OnSubmit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$MlnComnet$Yahoo$SelectProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Molecules$ProductSelector$Config = $elm$core$Basics$identity;
var $author$project$Components$Molecules$ProductSelector$custom = {ig: $elm$core$Maybe$Nothing, gD: $elm$core$Maybe$Nothing, iD: '全て選択'};
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $author$project$Components$Molecules$ProductSelector$view = F3(
	function (props, attrs, _v0) {
		var conf = _v0;
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(attrs),
					A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$disabled(true),
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange,
					props.j3)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$value('-1'),
							$rtfeldman$elm_css$Html$Styled$Attributes$selected(
							A2($elm$core$Maybe$withDefault, '-1', props.ih) === '-1')
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(conf.iD)
						])),
				A2(
					$elm$core$List$map,
					function (product) {
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(product.kl),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(
										A2($elm$core$Maybe$withDefault, '', props.ih),
										product.kl))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(product.nk)
								]));
					},
					A2(
						$elm$core$List$filter,
						function (product) {
							return _Utils_eq(conf.gD, $elm$core$Maybe$Nothing) || (_Utils_eq(
								conf.gD,
								$elm$core$Maybe$Just(-1)) || _Utils_eq(
								A2($elm$core$Maybe$withDefault, -1, conf.gD),
								product.ir));
						},
						A2(
							$elm$core$List$filter,
							function (product) {
								return _Utils_eq(conf.ig, $elm$core$Maybe$Nothing) || (_Utils_eq(
									conf.ig,
									$elm$core$Maybe$Just(-1)) || _Utils_eq(
									A2($elm$core$Maybe$withDefault, -1, conf.ig),
									product.e_));
							},
							props.kn)))));
	});
var $author$project$Components$Molecules$ProductSelector$withUnselectedLabel = F2(
	function (label, _v0) {
		var conf = _v0;
		return _Utils_update(
			conf,
			{iD: label});
	});
var $author$project$Pages$Users$MlnComnet$Yahoo$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$maxWidth(
						$rtfeldman$elm_css$Css$px(780)),
						$rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$auto)
					]))
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.fC;
				if (_v0.$ === 3) {
					var initRes = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$p,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('YahooのURLを設定する商品を選択してください')
											])),
										A3(
										$author$project$Components$Molecules$ProductSelector$view,
										{
											j3: $elm$core$Maybe$Just($author$project$Pages$Users$MlnComnet$Yahoo$SelectProduct),
											kn: initRes.kn,
											ih: $elm$core$Maybe$Just(model.ii)
										},
										_List_Nil,
										A2($author$project$Components$Molecules$ProductSelector$withUnselectedLabel, '選択してください', $author$project$Components$Molecules$ProductSelector$custom))
									])),
								function () {
								var _v1 = model.aY;
								if (_v1.$ === 3) {
									var urls = _v1.a;
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[
														$rtfeldman$elm_css$Css$marginTop(
														$rtfeldman$elm_css$Css$px(24)),
														$rtfeldman$elm_css$Css$marginBottom(
														$rtfeldman$elm_css$Css$px(40))
													]))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$p,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('YahooのURLを設定してください')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$table,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table '),
														A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'word-break', 'keep-all')
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$thead,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('店舗名')
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$css(
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Css$width(
																				$rtfeldman$elm_css$Css$px(600))
																			]))
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('URL')
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('有効')
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$th,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('更新')
																	]))
															])),
														A2(
														$rtfeldman$elm_css$Html$Styled$tbody,
														_List_Nil,
														A2(
															$elm$core$List$map,
															function (url) {
																var inputStatus = (url.eD === '') ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(_List_Nil) : ((A2($elm$core$String$startsWith, 'http://', url.eD) || A2($elm$core$String$startsWith, 'https://', url.eD)) ? $frandibar$elm_bootstrap$Bootstrap$Form$Input$success : $frandibar$elm_bootstrap$Bootstrap$Form$Input$danger);
																return A2(
																	$rtfeldman$elm_css$Html$Styled$tr,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$rtfeldman$elm_css$Html$Styled$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$text(url.kS)
																				])),
																			A2(
																			$rtfeldman$elm_css$Html$Styled$td,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$css(
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Css$width(
																							$rtfeldman$elm_css$Css$px(600))
																						]))
																				]),
																			_List_fromArray(
																				[
																					$frandibar$elm_bootstrap$Bootstrap$Form$Input$url(
																					_List_fromArray(
																						[
																							$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(url.eD),
																							$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
																							A2($author$project$Pages$Users$MlnComnet$Yahoo$OnChangeDirectURL, url.cR, url.da)),
																							inputStatus
																						]))
																				])),
																			A2(
																			$rtfeldman$elm_css$Html$Styled$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$rtfeldman$elm_css$Html$Styled$input,
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$Attributes$type_('checkbox'),
																							$rtfeldman$elm_css$Html$Styled$Attributes$checked(url.fl),
																							$rtfeldman$elm_css$Html$Styled$Events$onCheck(
																							A2($author$project$Pages$Users$MlnComnet$Yahoo$OnEnableDirectURL, url.cR, url.da))
																						]),
																					_List_Nil)
																				])),
																			A2(
																			$rtfeldman$elm_css$Html$Styled$td,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$frandibar$elm_bootstrap$Bootstrap$Button$button,
																					_List_fromArray(
																						[
																							$frandibar$elm_bootstrap$Bootstrap$Button$disabled(
																							_Utils_eq(inputStatus, $frandibar$elm_bootstrap$Bootstrap$Form$Input$danger)),
																							$frandibar$elm_bootstrap$Bootstrap$Button$secondary,
																							$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
																							$author$project$Pages$Users$MlnComnet$Yahoo$OnSubmit(url))
																						]),
																					_List_fromArray(
																						[
																							$rtfeldman$elm_css$Html$Styled$text('更新')
																						]))
																				]))
																		]));
															},
															urls))
													]))
											]));
								} else {
									return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
								}
							}()
							]));
				} else {
					return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
				}
			}()
			]));
};
var $author$project$Pages$Users$MlnComnet$Yahoo$view = function (model) {
	return {
		lI: $author$project$Pages$Users$MlnComnet$Yahoo$viewContent(model),
		iB: 'Yahoo 直接取得URL設定'
	};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateAllProducts = {$: 7};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$Drop = {$: 11};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$ShaComnet$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$ShaComnet$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$ShaComnet$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$ShaComnet$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$ShaComnet$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$ShaComnet$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$ShaComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$ShaComnet$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$ShaComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ShaComnet$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$ShaComnet$Day$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$Day$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																lowestClass,
																_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass)))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$ShaComnet$Day$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$ShaComnet$Day$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$Day$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$ShaComnet$Day$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$ShaComnet$Day$Nop = {$: 18};
var $author$project$Pages$Users$ShaComnet$Day$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$OnChangeMaker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$OnSubmit = {$: 12};
var $author$project$Pages$Users$ShaComnet$Day$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$ShaComnet$Day$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('量販店')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$ShaComnet$Day$OnChangeStore,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Day$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Day$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Day$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$ShaComnet$Day$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$ShaComnet$Day$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$Day$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$ShaComnet$Day$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$ShaComnet$Day$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$ShaComnet$Day$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$ShaComnet$Day$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$ShaComnet$Day$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$Day$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$ShaComnet$Day$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$ShaComnet$Day$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$ShaComnet$Day$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$ShaComnet$Day$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$Day$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$ShaComnet$Day$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$ShaComnet$Day$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$ShaComnet$Day$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$ShaComnet$Day$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$ShaComnet$Day$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$ShaComnet$Day$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$ShaComnet$Day$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$ShaComnet$Day$viewTableControl(model),
						$author$project$Pages$Users$ShaComnet$Day$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$ShaComnet$Day$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ShaComnet$Day$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '本日掲載された機種と価格';
			}
		}()
	};
};
var $author$project$Pages$Users$ShaComnet$Hour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$ShaComnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$ShaComnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$ShaComnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$ShaComnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$OnSubmit = {$: 8};
var $author$project$Pages$Users$ShaComnet$Hour$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$ShaComnet$Hour$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ShaComnet$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$ShaComnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$ShaComnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$ShaComnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$ShaComnet$Hour$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$ShaComnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$ShaComnet$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$ShaComnet$Hour$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$ShaComnet$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$ShaComnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$Hour$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$ShaComnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$ShaComnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$ShaComnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$ShaComnet$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$ShaComnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$ShaComnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$ShaComnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$ShaComnet$Hour$viewContent, model, $author$project$Pages$Users$ShaComnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$ShaComnet$Hour$pStoreHeader, $author$project$Pages$Users$ShaComnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$ShaComnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ShaComnet$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$ShaComnet$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$Nop = {$: 17};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$ShaComnet$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$ShaComnet$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$ShaComnet$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$ShaComnet$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$TimeSeq$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$ShaComnet$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$ShaComnet$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$ShaComnet$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$ShaComnet$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$ShaComnet$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$ShaComnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$ShaComnet$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$ShaComnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$ShaComnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ShaComnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return (item.jP !== '__blank__') ? A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	])) : A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '5em')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('')
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$WeeklyProduct$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$ShaComnet$WeeklyProduct$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnSubmit = {$: 8};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ShaComnet$WeeklyProduct$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$WeeklyProduct$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$WeeklyProduct$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$WeeklyProduct$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$ShaComnet$WeeklyProduct$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$WeeklyProduct$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$ShaComnet$WeeklyProduct$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$WeeklyProduct$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$ShaComnet$WeeklyProduct$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$ShaComnet$WeeklyProduct$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$ShaComnet$WeeklyProduct$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$ShaComnet$WeeklyProduct$viewTableControl(model),
							$author$project$Pages$Users$ShaComnet$WeeklyProduct$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$ShaComnet$WeeklyProduct$viewContent, model, $author$project$Pages$Users$ShaComnet$WeeklyProduct$pStoreGroupsHeader, $author$project$Pages$Users$ShaComnet$WeeklyProduct$pStoreHeader, $author$project$Pages$Users$ShaComnet$WeeklyProduct$pProductPriceRows);
};
var $author$project$Pages$Users$ShaComnet$WeeklyProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ShaComnet$WeeklyProduct$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$ShaComnet$Wide$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$ShaComnet$Wide$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$ShaComnet$Wide$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$ShaComnet$Wide$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$Wide$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$ShaComnet$Wide$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$ShaComnet$Wide$OnChangeBigCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$OnChangeMaker = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$OnChangeSmallCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$OnSubmit = {$: 8};
var $author$project$Pages$Users$ShaComnet$Wide$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Wide$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Wide$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$ShaComnet$Wide$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$ShaComnet$Wide$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$disabled(!model.c2),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$Wide$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$ShaComnet$Wide$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$ShaComnet$Wide$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$ShaComnet$Wide$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$ShaComnet$Wide$OnPressDownloadCSV = {$: 9};
var $author$project$Pages$Users$ShaComnet$Wide$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$ShaComnet$Wide$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$ShaComnet$Wide$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$ShaComnet$Wide$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$ShaComnet$Wide$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$ShaComnet$Wide$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$ShaComnet$Wide$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$ShaComnet$Wide$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$ShaComnet$Wide$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$ShaComnet$Wide$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$ShaComnet$Wide$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$ShaComnet$Wide$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$ShaComnet$Wide$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$ShaComnet$Wide$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$ShaComnet$Wide$viewTableControl(model),
						$author$project$Pages$Users$ShaComnet$Wide$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$ShaComnet$Wide$view = function (model) {
	return {
		lI: $author$project$Pages$Users$ShaComnet$Wide$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return 'NET-WIDE 掲載された機種と価格の時間変化(24回版)';
			}
		}()
	};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateAllProducts = {$: 8};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateTriggerFlag = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$Drop = {$: 12};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$TescomComnet$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$TescomComnet$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$TescomComnet$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$TescomComnet$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$TescomComnet$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$TescomComnet$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.n$),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateTriggerFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$TescomComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は税込みです')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TescomComnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table tescom-comnet')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('ヨドバシを')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格に')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('トリガーを')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('P算入後に')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$TescomComnet$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$TescomComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$TescomComnet$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$TescomComnet$Excel$Nop = {$: 13};
var $author$project$Pages$Users$TescomComnet$Excel$OnChangeBigCategory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$OnChangeSmallCategory = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$OnSubmit = {$: 10};
var $author$project$Pages$Users$TescomComnet$Excel$OnUpdateDateFrom = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$OnUpdateDateTo = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$OnUpdateTimeFrom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$OnUpdateTimeTo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$TescomComnet$Excel$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TescomComnet$Excel$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TescomComnet$Excel$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$TescomComnet$Excel$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$TescomComnet$Excel$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TescomComnet$Excel$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TescomComnet$Excel$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TescomComnet$Excel$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TescomComnet$Excel$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TescomComnet$Excel$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$TescomComnet$Excel$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$TescomComnet$Excel$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Alert$simpleDanger,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								A2($elm$core$Maybe$withDefault, '', model.H))
							]))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Users$TescomComnet$Excel$view = function (model) {
	return {
		lI: $author$project$Pages$Users$TescomComnet$Excel$viewContent(model),
		iB: 'エクセル出力'
	};
};
var $author$project$Pages$Users$TescomComnet$Hour$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TescomComnet$Hour$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(pastClass, lowerClass))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$TescomComnet$Hour$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$TescomComnet$Hour$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TescomComnet$Hour$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$TescomComnet$Hour$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$TescomComnet$Hour$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$OnSubmit = {$: 8};
var $author$project$Pages$Users$TescomComnet$Hour$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$TescomComnet$Hour$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TescomComnet$Hour$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TescomComnet$Hour$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TescomComnet$Hour$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TescomComnet$Hour$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TescomComnet$Hour$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TescomComnet$Hour$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$TescomComnet$Hour$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$TescomComnet$Hour$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$TescomComnet$Hour$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$TescomComnet$Hour$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$TescomComnet$Hour$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TescomComnet$Hour$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$TescomComnet$Hour$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$TescomComnet$Hour$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$TescomComnet$Hour$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$TescomComnet$Hour$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TescomComnet$Hour$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$TescomComnet$Hour$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$TescomComnet$Hour$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$TescomComnet$Hour$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$TescomComnet$Hour$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$TescomComnet$Hour$viewTableControl(model),
							$author$project$Pages$Users$TescomComnet$Hour$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$TescomComnet$Hour$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$TescomComnet$Hour$viewContent, model, $author$project$Pages$Users$TescomComnet$Hour$pStoreGroupsHeader, $author$project$Pages$Users$TescomComnet$Hour$pStoreHeader, $author$project$Pages$Users$TescomComnet$Hour$pProductPriceRows);
};
var $author$project$Pages$Users$TescomComnet$Hour$view = function (model) {
	return {
		lI: $author$project$Pages$Users$TescomComnet$Hour$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$Test$Fifteen$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Test$Fifteen$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Test$Fifteen$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Test$Fifteen$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Test$Fifteen$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Test$Fifteen$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Test$Fifteen$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$OnSubmit = {$: 8};
var $author$project$Pages$Users$Test$Fifteen$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Test$Fifteen$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Test$Fifteen$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Test$Fifteen$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Test$Fifteen$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Test$Fifteen$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Test$Fifteen$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Test$Fifteen$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Test$Fifteen$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Test$Fifteen$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Test$Fifteen$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Test$Fifteen$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Test$Fifteen$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Test$Fifteen$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Test$Fifteen$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Test$Fifteen$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Test$Fifteen$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Test$Fifteen$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Test$Fifteen$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Test$Fifteen$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Test$Fifteen$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Test$Fifteen$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Test$Fifteen$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Test$Fifteen$viewTableControl(model),
							$author$project$Pages$Users$Test$Fifteen$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Test$Fifteen$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Test$Fifteen$viewContent, model, $author$project$Pages$Users$Test$Fifteen$pStoreGroupsHeader, $author$project$Pages$Users$Test$Fifteen$pStoreHeader, $author$project$Pages$Users$Test$Fifteen$pProductPriceRows);
};
var $author$project$Pages$Users$Test$Fifteen$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Test$Fifteen$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateAllProducts = {$: 7};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$UpdateAnyPoint = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$Drop = {$: 11};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$To24tclComnet$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$To24tclComnet$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$To24tclComnet$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$To24tclComnet$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$viewTr = F5(
	function (product, ind, dragFrom, dragTo, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						product.dM ? ('targetDrop' + function () {
							var _v0 = _Utils_Tuple2(dragFrom, dragTo);
							if ((!_v0.a.$) && (!_v0.b.$)) {
								var from = _v0.a.a;
								var to = _v0.b.a;
								return (_Utils_cmp(from, to) > 0) ? 'Up' : 'Down';
							} else {
								return '';
							}
						}()) : ''),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!dragFrom.$) {
								var draggingInd = dragFrom.a;
								return _Utils_eq(ind, draggingInd) ? 'srcDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$To24tclComnet$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$To24tclComnet$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(base_price_without_point)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 101) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 102) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 103) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 105) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 110) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 113) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 115) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								if (!anyPoint.$) {
									var point = anyPoint.a;
									return $author$project$Utils$Helpers$toCommmaSplited(
										$elm$core$String$fromInt(((base_price_without_point * (100 + point)) / 100) | 0));
								} else {
									return '';
								}
							}())
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は想定売価（税抜き）です')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tclComnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込 P後')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('1%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('2%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('3%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('5%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('10%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('13%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('15%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('small float-left')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('任意%入力')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$To24tclComnet$ChangeProduct$UpdateAnyPoint),
														$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
														_List_fromArray(
															[
																A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px'),
																$rtfeldman$elm_css$Html$Styled$Attributes$max('100'),
																$rtfeldman$elm_css$Html$Styled$Attributes$min('0')
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ヨドバシ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A5($author$project$Pages$Users$To24tclComnet$ChangeProduct$viewTr, product, ind, model.cl, model.dy, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$To24tclComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tclComnet$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$To24tclComnet$Day$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tclComnet$Day$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'dayHeader';
																	case 3:
																		return 'itemHeader';
																	case 4:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$To24tclComnet$Day$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'dayHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$To24tclComnet$Day$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tclComnet$Day$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$To24tclComnet$Day$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$To24tclComnet$Day$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$To24tclComnet$Day$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tclComnet$Day$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tclComnet$Day$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tclComnet$Day$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('本日分を表示')
					]))
			]));
};
var $author$project$Pages$Users$To24tclComnet$Day$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$To24tclComnet$Day$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$To24tclComnet$Day$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$To24tclComnet$Day$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$To24tclComnet$Day$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tclComnet$Day$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$To24tclComnet$Day$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$To24tclComnet$Day$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$To24tclComnet$Day$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$To24tclComnet$Day$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tclComnet$Day$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$To24tclComnet$Day$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$To24tclComnet$Day$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$To24tclComnet$Day$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$To24tclComnet$Day$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$To24tclComnet$Day$viewTableControl(model),
							$author$project$Pages$Users$To24tclComnet$Day$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$To24tclComnet$Day$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$To24tclComnet$Day$viewContent, model, $author$project$Pages$Users$To24tclComnet$Day$pStoreGroupsHeader, $author$project$Pages$Users$To24tclComnet$Day$pStoreHeader, $author$project$Pages$Users$To24tclComnet$Day$pProductPriceRows);
};
var $author$project$Pages$Users$To24tclComnet$Day$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tclComnet$Day$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tclComnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 ')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Common$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('emptyMultiselectPlaceholder text-dark')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$To24tclComnet$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Common$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Common$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Common$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$To24tclComnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Common$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$Common$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$To24tclComnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tclComnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateAllProducts = {$: 8};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$UpdateAnyPoint = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateBasePoint = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateInterval = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$Drop = {$: 12};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$To24tcmComnet$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$To24tcmComnet$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$To24tcmComnet$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$To24tcmComnet$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$intToOption = F2(
	function (selected_v, v) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$option,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$value(
					$elm$core$String$fromInt(v)),
					$rtfeldman$elm_css$Html$Styled$Attributes$selected(
					_Utils_eq(v, selected_v))
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(
					$elm$core$String$fromInt(v))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		var base_price_without_point = A2($author$project$Utils$Helpers$calculatePriceWithoutPoint, product.lt, product.ls);
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$To24tcmComnet$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$To24tcmComnet$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$select,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onInput(
									$author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateInterval(ind)),
									A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Pages$Users$To24tcmComnet$ChangeProduct$intToOption(product.ju),
								_List_fromArray(
									[15, 60, 360])))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.ls)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '80px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateBasePoint(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(base_price_without_point)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 101) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 102) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 103) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 105) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 107) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Utils$Helpers$toCommmaSplited(
								$elm$core$String$fromInt(((base_price_without_point * 110) / 100) | 0)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							function () {
								if (!anyPoint.$) {
									var point = anyPoint.a;
									return $author$project$Utils$Helpers$toCommmaSplited(
										$elm$core$String$fromInt(((base_price_without_point * (100 + point)) / 100) | 0));
								} else {
									return '';
								}
							}())
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は想定売価（税抜き）です')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmComnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										function () {
										var intervalSum = $author$project$Pages$Users$To24tcmComnet$ChangeProduct$getIntervalSum(model.kn);
										return A2(
											$rtfeldman$elm_css$Html$Styled$th,
											(intervalSum > 140) ? _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'color', '#f33'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'font-size', '150%'),
													A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'background-color', '#fb4')
												]) : _List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													(intervalSum > 140) ? _List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Interval Exceeded')
														]) : _List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text('Interval')
														])),
													A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
													A2(
													$rtfeldman$elm_css$Html$Styled$span,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$elm$core$String$fromInt(
																$author$project$Pages$Users$To24tcmComnet$ChangeProduct$getIntervalSum(model.kn)) + '/140')
														]))
												]));
									}(),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ポイント')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('基準価格')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_Nil,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('税込 P後')
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('1%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('2%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('3%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('5%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('7%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('10%')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$span,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$class('small float-left')
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('任意%入力')
													])),
												A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
												$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$To24tcmComnet$ChangeProduct$UpdateAnyPoint),
														$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
														_List_fromArray(
															[
																A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100px'),
																$rtfeldman$elm_css$Html$Styled$Attributes$max('100'),
																$rtfeldman$elm_css$Html$Styled$Attributes$min('0')
															]))
													]))
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ヨドバシ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$To24tcmComnet$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$To24tcmComnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tcmComnet$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$OnSubmit = {$: 8};
var $author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateDateFrom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateDateTo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateTimeFrom = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateTimeTo = function (a) {
	return {$: 7, a: a};
};
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $abadi199$elm_input_extra$MultiSelect$Option = F3(
	function (value, text, selected) {
		return {kC: selected, kY: text, m: value};
	});
var $abadi199$elm_input_extra$MultiSelect$optionDecoder = A4(
	$elm$json$Json$Decode$map3,
	$abadi199$elm_input_extra$MultiSelect$Option,
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'text', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'selected', $elm$json$Json$Decode$bool));
var $abadi199$elm_input_extra$MultiSelect$optionsDecoder = A2(
	$elm$json$Json$Decode$field,
	'options',
	A2(
		$elm$json$Json$Decode$andThen,
		function (list) {
			var onlySuccess = A3(
				$elm$core$List$foldr,
				F2(
					function (_v0, sofar) {
						var next = _v0.b;
						if (next.$ === 1) {
							return sofar;
						} else {
							var x = next.a;
							return A2($elm$core$List$cons, x, sofar);
						}
					}),
				_List_Nil,
				list);
			return $elm$json$Json$Decode$succeed(onlySuccess);
		},
		$elm$json$Json$Decode$keyValuePairs(
			$elm$json$Json$Decode$maybe($abadi199$elm_input_extra$MultiSelect$optionDecoder))));
var $abadi199$elm_input_extra$MultiSelect$selectedOptionsDecoder = function () {
	var filterSelected = function (options) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.m;
			},
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.kC;
				},
				options));
	};
	return A2(
		$elm$json$Json$Decode$map,
		filterSelected,
		A2($elm$json$Json$Decode$field, 'target', $abadi199$elm_input_extra$MultiSelect$optionsDecoder));
}();
var $abadi199$elm_input_extra$MultiSelect$onChange = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $abadi199$elm_input_extra$MultiSelect$selectedOptionsDecoder));
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $abadi199$elm_input_extra$MultiSelect$multiSelect = F3(
	function (options, attributes, currentValue) {
		var isSelected = function (value) {
			return A2(
				$elm$core$List$any,
				$elm$core$Basics$eq(value),
				currentValue);
		};
		var toOption = function (_v0) {
			var value = _v0.m;
			var text = _v0.kY;
			var enabled = _v0.fl;
			return A2(
				$elm$html$Html$option,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$value(value),
						$elm$html$Html$Attributes$selected(
						isSelected(value)),
						$elm$html$Html$Attributes$disabled(!enabled)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(text)
					]));
		};
		return A2(
			$elm$html$Html$select,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$abadi199$elm_input_extra$MultiSelect$onChange(options.j3),
						$elm$html$Html$Attributes$multiple(true)
					])),
			A2($elm$core$List$map, toOption, options.mx));
	});
var $author$project$Pages$Users$To24tcmComnet$Csv$UpdateMultiselect = function (a) {
	return {$: 10, a: a};
};
var $abadi199$elm_input_extra$MultiSelect$defaultOptions = function (onChangeHandler) {
	return {mx: _List_Nil, j3: onChangeHandler};
};
var $author$project$Pages$Users$To24tcmComnet$Csv$multiSelectOptions = function (model) {
	var defaultOptions = $abadi199$elm_input_extra$MultiSelect$defaultOptions($author$project$Pages$Users$To24tcmComnet$Csv$UpdateMultiselect);
	return _Utils_update(
		defaultOptions,
		{
			mx: A2(
				$elm$core$List$map,
				function (_v0) {
					var v = _v0.a;
					var t = _v0.b;
					return {fl: true, kY: t, m: v};
				},
				model.kn)
		});
};
var $elm$html$Html$Attributes$size = function (n) {
	return A2(
		_VirtualDom_attribute,
		'size',
		$elm$core$String$fromInt(n));
};
var $author$project$Pages$Users$To24tcmComnet$Csv$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 ')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('型番')
									])),
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
								A3(
									$abadi199$elm_input_extra$MultiSelect$multiSelect,
									$author$project$Pages$Users$To24tcmComnet$Csv$multiSelectOptions(model),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('multiSelectContainer'),
											$elm$html$Html$Attributes$id('products-selector'),
											$elm$html$Html$Attributes$size(18)
										]),
									model.ij))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date'),
												$rtfeldman$elm_css$Html$Styled$Attributes$max(model.d_),
												$rtfeldman$elm_css$Html$Styled$Attributes$min(model.d1)
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateDateFrom)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.il,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateTimeFrom)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('\u3000')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('align-middle')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('〜')
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得日')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$id('date'),
												$rtfeldman$elm_css$Html$Styled$Attributes$max(model.d_),
												$rtfeldman$elm_css$Html$Styled$Attributes$min(model.d1)
											])),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
										$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateDateTo)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('取得時刻')
									])),
								A3(
								$author$project$Components$TimeSelector$timeSelector,
								model.ac,
								model.im,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
										$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmComnet$Csv$OnUpdateTimeTo)
									]))
							])),
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$group,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Form$label,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('\u3000')
									])),
								A2(
								$frandibar$elm_bootstrap$Bootstrap$Button$button,
								_List_fromArray(
									[
										$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											])),
										$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmComnet$Csv$OnSubmit)
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('送信')
									]))
							]))
					])),
				(model.cv || model.dP) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Csv$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tcmComnet$Csv$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '期間指定CSV';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tcmComnet$Day$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmComnet$Day$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'dayHeader';
																	case 3:
																		return 'itemHeader';
																	case 4:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$To24tcmComnet$Day$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'dayHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$Day$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tcmComnet$Day$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$To24tcmComnet$Day$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Day$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$To24tcmComnet$Day$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmComnet$Day$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmComnet$Day$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmComnet$Day$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('本日分を表示')
					]))
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Day$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Day$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$To24tcmComnet$Day$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Day$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$To24tcmComnet$Day$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmComnet$Day$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$To24tcmComnet$Day$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmComnet$Day$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$To24tcmComnet$Day$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$Day$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tcmComnet$Day$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$To24tcmComnet$Day$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$To24tcmComnet$Day$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Day$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$To24tcmComnet$Day$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$To24tcmComnet$Day$viewTableControl(model),
							$author$project$Pages$Users$To24tcmComnet$Day$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$Day$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$To24tcmComnet$Day$viewContent, model, $author$project$Pages$Users$To24tcmComnet$Day$pStoreGroupsHeader, $author$project$Pages$Users$To24tcmComnet$Day$pStoreHeader, $author$project$Pages$Users$To24tcmComnet$Day$pProductPriceRows);
};
var $author$project$Pages$Users$To24tcmComnet$Day$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tcmComnet$Day$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tcmComnet$Product$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmComnet$Product$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$To24tcmComnet$Product$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$Product$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tcmComnet$Product$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$To24tcmComnet$Product$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Product$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$OnSubmit = {$: 8};
var $author$project$Pages$Users$To24tcmComnet$Product$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$To24tcmComnet$Product$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmComnet$Product$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmComnet$Product$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$To24tcmComnet$Product$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmComnet$Product$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmComnet$Product$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmComnet$Product$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Product$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$To24tcmComnet$Product$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Product$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$To24tcmComnet$Product$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmComnet$Product$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$To24tcmComnet$Product$OnToggleIncludeCouponPrice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$To24tcmComnet$Product$viewIncludeCouponPriceCheckbox = function (includeCouponPrice) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mb-2')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(includeCouponPrice),
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value('1')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck($author$project$Pages$Users$To24tcmComnet$Product$OnToggleIncludeCouponPrice)
					]),
				'クーポン価格を含む')
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Product$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmComnet$Product$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$To24tcmComnet$Product$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$Product$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mb-1')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column mr-3')
					]),
				_List_fromArray(
					[
						$author$project$Pages$Users$To24tcmComnet$Product$viewIncludeCouponPriceCheckbox(model.dI),
						A2($author$project$Pages$Users$To24tcmComnet$Product$viewStoreGroupCheckbox, model.X, model.L)
					])),
				$author$project$Pages$Users$To24tcmComnet$Product$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$To24tcmComnet$Product$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$To24tcmComnet$Product$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$To24tcmComnet$Product$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$To24tcmComnet$Product$viewTableControl(model),
							$author$project$Pages$Users$To24tcmComnet$Product$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$To24tcmComnet$Product$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$To24tcmComnet$Product$viewContent, model, $author$project$Pages$Users$To24tcmComnet$Product$pStoreGroupsHeader, $author$project$Pages$Users$To24tcmComnet$Product$pStoreHeader, $author$project$Pages$Users$To24tcmComnet$Product$pProductPriceRows);
};
var $author$project$Pages$Users$To24tcmComnet$Product$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tcmComnet$Product$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 ')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$Common$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('emptyMultiselectPlaceholder text-dark')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Common$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Common$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$Common$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$Common$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$Common$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$To24tcmComnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$Common$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$Common$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$To24tcmComnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tcmComnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 4, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																lowestClass,
																_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass)))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 5:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tcmFridge$HourMix$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$To24tcmFridge$HourMix$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$Nop = {$: 18};
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeBigCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeSmallCategory = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnSubmit = {$: 12};
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$To24tcmFridge$HourMix$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('量販店')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeStore,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.p))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.p)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeMaker,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.S))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.S)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$To24tcmFridge$HourMix$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmFridge$HourMix$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$To24tcmFridge$HourMix$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnPressDownloadCSV = {$: 13};
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmFridge$HourMix$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$To24tcmFridge$HourMix$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$To24tcmFridge$HourMix$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tcmFridge$HourMix$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$To24tcmFridge$HourMix$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$To24tcmFridge$HourMix$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$To24tcmFridge$HourMix$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$To24tcmFridge$HourMix$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$To24tcmFridge$HourMix$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$To24tcmFridge$HourMix$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$To24tcmFridge$HourMix$viewTableControl(model),
						$author$project$Pages$Users$To24tcmFridge$HourMix$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$To24tcmFridge$HourMix$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tcmFridge$HourMix$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '本日掲載された機種と価格';
			}
		}()
	};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'dayHeader';
																	case 3:
																		return 'itemHeader';
																	case 4:
																		return 'basePriceHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerClass = price.hL ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(lowestButHigherThanBasePriceClass, lowerClass))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'dayHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tcmKitchen$Day$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$To24tcmKitchen$Day$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$To24tcmKitchen$Day$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmKitchen$Day$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$To24tcmKitchen$Day$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmKitchen$Day$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('本日分を表示')
					]))
			]));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$To24tcmKitchen$Day$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$To24tcmKitchen$Day$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$To24tcmKitchen$Day$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$To24tcmKitchen$Day$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$To24tcmKitchen$Day$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$To24tcmKitchen$Day$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$To24tcmKitchen$Day$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$To24tcmKitchen$Day$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$To24tcmKitchen$Day$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$To24tcmKitchen$Day$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$To24tcmKitchen$Day$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$To24tcmKitchen$Day$viewTableControl(model),
							$author$project$Pages$Users$To24tcmKitchen$Day$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$To24tcmKitchen$Day$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$To24tcmKitchen$Day$viewContent, model, $author$project$Pages$Users$To24tcmKitchen$Day$pStoreGroupsHeader, $author$project$Pages$Users$To24tcmKitchen$Day$pStoreHeader, $author$project$Pages$Users$To24tcmKitchen$Day$pProductPriceRows);
};
var $author$project$Pages$Users$To24tcmKitchen$Day$view = function (model) {
	return {
		lI: $author$project$Pages$Users$To24tcmKitchen$Day$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $author$project$Pages$Users$TsBat$TimeSeq$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TsBat$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$TsBat$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$TsBat$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TsBat$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$TsBat$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$TsBat$TimeSeq$Nop = {$: 17};
var $author$project$Pages$Users$TsBat$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$TsBat$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TsBat$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TsBat$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$TsBat$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$TsBat$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TsBat$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TsBat$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TsBat$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TsBat$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TsBat$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$TsBat$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$TsBat$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$TsBat$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$TsBat$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TsBat$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$TsBat$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$TsBat$TimeSeq$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$TsBat$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$TsBat$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TsBat$TimeSeq$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$TsBat$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$TsBat$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$TsBat$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$TsBat$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$TsBat$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$TsBat$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$TsBat$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$TsBat$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$TsBat$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$TsBat$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$TsBat$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return '2回 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$TsBat$Wide$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TsBat$Wide$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$TsBat$Wide$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$TsBat$Wide$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TsBat$Wide$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$TsBat$Wide$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$TsBat$Wide$OnChangeBigCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$OnChangeMaker = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$OnChangeSmallCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$OnSubmit = {$: 8};
var $author$project$Pages$Users$TsBat$Wide$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TsBat$Wide$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TsBat$Wide$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TsBat$Wide$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TsBat$Wide$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TsBat$Wide$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$TsBat$Wide$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$TsBat$Wide$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$TsBat$Wide$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$TsBat$Wide$OnPressDownloadCSV = {$: 9};
var $author$project$Pages$Users$TsBat$Wide$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TsBat$Wide$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$TsBat$Wide$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$TsBat$Wide$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$TsBat$Wide$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$TsBat$Wide$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TsBat$Wide$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$TsBat$Wide$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$TsBat$Wide$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$TsBat$Wide$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$TsBat$Wide$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$TsBat$Wide$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$TsBat$Wide$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$TsBat$Wide$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$TsBat$Wide$viewTableControl(model),
						$author$project$Pages$Users$TsBat$Wide$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$TsBat$Wide$view = function (model) {
	return {
		lI: $author$project$Pages$Users$TsBat$Wide$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return 'NET-WIDE 掲載された機種と価格の時間変化(2回版)';
			}
		}()
	};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$TstComnet$TimeSeq$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TstComnet$TimeSeq$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$TstComnet$TimeSeq$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$TstComnet$TimeSeq$Nop = {$: 17};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnChangeBigCategory = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnChangeSmallCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnSubmit = {$: 11};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateDateTo = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateTimeFrom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateTimeTo = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TstComnet$TimeSeq$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TstComnet$TimeSeq$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3 '),
								$author$project$Utils$Helpers$preventDefaultEnter($author$project$Pages$Users$TstComnet$TimeSeq$Nop)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('型番')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('multiSelectContainer'),
								$rtfeldman$elm_css$Html$Styled$Attributes$class(
								model.ha ? 'multiSelectWarning' : '')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$map,
								$author$project$Pages$Users$TstComnet$TimeSeq$OnChangeProduct,
								$rtfeldman$elm_css$Html$Styled$fromUnstyled(
									$inkuzmin$elm_multiselect$Multiselect$view(model.E))),
								$elm$core$List$isEmpty(
								$inkuzmin$elm_multiselect$Multiselect$getSelectedValues(model.E)) ? A2(
								$rtfeldman$elm_css$Html$Styled$span,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('allSelectMultiselectPlaceholder')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('全て選択')
									])) : A2($rtfeldman$elm_css$Html$Styled$span, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('flex-break')
					]),
				_List_Nil),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.il,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.il),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateTimeFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cZ),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateDateTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.im,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.im),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TstComnet$TimeSeq$OnUpdateTimeTo)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TstComnet$TimeSeq$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$TstComnet$TimeSeq$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$TstComnet$TimeSeq$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$TstComnet$TimeSeq$OnPressDownloadCSV = {$: 12};
var $author$project$Pages$Users$TstComnet$TimeSeq$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TstComnet$TimeSeq$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$TstComnet$TimeSeq$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$TstComnet$TimeSeq$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$TstComnet$TimeSeq$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TstComnet$TimeSeq$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$TstComnet$TimeSeq$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$TstComnet$TimeSeq$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$TstComnet$TimeSeq$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$TstComnet$TimeSeq$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$TstComnet$TimeSeq$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$TstComnet$TimeSeq$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$TstComnet$TimeSeq$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$TstComnet$TimeSeq$viewTableControl(model),
						$author$project$Pages$Users$TstComnet$TimeSeq$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$TstComnet$TimeSeq$view = function (model) {
	return {
		lI: $author$project$Pages$Users$TstComnet$TimeSeq$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得 時系列';
			}
		}()
	};
};
var $author$project$Pages$Users$TstComnet$Wide$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$TstComnet$Wide$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (productRow) {
					return A2(
						$elm$core$List$indexedMap,
						function (rowInd) {
							return function (row) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_Nil,
									$elm$core$List$concat(
										A2(
											$elm$core$List$indexedMap,
											function (ind) {
												return function (cell) {
													switch (cell.$) {
														case 0:
															var _v1 = cell.a;
															var rowspan = _v1.a;
															var itemList = _v1.b;
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(
																			function () {
																				var fixedInd = (!rowInd) ? ind : (ind + 2);
																				switch (fixedInd) {
																					case 0:
																						return 'numberHeader';
																					case 1:
																						return 'katabanHeader';
																					case 2:
																						return 'nthHeader';
																					case 3:
																						return 'itemHeader';
																					case 4:
																						return 'basePriceHeader';
																					default:
																						return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$rowspan(rowspan)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$p,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]));
																		},
																		itemList))
																]);
														case 1:
															return _List_fromArray(
																[
																	A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
																]);
														default:
															var price = cell.a;
															var priceChangingTypeClass = function () {
																var _v5 = price.ge;
																switch (_v5.$) {
																	case 0:
																		return 'increasedPriceTd ';
																	case 1:
																		return 'decreasedPriceTd ';
																	default:
																		return '';
																}
															}();
															var comparedPriceType = function () {
																var _v4 = price.du;
																switch (_v4) {
																	case 0:
																		return 'lowestPriceTd';
																	case 2:
																		return 'lowestButHigherThanBasePriceTd ';
																	case 1:
																		return 'lowerPriceTd';
																	default:
																		return '';
																}
															}();
															return _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$td,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(comparedPriceType),
																			$rtfeldman$elm_css$Html$Styled$Attributes$class(priceChangingTypeClass)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (item) {
																			var _v3 = item.m;
																			switch (_v3) {
																				case 2:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				case 4:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(item.jP)
																							]));
																				default:
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$a,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																										$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(item.jP)
																									]))
																							]));
																			}
																		},
																		price.h6))
																]);
													}
												};
											},
											row)));
							};
						},
						productRow);
				},
				bodyProducts)));
};
var $author$project$Pages$Users$TstComnet$Wide$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'nthHeader rowHeader';
														case 3:
															return 'itemHeader rowHeader';
														case 4:
															return 'basePriceHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$TstComnet$Wide$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum)))
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TstComnet$Wide$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$TstComnet$Wide$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$TstComnet$Wide$OnChangeBigCategory = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$OnChangeMaker = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$OnChangeSmallCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$OnSubmit = {$: 8};
var $author$project$Pages$Users$TstComnet$Wide$OnUpdateDateFrom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('メーカー')
							])),
						A3(
						$author$project$Components$CategorySelector$makerSelector,
						model.cE,
						model.eh,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TstComnet$Wide$OnChangeMaker)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TstComnet$Wide$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$TstComnet$Wide$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.cY),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$TstComnet$Wide$OnUpdateDateFrom)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3'),
								$rtfeldman$elm_css$Html$Styled$Attributes$type_('button')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TstComnet$Wide$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					]))
			]));
};
var $author$project$Pages$Users$TstComnet$Wide$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$TstComnet$Wide$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$TstComnet$Wide$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					$author$project$Utils$Helpers$displayStyleList))
			]));
};
var $author$project$Pages$Users$TstComnet$Wide$OnPressDownloadCSV = {$: 9};
var $author$project$Pages$Users$TstComnet$Wide$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$TstComnet$Wide$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$TstComnet$Wide$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$TstComnet$Wide$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$TstComnet$Wide$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$TstComnet$Wide$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$TstComnet$Wide$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$TstComnet$Wide$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$TstComnet$Wide$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$TstComnet$Wide$viewContent = function (model) {
	var headerStores = A2($author$project$Pages$Users$TstComnet$Wide$pStoreHeader, model.X, model.L);
	var headerStoreGroups = A2($author$project$Pages$Users$TstComnet$Wide$pStoreGroupsHeader, model.X, model.L);
	var bodyProducts = $author$project$Pages$Users$TstComnet$Wide$pProductPriceRows(model);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
			]),
		_List_fromArray(
			[
				$author$project$Pages$Users$TstComnet$Wide$viewProductFilter(model),
				A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
				(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
				(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
				$rtfeldman$elm_css$Html$Styled$span,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : (model.hA ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Users$TstComnet$Wide$viewTableControl(model),
						$author$project$Pages$Users$TstComnet$Wide$viewPriceTable(
						{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
			]));
};
var $author$project$Pages$Users$TstComnet$Wide$view = function (model) {
	return {
		lI: $author$project$Pages$Users$TstComnet$Wide$viewContent(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return 'NET-WIDE 掲載された機種と価格の時間変化(4回版)';
			}
		}()
	};
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateAllProducts = {$: 8};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateBasePrice = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateProduct = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateRPrice = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateYodobashiFlag = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$DragStart = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$Drop = {$: 12};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$dropSourceConfig = function (ind) {
	return {
		l_: {lK: false, mA: false, mS: true},
		mZ: $elm$core$Maybe$Nothing,
		m2: $elm$core$Basics$always($author$project$Pages$Users$Tv24Comnet$ChangeProduct$Drop),
		m7: $author$project$Pages$Users$Tv24Comnet$ChangeProduct$DragStart(ind)
	};
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$DragOver = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$dropTargetConfig = function (ind) {
	return {
		lZ: 1,
		m1: $elm$core$Basics$always($author$project$Pages$Users$Tv24Comnet$ChangeProduct$Drop),
		m3: $elm$core$Maybe$Nothing,
		m4: $elm$core$Maybe$Nothing,
		m6: $author$project$Pages$Users$Tv24Comnet$ChangeProduct$DragOver(ind)
	};
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$viewTr = F4(
	function (product, ind, draggingProductInd, anyPoint) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$draggable('true'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						(product.lY > 0) ? 'draggingUpward' : ((product.lY < 0) ? 'draggingDownward' : '')),
						$rtfeldman$elm_css$Html$Styled$Attributes$class(
						function () {
							if (!draggingProductInd.$) {
								var draggingInd = draggingProductInd.a;
								return _Utils_eq(ind, draggingInd) ? 'targetDrop' : '';
							} else {
								return '';
							}
						}())
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onSourceDrag(
							$author$project$Pages$Users$Tv24Comnet$ChangeProduct$dropSourceConfig(ind))),
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Html$Styled$Attributes$fromUnstyled,
						$mpizenberg$elm_pointer_events$Html$Events$Extra$Drag$onDropTarget(
							$author$project$Pages$Users$Tv24Comnet$ChangeProduct$dropTargetConfig(ind))))),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.nk)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(product.kl)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(product.lt)),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateBasePrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_bootstrap$Bootstrap$Form$Input$number(
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$value(
											$elm$core$String$fromInt(
												A2($elm$core$Maybe$withDefault, 0, product.ec))),
											A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '120px')
										])),
									$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput(
									$author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateRPrice(ind))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(product.oc),
									$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$onCheck(
									$author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateYodobashiFlag(ind))
								]),
							'')
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Button$button,
							_List_fromArray(
								[
									$frandibar$elm_bootstrap$Bootstrap$Button$onClick(
									$author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateProduct(ind))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('更新')
								]))
						]))
				]));
	});
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$viewContent = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3 mt-5'),
				$rtfeldman$elm_css$Html$Styled$Attributes$align('center')
			]),
		_List_fromArray(
			[
				(model.cv || model.k) ? $author$project$Components$Loading$loadingCenter(50.0) : ($elm_community$maybe_extra$Maybe$Extra$isJust(model.H) ? A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.H))
					])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil)),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '1000px'),
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5 mb-5'),
						$rtfeldman$elm_css$Html$Styled$Attributes$align('left')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 基準価格は想定売価（税抜き）です')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('- 商品の順序は、行をドラッグすることで変更できます(変更後は、一括更新してください)')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Button$button,
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Button$primary,
								$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Tv24Comnet$ChangeProduct$OnUpdateAllProducts)
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('一括更新')
							]))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$table,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('default-table')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('型番')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('JANコード')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('基準価格')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('R調整価格')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ヨドバシ')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$th,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('更新')
											]))
									]))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$tbody,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (product) {
									return A4($author$project$Pages$Users$Tv24Comnet$ChangeProduct$viewTr, product, ind, model.jg, model.iR);
								};
							},
							model.kn))
					]))
			]));
};
var $author$project$Pages$Users$Tv24Comnet$ChangeProduct$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Tv24Comnet$ChangeProduct$viewContent(model),
		iB: '商品の設定'
	};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$pStoreGroupsHeader = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$elm$core$List$cons,
			{bB: 5, iv: -1, kR: ''},
			A2(
				$elm$core$List$map,
				function (storeGroup) {
					return {
						bB: $elm$core$List$length(storeGroup.aN),
						iv: storeGroup.iv,
						kR: storeGroup.kR
					};
				},
				A2(
					$elm$core$List$filter,
					function (storeGroup) {
						return A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups) && (!$elm$core$List$isEmpty(storeGroup.aN));
					},
					storeGroups)));
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewTableBody = function (bodyProducts) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$tbody,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					$elm$core$List$concat(
						A2(
							$elm$core$List$indexedMap,
							function (ind) {
								return function (cell) {
									switch (cell.$) {
										case 0:
											var itemList = cell.a;
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															function () {
																switch (ind) {
																	case 0:
																		return 'numberHeader';
																	case 1:
																		return 'katabanHeader';
																	case 2:
																		return 'itemHeader';
																	case 3:
																		return 'basePriceHeader';
																	case 4:
																		return 'katabanHeader';
																	default:
																		return '';
																}
															}())
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															return A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$class('')
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(item.jP)
																	]));
														},
														itemList))
												]);
										case 1:
											return _List_fromArray(
												[
													A2($rtfeldman$elm_css$Html$Styled$td, _List_Nil, _List_Nil)
												]);
										default:
											var price = cell.a;
											var pastClass = (!price.fH) ? 'pastPriceTd ' : '';
											var lowestClass = price.hN ? 'lowestPriceTd ' : '';
											var lowestButHigherThanBasePriceClass = price.jL ? 'lowestButHigherThanBasePriceTd ' : '';
											var lowerRtyouseiClass = price.hM ? 'lowerRtyouseiPriceTd' : '';
											var lowerClass = (price.hL && (!price.hM)) ? 'lowerPriceTd ' : '';
											return _List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$td,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$class(
															_Utils_ap(
																pastClass,
																_Utils_ap(
																	lowestClass,
																	_Utils_ap(
																		lowestButHigherThanBasePriceClass,
																		_Utils_ap(lowerClass, lowerRtyouseiClass)))))
														]),
													A2(
														$elm$core$List$map,
														function (item) {
															var _v2 = item.m;
															switch (_v2) {
																case 2:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap text-danger')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																case 4:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(item.jP)
																			]));
																default:
																	return A2(
																		$rtfeldman$elm_css$Html$Styled$p,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$class('text-nowrap')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$rtfeldman$elm_css$Html$Styled$a,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$href(price.eD),
																						$rtfeldman$elm_css$Html$Styled$Attributes$target('_blank')
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(item.jP)
																					]))
																			]));
															}
														},
														price.h6))
												]);
									}
								};
							},
							row)));
			},
			bodyProducts));
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewTableHeader = F2(
	function (headerStoreGroups, headerStores) {
		var colsNum = A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, headerStoreGroups)).bB;
		return A2(
			$rtfeldman$elm_css$Html$Styled$thead,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (headerStoreGroup) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (!ind) {
													return 'rowHeader';
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(headerStoreGroup.iv);
												}
											}()),
											$rtfeldman$elm_css$Html$Styled$Attributes$colspan(headerStoreGroup.bB)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(headerStoreGroup.kR)
										]));
							};
						},
						headerStoreGroups)),
					A2(
					$rtfeldman$elm_css$Html$Styled$tr,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						function (ind) {
							return function (store) {
								return A2(
									$rtfeldman$elm_css$Html$Styled$th,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class(
											function () {
												if (_Utils_cmp(ind, colsNum) < 0) {
													switch (ind) {
														case 0:
															return 'numberHeader rowHeader';
														case 1:
															return 'katabanHeader rowHeader';
														case 2:
															return 'itemHeader rowHeader';
														case 3:
															return 'basePriceHeader rowHeader';
														case 4:
															return 'katabanHeader rowHeader';
														default:
															return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
													}
												} else {
													return 'storeGroupHeader' + $elm$core$String$fromInt(store.iv);
												}
											}())
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(store.kS)
										]));
							};
						},
						headerStores))
				]));
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewPriceTable = function (priceTableRequired) {
	var rowsNum = '2';
	var colsNum = $elm$core$String$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			{bB: 0, iv: 0, kR: ''},
			A2($elm_community$list_extra$List$Extra$getAt, 0, priceTableRequired.fA)).bB);
	return A2(
		$rtfeldman$elm_css$Html$Styled$table,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$id('priceTable'),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, '_fixedhead', 'rows:' + (rowsNum + (';cols:' + colsNum))),
				A2($rtfeldman$elm_css$Html$Styled$Attributes$attribute, 'class', 'Tv24Comnet')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Tv24Comnet$Thirty$viewTableHeader, priceTableRequired.fA, priceTableRequired.hC),
				$author$project$Pages$Users$Tv24Comnet$Thirty$viewTableBody(priceTableRequired.hi)
			]));
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnChangeBigCategory = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnChangeSmallCategory = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnSubmit = {$: 8};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnSubmitLatest = {$: 9};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnUpdateDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnUpdateTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewProductFilter = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$formInline,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-end')
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('大分類')
							])),
						A3(
						$author$project$Components$CategorySelector$bigCategorySelector,
						model.iW,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Tv24Comnet$Thirty$OnChangeBigCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('小分類')
							])),
						A4(
						$author$project$Components$CategorySelector$smallCategorySelector,
						model.kL,
						model.gD,
						model.ig,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Tv24Comnet$Thirty$OnChangeSmallCategory)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-3')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$for('date')
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得日')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Form$Input$date(
						_List_fromArray(
							[
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$attrs(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$id('date')
									])),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$value(model.bS),
								$frandibar$elm_bootstrap$Bootstrap$Form$Input$onInput($author$project$Pages$Users$Tv24Comnet$Thirty$OnUpdateDate)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$group,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column align-items-start mr-5')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$frandibar$elm_bootstrap$Bootstrap$Form$label,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('取得時刻')
							])),
						A3(
						$author$project$Components$TimeSelector$timeSelector,
						model.ac,
						model.bi,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bi),
								$rtfeldman$elm_css$Html$Styled$Events$onInput($author$project$Pages$Users$Tv24Comnet$Thirty$OnUpdateTime)
							]))
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
							])),
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Tv24Comnet$Thirty$OnSubmit)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('送信')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Button$button,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Tv24Comnet$Thirty$OnSubmitLatest)
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('最新時刻で送信')
					]))
			]));
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnChangeDisplayStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewDisplayStyleSelector = function (selectedDisplayStyle) {
	var displayStyleList = _List_fromArray(
		[
			_Utils_Tuple2('全てを表示', 'DisplayAll'),
			_Utils_Tuple2('価格のみ表示', 'DisplayPrice'),
			_Utils_Tuple2('価格及びポイント表示', 'DisplayPriceAndPoint'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示', 'DisplayAfterP'),
			_Utils_Tuple2('ポイント適用後の価格のみ表示(時刻抜き)', 'DisplayAfterPWithoutTime')
		]);
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$group,
		_List_fromArray(
			[
				$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$label,
				_List_Nil,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('表示形式')
					])),
				A2(
				$frandibar$elm_bootstrap$Bootstrap$Form$Select$select,
				_List_fromArray(
					[
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$onChange($author$project$Pages$Users$Tv24Comnet$Thirty$OnChangeDisplayStyle),
						$frandibar$elm_bootstrap$Bootstrap$Form$Select$attrs(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('')
							]))
					]),
				A2(
					$elm$core$List$map,
					function (_v0) {
						var label = _v0.a;
						var v = _v0.b;
						return A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$Select$item,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$value(v),
									$rtfeldman$elm_css$Html$Styled$Attributes$selected(
									_Utils_eq(v, selectedDisplayStyle))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(label)
								]));
					},
					displayStyleList))
			]));
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnPressDownloadCSV = {$: 10};
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewDownloadCSVButton = A2(
	$frandibar$elm_bootstrap$Bootstrap$Form$group,
	_List_fromArray(
		[
			$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-column ml-5')
				]))
		]),
	_List_fromArray(
		[
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$label,
			_List_Nil,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('\u3000')
				])),
			A2(
			$frandibar$elm_bootstrap$Bootstrap$Button$button,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Button$primary,
					$frandibar$elm_bootstrap$Bootstrap$Button$onClick($author$project$Pages$Users$Tv24Comnet$Thirty$OnPressDownloadCSV)
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text('CSVダウンロード')
				]))
		]));
var $author$project$Pages$Users$Tv24Comnet$Thirty$OnToggleStoreGroup = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewStoreGroupCheckbox = F2(
	function (storeGroups, visibleStoreGroups) {
		return A2(
			$frandibar$elm_bootstrap$Bootstrap$Form$group,
			_List_fromArray(
				[
					$frandibar$elm_bootstrap$Bootstrap$Form$attrs(
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row mr-3')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$frandibar$elm_bootstrap$Bootstrap$Form$label,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('表示店舗')
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row')
								]),
							A2(
								$elm$core$List$map,
								function (storeGroup) {
									return A2(
										$rtfeldman$elm_css$Html$Styled$div,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$class('mr-3')
											]),
										_List_fromArray(
											[
												A2(
												$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checkbox,
												_List_fromArray(
													[
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$checked(
														A2($elm$core$Set$member, storeGroup.iv, visibleStoreGroups)),
														$frandibar$elm_bootstrap$Bootstrap$Form$Checkbox$attrs(
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$value(
																$elm$core$String$fromInt(storeGroup.iv)),
																A2(
																$rtfeldman$elm_css$Html$Styled$Events$on,
																'click',
																A3($elm$json$Json$Decode$map2, $author$project$Pages$Users$Tv24Comnet$Thirty$OnToggleStoreGroup, $rtfeldman$elm_css$Html$Styled$Events$targetChecked, $rtfeldman$elm_css$Html$Styled$Events$targetValue))
															]))
													]),
												storeGroup.kR)
											]));
								},
								storeGroups))
						]))
				]));
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewTableControl = function (model) {
	return A2(
		$frandibar$elm_bootstrap$Bootstrap$Form$form,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('d-flex flex-row align-items-start mt-5 mb-1')
			]),
		_List_fromArray(
			[
				A2($author$project$Pages$Users$Tv24Comnet$Thirty$viewStoreGroupCheckbox, model.X, model.L),
				$author$project$Pages$Users$Tv24Comnet$Thirty$viewDisplayStyleSelector(model.c_),
				$author$project$Pages$Users$Tv24Comnet$Thirty$viewDownloadCSVButton
			]));
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewContent = F4(
	function (model, pStoreGroupsHeader_, pStoreHeader_, pProductPriceRows_) {
		var headerStores = A2(pStoreHeader_, model.X, model.L);
		var headerStoreGroups = A2(pStoreGroupsHeader_, model.X, model.L);
		var bodyProducts = pProductPriceRows_(model);
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-3 mr-3 mb-3')
				]),
			_List_fromArray(
				[
					$author$project$Pages$Users$Tv24Comnet$Thirty$viewProductFilter(model),
					A2($rtfeldman$elm_css$Html$Styled$hr, _List_Nil, _List_Nil),
					(model.dP || model.cv) ? $author$project$Components$Loading$loadingCenter(50.0) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					(A2($elm$core$Maybe$withDefault, '', model.H) !== '') ? A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							A2($elm$core$Maybe$withDefault, '', model.H))
						])) : (model.hA ? A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Users$Tv24Comnet$Thirty$viewTableControl(model),
							$author$project$Pages$Users$Tv24Comnet$Thirty$viewPriceTable(
							{hi: bodyProducts, fA: headerStoreGroups, hC: headerStores})
						])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil))
				]));
	});
var $author$project$Pages$Users$Tv24Comnet$Thirty$viewContentDefault = function (model) {
	return A4($author$project$Pages$Users$Tv24Comnet$Thirty$viewContent, model, $author$project$Pages$Users$Tv24Comnet$Thirty$pStoreGroupsHeader, $author$project$Pages$Users$Tv24Comnet$Thirty$pStoreHeader, $author$project$Pages$Users$Tv24Comnet$Thirty$pProductPriceRows);
};
var $author$project$Pages$Users$Tv24Comnet$Thirty$view = function (model) {
	return {
		lI: $author$project$Pages$Users$Tv24Comnet$Thirty$viewContentDefault(model),
		iB: function () {
			var _v0 = model.iB;
			if (!_v0.$) {
				var title = _v0.a;
				return title;
			} else {
				return $elm$core$String$fromInt(model.ac) + '分取得';
			}
		}()
	};
};
var $rtfeldman$elm_css$Html$Styled$h2 = $rtfeldman$elm_css$Html$Styled$node('h2');
var $rtfeldman$elm_css$Html$Styled$ol = $rtfeldman$elm_css$Html$Styled$node('ol');
var $author$project$Pages$User$viewTop = function (userName) {
	if (userName === 'nnagashio') {
		return {
			lI: A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('ml-5')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$h3,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text('商品管理')
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$ul,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('user/products/edit-products-permalinks')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Edit products_permalinks')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('user/products/add-product-config')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('商品の追加')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('user/products/yahoo')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('Yahoo個別取得URL')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('user/products/change-user-product')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ユーザーごとの商品の変更')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('user/products/edit-products')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('商品の型番，メーカー，小分類の変更')
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$a,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$href('user/products/edit-soldout-products')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('販売終了商品の変更')
											]))
									]))
							]))
					])),
			iB: '管理ページ'
		};
	} else {
		return {
			lI: A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5')
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$class('col-md-10 mx-auto')
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h2,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('mb-3')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('サービスの概要')
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$ol,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('border-ridge')
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('このサービスは電化新聞社が提供しているものです。販売店には提供しておりませんので、ご利用は社内に留めて下さい。')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('商品ごとの価格情報は随時収集しますが、当該企業のサイトのリニューアルなどの影響を受けることもあります。')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('当日の価格のみならず、任意の曜日の価格推移が一覧できます。また、ポイントの併記やポイント分を値引いた表示も可能です。')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('表示された価格をクリックすると当該ページにリンクしますから、内容を確認できます。')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('全てのページでCSVダウンロードが可能となっています。')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('このデータの持ち出しを禁止します。ハードコピーを取った場合はパスワード所持者の責任において破棄して下さい。')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('掲載する商品は発売・登録から2年間を目安に削除されます。')
											])),
										A2(
										$rtfeldman$elm_css$Html$Styled$li,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text('ご不明な点は管理責任者にお問い合わせ下さい。')
											]))
									]))
							]))
					])),
			iB: 'Netgate/インデックスページ'
		};
	}
};
var $author$project$Pages$User$view = function (model) {
	var _v0 = model;
	var userModel = _v0.a;
	var navModel = _v0.b;
	var news = _v0.c;
	return function (rootPageRequired) {
		return _Utils_update(
			rootPageRequired,
			{
				lI: A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Pages$User$userNavBar,
							A3(
								$elm$core$Basics$composeL,
								$elm$core$Maybe$withDefault(''),
								$author$project$Session$userName,
								$author$project$Pages$User$toSession(model)),
							userModel,
							navModel),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$class('mt-5 mb-3 col-12 col-md-10 mx-auto')
								]),
							$elm$core$String$isEmpty(news) ? _List_Nil : _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$class('news-container')
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											A3(
												$elm$core$String$replace,
												'</br>',
												'\n',
												A3(
													$elm$core$String$replace,
													'<br>',
													'\n',
													A3(
														$elm$core$String$replace,
														'<br/>',
														'\n',
														A3($elm$core$String$replace, '<br />', '\n', news)))))
										]))
								])),
							rootPageRequired.lI
						]))
			});
	}(
		function () {
			switch (userModel.$) {
				case 0:
					var session = userModel.a;
					return $author$project$Pages$User$viewTop(
						A3(
							$elm$core$Basics$composeL,
							$elm$core$Maybe$withDefault(''),
							$author$project$Session$userName,
							$author$project$Pages$User$toSession(model)));
				case 1:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDefaultMsg,
						$author$project$Pages$Users$Common$Default$view(defaultModel));
				case 2:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTimeSeqMsg,
						$author$project$Pages$Users$Common$TimeSeq$view(defaultModel));
				case 12:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotChangeProductMsg,
						$author$project$Pages$Users$Common$ChangeProduct$view(defaultModel));
				case 13:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tcmComnetTimeSeqMsg,
						$author$project$Pages$Users$To24tcmComnet$TimeSeq$view(defaultModel));
				case 15:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tcmComnetDayMsg,
						$author$project$Pages$Users$To24tcmComnet$Day$view(defaultModel));
				case 14:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tcmComnetCsvMsg,
						$author$project$Pages$Users$To24tcmComnet$Csv$view(defaultModel));
				case 16:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tcmComnetChangeProductMsg,
						$author$project$Pages$Users$To24tcmComnet$ChangeProduct$view(defaultModel));
				case 17:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tcmComnetProductMsg,
						$author$project$Pages$Users$To24tcmComnet$Product$view(defaultModel));
				case 58:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tcmKitchenDayMsg,
						$author$project$Pages$Users$To24tcmKitchen$Day$view(defaultModel));
				case 59:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tcmFridgeHourMixMsg,
						$author$project$Pages$Users$To24tcmFridge$HourMix$view(defaultModel));
				case 18:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tclComnetChangeProductMsg,
						$author$project$Pages$Users$To24tclComnet$ChangeProduct$view(defaultModel));
				case 19:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tclComnetDayMsg,
						$author$project$Pages$Users$To24tclComnet$Day$view(defaultModel));
				case 20:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTo24tclComnetTimeSeqMsg,
						$author$project$Pages$Users$To24tclComnet$TimeSeq$view(defaultModel));
				case 21:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotJvcComnetTimeSeqMsg,
						$author$project$Pages$Users$JvcComnet$TimeSeq$view(defaultModel));
				case 22:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotJvcComnetDefaultMsg,
						$author$project$Pages$Users$JvcComnet$Default$view(defaultModel));
				case 23:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotJvcComnetAmazonMsg,
						$author$project$Pages$Users$JvcComnet$Amazon$view(defaultModel));
				case 24:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotJvcComnetPriceDropMsg,
						$author$project$Pages$Users$JvcComnet$PriceDrop$view(defaultModel));
				case 3:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi24ComnetHourMsg,
						$author$project$Pages$Users$Hi24Comnet$Hour$view(defaultModel));
				case 4:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi24ComnetTimeSeqMsg,
						$author$project$Pages$Users$Hi24Comnet$TimeSeq$view(defaultModel));
				case 5:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi24ComnetHourSeqMsg,
						$author$project$Pages$Users$Hi24Comnet$HourSeq$view(defaultModel));
				case 6:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi24ComnetWeeklyProductFifteenMsg,
						$author$project$Pages$Users$Hi24Comnet$WeeklyProductFifteen$view(defaultModel));
				case 7:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi24ComnetTenAMMsg,
						$author$project$Pages$Users$Hi24Comnet$TenAM$view(defaultModel));
				case 8:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi24ComnetDayMsg,
						$author$project$Pages$Users$Hi24Comnet$Day$view(defaultModel));
				case 9:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi24ComnetSixHourMsg,
						$author$project$Pages$Users$Hi24Comnet$SixHour$view(defaultModel));
				case 10:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi3ComnetHourMsg,
						$author$project$Pages$Users$Hi3Comnet$Hour$view(defaultModel));
				case 11:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHi3ComnetTimeSeqMsg,
						$author$project$Pages$Users$Hi3Comnet$TimeSeq$view(defaultModel));
				case 25:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHisenseDayMsg,
						$author$project$Pages$Users$Hisense$Day$view(defaultModel));
				case 26:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHisenseTvHourMsg,
						$author$project$Pages$Users$Hisense$TvHour$view(defaultModel));
				case 28:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHisenseAmazonMsg,
						$author$project$Pages$Users$Hisense$Amazon$view(defaultModel));
				case 30:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHisenseChangeProductMsg,
						$author$project$Pages$Users$Hisense$ChangeProduct$view(defaultModel));
				case 27:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHisenseReviewMsg,
						$author$project$Pages$Users$Hisense$Review$view(defaultModel));
				case 29:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHisenseTimeSeqMsg,
						$author$project$Pages$Users$Hisense$TimeSeq$view(defaultModel));
				case 31:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotHisenseExcelMsg,
						$author$project$Pages$Users$Hisense$Excel$view(defaultModel));
				case 32:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTescomComnetHourMsg,
						$author$project$Pages$Users$TescomComnet$Hour$view(defaultModel));
				case 33:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTescomComnetExcelMsg,
						$author$project$Pages$Users$TescomComnet$Excel$view(defaultModel));
				case 34:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTescomComnetChangeProductMsg,
						$author$project$Pages$Users$TescomComnet$ChangeProduct$view(defaultModel));
				case 35:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCa6ComnetHourMsg,
						$author$project$Pages$Users$Ca6Comnet$Hour$view(defaultModel));
				case 36:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCa6ComnetHour2Msg,
						$author$project$Pages$Users$Ca6Comnet$Hour2$view(defaultModel));
				case 37:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCa6ComnetCsvMsg,
						$author$project$Pages$Users$Ca6Comnet$Csv$view(defaultModel));
				case 38:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCa6ComnetWeeklyProductMsg,
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct$view(defaultModel));
				case 39:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCa6ComnetWeeklyProduct2Msg,
						$author$project$Pages$Users$Ca6Comnet$WeeklyProduct2$view(defaultModel));
				case 40:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCa6ComnetItemsMsg,
						$author$project$Pages$Users$Ca6Comnet$Items$view(defaultModel));
				case 41:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCa6ComnetLowMsg,
						$author$project$Pages$Users$Ca6Comnet$Low$view(defaultModel));
				case 42:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetChangeProductMsg,
						$author$project$Pages$Users$MlnComnet$ChangeProduct$view(defaultModel));
				case 46:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetChangeMailMsg,
						$author$project$Pages$Users$MlnComnet$ChangeMail$view(defaultModel));
				case 47:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetChangeMailTestMsg,
						$author$project$Pages$Users$MlnComnet$ChangeMailTest$view(defaultModel));
				case 50:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetChangePasswordMsg,
						$author$project$Pages$Users$MlnComnet$ChangePassword$view(defaultModel));
				case 43:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetChronologicalMsg,
						$author$project$Pages$Users$MlnComnet$Chronological$view(defaultModel));
				case 44:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetHourMsg,
						$author$project$Pages$Users$MlnComnet$Hour$view(defaultModel));
				case 45:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetHourYamadaMsg,
						$author$project$Pages$Users$MlnComnet$HourYamada$view(defaultModel));
				case 48:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetAutoReloadMsg,
						$author$project$Pages$Users$MlnComnet$AutoReload$view(defaultModel));
				case 49:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetMailSettingMsg,
						$author$project$Pages$Users$MlnComnet$MailSetting$view(defaultModel));
				case 51:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotMlnComnetYahooMsg,
						$author$project$Pages$Users$MlnComnet$Yahoo$view(defaultModel));
				case 52:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTv24ComnetChangeProductMsg,
						$author$project$Pages$Users$Tv24Comnet$ChangeProduct$view(defaultModel));
				case 53:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTv24ComnetThirtyMsg,
						$author$project$Pages$Users$Tv24Comnet$Thirty$view(defaultModel));
				case 54:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotElecComnetHourMsg,
						$author$project$Pages$Users$ElecComnet$Hour$view(defaultModel));
				case 55:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotElecComnetExcelMsg,
						$author$project$Pages$Users$ElecComnet$Excel$view(defaultModel));
				case 56:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotElecComnetChangeProductMsg,
						$author$project$Pages$Users$ElecComnet$ChangeProduct$view(defaultModel));
				case 57:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotElecComnetTimeSeqMsg,
						$author$project$Pages$Users$ElecComnet$TimeSeq$view(defaultModel));
				case 60:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDelonghiHourMsg,
						$author$project$Pages$Users$Delonghi$Hour$view(defaultModel));
				case 61:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDelonghiChangeProductMsg,
						$author$project$Pages$Users$Delonghi$ChangeProduct$view(defaultModel));
				case 62:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDelonghiTimeSeqMsg,
						$author$project$Pages$Users$Delonghi$TimeSeq$view(defaultModel));
				case 63:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDelonghiTimeSeq2Msg,
						$author$project$Pages$Users$Delonghi$TimeSeq2$view(defaultModel));
				case 64:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDelonghiNineAMMsg,
						$author$project$Pages$Users$Delonghi$NineAM$view(defaultModel));
				case 65:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDelonghiWeeklyMsg,
						$author$project$Pages$Users$Delonghi$Weekly$view(defaultModel));
				case 66:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotKinujoComnetExcelMsg,
						$author$project$Pages$Users$KinujoComnet$Excel$view(defaultModel));
				case 67:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotKinujoComnetChangeProductMsg,
						$author$project$Pages$Users$KinujoComnet$ChangeProduct$view(defaultModel));
				case 68:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotKinujoComnetFifteeenMsg,
						$author$project$Pages$Users$KinujoComnet$Fifteen$view(defaultModel));
				case 69:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotShaComnetWideMsg,
						$author$project$Pages$Users$ShaComnet$Wide$view(defaultModel));
				case 70:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotShaComnetHourMsg,
						$author$project$Pages$Users$ShaComnet$Hour$view(defaultModel));
				case 71:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotShaComnetTimeSeqMsg,
						$author$project$Pages$Users$ShaComnet$TimeSeq$view(defaultModel));
				case 72:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotShaComnetWeeklyProductMsg,
						$author$project$Pages$Users$ShaComnet$WeeklyProduct$view(defaultModel));
				case 73:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotShaComnetDayMsg,
						$author$project$Pages$Users$ShaComnet$Day$view(defaultModel));
				case 74:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotShaComnetChangeProductMsg,
						$author$project$Pages$Users$ShaComnet$ChangeProduct$view(defaultModel));
				case 75:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTstComnetTimeSeqMsg,
						$author$project$Pages$Users$TstComnet$TimeSeq$view(defaultModel));
				case 76:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTstComnetWideMsg,
						$author$project$Pages$Users$TstComnet$Wide$view(defaultModel));
				case 77:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDbi6ComnetHourMsg,
						$author$project$Pages$Users$Dbi6Comnet$Hour$view(defaultModel));
				case 78:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDbi6ComnetTimeSeqMsg,
						$author$project$Pages$Users$Dbi6Comnet$TimeSeq$view(defaultModel));
				case 80:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDenon6ComnetWideMsg,
						$author$project$Pages$Users$Denon6Comnet$Wide$view(defaultModel));
				case 79:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotDenon6ComnetTimeSeqMsg,
						$author$project$Pages$Users$Denon6Comnet$TimeSeq$view(defaultModel));
				case 87:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotBraunComnetHourMsg,
						$author$project$Pages$Users$BraunComnet$Hour$view(defaultModel));
				case 88:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotBraunComnetWideMsg,
						$author$project$Pages$Users$BraunComnet$Wide$view(defaultModel));
				case 82:
					var reiModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotChangeUserProductMsg,
						$author$project$Pages$Cms$Products$ChangeUserProduct$view(reiModel));
				case 81:
					var reiModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotEditProductsPermalinks,
						$author$project$Pages$Cms$Products$EditProductsPermalinks$view(reiModel));
				case 83:
					var reiModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotAddProductConfigMsg,
						$author$project$Pages$Cms$Products$AddProductConfig$view(reiModel));
				case 84:
					var reiModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotEditProductsMsg,
						$author$project$Pages$Cms$Products$EditProducts$view(reiModel));
				case 85:
					var yModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotYahooMsg,
						$author$project$Pages$Cms$Stores$Yahoo$view(yModel));
				case 86:
					var reiModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotEditSoldoutProductsMsg,
						$author$project$Pages$Cms$Products$EditSoldoutProducts$view(reiModel));
				case 90:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTsBatWideMsg,
						$author$project$Pages$Users$TsBat$Wide$view(defaultModel));
				case 89:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTsBatTimeSeqMsg,
						$author$project$Pages$Users$TsBat$TimeSeq$view(defaultModel));
				case 100:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotTestFifteeenMsg,
						$author$project$Pages$Users$Test$Fifteen$view(defaultModel));
				case 91:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiComnetFifteenMsg,
						$author$project$Pages$Users$FujiComnet$Fifteen$view(defaultModel));
				case 92:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiComnetWeek30Msg,
						$author$project$Pages$Users$FujiComnet$Week30$view(defaultModel));
				case 93:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiComnetChangeProductMsg,
						$author$project$Pages$Users$FujiComnet$ChangeProduct$view(defaultModel));
				case 94:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiComnetLatestStoreMsg,
						$author$project$Pages$Users$FujiComnet$LatestStore$view(defaultModel));
				case 95:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiComnetMailAddressMsg,
						$author$project$Pages$Users$Common$MailAddress$view(defaultModel));
				case 96:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotCommonWeeklyProductMsg,
						$author$project$Pages$Users$Common$WeeklyProduct$view(defaultModel));
				case 97:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiinstaxComnetThirtyMsg,
						$author$project$Pages$Users$FujiinstaxComnet$Thirty$view(defaultModel));
				case 98:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiinstaxComnetWeek30Msg,
						$author$project$Pages$Users$FujiinstaxComnet$Week30$view(defaultModel));
				default:
					var defaultModel = userModel.a;
					return A2(
						$author$project$Page$map,
						$author$project$Pages$User$GotFujiinstaxComnetLatestStoreMsg,
						$author$project$Pages$Users$FujiinstaxComnet$LatestStore$view(defaultModel));
			}
		}());
};
var $author$project$Main$view = function (model) {
	var viewPage = F2(
		function (toMsg, pageRequired) {
			var _v1 = $author$project$Page$view(pageRequired);
			var title = _v1.iB;
			var body = _v1.dp;
			return {
				dp: A2(
					$elm$core$List$map,
					$elm$html$Html$map(toMsg),
					body),
				iB: title
			};
		});
	switch (model.$) {
		case 0:
			var session = model.a;
			return $author$project$Page$view(
				{
					lI: A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil),
					iB: ''
				});
		case 1:
			var loginModel = model.a;
			return A2(
				viewPage,
				$author$project$Main$GotLoginMsg,
				$author$project$Pages$Login$view(loginModel));
		case 2:
			var cmsModel = model.a;
			return A2(
				viewPage,
				$author$project$Main$GotCmsMsg,
				$author$project$Pages$Cms$view(cmsModel));
		default:
			var userModel = model.a;
			return A2(
				viewPage,
				$author$project$Main$GotUserMsg,
				$author$project$Pages$User$view(userModel));
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{x: $author$project$Main$init, m8: $author$project$Main$OnNavigation, m9: $author$project$Main$LinkClicked, nN: $author$project$Main$subscriptions, _: $author$project$Main$update, n3: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$value)
			])))(0)}});}(this));